var __defProp2 = Object.defineProperty;
var __defNormalProp2 = (obj, key, value) => key in obj ? __defProp2(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField2 = (obj, key, value) => __defNormalProp2(obj, typeof key !== "symbol" ? key + "" : key, value);
import { defineComponent, reactive, provide, openBlock, createElementBlock, renderSlot, ref, computed, inject, watch, normalizeClass, createElementVNode, createVNode, createCommentVNode, toDisplayString, Transition, withCtx, Fragment, renderList, createBlock, useSlots, resolveDirective, withDirectives, resolveDynamicComponent, mergeProps, withModifiers, withKeys, createTextVNode, normalizeStyle, onMounted, onUnmounted, resolveComponent, mergeModels, useModel, pushScopeId, popScopeId, nextTick, normalizeProps, guardReactiveProps, withScopeId, createApp, h as h$1, onBeforeUnmount, vModelCheckbox, vModelText, toRef, unref, isRef, createSlots, Teleport, render as render$e, onBeforeUpdate, vShow, getCurrentScope, onScopeDispose, vModelRadio, TransitionGroup, vModelDynamic, useCssVars, getCurrentInstance, shallowRef, markRaw } from "vue";
import { RouterLink } from "vue-router";
const bagelFormUtils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get arrField() {
    return arrField;
  },
  get bglForm() {
    return bglForm;
  },
  get checkField() {
    return checkField;
  },
  get dateField() {
    return dateField;
  },
  get findBglFieldById() {
    return findBglFieldById;
  },
  get frmRow() {
    return frmRow;
  },
  get getBaseField() {
    return getBaseField;
  },
  get numField() {
    return numField;
  },
  get richText() {
    return richText;
  },
  get slctField() {
    return slctField;
  },
  get telField() {
    return telField;
  },
  get txtField() {
    return txtField;
  },
  get uploadField() {
    return uploadField;
  }
}, Symbol.toStringTag, { value: "Module" }));
const _sfc_main$15 = /* @__PURE__ */ defineComponent({
  __name: "Accordion",
  setup(__props, { expose: __expose }) {
    __expose();
    const state2 = reactive({
      openItem: void 0
    });
    provide("accordionState", state2);
    const __returned__ = { state: state2 };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _export_sfc = (sfc, props2) => {
  const target = sfc.__vccOpts || sfc;
  for (const [key, val] of props2) {
    target[key] = val;
  }
  return target;
};
function _sfc_render$15(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const Accordion = /* @__PURE__ */ _export_sfc(_sfc_main$15, [["render", _sfc_render$15], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Accordion.vue"]]);
const _sfc_main$14 = /* @__PURE__ */ defineComponent({
  __name: "AccordionItem",
  props: {
    label: { type: String, required: false },
    id: { type: String, required: false },
    open: { type: Boolean, required: false },
    iconType: { type: String, required: false },
    iconPosition: { type: String, required: false },
    flat: { type: Boolean, required: false },
    iconClass: { type: String, required: false }
  },
  emits: ["update:open"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    let openVal = ref(!!props2.open);
    let isOpen = computed({
      get: () => openVal.value,
      set: (value) => {
        openVal.value = value;
        emit2("update:open", value);
      }
    });
    const accordionState = inject("accordionState");
    const id = props2.id || Math.random().toString(36).slice(7);
    const computedIcon = computed(() => {
      return props2.iconType === "plus_minus" ? isOpen.value ? "remove" : "add" : "expand_more";
    });
    const iconPosition = computed(() => props2.iconPosition || "end");
    watch(() => props2.open, () => isOpen.value = props2.open, { immediate: true });
    if (accordionState) {
      watch(
        () => accordionState.openItem,
        (currentOpenId) => {
          if (currentOpenId !== id) isOpen.value = false;
        },
        { immediate: true }
      );
    }
    function toggle() {
      isOpen.value = !isOpen.value;
      if (accordionState) {
        if (isOpen.value) {
          accordionState.openItem = id;
        } else if (accordionState.openItem === id) {
          accordionState.openItem = void 0;
        }
      }
    }
    const __returned__ = { props: props2, emit: emit2, get openVal() {
      return openVal;
    }, set openVal(v) {
      openVal = v;
    }, get isOpen() {
      return isOpen;
    }, set isOpen(v) {
      isOpen = v;
    }, accordionState, id, computedIcon, iconPosition, toggle, get MaterialIcon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$T = ["aria-expanded", "aria-controls"];
const _hoisted_2$B = { class: "accordion-label" };
const _hoisted_3$s = ["id", "aria-hidden"];
function _sfc_render$14(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["accordion-item txt-start", [{ flat: $props.flat }]])
    },
    [
      createElementVNode("button", {
        "aria-expanded": $setup.isOpen ? "true" : "false",
        class: "accordion-head",
        "aria-controls": `accordion-body-${$setup.id}`,
        onClick: _cache[0] || (_cache[0] = ($event) => $setup.toggle())
      }, [
        $setup.iconPosition === "start" ? (openBlock(), createElementBlock(
          "span",
          {
            key: 0,
            class: normalizeClass(["accordion-icon", [$props.iconClass, { open: $setup.isOpen && $props.iconType === "expand_more" }]])
          },
          [
            createVNode($setup["MaterialIcon"], { icon: $setup.computedIcon }, null, 8, ["icon"])
          ],
          2
          /* CLASS */
        )) : createCommentVNode("v-if", true),
        renderSlot(_ctx.$slots, "head", {}, () => [
          createElementVNode(
            "span",
            _hoisted_2$B,
            toDisplayString($props.label),
            1
            /* TEXT */
          )
        ], true),
        $setup.iconPosition === "end" ? (openBlock(), createElementBlock(
          "span",
          {
            key: 1,
            class: normalizeClass(["accordion-icon", [$props.iconClass, { open: $setup.isOpen && $props.iconType === "expand_more" }]])
          },
          [
            createVNode($setup["MaterialIcon"], { icon: $setup.computedIcon }, null, 8, ["icon"])
          ],
          2
          /* CLASS */
        )) : createCommentVNode("v-if", true)
      ], 8, _hoisted_1$T),
      createVNode(Transition, { name: "expand" }, {
        default: withCtx(() => [
          $setup.isOpen ? (openBlock(), createElementBlock("div", {
            key: 0,
            id: `accordion-body-${$setup.id}`,
            class: "accordion-body",
            "aria-hidden": $setup.isOpen ? "false" : "true"
          }, [
            renderSlot(_ctx.$slots, "default", {}, void 0, true)
          ], 8, _hoisted_3$s)) : createCommentVNode("v-if", true)
        ]),
        _: 3
        /* FORWARDED */
      })
    ],
    2
    /* CLASS */
  );
}
const AccordionItem = /* @__PURE__ */ _export_sfc(_sfc_main$14, [["render", _sfc_render$14], ["__scopeId", "data-v-9fa9cf49"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/AccordionItem.vue"]]);
const _sfc_main$13 = /* @__PURE__ */ defineComponent({
  __name: "AddressSearch",
  emits: ["addressSelected"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit2 = __emit;
    let addressInput = ref("");
    let searchResults = ref([]);
    const suggestion = ref();
    function emitAddress(address) {
      emit2("addressSelected", address);
      searchResults.value = [];
      addressInput.value = "";
    }
    async function searchAddresses() {
      var _a2;
      const addressURL = addressInput.value.replaceAll(/\s+/g, "+");
      const geocodeUrl = `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURI(addressURL)}`;
      const res = await fetch(geocodeUrl);
      searchResults.value = await res.json() || [];
      (_a2 = suggestion.value) == null ? void 0 : _a2.show();
    }
    const __returned__ = { emit: emit2, get addressInput() {
      return addressInput;
    }, set addressInput(v) {
      addressInput = v;
    }, get searchResults() {
      return searchResults;
    }, set searchResults(v) {
      searchResults = v;
    }, suggestion, emitAddress, searchAddresses, get Dropdown() {
      return Dropdown;
    }, get ListItem() {
      return ListItem;
    }, get ListView() {
      return ListView;
    }, get TextInput() {
      return TextInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$S = { class: "relative" };
function _sfc_render$13(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$S, [
    createVNode(
      $setup["Dropdown"],
      {
        ref: "suggestion",
        noAutoFocus: true,
        placement: "bottom-start"
      },
      {
        trigger: withCtx(() => [
          createVNode($setup["TextInput"], {
            modelValue: $setup.addressInput,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.addressInput = $event),
            placeholder: "Enter address",
            onDebounce: $setup.searchAddresses
          }, null, 8, ["modelValue"])
        ]),
        default: withCtx(() => [
          createVNode($setup["ListView"], { class: "-mt-2 hm-300px" }, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList($setup.searchResults, (result2, index2) => {
                  return openBlock(), createBlock($setup["ListItem"], {
                    key: index2,
                    icon: "location_on",
                    title: result2.display_name,
                    onClick: ($event) => $setup.emitAddress(result2)
                  }, null, 8, ["title", "onClick"]);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ]),
            _: 1
            /* STABLE */
          })
        ]),
        _: 1
        /* STABLE */
      },
      512
      /* NEED_PATCH */
    )
  ]);
}
const AddressSearch = /* @__PURE__ */ _export_sfc(_sfc_main$13, [["render", _sfc_render$13], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/AddressSearch.vue"]]);
const _sfc_main$12 = /* @__PURE__ */ defineComponent({
  __name: "Btn",
  props: {
    disabled: { type: Boolean, required: false, default: false },
    icon: { type: null, required: false },
    iconEnd: { type: null, required: false },
    color: { type: String, required: false },
    theme: { type: String, required: false },
    flat: { type: Boolean, required: false },
    border: { type: Boolean, required: false, default: false },
    outline: { type: Boolean, required: false, default: false },
    thin: { type: Boolean, required: false },
    type: { type: String, required: false, default: "button" },
    loading: { type: Boolean, required: false, default: false },
    role: { type: String, required: false, default: "button" },
    value: { type: String, required: false },
    to: { type: String, required: false },
    href: { type: String, required: false },
    round: { type: Boolean, required: false, default: false },
    is: { type: String, required: false, default: "button" },
    ripple: { type: Boolean, required: false, default: true },
    onClick: { type: Function, required: false, default: () => "" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const isComponent = computed(() => {
      if (props2.to) return RouterLink;
      if (props2.href) return "a";
      return props2.is;
    });
    const bind3 = computed(() => {
      const obj = {};
      if (props2.to) obj.to = props2.to;
      else if (props2.href) obj.href = props2.href;
      if (!props2.to && !props2.href) {
        obj.role = props2.role;
        obj.type = props2.type;
      }
      return obj;
    });
    const slots = useSlots();
    const __returned__ = { props: props2, isComponent, bind: bind3, slots, get MaterialIcon() {
      return Icon;
    }, get Loading() {
      return Loading;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$R = {
  key: 1,
  class: "bgl_btn-flex"
};
function _sfc_render$12(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_ripple = resolveDirective("ripple");
  return withDirectives((openBlock(), createBlock(resolveDynamicComponent($setup.isComponent), mergeProps($setup.bind, {
    disabled: $props.disabled,
    class: ["bgl_btn", {
      "bgl_btn-icon": $props.icon && !$setup.slots.default && !$props.value,
      thin: $props.thin,
      round: $props.round,
      "bgl_btn_flat": $props.flat,
      "bgl_btn-border": $props.border || $props.outline,
      [`bgl_btn-${$props.color}`]: $props.color,
      [`bgl_btn-${$props.theme}`]: $props.theme
    }],
    tabindex: $props.disabled ? -1 : 0,
    onClick: withModifiers($props.onClick, ["stop"]),
    onKeydown: [
      withKeys($props.onClick, ["enter"]),
      withKeys($props.onClick, ["space"])
    ]
  }), {
    default: withCtx(() => [
      $props.loading ? (openBlock(), createBlock($setup["Loading"], {
        key: 0,
        size: "15"
      })) : (openBlock(), createElementBlock("div", _hoisted_1$R, [
        $props.icon ? (openBlock(), createBlock($setup["MaterialIcon"], {
          key: 0,
          icon: $props.icon
        }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
        renderSlot(_ctx.$slots, "default", {}, void 0, true),
        !$setup.slots.default && $props.value ? (openBlock(), createElementBlock(
          Fragment,
          { key: 1 },
          [
            createTextVNode(
              toDisplayString($props.value),
              1
              /* TEXT */
            )
          ],
          64
          /* STABLE_FRAGMENT */
        )) : createCommentVNode("v-if", true),
        $props.iconEnd ? (openBlock(), createBlock($setup["MaterialIcon"], {
          key: 2,
          icon: $props.iconEnd
        }, null, 8, ["icon"])) : createCommentVNode("v-if", true)
      ]))
    ]),
    _: 3
    /* FORWARDED */
  }, 16, ["disabled", "class", "tabindex", "onClick", "onKeydown"])), [
    [_directive_ripple, $props.ripple]
  ]);
}
const Btn = /* @__PURE__ */ _export_sfc(_sfc_main$12, [["render", _sfc_render$12], ["__scopeId", "data-v-79038f85"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Btn.vue"]]);
const _sfc_main$11 = /* @__PURE__ */ defineComponent({
  __name: "Alert",
  props: {
    message: { type: String, required: true },
    dismissable: { type: Boolean, required: false },
    type: { type: String, required: false, default: "info" },
    icon: { type: null, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const isDismissed = ref(false);
    const color2 = {
      info: "var(--bgl-primary)",
      warning: "var(--bgl-yellow)",
      error: "var(--bgl-red)"
    };
    const __returned__ = { isDismissed, color: color2, get Icon() {
      return Icon;
    }, Btn };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$Q = ["dismissable"];
const _hoisted_2$A = { class: "m-0" };
function _sfc_render$11(_ctx, _cache, $props, $setup, $data, $options) {
  return !$setup.isDismissed ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["alert", [$props.type]]),
    dismissable: $props.dismissable
  }, [
    $props.icon !== "none" ? (openBlock(), createBlock($setup["Icon"], {
      key: 0,
      class: "alert_icon",
      icon: $props.icon || $props.type,
      size: 2,
      color: $setup.color[$props.type]
    }, null, 8, ["icon", "color"])) : createCommentVNode("v-if", true),
    createElementVNode(
      "p",
      _hoisted_2$A,
      toDisplayString($props.message),
      1
      /* TEXT */
    ),
    createVNode($setup["Btn"], {
      flat: "",
      thin: "",
      class: "alert_close",
      icon: "close",
      onClick: _cache[0] || (_cache[0] = ($event) => $setup.isDismissed = true)
    })
  ], 10, _hoisted_1$Q)) : createCommentVNode("v-if", true);
}
const Alert = /* @__PURE__ */ _export_sfc(_sfc_main$11, [["render", _sfc_render$11], ["__scopeId", "data-v-3f4a8ec2"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Alert.vue"]]);
const _sfc_main$10 = /* @__PURE__ */ defineComponent({
  __name: "Avatar",
  props: {
    fallback: { type: String, required: false },
    src: { type: String, required: false },
    name: { type: String, required: false },
    size: { type: Number, required: false, default: 50 }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = { get initials() {
      return initials;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$P = ["src", "alt"];
function _sfc_render$10(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: "avatar flex justify-content-center",
      style: normalizeStyle({ width: `${$props.size}px`, height: `${$props.size}px` })
    },
    [
      $props.src ? (openBlock(), createElementBlock("img", {
        key: 0,
        src: $props.src,
        alt: $props.name
      }, null, 8, _hoisted_1$P)) : (openBlock(), createElementBlock(
        "p",
        {
          key: 1,
          style: normalizeStyle({ "line-height": `${$props.size}px`, "font-size": `calc(1.5rem * ${$props.size} / 50)` })
        },
        toDisplayString(($props.fallback || $setup.initials($props.name || "")).toUpperCase()),
        5
        /* TEXT, STYLE */
      ))
    ],
    4
    /* STYLE */
  );
}
const Avatar = /* @__PURE__ */ _export_sfc(_sfc_main$10, [["render", _sfc_render$10], ["__scopeId", "data-v-69299821"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Avatar.vue"]]);
const _sfc_main$$ = /* @__PURE__ */ defineComponent({
  __name: "Badge",
  props: {
    color: { type: String, required: false },
    size: { type: String, required: false },
    text: { type: String, required: true },
    icon: { type: null, required: false },
    iconEnd: { type: null, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = { get Icon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$$(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["pill", [$props.color]])
    },
    [
      $props.icon ? (openBlock(), createBlock($setup["Icon"], {
        key: 0,
        class: "inline",
        icon: $props.icon
      }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
      createTextVNode(
        " " + toDisplayString($props.text) + " ",
        1
        /* TEXT */
      ),
      $props.iconEnd ? (openBlock(), createBlock($setup["Icon"], {
        key: 1,
        class: "inline",
        icon: $props.iconEnd
      }, null, 8, ["icon"])) : createCommentVNode("v-if", true)
    ],
    2
    /* CLASS */
  );
}
const Badge = /* @__PURE__ */ _export_sfc(_sfc_main$$, [["render", _sfc_render$$], ["__scopeId", "data-v-0d3d5e64"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Badge.vue"]]);
const _sfc_main$_ = /* @__PURE__ */ defineComponent({
  __name: "BglVideo",
  props: {
    src: { type: String, required: false },
    autoplay: { type: Boolean, required: false },
    mute: { type: Boolean, required: false },
    aspectRatio: { type: String, required: false },
    controls: { type: Boolean, required: false },
    loop: { type: Boolean, required: false },
    status: { type: String, required: false },
    playsinline: { type: Boolean, required: false }
  },
  setup(__props, { expose: __expose }) {
    const props2 = __props;
    const videoFormat = computed(() => {
      var _a2, _b, _c;
      return ((_c = (_b = (_a2 = props2.src) == null ? void 0 : _a2.split(".").pop()) == null ? void 0 : _b.split("?").shift()) == null ? void 0 : _c.toLowerCase()) || "mp4";
    });
    const aspectRatio = computed(
      () => {
        var _a2;
        return ((_a2 = props2.aspectRatio) == null ? void 0 : _a2.replace(":", "/")) || "16/9";
      }
    );
    const video = ref();
    function play() {
      var _a2;
      (_a2 = video.value) == null ? void 0 : _a2.play();
    }
    function pause() {
      var _a2;
      (_a2 = video.value) == null ? void 0 : _a2.pause();
    }
    watch(() => props2.status, (status) => {
      if (status === "play") play();
      if (status === "pause") pause();
    });
    __expose({ play, pause });
    const embedType = computed(() => {
      const youtubeRegex2 = /youtube\.com|youtu\.be/;
      if (youtubeRegex2.test(props2.src || "")) return "YouTube";
      const vimeoRegex2 = /vimeo\.com/;
      if (vimeoRegex2.test(props2.src || "")) return "Vimeo";
    });
    const videoUrl = computed(() => {
      var _a2, _b, _c, _d, _e2;
      if (embedType.value) {
        if (embedType.value === "YouTube") {
          const videoId = (_c = (_b = (_a2 = props2.src) == null ? void 0 : _a2.split(/v=|youtu\.be\//)[1]) == null ? void 0 : _b.split("&")) == null ? void 0 : _c[0];
          const queryParams = new URLSearchParams({
            autoplay: props2.autoplay ? "1" : "0",
            controls: "0",
            showinfo: "0",
            modestbranding: "1"
          });
          return `https://www.youtube.com/embed/${videoId}?${queryParams}`;
        }
        if (embedType.value === "Vimeo") {
          const vimeoRegex2 = /vimeo\.com\/(?:channels\/(?:\w+\/)?|groups\/([^/]*)\/videos\/|album\/(\d+)\/video\/)?(\d+)(?:$|\/|\?)/;
          const videoId = (_e2 = (_d = props2.src) == null ? void 0 : _d.match(vimeoRegex2)) == null ? void 0 : _e2[3];
          return `https://player.vimeo.com/video/${videoId}`;
        }
      }
      return props2.src;
    });
    const __returned__ = { props: props2, videoFormat, aspectRatio, video, play, pause, embedType, videoUrl };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$O = ["src"];
const _hoisted_2$z = ["autoplay", "muted", "loop", "controls", "playsinline"];
const _hoisted_3$r = ["src", "type"];
function _sfc_render$_(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["bgl_vid", { vid_empty: !$props.src }])
    },
    [
      $setup.embedType ? (openBlock(), createElementBlock("iframe", {
        key: 0,
        src: $setup.videoUrl,
        style: normalizeStyle({ aspectRatio: $setup.aspectRatio }),
        frameborder: "0",
        allowfullscreen: "",
        title: "Video",
        allow: "autoplay"
      }, null, 12, _hoisted_1$O)) : $props.src ? (openBlock(), createElementBlock("video", {
        key: 1,
        ref: "video",
        autoplay: $props.autoplay,
        muted: $props.mute,
        loop: $props.loop,
        style: normalizeStyle({ aspectRatio: $setup.aspectRatio }),
        controls: $props.controls,
        playsinline: $props.playsinline
      }, [
        createElementVNode("source", {
          src: $props.src,
          type: `video/${$setup.videoFormat}`
        }, null, 8, _hoisted_3$r)
      ], 12, _hoisted_2$z)) : createCommentVNode("v-if", true)
    ],
    2
    /* CLASS */
  );
}
const BglVideo = /* @__PURE__ */ _export_sfc(_sfc_main$_, [["render", _sfc_render$_], ["__scopeId", "data-v-de42246b"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/BglVideo.vue"]]);
const _sfc_main$Z = /* @__PURE__ */ defineComponent({
  __name: "Card",
  props: {
    label: { type: String, required: false },
    thin: { type: Boolean, required: false },
    outline: { type: Boolean, required: false },
    h100: { type: Boolean, required: false },
    to: { type: String, required: false },
    overflowX: { type: Boolean, required: false },
    overflowY: { type: Boolean, required: false },
    bg: { type: String, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const is4 = computed(() => props2.to ? "router-link" : "div");
    const __returned__ = { props: props2, is: is4 };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$N = {
  key: 0,
  class: "card_label"
};
function _sfc_render$Z(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_ripple = resolveDirective("ripple");
  return withDirectives((openBlock(), createBlock(resolveDynamicComponent($setup.is), {
    to: $props.to,
    class: normalizeClass(["bgl_card", {
      thin: $props.thin,
      "border": $props.outline,
      "h-100": $props.h100,
      [$props.bg || ""]: $props.bg,
      "overflow-x": $props.overflowX,
      "overflow-y": $props.overflowY
    }])
  }, {
    default: withCtx(() => [
      $props.label ? (openBlock(), createElementBlock(
        "span",
        _hoisted_1$N,
        toDisplayString($props.label),
        1
        /* TEXT */
      )) : createCommentVNode("v-if", true),
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["to", "class"])), [
    [_directive_ripple, !!$props.to]
  ]);
}
const Card = /* @__PURE__ */ _export_sfc(_sfc_main$Z, [["render", _sfc_render$Z], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Card.vue"]]);
const _sfc_main$Y = /* @__PURE__ */ defineComponent({
  __name: "Carousel",
  props: {
    autoHeight: { type: Boolean, default: false },
    allowScroll: { type: Boolean, default: true },
    freeDrag: { type: Boolean, default: true },
    items: { type: Number, default: 4 },
    index: { type: Number, default: 0 },
    rtl: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: false },
    autoPlaySpeed: { type: Number, default: 4e3 },
    dots: { type: Boolean, default: false }
  },
  emits: ["update:index"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const bglSlider = ref();
    let itemCount = ref(props2.items);
    let activeSlideIndex = ref(props2.index);
    let isDragging = ref(false);
    let isPressed = ref(false);
    let startX = ref(0);
    let scrollStart = ref(0);
    let yHeight = ref("auto");
    let slideCount = ref(0);
    let timeout;
    let autoPlayInterval;
    function preventDefaultClick(e) {
      e.preventDefault();
    }
    function countSlides() {
      if (!bglSlider.value) return;
      slideCount.value = bglSlider.value.children.length;
    }
    function disableDrag() {
      var _a2, _b;
      (_a2 = bglSlider.value) == null ? void 0 : _a2.querySelectorAll("img").forEach((img) => {
        img.setAttribute("draggable", "false");
      });
      Array.from(((_b = bglSlider.value) == null ? void 0 : _b.children) || []).forEach((child) => {
        child.setAttribute("draggable", "false");
        child.addEventListener("click", preventDefaultClick);
      });
    }
    function calcHeight() {
      if (!bglSlider.value) return;
      try {
        const slide = bglSlider.value.children[activeSlideIndex.value];
        if (!slide) return;
        const children2 = Array.from(slide.children);
        const totalHeight = children2.reduce((sum, el) => sum + el.clientHeight, 0);
        yHeight.value = `${totalHeight}px`;
      } catch (error) {
        console.error(error);
      }
    }
    function updateHeight() {
      if (!props2.autoHeight) return;
      setTimeout(calcHeight, 200);
    }
    function easeScroll(target, duration = 500) {
      if (!bglSlider.value || isPressed.value) return;
      const start = bglSlider.value.scrollLeft;
      const change = target - start;
      const startTime = performance.now();
      function animate(currentTime) {
        if (!bglSlider.value) return;
        const timeElapsed = currentTime - startTime;
        const progress = Math.min(timeElapsed / duration, 1);
        bglSlider.value.scrollLeft = start + change * easeInOutQuad(progress);
        if (progress < 1) requestAnimationFrame(animate);
      }
      function easeInOutQuad(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
      }
      requestAnimationFrame(animate);
    }
    function goToSlide(index2) {
      countSlides();
      if (!bglSlider.value || index2 < 0 || index2 >= slideCount.value) return;
      const offset2 = bglSlider.value.offsetWidth * index2 * (props2.rtl ? -1 : 1);
      const duration = window.innerWidth < 600 ? 400 : window.innerWidth < 991 ? 500 : 700;
      easeScroll(offset2, duration);
      activeSlideIndex.value = index2;
      updateHeight();
    }
    function handleSlideChange() {
      if (props2.index !== activeSlideIndex.value) emit2("update:index", activeSlideIndex.value);
    }
    function handleResize() {
      if (!bglSlider.value) return;
      itemCount.value = window.innerWidth < 600 ? 1 : window.innerWidth < 991 ? Math.min(props2.items, 2) : props2.items;
      goToSlide(activeSlideIndex.value);
    }
    function onScrollEnd() {
      if (!props2.freeDrag && !props2.allowScroll || !bglSlider.value) return;
      if (autoPlayInterval) clearInterval(autoPlayInterval);
      if (timeout) clearTimeout(timeout);
      timeout = setTimeout(() => {
        finalizeScroll();
      }, 400);
    }
    function finalizeScroll() {
      if (!bglSlider.value) return;
      if (props2.autoplay) autoPlayInterval = setInterval(next, props2.autoPlaySpeed);
      scrollStart.value = props2.rtl ? -bglSlider.value.scrollLeft : bglSlider.value.scrollLeft;
      activeSlideIndex.value = Math.round(scrollStart.value / bglSlider.value.offsetWidth);
      goToSlide(activeSlideIndex.value);
    }
    function startDrag(e) {
      if (e.button !== 0 || !props2.freeDrag || !bglSlider.value) return;
      if (autoPlayInterval) clearInterval(autoPlayInterval);
      startX.value = e.pageX - bglSlider.value.offsetLeft;
      scrollStart.value = bglSlider.value.scrollLeft;
      isPressed.value = true;
      document.addEventListener("mousemove", onDrag);
      document.addEventListener("mouseup", endDrag);
    }
    function onDrag(e) {
      if (!bglSlider.value) return;
      const x2 = e.pageX - bglSlider.value.offsetLeft;
      const distance = x2 - startX.value;
      if (Math.abs(distance) > 20) isDragging.value = true;
      if (isDragging.value) bglSlider.value.scrollLeft = scrollStart.value - distance;
    }
    function endDrag() {
      isPressed.value = false;
      document.removeEventListener("mousemove", onDrag);
      document.removeEventListener("mouseup", endDrag);
      setTimeout(() => isDragging.value = false, 100);
    }
    function next() {
      if (!bglSlider.value) return;
      countSlides();
      goToSlide((activeSlideIndex.value + 1) % slideCount.value);
    }
    function prev() {
      if (!bglSlider.value) return;
      countSlides();
      goToSlide((activeSlideIndex.value - 1 + slideCount.value) % slideCount.value);
    }
    onMounted(() => {
      window.addEventListener("resize", handleResize);
      disableDrag();
      updateHeight();
      handleResize();
      countSlides();
      if (props2.autoplay) {
        autoPlayInterval = setInterval(next, props2.autoPlaySpeed);
      }
    });
    function clearAutoplay() {
      if (autoPlayInterval) clearInterval(autoPlayInterval);
    }
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    watch(() => props2.index, goToSlide);
    watch(() => activeSlideIndex.value, handleSlideChange);
    const __returned__ = { props: props2, emit: emit2, bglSlider, get itemCount() {
      return itemCount;
    }, set itemCount(v) {
      itemCount = v;
    }, get activeSlideIndex() {
      return activeSlideIndex;
    }, set activeSlideIndex(v) {
      activeSlideIndex = v;
    }, get isDragging() {
      return isDragging;
    }, set isDragging(v) {
      isDragging = v;
    }, get isPressed() {
      return isPressed;
    }, set isPressed(v) {
      isPressed = v;
    }, get startX() {
      return startX;
    }, set startX(v) {
      startX = v;
    }, get scrollStart() {
      return scrollStart;
    }, set scrollStart(v) {
      scrollStart = v;
    }, get yHeight() {
      return yHeight;
    }, set yHeight(v) {
      yHeight = v;
    }, get slideCount() {
      return slideCount;
    }, set slideCount(v) {
      slideCount = v;
    }, get timeout() {
      return timeout;
    }, set timeout(v) {
      timeout = v;
    }, get autoPlayInterval() {
      return autoPlayInterval;
    }, set autoPlayInterval(v) {
      autoPlayInterval = v;
    }, preventDefaultClick, countSlides, disableDrag, calcHeight, updateHeight, easeScroll, goToSlide, handleSlideChange, handleResize, onScrollEnd, finalizeScroll, startDrag, onDrag, endDrag, next, prev, clearAutoplay };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$M = ["dir"];
const _hoisted_2$y = {
  key: 0,
  class: "blocker"
};
const _hoisted_3$q = {
  key: 0,
  class: "dots flex-center gap-05 mt-1"
};
const _hoisted_4$i = ["onClick"];
const _hoisted_5$g = { class: "Handlers" };
function _sfc_render$Y(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["BglCarousel", { autoHeight: $props.autoHeight }]),
    style: normalizeStyle({ height: $setup.yHeight }),
    dir: $props.rtl ? "rtl" : "ltr"
  }, [
    createElementVNode(
      "div",
      {
        ref: "bglSlider",
        class: normalizeClass(["bgl-slider", { dragging: $setup.isDragging, clicking: $setup.isPressed, allowScroll: $props.allowScroll, odd: $setup.itemCount % 2 !== 0, [`slides-${$setup.itemCount}`]: $setup.itemCount === 1 }]),
        style: normalizeStyle({ "--item-count": $setup.itemCount }),
        onScroll: $setup.onScrollEnd,
        onMousedown: $setup.startDrag,
        onMouseover: $setup.clearAutoplay,
        onFocusin: $setup.clearAutoplay
      },
      [
        $setup.isDragging ? (openBlock(), createElementBlock("div", _hoisted_2$y)) : createCommentVNode("v-if", true),
        renderSlot(_ctx.$slots, "default", {}, void 0, true)
      ],
      38
      /* CLASS, STYLE, NEED_HYDRATION */
    ),
    $props.dots && $setup.slideCount > 1 ? (openBlock(), createElementBlock("div", _hoisted_3$q, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($setup.slideCount, (i) => {
          return openBlock(), createElementBlock("span", {
            key: i,
            class: normalizeClass(["dot cursor", { current: $setup.activeSlideIndex === i - 1 }]),
            onClick: ($event) => $setup.goToSlide(i - 1)
          }, null, 10, _hoisted_4$i);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : createCommentVNode("v-if", true),
    createElementVNode("div", _hoisted_5$g, [
      createElementVNode("span", { onClick: $setup.prev }, [
        renderSlot(_ctx.$slots, "prev", {
          index: $setup.activeSlideIndex,
          prev: $setup.prev
        }, void 0, true)
      ]),
      createElementVNode("span", { onClick: $setup.next }, [
        renderSlot(_ctx.$slots, "next", {
          index: $setup.activeSlideIndex,
          next: $setup.next
        }, void 0, true)
      ])
    ])
  ], 14, _hoisted_1$M);
}
const Carousel = /* @__PURE__ */ _export_sfc(_sfc_main$Y, [["render", _sfc_render$Y], ["__scopeId", "data-v-f2893689"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Carousel.vue"]]);
function _isPlaceholder(a) {
  return a != null && typeof a === "object" && a["@@functional/placeholder"] === true;
}
function _curry1(fn2) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn2.apply(this, arguments);
    }
  };
}
function _curry2(fn2) {
  return function f2(a, b2) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function(_b) {
          return fn2(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b2) ? f2 : _isPlaceholder(a) ? _curry1(function(_a2) {
          return fn2(_a2, b2);
        }) : _isPlaceholder(b2) ? _curry1(function(_b) {
          return fn2(a, _b);
        }) : fn2(a, b2);
    }
  };
}
function _arity(n2, fn2) {
  switch (n2) {
    case 0:
      return function() {
        return fn2.apply(this, arguments);
      };
    case 1:
      return function(a0) {
        return fn2.apply(this, arguments);
      };
    case 2:
      return function(a0, a1) {
        return fn2.apply(this, arguments);
      };
    case 3:
      return function(a0, a1, a2) {
        return fn2.apply(this, arguments);
      };
    case 4:
      return function(a0, a1, a2, a3) {
        return fn2.apply(this, arguments);
      };
    case 5:
      return function(a0, a1, a2, a3, a4) {
        return fn2.apply(this, arguments);
      };
    case 6:
      return function(a0, a1, a2, a3, a4, a5) {
        return fn2.apply(this, arguments);
      };
    case 7:
      return function(a0, a1, a2, a3, a4, a5, a6) {
        return fn2.apply(this, arguments);
      };
    case 8:
      return function(a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn2.apply(this, arguments);
      };
    case 9:
      return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn2.apply(this, arguments);
      };
    case 10:
      return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn2.apply(this, arguments);
      };
    default:
      throw new Error("First argument to _arity must be a non-negative integer no greater than ten");
  }
}
function _curryN(length, received, fn2) {
  return function() {
    var combined = [];
    var argsIdx = 0;
    var left2 = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result2;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result2 = received[combinedIdx];
      } else {
        result2 = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result2;
      if (!_isPlaceholder(result2)) {
        left2 -= 1;
      }
      combinedIdx += 1;
    }
    return left2 <= 0 ? fn2.apply(this, combined) : _arity(left2, _curryN(length, combined, fn2));
  };
}
var curryN = /* @__PURE__ */ _curry2(function curryN2(length, fn2) {
  if (length === 1) {
    return _curry1(fn2);
  }
  return _arity(length, _curryN(length, [], fn2));
});
function _curry3(fn2) {
  return function f3(a, b2, c2) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function(_b, _c) {
          return fn2(a, _b, _c);
        });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b2) ? f3 : _isPlaceholder(a) ? _curry2(function(_a2, _c) {
          return fn2(_a2, b2, _c);
        }) : _isPlaceholder(b2) ? _curry2(function(_b, _c) {
          return fn2(a, _b, _c);
        }) : _curry1(function(_c) {
          return fn2(a, b2, _c);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b2) && _isPlaceholder(c2) ? f3 : _isPlaceholder(a) && _isPlaceholder(b2) ? _curry2(function(_a2, _b) {
          return fn2(_a2, _b, c2);
        }) : _isPlaceholder(a) && _isPlaceholder(c2) ? _curry2(function(_a2, _c) {
          return fn2(_a2, b2, _c);
        }) : _isPlaceholder(b2) && _isPlaceholder(c2) ? _curry2(function(_b, _c) {
          return fn2(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function(_a2) {
          return fn2(_a2, b2, c2);
        }) : _isPlaceholder(b2) ? _curry1(function(_b) {
          return fn2(a, _b, c2);
        }) : _isPlaceholder(c2) ? _curry1(function(_c) {
          return fn2(a, b2, _c);
        }) : fn2(a, b2, c2);
    }
  };
}
var _isArray = Array.isArray || function _isArray2(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === "[object Array]";
};
function _isTransformer(obj) {
  return obj != null && typeof obj["@@transducer/step"] === "function";
}
function _dispatchable(methodNames, transducerCreator, fn2) {
  return function() {
    if (arguments.length === 0) {
      return fn2();
    }
    var obj = arguments[arguments.length - 1];
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === "function") {
          return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return transducer(obj);
      }
    }
    return fn2.apply(this, arguments);
  };
}
var _xfBase = {
  init: function() {
    return this.xf["@@transducer/init"]();
  },
  result: function(result2) {
    return this.xf["@@transducer/result"](result2);
  }
};
function _map(fn2, functor) {
  var idx = 0;
  var len = functor.length;
  var result2 = Array(len);
  while (idx < len) {
    result2[idx] = fn2(functor[idx]);
    idx += 1;
  }
  return result2;
}
function _isString(x2) {
  return Object.prototype.toString.call(x2) === "[object String]";
}
var _isArrayLike = /* @__PURE__ */ _curry1(function isArrayLike(x2) {
  if (_isArray(x2)) {
    return true;
  }
  if (!x2) {
    return false;
  }
  if (typeof x2 !== "object") {
    return false;
  }
  if (_isString(x2)) {
    return false;
  }
  if (x2.length === 0) {
    return true;
  }
  if (x2.length > 0) {
    return x2.hasOwnProperty(0) && x2.hasOwnProperty(x2.length - 1);
  }
  return false;
});
var XWrap = /* @__PURE__ */ function() {
  function XWrap2(fn2) {
    this.f = fn2;
  }
  XWrap2.prototype["@@transducer/init"] = function() {
    throw new Error("init not implemented on XWrap");
  };
  XWrap2.prototype["@@transducer/result"] = function(acc) {
    return acc;
  };
  XWrap2.prototype["@@transducer/step"] = function(acc, x2) {
    return this.f(acc, x2);
  };
  return XWrap2;
}();
function _xwrap(fn2) {
  return new XWrap(fn2);
}
var bind$1 = /* @__PURE__ */ _curry2(function bind2(fn2, thisObj) {
  return _arity(fn2.length, function() {
    return fn2.apply(thisObj, arguments);
  });
});
function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf["@@transducer/step"](acc, list[idx]);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    idx += 1;
  }
  return xf["@@transducer/result"](acc);
}
function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf["@@transducer/step"](acc, step.value);
    if (acc && acc["@@transducer/reduced"]) {
      acc = acc["@@transducer/value"];
      break;
    }
    step = iter.next();
  }
  return xf["@@transducer/result"](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
  return xf["@@transducer/result"](obj[methodName](bind$1(xf["@@transducer/step"], xf), acc));
}
var symIterator = typeof Symbol !== "undefined" ? Symbol.iterator : "@@iterator";
function _reduce(fn2, acc, list) {
  if (typeof fn2 === "function") {
    fn2 = _xwrap(fn2);
  }
  if (_isArrayLike(list)) {
    return _arrayReduce(fn2, acc, list);
  }
  if (typeof list["fantasy-land/reduce"] === "function") {
    return _methodReduce(fn2, acc, list, "fantasy-land/reduce");
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn2, acc, list[symIterator]());
  }
  if (typeof list.next === "function") {
    return _iterableReduce(fn2, acc, list);
  }
  if (typeof list.reduce === "function") {
    return _methodReduce(fn2, acc, list, "reduce");
  }
  throw new TypeError("reduce: list must be array or iterable");
}
var XMap = /* @__PURE__ */ function() {
  function XMap2(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap2.prototype["@@transducer/init"] = _xfBase.init;
  XMap2.prototype["@@transducer/result"] = _xfBase.result;
  XMap2.prototype["@@transducer/step"] = function(result2, input) {
    return this.xf["@@transducer/step"](result2, this.f(input));
  };
  return XMap2;
}();
var _xmap = /* @__PURE__ */ _curry2(function _xmap2(f, xf) {
  return new XMap(f, xf);
});
function _has(prop3, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop3);
}
var toString$1 = Object.prototype.toString;
var _isArguments = /* @__PURE__ */ function() {
  return toString$1.call(arguments) === "[object Arguments]" ? function _isArguments2(x2) {
    return toString$1.call(x2) === "[object Arguments]";
  } : function _isArguments2(x2) {
    return _has("callee", x2);
  };
}();
var hasEnumBug = !/* @__PURE__ */ {
  toString: null
}.propertyIsEnumerable("toString");
var nonEnumerableProps = ["constructor", "valueOf", "isPrototypeOf", "toString", "propertyIsEnumerable", "hasOwnProperty", "toLocaleString"];
var hasArgsEnumBug = /* @__PURE__ */ function() {
  return arguments.propertyIsEnumerable("length");
}();
var contains = function contains2(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};
var keys = typeof Object.keys === "function" && !hasArgsEnumBug ? /* @__PURE__ */ _curry1(function keys2(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /* @__PURE__ */ _curry1(function keys3(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop3, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  for (prop3 in obj) {
    if (_has(prop3, obj) && (!checkArgsLength || prop3 !== "length")) {
      ks[ks.length] = prop3;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop3 = nonEnumerableProps[nIdx];
      if (_has(prop3, obj) && !contains(ks, prop3)) {
        ks[ks.length] = prop3;
      }
      nIdx -= 1;
    }
  }
  return ks;
});
var map$1 = /* @__PURE__ */ _curry2(
  /* @__PURE__ */ _dispatchable(["fantasy-land/map", "map"], _xmap, function map2(fn2, functor) {
    switch (Object.prototype.toString.call(functor)) {
      case "[object Function]":
        return curryN(functor.length, function() {
          return fn2.call(this, functor.apply(this, arguments));
        });
      case "[object Object]":
        return _reduce(function(acc, key) {
          acc[key] = fn2(functor[key]);
          return acc;
        }, {}, keys(functor));
      default:
        return _map(fn2, functor);
    }
  })
);
var map$2 = map$1;
var _isInteger = Number.isInteger || function _isInteger2(n2) {
  return n2 << 0 === n2;
};
var nth = /* @__PURE__ */ _curry2(function nth2(offset2, list) {
  var idx = offset2 < 0 ? list.length + offset2 : offset2;
  return _isString(list) ? list.charAt(idx) : list[idx];
});
var nth$1 = nth;
var prop = /* @__PURE__ */ _curry2(function prop2(p, obj) {
  if (obj == null) {
    return;
  }
  return _isInteger(p) ? nth$1(p, obj) : obj[p];
});
var prop$1 = prop;
var reduce = /* @__PURE__ */ _curry3(_reduce);
var reduce$1 = reduce;
var values = /* @__PURE__ */ _curry1(function values2(obj) {
  var props2 = keys(obj);
  var len = props2.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props2[idx]];
    idx += 1;
  }
  return vals;
});
var values$1 = values;
function _isFunction(x2) {
  var type3 = Object.prototype.toString.call(x2);
  return type3 === "[object Function]" || type3 === "[object AsyncFunction]" || type3 === "[object GeneratorFunction]" || type3 === "[object AsyncGeneratorFunction]";
}
var type = /* @__PURE__ */ _curry1(function type2(val) {
  return val === null ? "Null" : val === void 0 ? "Undefined" : Object.prototype.toString.call(val).slice(8, -1);
});
function _pipe(f, g2) {
  return function() {
    return g2.call(this, f.apply(this, arguments));
  };
}
function _checkForMethod(methodname, fn2) {
  return function() {
    var length = arguments.length;
    if (length === 0) {
      return fn2();
    }
    var obj = arguments[length - 1];
    return _isArray(obj) || typeof obj[methodname] !== "function" ? fn2.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
  };
}
var slice = /* @__PURE__ */ _curry3(
  /* @__PURE__ */ _checkForMethod("slice", function slice2(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
  })
);
var tail = /* @__PURE__ */ _curry1(
  /* @__PURE__ */ _checkForMethod(
    "tail",
    /* @__PURE__ */ slice(1, Infinity)
  )
);
var tail$1 = tail;
function pipe() {
  if (arguments.length === 0) {
    throw new Error("pipe requires at least one argument");
  }
  return _arity(arguments[0].length, reduce$1(_pipe, arguments[0], tail$1(arguments)));
}
function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}
function _includesWith(pred, x2, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x2, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}
function _functionName(f) {
  var match2 = String(f).match(/^function (\w*)/);
  return match2 == null ? "" : match2[1];
}
function _objectIs(a, b2) {
  if (a === b2) {
    return a !== 0 || 1 / a === 1 / b2;
  } else {
    return a !== a && b2 !== b2;
  }
}
var _objectIs$1 = typeof Object.is === "function" ? Object.is : _objectIs;
function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);
  var b2 = _arrayFromIterator(bIterator);
  function eq(_a2, _b) {
    return _equals(_a2, _b, stackA.slice(), stackB.slice());
  }
  return !_includesWith(function(b3, aItem) {
    return !_includesWith(eq, aItem, b3);
  }, b2, a);
}
function _equals(a, b2, stackA, stackB) {
  if (_objectIs$1(a, b2)) {
    return true;
  }
  var typeA = type(a);
  if (typeA !== type(b2)) {
    return false;
  }
  if (typeof a["fantasy-land/equals"] === "function" || typeof b2["fantasy-land/equals"] === "function") {
    return typeof a["fantasy-land/equals"] === "function" && a["fantasy-land/equals"](b2) && typeof b2["fantasy-land/equals"] === "function" && b2["fantasy-land/equals"](a);
  }
  if (typeof a.equals === "function" || typeof b2.equals === "function") {
    return typeof a.equals === "function" && a.equals(b2) && typeof b2.equals === "function" && b2.equals(a);
  }
  switch (typeA) {
    case "Arguments":
    case "Array":
    case "Object":
      if (typeof a.constructor === "function" && _functionName(a.constructor) === "Promise") {
        return a === b2;
      }
      break;
    case "Boolean":
    case "Number":
    case "String":
      if (!(typeof a === typeof b2 && _objectIs$1(a.valueOf(), b2.valueOf()))) {
        return false;
      }
      break;
    case "Date":
      if (!_objectIs$1(a.valueOf(), b2.valueOf())) {
        return false;
      }
      break;
    case "Error":
      return a.name === b2.name && a.message === b2.message;
    case "RegExp":
      if (!(a.source === b2.source && a.global === b2.global && a.ignoreCase === b2.ignoreCase && a.multiline === b2.multiline && a.sticky === b2.sticky && a.unicode === b2.unicode)) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b2;
    }
    idx -= 1;
  }
  switch (typeA) {
    case "Map":
      if (a.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(a.entries(), b2.entries(), stackA.concat([a]), stackB.concat([b2]));
    case "Set":
      if (a.size !== b2.size) {
        return false;
      }
      return _uniqContentEquals(a.values(), b2.values(), stackA.concat([a]), stackB.concat([b2]));
    case "Arguments":
    case "Array":
    case "Object":
    case "Boolean":
    case "Number":
    case "String":
    case "Date":
    case "Error":
    case "RegExp":
    case "Int8Array":
    case "Uint8Array":
    case "Uint8ClampedArray":
    case "Int16Array":
    case "Uint16Array":
    case "Int32Array":
    case "Uint32Array":
    case "Float32Array":
    case "Float64Array":
    case "ArrayBuffer":
      break;
    default:
      return false;
  }
  var keysA = keys(a);
  if (keysA.length !== keys(b2).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b2]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b2) && _equals(b2[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}
var equals = /* @__PURE__ */ _curry2(function equals2(a, b2) {
  return _equals(a, b2, [], []);
});
function _indexOf(list, a, idx) {
  var inf, item;
  if (typeof list.indexOf === "function") {
    switch (typeof a) {
      case "number":
        if (a === 0) {
          inf = 1 / a;
          while (idx < list.length) {
            item = list[idx];
            if (item === 0 && 1 / item === inf) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        } else if (a !== a) {
          while (idx < list.length) {
            item = list[idx];
            if (typeof item === "number" && item !== item) {
              return idx;
            }
            idx += 1;
          }
          return -1;
        }
        return list.indexOf(a, idx);
      // all these types can utilise Set
      case "string":
      case "boolean":
      case "function":
      case "undefined":
        return list.indexOf(a, idx);
      case "object":
        if (a === null) {
          return list.indexOf(a, idx);
        }
    }
  }
  while (idx < list.length) {
    if (equals(list[idx], a)) {
      return idx;
    }
    idx += 1;
  }
  return -1;
}
function _includes(a, list) {
  return _indexOf(list, a, 0) >= 0;
}
function _quote(s) {
  var escaped = s.replace(/\\/g, "\\\\").replace(/[\b]/g, "\\b").replace(/\f/g, "\\f").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/\t/g, "\\t").replace(/\v/g, "\\v").replace(/\0/g, "\\0");
  return '"' + escaped.replace(/"/g, '\\"') + '"';
}
var pad = function pad2(n2) {
  return (n2 < 10 ? "0" : "") + n2;
};
var _toISOString = typeof Date.prototype.toISOString === "function" ? function _toISOString2(d2) {
  return d2.toISOString();
} : function _toISOString3(d2) {
  return d2.getUTCFullYear() + "-" + pad(d2.getUTCMonth() + 1) + "-" + pad(d2.getUTCDate()) + "T" + pad(d2.getUTCHours()) + ":" + pad(d2.getUTCMinutes()) + ":" + pad(d2.getUTCSeconds()) + "." + (d2.getUTCMilliseconds() / 1e3).toFixed(3).slice(2, 5) + "Z";
};
function _complement(f) {
  return function() {
    return !f.apply(this, arguments);
  };
}
function _filter(fn2, list) {
  var idx = 0;
  var len = list.length;
  var result2 = [];
  while (idx < len) {
    if (fn2(list[idx])) {
      result2[result2.length] = list[idx];
    }
    idx += 1;
  }
  return result2;
}
function _isObject(x2) {
  return Object.prototype.toString.call(x2) === "[object Object]";
}
var XFilter = /* @__PURE__ */ function() {
  function XFilter2(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XFilter2.prototype["@@transducer/init"] = _xfBase.init;
  XFilter2.prototype["@@transducer/result"] = _xfBase.result;
  XFilter2.prototype["@@transducer/step"] = function(result2, input) {
    return this.f(input) ? this.xf["@@transducer/step"](result2, input) : result2;
  };
  return XFilter2;
}();
var _xfilter = /* @__PURE__ */ _curry2(function _xfilter2(f, xf) {
  return new XFilter(f, xf);
});
var filter$1 = /* @__PURE__ */ _curry2(
  /* @__PURE__ */ _dispatchable(["fantasy-land/filter", "filter"], _xfilter, function(pred, filterable) {
    return _isObject(filterable) ? _reduce(function(acc, key) {
      if (pred(filterable[key])) {
        acc[key] = filterable[key];
      }
      return acc;
    }, {}, keys(filterable)) : (
      // else
      _filter(pred, filterable)
    );
  })
);
var reject = /* @__PURE__ */ _curry2(function reject2(pred, filterable) {
  return filter$1(_complement(pred), filterable);
});
function _toString(x2, seen) {
  var recur = function recur2(y2) {
    var xs = seen.concat([x2]);
    return _includes(y2, xs) ? "<Circular>" : _toString(y2, xs);
  };
  var mapPairs = function(obj, keys4) {
    return _map(function(k2) {
      return _quote(k2) + ": " + recur(obj[k2]);
    }, keys4.slice().sort());
  };
  switch (Object.prototype.toString.call(x2)) {
    case "[object Arguments]":
      return "(function() { return arguments; }(" + _map(recur, x2).join(", ") + "))";
    case "[object Array]":
      return "[" + _map(recur, x2).concat(mapPairs(x2, reject(function(k2) {
        return /^\d+$/.test(k2);
      }, keys(x2)))).join(", ") + "]";
    case "[object Boolean]":
      return typeof x2 === "object" ? "new Boolean(" + recur(x2.valueOf()) + ")" : x2.toString();
    case "[object Date]":
      return "new Date(" + (isNaN(x2.valueOf()) ? recur(NaN) : _quote(_toISOString(x2))) + ")";
    case "[object Null]":
      return "null";
    case "[object Number]":
      return typeof x2 === "object" ? "new Number(" + recur(x2.valueOf()) + ")" : 1 / x2 === -Infinity ? "-0" : x2.toString(10);
    case "[object String]":
      return typeof x2 === "object" ? "new String(" + recur(x2.valueOf()) + ")" : _quote(x2);
    case "[object Undefined]":
      return "undefined";
    default:
      if (typeof x2.toString === "function") {
        var repr = x2.toString();
        if (repr !== "[object Object]") {
          return repr;
        }
      }
      return "{" + mapPairs(x2, keys(x2)).join(", ") + "}";
  }
}
var toString$2 = /* @__PURE__ */ _curry1(function toString2(val) {
  return _toString(val, []);
});
var curry = /* @__PURE__ */ _curry1(function curry2(fn2) {
  return curryN(fn2.length, fn2);
});
var curry$1 = curry;
var invoker = /* @__PURE__ */ _curry2(function invoker2(arity, method) {
  return curryN(arity + 1, function() {
    var target = arguments[arity];
    if (target != null && _isFunction(target[method])) {
      return target[method].apply(target, Array.prototype.slice.call(arguments, 0, arity));
    }
    throw new TypeError(toString$2(target) + ' does not have a method named "' + method + '"');
  });
});
var invoker$1 = invoker;
var is = /* @__PURE__ */ _curry2(function is2(Ctor, val) {
  return val instanceof Ctor || val != null && (val.constructor === Ctor || Ctor.name === "Object" && typeof val === "object");
});
var is$1 = is;
var join = /* @__PURE__ */ invoker$1(1, "join");
var join$1 = join;
var mergeWithKey = /* @__PURE__ */ _curry3(function mergeWithKey2(fn2, l, r) {
  var result2 = {};
  var k2;
  for (k2 in l) {
    if (_has(k2, l)) {
      result2[k2] = _has(k2, r) ? fn2(k2, l[k2], r[k2]) : l[k2];
    }
  }
  for (k2 in r) {
    if (_has(k2, r) && !_has(k2, result2)) {
      result2[k2] = r[k2];
    }
  }
  return result2;
});
var mergeDeepWithKey = /* @__PURE__ */ _curry3(function mergeDeepWithKey2(fn2, lObj, rObj) {
  return mergeWithKey(function(k2, lVal, rVal) {
    if (_isObject(lVal) && _isObject(rVal)) {
      return mergeDeepWithKey2(fn2, lVal, rVal);
    } else {
      return fn2(k2, lVal, rVal);
    }
  }, lObj, rObj);
});
var mergeDeepLeft = /* @__PURE__ */ _curry2(function mergeDeepLeft2(lObj, rObj) {
  return mergeDeepWithKey(function(k2, lVal, rVal) {
    return lVal;
  }, lObj, rObj);
});
var mergeDeepLeft$1 = mergeDeepLeft;
var omit = /* @__PURE__ */ _curry2(function omit2(names, obj) {
  var result2 = {};
  var index2 = {};
  var idx = 0;
  var len = names.length;
  while (idx < len) {
    index2[names[idx]] = 1;
    idx += 1;
  }
  for (var prop3 in obj) {
    if (!index2.hasOwnProperty(prop3)) {
      result2[prop3] = obj[prop3];
    }
  }
  return result2;
});
var omit$1 = omit;
var pickBy = /* @__PURE__ */ _curry2(function pickBy2(test2, obj) {
  var result2 = {};
  for (var prop3 in obj) {
    if (test2(obj[prop3], prop3, obj)) {
      result2[prop3] = obj[prop3];
    }
  }
  return result2;
});
var pickBy$1 = pickBy;
var split = /* @__PURE__ */ invoker$1(1, "split");
var split$1 = split;
var toLower = /* @__PURE__ */ invoker$1(0, "toLowerCase");
var toLower$1 = toLower;
var zipObj = /* @__PURE__ */ _curry2(function zipObj2(keys4, values3) {
  var idx = 0;
  var len = Math.min(keys4.length, values3.length);
  var out = {};
  while (idx < len) {
    out[keys4[idx]] = values3[idx];
    idx += 1;
  }
  return out;
});
var zipObj$1 = zipObj;
pipe(toLower$1, split$1(" "), join$1("-"));
const getCol = curry$1((col, df) => {
  if (is$1(Number)) {
    return map$2((v) => nth$1(col, v) || "", df).filter((x2) => x2 !== "");
  }
  return map$2(prop$1(col), df);
});
const mapKeys = (fn2, data2) => zipObj$1(map$2(fn2, keys(data2)), values$1(data2));
const kebabize = (str) => {
  return str.split("").map((letter, idx) => {
    return letter.toUpperCase() === letter ? `${idx !== 0 ? "-" : ""}${letter.toLowerCase()}` : letter;
  }).join("");
};
function ascending$1(a, b2) {
  return a == null || b2 == null ? NaN : a < b2 ? -1 : a > b2 ? 1 : a >= b2 ? 0 : NaN;
}
function descending$1(a, b2) {
  return a == null || b2 == null ? NaN : b2 < a ? -1 : b2 > a ? 1 : b2 >= a ? 0 : NaN;
}
function bisector(f) {
  let compare1, compare2, delta;
  if (f.length !== 2) {
    compare1 = ascending$1;
    compare2 = (d2, x2) => ascending$1(f(d2), x2);
    delta = (d2, x2) => f(d2) - x2;
  } else {
    compare1 = f === ascending$1 || f === descending$1 ? f : zero$1;
    compare2 = f;
    delta = f;
  }
  function left2(a, x2, lo2 = 0, hi = a.length) {
    if (lo2 < hi) {
      if (compare1(x2, x2) !== 0) return hi;
      do {
        const mid = lo2 + hi >>> 1;
        if (compare2(a[mid], x2) < 0) lo2 = mid + 1;
        else hi = mid;
      } while (lo2 < hi);
    }
    return lo2;
  }
  function right2(a, x2, lo2 = 0, hi = a.length) {
    if (lo2 < hi) {
      if (compare1(x2, x2) !== 0) return hi;
      do {
        const mid = lo2 + hi >>> 1;
        if (compare2(a[mid], x2) <= 0) lo2 = mid + 1;
        else hi = mid;
      } while (lo2 < hi);
    }
    return lo2;
  }
  function center2(a, x2, lo2 = 0, hi = a.length) {
    const i = left2(a, x2, lo2, hi - 1);
    return i > lo2 && delta(a[i - 1], x2) > -delta(a[i], x2) ? i - 1 : i;
  }
  return { left: left2, center: center2, right: right2 };
}
function zero$1() {
  return 0;
}
function number$2(x2) {
  return x2 === null ? NaN : +x2;
}
const ascendingBisect = bisector(ascending$1);
const bisectRight = ascendingBisect.right;
const bisectCenter = bisector(number$2).center;
function extent(values3, valueof) {
  let min2;
  let max2;
  {
    for (const value of values3) {
      if (value != null) {
        if (min2 === void 0) {
          if (value >= value) min2 = max2 = value;
        } else {
          if (min2 > value) min2 = value;
          if (max2 < value) max2 = value;
        }
      }
    }
  }
  return [min2, max2];
}
class InternMap extends Map {
  constructor(entries, key = keyof) {
    super();
    Object.defineProperties(this, { _intern: { value: /* @__PURE__ */ new Map() }, _key: { value: key } });
    if (entries != null) for (const [key2, value] of entries) this.set(key2, value);
  }
  get(key) {
    return super.get(intern_get(this, key));
  }
  has(key) {
    return super.has(intern_get(this, key));
  }
  set(key, value) {
    return super.set(intern_set(this, key), value);
  }
  delete(key) {
    return super.delete(intern_delete(this, key));
  }
}
function intern_get({ _intern, _key }, value) {
  const key = _key(value);
  return _intern.has(key) ? _intern.get(key) : value;
}
function intern_set({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) return _intern.get(key);
  _intern.set(key, value);
  return value;
}
function intern_delete({ _intern, _key }, value) {
  const key = _key(value);
  if (_intern.has(key)) {
    value = _intern.get(key);
    _intern.delete(key);
  }
  return value;
}
function keyof(value) {
  return value !== null && typeof value === "object" ? value.valueOf() : value;
}
const e10 = Math.sqrt(50), e5 = Math.sqrt(10), e2 = Math.sqrt(2);
function tickSpec(start, stop, count2) {
  const step = (stop - start) / Math.max(0, count2), power = Math.floor(Math.log10(step)), error = step / Math.pow(10, power), factor = error >= e10 ? 10 : error >= e5 ? 5 : error >= e2 ? 2 : 1;
  let i1, i2, inc;
  if (power < 0) {
    inc = Math.pow(10, -power) / factor;
    i1 = Math.round(start * inc);
    i2 = Math.round(stop * inc);
    if (i1 / inc < start) ++i1;
    if (i2 / inc > stop) --i2;
    inc = -inc;
  } else {
    inc = Math.pow(10, power) * factor;
    i1 = Math.round(start / inc);
    i2 = Math.round(stop / inc);
    if (i1 * inc < start) ++i1;
    if (i2 * inc > stop) --i2;
  }
  if (i2 < i1 && 0.5 <= count2 && count2 < 2) return tickSpec(start, stop, count2 * 2);
  return [i1, i2, inc];
}
function ticks(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  if (!(count2 > 0)) return [];
  if (start === stop) return [start];
  const reverse = stop < start, [i1, i2, inc] = reverse ? tickSpec(stop, start, count2) : tickSpec(start, stop, count2);
  if (!(i2 >= i1)) return [];
  const n2 = i2 - i1 + 1, ticks2 = new Array(n2);
  if (reverse) {
    if (inc < 0) for (let i = 0; i < n2; ++i) ticks2[i] = (i2 - i) / -inc;
    else for (let i = 0; i < n2; ++i) ticks2[i] = (i2 - i) * inc;
  } else {
    if (inc < 0) for (let i = 0; i < n2; ++i) ticks2[i] = (i1 + i) / -inc;
    else for (let i = 0; i < n2; ++i) ticks2[i] = (i1 + i) * inc;
  }
  return ticks2;
}
function tickIncrement(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  return tickSpec(start, stop, count2)[2];
}
function tickStep(start, stop, count2) {
  stop = +stop, start = +start, count2 = +count2;
  const reverse = stop < start, inc = reverse ? tickIncrement(stop, start, count2) : tickIncrement(start, stop, count2);
  return (reverse ? -1 : 1) * (inc < 0 ? 1 / -inc : inc);
}
function max$1$1(values3, valueof) {
  let max2;
  if (valueof === void 0) {
    for (const value of values3) {
      if (value != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values3) {
      if ((value = valueof(value, ++index2, values3)) != null && (max2 < value || max2 === void 0 && value >= value)) {
        max2 = value;
      }
    }
  }
  return max2;
}
function min$1$1(values3, valueof) {
  let min2;
  if (valueof === void 0) {
    for (const value of values3) {
      if (value != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  } else {
    let index2 = -1;
    for (let value of values3) {
      if ((value = valueof(value, ++index2, values3)) != null && (min2 > value || min2 === void 0 && value >= value)) {
        min2 = value;
      }
    }
  }
  return min2;
}
function range(start, stop, step) {
  start = +start, stop = +stop, step = (n2 = arguments.length) < 2 ? (stop = start, start = 0, 1) : n2 < 3 ? 1 : +step;
  var i = -1, n2 = Math.max(0, Math.ceil((stop - start) / step)) | 0, range2 = new Array(n2);
  while (++i < n2) {
    range2[i] = start + i * step;
  }
  return range2;
}
function initRange(domain2, range2) {
  switch (arguments.length) {
    case 0:
      break;
    case 1:
      this.range(domain2);
      break;
    default:
      this.range(range2).domain(domain2);
      break;
  }
  return this;
}
function initInterpolator(domain2, interpolator) {
  switch (arguments.length) {
    case 0:
      break;
    case 1: {
      if (typeof domain2 === "function") this.interpolator(domain2);
      else this.range(domain2);
      break;
    }
    default: {
      this.domain(domain2);
      if (typeof interpolator === "function") this.interpolator(interpolator);
      else this.range(interpolator);
      break;
    }
  }
  return this;
}
const implicit = Symbol("implicit");
function ordinal() {
  var index2 = new InternMap(), domain2 = [], range2 = [], unknown = implicit;
  function scale(d2) {
    let i = index2.get(d2);
    if (i === void 0) {
      if (unknown !== implicit) return unknown;
      index2.set(d2, i = domain2.push(d2) - 1);
    }
    return range2[i % range2.length];
  }
  scale.domain = function(_2) {
    if (!arguments.length) return domain2.slice();
    domain2 = [], index2 = new InternMap();
    for (const value of _2) {
      if (index2.has(value)) continue;
      index2.set(value, domain2.push(value) - 1);
    }
    return scale;
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), scale) : range2.slice();
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown = _2, scale) : unknown;
  };
  scale.copy = function() {
    return ordinal(domain2, range2).unknown(unknown);
  };
  initRange.apply(scale, arguments);
  return scale;
}
function band() {
  var scale = ordinal().unknown(void 0), domain2 = scale.domain, ordinalRange = scale.range, r0 = 0, r1 = 1, step, bandwidth, round2 = false, paddingInner = 0, paddingOuter = 0, align = 0.5;
  delete scale.unknown;
  function rescale() {
    var n2 = domain2().length, reverse = r1 < r0, start = reverse ? r1 : r0, stop = reverse ? r0 : r1;
    step = (stop - start) / Math.max(1, n2 - paddingInner + paddingOuter * 2);
    if (round2) step = Math.floor(step);
    start += (stop - start - step * (n2 - paddingInner)) * align;
    bandwidth = step * (1 - paddingInner);
    if (round2) start = Math.round(start), bandwidth = Math.round(bandwidth);
    var values3 = range(n2).map(function(i) {
      return start + step * i;
    });
    return ordinalRange(reverse ? values3.reverse() : values3);
  }
  scale.domain = function(_2) {
    return arguments.length ? (domain2(_2), rescale()) : domain2();
  };
  scale.range = function(_2) {
    return arguments.length ? ([r0, r1] = _2, r0 = +r0, r1 = +r1, rescale()) : [r0, r1];
  };
  scale.rangeRound = function(_2) {
    return [r0, r1] = _2, r0 = +r0, r1 = +r1, round2 = true, rescale();
  };
  scale.bandwidth = function() {
    return bandwidth;
  };
  scale.step = function() {
    return step;
  };
  scale.round = function(_2) {
    return arguments.length ? (round2 = !!_2, rescale()) : round2;
  };
  scale.padding = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, paddingOuter = +_2), rescale()) : paddingInner;
  };
  scale.paddingInner = function(_2) {
    return arguments.length ? (paddingInner = Math.min(1, _2), rescale()) : paddingInner;
  };
  scale.paddingOuter = function(_2) {
    return arguments.length ? (paddingOuter = +_2, rescale()) : paddingOuter;
  };
  scale.align = function(_2) {
    return arguments.length ? (align = Math.max(0, Math.min(1, _2)), rescale()) : align;
  };
  scale.copy = function() {
    return band(domain2(), [r0, r1]).round(round2).paddingInner(paddingInner).paddingOuter(paddingOuter).align(align);
  };
  return initRange.apply(rescale(), arguments);
}
function define(constructor, factory, prototype2) {
  constructor.prototype = factory.prototype = prototype2;
  prototype2.constructor = constructor;
}
function extend$2(parent, definition) {
  var prototype2 = Object.create(parent.prototype);
  for (var key in definition) prototype2[key] = definition[key];
  return prototype2;
}
function Color() {
}
var darker = 0.7;
var brighter = 1 / darker;
var reI = "\\s*([+-]?\\d+)\\s*", reN = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)\\s*", reP = "\\s*([+-]?(?:\\d*\\.)?\\d+(?:[eE][+-]?\\d+)?)%\\s*", reHex = /^#([0-9a-f]{3,8})$/, reRgbInteger = new RegExp(`^rgb\\(${reI},${reI},${reI}\\)$`), reRgbPercent = new RegExp(`^rgb\\(${reP},${reP},${reP}\\)$`), reRgbaInteger = new RegExp(`^rgba\\(${reI},${reI},${reI},${reN}\\)$`), reRgbaPercent = new RegExp(`^rgba\\(${reP},${reP},${reP},${reN}\\)$`), reHslPercent = new RegExp(`^hsl\\(${reN},${reP},${reP}\\)$`), reHslaPercent = new RegExp(`^hsla\\(${reN},${reP},${reP},${reN}\\)$`);
var named = {
  aliceblue: 15792383,
  antiquewhite: 16444375,
  aqua: 65535,
  aquamarine: 8388564,
  azure: 15794175,
  beige: 16119260,
  bisque: 16770244,
  black: 0,
  blanchedalmond: 16772045,
  blue: 255,
  blueviolet: 9055202,
  brown: 10824234,
  burlywood: 14596231,
  cadetblue: 6266528,
  chartreuse: 8388352,
  chocolate: 13789470,
  coral: 16744272,
  cornflowerblue: 6591981,
  cornsilk: 16775388,
  crimson: 14423100,
  cyan: 65535,
  darkblue: 139,
  darkcyan: 35723,
  darkgoldenrod: 12092939,
  darkgray: 11119017,
  darkgreen: 25600,
  darkgrey: 11119017,
  darkkhaki: 12433259,
  darkmagenta: 9109643,
  darkolivegreen: 5597999,
  darkorange: 16747520,
  darkorchid: 10040012,
  darkred: 9109504,
  darksalmon: 15308410,
  darkseagreen: 9419919,
  darkslateblue: 4734347,
  darkslategray: 3100495,
  darkslategrey: 3100495,
  darkturquoise: 52945,
  darkviolet: 9699539,
  deeppink: 16716947,
  deepskyblue: 49151,
  dimgray: 6908265,
  dimgrey: 6908265,
  dodgerblue: 2003199,
  firebrick: 11674146,
  floralwhite: 16775920,
  forestgreen: 2263842,
  fuchsia: 16711935,
  gainsboro: 14474460,
  ghostwhite: 16316671,
  gold: 16766720,
  goldenrod: 14329120,
  gray: 8421504,
  green: 32768,
  greenyellow: 11403055,
  grey: 8421504,
  honeydew: 15794160,
  hotpink: 16738740,
  indianred: 13458524,
  indigo: 4915330,
  ivory: 16777200,
  khaki: 15787660,
  lavender: 15132410,
  lavenderblush: 16773365,
  lawngreen: 8190976,
  lemonchiffon: 16775885,
  lightblue: 11393254,
  lightcoral: 15761536,
  lightcyan: 14745599,
  lightgoldenrodyellow: 16448210,
  lightgray: 13882323,
  lightgreen: 9498256,
  lightgrey: 13882323,
  lightpink: 16758465,
  lightsalmon: 16752762,
  lightseagreen: 2142890,
  lightskyblue: 8900346,
  lightslategray: 7833753,
  lightslategrey: 7833753,
  lightsteelblue: 11584734,
  lightyellow: 16777184,
  lime: 65280,
  limegreen: 3329330,
  linen: 16445670,
  magenta: 16711935,
  maroon: 8388608,
  mediumaquamarine: 6737322,
  mediumblue: 205,
  mediumorchid: 12211667,
  mediumpurple: 9662683,
  mediumseagreen: 3978097,
  mediumslateblue: 8087790,
  mediumspringgreen: 64154,
  mediumturquoise: 4772300,
  mediumvioletred: 13047173,
  midnightblue: 1644912,
  mintcream: 16121850,
  mistyrose: 16770273,
  moccasin: 16770229,
  navajowhite: 16768685,
  navy: 128,
  oldlace: 16643558,
  olive: 8421376,
  olivedrab: 7048739,
  orange: 16753920,
  orangered: 16729344,
  orchid: 14315734,
  palegoldenrod: 15657130,
  palegreen: 10025880,
  paleturquoise: 11529966,
  palevioletred: 14381203,
  papayawhip: 16773077,
  peachpuff: 16767673,
  peru: 13468991,
  pink: 16761035,
  plum: 14524637,
  powderblue: 11591910,
  purple: 8388736,
  rebeccapurple: 6697881,
  red: 16711680,
  rosybrown: 12357519,
  royalblue: 4286945,
  saddlebrown: 9127187,
  salmon: 16416882,
  sandybrown: 16032864,
  seagreen: 3050327,
  seashell: 16774638,
  sienna: 10506797,
  silver: 12632256,
  skyblue: 8900331,
  slateblue: 6970061,
  slategray: 7372944,
  slategrey: 7372944,
  snow: 16775930,
  springgreen: 65407,
  steelblue: 4620980,
  tan: 13808780,
  teal: 32896,
  thistle: 14204888,
  tomato: 16737095,
  turquoise: 4251856,
  violet: 15631086,
  wheat: 16113331,
  white: 16777215,
  whitesmoke: 16119285,
  yellow: 16776960,
  yellowgreen: 10145074
};
define(Color, color, {
  copy(channels) {
    return Object.assign(new this.constructor(), this, channels);
  },
  displayable() {
    return this.rgb().displayable();
  },
  hex: color_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: color_formatHex,
  formatHex8: color_formatHex8,
  formatHsl: color_formatHsl,
  formatRgb: color_formatRgb,
  toString: color_formatRgb
});
function color_formatHex() {
  return this.rgb().formatHex();
}
function color_formatHex8() {
  return this.rgb().formatHex8();
}
function color_formatHsl() {
  return hslConvert(this).formatHsl();
}
function color_formatRgb() {
  return this.rgb().formatRgb();
}
function color(format2) {
  var m2, l;
  format2 = (format2 + "").trim().toLowerCase();
  return (m2 = reHex.exec(format2)) ? (l = m2[1].length, m2 = parseInt(m2[1], 16), l === 6 ? rgbn(m2) : l === 3 ? new Rgb(m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, (m2 & 15) << 4 | m2 & 15, 1) : l === 8 ? rgba(m2 >> 24 & 255, m2 >> 16 & 255, m2 >> 8 & 255, (m2 & 255) / 255) : l === 4 ? rgba(m2 >> 12 & 15 | m2 >> 8 & 240, m2 >> 8 & 15 | m2 >> 4 & 240, m2 >> 4 & 15 | m2 & 240, ((m2 & 15) << 4 | m2 & 15) / 255) : null) : (m2 = reRgbInteger.exec(format2)) ? new Rgb(m2[1], m2[2], m2[3], 1) : (m2 = reRgbPercent.exec(format2)) ? new Rgb(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, 1) : (m2 = reRgbaInteger.exec(format2)) ? rgba(m2[1], m2[2], m2[3], m2[4]) : (m2 = reRgbaPercent.exec(format2)) ? rgba(m2[1] * 255 / 100, m2[2] * 255 / 100, m2[3] * 255 / 100, m2[4]) : (m2 = reHslPercent.exec(format2)) ? hsla(m2[1], m2[2] / 100, m2[3] / 100, 1) : (m2 = reHslaPercent.exec(format2)) ? hsla(m2[1], m2[2] / 100, m2[3] / 100, m2[4]) : named.hasOwnProperty(format2) ? rgbn(named[format2]) : format2 === "transparent" ? new Rgb(NaN, NaN, NaN, 0) : null;
}
function rgbn(n2) {
  return new Rgb(n2 >> 16 & 255, n2 >> 8 & 255, n2 & 255, 1);
}
function rgba(r, g2, b2, a) {
  if (a <= 0) r = g2 = b2 = NaN;
  return new Rgb(r, g2, b2, a);
}
function rgbConvert(o) {
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Rgb();
  o = o.rgb();
  return new Rgb(o.r, o.g, o.b, o.opacity);
}
function rgb$1(r, g2, b2, opacity) {
  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g2, b2, opacity == null ? 1 : opacity);
}
function Rgb(r, g2, b2, opacity) {
  this.r = +r;
  this.g = +g2;
  this.b = +b2;
  this.opacity = +opacity;
}
define(Rgb, rgb$1, extend$2(Color, {
  brighter(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Rgb(this.r * k2, this.g * k2, this.b * k2, this.opacity);
  },
  rgb() {
    return this;
  },
  clamp() {
    return new Rgb(clampi(this.r), clampi(this.g), clampi(this.b), clampa(this.opacity));
  },
  displayable() {
    return -0.5 <= this.r && this.r < 255.5 && (-0.5 <= this.g && this.g < 255.5) && (-0.5 <= this.b && this.b < 255.5) && (0 <= this.opacity && this.opacity <= 1);
  },
  hex: rgb_formatHex,
  // Deprecated! Use color.formatHex.
  formatHex: rgb_formatHex,
  formatHex8: rgb_formatHex8,
  formatRgb: rgb_formatRgb,
  toString: rgb_formatRgb
}));
function rgb_formatHex() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}`;
}
function rgb_formatHex8() {
  return `#${hex(this.r)}${hex(this.g)}${hex(this.b)}${hex((isNaN(this.opacity) ? 1 : this.opacity) * 255)}`;
}
function rgb_formatRgb() {
  const a = clampa(this.opacity);
  return `${a === 1 ? "rgb(" : "rgba("}${clampi(this.r)}, ${clampi(this.g)}, ${clampi(this.b)}${a === 1 ? ")" : `, ${a})`}`;
}
function clampa(opacity) {
  return isNaN(opacity) ? 1 : Math.max(0, Math.min(1, opacity));
}
function clampi(value) {
  return Math.max(0, Math.min(255, Math.round(value) || 0));
}
function hex(value) {
  value = clampi(value);
  return (value < 16 ? "0" : "") + value.toString(16);
}
function hsla(h2, s, l, a) {
  if (a <= 0) h2 = s = l = NaN;
  else if (l <= 0 || l >= 1) h2 = s = NaN;
  else if (s <= 0) h2 = NaN;
  return new Hsl(h2, s, l, a);
}
function hslConvert(o) {
  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
  if (!(o instanceof Color)) o = color(o);
  if (!o) return new Hsl();
  if (o instanceof Hsl) return o;
  o = o.rgb();
  var r = o.r / 255, g2 = o.g / 255, b2 = o.b / 255, min2 = Math.min(r, g2, b2), max2 = Math.max(r, g2, b2), h2 = NaN, s = max2 - min2, l = (max2 + min2) / 2;
  if (s) {
    if (r === max2) h2 = (g2 - b2) / s + (g2 < b2) * 6;
    else if (g2 === max2) h2 = (b2 - r) / s + 2;
    else h2 = (r - g2) / s + 4;
    s /= l < 0.5 ? max2 + min2 : 2 - max2 - min2;
    h2 *= 60;
  } else {
    s = l > 0 && l < 1 ? 0 : h2;
  }
  return new Hsl(h2, s, l, o.opacity);
}
function hsl(h2, s, l, opacity) {
  return arguments.length === 1 ? hslConvert(h2) : new Hsl(h2, s, l, opacity == null ? 1 : opacity);
}
function Hsl(h2, s, l, opacity) {
  this.h = +h2;
  this.s = +s;
  this.l = +l;
  this.opacity = +opacity;
}
define(Hsl, hsl, extend$2(Color, {
  brighter(k2) {
    k2 = k2 == null ? brighter : Math.pow(brighter, k2);
    return new Hsl(this.h, this.s, this.l * k2, this.opacity);
  },
  darker(k2) {
    k2 = k2 == null ? darker : Math.pow(darker, k2);
    return new Hsl(this.h, this.s, this.l * k2, this.opacity);
  },
  rgb() {
    var h2 = this.h % 360 + (this.h < 0) * 360, s = isNaN(h2) || isNaN(this.s) ? 0 : this.s, l = this.l, m2 = l + (l < 0.5 ? l : 1 - l) * s, m1 = 2 * l - m2;
    return new Rgb(
      hsl2rgb(h2 >= 240 ? h2 - 240 : h2 + 120, m1, m2),
      hsl2rgb(h2, m1, m2),
      hsl2rgb(h2 < 120 ? h2 + 240 : h2 - 120, m1, m2),
      this.opacity
    );
  },
  clamp() {
    return new Hsl(clamph(this.h), clampt(this.s), clampt(this.l), clampa(this.opacity));
  },
  displayable() {
    return (0 <= this.s && this.s <= 1 || isNaN(this.s)) && (0 <= this.l && this.l <= 1) && (0 <= this.opacity && this.opacity <= 1);
  },
  formatHsl() {
    const a = clampa(this.opacity);
    return `${a === 1 ? "hsl(" : "hsla("}${clamph(this.h)}, ${clampt(this.s) * 100}%, ${clampt(this.l) * 100}%${a === 1 ? ")" : `, ${a})`}`;
  }
}));
function clamph(value) {
  value = (value || 0) % 360;
  return value < 0 ? value + 360 : value;
}
function clampt(value) {
  return Math.max(0, Math.min(1, value || 0));
}
function hsl2rgb(h2, m1, m2) {
  return (h2 < 60 ? m1 + (m2 - m1) * h2 / 60 : h2 < 180 ? m2 : h2 < 240 ? m1 + (m2 - m1) * (240 - h2) / 60 : m1) * 255;
}
const radians = Math.PI / 180;
const degrees = 180 / Math.PI;
const K$1 = 18, Xn = 0.96422, Yn$1 = 1, Zn = 0.82521, t0 = 4 / 29, t1 = 6 / 29, t2 = 3 * t1 * t1, t3 = t1 * t1 * t1;
function labConvert(o) {
  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
  if (o instanceof Hcl) return hcl2lab(o);
  if (!(o instanceof Rgb)) o = rgbConvert(o);
  var r = rgb2lrgb(o.r), g2 = rgb2lrgb(o.g), b2 = rgb2lrgb(o.b), y2 = xyz2lab((0.2225045 * r + 0.7168786 * g2 + 0.0606169 * b2) / Yn$1), x2, z2;
  if (r === g2 && g2 === b2) x2 = z2 = y2;
  else {
    x2 = xyz2lab((0.4360747 * r + 0.3850649 * g2 + 0.1430804 * b2) / Xn);
    z2 = xyz2lab((0.0139322 * r + 0.0971045 * g2 + 0.7141733 * b2) / Zn);
  }
  return new Lab(116 * y2 - 16, 500 * (x2 - y2), 200 * (y2 - z2), o.opacity);
}
function lab(l, a, b2, opacity) {
  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b2, opacity == null ? 1 : opacity);
}
function Lab(l, a, b2, opacity) {
  this.l = +l;
  this.a = +a;
  this.b = +b2;
  this.opacity = +opacity;
}
define(Lab, lab, extend$2(Color, {
  brighter(k2) {
    return new Lab(this.l + K$1 * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
  },
  darker(k2) {
    return new Lab(this.l - K$1 * (k2 == null ? 1 : k2), this.a, this.b, this.opacity);
  },
  rgb() {
    var y2 = (this.l + 16) / 116, x2 = isNaN(this.a) ? y2 : y2 + this.a / 500, z2 = isNaN(this.b) ? y2 : y2 - this.b / 200;
    x2 = Xn * lab2xyz(x2);
    y2 = Yn$1 * lab2xyz(y2);
    z2 = Zn * lab2xyz(z2);
    return new Rgb(
      lrgb2rgb(3.1338561 * x2 - 1.6168667 * y2 - 0.4906146 * z2),
      lrgb2rgb(-0.9787684 * x2 + 1.9161415 * y2 + 0.033454 * z2),
      lrgb2rgb(0.0719453 * x2 - 0.2289914 * y2 + 1.4052427 * z2),
      this.opacity
    );
  }
}));
function xyz2lab(t) {
  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
}
function lab2xyz(t) {
  return t > t1 ? t * t * t : t2 * (t - t0);
}
function lrgb2rgb(x2) {
  return 255 * (x2 <= 31308e-7 ? 12.92 * x2 : 1.055 * Math.pow(x2, 1 / 2.4) - 0.055);
}
function rgb2lrgb(x2) {
  return (x2 /= 255) <= 0.04045 ? x2 / 12.92 : Math.pow((x2 + 0.055) / 1.055, 2.4);
}
function hclConvert(o) {
  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
  if (!(o instanceof Lab)) o = labConvert(o);
  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
  var h2 = Math.atan2(o.b, o.a) * degrees;
  return new Hcl(h2 < 0 ? h2 + 360 : h2, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
}
function hcl$1(h2, c2, l, opacity) {
  return arguments.length === 1 ? hclConvert(h2) : new Hcl(h2, c2, l, opacity == null ? 1 : opacity);
}
function Hcl(h2, c2, l, opacity) {
  this.h = +h2;
  this.c = +c2;
  this.l = +l;
  this.opacity = +opacity;
}
function hcl2lab(o) {
  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
  var h2 = o.h * radians;
  return new Lab(o.l, Math.cos(h2) * o.c, Math.sin(h2) * o.c, o.opacity);
}
define(Hcl, hcl$1, extend$2(Color, {
  brighter(k2) {
    return new Hcl(this.h, this.c, this.l + K$1 * (k2 == null ? 1 : k2), this.opacity);
  },
  darker(k2) {
    return new Hcl(this.h, this.c, this.l - K$1 * (k2 == null ? 1 : k2), this.opacity);
  },
  rgb() {
    return hcl2lab(this).rgb();
  }
}));
var constant$3 = (x2) => () => x2;
function linear$1(a, d2) {
  return function(t) {
    return a + t * d2;
  };
}
function exponential(a, b2, y2) {
  return a = Math.pow(a, y2), b2 = Math.pow(b2, y2) - a, y2 = 1 / y2, function(t) {
    return Math.pow(a + t * b2, y2);
  };
}
function hue(a, b2) {
  var d2 = b2 - a;
  return d2 ? linear$1(a, d2 > 180 || d2 < -180 ? d2 - 360 * Math.round(d2 / 360) : d2) : constant$3(isNaN(a) ? b2 : a);
}
function gamma(y2) {
  return (y2 = +y2) === 1 ? nogamma : function(a, b2) {
    return b2 - a ? exponential(a, b2, y2) : constant$3(isNaN(a) ? b2 : a);
  };
}
function nogamma(a, b2) {
  var d2 = b2 - a;
  return d2 ? linear$1(a, d2) : constant$3(isNaN(a) ? b2 : a);
}
var rgb = function rgbGamma(y2) {
  var color2 = gamma(y2);
  function rgb2(start, end) {
    var r = color2((start = rgb$1(start)).r, (end = rgb$1(end)).r), g2 = color2(start.g, end.g), b2 = color2(start.b, end.b), opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.r = r(t);
      start.g = g2(t);
      start.b = b2(t);
      start.opacity = opacity(t);
      return start + "";
    };
  }
  rgb2.gamma = rgbGamma;
  return rgb2;
}(1);
function numberArray(a, b2) {
  if (!b2) b2 = [];
  var n2 = a ? Math.min(b2.length, a.length) : 0, c2 = b2.slice(), i;
  return function(t) {
    for (i = 0; i < n2; ++i) c2[i] = a[i] * (1 - t) + b2[i] * t;
    return c2;
  };
}
function isNumberArray(x2) {
  return ArrayBuffer.isView(x2) && !(x2 instanceof DataView);
}
function genericArray(a, b2) {
  var nb = b2 ? b2.length : 0, na = a ? Math.min(nb, a.length) : 0, x2 = new Array(na), c2 = new Array(nb), i;
  for (i = 0; i < na; ++i) x2[i] = interpolate(a[i], b2[i]);
  for (; i < nb; ++i) c2[i] = b2[i];
  return function(t) {
    for (i = 0; i < na; ++i) c2[i] = x2[i](t);
    return c2;
  };
}
function date(a, b2) {
  var d2 = /* @__PURE__ */ new Date();
  return a = +a, b2 = +b2, function(t) {
    return d2.setTime(a * (1 - t) + b2 * t), d2;
  };
}
function interpolateNumber(a, b2) {
  return a = +a, b2 = +b2, function(t) {
    return a * (1 - t) + b2 * t;
  };
}
function object(a, b2) {
  var i = {}, c2 = {}, k2;
  if (a === null || typeof a !== "object") a = {};
  if (b2 === null || typeof b2 !== "object") b2 = {};
  for (k2 in b2) {
    if (k2 in a) {
      i[k2] = interpolate(a[k2], b2[k2]);
    } else {
      c2[k2] = b2[k2];
    }
  }
  return function(t) {
    for (k2 in i) c2[k2] = i[k2](t);
    return c2;
  };
}
var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g, reB = new RegExp(reA.source, "g");
function zero(b2) {
  return function() {
    return b2;
  };
}
function one(b2) {
  return function(t) {
    return b2(t) + "";
  };
}
function string(a, b2) {
  var bi = reA.lastIndex = reB.lastIndex = 0, am, bm, bs, i = -1, s = [], q2 = [];
  a = a + "", b2 = b2 + "";
  while ((am = reA.exec(a)) && (bm = reB.exec(b2))) {
    if ((bs = bm.index) > bi) {
      bs = b2.slice(bi, bs);
      if (s[i]) s[i] += bs;
      else s[++i] = bs;
    }
    if ((am = am[0]) === (bm = bm[0])) {
      if (s[i]) s[i] += bm;
      else s[++i] = bm;
    } else {
      s[++i] = null;
      q2.push({ i, x: interpolateNumber(am, bm) });
    }
    bi = reB.lastIndex;
  }
  if (bi < b2.length) {
    bs = b2.slice(bi);
    if (s[i]) s[i] += bs;
    else s[++i] = bs;
  }
  return s.length < 2 ? q2[0] ? one(q2[0].x) : zero(b2) : (b2 = q2.length, function(t) {
    for (var i2 = 0, o; i2 < b2; ++i2) s[(o = q2[i2]).i] = o.x(t);
    return s.join("");
  });
}
function interpolate(a, b2) {
  var t = typeof b2, c2;
  return b2 == null || t === "boolean" ? constant$3(b2) : (t === "number" ? interpolateNumber : t === "string" ? (c2 = color(b2)) ? (b2 = c2, rgb) : string : b2 instanceof color ? rgb : b2 instanceof Date ? date : isNumberArray(b2) ? numberArray : Array.isArray(b2) ? genericArray : typeof b2.valueOf !== "function" && typeof b2.toString !== "function" || isNaN(b2) ? object : interpolateNumber)(a, b2);
}
function interpolateRound(a, b2) {
  return a = +a, b2 = +b2, function(t) {
    return Math.round(a * (1 - t) + b2 * t);
  };
}
function hcl(hue2) {
  return function(start, end) {
    var h2 = hue2((start = hcl$1(start)).h, (end = hcl$1(end)).h), c2 = nogamma(start.c, end.c), l = nogamma(start.l, end.l), opacity = nogamma(start.opacity, end.opacity);
    return function(t) {
      start.h = h2(t);
      start.c = c2(t);
      start.l = l(t);
      start.opacity = opacity(t);
      return start + "";
    };
  };
}
var interpolateHcl = hcl(hue);
function constants(x2) {
  return function() {
    return x2;
  };
}
function number$1(x2) {
  return +x2;
}
var unit = [0, 1];
function identity$3(x2) {
  return x2;
}
function normalize$1(a, b2) {
  return (b2 -= a = +a) ? function(x2) {
    return (x2 - a) / b2;
  } : constants(isNaN(b2) ? NaN : 0.5);
}
function clamper(a, b2) {
  var t;
  if (a > b2) t = a, a = b2, b2 = t;
  return function(x2) {
    return Math.max(a, Math.min(b2, x2));
  };
}
function bimap(domain2, range2, interpolate2) {
  var d0 = domain2[0], d1 = domain2[1], r0 = range2[0], r1 = range2[1];
  if (d1 < d0) d0 = normalize$1(d1, d0), r0 = interpolate2(r1, r0);
  else d0 = normalize$1(d0, d1), r0 = interpolate2(r0, r1);
  return function(x2) {
    return r0(d0(x2));
  };
}
function polymap(domain2, range2, interpolate2) {
  var j2 = Math.min(domain2.length, range2.length) - 1, d2 = new Array(j2), r = new Array(j2), i = -1;
  if (domain2[j2] < domain2[0]) {
    domain2 = domain2.slice().reverse();
    range2 = range2.slice().reverse();
  }
  while (++i < j2) {
    d2[i] = normalize$1(domain2[i], domain2[i + 1]);
    r[i] = interpolate2(range2[i], range2[i + 1]);
  }
  return function(x2) {
    var i2 = bisectRight(domain2, x2, 1, j2) - 1;
    return r[i2](d2[i2](x2));
  };
}
function copy$1(source, target) {
  return target.domain(source.domain()).range(source.range()).interpolate(source.interpolate()).clamp(source.clamp()).unknown(source.unknown());
}
function transformer$1() {
  var domain2 = unit, range2 = unit, interpolate$1 = interpolate, transform, untransform, unknown, clamp2 = identity$3, piecewise, output, input;
  function rescale() {
    var n2 = Math.min(domain2.length, range2.length);
    if (clamp2 !== identity$3) clamp2 = clamper(domain2[0], domain2[n2 - 1]);
    piecewise = n2 > 2 ? polymap : bimap;
    output = input = null;
    return scale;
  }
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : (output || (output = piecewise(domain2.map(transform), range2, interpolate$1)))(transform(clamp2(x2)));
  }
  scale.invert = function(y2) {
    return clamp2(untransform((input || (input = piecewise(range2, domain2.map(transform), interpolateNumber)))(y2)));
  };
  scale.domain = function(_2) {
    return arguments.length ? (domain2 = Array.from(_2, number$1), rescale()) : domain2.slice();
  };
  scale.range = function(_2) {
    return arguments.length ? (range2 = Array.from(_2), rescale()) : range2.slice();
  };
  scale.rangeRound = function(_2) {
    return range2 = Array.from(_2), interpolate$1 = interpolateRound, rescale();
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = _2 ? true : identity$3, rescale()) : clamp2 !== identity$3;
  };
  scale.interpolate = function(_2) {
    return arguments.length ? (interpolate$1 = _2, rescale()) : interpolate$1;
  };
  scale.unknown = function(_2) {
    return arguments.length ? (unknown = _2, scale) : unknown;
  };
  return function(t, u) {
    transform = t, untransform = u;
    return rescale();
  };
}
function continuous() {
  return transformer$1()(identity$3, identity$3);
}
function formatDecimal(x2) {
  return Math.abs(x2 = Math.round(x2)) >= 1e21 ? x2.toLocaleString("en").replace(/,/g, "") : x2.toString(10);
}
function formatDecimalParts(x2, p) {
  if ((i = (x2 = p ? x2.toExponential(p - 1) : x2.toExponential()).indexOf("e")) < 0) return null;
  var i, coefficient = x2.slice(0, i);
  return [
    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
    +x2.slice(i + 1)
  ];
}
function exponent(x2) {
  return x2 = formatDecimalParts(Math.abs(x2)), x2 ? x2[1] : NaN;
}
function formatGroup(grouping, thousands) {
  return function(value, width) {
    var i = value.length, t = [], j2 = 0, g2 = grouping[0], length = 0;
    while (i > 0 && g2 > 0) {
      if (length + g2 + 1 > width) g2 = Math.max(1, width - length);
      t.push(value.substring(i -= g2, i + g2));
      if ((length += g2 + 1) > width) break;
      g2 = grouping[j2 = (j2 + 1) % grouping.length];
    }
    return t.reverse().join(thousands);
  };
}
function formatNumerals(numerals) {
  return function(value) {
    return value.replace(/[0-9]/g, function(i) {
      return numerals[+i];
    });
  };
}
var re$1 = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
function formatSpecifier(specifier) {
  if (!(match2 = re$1.exec(specifier))) throw new Error("invalid format: " + specifier);
  var match2;
  return new FormatSpecifier({
    fill: match2[1],
    align: match2[2],
    sign: match2[3],
    symbol: match2[4],
    zero: match2[5],
    width: match2[6],
    comma: match2[7],
    precision: match2[8] && match2[8].slice(1),
    trim: match2[9],
    type: match2[10]
  });
}
formatSpecifier.prototype = FormatSpecifier.prototype;
function FormatSpecifier(specifier) {
  this.fill = specifier.fill === void 0 ? " " : specifier.fill + "";
  this.align = specifier.align === void 0 ? ">" : specifier.align + "";
  this.sign = specifier.sign === void 0 ? "-" : specifier.sign + "";
  this.symbol = specifier.symbol === void 0 ? "" : specifier.symbol + "";
  this.zero = !!specifier.zero;
  this.width = specifier.width === void 0 ? void 0 : +specifier.width;
  this.comma = !!specifier.comma;
  this.precision = specifier.precision === void 0 ? void 0 : +specifier.precision;
  this.trim = !!specifier.trim;
  this.type = specifier.type === void 0 ? "" : specifier.type + "";
}
FormatSpecifier.prototype.toString = function() {
  return this.fill + this.align + this.sign + this.symbol + (this.zero ? "0" : "") + (this.width === void 0 ? "" : Math.max(1, this.width | 0)) + (this.comma ? "," : "") + (this.precision === void 0 ? "" : "." + Math.max(0, this.precision | 0)) + (this.trim ? "~" : "") + this.type;
};
function formatTrim(s) {
  out: for (var n2 = s.length, i = 1, i0 = -1, i1; i < n2; ++i) {
    switch (s[i]) {
      case ".":
        i0 = i1 = i;
        break;
      case "0":
        if (i0 === 0) i0 = i;
        i1 = i;
        break;
      default:
        if (!+s[i]) break out;
        if (i0 > 0) i0 = 0;
        break;
    }
  }
  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
}
var prefixExponent;
function formatPrefixAuto(x2, p) {
  var d2 = formatDecimalParts(x2, p);
  if (!d2) return x2 + "";
  var coefficient = d2[0], exponent2 = d2[1], i = exponent2 - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent2 / 3))) * 3) + 1, n2 = coefficient.length;
  return i === n2 ? coefficient : i > n2 ? coefficient + new Array(i - n2 + 1).join("0") : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i) : "0." + new Array(1 - i).join("0") + formatDecimalParts(x2, Math.max(0, p + i - 1))[0];
}
function formatRounded(x2, p) {
  var d2 = formatDecimalParts(x2, p);
  if (!d2) return x2 + "";
  var coefficient = d2[0], exponent2 = d2[1];
  return exponent2 < 0 ? "0." + new Array(-exponent2).join("0") + coefficient : coefficient.length > exponent2 + 1 ? coefficient.slice(0, exponent2 + 1) + "." + coefficient.slice(exponent2 + 1) : coefficient + new Array(exponent2 - coefficient.length + 2).join("0");
}
var formatTypes = {
  "%": (x2, p) => (x2 * 100).toFixed(p),
  "b": (x2) => Math.round(x2).toString(2),
  "c": (x2) => x2 + "",
  "d": formatDecimal,
  "e": (x2, p) => x2.toExponential(p),
  "f": (x2, p) => x2.toFixed(p),
  "g": (x2, p) => x2.toPrecision(p),
  "o": (x2) => Math.round(x2).toString(8),
  "p": (x2, p) => formatRounded(x2 * 100, p),
  "r": formatRounded,
  "s": formatPrefixAuto,
  "X": (x2) => Math.round(x2).toString(16).toUpperCase(),
  "x": (x2) => Math.round(x2).toString(16)
};
function identity$2(x2) {
  return x2;
}
var map = Array.prototype.map, prefixes = ["y", "z", "a", "f", "p", "n", "µ", "m", "", "k", "M", "G", "T", "P", "E", "Z", "Y"];
function formatLocale(locale2) {
  var group = locale2.grouping === void 0 || locale2.thousands === void 0 ? identity$2 : formatGroup(map.call(locale2.grouping, Number), locale2.thousands + ""), currencyPrefix = locale2.currency === void 0 ? "" : locale2.currency[0] + "", currencySuffix = locale2.currency === void 0 ? "" : locale2.currency[1] + "", decimal = locale2.decimal === void 0 ? "." : locale2.decimal + "", numerals = locale2.numerals === void 0 ? identity$2 : formatNumerals(map.call(locale2.numerals, String)), percent = locale2.percent === void 0 ? "%" : locale2.percent + "", minus = locale2.minus === void 0 ? "−" : locale2.minus + "", nan = locale2.nan === void 0 ? "NaN" : locale2.nan + "";
  function newFormat(specifier) {
    specifier = formatSpecifier(specifier);
    var fill = specifier.fill, align = specifier.align, sign2 = specifier.sign, symbol = specifier.symbol, zero2 = specifier.zero, width = specifier.width, comma = specifier.comma, precision = specifier.precision, trim2 = specifier.trim, type3 = specifier.type;
    if (type3 === "n") comma = true, type3 = "g";
    else if (!formatTypes[type3]) precision === void 0 && (precision = 12), trim2 = true, type3 = "g";
    if (zero2 || fill === "0" && align === "=") zero2 = true, fill = "0", align = "=";
    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type3) ? "0" + type3.toLowerCase() : "", suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type3) ? percent : "";
    var formatType = formatTypes[type3], maybeSuffix = /[defgprs%]/.test(type3);
    precision = precision === void 0 ? 6 : /[gprs]/.test(type3) ? Math.max(1, Math.min(21, precision)) : Math.max(0, Math.min(20, precision));
    function format2(value) {
      var valuePrefix = prefix, valueSuffix = suffix, i, n2, c2;
      if (type3 === "c") {
        valueSuffix = formatType(value) + valueSuffix;
        value = "";
      } else {
        value = +value;
        var valueNegative = value < 0 || 1 / value < 0;
        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
        if (trim2) value = formatTrim(value);
        if (valueNegative && +value === 0 && sign2 !== "+") valueNegative = false;
        valuePrefix = (valueNegative ? sign2 === "(" ? sign2 : minus : sign2 === "-" || sign2 === "(" ? "" : sign2) + valuePrefix;
        valueSuffix = (type3 === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign2 === "(" ? ")" : "");
        if (maybeSuffix) {
          i = -1, n2 = value.length;
          while (++i < n2) {
            if (c2 = value.charCodeAt(i), 48 > c2 || c2 > 57) {
              valueSuffix = (c2 === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
              value = value.slice(0, i);
              break;
            }
          }
        }
      }
      if (comma && !zero2) value = group(value, Infinity);
      var length = valuePrefix.length + value.length + valueSuffix.length, padding = length < width ? new Array(width - length + 1).join(fill) : "";
      if (comma && zero2) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
      switch (align) {
        case "<":
          value = valuePrefix + value + valueSuffix + padding;
          break;
        case "=":
          value = valuePrefix + padding + value + valueSuffix;
          break;
        case "^":
          value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
          break;
        default:
          value = padding + valuePrefix + value + valueSuffix;
          break;
      }
      return numerals(value);
    }
    format2.toString = function() {
      return specifier + "";
    };
    return format2;
  }
  function formatPrefix2(specifier, value) {
    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)), e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3, k2 = Math.pow(10, -e), prefix = prefixes[8 + e / 3];
    return function(value2) {
      return f(k2 * value2) + prefix;
    };
  }
  return {
    format: newFormat,
    formatPrefix: formatPrefix2
  };
}
var locale;
var format$1;
var formatPrefix;
defaultLocale({
  thousands: ",",
  grouping: [3],
  currency: ["$", ""]
});
function defaultLocale(definition) {
  locale = formatLocale(definition);
  format$1 = locale.format;
  formatPrefix = locale.formatPrefix;
  return locale;
}
function precisionFixed(step) {
  return Math.max(0, -exponent(Math.abs(step)));
}
function precisionPrefix(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}
function precisionRound(step, max2) {
  step = Math.abs(step), max2 = Math.abs(max2) - step;
  return Math.max(0, exponent(max2) - exponent(step)) + 1;
}
function tickFormat(start, stop, count2, specifier) {
  var step = tickStep(start, stop, count2), precision;
  specifier = formatSpecifier(specifier == null ? ",f" : specifier);
  switch (specifier.type) {
    case "s": {
      var value = Math.max(Math.abs(start), Math.abs(stop));
      if (specifier.precision == null && !isNaN(precision = precisionPrefix(step, value))) specifier.precision = precision;
      return formatPrefix(specifier, value);
    }
    case "":
    case "e":
    case "g":
    case "p":
    case "r": {
      if (specifier.precision == null && !isNaN(precision = precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
      break;
    }
    case "f":
    case "%": {
      if (specifier.precision == null && !isNaN(precision = precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
      break;
    }
  }
  return format$1(specifier);
}
function linearish(scale) {
  var domain2 = scale.domain;
  scale.ticks = function(count2) {
    var d2 = domain2();
    return ticks(d2[0], d2[d2.length - 1], count2 == null ? 10 : count2);
  };
  scale.tickFormat = function(count2, specifier) {
    var d2 = domain2();
    return tickFormat(d2[0], d2[d2.length - 1], count2 == null ? 10 : count2, specifier);
  };
  scale.nice = function(count2) {
    if (count2 == null) count2 = 10;
    var d2 = domain2();
    var i0 = 0;
    var i1 = d2.length - 1;
    var start = d2[i0];
    var stop = d2[i1];
    var prestep;
    var step;
    var maxIter = 10;
    if (stop < start) {
      step = start, start = stop, stop = step;
      step = i0, i0 = i1, i1 = step;
    }
    while (maxIter-- > 0) {
      step = tickIncrement(start, stop, count2);
      if (step === prestep) {
        d2[i0] = start;
        d2[i1] = stop;
        return domain2(d2);
      } else if (step > 0) {
        start = Math.floor(start / step) * step;
        stop = Math.ceil(stop / step) * step;
      } else if (step < 0) {
        start = Math.ceil(start * step) / step;
        stop = Math.floor(stop * step) / step;
      } else {
        break;
      }
      prestep = step;
    }
    return scale;
  };
  return scale;
}
function linear() {
  var scale = continuous();
  scale.copy = function() {
    return copy$1(scale, linear());
  };
  initRange.apply(scale, arguments);
  return linearish(scale);
}
function transformer() {
  var x0 = 0, x1 = 1, t02, t12, k10, transform, interpolator = identity$3, clamp2 = false, unknown;
  function scale(x2) {
    return x2 == null || isNaN(x2 = +x2) ? unknown : interpolator(k10 === 0 ? 0.5 : (x2 = (transform(x2) - t02) * k10, clamp2 ? Math.max(0, Math.min(1, x2)) : x2));
  }
  scale.domain = function(_2) {
    return arguments.length ? ([x0, x1] = _2, t02 = transform(x0 = +x0), t12 = transform(x1 = +x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02), scale) : [x0, x1];
  };
  scale.clamp = function(_2) {
    return arguments.length ? (clamp2 = !!_2, scale) : clamp2;
  };
  scale.interpolator = function(_2) {
    return arguments.length ? (interpolator = _2, scale) : interpolator;
  };
  function range2(interpolate2) {
    return function(_2) {
      var r0, r1;
      return arguments.length ? ([r0, r1] = _2, interpolator = interpolate2(r0, r1), scale) : [interpolator(0), interpolator(1)];
    };
  }
  scale.range = range2(interpolate);
  scale.rangeRound = range2(interpolateRound);
  scale.unknown = function(_2) {
    return arguments.length ? (unknown = _2, scale) : unknown;
  };
  return function(t) {
    transform = t, t02 = t(x0), t12 = t(x1), k10 = t02 === t12 ? 0 : 1 / (t12 - t02);
    return scale;
  };
}
function copy(source, target) {
  return target.domain(source.domain()).interpolator(source.interpolator()).clamp(source.clamp()).unknown(source.unknown());
}
function sequential() {
  var scale = linearish(transformer()(identity$3));
  scale.copy = function() {
    return copy(scale, sequential());
  };
  return initInterpolator.apply(scale, arguments);
}
class Scale {
  constructor(config) {
    this.config = config;
    this.createScale(config.type);
  }
  createScale(type3) {
    switch (type3) {
      case "band":
        this.scale = band();
        break;
      case "linear":
        this.scale = linear();
        break;
    }
  }
  changeConfig(config) {
    this.createScale(config.type);
    this.config = config;
  }
  get type() {
    return this.config.type;
  }
  bandwidth() {
    if (this.type === "band") {
      return this.scale.bandwidth();
    }
    return 0;
  }
  updateRange(range2) {
    this.scale = this.scale.copy().range(range2);
  }
  updateDomain(data2, stackedData2, keys4) {
    const domain2 = this.config.type === "band" ? this.categoryDomain(data2, keys4) : this.numericDomain(data2, stackedData2, keys4);
    this.scale = this.scale.copy().domain(domain2);
  }
  map(values3) {
    return values3.map((v) => this.mapOne(v));
  }
  mapOne(val) {
    const { type: type3 } = this.config;
    if (type3 === "band") {
      return this.scale(val) + this.scale.bandwidth() / 2;
    }
    return this.scale(val);
  }
  ticks() {
    const { type: type3 } = this.config;
    if (this.config.tickValues !== void 0) {
      return this.config.tickValues;
    }
    if (type3 === "band") {
      return this.scale.domain();
    }
    return this.scale.ticks(this.config.ticks || 5);
  }
  categoryDomain(data2, keys4) {
    const values3 = keys4.reduce((arr, key) => arr.concat(getCol(key, data2)), []);
    return Array.from(new Set(values3));
  }
  numericDomain(data, stackedData, keys) {
    const { domain } = this.config;
    const values = keys.reduce((arr, key) => arr.concat(getCol(key, data)), []);
    const valueMax = max$1$1(stackedData, (arr) => max$1$1(arr, (x2) => max$1$1(x2))) || 0;
    const valueMin = min$1$1(stackedData, (arr) => min$1$1(arr, (x2) => min$1$1(x2))) || 0;
    const [dataMin, dataMax] = extent(Array.from(new Set(values.concat([valueMin, valueMax]))));
    const yMin = eval(`
      let dataMin = ${dataMin || 0}
      ${domain[0]}
    `);
    const yMax = eval(`
      let dataMax = ${dataMax || 0}
      ${domain[1]}
    `);
    return [yMin, yMax];
  }
}
class Scales {
  constructor(config) {
    this.config = config;
    this.primary = new Scale(config.primary);
    this.secondary = new Scale(config.secondary);
  }
  changeConfig(config) {
    this.config = config;
    this.primary.changeConfig(config.primary);
    this.secondary.changeConfig(config.secondary);
  }
  updateRange(canvas, direction) {
    if (direction === "horizontal") {
      this.primary.updateRange([canvas.x, canvas.width]);
      this.secondary.updateRange([canvas.height, canvas.y]);
    } else if (direction === "vertical") {
      this.primary.updateRange([canvas.y, canvas.height]);
      this.secondary.updateRange([canvas.x, canvas.width]);
    }
  }
  updateDomain(data2, stackedData2, keys4) {
    this.primary.updateDomain(data2, stackedData2, getCol(0, keys4));
    this.secondary.updateDomain(data2, stackedData2, getCol(1, keys4));
  }
}
function constant$2(x2) {
  return function constant2() {
    return x2;
  };
}
const abs = Math.abs;
const atan2 = Math.atan2;
const cos = Math.cos;
const max$2 = Math.max;
const min$2 = Math.min;
const sin = Math.sin;
const sqrt = Math.sqrt;
const epsilon$2 = 1e-12;
const pi$1 = Math.PI;
const halfPi = pi$1 / 2;
const tau$1 = 2 * pi$1;
function acos(x2) {
  return x2 > 1 ? 0 : x2 < -1 ? pi$1 : Math.acos(x2);
}
function asin(x2) {
  return x2 >= 1 ? halfPi : x2 <= -1 ? -halfPi : Math.asin(x2);
}
const pi = Math.PI, tau = 2 * pi, epsilon$1 = 1e-6, tauEpsilon = tau - epsilon$1;
function append(strings) {
  this._ += strings[0];
  for (let i = 1, n2 = strings.length; i < n2; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  let d2 = Math.floor(digits);
  if (!(d2 >= 0)) throw new Error(`invalid digits: ${digits}`);
  if (d2 > 15) return append;
  const k2 = 10 ** d2;
  return function(strings) {
    this._ += strings[0];
    for (let i = 1, n2 = strings.length; i < n2; ++i) {
      this._ += Math.round(arguments[i] * k2) / k2 + strings[i];
    }
  };
}
class Path {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append : appendRound(digits);
  }
  moveTo(x2, y2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x2, y2) {
    this._append`L${this._x1 = +x2},${this._y1 = +y2}`;
  }
  quadraticCurveTo(x1, y1, x2, y2) {
    this._append`Q${+x1},${+y1},${this._x1 = +x2},${this._y1 = +y2}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x3},${this._y1 = +y3}`;
  }
  arcTo(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    if (r < 0) throw new Error(`negative radius: ${r}`);
    let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon$1)) ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon$1) || !r) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
      if (Math.abs(t01 - 1) > epsilon$1) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x2, y2, r, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r = +r, ccw = !!ccw;
    if (r < 0) throw new Error(`negative radius: ${r}`);
    let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x2 + dx, y0 = y2 + dy, cw = 1 ^ ccw, da2 = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon$1 || Math.abs(this._y1 - y0) > epsilon$1) {
      this._append`L${x0},${y0}`;
    }
    if (!r) return;
    if (da2 < 0) da2 = da2 % tau + tau;
    if (da2 > tauEpsilon) {
      this._append`A${r},${r},0,1,${cw},${x2 - dx},${y2 - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da2 > epsilon$1) {
      this._append`A${r},${r},0,${+(da2 >= pi)},${cw},${this._x1 = x2 + r * Math.cos(a1)},${this._y1 = y2 + r * Math.sin(a1)}`;
    }
  }
  rect(x2, y2, w, h2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}h${w = +w}v${+h2}h${-w}Z`;
  }
  toString() {
    return this._;
  }
}
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_2) {
    if (!arguments.length) return digits;
    if (_2 == null) {
      digits = null;
    } else {
      const d2 = Math.floor(_2);
      if (!(d2 >= 0)) throw new RangeError(`invalid digits: ${_2}`);
      digits = d2;
    }
    return shape;
  };
  return () => new Path(digits);
}
function arcInnerRadius(d2) {
  return d2.innerRadius;
}
function arcOuterRadius(d2) {
  return d2.outerRadius;
}
function arcStartAngle(d2) {
  return d2.startAngle;
}
function arcEndAngle(d2) {
  return d2.endAngle;
}
function arcPadAngle(d2) {
  return d2 && d2.padAngle;
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
  if (t * t < epsilon$2) return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1, y01 = y0 - y1, lo2 = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo2 * y01, oy = -lo2 * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d3 = (dy < 0 ? -1 : 1) * sqrt(max$2(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d3) / d2, cy0 = (-D * dx - dy * d3) / d2, cx1 = (D * dy + dx * d3) / d2, cy1 = (-D * dx + dy * d3) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1) cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}
function arc() {
  var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant$2(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path = withPath(arc2);
  function arc2() {
    var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da2 = abs(a1 - a0), cw = a1 > a0;
    if (!context) context = buffer = path();
    if (r1 < r0) r = r1, r1 = r0, r0 = r;
    if (!(r1 > epsilon$2)) context.moveTo(0, 0);
    else if (da2 > tau$1 - epsilon$2) {
      context.moveTo(r1 * cos(a0), r1 * sin(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon$2) {
        context.moveTo(r0 * cos(a1), r0 * sin(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } else {
      var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da2, da1 = da2, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon$2 && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min$2(abs(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t02, t12;
      if (rp > epsilon$2) {
        var p0 = asin(rp / r0 * sin(ap)), p1 = asin(rp / r1 * sin(ap));
        if ((da0 -= p0 * 2) > epsilon$2) p0 *= cw ? 1 : -1, a00 += p0, a10 -= p0;
        else da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon$2) p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
        else da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos(a01), y01 = r1 * sin(a01), x10 = r0 * cos(a10), y10 = r0 * sin(a10);
      if (rc > epsilon$2) {
        var x11 = r1 * cos(a11), y11 = r1 * sin(a11), x00 = r0 * cos(a00), y00 = r0 * sin(a00), oc;
        if (da2 < pi$1) {
          if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min$2(rc, (r0 - lc) / (kc - 1));
            rc1 = min$2(rc, (r1 - lc) / (kc + 1));
          } else {
            rc0 = rc1 = 0;
          }
        }
      }
      if (!(da1 > epsilon$2)) context.moveTo(x01, y01);
      else if (rc1 > epsilon$2) {
        t02 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t12 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc1 < rc) context.arc(t02.cx, t02.cy, rc1, atan2(t02.y01, t02.x01), atan2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc1, atan2(t02.y01, t02.x01), atan2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r1, atan2(t02.cy + t02.y11, t02.cx + t02.x11), atan2(t12.cy + t12.y11, t12.cx + t12.x11), !cw);
          context.arc(t12.cx, t12.cy, rc1, atan2(t12.y11, t12.x11), atan2(t12.y01, t12.x01), !cw);
        }
      } else context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon$2) || !(da0 > epsilon$2)) context.lineTo(x10, y10);
      else if (rc0 > epsilon$2) {
        t02 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t12 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t02.cx + t02.x01, t02.cy + t02.y01);
        if (rc0 < rc) context.arc(t02.cx, t02.cy, rc0, atan2(t02.y01, t02.x01), atan2(t12.y01, t12.x01), !cw);
        else {
          context.arc(t02.cx, t02.cy, rc0, atan2(t02.y01, t02.x01), atan2(t02.y11, t02.x11), !cw);
          context.arc(0, 0, r0, atan2(t02.cy + t02.y11, t02.cx + t02.x11), atan2(t12.cy + t12.y11, t12.cx + t12.x11), cw);
          context.arc(t12.cx, t12.cy, rc0, atan2(t12.y11, t12.x11), atan2(t12.y01, t12.x01), !cw);
        }
      } else context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer) return context = null, buffer + "" || null;
  }
  arc2.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi$1 / 2;
    return [cos(a) * r, sin(a) * r];
  };
  arc2.innerRadius = function(_2) {
    return arguments.length ? (innerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : innerRadius;
  };
  arc2.outerRadius = function(_2) {
    return arguments.length ? (outerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : outerRadius;
  };
  arc2.cornerRadius = function(_2) {
    return arguments.length ? (cornerRadius = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : cornerRadius;
  };
  arc2.padRadius = function(_2) {
    return arguments.length ? (padRadius = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : padRadius;
  };
  arc2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : startAngle;
  };
  arc2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : endAngle;
  };
  arc2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$2(+_2), arc2) : padAngle;
  };
  arc2.context = function(_2) {
    return arguments.length ? (context = _2 == null ? null : _2, arc2) : context;
  };
  return arc2;
}
function array$1(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      // falls through
      default:
        this._context.lineTo(x2, y2);
        break;
    }
  }
};
function curveLinear(context) {
  return new Linear(context);
}
function x$1(p) {
  return p[0];
}
function y$1(p) {
  return p[1];
}
function line(x$1$1, y$1$1) {
  var defined = constant$2(true), context = null, curve = curveLinear, output = null, path = withPath(line2);
  x$1$1 = typeof x$1$1 === "function" ? x$1$1 : x$1$1 === void 0 ? x$1 : constant$2(x$1$1);
  y$1$1 = typeof y$1$1 === "function" ? y$1$1 : y$1$1 === void 0 ? y$1 : constant$2(y$1$1);
  function line2(data2) {
    var i, n2 = (data2 = array$1(data2)).length, d2, defined0 = false, buffer;
    if (context == null) output = curve(buffer = path());
    for (i = 0; i <= n2; ++i) {
      if (!(i < n2 && defined(d2 = data2[i], i, data2)) === defined0) {
        if (defined0 = !defined0) output.lineStart();
        else output.lineEnd();
      }
      if (defined0) output.point(+x$1$1(d2, i, data2), +y$1$1(d2, i, data2));
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  line2.x = function(_2) {
    return arguments.length ? (x$1$1 = typeof _2 === "function" ? _2 : constant$2(+_2), line2) : x$1$1;
  };
  line2.y = function(_2) {
    return arguments.length ? (y$1$1 = typeof _2 === "function" ? _2 : constant$2(+_2), line2) : y$1$1;
  };
  line2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$2(!!_2), line2) : defined;
  };
  line2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), line2) : curve;
  };
  line2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), line2) : context;
  };
  return line2;
}
function area(x0, y0, y1) {
  var x1 = null, defined = constant$2(true), context = null, curve = curveLinear, output = null, path = withPath(area2);
  x0 = typeof x0 === "function" ? x0 : x0 === void 0 ? x$1 : constant$2(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === void 0 ? constant$2(0) : constant$2(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === void 0 ? y$1 : constant$2(+y1);
  function area2(data2) {
    var i, j2, k2, n2 = (data2 = array$1(data2)).length, d2, defined0 = false, buffer, x0z = new Array(n2), y0z = new Array(n2);
    if (context == null) output = curve(buffer = path());
    for (i = 0; i <= n2; ++i) {
      if (!(i < n2 && defined(d2 = data2[i], i, data2)) === defined0) {
        if (defined0 = !defined0) {
          j2 = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k2 = i - 1; k2 >= j2; --k2) {
            output.point(x0z[k2], y0z[k2]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d2, i, data2), y0z[i] = +y0(d2, i, data2);
        output.point(x1 ? +x1(d2, i, data2) : x0z[i], y1 ? +y1(d2, i, data2) : y0z[i]);
      }
    }
    if (buffer) return output = null, buffer + "" || null;
  }
  function arealine() {
    return line().defined(defined).curve(curve).context(context);
  }
  area2.x = function(_2) {
    return arguments.length ? (x0 = typeof _2 === "function" ? _2 : constant$2(+_2), x1 = null, area2) : x0;
  };
  area2.x0 = function(_2) {
    return arguments.length ? (x0 = typeof _2 === "function" ? _2 : constant$2(+_2), area2) : x0;
  };
  area2.x1 = function(_2) {
    return arguments.length ? (x1 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), area2) : x1;
  };
  area2.y = function(_2) {
    return arguments.length ? (y0 = typeof _2 === "function" ? _2 : constant$2(+_2), y1 = null, area2) : y0;
  };
  area2.y0 = function(_2) {
    return arguments.length ? (y0 = typeof _2 === "function" ? _2 : constant$2(+_2), area2) : y0;
  };
  area2.y1 = function(_2) {
    return arguments.length ? (y1 = _2 == null ? null : typeof _2 === "function" ? _2 : constant$2(+_2), area2) : y1;
  };
  area2.lineX0 = area2.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };
  area2.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };
  area2.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };
  area2.defined = function(_2) {
    return arguments.length ? (defined = typeof _2 === "function" ? _2 : constant$2(!!_2), area2) : defined;
  };
  area2.curve = function(_2) {
    return arguments.length ? (curve = _2, context != null && (output = curve(context)), area2) : curve;
  };
  area2.context = function(_2) {
    return arguments.length ? (_2 == null ? context = output = null : output = curve(context = _2), area2) : context;
  };
  return area2;
}
function descending(a, b2) {
  return b2 < a ? -1 : b2 > a ? 1 : b2 >= a ? 0 : NaN;
}
function identity$1(d2) {
  return d2;
}
function pie() {
  var value = identity$1, sortValues = descending, sort2 = null, startAngle = constant$2(0), endAngle = constant$2(tau$1), padAngle = constant$2(0);
  function pie2(data2) {
    var i, n2 = (data2 = array$1(data2)).length, j2, k2, sum = 0, index2 = new Array(n2), arcs = new Array(n2), a0 = +startAngle.apply(this, arguments), da2 = Math.min(tau$1, Math.max(-tau$1, endAngle.apply(this, arguments) - a0)), a1, p = Math.min(Math.abs(da2) / n2, padAngle.apply(this, arguments)), pa = p * (da2 < 0 ? -1 : 1), v;
    for (i = 0; i < n2; ++i) {
      if ((v = arcs[index2[i] = i] = +value(data2[i], i, data2)) > 0) {
        sum += v;
      }
    }
    if (sortValues != null) index2.sort(function(i2, j3) {
      return sortValues(arcs[i2], arcs[j3]);
    });
    else if (sort2 != null) index2.sort(function(i2, j3) {
      return sort2(data2[i2], data2[j3]);
    });
    for (i = 0, k2 = sum ? (da2 - n2 * pa) / sum : 0; i < n2; ++i, a0 = a1) {
      j2 = index2[i], v = arcs[j2], a1 = a0 + (v > 0 ? v * k2 : 0) + pa, arcs[j2] = {
        data: data2[j2],
        index: i,
        value: v,
        startAngle: a0,
        endAngle: a1,
        padAngle: p
      };
    }
    return arcs;
  }
  pie2.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$2(+_2), pie2) : value;
  };
  pie2.sortValues = function(_2) {
    return arguments.length ? (sortValues = _2, sort2 = null, pie2) : sortValues;
  };
  pie2.sort = function(_2) {
    return arguments.length ? (sort2 = _2, sortValues = null, pie2) : sort2;
  };
  pie2.startAngle = function(_2) {
    return arguments.length ? (startAngle = typeof _2 === "function" ? _2 : constant$2(+_2), pie2) : startAngle;
  };
  pie2.endAngle = function(_2) {
    return arguments.length ? (endAngle = typeof _2 === "function" ? _2 : constant$2(+_2), pie2) : endAngle;
  };
  pie2.padAngle = function(_2) {
    return arguments.length ? (padAngle = typeof _2 === "function" ? _2 : constant$2(+_2), pie2) : padAngle;
  };
  return pie2;
}
function sign(x2) {
  return x2 < 0 ? -1 : 1;
}
function slope3(that, x2, y2) {
  var h0 = that._x1 - that._x0, h1 = x2 - that._x1, s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0), s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0), p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
function slope2(that, t) {
  var h2 = that._x1 - that._x0;
  return h2 ? (3 * (that._y1 - that._y0) / h2 - t) / 2 : t;
}
function point(that, t02, t12) {
  var x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 3;
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t02, x1 - dx, y1 - dx * t12, x1, y1);
}
function MonotoneX(context) {
  this._context = context;
}
MonotoneX.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    var t12 = NaN;
    x2 = +x2, y2 = +y2;
    if (x2 === this._x1 && y2 === this._y1) return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point(this, slope2(this, t12 = slope3(this, x2, y2)), t12);
        break;
      default:
        point(this, this._t0, t12 = slope3(this, x2, y2));
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
    this._t0 = t12;
  }
};
function MonotoneY(context) {
  this._context = new ReflectContext(context);
}
(MonotoneY.prototype = Object.create(MonotoneX.prototype)).point = function(x2, y2) {
  MonotoneX.prototype.point.call(this, y2, x2);
};
function ReflectContext(context) {
  this._context = context;
}
ReflectContext.prototype = {
  moveTo: function(x2, y2) {
    this._context.moveTo(y2, x2);
  },
  closePath: function() {
    this._context.closePath();
  },
  lineTo: function(x2, y2) {
    this._context.lineTo(y2, x2);
  },
  bezierCurveTo: function(x1, y1, x2, y2, x3, y3) {
    this._context.bezierCurveTo(y1, x1, y2, x2, y3, x3);
  }
};
function monotoneX(context) {
  return new MonotoneX(context);
}
function monotoneY(context) {
  return new MonotoneY(context);
}
function Natural(context) {
  this._context = context;
}
Natural.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = [];
    this._y = [];
  },
  lineEnd: function() {
    var x2 = this._x, y2 = this._y, n2 = x2.length;
    if (n2) {
      this._line ? this._context.lineTo(x2[0], y2[0]) : this._context.moveTo(x2[0], y2[0]);
      if (n2 === 2) {
        this._context.lineTo(x2[1], y2[1]);
      } else {
        var px = controlPoints(x2), py = controlPoints(y2);
        for (var i0 = 0, i1 = 1; i1 < n2; ++i0, ++i1) {
          this._context.bezierCurveTo(px[0][i0], py[0][i0], px[1][i0], py[1][i0], x2[i1], y2[i1]);
        }
      }
    }
    if (this._line || this._line !== 0 && n2 === 1) this._context.closePath();
    this._line = 1 - this._line;
    this._x = this._y = null;
  },
  point: function(x2, y2) {
    this._x.push(+x2);
    this._y.push(+y2);
  }
};
function controlPoints(x2) {
  var i, n2 = x2.length - 1, m2, a = new Array(n2), b2 = new Array(n2), r = new Array(n2);
  a[0] = 0, b2[0] = 2, r[0] = x2[0] + 2 * x2[1];
  for (i = 1; i < n2 - 1; ++i) a[i] = 1, b2[i] = 4, r[i] = 4 * x2[i] + 2 * x2[i + 1];
  a[n2 - 1] = 2, b2[n2 - 1] = 7, r[n2 - 1] = 8 * x2[n2 - 1] + x2[n2];
  for (i = 1; i < n2; ++i) m2 = a[i] / b2[i - 1], b2[i] -= m2, r[i] -= m2 * r[i - 1];
  a[n2 - 1] = r[n2 - 1] / b2[n2 - 1];
  for (i = n2 - 2; i >= 0; --i) a[i] = (r[i] - a[i + 1]) / b2[i];
  b2[n2 - 1] = (x2[n2] + a[n2 - 1]) / 2;
  for (i = 0; i < n2 - 1; ++i) b2[i] = 2 * x2[i + 1] - a[i + 1];
  return [a, b2];
}
function curveNatural(context) {
  return new Natural(context);
}
function Step(context, t) {
  this._context = context;
  this._t = t;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2) this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1) this._context.closePath();
    if (this._line >= 0) this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      // falls through
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y2);
          this._context.lineTo(x2, y2);
        } else {
          var x1 = this._x * (1 - this._t) + x2 * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y2);
        }
        break;
      }
    }
    this._x = x2, this._y = y2;
  }
};
function curveStep(context) {
  return new Step(context, 0.5);
}
function stepAfter(context) {
  return new Step(context, 1);
}
function none$1(series, order) {
  if (!((n2 = series.length) > 1)) return;
  for (var i = 1, j2, s0, s1 = series[order[0]], n2, m2 = s1.length; i < n2; ++i) {
    s0 = s1, s1 = series[order[i]];
    for (j2 = 0; j2 < m2; ++j2) {
      s1[j2][1] += s1[j2][0] = isNaN(s0[j2][1]) ? s0[j2][0] : s0[j2][1];
    }
  }
}
function stackOrderNone(series) {
  var n2 = series.length, o = new Array(n2);
  while (--n2 >= 0) o[n2] = n2;
  return o;
}
function stackValue(d2, key) {
  return d2[key];
}
function stackSeries(key) {
  const series = [];
  series.key = key;
  return series;
}
function stack() {
  var keys4 = constant$2([]), order = stackOrderNone, offset2 = none$1, value = stackValue;
  function stack2(data2) {
    var sz = Array.from(keys4.apply(this, arguments), stackSeries), i, n2 = sz.length, j2 = -1, oz;
    for (const d2 of data2) {
      for (i = 0, ++j2; i < n2; ++i) {
        (sz[i][j2] = [0, +value(d2, sz[i].key, j2, data2)]).data = d2;
      }
    }
    for (i = 0, oz = array$1(order(sz)); i < n2; ++i) {
      sz[oz[i]].index = i;
    }
    offset2(sz, oz);
    return sz;
  }
  stack2.keys = function(_2) {
    return arguments.length ? (keys4 = typeof _2 === "function" ? _2 : constant$2(Array.from(_2)), stack2) : keys4;
  };
  stack2.value = function(_2) {
    return arguments.length ? (value = typeof _2 === "function" ? _2 : constant$2(+_2), stack2) : value;
  };
  stack2.order = function(_2) {
    return arguments.length ? (order = _2 == null ? stackOrderNone : typeof _2 === "function" ? _2 : constant$2(Array.from(_2)), stack2) : order;
  };
  stack2.offset = function(_2) {
    return arguments.length ? (offset2 = _2 == null ? none$1 : _2, stack2) : offset2;
  };
  return stack2;
}
const defaultConfig = {
  size: { width: 500, height: 400 },
  margin: {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  },
  direction: "horizontal",
  axis: {
    primary: {
      domain: ["dataMin", "dataMax"],
      type: "band"
    },
    secondary: {
      domain: ["dataMin", "dataMax"],
      type: "linear"
    }
  },
  axisSpace: {
    x: 40,
    y: 20
  }
};
class Chart {
  constructor(data2, config) {
    this.data = data2;
    this.layers = [];
    this.config = mergeDeepLeft$1(pickBy$1((p) => p !== void 0, config), defaultConfig);
    this.scales = new Scales(this.config.axis);
    this.updates = ref(0);
  }
  get bandScale() {
    if (this.scales.primary.type === "band")
      return this.scales.primary;
    if (this.scales.secondary.type === "band")
      return this.scales.secondary;
    return null;
  }
  get canvas() {
    const { margin, size: size2 } = this.config;
    const axisSpace = this.config.axisSpace;
    if (this.config.axis.primary.hide) {
      axisSpace.y = 0;
    }
    if (this.config.axis.secondary.hide) {
      axisSpace.x = 0;
    }
    return {
      x: margin.left + axisSpace.x,
      y: margin.top,
      width: size2.width - margin.right,
      height: size2.height - margin.bottom - axisSpace.y
    };
  }
  getStackedData(keys4) {
    return stack().keys(keys4).order(stackOrderNone)(this.data);
  }
  changeData(data2) {
    this.data = data2;
    this.update("data");
  }
  changeConfig(config) {
    this.config = mergeDeepLeft$1(pickBy$1((p) => p !== void 0, config), this.config);
    this.scales.changeConfig(this.config.axis);
    this.update("config");
  }
  addLayer(layer) {
    this.layers.push(layer);
    this.update("layers");
  }
  removeLayer(id) {
    this.layers = this.layers.filter((l) => l.id !== id);
    this.update("layers");
  }
  getLayers(type3) {
    if (type3) {
      return this.layers.filter((l) => l.type === type3);
    }
    return this.layers;
  }
  getData(keys4) {
    return keys4.reduce((arr, key) => arr.concat(getCol(key, this.data)), []);
  }
  getKeys(idx = -1, type3 = null) {
    const keys4 = this.layers.filter((l) => {
      if (type3)
        return l.type === type3;
      return true;
    }).map((l) => l.dataKeys);
    if (idx === -1) {
      return keys4;
    }
    return getCol(idx, keys4);
  }
  getStackedKeys(idx = -1, type3 = null) {
    const keys4 = this.layers.filter((l) => {
      if (type3)
        return l.type === type3 && l.props.stacked;
      return l.props.stacked;
    }).map((l) => l.dataKeys);
    if (idx === -1) {
      return keys4;
    }
    return getCol(idx, keys4);
  }
  update(_2) {
    const stackedData2 = this.getStackedData(this.getStackedKeys(1));
    this.scales.updateRange(this.canvas, this.config.direction);
    this.scales.updateDomain(this.data, stackedData2, this.getKeys());
    this.updates.value += 1;
  }
}
var xhtml = "http://www.w3.org/1999/xhtml";
var namespaces = {
  svg: "http://www.w3.org/2000/svg",
  xhtml,
  xlink: "http://www.w3.org/1999/xlink",
  xml: "http://www.w3.org/XML/1998/namespace",
  xmlns: "http://www.w3.org/2000/xmlns/"
};
function namespace(name) {
  var prefix = name += "", i = prefix.indexOf(":");
  if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
  return namespaces.hasOwnProperty(prefix) ? { space: namespaces[prefix], local: name } : name;
}
function creatorInherit(name) {
  return function() {
    var document2 = this.ownerDocument, uri = this.namespaceURI;
    return uri === xhtml && document2.documentElement.namespaceURI === xhtml ? document2.createElement(name) : document2.createElementNS(uri, name);
  };
}
function creatorFixed(fullname) {
  return function() {
    return this.ownerDocument.createElementNS(fullname.space, fullname.local);
  };
}
function creator(name) {
  var fullname = namespace(name);
  return (fullname.local ? creatorFixed : creatorInherit)(fullname);
}
function none() {
}
function selector(selector2) {
  return selector2 == null ? none : function() {
    return this.querySelector(selector2);
  };
}
function selection_select(select2) {
  if (typeof select2 !== "function") select2 = selector(select2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = new Array(m2), j2 = 0; j2 < m2; ++j2) {
    for (var group = groups2[j2], n2 = group.length, subgroup = subgroups[j2] = new Array(n2), node, subnode, i = 0; i < n2; ++i) {
      if ((node = group[i]) && (subnode = select2.call(node, node.__data__, i, group))) {
        if ("__data__" in node) subnode.__data__ = node.__data__;
        subgroup[i] = subnode;
      }
    }
  }
  return new Selection(subgroups, this._parents);
}
function array(x2) {
  return x2 == null ? [] : Array.isArray(x2) ? x2 : Array.from(x2);
}
function empty() {
  return [];
}
function selectorAll(selector2) {
  return selector2 == null ? empty : function() {
    return this.querySelectorAll(selector2);
  };
}
function arrayAll(select2) {
  return function() {
    return array(select2.apply(this, arguments));
  };
}
function selection_selectAll(select2) {
  if (typeof select2 === "function") select2 = arrayAll(select2);
  else select2 = selectorAll(select2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = [], parents = [], j2 = 0; j2 < m2; ++j2) {
    for (var group = groups2[j2], n2 = group.length, node, i = 0; i < n2; ++i) {
      if (node = group[i]) {
        subgroups.push(select2.call(node, node.__data__, i, group));
        parents.push(node);
      }
    }
  }
  return new Selection(subgroups, parents);
}
function matcher(selector2) {
  return function() {
    return this.matches(selector2);
  };
}
function childMatcher(selector2) {
  return function(node) {
    return node.matches(selector2);
  };
}
var find$1 = Array.prototype.find;
function childFind(match2) {
  return function() {
    return find$1.call(this.children, match2);
  };
}
function childFirst() {
  return this.firstElementChild;
}
function selection_selectChild(match2) {
  return this.select(match2 == null ? childFirst : childFind(typeof match2 === "function" ? match2 : childMatcher(match2)));
}
var filter = Array.prototype.filter;
function children() {
  return Array.from(this.children);
}
function childrenFilter(match2) {
  return function() {
    return filter.call(this.children, match2);
  };
}
function selection_selectChildren(match2) {
  return this.selectAll(match2 == null ? children : childrenFilter(typeof match2 === "function" ? match2 : childMatcher(match2)));
}
function selection_filter(match2) {
  if (typeof match2 !== "function") match2 = matcher(match2);
  for (var groups2 = this._groups, m2 = groups2.length, subgroups = new Array(m2), j2 = 0; j2 < m2; ++j2) {
    for (var group = groups2[j2], n2 = group.length, subgroup = subgroups[j2] = [], node, i = 0; i < n2; ++i) {
      if ((node = group[i]) && match2.call(node, node.__data__, i, group)) {
        subgroup.push(node);
      }
    }
  }
  return new Selection(subgroups, this._parents);
}
function sparse(update) {
  return new Array(update.length);
}
function selection_enter() {
  return new Selection(this._enter || this._groups.map(sparse), this._parents);
}
function EnterNode(parent, datum2) {
  this.ownerDocument = parent.ownerDocument;
  this.namespaceURI = parent.namespaceURI;
  this._next = null;
  this._parent = parent;
  this.__data__ = datum2;
}
EnterNode.prototype = {
  constructor: EnterNode,
  appendChild: function(child) {
    return this._parent.insertBefore(child, this._next);
  },
  insertBefore: function(child, next) {
    return this._parent.insertBefore(child, next);
  },
  querySelector: function(selector2) {
    return this._parent.querySelector(selector2);
  },
  querySelectorAll: function(selector2) {
    return this._parent.querySelectorAll(selector2);
  }
};
function constant$1(x2) {
  return function() {
    return x2;
  };
}
function bindIndex(parent, group, enter, update, exit, data2) {
  var i = 0, node, groupLength = group.length, dataLength = data2.length;
  for (; i < dataLength; ++i) {
    if (node = group[i]) {
      node.__data__ = data2[i];
      update[i] = node;
    } else {
      enter[i] = new EnterNode(parent, data2[i]);
    }
  }
  for (; i < groupLength; ++i) {
    if (node = group[i]) {
      exit[i] = node;
    }
  }
}
function bindKey(parent, group, enter, update, exit, data2, key) {
  var i, node, nodeByKeyValue = /* @__PURE__ */ new Map(), groupLength = group.length, dataLength = data2.length, keyValues = new Array(groupLength), keyValue;
  for (i = 0; i < groupLength; ++i) {
    if (node = group[i]) {
      keyValues[i] = keyValue = key.call(node, node.__data__, i, group) + "";
      if (nodeByKeyValue.has(keyValue)) {
        exit[i] = node;
      } else {
        nodeByKeyValue.set(keyValue, node);
      }
    }
  }
  for (i = 0; i < dataLength; ++i) {
    keyValue = key.call(parent, data2[i], i, data2) + "";
    if (node = nodeByKeyValue.get(keyValue)) {
      update[i] = node;
      node.__data__ = data2[i];
      nodeByKeyValue.delete(keyValue);
    } else {
      enter[i] = new EnterNode(parent, data2[i]);
    }
  }
  for (i = 0; i < groupLength; ++i) {
    if ((node = group[i]) && nodeByKeyValue.get(keyValues[i]) === node) {
      exit[i] = node;
    }
  }
}
function datum(node) {
  return node.__data__;
}
function selection_data(value, key) {
  if (!arguments.length) return Array.from(this, datum);
  var bind3 = key ? bindKey : bindIndex, parents = this._parents, groups2 = this._groups;
  if (typeof value !== "function") value = constant$1(value);
  for (var m2 = groups2.length, update = new Array(m2), enter = new Array(m2), exit = new Array(m2), j2 = 0; j2 < m2; ++j2) {
    var parent = parents[j2], group = groups2[j2], groupLength = group.length, data2 = arraylike(value.call(parent, parent && parent.__data__, j2, parents)), dataLength = data2.length, enterGroup = enter[j2] = new Array(dataLength), updateGroup = update[j2] = new Array(dataLength), exitGroup = exit[j2] = new Array(groupLength);
    bind3(parent, group, enterGroup, updateGroup, exitGroup, data2, key);
    for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
      if (previous = enterGroup[i0]) {
        if (i0 >= i1) i1 = i0 + 1;
        while (!(next = updateGroup[i1]) && ++i1 < dataLength) ;
        previous._next = next || null;
      }
    }
  }
  update = new Selection(update, parents);
  update._enter = enter;
  update._exit = exit;
  return update;
}
function arraylike(data2) {
  return typeof data2 === "object" && "length" in data2 ? data2 : Array.from(data2);
}
function selection_exit() {
  return new Selection(this._exit || this._groups.map(sparse), this._parents);
}
function selection_join(onenter, onupdate, onexit) {
  var enter = this.enter(), update = this, exit = this.exit();
  if (typeof onenter === "function") {
    enter = onenter(enter);
    if (enter) enter = enter.selection();
  } else {
    enter = enter.append(onenter + "");
  }
  if (onupdate != null) {
    update = onupdate(update);
    if (update) update = update.selection();
  }
  if (onexit == null) exit.remove();
  else onexit(exit);
  return enter && update ? enter.merge(update).order() : update;
}
function selection_merge(context) {
  var selection = context.selection ? context.selection() : context;
  for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m2 = Math.min(m0, m1), merges = new Array(m0), j2 = 0; j2 < m2; ++j2) {
    for (var group0 = groups0[j2], group1 = groups1[j2], n2 = group0.length, merge2 = merges[j2] = new Array(n2), node, i = 0; i < n2; ++i) {
      if (node = group0[i] || group1[i]) {
        merge2[i] = node;
      }
    }
  }
  for (; j2 < m0; ++j2) {
    merges[j2] = groups0[j2];
  }
  return new Selection(merges, this._parents);
}
function selection_order() {
  for (var groups2 = this._groups, j2 = -1, m2 = groups2.length; ++j2 < m2; ) {
    for (var group = groups2[j2], i = group.length - 1, next = group[i], node; --i >= 0; ) {
      if (node = group[i]) {
        if (next && node.compareDocumentPosition(next) ^ 4) next.parentNode.insertBefore(node, next);
        next = node;
      }
    }
  }
  return this;
}
function selection_sort(compare2) {
  if (!compare2) compare2 = ascending;
  function compareNode(a, b2) {
    return a && b2 ? compare2(a.__data__, b2.__data__) : !a - !b2;
  }
  for (var groups2 = this._groups, m2 = groups2.length, sortgroups = new Array(m2), j2 = 0; j2 < m2; ++j2) {
    for (var group = groups2[j2], n2 = group.length, sortgroup = sortgroups[j2] = new Array(n2), node, i = 0; i < n2; ++i) {
      if (node = group[i]) {
        sortgroup[i] = node;
      }
    }
    sortgroup.sort(compareNode);
  }
  return new Selection(sortgroups, this._parents).order();
}
function ascending(a, b2) {
  return a < b2 ? -1 : a > b2 ? 1 : a >= b2 ? 0 : NaN;
}
function selection_call() {
  var callback = arguments[0];
  arguments[0] = this;
  callback.apply(null, arguments);
  return this;
}
function selection_nodes() {
  return Array.from(this);
}
function selection_node() {
  for (var groups2 = this._groups, j2 = 0, m2 = groups2.length; j2 < m2; ++j2) {
    for (var group = groups2[j2], i = 0, n2 = group.length; i < n2; ++i) {
      var node = group[i];
      if (node) return node;
    }
  }
  return null;
}
function selection_size() {
  let size2 = 0;
  for (const node of this) ++size2;
  return size2;
}
function selection_empty() {
  return !this.node();
}
function selection_each(callback) {
  for (var groups2 = this._groups, j2 = 0, m2 = groups2.length; j2 < m2; ++j2) {
    for (var group = groups2[j2], i = 0, n2 = group.length, node; i < n2; ++i) {
      if (node = group[i]) callback.call(node, node.__data__, i, group);
    }
  }
  return this;
}
function attrRemove(name) {
  return function() {
    this.removeAttribute(name);
  };
}
function attrRemoveNS(fullname) {
  return function() {
    this.removeAttributeNS(fullname.space, fullname.local);
  };
}
function attrConstant(name, value) {
  return function() {
    this.setAttribute(name, value);
  };
}
function attrConstantNS(fullname, value) {
  return function() {
    this.setAttributeNS(fullname.space, fullname.local, value);
  };
}
function attrFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttribute(name);
    else this.setAttribute(name, v);
  };
}
function attrFunctionNS(fullname, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
    else this.setAttributeNS(fullname.space, fullname.local, v);
  };
}
function selection_attr(name, value) {
  var fullname = namespace(name);
  if (arguments.length < 2) {
    var node = this.node();
    return fullname.local ? node.getAttributeNS(fullname.space, fullname.local) : node.getAttribute(fullname);
  }
  return this.each((value == null ? fullname.local ? attrRemoveNS : attrRemove : typeof value === "function" ? fullname.local ? attrFunctionNS : attrFunction : fullname.local ? attrConstantNS : attrConstant)(fullname, value));
}
function defaultView(node) {
  return node.ownerDocument && node.ownerDocument.defaultView || node.document && node || node.defaultView;
}
function styleRemove(name) {
  return function() {
    this.style.removeProperty(name);
  };
}
function styleConstant(name, value, priority) {
  return function() {
    this.style.setProperty(name, value, priority);
  };
}
function styleFunction(name, value, priority) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) this.style.removeProperty(name);
    else this.style.setProperty(name, v, priority);
  };
}
function selection_style(name, value, priority) {
  return arguments.length > 1 ? this.each((value == null ? styleRemove : typeof value === "function" ? styleFunction : styleConstant)(name, value, priority == null ? "" : priority)) : styleValue(this.node(), name);
}
function styleValue(node, name) {
  return node.style.getPropertyValue(name) || defaultView(node).getComputedStyle(node, null).getPropertyValue(name);
}
function propertyRemove(name) {
  return function() {
    delete this[name];
  };
}
function propertyConstant(name, value) {
  return function() {
    this[name] = value;
  };
}
function propertyFunction(name, value) {
  return function() {
    var v = value.apply(this, arguments);
    if (v == null) delete this[name];
    else this[name] = v;
  };
}
function selection_property(name, value) {
  return arguments.length > 1 ? this.each((value == null ? propertyRemove : typeof value === "function" ? propertyFunction : propertyConstant)(name, value)) : this.node()[name];
}
function classArray(string2) {
  return string2.trim().split(/^|\s+/);
}
function classList(node) {
  return node.classList || new ClassList(node);
}
function ClassList(node) {
  this._node = node;
  this._names = classArray(node.getAttribute("class") || "");
}
ClassList.prototype = {
  add: function(name) {
    var i = this._names.indexOf(name);
    if (i < 0) {
      this._names.push(name);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  remove: function(name) {
    var i = this._names.indexOf(name);
    if (i >= 0) {
      this._names.splice(i, 1);
      this._node.setAttribute("class", this._names.join(" "));
    }
  },
  contains: function(name) {
    return this._names.indexOf(name) >= 0;
  }
};
function classedAdd(node, names) {
  var list = classList(node), i = -1, n2 = names.length;
  while (++i < n2) list.add(names[i]);
}
function classedRemove(node, names) {
  var list = classList(node), i = -1, n2 = names.length;
  while (++i < n2) list.remove(names[i]);
}
function classedTrue(names) {
  return function() {
    classedAdd(this, names);
  };
}
function classedFalse(names) {
  return function() {
    classedRemove(this, names);
  };
}
function classedFunction(names, value) {
  return function() {
    (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
  };
}
function selection_classed(name, value) {
  var names = classArray(name + "");
  if (arguments.length < 2) {
    var list = classList(this.node()), i = -1, n2 = names.length;
    while (++i < n2) if (!list.contains(names[i])) return false;
    return true;
  }
  return this.each((typeof value === "function" ? classedFunction : value ? classedTrue : classedFalse)(names, value));
}
function textRemove() {
  this.textContent = "";
}
function textConstant(value) {
  return function() {
    this.textContent = value;
  };
}
function textFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.textContent = v == null ? "" : v;
  };
}
function selection_text(value) {
  return arguments.length ? this.each(value == null ? textRemove : (typeof value === "function" ? textFunction : textConstant)(value)) : this.node().textContent;
}
function htmlRemove() {
  this.innerHTML = "";
}
function htmlConstant(value) {
  return function() {
    this.innerHTML = value;
  };
}
function htmlFunction(value) {
  return function() {
    var v = value.apply(this, arguments);
    this.innerHTML = v == null ? "" : v;
  };
}
function selection_html(value) {
  return arguments.length ? this.each(value == null ? htmlRemove : (typeof value === "function" ? htmlFunction : htmlConstant)(value)) : this.node().innerHTML;
}
function raise() {
  if (this.nextSibling) this.parentNode.appendChild(this);
}
function selection_raise() {
  return this.each(raise);
}
function lower() {
  if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
}
function selection_lower() {
  return this.each(lower);
}
function selection_append(name) {
  var create = typeof name === "function" ? name : creator(name);
  return this.select(function() {
    return this.appendChild(create.apply(this, arguments));
  });
}
function constantNull() {
  return null;
}
function selection_insert(name, before) {
  var create = typeof name === "function" ? name : creator(name), select2 = before == null ? constantNull : typeof before === "function" ? before : selector(before);
  return this.select(function() {
    return this.insertBefore(create.apply(this, arguments), select2.apply(this, arguments) || null);
  });
}
function remove() {
  var parent = this.parentNode;
  if (parent) parent.removeChild(this);
}
function selection_remove() {
  return this.each(remove);
}
function selection_cloneShallow() {
  var clone2 = this.cloneNode(false), parent = this.parentNode;
  return parent ? parent.insertBefore(clone2, this.nextSibling) : clone2;
}
function selection_cloneDeep() {
  var clone2 = this.cloneNode(true), parent = this.parentNode;
  return parent ? parent.insertBefore(clone2, this.nextSibling) : clone2;
}
function selection_clone(deep) {
  return this.select(deep ? selection_cloneDeep : selection_cloneShallow);
}
function selection_datum(value) {
  return arguments.length ? this.property("__data__", value) : this.node().__data__;
}
function contextListener(listener) {
  return function(event) {
    listener.call(this, event, this.__data__);
  };
}
function parseTypenames(typenames) {
  return typenames.trim().split(/^|\s+/).map(function(t) {
    var name = "", i = t.indexOf(".");
    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
    return { type: t, name };
  });
}
function onRemove(typename) {
  return function() {
    var on2 = this.__on;
    if (!on2) return;
    for (var j2 = 0, i = -1, m2 = on2.length, o; j2 < m2; ++j2) {
      if (o = on2[j2], (!typename.type || o.type === typename.type) && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
      } else {
        on2[++i] = o;
      }
    }
    if (++i) on2.length = i;
    else delete this.__on;
  };
}
function onAdd(typename, value, options) {
  return function() {
    var on2 = this.__on, o, listener = contextListener(value);
    if (on2) for (var j2 = 0, m2 = on2.length; j2 < m2; ++j2) {
      if ((o = on2[j2]).type === typename.type && o.name === typename.name) {
        this.removeEventListener(o.type, o.listener, o.options);
        this.addEventListener(o.type, o.listener = listener, o.options = options);
        o.value = value;
        return;
      }
    }
    this.addEventListener(typename.type, listener, options);
    o = { type: typename.type, name: typename.name, value, listener, options };
    if (!on2) this.__on = [o];
    else on2.push(o);
  };
}
function selection_on(typename, value, options) {
  var typenames = parseTypenames(typename + ""), i, n2 = typenames.length, t;
  if (arguments.length < 2) {
    var on2 = this.node().__on;
    if (on2) for (var j2 = 0, m2 = on2.length, o; j2 < m2; ++j2) {
      for (i = 0, o = on2[j2]; i < n2; ++i) {
        if ((t = typenames[i]).type === o.type && t.name === o.name) {
          return o.value;
        }
      }
    }
    return;
  }
  on2 = value ? onAdd : onRemove;
  for (i = 0; i < n2; ++i) this.each(on2(typenames[i], value, options));
  return this;
}
function dispatchEvent$1(node, type3, params) {
  var window2 = defaultView(node), event = window2.CustomEvent;
  if (typeof event === "function") {
    event = new event(type3, params);
  } else {
    event = window2.document.createEvent("Event");
    if (params) event.initEvent(type3, params.bubbles, params.cancelable), event.detail = params.detail;
    else event.initEvent(type3, false, false);
  }
  node.dispatchEvent(event);
}
function dispatchConstant(type3, params) {
  return function() {
    return dispatchEvent$1(this, type3, params);
  };
}
function dispatchFunction(type3, params) {
  return function() {
    return dispatchEvent$1(this, type3, params.apply(this, arguments));
  };
}
function selection_dispatch(type3, params) {
  return this.each((typeof params === "function" ? dispatchFunction : dispatchConstant)(type3, params));
}
function* selection_iterator() {
  for (var groups2 = this._groups, j2 = 0, m2 = groups2.length; j2 < m2; ++j2) {
    for (var group = groups2[j2], i = 0, n2 = group.length, node; i < n2; ++i) {
      if (node = group[i]) yield node;
    }
  }
}
var root = [null];
function Selection(groups2, parents) {
  this._groups = groups2;
  this._parents = parents;
}
function selection_selection() {
  return this;
}
Selection.prototype = {
  constructor: Selection,
  select: selection_select,
  selectAll: selection_selectAll,
  selectChild: selection_selectChild,
  selectChildren: selection_selectChildren,
  filter: selection_filter,
  data: selection_data,
  enter: selection_enter,
  exit: selection_exit,
  join: selection_join,
  merge: selection_merge,
  selection: selection_selection,
  order: selection_order,
  sort: selection_sort,
  call: selection_call,
  nodes: selection_nodes,
  node: selection_node,
  size: selection_size,
  empty: selection_empty,
  each: selection_each,
  attr: selection_attr,
  style: selection_style,
  property: selection_property,
  classed: selection_classed,
  text: selection_text,
  html: selection_html,
  raise: selection_raise,
  lower: selection_lower,
  append: selection_append,
  insert: selection_insert,
  remove: selection_remove,
  clone: selection_clone,
  datum: selection_datum,
  on: selection_on,
  dispatch: selection_dispatch,
  [Symbol.iterator]: selection_iterator
};
function select(selector2) {
  return typeof selector2 === "string" ? new Selection([[document.querySelector(selector2)]], [document.documentElement]) : new Selection([[selector2]], root);
}
function sourceEvent(event) {
  let sourceEvent2;
  while (sourceEvent2 = event.sourceEvent) event = sourceEvent2;
  return event;
}
function pointer(event, node) {
  event = sourceEvent(event);
  if (node === void 0) node = event.currentTarget;
  if (node) {
    var svg = node.ownerSVGElement || node;
    if (svg.createSVGPoint) {
      var point2 = svg.createSVGPoint();
      point2.x = event.clientX, point2.y = event.clientY;
      point2 = point2.matrixTransform(node.getScreenCTM().inverse());
      return [point2.x, point2.y];
    }
    if (node.getBoundingClientRect) {
      var rect = node.getBoundingClientRect();
      return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
    }
  }
  return [event.pageX, event.pageY];
}
function identity(x2) {
  return x2;
}
var top = 1, right = 2, bottom = 3, left = 4, epsilon = 1e-6;
function translateX(x2) {
  return "translate(" + x2 + ",0)";
}
function translateY(y2) {
  return "translate(0," + y2 + ")";
}
function number(scale) {
  return (d2) => +scale(d2);
}
function center(scale, offset2) {
  offset2 = Math.max(0, scale.bandwidth() - offset2 * 2) / 2;
  if (scale.round()) offset2 = Math.round(offset2);
  return (d2) => +scale(d2) + offset2;
}
function entering() {
  return !this.__axis;
}
function axis(orient, scale) {
  var tickArguments = [], tickValues = null, tickFormat2 = null, tickSizeInner = 6, tickSizeOuter = 6, tickPadding = 3, offset2 = typeof window !== "undefined" && window.devicePixelRatio > 1 ? 0 : 0.5, k2 = orient === top || orient === left ? -1 : 1, x2 = orient === left || orient === right ? "x" : "y", transform = orient === top || orient === bottom ? translateX : translateY;
  function axis2(context) {
    var values3 = tickValues == null ? scale.ticks ? scale.ticks.apply(scale, tickArguments) : scale.domain() : tickValues, format2 = tickFormat2 == null ? scale.tickFormat ? scale.tickFormat.apply(scale, tickArguments) : identity : tickFormat2, spacing = Math.max(tickSizeInner, 0) + tickPadding, range2 = scale.range(), range0 = +range2[0] + offset2, range1 = +range2[range2.length - 1] + offset2, position = (scale.bandwidth ? center : number)(scale.copy(), offset2), selection = context.selection ? context.selection() : context, path = selection.selectAll(".domain").data([null]), tick = selection.selectAll(".tick").data(values3, scale).order(), tickExit = tick.exit(), tickEnter = tick.enter().append("g").attr("class", "tick"), line2 = tick.select("line"), text = tick.select("text");
    path = path.merge(path.enter().insert("path", ".tick").attr("class", "domain").attr("stroke", "currentColor"));
    tick = tick.merge(tickEnter);
    line2 = line2.merge(tickEnter.append("line").attr("stroke", "currentColor").attr(x2 + "2", k2 * tickSizeInner));
    text = text.merge(tickEnter.append("text").attr("fill", "currentColor").attr(x2, k2 * spacing).attr("dy", orient === top ? "0em" : orient === bottom ? "0.71em" : "0.32em"));
    if (context !== selection) {
      path = path.transition(context);
      tick = tick.transition(context);
      line2 = line2.transition(context);
      text = text.transition(context);
      tickExit = tickExit.transition(context).attr("opacity", epsilon).attr("transform", function(d2) {
        return isFinite(d2 = position(d2)) ? transform(d2 + offset2) : this.getAttribute("transform");
      });
      tickEnter.attr("opacity", epsilon).attr("transform", function(d2) {
        var p = this.parentNode.__axis;
        return transform((p && isFinite(p = p(d2)) ? p : position(d2)) + offset2);
      });
    }
    tickExit.remove();
    path.attr("d", orient === left || orient === right ? tickSizeOuter ? "M" + k2 * tickSizeOuter + "," + range0 + "H" + offset2 + "V" + range1 + "H" + k2 * tickSizeOuter : "M" + offset2 + "," + range0 + "V" + range1 : tickSizeOuter ? "M" + range0 + "," + k2 * tickSizeOuter + "V" + offset2 + "H" + range1 + "V" + k2 * tickSizeOuter : "M" + range0 + "," + offset2 + "H" + range1);
    tick.attr("opacity", 1).attr("transform", function(d2) {
      return transform(position(d2) + offset2);
    });
    line2.attr(x2 + "2", k2 * tickSizeInner);
    text.attr(x2, k2 * spacing).text(format2);
    selection.filter(entering).attr("fill", "none").attr("font-size", 10).attr("font-family", "sans-serif").attr("text-anchor", orient === right ? "start" : orient === left ? "end" : "middle");
    selection.each(function() {
      this.__axis = position;
    });
  }
  axis2.scale = function(_2) {
    return arguments.length ? (scale = _2, axis2) : scale;
  };
  axis2.ticks = function() {
    return tickArguments = Array.from(arguments), axis2;
  };
  axis2.tickArguments = function(_2) {
    return arguments.length ? (tickArguments = _2 == null ? [] : Array.from(_2), axis2) : tickArguments.slice();
  };
  axis2.tickValues = function(_2) {
    return arguments.length ? (tickValues = _2 == null ? null : Array.from(_2), axis2) : tickValues && tickValues.slice();
  };
  axis2.tickFormat = function(_2) {
    return arguments.length ? (tickFormat2 = _2, axis2) : tickFormat2;
  };
  axis2.tickSize = function(_2) {
    return arguments.length ? (tickSizeInner = tickSizeOuter = +_2, axis2) : tickSizeInner;
  };
  axis2.tickSizeInner = function(_2) {
    return arguments.length ? (tickSizeInner = +_2, axis2) : tickSizeInner;
  };
  axis2.tickSizeOuter = function(_2) {
    return arguments.length ? (tickSizeOuter = +_2, axis2) : tickSizeOuter;
  };
  axis2.tickPadding = function(_2) {
    return arguments.length ? (tickPadding = +_2, axis2) : tickPadding;
  };
  axis2.offset = function(_2) {
    return arguments.length ? (offset2 = +_2, axis2) : offset2;
  };
  return axis2;
}
function axisBottom(scale) {
  return axis(bottom, scale);
}
function axisLeft(scale) {
  return axis(left, scale);
}
var useChart = () => {
  const chart = inject("chart");
  return chart;
};
var usePoints = (dataKeys, props2 = { stacked: false, type: "line" }) => {
  const points = ref([]);
  const chart = useChart();
  const { stacked, type: type3 } = props2;
  function getPoints(key, values3) {
    const { primary, secondary } = chart.scales;
    if (chart.config.direction === "horizontal") {
      const res = values3.map((val) => {
        return {
          x: primary.mapOne(val.data[key]),
          y: secondary.mapOne(val[1]),
          props: { values: [...val], data: val.data }
        };
      }).filter((p) => !isNaN(p.x) && !isNaN(p.y));
      return res;
    } else if (chart.config.direction === "vertical") {
      return values3.map((val) => {
        return {
          x: secondary.mapOne(val[1]),
          y: primary.mapOne(val.data[key]),
          props: { values: [...val], data: val.data }
        };
      }).filter((p) => !isNaN(p.x) && !isNaN(p.y));
    }
    return [];
  }
  function update() {
    const keys4 = chart.getStackedKeys(1, type3);
    const [primaryKey, secondaryKey] = dataKeys;
    const stack2 = chart.getStackedData(stacked ? keys4 : [dataKeys[1]]);
    const data2 = stack2.find((s) => s.key === secondaryKey);
    if (data2) {
      points.value = getPoints(primaryKey, data2);
    }
  }
  watch(chart.updates, () => {
    update();
  }, { immediate: true });
  return {
    points
  };
};
var useMouse = () => {
  const mouse = inject("chartMouse", {
    index: -1,
    position: { x: 0, y: 0 },
    hover: false
  });
  return mouse;
};
var useBars = (dataKeys, props2 = { maxWidth: -1, gap: 5, stacked: false, type: "bar" }) => {
  const bars = ref([]);
  const chart = useChart();
  const { stacked, type: type3, gap } = props2;
  function scales() {
    const { primary, secondary } = chart.scales;
    const bandScale = primary.type === "band" ? primary : secondary;
    const linearScale = primary.type === "band" ? secondary : primary;
    return { bandScale, linearScale };
  }
  function getIndex() {
    if (stacked) {
      return 0;
    }
    const barLayers = chart.getLayers(type3);
    const idx = barLayers.findIndex((l) => l.dataKeys.join(",") === dataKeys.join(","));
    return idx > -1 ? idx : 0;
  }
  function getBarWidth() {
    const { bandScale } = scales();
    const maxWidth = props2.maxWidth > -1 ? Math.min(bandScale.bandwidth() - gap, props2.maxWidth) : bandScale.bandwidth() - gap;
    const barLayers = chart.getLayers(type3);
    return barLayers.length > 0 && !stacked ? maxWidth / barLayers.length : maxWidth;
  }
  function getDiffWidth() {
    if (stacked) {
      return 0;
    }
    const { bandScale } = scales();
    const max2 = bandScale.bandwidth() - gap;
    const total = chart.getLayers(type3).length * getBarWidth();
    return (max2 - total) / 2;
  }
  function getBars(key, values3) {
    const { bandScale, linearScale } = scales();
    const index2 = getIndex();
    const barSize = getBarWidth();
    const diff = getDiffWidth();
    return values3.map((val) => {
      const rect = { x: 0, y: 0, width: 0, height: 0, props: { values: [...val], data: val.data } };
      const xVal = bandScale.scale(val.data[key]);
      const [yVal0, yVal1] = linearScale.map(val);
      if (chart.config.direction === "horizontal") {
        rect.y = Math.min(yVal0, yVal1);
        rect.height = Math.abs(yVal0 - yVal1);
        rect.x = diff + xVal + index2 * barSize + gap / 2;
        rect.width = barSize;
      } else if (chart.config.direction === "vertical") {
        rect.x = Math.min(yVal0, yVal1);
        rect.width = Math.abs(yVal0 - yVal1);
        rect.y = diff + xVal + index2 * barSize + gap / 2;
        rect.height = barSize;
      }
      return rect;
    });
  }
  function update() {
    const keys4 = stacked ? chart.getStackedKeys(1, type3) : [dataKeys[1]];
    const [primaryKey, secondaryKey] = dataKeys;
    const stack2 = chart.getStackedData(keys4);
    const data2 = stack2.find((s) => s.key === secondaryKey);
    if (data2) {
      bars.value = getBars(primaryKey, data2);
    }
  }
  watch(chart.updates, () => {
    update();
  });
  return {
    bars
  };
};
var useTooltip = () => {
  const mouse = useMouse();
  const chart = useChart();
  const show = computed(() => mouse.hover);
  const position = ref({ x: 0, y: 0 });
  const payload = ref({});
  watch(mouse, () => {
    const { primary } = chart.scales;
    const keys4 = chart.getKeys(0);
    const vals = chart.getData(keys4);
    const [x2] = primary.map([vals[mouse.index]]);
    if (x2) {
      if (chart.config.direction === "horizontal") {
        position.value = {
          x: x2,
          y: mouse.position.y
        };
      } else if (chart.config.direction === "vertical") {
        position.value = {
          x: mouse.position.x,
          y: x2
        };
      } else {
        position.value = {
          x: mouse.position.x,
          y: mouse.position.y
        };
      }
    }
    const d2 = chart.data[mouse.index];
    if (d2) {
      payload.value = Object.assign(Object.assign({}, d2), { idx: mouse.index });
    }
  });
  return { position, payload, show };
};
var useResize = (el) => {
  const width = ref(0);
  const height = ref(0);
  let observer = null;
  let resizeCallback = null;
  function onUpdate(w, h2) {
    width.value = w;
    height.value = h2;
    if (resizeCallback) {
      resizeCallback();
    }
  }
  function onResize(callback) {
    resizeCallback = callback;
  }
  onMounted(() => {
    observer = new window.ResizeObserver((entries) => {
      const w = entries[0].contentRect.width;
      const h2 = entries[0].contentRect.height;
      onUpdate(w, h2);
    });
    observer.observe(el.value);
  });
  onUnmounted(() => {
    observer.disconnect();
  });
  return { width, height, onResize };
};
var script$d = defineComponent({
  name: "Axis",
  props: {
    position: {
      type: String,
      default: "bottom"
    },
    rotate: {
      type: Boolean,
      default: false
    },
    isPrimary: {
      type: Boolean,
      default: false
    }
  },
  setup(props2) {
    const el = ref();
    const chart = useChart();
    const axis2 = computed(() => {
      return props2.position === "bottom" ? axisBottom : axisLeft;
    });
    const canvas = ref(chart.canvas);
    const defaultConfig2 = { ticks: 5 };
    function drawAxis() {
      if (chart.data.length > 0) {
        const { primary, secondary } = chart.scales;
        const current = props2.isPrimary ? primary : secondary;
        const config = Object.assign({}, props2.isPrimary ? primary.config : secondary.config, defaultConfig2);
        const ax = axis2.value(current.scale);
        if (config.format) {
          ax.tickFormat(config.format);
        }
        if (config.ticks !== void 0) {
          ax.ticks(config.ticks);
        }
        if (config.tickValues !== void 0) {
          ax.tickValues(config.tickValues);
        }
        if (config.useConfig) {
          config.useConfig(ax);
        }
        const res = select(el.value).call(ax);
        if (props2.position === "bottom" && props2.rotate) {
          res.selectAll("text").attr("y", 0).attr("x", 9).attr("dy", ".35em").attr("transform", "rotate(90)").style("text-anchor", "start");
        }
        return ax;
      }
      return null;
    }
    watch(() => props2.isPrimary, () => {
      drawAxis();
    });
    watch(chart.updates, () => {
      canvas.value = chart.canvas;
      drawAxis();
    });
    return { el, canvas };
  }
});
const _hoisted_1$b$1 = ["transform"];
const _hoisted_2$8$1 = ["transform"];
function render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.position === "bottom" ? (openBlock(), createElementBlock("g", {
    key: 0,
    class: normalizeClass(`layer-axis-x`),
    ref: "el",
    transform: `translate(0, ${_ctx.canvas.height})`
  }, null, 8, _hoisted_1$b$1)) : (openBlock(), createElementBlock("g", {
    key: 1,
    class: normalizeClass(`layer-axis-y`),
    ref: "el",
    transform: `translate(${_ctx.canvas.x}, 0)`
  }, null, 8, _hoisted_2$8$1));
}
script$d.render = render$d;
script$d.__file = "src/components/Axis/index.vue";
var script$c = defineComponent({
  name: "Chart",
  components: { Axis: script$d },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    margin: {
      type: Object,
      default: () => ({
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }),
      required: false
    },
    size: {
      type: Object,
      default: () => ({ width: 500, height: 400 }),
      required: false
    },
    direction: {
      type: String,
      default: "horizontal",
      required: false
    },
    axis: {
      type: Object,
      required: false
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props2) {
    const chartEl = ref(null);
    const axLeftEl = ref();
    const axBottomEl = ref();
    const axisSpace = reactive({ x: 40, y: 20 });
    const chart = new Chart(props2.data, props2.config);
    const rotateX = computed(() => props2.axis && props2.axis.primary && props2.axis.primary.rotate);
    const hideX = computed(() => {
      return props2.axis && props2.axis.primary && props2.axis.primary.hide;
    });
    const hideY = computed(() => {
      return props2.axis && props2.axis.secondary && props2.axis.secondary.hide;
    });
    const mouse = reactive({
      index: -1,
      position: { x: 0, y: 0 },
      hover: false
    });
    provide("chart", chart);
    provide("chartMouse", mouse);
    watch(() => props2.data, () => {
      if (chart)
        chart.changeData(props2.data);
    }, { immediate: true });
    watch(() => props2.config, () => {
      if (chart)
        chart.changeConfig(props2.config);
    });
    watch(() => [Object.assign({}, axisSpace), props2.direction, props2.size, props2.margin, props2.axis], () => {
      if (chart) {
        chart.changeConfig({
          axisSpace: Object.assign({}, axisSpace),
          direction: props2.direction,
          size: props2.size,
          margin: props2.margin,
          axis: props2.axis
        });
      }
    }, { immediate: true });
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (axBottomEl.value && entry.target === axBottomEl.value.$el) {
          axisSpace.y = entry.contentRect.height;
        } else if (axLeftEl.value && entry.target === axLeftEl.value.$el) {
          axisSpace.x = entry.contentRect.width;
        }
      }
    });
    onMounted(() => {
      if (axBottomEl.value) {
        resizeObserver.observe(axBottomEl.value.$el);
      }
      if (axLeftEl.value) {
        resizeObserver.observe(axLeftEl.value.$el);
      }
    });
    onUnmounted(() => {
      resizeObserver.disconnect();
    });
    function onMouseOut() {
      if (props2.config.controlHover === false) {
        return;
      }
      mouse.index = -1;
      mouse.hover = false;
    }
    function onMouseMove(e) {
      if (props2.config.controlHover === false) {
        return;
      }
      mouse.hover = true;
      mouse.position = { x: pointer(e)[0], y: pointer(e)[1] };
      const { primary } = chart.scales;
      const keys4 = chart.getKeys(0);
      const vals = chart.getData(keys4);
      if (chart.config.direction === "horizontal") {
        if (primary.type === "band") {
          const band2 = primary.bandwidth();
          const delta = mouse.position.x - chart.canvas.x;
          mouse.index = Math.round((delta + band2 / 2) / band2) - 1;
        } else {
          mouse.index = bisectCenter(vals, primary.scale.invert(mouse.position.x));
        }
      } else if (chart.config.direction === "vertical") {
        if (primary.type === "band") {
          const band2 = primary.bandwidth();
          const delta = mouse.position.y - chart.canvas.y;
          mouse.index = Math.round((delta + band2 / 2) / band2) - 1;
        } else {
          mouse.index = bisectCenter(vals, primary.scale.invert(mouse.position.y));
        }
      }
    }
    return { axBottomEl, axLeftEl, chartEl, hideX, hideY, rotateX, onMouseMove, onMouseOut };
  }
});
const _hoisted_1$a$1 = {
  class: "chart",
  ref: "chartEl"
};
const _hoisted_2$7$1 = ["width", "height", "viewBox"];
const _hoisted_3$6$1 = { class: "layers" };
const _hoisted_4$3$1 = { class: "axis" };
const _hoisted_5$3$1 = { class: "widgets" };
function render$c(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_axis = resolveComponent("axis");
  return openBlock(), createElementBlock(
    "div",
    _hoisted_1$a$1,
    [
      (openBlock(), createElementBlock("svg", {
        width: _ctx.size.width,
        height: _ctx.size.height,
        viewBox: `0 0 ${_ctx.size.width} ${_ctx.size.height}`,
        onPointermove: _cache[0] || (_cache[0] = (...args) => _ctx.onMouseMove && _ctx.onMouseMove(...args)),
        onPointerleave: _cache[1] || (_cache[1] = (...args) => _ctx.onMouseOut && _ctx.onMouseOut(...args))
      }, [
        createElementVNode("g", _hoisted_3$6$1, [
          renderSlot(_ctx.$slots, "layers")
        ]),
        createElementVNode("g", _hoisted_4$3$1, [
          !_ctx.hideX ? (openBlock(), createBlock(_component_axis, {
            key: 0,
            position: "bottom",
            ref: "axBottomEl",
            rotate: _ctx.rotateX,
            isPrimary: _ctx.direction === "horizontal"
          }, null, 8, ["rotate", "isPrimary"])) : createCommentVNode("v-if", true),
          !_ctx.hideY ? (openBlock(), createBlock(_component_axis, {
            key: 1,
            position: "left",
            ref: "axLeftEl",
            isPrimary: _ctx.direction === "vertical"
          }, null, 8, ["isPrimary"])) : createCommentVNode("v-if", true)
        ])
      ], 40, _hoisted_2$7$1)),
      createElementVNode("div", _hoisted_5$3$1, [
        renderSlot(_ctx.$slots, "widgets")
      ])
    ],
    512
    /* NEED_PATCH */
  );
}
function styleInject(css2, ref2) {
  if (ref2 === void 0) ref2 = {};
  var insertAt = ref2.insertAt;
  if (!css2 || typeof document === "undefined") {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.type = "text/css";
  if (insertAt === "top") {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css2;
  } else {
    style.appendChild(document.createTextNode(css2));
  }
}
var css_248z$1 = "\n.chart {\n  position: relative;\n}\n";
styleInject(css_248z$1);
script$c.render = render$c;
script$c.__file = "src/components/Chart/index.vue";
var script$b = defineComponent({
  name: "Layer",
  props: {
    type: {
      type: String,
      default: "custom"
    },
    dataKeys: {
      type: Object,
      required: true
    }
  },
  setup(props2) {
    const chart = useChart();
    const id = (/* @__PURE__ */ new Date()).getTime().toString();
    const extraProps = inject("layerProps", {});
    onMounted(() => {
      chart.addLayer({ id, type: props2.type, dataKeys: props2.dataKeys, props: extraProps });
    });
    onUnmounted(() => {
      chart.removeLayer(id);
    });
    return {};
  }
});
function render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "g",
    {
      class: normalizeClass(`layer-${_ctx.type}`)
    },
    [
      renderSlot(_ctx.$slots, "default")
    ],
    2
    /* CLASS */
  );
}
script$b.render = render$b;
script$b.__file = "src/components/Layer/index.vue";
var script$a = defineComponent({
  name: "AreaComponent",
  components: { Layer: script$b },
  props: {
    areaStyle: {
      type: Object,
      required: false
    },
    dataKeys: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: () => "normal"
    },
    gap: {
      type: Number,
      default: 0
    }
  },
  setup(props2) {
    const chart = useChart();
    const { stacked } = inject("layerProps", { stacked: false });
    const { points } = usePoints(props2.dataKeys, {
      stacked: false,
      type: "area"
    });
    const { bars } = useBars(props2.dataKeys, {
      stacked,
      type: "area",
      gap: props2.gap,
      maxWidth: -1
    });
    const d2 = ref("");
    const lineType = (type3) => {
      const map3 = {
        normal: curveLinear,
        natural: curveNatural,
        step: curveStep,
        monotone: chart.config.direction === "horizontal" ? monotoneX : monotoneY
      };
      return map3[type3];
    };
    const buildArea = () => {
      console.log(points.value);
      const { secondary } = chart.scales;
      if (stacked) {
        return area().curve(lineType(props2.type)).x0((p) => p.x + p.width / 2).y0((p) => p.y).x1((p) => p.x + p.width / 2).y1((p) => p.y + p.height);
      }
      if (chart.config.direction === "vertical") {
        return area().curve(lineType(props2.type)).y0((p) => p.y).y1((p) => p.y).x0((p) => p.x).x1(() => secondary.scale(0));
      }
      return area().curve(lineType(props2.type)).x0((p) => p.x).x1((p) => p.x).y0((p) => p.y).y1(() => secondary.scale(0));
    };
    const getStyle = computed(() => {
      return () => Object.assign({ fill: "blue", fillOpacity: 0.25, stroke: "none" }, props2.areaStyle);
    });
    const toKebabCase = (data2) => mapKeys(kebabize, data2);
    watch(points, () => {
      d2.value = stacked ? buildArea()(bars.value) : buildArea()(points.value);
    });
    return { d: d2, getStyle, toKebabCase };
  }
});
const _hoisted_1$9$1 = ["d"];
function render$a(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    type: "area",
    dataKeys: _ctx.dataKeys
  }, {
    default: withCtx(() => [
      createElementVNode("path", mergeProps(_ctx.toKebabCase(_ctx.getStyle()), { d: _ctx.d }), null, 16, _hoisted_1$9$1)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["dataKeys"]);
}
script$a.render = render$a;
script$a.__file = "src/components/Area/index.vue";
var script$9 = defineComponent({
  name: "LineComponent",
  components: { Layer: script$b },
  props: {
    lineStyle: {
      type: Object,
      required: false
    },
    dotStyle: {
      type: Object,
      required: false
    },
    hideDot: {
      type: Boolean,
      default: false
    },
    dataKeys: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      default: () => "normal"
    }
  },
  setup(props2) {
    const { stacked } = inject("layerProps", { stacked: false });
    const mouse = useMouse();
    const chart = useChart();
    const d2 = ref("");
    const { points } = usePoints(props2.dataKeys, { stacked, type: "line" });
    const lineType = {
      normal: curveLinear,
      natural: curveNatural,
      step: stepAfter,
      monotone: monotoneX
    };
    function updateLine() {
      let type3 = lineType[props2.type];
      if (props2.type === "monotone" && chart.config.direction === "vertical") {
        type3 = monotoneY;
      }
      d2.value = line().x((p) => p.x).y((p) => p.y).curve(type3)(points.value);
    }
    function computeDotStyle(active) {
      const dotStyle = props2.dotStyle;
      const style = getStyle.value();
      return Object.assign({ r: active ? 5 : 3, stroke: style.stroke, strokeWidth: style.strokeWidth, fill: "white" }, dotStyle);
    }
    const getStyle = computed(() => {
      if (is$1(Function, props2.lineStyle)) {
        return props2.lineStyle;
      }
      return () => Object.assign({ stroke: "#8884d8", strokeWidth: 2 }, props2.lineStyle);
    });
    const getDotStyle = computed(() => {
      if (is$1(Function, props2.dotStyle)) {
        return props2.dotStyle;
      }
      return ({ active }) => computeDotStyle(active);
    });
    watch(points, () => updateLine());
    watch(chart.updates, () => updateLine());
    const toKebabCase = (data2) => mapKeys(kebabize, data2);
    return { d: d2, mouse, points, toKebabCase, getStyle, getDotStyle };
  }
});
const _hoisted_1$8$1 = ["d"];
const _hoisted_2$6$1 = { key: 0 };
const _hoisted_3$5$1 = ["cx", "cy"];
function render$9(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    dataKeys: _ctx.dataKeys,
    type: "line"
  }, {
    default: withCtx(() => [
      createElementVNode("path", mergeProps({ class: "chart-line" }, _ctx.toKebabCase(_ctx.getStyle()), {
        d: _ctx.d,
        fill: "none"
      }), null, 16, _hoisted_1$8$1),
      createCommentVNode(' :stroke="stroke"\n      :stroke-width="strokeWidth"\n      stroke-linejoin="round"\n      stroke-linecap="round" '),
      !_ctx.hideDot ? (openBlock(), createElementBlock("g", _hoisted_2$6$1, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.points, (c2, i) => {
            return openBlock(), createElementBlock("circle", mergeProps(_ctx.toKebabCase(_ctx.getDotStyle({ active: i === _ctx.mouse.index, index: i })), {
              key: i,
              cx: c2.x,
              cy: c2.y
            }), null, 16, _hoisted_3$5$1);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ])) : createCommentVNode("v-if", true)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["dataKeys"]);
}
script$9.render = render$9;
script$9.__file = "src/components/Line/index.vue";
var script$8 = defineComponent({
  name: "Bar",
  components: { Layer: script$b },
  props: {
    selectedBar: {
      type: Object,
      default: () => null
    },
    barStyle: {
      type: [Function, Object],
      default: () => ({
        fill: "blue"
      })
    },
    barStyleSelected: {
      type: [Function, Object],
      default: () => ({
        fill: "darkblue"
      })
    },
    maxWidth: {
      type: Number,
      default: -1
    },
    dataKeys: {
      type: Object,
      required: true
    },
    gap: {
      type: Number,
      default: 5
    }
  },
  setup(props2, { emit: emit2 }) {
    const mouse = useMouse();
    const { stacked, maxWidth } = inject("layerProps", {
      stacked: false,
      maxWidth: -1
    });
    const { bars } = useBars(props2.dataKeys, {
      maxWidth: Math.max(props2.maxWidth, maxWidth),
      stacked,
      gap: props2.gap,
      type: "bar"
    });
    const getStyle = computed(() => {
      if (is$1(Function, props2.barStyle)) {
        return props2.barStyle;
      }
      return () => props2.barStyle;
    });
    const getStyleSelected = computed(() => {
      if (is$1(Function, props2.barStyleSelected)) {
        return props2.barStyleSelected;
      }
      return () => props2.barStyleSelected;
    });
    const toKebabCase = (data2) => mapKeys(kebabize, data2);
    function onBarClick(bar, idx) {
      emit2("barClick", Object.assign(Object.assign({}, bar), { idx }));
    }
    return { getStyle, getStyleSelected, toKebabCase, bars, mouse, onBarClick };
  }
});
const _hoisted_1$7$1 = { key: 0 };
const _hoisted_2$5$1 = ["x", "y", "width", "height", "onClick"];
const _hoisted_3$4$1 = ["x", "y", "width", "height"];
function render$8(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    dataKeys: _ctx.dataKeys,
    type: "bar"
  }, {
    default: withCtx(() => [
      _ctx.bars.length === 0 ? (openBlock(), createElementBlock("text", _hoisted_1$7$1, "No Data")) : createCommentVNode("v-if", true),
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.bars, (bar, i) => {
          return openBlock(), createElementBlock("rect", mergeProps(
            { class: "chart-bar" },
            _ctx.toKebabCase(_ctx.getStyle({ ...bar.props, active: i === _ctx.mouse.index })),
            {
              key: i,
              x: bar.x,
              y: bar.y,
              width: bar.width > 0 ? bar.width : 0,
              height: bar.height > 0 ? bar.height : 0,
              onClick: () => _ctx.onBarClick(bar, i)
            }
          ), null, 16, _hoisted_2$5$1);
        }),
        128
        /* KEYED_FRAGMENT */
      )),
      _ctx.selectedBar ? (openBlock(), createElementBlock("rect", mergeProps(
        {
          key: 1,
          class: "chart-bar"
        },
        _ctx.toKebabCase(_ctx.getStyleSelected({ ..._ctx.selectedBar.props })),
        {
          x: _ctx.selectedBar.x,
          y: _ctx.selectedBar.y,
          width: _ctx.selectedBar.width > 0 ? _ctx.selectedBar.width : 0,
          height: _ctx.selectedBar.height > 0 ? _ctx.selectedBar.height : 0
        }
      ), null, 16, _hoisted_3$4$1)) : createCommentVNode("v-if", true)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["dataKeys"]);
}
script$8.render = render$8;
script$8.__file = "src/components/Bar/index.vue";
const PieSort = String;
var script$7 = defineComponent({
  name: "PieLayer",
  components: { Layer: script$b },
  props: {
    pieStyle: {
      type: Object,
      required: false
    },
    dataKeys: {
      type: Object,
      required: true
    },
    sort: {
      type: PieSort,
      default: "desc",
      required: false
    },
    sortFunc: {
      type: Function,
      required: false
    }
  },
  setup(props2) {
    var _a2;
    const chart = useChart();
    const mouse = useMouse();
    const size2 = ref(Math.min(chart.canvas.width - chart.canvas.x, chart.canvas.height - chart.canvas.y) / 2);
    const getStyle = computed(() => {
      return () => Object.assign({ colors: ["#4daf4a", "#377eb8", "#ff7f00", "#984ea3", "#e41a1c"], innerRadius: 2, cornerRadius: 0, padAngle: 0.01 }, props2.pieStyle);
    });
    const style = getStyle.value();
    const arcs = ref([]);
    const colors = ordinal(getStyle.value().colors);
    const arcGen = () => {
      return arc().outerRadius(size2.value).innerRadius(style.innerRadius).cornerRadius(style.cornerRadius).padAngle(style.padAngle);
    };
    const transform = ref(`translate(${size2.value + chart.canvas.x}, ${size2.value + chart.canvas.y})`);
    let pieSort;
    switch (props2.sort) {
      case "desc":
        pieSort = descending$1;
        break;
      case "asc":
        pieSort = ascending$1;
        break;
      case "none":
        pieSort = null;
        break;
      case "custom":
        pieSort = (_a2 = props2.sortFunc) !== null && _a2 !== void 0 ? _a2 : null;
        break;
      default:
        pieSort = null;
    }
    function updatePie() {
      const data2 = chart.getData([props2.dataKeys[1]]);
      arcs.value = pie().sort(pieSort)(data2);
    }
    function getColor(index2) {
      return colors(index2.toString());
    }
    function showTooltip(event, index2) {
      mouse.hover = true;
      mouse.index = index2;
      const [x2, y2] = pointer(event);
      mouse.position = { x: x2 + size2.value, y: y2 + size2.value };
    }
    function hideTooltip() {
      mouse.hover = false;
      mouse.index = -1;
    }
    function toKebabCase(data2) {
      mapKeys(kebabize, data2);
    }
    watch(chart.updates, () => {
      size2.value = Math.min(chart.canvas.width - chart.canvas.x, (chart.canvas.height - chart.canvas.y) / 2);
      transform.value = `translate(${size2.value + chart.canvas.x}, ${size2.value + chart.canvas.y})`;
      updatePie();
    });
    return {
      arcs,
      arcGen,
      getStyle,
      transform,
      getColor,
      hideTooltip,
      toKebabCase,
      showTooltip
    };
  }
});
const _hoisted_1$6$1 = { key: 0 };
const _hoisted_2$4$1 = ["transform"];
const _hoisted_3$3$1 = ["id", "fill", "d", "onMousemove"];
function render$7(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Layer = resolveComponent("Layer");
  return openBlock(), createBlock(_component_Layer, {
    dataKeys: _ctx.dataKeys,
    type: "pie"
  }, {
    default: withCtx(() => [
      _ctx.arcs.length === 0 ? (openBlock(), createElementBlock("text", _hoisted_1$6$1, "No Data")) : createCommentVNode("v-if", true),
      createElementVNode("g", { transform: _ctx.transform }, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.arcs, (arc2, i) => {
            return openBlock(), createElementBlock("path", mergeProps({
              key: i,
              id: `arc-${i}`,
              class: "chart-pie"
            }, _ctx.toKebabCase(_ctx.getStyle()), {
              fill: _ctx.getColor(i),
              d: _ctx.arcGen()(arc2),
              onMousemove: ($event) => _ctx.showTooltip($event, i),
              onMouseleave: _cache[0] || (_cache[0] = ($event) => _ctx.hideTooltip())
            }), null, 16, _hoisted_3$3$1);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ], 8, _hoisted_2$4$1)
    ]),
    _: 1
    /* STABLE */
  }, 8, ["dataKeys"]);
}
script$7.render = render$7;
script$7.__file = "src/components/Pie/index.vue";
var script$6 = defineComponent({
  name: "Responsive",
  setup() {
    const el = ref(null);
    const { width, height } = useResize(el);
    return { el, width, height };
  }
});
const _hoisted_1$5$1 = { ref: "el" };
function render$6(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    _hoisted_1$5$1,
    [
      renderSlot(_ctx.$slots, "main", {
        width: _ctx.width,
        height: _ctx.height
      })
    ],
    512
    /* NEED_PATCH */
  );
}
script$6.render = render$6;
script$6.__file = "src/components/Responsive/index.vue";
var script$5 = defineComponent({
  name: "Grid",
  props: {
    strokeDasharray: {
      type: String,
      default: () => "3 3"
    },
    hideX: {
      type: Boolean,
      default: false
    },
    hideY: {
      type: Boolean,
      default: false
    },
    center: {
      type: Boolean,
      default: true
    }
  },
  setup(props2) {
    const chart = useChart();
    const data2 = ref([]);
    const canvas = ref(null);
    const xLines = ref([]);
    const yLines = ref([]);
    function updateXLines() {
      const { primary, secondary } = chart.scales;
      const current = chart.config.direction === "horizontal" ? secondary : primary;
      if (current.type === "band" && !props2.center) {
        const vals = current.map(chart.getData(chart.getKeys(0))).map((x2) => x2 + current.bandwidth() / 2);
        vals.pop();
        xLines.value = vals;
      } else {
        const ticks2 = current.ticks();
        xLines.value = current.map(ticks2);
      }
    }
    function updateYLines() {
      const { primary, secondary } = chart.scales;
      const current = chart.config.direction === "horizontal" ? primary : secondary;
      if (current.type === "band" && !props2.center) {
        const vals = current.map(chart.getData(chart.getKeys(0))).map((x2) => x2 + current.bandwidth() / 2);
        vals.pop();
        yLines.value = vals;
      } else {
        const ticks2 = current.ticks();
        yLines.value = current.map(ticks2);
      }
    }
    watch(chart.updates, () => {
      data2.value = chart.data;
      canvas.value = chart.canvas;
      updateXLines();
      updateYLines();
    });
    return { data: data2, canvas, xLines, yLines };
  }
});
const _hoisted_1$4$1 = ["stroke-dasharray"];
const _hoisted_2$3$1 = {
  key: 0,
  class: "grid-x"
};
const _hoisted_3$2$1 = ["x1", "y1", "x2", "y2"];
const _hoisted_4$2$1 = {
  key: 1,
  class: "grid-y"
};
const _hoisted_5$2$1 = ["x1", "y1", "x2", "y2"];
const _hoisted_6$2$1 = ["x1", "y1", "x2", "y2"];
const _hoisted_7$8 = ["x1", "y1", "x2", "y2"];
function render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.data.length ? (openBlock(), createElementBlock("g", {
    key: 0,
    class: "layer-grid",
    stroke: "black",
    "stroke-opacity": "0.15",
    "stroke-width": "1",
    "stroke-dasharray": _ctx.strokeDasharray
  }, [
    !_ctx.hideX ? (openBlock(), createElementBlock("g", _hoisted_2$3$1, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.xLines, (y2, i) => {
          return openBlock(), createElementBlock("line", {
            key: i,
            x1: _ctx.canvas.x,
            y1: y2,
            x2: _ctx.canvas.width,
            y2
          }, null, 8, _hoisted_3$2$1);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : createCommentVNode("v-if", true),
    !_ctx.hideY ? (openBlock(), createElementBlock("g", _hoisted_4$2$1, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList(_ctx.yLines, (x2, i) => {
          return openBlock(), createElementBlock("line", {
            key: i,
            x1: x2,
            y1: _ctx.canvas.y,
            x2,
            y2: _ctx.canvas.height
          }, null, 8, _hoisted_5$2$1);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : createCommentVNode("v-if", true),
    createElementVNode("g", null, [
      createElementVNode("line", {
        x1: _ctx.canvas.x,
        y1: _ctx.canvas.y,
        x2: _ctx.canvas.width,
        y2: _ctx.canvas.y
      }, null, 8, _hoisted_6$2$1),
      createElementVNode("line", {
        x1: _ctx.canvas.width - 1,
        y1: _ctx.canvas.y,
        x2: _ctx.canvas.width - 1,
        y2: _ctx.canvas.height
      }, null, 8, _hoisted_7$8)
    ])
  ], 8, _hoisted_1$4$1)) : createCommentVNode("v-if", true);
}
script$5.render = render$5;
script$5.__file = "src/components/Grid/index.vue";
var script$4 = defineComponent({
  name: "Tooltip",
  components: {},
  props: {
    format: {
      type: String,
      default: ",.0f"
    },
    color: {
      type: String,
      default: "#7876ec"
    },
    hideLine: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },
  setup(props2) {
    const el = ref(null);
    const chart = useChart();
    const canvas = ref(chart.canvas);
    const direction = ref(chart.config.direction);
    const { position, payload, show } = useTooltip();
    const isRight = computed(() => {
      return position.value.x >= canvas.value.width / 4 * 3;
    });
    const style = computed(() => {
      if (direction.value === "vertical") {
        return {
          top: position.value.y - 0.5 + "px",
          left: canvas.value.x + "px"
        };
      } else if (direction.value === "horizontal") {
        return {
          top: canvas.value.y + "px",
          left: position.value.x - 0.5 + "px"
        };
      } else {
        return {
          top: canvas.value.y + "px",
          left: canvas.value.x + "px"
        };
      }
    });
    const styleContent = computed(() => {
      if (direction.value === "vertical") {
        return {
          top: "5px",
          left: position.value.x - 30 + "px"
        };
      } else if (direction.value === "horizontal") {
        return {
          top: position.value.y + "px",
          transform: `translateX(${isRight.value ? "-100%" : 0})`
        };
      } else {
        return {
          top: position.value.y + "px",
          left: position.value.x + "px"
        };
      }
    });
    const formatValue = (val, formatter) => {
      return is$1(Function, formatter) ? formatter(val) : is$1(Number, val) ? format$1(formatter)(val) : val;
    };
    const items = computed(() => {
      return Object.keys(omit$1(["idx"], payload.value)).map((key) => {
        const config = Object.assign({ label: key, format: props2.format, color: props2.color, hide: false }, props2.config[key]);
        return {
          key,
          label: config.label,
          value: payload.value[key],
          valueFormatted: formatValue(payload.value[key], config.format),
          color: is$1(Function, config.color) ? config.color(payload.value) : config.color,
          hide: config.hide
        };
      }).filter((i) => !i.hide);
    });
    watch(chart.updates, () => {
      direction.value = chart.config.direction;
      canvas.value = chart.canvas;
    });
    return { el, show, canvas, direction, style, styleContent, position, items, isRight };
  }
});
const _hoisted_1$3$1 = { key: 0 };
function render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.show ? (openBlock(), createElementBlock(
    "div",
    {
      key: 0,
      class: "v-tooltip",
      style: normalizeStyle(_ctx.style)
    },
    [
      createElementVNode(
        "div",
        {
          class: "v-tooltip-content",
          style: normalizeStyle(_ctx.styleContent),
          ref: "el"
        },
        [
          renderSlot(_ctx.$slots, "default", { payload: _ctx.items }, () => [
            createElementVNode(
              "div",
              {
                style: normalizeStyle({ borderColor: _ctx.color })
              },
              [
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList(_ctx.items, (item, i) => {
                    return openBlock(), createElementBlock(
                      "div",
                      {
                        key: i,
                        style: normalizeStyle({ color: item.color })
                      },
                      [
                        createElementVNode(
                          "b",
                          null,
                          toDisplayString(item.label),
                          1
                          /* TEXT */
                        ),
                        createTextVNode(
                          ": " + toDisplayString(item.valueFormatted),
                          1
                          /* TEXT */
                        )
                      ],
                      4
                      /* STYLE */
                    );
                  }),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              4
              /* STYLE */
            )
          ])
        ],
        4
        /* STYLE */
      ),
      !_ctx.hideLine ? (openBlock(), createElementBlock("div", _hoisted_1$3$1, [
        _ctx.direction === "horizontal" ? (openBlock(), createElementBlock(
          "div",
          {
            key: 0,
            class: "v-tooltip-line-vertical",
            style: normalizeStyle({
              height: _ctx.canvas.height + "px"
            })
          },
          null,
          4
          /* STYLE */
        )) : (openBlock(), createElementBlock(
          "div",
          {
            key: 1,
            class: "v-tooltip-line-horizontal",
            style: normalizeStyle({
              width: _ctx.canvas.width - 40 + "px"
            })
          },
          null,
          4
          /* STYLE */
        ))
      ])) : createCommentVNode("v-if", true)
    ],
    4
    /* STYLE */
  )) : createCommentVNode("v-if", true);
}
var css_248z = "\n.v-tooltip[data-v-43da20c6] {\n  position: absolute;\n  pointer-events: none;\n}\n.v-tooltip-content[data-v-43da20c6] {\n  position: absolute;\n  white-space: nowrap;\n  pointer-events: none;\n}\n.v-tooltip-content > div[data-v-43da20c6] {\n  margin-left: 5px;\n  margin-right: 5px;\n  border: 2px solid;\n  background-color: white;\n  padding: 8px;\n  text-align: left;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);\n}\n.v-tooltip-right[data-v-43da20c6] {\n  transform: translateX(-100%);\n  margin-left: 0;\n}\n.v-tooltip-line-vertical[data-v-43da20c6] {\n  top: 0px;\n  position: absolute;\n  width: 1px;\n  background-color: black;\n  pointer-events: none;\n  opacity: 0.3;\n}\n.v-tooltip-line-horizontal[data-v-43da20c6] {\n  left: 0px;\n  position: absolute;\n  height: 1px;\n  background-color: black;\n  pointer-events: none;\n  opacity: 0.3;\n}\n";
styleInject(css_248z);
script$4.render = render$4;
script$4.__scopeId = "data-v-43da20c6";
script$4.__file = "src/components/Tooltip/index.vue";
var script$3 = defineComponent({
  props: {
    stacked: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: -1
    }
  },
  setup(props2) {
    provide("layerProps", props2);
  }
});
function render$3(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
script$3.render = render$3;
script$3.__file = "src/components/Group/index.vue";
var script$2 = defineComponent({
  name: "Grid",
  props: {
    value: {
      type: Number
    },
    label: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: "red"
    },
    strokeDasharray: {
      type: String,
      default: () => "3"
    },
    strokeWidth: {
      type: Number,
      default: 1
    },
    strokeOpacity: {
      type: Number,
      default: 0.5
    }
  },
  setup(props2) {
    const chart = useChart();
    const y2 = ref(0);
    const direction = ref("horizontal");
    const canvas = ref({});
    watch(chart.updates, () => {
      if (props2.value !== void 0) {
        y2.value = chart.scales.secondary.scale(props2.value);
      }
      canvas.value = chart.canvas;
      direction.value = chart.config.direction;
    }, { immediate: true });
    watch(() => props2.value, () => {
      y2.value = chart.scales.secondary.scale(props2.value);
    }, { immediate: true });
    return { y: y2, canvas, direction };
  }
});
const _hoisted_1$2$1 = {
  key: 0,
  class: "layer-marker"
};
const _hoisted_2$2$1 = ["x", "y", "fill"];
const _hoisted_3$1$1 = ["x1", "y1", "x2", "y2", "stroke", "stroke-opacity", "stroke-width", "stroke-dasharray"];
const _hoisted_4$1$1 = {
  key: 1,
  class: "layer-marker"
};
const _hoisted_5$1$1 = ["x", "y", "fill"];
const _hoisted_6$1$1 = ["x1", "y1", "x2", "y2", "stroke", "stroke-opacity", "stroke-width", "stroke-dasharray"];
function render$2(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.direction === "horizontal" ? (openBlock(), createElementBlock("g", _hoisted_1$2$1, [
    createElementVNode("text", {
      x: _ctx.canvas.x + 5,
      y: _ctx.y - 5,
      "text-anchor": "start",
      fill: _ctx.color
    }, toDisplayString(_ctx.label), 9, _hoisted_2$2$1),
    createElementVNode("line", {
      x1: _ctx.canvas.x,
      y1: _ctx.y,
      x2: _ctx.canvas.width,
      y2: _ctx.y,
      stroke: _ctx.color,
      "stroke-opacity": _ctx.strokeOpacity,
      "stroke-width": _ctx.strokeWidth,
      "stroke-dasharray": _ctx.strokeDasharray
    }, null, 8, _hoisted_3$1$1)
  ])) : (openBlock(), createElementBlock("g", _hoisted_4$1$1, [
    createElementVNode("text", {
      x: _ctx.y + 10,
      y: _ctx.canvas.y + 5,
      "text-anchor": "start",
      fill: _ctx.color,
      style: { "writing-mode": "tb" }
    }, toDisplayString(_ctx.label), 9, _hoisted_5$1$1),
    createElementVNode("line", {
      x1: _ctx.y,
      y1: _ctx.canvas.y,
      x2: _ctx.y,
      y2: _ctx.canvas.height,
      stroke: _ctx.color,
      "stroke-opacity": _ctx.strokeOpacity,
      "stroke-width": _ctx.strokeWidth,
      "stroke-dasharray": _ctx.strokeDasharray
    }, null, 8, _hoisted_6$1$1)
  ]));
}
script$2.render = render$2;
script$2.__file = "src/components/Marker/index.vue";
function count(node) {
  var sum = 0, children2 = node.children, i = children2 && children2.length;
  if (!i) sum = 1;
  else while (--i >= 0) sum += children2[i].value;
  node.value = sum;
}
function node_count() {
  return this.eachAfter(count);
}
function node_each(callback, that) {
  let index2 = -1;
  for (const node of this) {
    callback.call(that, node, ++index2, this);
  }
  return this;
}
function node_eachBefore(callback, that) {
  var node = this, nodes = [node], children2, i, index2 = -1;
  while (node = nodes.pop()) {
    callback.call(that, node, ++index2, this);
    if (children2 = node.children) {
      for (i = children2.length - 1; i >= 0; --i) {
        nodes.push(children2[i]);
      }
    }
  }
  return this;
}
function node_eachAfter(callback, that) {
  var node = this, nodes = [node], next = [], children2, i, n2, index2 = -1;
  while (node = nodes.pop()) {
    next.push(node);
    if (children2 = node.children) {
      for (i = 0, n2 = children2.length; i < n2; ++i) {
        nodes.push(children2[i]);
      }
    }
  }
  while (node = next.pop()) {
    callback.call(that, node, ++index2, this);
  }
  return this;
}
function node_find(callback, that) {
  let index2 = -1;
  for (const node of this) {
    if (callback.call(that, node, ++index2, this)) {
      return node;
    }
  }
}
function node_sum(value) {
  return this.eachAfter(function(node) {
    var sum = +value(node.data) || 0, children2 = node.children, i = children2 && children2.length;
    while (--i >= 0) sum += children2[i].value;
    node.value = sum;
  });
}
function node_sort(compare2) {
  return this.eachBefore(function(node) {
    if (node.children) {
      node.children.sort(compare2);
    }
  });
}
function node_path(end) {
  var start = this, ancestor = leastCommonAncestor(start, end), nodes = [start];
  while (start !== ancestor) {
    start = start.parent;
    nodes.push(start);
  }
  var k2 = nodes.length;
  while (end !== ancestor) {
    nodes.splice(k2, 0, end);
    end = end.parent;
  }
  return nodes;
}
function leastCommonAncestor(a, b2) {
  if (a === b2) return a;
  var aNodes = a.ancestors(), bNodes = b2.ancestors(), c2 = null;
  a = aNodes.pop();
  b2 = bNodes.pop();
  while (a === b2) {
    c2 = a;
    a = aNodes.pop();
    b2 = bNodes.pop();
  }
  return c2;
}
function node_ancestors() {
  var node = this, nodes = [node];
  while (node = node.parent) {
    nodes.push(node);
  }
  return nodes;
}
function node_descendants() {
  return Array.from(this);
}
function node_leaves() {
  var leaves = [];
  this.eachBefore(function(node) {
    if (!node.children) {
      leaves.push(node);
    }
  });
  return leaves;
}
function node_links() {
  var root2 = this, links = [];
  root2.each(function(node) {
    if (node !== root2) {
      links.push({ source: node.parent, target: node });
    }
  });
  return links;
}
function* node_iterator() {
  var node = this, current, next = [node], children2, i, n2;
  do {
    current = next.reverse(), next = [];
    while (node = current.pop()) {
      yield node;
      if (children2 = node.children) {
        for (i = 0, n2 = children2.length; i < n2; ++i) {
          next.push(children2[i]);
        }
      }
    }
  } while (next.length);
}
function hierarchy(data2, children2) {
  if (data2 instanceof Map) {
    data2 = [void 0, data2];
    if (children2 === void 0) children2 = mapChildren;
  } else if (children2 === void 0) {
    children2 = objectChildren;
  }
  var root2 = new Node$1(data2), node, nodes = [root2], child, childs, i, n2;
  while (node = nodes.pop()) {
    if ((childs = children2(node.data)) && (n2 = (childs = Array.from(childs)).length)) {
      node.children = childs;
      for (i = n2 - 1; i >= 0; --i) {
        nodes.push(child = childs[i] = new Node$1(childs[i]));
        child.parent = node;
        child.depth = node.depth + 1;
      }
    }
  }
  return root2.eachBefore(computeHeight);
}
function node_copy() {
  return hierarchy(this).eachBefore(copyData);
}
function objectChildren(d2) {
  return d2.children;
}
function mapChildren(d2) {
  return Array.isArray(d2) ? d2[1] : null;
}
function copyData(node) {
  if (node.data.value !== void 0) node.value = node.data.value;
  node.data = node.data.data;
}
function computeHeight(node) {
  var height = 0;
  do
    node.height = height;
  while ((node = node.parent) && node.height < ++height);
}
function Node$1(data2) {
  this.data = data2;
  this.depth = this.height = 0;
  this.parent = null;
}
Node$1.prototype = hierarchy.prototype = {
  constructor: Node$1,
  count: node_count,
  each: node_each,
  eachAfter: node_eachAfter,
  eachBefore: node_eachBefore,
  find: node_find,
  sum: node_sum,
  sort: node_sort,
  path: node_path,
  ancestors: node_ancestors,
  descendants: node_descendants,
  leaves: node_leaves,
  links: node_links,
  copy: node_copy,
  [Symbol.iterator]: node_iterator
};
function optional(f) {
  return f == null ? null : required(f);
}
function required(f) {
  if (typeof f !== "function") throw new Error();
  return f;
}
function constantZero() {
  return 0;
}
function constant(x2) {
  return function() {
    return x2;
  };
}
function roundNode(node) {
  node.x0 = Math.round(node.x0);
  node.y0 = Math.round(node.y0);
  node.x1 = Math.round(node.x1);
  node.y1 = Math.round(node.y1);
}
function treemapDice(parent, x0, y0, x1, y1) {
  var nodes = parent.children, node, i = -1, n2 = nodes.length, k2 = parent.value && (x1 - x0) / parent.value;
  while (++i < n2) {
    node = nodes[i], node.y0 = y0, node.y1 = y1;
    node.x0 = x0, node.x1 = x0 += node.value * k2;
  }
}
var preroot = { depth: -1 }, ambiguous = {}, imputed = {};
function defaultId(d2) {
  return d2.id;
}
function defaultParentId(d2) {
  return d2.parentId;
}
function stratify() {
  var id = defaultId, parentId = defaultParentId, path;
  function stratify2(data2) {
    var nodes = Array.from(data2), currentId = id, currentParentId = parentId, n2, d2, i, root2, parent, node, nodeId, nodeKey, nodeByKey = /* @__PURE__ */ new Map();
    if (path != null) {
      const I = nodes.map((d3, i2) => normalize(path(d3, i2, data2)));
      const P = I.map(parentof);
      const S2 = new Set(I).add("");
      for (const i2 of P) {
        if (!S2.has(i2)) {
          S2.add(i2);
          I.push(i2);
          P.push(parentof(i2));
          nodes.push(imputed);
        }
      }
      currentId = (_2, i2) => I[i2];
      currentParentId = (_2, i2) => P[i2];
    }
    for (i = 0, n2 = nodes.length; i < n2; ++i) {
      d2 = nodes[i], node = nodes[i] = new Node$1(d2);
      if ((nodeId = currentId(d2, i, data2)) != null && (nodeId += "")) {
        nodeKey = node.id = nodeId;
        nodeByKey.set(nodeKey, nodeByKey.has(nodeKey) ? ambiguous : node);
      }
      if ((nodeId = currentParentId(d2, i, data2)) != null && (nodeId += "")) {
        node.parent = nodeId;
      }
    }
    for (i = 0; i < n2; ++i) {
      node = nodes[i];
      if (nodeId = node.parent) {
        parent = nodeByKey.get(nodeId);
        if (!parent) throw new Error("missing: " + nodeId);
        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
        if (parent.children) parent.children.push(node);
        else parent.children = [node];
        node.parent = parent;
      } else {
        if (root2) throw new Error("multiple roots");
        root2 = node;
      }
    }
    if (!root2) throw new Error("no root");
    if (path != null) {
      while (root2.data === imputed && root2.children.length === 1) {
        root2 = root2.children[0], --n2;
      }
      for (let i2 = nodes.length - 1; i2 >= 0; --i2) {
        node = nodes[i2];
        if (node.data !== imputed) break;
        node.data = null;
      }
    }
    root2.parent = preroot;
    root2.eachBefore(function(node2) {
      node2.depth = node2.parent.depth + 1;
      --n2;
    }).eachBefore(computeHeight);
    root2.parent = null;
    if (n2 > 0) throw new Error("cycle");
    return root2;
  }
  stratify2.id = function(x2) {
    return arguments.length ? (id = optional(x2), stratify2) : id;
  };
  stratify2.parentId = function(x2) {
    return arguments.length ? (parentId = optional(x2), stratify2) : parentId;
  };
  stratify2.path = function(x2) {
    return arguments.length ? (path = optional(x2), stratify2) : path;
  };
  return stratify2;
}
function normalize(path) {
  path = `${path}`;
  let i = path.length;
  if (slash(path, i - 1) && !slash(path, i - 2)) path = path.slice(0, -1);
  return path[0] === "/" ? path : `/${path}`;
}
function parentof(path) {
  let i = path.length;
  if (i < 2) return "";
  while (--i > 1) if (slash(path, i)) break;
  return path.slice(0, i);
}
function slash(path, i) {
  if (path[i] === "/") {
    let k2 = 0;
    while (i > 0 && path[--i] === "\\") ++k2;
    if ((k2 & 1) === 0) return true;
  }
  return false;
}
function treemapSlice(parent, x0, y0, x1, y1) {
  var nodes = parent.children, node, i = -1, n2 = nodes.length, k2 = parent.value && (y1 - y0) / parent.value;
  while (++i < n2) {
    node = nodes[i], node.x0 = x0, node.x1 = x1;
    node.y0 = y0, node.y1 = y0 += node.value * k2;
  }
}
var phi = (1 + Math.sqrt(5)) / 2;
function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
  var rows = [], nodes = parent.children, row, nodeValue, i0 = 0, i1 = 0, n2 = nodes.length, dx, dy, value = parent.value, sumValue, minValue, maxValue, newRatio, minRatio, alpha, beta;
  while (i0 < n2) {
    dx = x1 - x0, dy = y1 - y0;
    do
      sumValue = nodes[i1++].value;
    while (!sumValue && i1 < n2);
    minValue = maxValue = sumValue;
    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
    beta = sumValue * sumValue * alpha;
    minRatio = Math.max(maxValue / beta, beta / minValue);
    for (; i1 < n2; ++i1) {
      sumValue += nodeValue = nodes[i1].value;
      if (nodeValue < minValue) minValue = nodeValue;
      if (nodeValue > maxValue) maxValue = nodeValue;
      beta = sumValue * sumValue * alpha;
      newRatio = Math.max(maxValue / beta, beta / minValue);
      if (newRatio > minRatio) {
        sumValue -= nodeValue;
        break;
      }
      minRatio = newRatio;
    }
    rows.push(row = { value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1) });
    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
    value -= sumValue, i0 = i1;
  }
  return rows;
}
var squarify = function custom(ratio) {
  function squarify2(parent, x0, y0, x1, y1) {
    squarifyRatio(ratio, parent, x0, y0, x1, y1);
  }
  squarify2.ratio = function(x2) {
    return custom((x2 = +x2) > 1 ? x2 : 1);
  };
  return squarify2;
}(phi);
function treemap() {
  var tile = squarify, round2 = false, dx = 1, dy = 1, paddingStack = [0], paddingInner = constantZero, paddingTop = constantZero, paddingRight = constantZero, paddingBottom = constantZero, paddingLeft = constantZero;
  function treemap2(root2) {
    root2.x0 = root2.y0 = 0;
    root2.x1 = dx;
    root2.y1 = dy;
    root2.eachBefore(positionNode);
    paddingStack = [0];
    if (round2) root2.eachBefore(roundNode);
    return root2;
  }
  function positionNode(node) {
    var p = paddingStack[node.depth], x0 = node.x0 + p, y0 = node.y0 + p, x1 = node.x1 - p, y1 = node.y1 - p;
    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
    node.x0 = x0;
    node.y0 = y0;
    node.x1 = x1;
    node.y1 = y1;
    if (node.children) {
      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
      x0 += paddingLeft(node) - p;
      y0 += paddingTop(node) - p;
      x1 -= paddingRight(node) - p;
      y1 -= paddingBottom(node) - p;
      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
      tile(node, x0, y0, x1, y1);
    }
  }
  treemap2.round = function(x2) {
    return arguments.length ? (round2 = !!x2, treemap2) : round2;
  };
  treemap2.size = function(x2) {
    return arguments.length ? (dx = +x2[0], dy = +x2[1], treemap2) : [dx, dy];
  };
  treemap2.tile = function(x2) {
    return arguments.length ? (tile = required(x2), treemap2) : tile;
  };
  treemap2.padding = function(x2) {
    return arguments.length ? treemap2.paddingInner(x2).paddingOuter(x2) : treemap2.paddingInner();
  };
  treemap2.paddingInner = function(x2) {
    return arguments.length ? (paddingInner = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingInner;
  };
  treemap2.paddingOuter = function(x2) {
    return arguments.length ? treemap2.paddingTop(x2).paddingRight(x2).paddingBottom(x2).paddingLeft(x2) : treemap2.paddingTop();
  };
  treemap2.paddingTop = function(x2) {
    return arguments.length ? (paddingTop = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingTop;
  };
  treemap2.paddingRight = function(x2) {
    return arguments.length ? (paddingRight = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingRight;
  };
  treemap2.paddingBottom = function(x2) {
    return arguments.length ? (paddingBottom = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingBottom;
  };
  treemap2.paddingLeft = function(x2) {
    return arguments.length ? (paddingLeft = typeof x2 === "function" ? x2 : constant(+x2), treemap2) : paddingLeft;
  };
  return treemap2;
}
var script$1 = defineComponent({
  name: "Treemap",
  props: {
    size: {
      type: Object,
      default: () => ({ width: 500, height: 400 }),
      required: false
    },
    margin: {
      type: Object,
      default: () => ({ top: 0, right: 0, bottom: 0, left: 0 })
    },
    padding: {
      type: Number,
      default: 8
    },
    data: {
      type: Array,
      default: () => []
    },
    dataKeys: {
      type: Object,
      required: true
    },
    colorFn: {
      type: Function,
      default: () => interpolateHcl("#60c96e", "#6b46c1")
    },
    rcStyle: {
      type: Function,
      required: false
    }
  },
  setup(props2) {
    const el = ref(null);
    const data2 = ref(props2.data);
    const selected = ref(null);
    const canvas = ref({
      x: props2.margin.left,
      y: props2.margin.top,
      width: props2.size.width - props2.margin.right,
      height: props2.size.height - props2.margin.bottom
    });
    const rectangles = ref([]);
    function getScales() {
      const values3 = extent(data2.value.map((d2) => d2[props2.dataKeys[1]]));
      const x2 = linear().domain(values3).range([0, 100]).nice();
      const y2 = sequential().domain(values3).interpolator(props2.colorFn());
      return { x: x2, y: y2 };
    }
    function buildRectangles() {
      const { y: y2 } = getScales();
      const res = buildTree(data2.value).leaves().map((d2, idx) => {
        return {
          idx,
          x0: canvas.value.x + d2.x0,
          x1: canvas.value.x + d2.x1,
          y0: canvas.value.y + d2.y0,
          y1: canvas.value.y + d2.y1,
          width: d2.x1 - d2.x0,
          height: d2.y1 - d2.y0,
          data: d2.data,
          color: y2(d2.value)
          // props.color
        };
      });
      return res;
    }
    function buildTree(data3) {
      const { x: x2 } = getScales();
      const createTreeMap = treemap().size([canvas.value.width - canvas.value.x, canvas.value.height - canvas.value.y]).padding(props2.padding);
      const treeFn = stratify().id((d2) => d2.name).parentId((d2) => d2.parent);
      const tree = treeFn([{ name: "root" }].concat(data3.map((x3) => {
        return {
          name: x3[props2.dataKeys[0]],
          value: x3[props2.dataKeys[1]],
          parent: "root"
        };
      })));
      tree.sum((d2) => x2(d2.value));
      createTreeMap(tree);
      return tree;
    }
    const toKebabCase = (data3) => mapKeys(kebabize, data3);
    const getStyle = (r) => {
      const style = {
        stroke: r.color,
        strokeWidth: 5,
        fill: r.color,
        fillOpacity: 0.9
      };
      if (props2.rcStyle && typeof props2.rcStyle === "function") {
        return Object.assign(Object.assign({}, style), props2.rcStyle(r));
      }
      return style;
    };
    function onMouseOver(i) {
      selected.value = i;
    }
    function onMouseOut() {
      selected.value = null;
    }
    watch(props2, () => {
      data2.value = props2.data;
      canvas.value = {
        x: props2.margin.left,
        y: props2.margin.top,
        width: props2.size.width - props2.margin.right,
        height: props2.size.height - props2.margin.bottom
      };
      rectangles.value = buildRectangles();
    }, { immediate: true });
    return { el, rectangles, selected, getStyle, toKebabCase, onMouseOver, onMouseOut };
  }
});
const _hoisted_1$1$1 = {
  class: "treemap",
  style: { display: "flex", position: "relative" }
};
const _hoisted_2$1$1 = ["width", "height", "viewBox"];
const _hoisted_3$p = { class: "layer-rectangles" };
const _hoisted_4$h = ["transform", "onMouseover"];
const _hoisted_5$f = ["width", "height"];
const _hoisted_6$c = {
  x: 0 + 10,
  y: 0 + 20,
  "font-size": `15px`,
  fill: `white`,
  "font-weight": "bold"
};
function render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$1$1, [
    (openBlock(), createElementBlock("svg", {
      width: _ctx.size.width,
      height: _ctx.size.height,
      viewBox: `0 0 ${_ctx.size.width} ${_ctx.size.height}`,
      ref: "el"
    }, [
      createElementVNode("g", _hoisted_3$p, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList(_ctx.rectangles, (r, i) => {
            return openBlock(), createElementBlock("g", {
              class: normalizeClass(["rectangle", { selected: _ctx.selected === i }]),
              key: i,
              transform: `translate(${r.x0}, ${r.y0})`,
              onMouseover: () => _ctx.onMouseOver(i),
              onMouseleave: _cache[0] || (_cache[0] = (...args) => _ctx.onMouseOut && _ctx.onMouseOut(...args))
            }, [
              renderSlot(_ctx.$slots, "default", {
                r,
                selected: _ctx.selected === i
              }, () => [
                createElementVNode("rect", mergeProps(_ctx.toKebabCase(_ctx.getStyle(r)), {
                  x: 0,
                  y: 0,
                  width: r.width,
                  height: r.height
                }), null, 16, _hoisted_5$f),
                renderSlot(_ctx.$slots, "text", {
                  r,
                  selected: _ctx.selected === i
                }, () => [
                  createElementVNode(
                    "text",
                    _hoisted_6$c,
                    toDisplayString(r.data.name),
                    1
                    /* TEXT */
                  )
                ])
              ])
            ], 42, _hoisted_4$h);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ])
    ], 8, _hoisted_2$1$1)),
    renderSlot(_ctx.$slots, "widgets")
  ]);
}
script$1.render = render$1;
script$1.__file = "src/components/Treemap/index.vue";
var script = defineComponent({
  name: "HoverBar",
  props: {
    barStyle: {
      type: Object,
      default: () => ({ "fill-opacity": 0.05 })
    }
  },
  setup() {
    const chart = useChart();
    const mouse = useMouse();
    const bar = ref({ x: 0, y: 0, width: 0, height: 0 });
    const direction = ref("horizontal");
    const canvas = ref({ x: 0, y: 0, width: 0, height: 0 });
    watch(chart.updates, () => {
      canvas.value = chart.canvas;
      direction.value = chart.config.direction;
    }, { immediate: true });
    watch(mouse, () => {
      if (chart.bandScale) {
        const vals = chart.getData(chart.getKeys(0));
        const [x2] = chart.bandScale.map([vals[mouse.index]]);
        const width = chart.bandScale.bandwidth();
        if (x2) {
          if (chart.config.direction === "horizontal") {
            bar.value = {
              x: x2 - width / 2,
              y: 0,
              width,
              height: canvas.value.height
            };
          } else {
            bar.value = {
              x: 40,
              y: x2 - width / 2,
              width: canvas.value.width - 40,
              height: width
            };
          }
        }
      }
    });
    return { bar, canvas, direction, mouse };
  }
});
const _hoisted_1$L = {
  key: 0,
  class: "layer-hover-bar"
};
const _hoisted_2$x = ["x", "y", "width", "height"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _ctx.mouse.hover ? (openBlock(), createElementBlock("g", _hoisted_1$L, [
    createElementVNode("rect", mergeProps({ class: "hover-bar" }, _ctx.barStyle, {
      x: _ctx.bar.x,
      y: _ctx.bar.y,
      width: _ctx.bar.width > 0 ? _ctx.bar.width : 0,
      height: _ctx.bar.height > 0 ? _ctx.bar.height : 0
    }), null, 16, _hoisted_2$x)
  ])) : createCommentVNode("v-if", true);
}
script.render = render;
script.__file = "src/components/HoverBar/index.vue";
const BRAND_COLOR = "var(--bgl-primary)";
const _sfc_main$X = /* @__PURE__ */ defineComponent({
  __name: "Lineart",
  props: {
    data: { type: Array, required: true },
    locale: { type: String, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const data2 = computed(() => props2.locale === "he" ? [...props2.data].reverse() : props2.data);
    const meanValue = computed(() => {
      const sum = props2.data.reduce((acc, curr) => acc + +curr.total_value, 0);
      return sum / props2.data.length;
    });
    const axisConfig = computed(() => ({
      primary: {
        type: "band",
        rotate: true,
        ticks: 5,
        domain: ["dataMin", "dataMax"],
        tickValues: props2.data.length > 100 ? [""] : props2.data.map((d2) => d2.date)
      },
      secondary: {
        domain: ["dataMin", "dataMax * 1.05"],
        type: "linear",
        ticks: 8
      }
    }));
    const tooltipConfiguration = {
      date: { label: "תאריך" },
      total_value: {
        color: BRAND_COLOR,
        label: "סכום",
        format: (v) => `₪${v.toLocaleString() || ""}`
      },
      total_count: {
        label: "מספר התרומות",
        format: (v) => `${v.toLocaleString() || ""}`
      }
    };
    let chartSize = ref();
    const chartContainer = ref();
    const displayMarker = ref(true);
    const chartMargin = ref({
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    });
    function adjustChartSize() {
      chartSize.value = void 0;
      const el = chartContainer.value;
      if (!el) return;
      const { width, height } = el.getBoundingClientRect();
      chartSize.value = { width: width - 5, height: height - 10 };
    }
    function handleResize() {
      setTimeout(adjustChartSize, 300);
    }
    onMounted(() => {
      adjustChartSize();
      window.addEventListener("resize", handleResize);
    });
    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });
    function dotStyling(ctx) {
      return {
        r: ctx.active ? 5 : 1,
        fill: BRAND_COLOR
      };
    }
    const __returned__ = { props: props2, data: data2, meanValue, axisConfig, BRAND_COLOR, tooltipConfiguration, get chartSize() {
      return chartSize;
    }, set chartSize(v) {
      chartSize = v;
    }, chartContainer, displayMarker, chartMargin, adjustChartSize, handleResize, dotStyling, get Area() {
      return script$a;
    }, get Chart() {
      return script$c;
    }, get Grid() {
      return script$5;
    }, get Line() {
      return script$9;
    }, get Marker() {
      return script$2;
    }, get Tooltip() {
      return script$4;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$K = {
  ref: "chartContainer",
  class: "chart-line"
};
function _sfc_render$X(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    _hoisted_1$K,
    [
      $setup.chartSize ? (openBlock(), createBlock($setup["Chart"], {
        key: 0,
        size: $setup.chartSize,
        data: $setup.data,
        margin: $setup.chartMargin,
        axis: $setup.axisConfig
      }, {
        layers: withCtx(() => [
          createVNode($setup["Grid"], {
            center: true,
            strokeDasharray: "2,2",
            hideY: true
          }),
          createVNode($setup["Area"], {
            "aria-label": "Profit/Loss",
            dataKeys: ["date", "total_value"],
            type: "monotone",
            areaStyle: { fill: "url(#grad)" }
          }),
          createVNode($setup["Line"], {
            dataKeys: ["date", "total_value"],
            type: "monotone",
            dotStyle: $setup.dotStyling,
            lineStyle: { stroke: $setup.BRAND_COLOR, r: 2 }
          }, null, 8, ["lineStyle"]),
          $setup.displayMarker ? (openBlock(), createBlock($setup["Marker"], {
            key: 0,
            value: $setup.meanValue,
            label: "ממוצע",
            color: $setup.BRAND_COLOR,
            strokeWidth: 2,
            strokeDasharray: "6 6"
          }, null, 8, ["value"])) : createCommentVNode("v-if", true),
          createElementVNode("defs", null, [
            createElementVNode("linearGradient", {
              id: "grad",
              gradientTransform: "rotate(90)"
            }, [
              createElementVNode("stop", {
                offset: "0%",
                "stop-color": $setup.BRAND_COLOR,
                "stop-opacity": "1"
              }),
              _cache[0] || (_cache[0] = createElementVNode(
                "stop",
                {
                  offset: "100%",
                  "stop-color": "white",
                  "stop-opacity": "0.4"
                },
                null,
                -1
                /* HOISTED */
              ))
            ])
          ])
        ]),
        widgets: withCtx(() => [
          createVNode($setup["Tooltip"], {
            color: "white",
            config: $setup.tooltipConfiguration
          })
        ]),
        _: 1
        /* STABLE */
      }, 8, ["size", "data", "margin", "axis"])) : createCommentVNode("v-if", true)
    ],
    512
    /* NEED_PATCH */
  );
}
const Lineart = /* @__PURE__ */ _export_sfc(_sfc_main$X, [["render", _sfc_render$X], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/dashboard/Lineart.vue"]]);
const _sfc_main$W = /* @__PURE__ */ defineComponent({
  __name: "DataPreview",
  props: /* @__PURE__ */ mergeModels({
    showFields: { type: Array, required: false },
    schema: { type: null, required: false },
    title: { type: String, required: false },
    excludeUnset: { type: Boolean, required: false }
  }, {
    "data": { type: Object, ...{ default: {} } },
    "dataModifiers": {}
  }),
  emits: ["update:data"],
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const itemData = useModel(__props, "data");
    function dataTransform(dataValue) {
      if (!dataValue) return dataValue;
      if (Array.isArray(dataValue)) return dataValue.map(dataTransform);
      if (typeof dataValue === "object") {
        Object.keys(dataValue).forEach((key) => {
          dataValue[key] = dataTransform(dataValue[key]);
        });
      }
      if (isDate(dataValue)) {
        const date2 = new Date(dataValue);
        return date2.toDateString();
      }
      return dataValue;
    }
    function isUnset(value) {
      if (!props2.excludeUnset) return false;
      return value === void 0 || value === null || value === "" || value.length === 0;
    }
    const computedSchema = computed(() => getFallbackSchema([itemData.value], props2.showFields));
    const __returned__ = { props: props2, itemData, dataTransform, isUnset, computedSchema, get BglField() {
      return BglField;
    }, get Title() {
      return Title;
    }, get iffer() {
      return iffer;
    }, get keyToLabel() {
      return keyToLabel;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$J = {
  key: 0,
  class: "data"
};
const _hoisted_2$w = {
  key: 0,
  class: "data-row m_py-05"
};
const _hoisted_3$o = { class: "key" };
const _hoisted_4$g = { class: "m-0" };
const _hoisted_5$e = { key: 1 };
const _hoisted_6$b = {
  key: 0,
  class: "data-row"
};
const _hoisted_7$7 = { class: "key" };
const _hoisted_8$5 = { class: "m-0" };
const _hoisted_9$4 = {
  key: 0,
  class: "m-0"
};
function _sfc_render$W(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2;
  return $props.data ? (openBlock(), createElementBlock("div", _hoisted_1$J, [
    $props.title ? (openBlock(), createBlock($setup["Title"], {
      key: 0,
      label: $props.title
    }, null, 8, ["label"])) : createCommentVNode("v-if", true),
    (openBlock(true), createElementBlock(
      Fragment,
      null,
      renderList($props.schema, (field) => {
        return openBlock(), createElementBlock(
          Fragment,
          {
            key: field.id
          },
          [
            $setup.iffer(field, $setup.itemData) ? (openBlock(), createElementBlock("div", _hoisted_2$w, [
              createElementVNode("div", _hoisted_3$o, [
                createElementVNode(
                  "p",
                  _hoisted_4$g,
                  toDisplayString((field == null ? void 0 : field.label) || $setup.keyToLabel(field.id)),
                  1
                  /* TEXT */
                )
              ]),
              createVNode($setup["BglField"], {
                modelValue: $setup.itemData,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.itemData = $event),
                label: "",
                style: { "width": "min-content", "min-width": "140px" },
                field
              }, null, 8, ["modelValue", "field"])
            ])) : createCommentVNode("v-if", true)
          ],
          64
          /* STABLE_FRAGMENT */
        );
      }),
      128
      /* KEYED_FRAGMENT */
    )),
    !((_a2 = $props.schema) == null ? void 0 : _a2.length) ? (openBlock(), createElementBlock("div", _hoisted_5$e, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($setup.computedSchema, ({ id, label }) => {
          return openBlock(), createElementBlock(
            Fragment,
            { key: id },
            [
              !$setup.isUnset($setup.itemData[id]) ? (openBlock(), createElementBlock("div", _hoisted_6$b, [
                createElementVNode("div", _hoisted_7$7, [
                  createElementVNode(
                    "p",
                    _hoisted_8$5,
                    toDisplayString(label),
                    1
                    /* TEXT */
                  )
                ]),
                createElementVNode("div", null, [
                  id ? (openBlock(), createElementBlock(
                    "p",
                    _hoisted_9$4,
                    toDisplayString($setup.dataTransform($setup.itemData[id])),
                    1
                    /* TEXT */
                  )) : createCommentVNode("v-if", true)
                ])
              ])) : createCommentVNode("v-if", true)
            ],
            64
            /* STABLE_FRAGMENT */
          );
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : createCommentVNode("v-if", true),
    renderSlot(_ctx.$slots, "footer", {}, void 0, true)
  ])) : createCommentVNode("v-if", true);
}
const DataPreview = /* @__PURE__ */ _export_sfc(_sfc_main$W, [["render", _sfc_render$W], ["__scopeId", "data-v-da250939"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/DataPreview.vue"]]);
const sides = ["top", "right", "bottom", "left"];
const alignments = ["start", "end"];
const placements = /* @__PURE__ */ sides.reduce((acc, side) => acc.concat(side, side + "-" + alignments[0], side + "-" + alignments[1]), []);
const min$1 = Math.min;
const max$1 = Math.max;
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max$1(start, min$1(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis2) {
  return axis2 === "x" ? "y" : "x";
}
function getAxisLength(axis2) {
  return axis2 === "y" ? "height" : "width";
}
function getSideAxis(placement) {
  return ["top", "bottom"].includes(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
function getSideList(side, isStart, rtl) {
  const lr2 = ["left", "right"];
  const rl = ["right", "left"];
  const tb = ["top", "bottom"];
  const bt2 = ["bottom", "top"];
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rl : lr2;
      return isStart ? lr2 : rl;
    case "left":
    case "right":
      return isStart ? tb : bt2;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list = list.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list = list.concat(list.map(getOppositeAlignmentPlacement));
    }
  }
  return list;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y2,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y2,
    left: x2,
    right: x2 + width,
    bottom: y2 + height,
    x: x2,
    y: y2
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i = 0; i < validMiddleware.length; i++) {
    const {
      name,
      fn: fn2
    } = validMiddleware[i];
    const {
      x: nextX,
      y: nextY,
      data: data2,
      reset
    } = await fn2({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name]: {
        ...middlewareData[name],
        ...data2
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state2, options) {
  var _await$platform$isEle;
  if (options === void 0) {
    options = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements,
    strategy
  } = state2;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options, state2);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext === "floating" ? "reference" : "floating";
  const element = elements[altBoundary ? altContext : elementContext];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element))) != null ? _await$platform$isEle : true) ? element : element.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow = (options) => ({
  name: "arrow",
  options,
  async fn(state2) {
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2,
      elements,
      middlewareData
    } = state2;
    const {
      element,
      padding = 0
    } = evaluate(options, state2) || {};
    if (element == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x2,
      y: y2
    };
    const axis2 = getAlignmentAxis(placement);
    const length = getAxisLength(axis2);
    const arrowDimensions = await platform2.getDimensions(element);
    const isYAxis = axis2 === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis2] - coords[axis2] - rects.floating[length];
    const startDiff = coords[axis2] - rects.reference[axis2];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min$1(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min$1(paddingObject[maxProp], largestPossiblePadding);
    const min$1$12 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center2 = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$1$12, center2, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center2 !== offset2 && rects.reference[length] / 2 - (center2 < min$1$12 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center2 < min$1$12 ? center2 - min$1$12 : center2 - max2 : 0;
    return {
      [axis2]: coords[axis2] + alignmentOffset,
      data: {
        [axis2]: offset2,
        centerOffset: center2 - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
function getPlacementList(alignment, autoAlignment, allowedPlacements) {
  const allowedPlacementsSortedByAlignment = alignment ? [...allowedPlacements.filter((placement) => getAlignment(placement) === alignment), ...allowedPlacements.filter((placement) => getAlignment(placement) !== alignment)] : allowedPlacements.filter((placement) => getSide(placement) === placement);
  return allowedPlacementsSortedByAlignment.filter((placement) => {
    if (alignment) {
      return getAlignment(placement) === alignment || (autoAlignment ? getOppositeAlignmentPlacement(placement) !== placement : false);
    }
    return true;
  });
}
const autoPlacement = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "autoPlacement",
    options,
    async fn(state2) {
      var _middlewareData$autoP, _middlewareData$autoP2, _placementsThatFitOnE;
      const {
        rects,
        middlewareData,
        placement,
        platform: platform2,
        elements
      } = state2;
      const {
        crossAxis = false,
        alignment,
        allowedPlacements = placements,
        autoAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state2);
      const placements$1 = alignment !== void 0 || allowedPlacements === placements ? getPlacementList(alignment || null, autoAlignment, allowedPlacements) : allowedPlacements;
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const currentIndex = ((_middlewareData$autoP = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP.index) || 0;
      const currentPlacement = placements$1[currentIndex];
      if (currentPlacement == null) {
        return {};
      }
      const alignmentSides = getAlignmentSides(currentPlacement, rects, await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)));
      if (placement !== currentPlacement) {
        return {
          reset: {
            placement: placements$1[0]
          }
        };
      }
      const currentOverflows = [overflow[getSide(currentPlacement)], overflow[alignmentSides[0]], overflow[alignmentSides[1]]];
      const allOverflows = [...((_middlewareData$autoP2 = middlewareData.autoPlacement) == null ? void 0 : _middlewareData$autoP2.overflows) || [], {
        placement: currentPlacement,
        overflows: currentOverflows
      }];
      const nextPlacement = placements$1[currentIndex + 1];
      if (nextPlacement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: nextPlacement
          }
        };
      }
      const placementsSortedByMostSpace = allOverflows.map((d2) => {
        const alignment2 = getAlignment(d2.placement);
        return [d2.placement, alignment2 && crossAxis ? (
          // Check along the mainAxis and main crossAxis side.
          d2.overflows.slice(0, 2).reduce((acc, v) => acc + v, 0)
        ) : (
          // Check only the mainAxis.
          d2.overflows[0]
        ), d2.overflows];
      }).sort((a, b2) => a[1] - b2[1]);
      const placementsThatFitOnEachSide = placementsSortedByMostSpace.filter((d2) => d2[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        getAlignment(d2[0]) ? 2 : 3
      ).every((v) => v <= 0));
      const resetPlacement = ((_placementsThatFitOnE = placementsThatFitOnEachSide[0]) == null ? void 0 : _placementsThatFitOnE[0]) || placementsSortedByMostSpace[0][0];
      if (resetPlacement !== placement) {
        return {
          data: {
            index: currentIndex + 1,
            overflows: allOverflows
          },
          reset: {
            placement: resetPlacement
          }
        };
      }
      return {};
    }
  };
};
const flip = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "flip",
    options,
    async fn(state2) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements
      } = state2;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options, state2);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements2 = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides2 = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides2[0]], overflow[sides2[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements2[nextIndex];
        if (nextPlacement) {
          return {
            data: {
              index: nextIndex,
              overflows: overflowsData
            },
            reset: {
              placement: nextPlacement
            }
          };
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a, b2) => a.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a, b2) => a[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
async function convertValueToCoords(state2, options) {
  const {
    placement,
    platform: platform2,
    elements
  } = state2;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = ["left", "top"].includes(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options, state2);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: 0,
    crossAxis: 0,
    alignmentAxis: null,
    ...rawValue
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset = function(options) {
  if (options === void 0) {
    options = 0;
  }
  return {
    name: "offset",
    options,
    async fn(state2) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state2;
      const diffCoords = await convertValueToCoords(state2, options);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "shift",
    options,
    async fn(state2) {
      const {
        x: x2,
        y: y2,
        placement
      } = state2;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y3
            } = _ref;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options, state2);
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state2,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2
        }
      };
    }
  };
};
const size = function(options) {
  if (options === void 0) {
    options = {};
  }
  return {
    name: "size",
    options,
    async fn(state2) {
      const {
        placement,
        rects,
        platform: platform2,
        elements
      } = state2;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options, state2);
      const overflow = await detectOverflow(state2, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min$1(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min$1(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state2.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if (isYAxis) {
        availableWidth = alignment || noShift ? min$1(overflowAvailableWidth, maximumClippingWidth) : maximumClippingWidth;
      } else {
        availableHeight = alignment || noShift ? min$1(overflowAvailableHeight, maximumClippingHeight) : maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max$1(overflow.left, 0);
        const xMax = max$1(overflow.right, 0);
        const yMin2 = max$1(overflow.top, 0);
        const yMax2 = max$1(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max$1(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin2 !== 0 || yMax2 !== 0 ? yMin2 + yMax2 : max$1(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state2,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function getWindow(node) {
  var _node$ownerDocument;
  return ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}
const min = Math.min;
const max = Math.max;
const round = Math.round;
function getCssDimensions(element) {
  const css2 = getComputedStyle$1(element);
  let width = parseFloat(css2.width);
  let height = parseFloat(css2.height);
  const offsetWidth = element.offsetWidth;
  const offsetHeight = element.offsetHeight;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    fallback: shouldFallback
  };
}
function getNodeName(node) {
  return isNode(node) ? (node.nodeName || "").toLowerCase() : "";
}
let uaString;
function getUAString() {
  if (uaString) {
    return uaString;
  }
  const uaData = navigator.userAgentData;
  if (uaData && Array.isArray(uaData.brands)) {
    uaString = uaData.brands.map((item) => item.brand + "/" + item.version).join(" ");
    return uaString;
  }
  return navigator.userAgent;
}
function isHTMLElement(value) {
  return value instanceof getWindow(value).HTMLElement;
}
function isElement(value) {
  return value instanceof getWindow(value).Element;
}
function isNode(value) {
  return value instanceof getWindow(value).Node;
}
function isShadowRoot(node) {
  if (typeof ShadowRoot === "undefined") {
    return false;
  }
  const OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}
function isOverflowElement(element) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !["inline", "contents"].includes(display);
}
function isTableElement(element) {
  return ["table", "td", "th"].includes(getNodeName(element));
}
function isContainingBlock(element) {
  const isFirefox = /firefox/i.test(getUAString());
  const css2 = getComputedStyle$1(element);
  const backdropFilter = css2.backdropFilter || css2.WebkitBackdropFilter;
  return css2.transform !== "none" || css2.perspective !== "none" || (backdropFilter ? backdropFilter !== "none" : false) || isFirefox && css2.willChange === "filter" || isFirefox && (css2.filter ? css2.filter !== "none" : false) || ["transform", "perspective"].some((value) => css2.willChange.includes(value)) || ["paint", "layout", "strict", "content"].some((value) => {
    const contain = css2.contain;
    return contain != null ? contain.includes(value) : false;
  });
}
function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}
function isLastTraversableNode(node) {
  return ["html", "body", "#document"].includes(getNodeName(node));
}
function unwrapElement(element) {
  return !isElement(element) ? element.contextElement : element;
}
const FALLBACK_SCALE = {
  x: 1,
  y: 1
};
function getScale(element) {
  const domElement = unwrapElement(element);
  if (!isHTMLElement(domElement)) {
    return FALLBACK_SCALE;
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    fallback
  } = getCssDimensions(domElement);
  let x2 = (fallback ? round(rect.width) : rect.width) / width;
  let y2 = (fallback ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
function getBoundingClientRect(element, includeScale, isFixedStrategy, offsetParent) {
  var _win$visualViewport, _win$visualViewport2;
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element.getBoundingClientRect();
  const domElement = unwrapElement(element);
  let scale = FALLBACK_SCALE;
  if (includeScale) {
    if (offsetParent) {
      if (isElement(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element);
    }
  }
  const win = domElement ? getWindow(domElement) : window;
  const addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  let x2 = (clientRect.left + (addVisualOffsets ? ((_win$visualViewport = win.visualViewport) == null ? void 0 : _win$visualViewport.offsetLeft) || 0 : 0)) / scale.x;
  let y2 = (clientRect.top + (addVisualOffsets ? ((_win$visualViewport2 = win.visualViewport) == null ? void 0 : _win$visualViewport2.offsetTop) || 0 : 0)) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win2 = getWindow(domElement);
    const offsetWin = offsetParent && isElement(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentIFrame = win2.frameElement;
    while (currentIFrame && offsetParent && offsetWin !== win2) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css2 = getComputedStyle(currentIFrame);
      iframeRect.x += (currentIFrame.clientLeft + parseFloat(css2.paddingLeft)) * iframeScale.x;
      iframeRect.y += (currentIFrame.clientTop + parseFloat(css2.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += iframeRect.x;
      y2 += iframeRect.y;
      currentIFrame = getWindow(currentIFrame).frameElement;
    }
  }
  return {
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: y2 + height,
    left: x2,
    x: x2,
    y: y2
  };
}
function getDocumentElement(node) {
  return ((isNode(node) ? node.ownerDocument : node.document) || window.document).documentElement;
}
function getNodeScroll(element) {
  if (isElement(element)) {
    return {
      scrollLeft: element.scrollLeft,
      scrollTop: element.scrollTop
    };
  }
  return {
    scrollLeft: element.pageXOffset,
    scrollTop: element.pageYOffset
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  if (offsetParent === documentElement) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = {
    x: 1,
    y: 1
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y
  };
}
function getWindowScrollBarX(element) {
  return getBoundingClientRect(getDocumentElement(element)).left + getNodeScroll(element).scrollLeft;
}
function getDocumentRect(element) {
  const html = getDocumentElement(element);
  const scroll = getNodeScroll(element);
  const body = element.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result2 = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result2) ? result2.host : result2;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return parentNode.ownerDocument.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list) {
  var _node$ownerDocument;
  if (list === void 0) {
    list = [];
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    return list.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : []);
  }
  return list.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor));
}
function getViewportRect(element, strategy) {
  const win = getWindow(element);
  const html = getDocumentElement(element);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const layoutViewport = isLayoutViewport();
    if (layoutViewport || !layoutViewport && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getInnerBoundingClientRect(element, strategy) {
  const clientRect = getBoundingClientRect(element, true, strategy === "fixed");
  const top2 = clientRect.top + element.clientTop;
  const left2 = clientRect.left + element.clientLeft;
  const scale = isHTMLElement(element) ? getScale(element) : {
    x: 1,
    y: 1
  };
  const width = element.clientWidth * scale.x;
  const height = element.clientHeight * scale.y;
  const x2 = left2 * scale.x;
  const y2 = top2 * scale.y;
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element, clippingAncestor, strategy) {
  if (clippingAncestor === "viewport") {
    return rectToClientRect(getViewportRect(element, strategy));
  }
  if (isElement(clippingAncestor)) {
    return rectToClientRect(getInnerBoundingClientRect(clippingAncestor, strategy));
  }
  return rectToClientRect(getDocumentRect(getDocumentElement(element)));
}
function getClippingElementAncestors(element, cache) {
  const cachedResult = cache.get(element);
  if (cachedResult) {
    return cachedResult;
  }
  let result2 = getOverflowAncestors(element).filter((el) => isElement(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element) : element;
  while (isElement(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const containingBlock = isContainingBlock(currentNode);
    const shouldDropCurrentNode = elementIsFixed ? !containingBlock && !currentContainingBlockComputedStyle : !containingBlock && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && ["absolute", "fixed"].includes(currentContainingBlockComputedStyle.position);
    if (shouldDropCurrentNode) {
      result2 = result2.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element, result2);
  return result2;
}
function getClippingRect(_ref) {
  let {
    element,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? getClippingElementAncestors(element, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element) {
  if (isHTMLElement(element)) {
    return getCssDimensions(element);
  }
  return element.getBoundingClientRect();
}
function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || getComputedStyle$1(element).position === "fixed") {
    return null;
  }
  return element.offsetParent;
}
function getContainingBlock(element) {
  let currentNode = getParentNode(element);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else {
      currentNode = getParentNode(currentNode);
    }
  }
  return null;
}
function getOffsetParent(element) {
  const window2 = getWindow(element);
  let offsetParent = getTrueOffsetParent(element);
  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === "static") {
    offsetParent = getTrueOffsetParent(offsetParent);
  }
  if (offsetParent && (getNodeName(offsetParent) === "html" || getNodeName(offsetParent) === "body" && getComputedStyle$1(offsetParent).position === "static" && !isContainingBlock(offsetParent))) {
    return window2;
  }
  return offsetParent || getContainingBlock(element) || window2;
}
function getRectRelativeToOffsetParent(element, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const rect = getBoundingClientRect(element, true, strategy === "fixed", offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = {
    x: 0,
    y: 0
  };
  if (isOffsetParentAnElement || !isOffsetParentAnElement && strategy !== "fixed") {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent, true);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }
  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}
const platform$2 = {
  getClippingRect,
  convertOffsetParentRelativeRectToViewportRelativeRect,
  isElement,
  getDimensions,
  getOffsetParent,
  getDocumentElement,
  getScale,
  async getElementRects(_ref) {
    let {
      reference,
      floating,
      strategy
    } = _ref;
    const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
    const getDimensionsFn = this.getDimensions;
    return {
      reference: getRectRelativeToOffsetParent(reference, await getOffsetParentFn(floating), strategy),
      floating: {
        x: 0,
        y: 0,
        ...await getDimensionsFn(floating)
      }
    };
  },
  getClientRects: (element) => Array.from(element.getClientRects()),
  isRTL: (element) => getComputedStyle$1(element).direction === "rtl"
};
const computePosition = (reference, floating, options) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform: platform$2,
    ...options
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
function ye(e, t) {
  for (const o in t)
    Object.prototype.hasOwnProperty.call(t, o) && (typeof t[o] == "object" && e[o] ? ye(e[o], t[o]) : e[o] = t[o]);
}
const h = {
  // Disable popper components
  disabled: false,
  // Default position offset along main axis (px)
  distance: 5,
  // Default position offset along cross axis (px)
  skidding: 0,
  // Default container where the tooltip will be appended
  container: "body",
  // Element used to compute position and size boundaries
  boundary: void 0,
  // Skip delay & CSS transitions when another popper is shown, so that the popper appear to instanly move to the new position.
  instantMove: false,
  // Auto destroy tooltip DOM nodes (ms)
  disposeTimeout: 150,
  // Triggers on the popper itself
  popperTriggers: [],
  // Positioning strategy
  strategy: "absolute",
  // Prevent overflow
  preventOverflow: true,
  // Flip to the opposite placement if needed
  flip: true,
  // Shift on the cross axis to prevent the popper from overflowing
  shift: true,
  // Overflow padding (px)
  overflowPadding: 0,
  // Arrow padding (px)
  arrowPadding: 0,
  // Compute arrow overflow (useful to hide it)
  arrowOverflow: true,
  /**
   * By default, compute autohide on 'click'.
   */
  autoHideOnMousedown: false,
  // Themes
  themes: {
    tooltip: {
      // Default tooltip placement relative to target element
      placement: "top",
      // Default events that trigger the tooltip
      triggers: ["hover", "focus", "touch"],
      // Close tooltip on click on tooltip target
      hideTriggers: (e) => [...e, "click"],
      // Delay (ms)
      delay: {
        show: 200,
        hide: 0
      },
      // Update popper on content resize
      handleResize: false,
      // Enable HTML content in directive
      html: false,
      // Displayed when tooltip content is loading
      loadingContent: "..."
    },
    dropdown: {
      // Default dropdown placement relative to target element
      placement: "bottom",
      // Default events that trigger the dropdown
      triggers: ["click"],
      // Delay (ms)
      delay: 0,
      // Update popper on content resize
      handleResize: true,
      // Hide on clock outside
      autoHide: true
    },
    menu: {
      $extend: "dropdown",
      triggers: ["hover", "focus"],
      popperTriggers: ["hover"],
      delay: {
        show: 0,
        hide: 400
      }
    }
  }
};
function S(e, t) {
  let o = h.themes[e] || {}, i;
  do
    i = o[t], typeof i > "u" ? o.$extend ? o = h.themes[o.$extend] || {} : (o = null, i = h[t]) : o = null;
  while (o);
  return i;
}
function Ze$1(e) {
  const t = [e];
  let o = h.themes[e] || {};
  do
    o.$extend && !o.$resetCss ? (t.push(o.$extend), o = h.themes[o.$extend] || {}) : o = null;
  while (o);
  return t.map((i) => `v-popper--theme-${i}`);
}
function re(e) {
  const t = [e];
  let o = h.themes[e] || {};
  do
    o.$extend ? (t.push(o.$extend), o = h.themes[o.$extend] || {}) : o = null;
  while (o);
  return t;
}
let $ = false;
if (typeof window < "u") {
  $ = false;
  try {
    const e = Object.defineProperty({}, "passive", {
      get() {
        $ = true;
      }
    });
    window.addEventListener("test", null, e);
  } catch {
  }
}
let _e$1 = false;
typeof window < "u" && typeof navigator < "u" && (_e$1 = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
const Te = ["auto", "top", "bottom", "left", "right"].reduce((e, t) => e.concat([
  t,
  `${t}-start`,
  `${t}-end`
]), []), pe = {
  hover: "mouseenter",
  focus: "focus",
  click: "click",
  touch: "touchstart",
  pointer: "pointerdown"
}, ae = {
  hover: "mouseleave",
  focus: "blur",
  click: "click",
  touch: "touchend",
  pointer: "pointerup"
};
function de(e, t) {
  const o = e.indexOf(t);
  o !== -1 && e.splice(o, 1);
}
function G() {
  return new Promise((e) => requestAnimationFrame(() => {
    requestAnimationFrame(e);
  }));
}
const d = [];
let g = null;
const le = {};
function he(e) {
  let t = le[e];
  return t || (t = le[e] = []), t;
}
let Y = function() {
};
typeof window < "u" && (Y = window.Element);
function n(e) {
  return function(t) {
    return S(t.theme, e);
  };
}
const q = "__floating-vue__popper", Q = () => defineComponent({
  name: "VPopper",
  provide() {
    return {
      [q]: {
        parentPopper: this
      }
    };
  },
  inject: {
    [q]: { default: null }
  },
  props: {
    theme: {
      type: String,
      required: true
    },
    targetNodes: {
      type: Function,
      required: true
    },
    referenceNode: {
      type: Function,
      default: null
    },
    popperNode: {
      type: Function,
      required: true
    },
    shown: {
      type: Boolean,
      default: false
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: n("disabled")
    },
    positioningDisabled: {
      type: Boolean,
      default: n("positioningDisabled")
    },
    placement: {
      type: String,
      default: n("placement"),
      validator: (e) => Te.includes(e)
    },
    delay: {
      type: [String, Number, Object],
      default: n("delay")
    },
    distance: {
      type: [Number, String],
      default: n("distance")
    },
    skidding: {
      type: [Number, String],
      default: n("skidding")
    },
    triggers: {
      type: Array,
      default: n("triggers")
    },
    showTriggers: {
      type: [Array, Function],
      default: n("showTriggers")
    },
    hideTriggers: {
      type: [Array, Function],
      default: n("hideTriggers")
    },
    popperTriggers: {
      type: Array,
      default: n("popperTriggers")
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: n("popperShowTriggers")
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: n("popperHideTriggers")
    },
    container: {
      type: [String, Object, Y, Boolean],
      default: n("container")
    },
    boundary: {
      type: [String, Y],
      default: n("boundary")
    },
    strategy: {
      type: String,
      validator: (e) => ["absolute", "fixed"].includes(e),
      default: n("strategy")
    },
    autoHide: {
      type: [Boolean, Function],
      default: n("autoHide")
    },
    handleResize: {
      type: Boolean,
      default: n("handleResize")
    },
    instantMove: {
      type: Boolean,
      default: n("instantMove")
    },
    eagerMount: {
      type: Boolean,
      default: n("eagerMount")
    },
    popperClass: {
      type: [String, Array, Object],
      default: n("popperClass")
    },
    computeTransformOrigin: {
      type: Boolean,
      default: n("computeTransformOrigin")
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: n("autoMinSize")
    },
    autoSize: {
      type: [Boolean, String],
      default: n("autoSize")
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: n("autoMaxSize")
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: n("autoBoundaryMaxSize")
    },
    preventOverflow: {
      type: Boolean,
      default: n("preventOverflow")
    },
    overflowPadding: {
      type: [Number, String],
      default: n("overflowPadding")
    },
    arrowPadding: {
      type: [Number, String],
      default: n("arrowPadding")
    },
    arrowOverflow: {
      type: Boolean,
      default: n("arrowOverflow")
    },
    flip: {
      type: Boolean,
      default: n("flip")
    },
    shift: {
      type: Boolean,
      default: n("shift")
    },
    shiftCrossAxis: {
      type: Boolean,
      default: n("shiftCrossAxis")
    },
    noAutoFocus: {
      type: Boolean,
      default: n("noAutoFocus")
    },
    disposeTimeout: {
      type: Number,
      default: n("disposeTimeout")
    }
  },
  emits: {
    show: () => true,
    hide: () => true,
    "update:shown": (e) => true,
    "apply-show": () => true,
    "apply-hide": () => true,
    "close-group": () => true,
    "close-directive": () => true,
    "auto-hide": () => true,
    resize: () => true
  },
  data() {
    return {
      isShown: false,
      isMounted: false,
      skipTransition: false,
      classes: {
        showFrom: false,
        showTo: false,
        hideFrom: false,
        hideTo: true
      },
      result: {
        x: 0,
        y: 0,
        placement: "",
        strategy: this.strategy,
        arrow: {
          x: 0,
          y: 0,
          centerOffset: 0
        },
        transformOrigin: null
      },
      randomId: `popper_${[Math.random(), Date.now()].map((e) => e.toString(36).substring(2, 10)).join("_")}`,
      shownChildren: /* @__PURE__ */ new Set(),
      lastAutoHide: true,
      pendingHide: false,
      containsGlobalTarget: false,
      isDisposed: true,
      mouseDownContains: false
    };
  },
  computed: {
    popperId() {
      return this.ariaId != null ? this.ariaId : this.randomId;
    },
    shouldMountContent() {
      return this.eagerMount || this.isMounted;
    },
    slotData() {
      return {
        popperId: this.popperId,
        isShown: this.isShown,
        shouldMountContent: this.shouldMountContent,
        skipTransition: this.skipTransition,
        autoHide: typeof this.autoHide == "function" ? this.lastAutoHide : this.autoHide,
        show: this.show,
        hide: this.hide,
        handleResize: this.handleResize,
        onResize: this.onResize,
        classes: {
          ...this.classes,
          popperClass: this.popperClass
        },
        result: this.positioningDisabled ? null : this.result,
        attrs: this.$attrs
      };
    },
    parentPopper() {
      var e;
      return (e = this[q]) == null ? void 0 : e.parentPopper;
    },
    hasPopperShowTriggerHover() {
      var e, t;
      return ((e = this.popperTriggers) == null ? void 0 : e.includes("hover")) || ((t = this.popperShowTriggers) == null ? void 0 : t.includes("hover"));
    }
  },
  watch: {
    shown: "$_autoShowHide",
    disabled(e) {
      e ? this.dispose() : this.init();
    },
    async container() {
      this.isShown && (this.$_ensureTeleport(), await this.$_computePosition());
    },
    triggers: {
      handler: "$_refreshListeners",
      deep: true
    },
    positioningDisabled: "$_refreshListeners",
    ...[
      "placement",
      "distance",
      "skidding",
      "boundary",
      "strategy",
      "overflowPadding",
      "arrowPadding",
      "preventOverflow",
      "shift",
      "shiftCrossAxis",
      "flip"
    ].reduce((e, t) => (e[t] = "$_computePosition", e), {})
  },
  created() {
    this.autoMinSize && console.warn('[floating-vue] `autoMinSize` option is deprecated. Use `autoSize="min"` instead.'), this.autoMaxSize && console.warn("[floating-vue] `autoMaxSize` option is deprecated. Use `autoBoundaryMaxSize` instead.");
  },
  mounted() {
    this.init(), this.$_detachPopperNode();
  },
  activated() {
    this.$_autoShowHide();
  },
  deactivated() {
    this.hide();
  },
  beforeUnmount() {
    this.dispose();
  },
  methods: {
    show({ event: e = null, skipDelay: t = false, force: o = false } = {}) {
      var i, s;
      (i = this.parentPopper) != null && i.lockedChild && this.parentPopper.lockedChild !== this || (this.pendingHide = false, (o || !this.disabled) && (((s = this.parentPopper) == null ? void 0 : s.lockedChild) === this && (this.parentPopper.lockedChild = null), this.$_scheduleShow(e, t), this.$emit("show"), this.$_showFrameLocked = true, requestAnimationFrame(() => {
        this.$_showFrameLocked = false;
      })), this.$emit("update:shown", true));
    },
    hide({ event: e = null, skipDelay: t = false } = {}) {
      var o;
      if (!this.$_hideInProgress) {
        if (this.shownChildren.size > 0) {
          this.pendingHide = true;
          return;
        }
        if (this.hasPopperShowTriggerHover && this.$_isAimingPopper()) {
          this.parentPopper && (this.parentPopper.lockedChild = this, clearTimeout(this.parentPopper.lockedChildTimer), this.parentPopper.lockedChildTimer = setTimeout(() => {
            this.parentPopper.lockedChild === this && (this.parentPopper.lockedChild.hide({ skipDelay: t }), this.parentPopper.lockedChild = null);
          }, 1e3));
          return;
        }
        ((o = this.parentPopper) == null ? void 0 : o.lockedChild) === this && (this.parentPopper.lockedChild = null), this.pendingHide = false, this.$_scheduleHide(e, t), this.$emit("hide"), this.$emit("update:shown", false);
      }
    },
    init() {
      var e;
      this.isDisposed && (this.isDisposed = false, this.isMounted = false, this.$_events = [], this.$_preventShow = false, this.$_referenceNode = ((e = this.referenceNode) == null ? void 0 : e.call(this)) ?? this.$el, this.$_targetNodes = this.targetNodes().filter((t) => t.nodeType === t.ELEMENT_NODE), this.$_popperNode = this.popperNode(), this.$_innerNode = this.$_popperNode.querySelector(".v-popper__inner"), this.$_arrowNode = this.$_popperNode.querySelector(".v-popper__arrow-container"), this.$_swapTargetAttrs("title", "data-original-title"), this.$_detachPopperNode(), this.triggers.length && this.$_addEventListeners(), this.shown && this.show());
    },
    dispose() {
      this.isDisposed || (this.isDisposed = true, this.$_removeEventListeners(), this.hide({ skipDelay: true }), this.$_detachPopperNode(), this.isMounted = false, this.isShown = false, this.$_updateParentShownChildren(false), this.$_swapTargetAttrs("data-original-title", "title"));
    },
    async onResize() {
      this.isShown && (await this.$_computePosition(), this.$emit("resize"));
    },
    async $_computePosition() {
      if (this.isDisposed || this.positioningDisabled)
        return;
      const e = {
        strategy: this.strategy,
        middleware: []
      };
      (this.distance || this.skidding) && e.middleware.push(offset({
        mainAxis: this.distance,
        crossAxis: this.skidding
      }));
      const t = this.placement.startsWith("auto");
      if (t ? e.middleware.push(autoPlacement({
        alignment: this.placement.split("-")[1] ?? ""
      })) : e.placement = this.placement, this.preventOverflow && (this.shift && e.middleware.push(shift({
        padding: this.overflowPadding,
        boundary: this.boundary,
        crossAxis: this.shiftCrossAxis
      })), !t && this.flip && e.middleware.push(flip({
        padding: this.overflowPadding,
        boundary: this.boundary
      }))), e.middleware.push(arrow({
        element: this.$_arrowNode,
        padding: this.arrowPadding
      })), this.arrowOverflow && e.middleware.push({
        name: "arrowOverflow",
        fn: ({ placement: i, rects: s, middlewareData: r }) => {
          let p;
          const { centerOffset: a } = r.arrow;
          return i.startsWith("top") || i.startsWith("bottom") ? p = Math.abs(a) > s.reference.width / 2 : p = Math.abs(a) > s.reference.height / 2, {
            data: {
              overflow: p
            }
          };
        }
      }), this.autoMinSize || this.autoSize) {
        const i = this.autoSize ? this.autoSize : this.autoMinSize ? "min" : null;
        e.middleware.push({
          name: "autoSize",
          fn: ({ rects: s, placement: r, middlewareData: p }) => {
            var u;
            if ((u = p.autoSize) != null && u.skip)
              return {};
            let a, l;
            return r.startsWith("top") || r.startsWith("bottom") ? a = s.reference.width : l = s.reference.height, this.$_innerNode.style[i === "min" ? "minWidth" : i === "max" ? "maxWidth" : "width"] = a != null ? `${a}px` : null, this.$_innerNode.style[i === "min" ? "minHeight" : i === "max" ? "maxHeight" : "height"] = l != null ? `${l}px` : null, {
              data: {
                skip: true
              },
              reset: {
                rects: true
              }
            };
          }
        });
      }
      (this.autoMaxSize || this.autoBoundaryMaxSize) && (this.$_innerNode.style.maxWidth = null, this.$_innerNode.style.maxHeight = null, e.middleware.push(size({
        boundary: this.boundary,
        padding: this.overflowPadding,
        apply: ({ availableWidth: i, availableHeight: s }) => {
          this.$_innerNode.style.maxWidth = i != null ? `${i}px` : null, this.$_innerNode.style.maxHeight = s != null ? `${s}px` : null;
        }
      })));
      const o = await computePosition(this.$_referenceNode, this.$_popperNode, e);
      Object.assign(this.result, {
        x: o.x,
        y: o.y,
        placement: o.placement,
        strategy: o.strategy,
        arrow: {
          ...o.middlewareData.arrow,
          ...o.middlewareData.arrowOverflow
        }
      });
    },
    $_scheduleShow(e, t = false) {
      if (this.$_updateParentShownChildren(true), this.$_hideInProgress = false, clearTimeout(this.$_scheduleTimer), g && this.instantMove && g.instantMove && g !== this.parentPopper) {
        g.$_applyHide(true), this.$_applyShow(true);
        return;
      }
      t ? this.$_applyShow() : this.$_scheduleTimer = setTimeout(this.$_applyShow.bind(this), this.$_computeDelay("show"));
    },
    $_scheduleHide(e, t = false) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = true;
        return;
      }
      this.$_updateParentShownChildren(false), this.$_hideInProgress = true, clearTimeout(this.$_scheduleTimer), this.isShown && (g = this), t ? this.$_applyHide() : this.$_scheduleTimer = setTimeout(this.$_applyHide.bind(this), this.$_computeDelay("hide"));
    },
    $_computeDelay(e) {
      const t = this.delay;
      return parseInt(t && t[e] || t || 0);
    },
    async $_applyShow(e = false) {
      clearTimeout(this.$_disposeTimer), clearTimeout(this.$_scheduleTimer), this.skipTransition = e, !this.isShown && (this.$_ensureTeleport(), await G(), await this.$_computePosition(), await this.$_applyShowEffect(), this.positioningDisabled || this.$_registerEventListeners([
        ...getOverflowAncestors(this.$_referenceNode),
        ...getOverflowAncestors(this.$_popperNode)
      ], "scroll", () => {
        this.$_computePosition();
      }));
    },
    async $_applyShowEffect() {
      if (this.$_hideInProgress)
        return;
      if (this.computeTransformOrigin) {
        const t = this.$_referenceNode.getBoundingClientRect(), o = this.$_popperNode.querySelector(".v-popper__wrapper"), i = o.parentNode.getBoundingClientRect(), s = t.x + t.width / 2 - (i.left + o.offsetLeft), r = t.y + t.height / 2 - (i.top + o.offsetTop);
        this.result.transformOrigin = `${s}px ${r}px`;
      }
      this.isShown = true, this.$_applyAttrsToTarget({
        "aria-describedby": this.popperId,
        "data-popper-shown": ""
      });
      const e = this.showGroup;
      if (e) {
        let t;
        for (let o = 0; o < d.length; o++)
          t = d[o], t.showGroup !== e && (t.hide(), t.$emit("close-group"));
      }
      d.push(this), document.body.classList.add("v-popper--some-open");
      for (const t of re(this.theme))
        he(t).push(this), document.body.classList.add(`v-popper--some-open--${t}`);
      this.$emit("apply-show"), this.classes.showFrom = true, this.classes.showTo = false, this.classes.hideFrom = false, this.classes.hideTo = false, await G(), this.classes.showFrom = false, this.classes.showTo = true, this.noAutoFocus || this.$_popperNode.focus();
    },
    async $_applyHide(e = false) {
      if (this.shownChildren.size > 0) {
        this.pendingHide = true, this.$_hideInProgress = false;
        return;
      }
      if (clearTimeout(this.$_scheduleTimer), !this.isShown)
        return;
      this.skipTransition = e, de(d, this), d.length === 0 && document.body.classList.remove("v-popper--some-open");
      for (const o of re(this.theme)) {
        const i = he(o);
        de(i, this), i.length === 0 && document.body.classList.remove(`v-popper--some-open--${o}`);
      }
      g === this && (g = null), this.isShown = false, this.$_applyAttrsToTarget({
        "aria-describedby": void 0,
        "data-popper-shown": void 0
      }), clearTimeout(this.$_disposeTimer);
      const t = this.disposeTimeout;
      t !== null && (this.$_disposeTimer = setTimeout(() => {
        this.$_popperNode && (this.$_detachPopperNode(), this.isMounted = false);
      }, t)), this.$_removeEventListeners("scroll"), this.$emit("apply-hide"), this.classes.showFrom = false, this.classes.showTo = false, this.classes.hideFrom = true, this.classes.hideTo = false, await G(), this.classes.hideFrom = false, this.classes.hideTo = true;
    },
    $_autoShowHide() {
      this.shown ? this.show() : this.hide();
    },
    $_ensureTeleport() {
      if (this.isDisposed)
        return;
      let e = this.container;
      if (typeof e == "string" ? e = window.document.querySelector(e) : e === false && (e = this.$_targetNodes[0].parentNode), !e)
        throw new Error("No container for popover: " + this.container);
      e.appendChild(this.$_popperNode), this.isMounted = true;
    },
    $_addEventListeners() {
      const e = (o) => {
        this.isShown && !this.$_hideInProgress || (o.usedByTooltip = true, !this.$_preventShow && this.show({ event: o }));
      };
      this.$_registerTriggerListeners(this.$_targetNodes, pe, this.triggers, this.showTriggers, e), this.$_registerTriggerListeners([this.$_popperNode], pe, this.popperTriggers, this.popperShowTriggers, e);
      const t = (o) => {
        o.usedByTooltip || this.hide({ event: o });
      };
      this.$_registerTriggerListeners(this.$_targetNodes, ae, this.triggers, this.hideTriggers, t), this.$_registerTriggerListeners([this.$_popperNode], ae, this.popperTriggers, this.popperHideTriggers, t);
    },
    $_registerEventListeners(e, t, o) {
      this.$_events.push({ targetNodes: e, eventType: t, handler: o }), e.forEach((i) => i.addEventListener(t, o, $ ? {
        passive: true
      } : void 0));
    },
    $_registerTriggerListeners(e, t, o, i, s) {
      let r = o;
      i != null && (r = typeof i == "function" ? i(r) : i), r.forEach((p) => {
        const a = t[p];
        a && this.$_registerEventListeners(e, a, s);
      });
    },
    $_removeEventListeners(e) {
      const t = [];
      this.$_events.forEach((o) => {
        const { targetNodes: i, eventType: s, handler: r } = o;
        !e || e === s ? i.forEach((p) => p.removeEventListener(s, r)) : t.push(o);
      }), this.$_events = t;
    },
    $_refreshListeners() {
      this.isDisposed || (this.$_removeEventListeners(), this.$_addEventListeners());
    },
    $_handleGlobalClose(e, t = false) {
      this.$_showFrameLocked || (this.hide({ event: e }), e.closePopover ? this.$emit("close-directive") : this.$emit("auto-hide"), t && (this.$_preventShow = true, setTimeout(() => {
        this.$_preventShow = false;
      }, 300)));
    },
    $_detachPopperNode() {
      this.$_popperNode.parentNode && this.$_popperNode.parentNode.removeChild(this.$_popperNode);
    },
    $_swapTargetAttrs(e, t) {
      for (const o of this.$_targetNodes) {
        const i = o.getAttribute(e);
        i && (o.removeAttribute(e), o.setAttribute(t, i));
      }
    },
    $_applyAttrsToTarget(e) {
      for (const t of this.$_targetNodes)
        for (const o in e) {
          const i = e[o];
          i == null ? t.removeAttribute(o) : t.setAttribute(o, i);
        }
    },
    $_updateParentShownChildren(e) {
      let t = this.parentPopper;
      for (; t; )
        e ? t.shownChildren.add(this.randomId) : (t.shownChildren.delete(this.randomId), t.pendingHide && t.hide()), t = t.parentPopper;
    },
    $_isAimingPopper() {
      const e = this.$_referenceNode.getBoundingClientRect();
      if (y >= e.left && y <= e.right && _ >= e.top && _ <= e.bottom) {
        const t = this.$_popperNode.getBoundingClientRect(), o = y - c, i = _ - m, r = t.left + t.width / 2 - c + (t.top + t.height / 2) - m + t.width + t.height, p = c + o * r, a = m + i * r;
        return C(c, m, p, a, t.left, t.top, t.left, t.bottom) || // Left edge
        C(c, m, p, a, t.left, t.top, t.right, t.top) || // Top edge
        C(c, m, p, a, t.right, t.top, t.right, t.bottom) || // Right edge
        C(c, m, p, a, t.left, t.bottom, t.right, t.bottom);
      }
      return false;
    }
  },
  render() {
    return this.$slots.default(this.slotData);
  }
});
if (typeof document < "u" && typeof window < "u") {
  if (_e$1) {
    const e = $ ? {
      passive: true,
      capture: true
    } : true;
    document.addEventListener("touchstart", (t) => ue(t, true), e), document.addEventListener("touchend", (t) => fe(t, true), e);
  } else
    window.addEventListener("mousedown", (e) => ue(e, false), true), window.addEventListener("click", (e) => fe(e, false), true);
  window.addEventListener("resize", tt);
}
function ue(e, t) {
  if (h.autoHideOnMousedown)
    Pe(e, t);
  else
    for (let o = 0; o < d.length; o++) {
      const i = d[o];
      try {
        i.mouseDownContains = i.popperNode().contains(e.target);
      } catch {
      }
    }
}
function fe(e, t) {
  h.autoHideOnMousedown || Pe(e, t);
}
function Pe(e, t) {
  const o = {};
  for (let i = d.length - 1; i >= 0; i--) {
    const s = d[i];
    try {
      const r = s.containsGlobalTarget = s.mouseDownContains || s.popperNode().contains(e.target);
      s.pendingHide = false, requestAnimationFrame(() => {
        if (s.pendingHide = false, !o[s.randomId] && ce(s, r, e)) {
          if (s.$_handleGlobalClose(e, t), !e.closeAllPopover && e.closePopover && r) {
            let a = s.parentPopper;
            for (; a; )
              o[a.randomId] = true, a = a.parentPopper;
            return;
          }
          let p = s.parentPopper;
          for (; p && ce(p, p.containsGlobalTarget, e); ) {
            p.$_handleGlobalClose(e, t);
            p = p.parentPopper;
          }
        }
      });
    } catch {
    }
  }
}
function ce(e, t, o) {
  return o.closeAllPopover || o.closePopover && t || et(e, o) && !t;
}
function et(e, t) {
  if (typeof e.autoHide == "function") {
    const o = e.autoHide(t);
    return e.lastAutoHide = o, o;
  }
  return e.autoHide;
}
function tt() {
  for (let e = 0; e < d.length; e++)
    d[e].$_computePosition();
}
let c = 0, m = 0, y = 0, _ = 0;
typeof window < "u" && window.addEventListener("mousemove", (e) => {
  c = y, m = _, y = e.clientX, _ = e.clientY;
}, $ ? {
  passive: true
} : void 0);
function C(e, t, o, i, s, r, p, a) {
  const l = ((p - s) * (t - r) - (a - r) * (e - s)) / ((a - r) * (o - e) - (p - s) * (i - t)), u = ((o - e) * (t - r) - (i - t) * (e - s)) / ((a - r) * (o - e) - (p - s) * (i - t));
  return l >= 0 && l <= 1 && u >= 0 && u <= 1;
}
const ot = {
  extends: Q()
}, B = (e, t) => {
  const o = e.__vccOpts || e;
  for (const [i, s] of t)
    o[i] = s;
  return o;
};
function it$1(e, t, o, i, s, r) {
  return openBlock(), createElementBlock("div", {
    ref: "reference",
    class: normalizeClass(["v-popper", {
      "v-popper--shown": e.slotData.isShown
    }])
  }, [
    renderSlot(e.$slots, "default", normalizeProps(guardReactiveProps(e.slotData)))
  ], 2);
}
const st = /* @__PURE__ */ B(ot, [["render", it$1]]);
function nt$1() {
  var e = window.navigator.userAgent, t = e.indexOf("MSIE ");
  if (t > 0)
    return parseInt(e.substring(t + 5, e.indexOf(".", t)), 10);
  var o = e.indexOf("Trident/");
  if (o > 0) {
    var i = e.indexOf("rv:");
    return parseInt(e.substring(i + 3, e.indexOf(".", i)), 10);
  }
  var s = e.indexOf("Edge/");
  return s > 0 ? parseInt(e.substring(s + 5, e.indexOf(".", s)), 10) : -1;
}
let z;
function X() {
  X.init || (X.init = true, z = nt$1() !== -1);
}
var E = {
  name: "ResizeObserver",
  props: {
    emitOnMount: {
      type: Boolean,
      default: false
    },
    ignoreWidth: {
      type: Boolean,
      default: false
    },
    ignoreHeight: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    "notify"
  ],
  mounted() {
    X(), nextTick(() => {
      this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitOnMount && this.emitSize();
    });
    const e = document.createElement("object");
    this._resizeObject = e, e.setAttribute("aria-hidden", "true"), e.setAttribute("tabindex", -1), e.onload = this.addResizeHandlers, e.type = "text/html", z && this.$el.appendChild(e), e.data = "about:blank", z || this.$el.appendChild(e);
  },
  beforeUnmount() {
    this.removeResizeHandlers();
  },
  methods: {
    compareAndNotify() {
      (!this.ignoreWidth && this._w !== this.$el.offsetWidth || !this.ignoreHeight && this._h !== this.$el.offsetHeight) && (this._w = this.$el.offsetWidth, this._h = this.$el.offsetHeight, this.emitSize());
    },
    emitSize() {
      this.$emit("notify", {
        width: this._w,
        height: this._h
      });
    },
    addResizeHandlers() {
      this._resizeObject.contentDocument.defaultView.addEventListener("resize", this.compareAndNotify), this.compareAndNotify();
    },
    removeResizeHandlers() {
      this._resizeObject && this._resizeObject.onload && (!z && this._resizeObject.contentDocument && this._resizeObject.contentDocument.defaultView.removeEventListener("resize", this.compareAndNotify), this.$el.removeChild(this._resizeObject), this._resizeObject.onload = null, this._resizeObject = null);
    }
  }
};
const rt$1 = /* @__PURE__ */ withScopeId("data-v-b329ee4c");
pushScopeId("data-v-b329ee4c");
const pt$1 = {
  class: "resize-observer",
  tabindex: "-1"
};
popScopeId();
const at = /* @__PURE__ */ rt$1((e, t, o, i, s, r) => (openBlock(), createBlock("div", pt$1)));
E.render = at;
E.__scopeId = "data-v-b329ee4c";
E.__file = "src/components/ResizeObserver.vue";
const Z = (e = "theme") => ({
  computed: {
    themeClass() {
      return Ze$1(this[e]);
    }
  }
}), dt$1 = defineComponent({
  name: "VPopperContent",
  components: {
    ResizeObserver: E
  },
  mixins: [
    Z()
  ],
  props: {
    popperId: String,
    theme: String,
    shown: Boolean,
    mounted: Boolean,
    skipTransition: Boolean,
    autoHide: Boolean,
    handleResize: Boolean,
    classes: Object,
    result: Object
  },
  emits: [
    "hide",
    "resize"
  ],
  methods: {
    toPx(e) {
      return e != null && !isNaN(e) ? `${e}px` : null;
    }
  }
}), lt$1 = ["id", "aria-hidden", "tabindex", "data-popper-placement"], ht = {
  ref: "inner",
  class: "v-popper__inner"
}, ut = /* @__PURE__ */ createElementVNode("div", { class: "v-popper__arrow-outer" }, null, -1), ft = /* @__PURE__ */ createElementVNode("div", { class: "v-popper__arrow-inner" }, null, -1), ct = [
  ut,
  ft
];
function mt$1(e, t, o, i, s, r) {
  const p = resolveComponent("ResizeObserver");
  return openBlock(), createElementBlock("div", {
    id: e.popperId,
    ref: "popover",
    class: normalizeClass(["v-popper__popper", [
      e.themeClass,
      e.classes.popperClass,
      {
        "v-popper__popper--shown": e.shown,
        "v-popper__popper--hidden": !e.shown,
        "v-popper__popper--show-from": e.classes.showFrom,
        "v-popper__popper--show-to": e.classes.showTo,
        "v-popper__popper--hide-from": e.classes.hideFrom,
        "v-popper__popper--hide-to": e.classes.hideTo,
        "v-popper__popper--skip-transition": e.skipTransition,
        "v-popper__popper--arrow-overflow": e.result && e.result.arrow.overflow,
        "v-popper__popper--no-positioning": !e.result
      }
    ]]),
    style: normalizeStyle(e.result ? {
      position: e.result.strategy,
      transform: `translate3d(${Math.round(e.result.x)}px,${Math.round(e.result.y)}px,0)`
    } : void 0),
    "aria-hidden": e.shown ? "false" : "true",
    tabindex: e.autoHide ? 0 : void 0,
    "data-popper-placement": e.result ? e.result.placement : void 0,
    onKeyup: t[2] || (t[2] = withKeys((a) => e.autoHide && e.$emit("hide"), ["esc"]))
  }, [
    createElementVNode("div", {
      class: "v-popper__backdrop",
      onClick: t[0] || (t[0] = (a) => e.autoHide && e.$emit("hide"))
    }),
    createElementVNode("div", {
      class: "v-popper__wrapper",
      style: normalizeStyle(e.result ? {
        transformOrigin: e.result.transformOrigin
      } : void 0)
    }, [
      createElementVNode("div", ht, [
        e.mounted ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
          createElementVNode("div", null, [
            renderSlot(e.$slots, "default")
          ]),
          e.handleResize ? (openBlock(), createBlock(p, {
            key: 0,
            onNotify: t[1] || (t[1] = (a) => e.$emit("resize", a))
          })) : createCommentVNode("", true)
        ], 64)) : createCommentVNode("", true)
      ], 512),
      createElementVNode("div", {
        ref: "arrow",
        class: "v-popper__arrow-container",
        style: normalizeStyle(e.result ? {
          left: e.toPx(e.result.arrow.x),
          top: e.toPx(e.result.arrow.y)
        } : void 0)
      }, ct, 4)
    ], 4)
  ], 46, lt$1);
}
const ee = /* @__PURE__ */ B(dt$1, [["render", mt$1]]), te = {
  methods: {
    show(...e) {
      return this.$refs.popper.show(...e);
    },
    hide(...e) {
      return this.$refs.popper.hide(...e);
    },
    dispose(...e) {
      return this.$refs.popper.dispose(...e);
    },
    onResize(...e) {
      return this.$refs.popper.onResize(...e);
    }
  }
};
let K = function() {
};
typeof window < "u" && (K = window.Element);
const gt$1 = defineComponent({
  name: "VPopperWrapper",
  components: {
    Popper: st,
    PopperContent: ee
  },
  mixins: [
    te,
    Z("finalTheme")
  ],
  props: {
    theme: {
      type: String,
      default: null
    },
    referenceNode: {
      type: Function,
      default: null
    },
    shown: {
      type: Boolean,
      default: false
    },
    showGroup: {
      type: String,
      default: null
    },
    // eslint-disable-next-line vue/require-prop-types
    ariaId: {
      default: null
    },
    disabled: {
      type: Boolean,
      default: void 0
    },
    positioningDisabled: {
      type: Boolean,
      default: void 0
    },
    placement: {
      type: String,
      default: void 0
    },
    delay: {
      type: [String, Number, Object],
      default: void 0
    },
    distance: {
      type: [Number, String],
      default: void 0
    },
    skidding: {
      type: [Number, String],
      default: void 0
    },
    triggers: {
      type: Array,
      default: void 0
    },
    showTriggers: {
      type: [Array, Function],
      default: void 0
    },
    hideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperTriggers: {
      type: Array,
      default: void 0
    },
    popperShowTriggers: {
      type: [Array, Function],
      default: void 0
    },
    popperHideTriggers: {
      type: [Array, Function],
      default: void 0
    },
    container: {
      type: [String, Object, K, Boolean],
      default: void 0
    },
    boundary: {
      type: [String, K],
      default: void 0
    },
    strategy: {
      type: String,
      default: void 0
    },
    autoHide: {
      type: [Boolean, Function],
      default: void 0
    },
    handleResize: {
      type: Boolean,
      default: void 0
    },
    instantMove: {
      type: Boolean,
      default: void 0
    },
    eagerMount: {
      type: Boolean,
      default: void 0
    },
    popperClass: {
      type: [String, Array, Object],
      default: void 0
    },
    computeTransformOrigin: {
      type: Boolean,
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMinSize: {
      type: Boolean,
      default: void 0
    },
    autoSize: {
      type: [Boolean, String],
      default: void 0
    },
    /**
     * @deprecated
     */
    autoMaxSize: {
      type: Boolean,
      default: void 0
    },
    autoBoundaryMaxSize: {
      type: Boolean,
      default: void 0
    },
    preventOverflow: {
      type: Boolean,
      default: void 0
    },
    overflowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowPadding: {
      type: [Number, String],
      default: void 0
    },
    arrowOverflow: {
      type: Boolean,
      default: void 0
    },
    flip: {
      type: Boolean,
      default: void 0
    },
    shift: {
      type: Boolean,
      default: void 0
    },
    shiftCrossAxis: {
      type: Boolean,
      default: void 0
    },
    noAutoFocus: {
      type: Boolean,
      default: void 0
    },
    disposeTimeout: {
      type: Number,
      default: void 0
    }
  },
  emits: {
    show: () => true,
    hide: () => true,
    "update:shown": (e) => true,
    "apply-show": () => true,
    "apply-hide": () => true,
    "close-group": () => true,
    "close-directive": () => true,
    "auto-hide": () => true,
    resize: () => true
  },
  computed: {
    finalTheme() {
      return this.theme ?? this.$options.vPopperTheme;
    }
  },
  methods: {
    getTargetNodes() {
      return Array.from(this.$el.children).filter((e) => e !== this.$refs.popperContent.$el);
    }
  }
});
function wt(e, t, o, i, s, r) {
  const p = resolveComponent("PopperContent"), a = resolveComponent("Popper");
  return openBlock(), createBlock(a, mergeProps({ ref: "popper" }, e.$props, {
    theme: e.finalTheme,
    "target-nodes": e.getTargetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    class: [
      e.themeClass
    ],
    onShow: t[0] || (t[0] = () => e.$emit("show")),
    onHide: t[1] || (t[1] = () => e.$emit("hide")),
    "onUpdate:shown": t[2] || (t[2] = (l) => e.$emit("update:shown", l)),
    onApplyShow: t[3] || (t[3] = () => e.$emit("apply-show")),
    onApplyHide: t[4] || (t[4] = () => e.$emit("apply-hide")),
    onCloseGroup: t[5] || (t[5] = () => e.$emit("close-group")),
    onCloseDirective: t[6] || (t[6] = () => e.$emit("close-directive")),
    onAutoHide: t[7] || (t[7] = () => e.$emit("auto-hide")),
    onResize: t[8] || (t[8] = () => e.$emit("resize"))
  }), {
    default: withCtx(({
      popperId: l,
      isShown: u,
      shouldMountContent: L,
      skipTransition: D,
      autoHide: I,
      show: F,
      hide: v,
      handleResize: R,
      onResize: j2,
      classes: V,
      result: Ee
    }) => [
      renderSlot(e.$slots, "default", {
        shown: u,
        show: F,
        hide: v
      }),
      createVNode(p, {
        ref: "popperContent",
        "popper-id": l,
        theme: e.finalTheme,
        shown: u,
        mounted: L,
        "skip-transition": D,
        "auto-hide": I,
        "handle-resize": R,
        classes: V,
        result: Ee,
        onHide: v,
        onResize: j2
      }, {
        default: withCtx(() => [
          renderSlot(e.$slots, "popper", {
            shown: u,
            hide: v
          })
        ]),
        _: 2
      }, 1032, ["popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 3
  }, 16, ["theme", "target-nodes", "popper-node", "class"]);
}
const k = /* @__PURE__ */ B(gt$1, [["render", wt]]), Se$1 = {
  ...k,
  name: "VDropdown",
  vPopperTheme: "dropdown"
}, be = {
  ...k,
  name: "VMenu",
  vPopperTheme: "menu"
}, Ce$1 = {
  ...k,
  name: "VTooltip",
  vPopperTheme: "tooltip"
}, $t = defineComponent({
  name: "VTooltipDirective",
  components: {
    Popper: Q(),
    PopperContent: ee
  },
  mixins: [
    te
  ],
  inheritAttrs: false,
  props: {
    theme: {
      type: String,
      default: "tooltip"
    },
    html: {
      type: Boolean,
      default: (e) => S(e.theme, "html")
    },
    content: {
      type: [String, Number, Function],
      default: null
    },
    loadingContent: {
      type: String,
      default: (e) => S(e.theme, "loadingContent")
    },
    targetNodes: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      asyncContent: null
    };
  },
  computed: {
    isContentAsync() {
      return typeof this.content == "function";
    },
    loading() {
      return this.isContentAsync && this.asyncContent == null;
    },
    finalContent() {
      return this.isContentAsync ? this.loading ? this.loadingContent : this.asyncContent : this.content;
    }
  },
  watch: {
    content: {
      handler() {
        this.fetchContent(true);
      },
      immediate: true
    },
    async finalContent() {
      await this.$nextTick(), this.$refs.popper.onResize();
    }
  },
  created() {
    this.$_fetchId = 0;
  },
  methods: {
    fetchContent(e) {
      if (typeof this.content == "function" && this.$_isShown && (e || !this.$_loading && this.asyncContent == null)) {
        this.asyncContent = null, this.$_loading = true;
        const t = ++this.$_fetchId, o = this.content(this);
        o.then ? o.then((i) => this.onResult(t, i)) : this.onResult(t, o);
      }
    },
    onResult(e, t) {
      e === this.$_fetchId && (this.$_loading = false, this.asyncContent = t);
    },
    onShow() {
      this.$_isShown = true, this.fetchContent();
    },
    onHide() {
      this.$_isShown = false;
    }
  }
}), vt = ["innerHTML"], yt$1 = ["textContent"];
function _t(e, t, o, i, s, r) {
  const p = resolveComponent("PopperContent"), a = resolveComponent("Popper");
  return openBlock(), createBlock(a, mergeProps({ ref: "popper" }, e.$attrs, {
    theme: e.theme,
    "target-nodes": e.targetNodes,
    "popper-node": () => e.$refs.popperContent.$el,
    onApplyShow: e.onShow,
    onApplyHide: e.onHide
  }), {
    default: withCtx(({
      popperId: l,
      isShown: u,
      shouldMountContent: L,
      skipTransition: D,
      autoHide: I,
      hide: F,
      handleResize: v,
      onResize: R,
      classes: j2,
      result: V
    }) => [
      createVNode(p, {
        ref: "popperContent",
        class: normalizeClass({
          "v-popper--tooltip-loading": e.loading
        }),
        "popper-id": l,
        theme: e.theme,
        shown: u,
        mounted: L,
        "skip-transition": D,
        "auto-hide": I,
        "handle-resize": v,
        classes: j2,
        result: V,
        onHide: F,
        onResize: R
      }, {
        default: withCtx(() => [
          e.html ? (openBlock(), createElementBlock("div", {
            key: 0,
            innerHTML: e.finalContent
          }, null, 8, vt)) : (openBlock(), createElementBlock("div", {
            key: 1,
            textContent: toDisplayString(e.finalContent)
          }, null, 8, yt$1))
        ]),
        _: 2
      }, 1032, ["class", "popper-id", "theme", "shown", "mounted", "skip-transition", "auto-hide", "handle-resize", "classes", "result", "onHide", "onResize"])
    ]),
    _: 1
  }, 16, ["theme", "target-nodes", "popper-node", "onApplyShow", "onApplyHide"]);
}
const ze$1 = /* @__PURE__ */ B($t, [["render", _t]]), Ae = "v-popper--has-tooltip";
function Tt$1(e, t) {
  let o = e.placement;
  if (!o && t)
    for (const i of Te)
      t[i] && (o = i);
  return o || (o = S(e.theme || "tooltip", "placement")), o;
}
function Ne(e, t, o) {
  let i;
  const s = typeof t;
  return s === "string" ? i = { content: t } : t && s === "object" ? i = t : i = { content: false }, i.placement = Tt$1(i, o), i.targetNodes = () => [e], i.referenceNode = () => e, i;
}
let x, b, Pt = 0;
function St$1() {
  if (x)
    return;
  b = ref([]), x = createApp({
    name: "VTooltipDirectiveApp",
    setup() {
      return {
        directives: b
      };
    },
    render() {
      return this.directives.map((t) => h$1(ze$1, {
        ...t.options,
        shown: t.shown || t.options.shown,
        key: t.id
      }));
    },
    devtools: {
      hide: true
    }
  });
  const e = document.createElement("div");
  document.body.appendChild(e), x.mount(e);
}
function bt$1(e, t, o) {
  St$1();
  const i = ref(Ne(e, t, o)), s = ref(false), r = {
    id: Pt++,
    options: i,
    shown: s
  };
  return b.value.push(r), e.classList && e.classList.add(Ae), e.$_popper = {
    options: i,
    item: r,
    show() {
      s.value = true;
    },
    hide() {
      s.value = false;
    }
  };
}
function He$1(e) {
  if (e.$_popper) {
    const t = b.value.indexOf(e.$_popper.item);
    t !== -1 && b.value.splice(t, 1), delete e.$_popper, delete e.$_popperOldShown, delete e.$_popperMountTarget;
  }
  e.classList && e.classList.remove(Ae);
}
function me(e, { value: t, modifiers: o }) {
  const i = Ne(e, t, o);
  if (!i.content || S(i.theme || "tooltip", "disabled"))
    He$1(e);
  else {
    let s;
    e.$_popper ? (s = e.$_popper, s.options.value = i) : s = bt$1(e, t, o), typeof t.shown < "u" && t.shown !== e.$_popperOldShown && (e.$_popperOldShown = t.shown, t.shown ? s.show() : s.hide());
  }
}
const oe = {
  beforeMount: me,
  updated: me,
  beforeUnmount(e) {
    He$1(e);
  }
};
function ge(e) {
  e.addEventListener("mousedown", H), e.addEventListener("click", H), e.addEventListener("touchstart", Oe$1, $ ? {
    passive: true
  } : false);
}
function we(e) {
  e.removeEventListener("mousedown", H), e.removeEventListener("click", H), e.removeEventListener("touchstart", Oe$1), e.removeEventListener("touchend", Me), e.removeEventListener("touchcancel", Be$1);
}
function H(e) {
  const t = e.currentTarget;
  e.closePopover = !t.$_vclosepopover_touch, e.closeAllPopover = t.$_closePopoverModifiers && !!t.$_closePopoverModifiers.all;
}
function Oe$1(e) {
  if (e.changedTouches.length === 1) {
    const t = e.currentTarget;
    t.$_vclosepopover_touch = true;
    const o = e.changedTouches[0];
    t.$_vclosepopover_touchPoint = o, t.addEventListener("touchend", Me), t.addEventListener("touchcancel", Be$1);
  }
}
function Me(e) {
  const t = e.currentTarget;
  if (t.$_vclosepopover_touch = false, e.changedTouches.length === 1) {
    const o = e.changedTouches[0], i = t.$_vclosepopover_touchPoint;
    e.closePopover = Math.abs(o.screenY - i.screenY) < 20 && Math.abs(o.screenX - i.screenX) < 20, e.closeAllPopover = t.$_closePopoverModifiers && !!t.$_closePopoverModifiers.all;
  }
}
function Be$1(e) {
  const t = e.currentTarget;
  t.$_vclosepopover_touch = false;
}
const ie = {
  beforeMount(e, { value: t, modifiers: o }) {
    e.$_closePopoverModifiers = o, (typeof t > "u" || t) && ge(e);
  },
  updated(e, { value: t, oldValue: o, modifiers: i }) {
    e.$_closePopoverModifiers = i, t !== o && (typeof t > "u" || t ? ge(e) : we(e));
  },
  beforeUnmount(e) {
    we(e);
  }
}, kt$1 = Se$1;
function Ct$1(e, t = {}) {
  e.$_vTooltipInstalled || (e.$_vTooltipInstalled = true, ye(h, t), e.directive("tooltip", oe), e.directive("close-popper", ie), e.component("VTooltip", Ce$1), e.component("VDropdown", Se$1), e.component("VMenu", be));
}
const Gt$1 = {
  // eslint-disable-next-line no-undef
  version: "5.2.2",
  install: Ct$1,
  options: h
};
const _sfc_main$V = /* @__PURE__ */ defineComponent({
  __name: "Dropdown",
  props: /* @__PURE__ */ mergeModels({
    value: { type: String, required: false },
    thin: { type: Boolean, required: false },
    flat: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
    icon: { type: null, required: false },
    triggerClass: { type: String, required: false },
    iconEnd: { type: null, required: false },
    border: { type: Boolean, required: false },
    outline: { type: Boolean, required: false },
    round: { type: Boolean, required: false },
    placement: { type: null, required: false },
    noAutoFocus: { type: Boolean, required: false },
    positioningDisabled: { type: Boolean, required: false }
  }, {
    "shown": {
      type: Boolean,
      default: false
    },
    "shownModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["show", "hide"], ["update:shown"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit2 = __emit;
    const ddownRef = ref();
    const shown = useModel(__props, "shown");
    const show = () => {
      var _a2;
      return (_a2 = ddownRef.value) == null ? void 0 : _a2.show();
    };
    const hide = () => {
      var _a2;
      return (_a2 = ddownRef.value) == null ? void 0 : _a2.hide();
    };
    __expose({ show, hide, shown });
    const __returned__ = { emit: emit2, ddownRef, shown, show, hide, get Btn() {
      return Btn;
    }, get DDown() {
      return kt$1;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$V(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["DDown"], {
    ref: "ddownRef",
    shown: $setup.shown,
    "onUpdate:shown": _cache[0] || (_cache[0] = ($event) => $setup.shown = $event),
    disabled: $props.disabled,
    noAutoFocus: $props.noAutoFocus,
    placement: $props.placement,
    onHide: _cache[1] || (_cache[1] = ($event) => $setup.emit("hide")),
    onShow: _cache[2] || (_cache[2] = ($event) => $setup.emit("show"))
  }, {
    popper: withCtx(({ hide, show }) => [
      renderSlot(_ctx.$slots, "default", {
        hide,
        show
      })
    ]),
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "trigger", {}, () => [
        createVNode($setup["Btn"], {
          class: normalizeClass($props.triggerClass),
          iconEnd: $props.iconEnd,
          icon: $props.icon,
          value: $props.value,
          thin: $props.thin,
          flat: $props.flat
        }, null, 8, ["class", "iconEnd", "icon", "value", "thin", "flat"])
      ])
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["shown", "disabled", "noAutoFocus", "placement"]);
}
const Dropdown = /* @__PURE__ */ _export_sfc(_sfc_main$V, [["render", _sfc_render$V], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Dropdown.vue"]]);
const _sfc_main$U = /* @__PURE__ */ defineComponent({
  __name: "Flag",
  props: {
    country: { type: String, required: true },
    size: { type: [Number, String], required: false },
    circle: { type: Boolean, required: false },
    square: { type: Boolean, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const fis = computed(() => {
      if (props2.circle || props2.square) return true;
      return false;
    });
    const height = computed(() => `${props2.size || 1}rem`);
    const backgroundImage = computed(() => {
      let country = props2.country.toLowerCase();
      if (country === "ac") country = "sh-ac";
      const baseURL = "https://cdn.jsdelivr.net/gh/lipis/flag-icons@7.0.0/flags";
      if (fis.value) return `url(${baseURL}/1x1/${country.toLowerCase()}.svg)`;
      return `url(${baseURL}/4x3/${country.toLowerCase()}.svg)`;
    });
    const __returned__ = { props: props2, fis, height, backgroundImage };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$U(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "span",
    {
      class: normalizeClass(["fi", { fis: $setup.fis, circle: $props.circle }]),
      style: normalizeStyle({ height: $setup.height, backgroundImage: $setup.backgroundImage })
    },
    null,
    6
    /* CLASS, STYLE */
  );
}
const Flag = /* @__PURE__ */ _export_sfc(_sfc_main$U, [["render", _sfc_render$U], ["__scopeId", "data-v-81fc1c7c"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Flag.vue"]]);
const state$1 = reactive(/* @__PURE__ */ new Map());
function useTabs(group) {
  if (!state$1.has(group)) {
    state$1.set(group, reactive({ currentTab: void 0 }));
  }
  const currentTab = computed({
    get: () => state$1.get(group).currentTab,
    set: (val) => {
      state$1.get(group).currentTab = val;
    }
  });
  return { currentTab };
}
const _sfc_main$T = /* @__PURE__ */ defineComponent({
  __name: "TabsNav",
  props: {
    title: { type: String, required: false },
    tabs: { type: Array, required: true },
    modelValue: { type: String, required: false },
    sideTabs: { type: Boolean, required: false },
    group: { type: String, required: true },
    flat: { type: Boolean, required: false },
    vertical: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const { currentTab } = useTabs(props2.group);
    currentTab.value = props2.modelValue || typeof props2.tabs[0] === "string" ? props2.tabs[0] : props2.tabs[0].id;
    const tabsWrap = ref(void 0);
    const tabs = ref([]);
    function updateIndicator() {
      const activeTab = tabs.value.find((tab) => tab.classList.contains("active"));
      if (activeTab && tabsWrap.value) {
        const { offsetLeft, offsetWidth } = activeTab;
        tabsWrap.value.style.setProperty("--indicator-left", `${offsetLeft}px`);
        if (tabsWrap.value) {
          tabsWrap.value.style.setProperty("--indicator-width", `${offsetWidth}px`);
        }
      }
    }
    function selectTab(tab) {
      currentTab.value = typeof tab === "string" ? tab : tab.id;
      emit2("update:modelValue", currentTab.value);
      nextTick(() => {
        updateIndicator();
      });
    }
    function isActive(tab) {
      if (typeof tab === "string") return currentTab.value === tab;
      return currentTab.value === tab.id;
    }
    function tabLabel(tab) {
      if (typeof tab === "string") return tab;
      return tab.label;
    }
    watch(
      () => props2.modelValue,
      (value) => {
        if (value && !isActive(value)) currentTab.value = value;
        nextTick(() => {
          updateIndicator();
        });
      },
      { immediate: true }
    );
    onMounted(() => {
      var _a2;
      tabs.value = Array.from(((_a2 = tabsWrap.value) == null ? void 0 : _a2.querySelectorAll(".bgl_tab")) || []);
      updateIndicator();
      window.addEventListener("resize", updateIndicator);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("resize", updateIndicator);
    });
    const __returned__ = { props: props2, emit: emit2, currentTab, tabsWrap, tabs, updateIndicator, selectTab, isActive, tabLabel, get Icon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$I = ["onClick"];
function _sfc_render$T(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      ref: "tabsWrap",
      class: normalizeClass(["grid auto-flow-columns relative fit-content bgl_tabs_wrap overflow-hidden", { "bgl_flat-tabs": $props.flat, "bgl_vertical-tabs": $props.vertical }])
    },
    [
      renderSlot(_ctx.$slots, "tabs", normalizeProps(guardReactiveProps({ selectTab: $setup.selectTab, isActive: $setup.isActive, tabLabel: $setup.tabLabel, tabs: $setup.tabs })), () => [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList($setup.props.tabs, (tab, i) => {
            return openBlock(), createElementBlock("button", {
              key: i,
              type: "button",
              class: normalizeClass([{ active: $setup.isActive(tab) }, "bgl_tab relative z-1"]),
              onClick: ($event) => $setup.selectTab(tab)
            }, [
              typeof tab !== "string" && tab.icon ? (openBlock(), createBlock($setup["Icon"], {
                key: 0,
                icon: tab.icon
              }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
              createTextVNode(
                " " + toDisplayString($setup.tabLabel(tab)),
                1
                /* TEXT */
              )
            ], 10, _hoisted_1$I);
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ], true)
    ],
    2
    /* CLASS */
  );
}
const TabsNav = /* @__PURE__ */ _export_sfc(_sfc_main$T, [["render", _sfc_render$T], ["__scopeId", "data-v-ede03a19"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/layout/TabsNav.vue"]]);
const _sfc_main$S = /* @__PURE__ */ defineComponent({
  __name: "BglField",
  props: {
    field: { type: null, required: true },
    modelValue: { type: Object, required: true, default: () => ({}) }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const customAttrs = ref({});
    const is4 = computed(() => {
      if (props2.field.$el === "text") return TextInput;
      if (props2.field.$el === "textarea") {
        customAttrs.value.multiline = true;
        return TextInput;
      }
      if (props2.field.$el === "number") return NumberInput;
      if (props2.field.$el === "array") return FieldArray;
      if (props2.field.$el === "select") return SelectInput;
      if (props2.field.$el === "toggle") return ToggleInput;
      if (props2.field.$el === "check") return CheckInput;
      if (props2.field.$el === "richtext") return RichText;
      if (props2.field.$el === "upload") return UploadInput;
      if (props2.field.$el === "file") return FileUpload;
      if (props2.field.$el === "date") return DateInput;
      if (props2.field.$el === "tabs") return TabsNav;
      if (props2.field.$el === "form") return BagelForm;
      return props2.field.$el ?? "div";
    });
    const formData = computed({
      get: () => props2.modelValue,
      set: (val) => {
        emit2("update:modelValue", val);
      }
    });
    const objPathRegex = /[.\][]/;
    function setFieldData(key, val) {
      const data2 = { ...props2.modelValue };
      const keys4 = key.split(objPathRegex);
      let temp = data2;
      for (let i = 0; i < keys4.length - 1; i++) {
        if (!temp[keys4[i]]) {
          temp[keys4[i]] = {};
        }
        temp = temp[keys4[i]];
      }
      temp[keys4[keys4.length - 1]] = val;
      return data2;
    }
    const isForm = computed(() => props2.field.$el === "form" || props2.field.$el === BagelForm);
    function getFieldData(obj, key) {
      if (typeof obj !== "object" || obj === null) return obj;
      const keys4 = key.split(objPathRegex);
      let result2 = obj;
      for (const k2 of keys4) {
        if (result2 && k2 in result2) {
          result2 = result2[k2];
        } else {
          return void 0;
        }
      }
      return result2;
    }
    const fieldData = computed({
      set: (val) => {
        if (isForm.value) {
          emit2("update:modelValue", val);
          return;
        }
        if (!props2.field.id) return;
        const data2 = setFieldData(props2.field.id, val);
        emit2("update:modelValue", data2);
      },
      get: () => {
        if (props2.field.id) return getFieldData(props2.modelValue, props2.field.id);
        if (isForm.value) return props2.modelValue;
        return props2.field.defaultValue ?? "";
      }
    });
    const vIf = computed(() => {
      if (props2.field["v-if"] === void 0 && props2.field.vIf === void 0) return true;
      if (typeof props2.field["v-if"] === "boolean" || typeof props2.field.vIf === "boolean") return props2.field["v-if"];
      if (typeof props2.field["v-if"] === "string" || typeof props2.field.vIf === "string") return true;
      if (typeof props2.field["v-if"] === "function") return props2.field["v-if"](fieldData.value, formData.value);
      if (typeof props2.field.vIf === "function") return props2.field.vIf(fieldData.value, formData.value);
      return true;
    });
    const computedFieldData = computed(
      () => {
        var _a2, _b;
        return ((_b = (_a2 = props2.field).transform) == null ? void 0 : _b.call(_a2, fieldData.value, props2.modelValue)) ?? fieldData.value;
      }
    );
    const computedOptions = computed(
      () => bindAttrs({ options: props2.field.options }, fieldData.value, props2.modelValue).options
    );
    const computedAttrs = computed(() => {
      const attrs = { ...customAttrs.value, ...props2.field.attrs };
      return bindAttrs(attrs, fieldData.value, props2.modelValue);
    });
    const computedClass = computed(
      () => {
        var _a2;
        return classify(fieldData.value, props2.modelValue, props2.field.class, (_a2 = props2.field.attrs) == null ? void 0 : _a2.class);
      }
    );
    const __returned__ = { props: props2, emit: emit2, customAttrs, is: is4, formData, objPathRegex, setFieldData, isForm, getFieldData, fieldData, vIf, computedFieldData, computedOptions, computedAttrs, computedClass };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$S(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_BglField = resolveComponent("BglField", true);
  return $setup.vIf ? (openBlock(), createBlock(resolveDynamicComponent($setup.is), mergeProps({ key: 0 }, $setup.computedAttrs, {
    id: $props.field.id,
    modelValue: $setup.fieldData,
    "onUpdate:modelValue": [
      _cache[1] || (_cache[1] = ($event) => $setup.fieldData = $event),
      _cache[2] || (_cache[2] = ($event) => {
        var _a2, _b;
        return (_b = (_a2 = $props.field) == null ? void 0 : _a2.onUpdate) == null ? void 0 : _b.call(_a2, $event, $setup.formData);
      })
    ],
    required: $props.field.required,
    class: $setup.computedClass,
    label: $props.field.label,
    placeholder: $props.field.placeholder || $props.field.label,
    defaultValue: $props.field.defaultValue,
    disabled: $props.field.disabled,
    options: $setup.computedOptions,
    helptext: $props.field.helptext
  }), {
    default: withCtx(() => [
      createTextVNode(
        toDisplayString($setup.computedFieldData) + " ",
        1
        /* TEXT */
      ),
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($props.field.children, (child, ii) => {
          return openBlock(), createBlock(_component_BglField, {
            key: child.id || ii,
            modelValue: $setup.formData,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.formData = $event),
            field: child
          }, null, 8, ["modelValue", "field"]);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ]),
    _: 1
    /* STABLE */
  }, 16, ["id", "modelValue", "required", "class", "label", "placeholder", "defaultValue", "disabled", "options", "helptext"])) : createCommentVNode("v-if", true);
}
const BglField = /* @__PURE__ */ _export_sfc(_sfc_main$S, [["render", _sfc_render$S], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/BglField.vue"]]);
const _sfc_main$R = /* @__PURE__ */ defineComponent({
  __name: "BglForm",
  props: {
    label: { type: String, required: false },
    id: { type: String, required: false },
    schema: { type: null, required: true },
    modelValue: { type: Object, required: false, default: () => ({}) },
    onDelete: { type: Function, required: false },
    onSubmit: { type: Function, required: false },
    status: { type: String, required: false }
  },
  emits: ["update:modelValue", "submit", "dirty"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const slots = useSlots();
    const { showModal } = useModal();
    const instAt = /* @__PURE__ */ new Date();
    const timeSinceInst = () => Date.now() - instAt.getTime();
    let formData = ref(props2.modelValue || {});
    let isDirty = ref(false);
    let data2 = computed({
      set: (val) => {
        if (timeSinceInst() > 100) {
          emit2("dirty");
          isDirty.value = true;
        }
        formData.value = val;
        emit2("update:modelValue", val);
      },
      get: () => formData.value
    });
    const form = ref();
    function validateForm() {
      setTimeout(() => {
        var _a2;
        return (_a2 = form.value) == null ? void 0 : _a2.reportValidity();
      }, 300);
      if (!form.value) return false;
      return form.value.reportValidity();
    }
    const clearForm = () => data2.value = {};
    watch(
      () => props2.status,
      (status) => {
        if (status === "success") {
          isDirty.value = false;
          clearForm();
        }
      },
      { immediate: true }
    );
    function runSubmit() {
      const isValid2 = validateForm();
      if (!isValid2) return;
      emit2("submit", { ...formData.value });
      isDirty.value = false;
    }
    const i18nT = (val) => val;
    function deleteItem() {
      showModal(
        {
          class: "small-modal",
          title: i18nT("Are you sure?"),
          actions: [
            {
              value: "Confirm",
              color: "red",
              onClick: () => {
                var _a2;
                return (_a2 = props2.onDelete) == null ? void 0 : _a2.call(props2, data2.value.value.id);
              }
            },
            { value: "Cancel", color: "gray" }
          ]
        },
        { default: i18nT("form.deleteMessage") }
      );
    }
    const computedSchema = computed(
      () => useBglSchema({ schema: props2.schema })
    );
    __expose({
      submit: runSubmit,
      validateForm,
      deleteItem,
      isDirty: isDirty.value,
      clearForm
    });
    const __returned__ = { props: props2, emit: emit2, slots, showModal, instAt, timeSinceInst, get formData() {
      return formData;
    }, set formData(v) {
      formData = v;
    }, get isDirty() {
      return isDirty;
    }, set isDirty(v) {
      isDirty = v;
    }, get data() {
      return data2;
    }, set data(v) {
      data2 = v;
    }, form, validateForm, clearForm, runSubmit, i18nT, deleteItem, computedSchema, get BglField() {
      return BglField;
    }, get Title() {
      return Title;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$R(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      $props.id ? (openBlock(), createElementBlock(
        Fragment,
        { key: 0 },
        [
          $props.label ? (openBlock(), createBlock($setup["Title"], {
            key: 0,
            tag: "h4",
            label: $props.label
          }, null, 8, ["label"])) : createCommentVNode("v-if", true),
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList($setup.computedSchema, (field, i) => {
              return openBlock(), createBlock($setup["BglField"], {
                key: field.id || `${i}p`,
                modelValue: $setup.data,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.data = $event),
                field
              }, null, 8, ["modelValue", "field"]);
            }),
            128
            /* KEYED_FRAGMENT */
          )),
          renderSlot(_ctx.$slots, "submit", {
            submit: $setup.runSubmit,
            isDirty: $setup.isDirty,
            validateForm: $setup.validateForm
          })
        ],
        64
        /* STABLE_FRAGMENT */
      )) : !$setup.slots.success || $props.status !== "success" ? (openBlock(), createElementBlock(
        "form",
        {
          key: 1,
          ref: "form",
          onSubmit: withModifiers($setup.runSubmit, ["prevent"])
        },
        [
          $props.label ? (openBlock(), createBlock($setup["Title"], {
            key: 0,
            tag: "h4",
            label: $props.label
          }, null, 8, ["label"])) : createCommentVNode("v-if", true),
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList($setup.computedSchema, (field, i) => {
              return openBlock(), createBlock($setup["BglField"], {
                key: field.id || `${i}p`,
                modelValue: $setup.data,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.data = $event),
                field
              }, null, 8, ["modelValue", "field"]);
            }),
            128
            /* KEYED_FRAGMENT */
          )),
          renderSlot(_ctx.$slots, "submit", {
            submit: $setup.runSubmit,
            isDirty: $setup.isDirty,
            validateForm: $setup.validateForm
          })
        ],
        544
        /* NEED_HYDRATION, NEED_PATCH */
      )) : createCommentVNode("v-if", true),
      $props.status === "success" ? renderSlot(_ctx.$slots, "success", { key: 2 }) : createCommentVNode("v-if", true),
      $props.status === "error" ? renderSlot(_ctx.$slots, "error", { key: 3 }) : createCommentVNode("v-if", true)
    ],
    64
    /* STABLE_FRAGMENT */
  );
}
const BagelForm = /* @__PURE__ */ _export_sfc(_sfc_main$R, [["render", _sfc_render$R], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/BglForm.vue"]]);
const _sfc_main$Q = /* @__PURE__ */ defineComponent({
  __name: "BglMultiStepForm",
  props: /* @__PURE__ */ mergeModels({
    bagelFormProps: { type: Object, required: false, default: () => ({}) },
    schema: { type: null, required: true }
  }, {
    "modelValue": { type: null, ...{ default: () => {
    }, required: true } },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["submit"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    var _a2, _b, _c, _d;
    const props2 = __props;
    const emits = __emit;
    const formRef = ref();
    const formData = useModel(
      __props,
      "modelValue"
    );
    function reportValidity() {
      if (!formRef.value) return false;
      return formRef.value.validateForm();
    }
    const computedSchema = computed(
      () => useBglSchema({ schema: props2.schema })
    );
    const numberOfSteps = ref(computedSchema.value.length);
    let currentStep = ref(0);
    const currentStepSchema = computed(() => computedSchema.value[currentStep.value]);
    let isStepping = ref(false);
    let isSteppingTO;
    watch(
      () => currentStep.value,
      () => {
        clearTimeout(isSteppingTO);
        isStepping.value = true;
        isSteppingTO = setTimeout(() => isStepping.value = false, 600);
      }
    );
    const canDoNext = computed(() => currentStep.value < numberOfSteps.value - 1);
    function prevStep() {
      if (currentStep.value > 0) currentStep.value--;
    }
    function nextStep() {
      if (reportValidity() === false) return;
      if (canDoNext.value) currentStep.value++;
    }
    function handleSubmit() {
      if (reportValidity() === false) return;
      emits("submit", formData.value);
    }
    __expose({
      submit: handleSubmit,
      validateForm: (_a2 = formRef.value) == null ? void 0 : _a2.validateForm,
      deleteItem: (_b = formRef.value) == null ? void 0 : _b.deleteItem,
      isDirty: (_c = formRef.value) == null ? void 0 : _c.isDirty,
      clearForm: (_d = formRef.value) == null ? void 0 : _d.clearForm
    });
    const __returned__ = { props: props2, emits, formRef, formData, reportValidity, computedSchema, numberOfSteps, get currentStep() {
      return currentStep;
    }, set currentStep(v) {
      currentStep = v;
    }, currentStepSchema, get isStepping() {
      return isStepping;
    }, set isStepping(v) {
      isStepping = v;
    }, get isSteppingTO() {
      return isSteppingTO;
    }, set isSteppingTO(v) {
      isSteppingTO = v;
    }, canDoNext, prevStep, nextStep, handleSubmit, get BagelForm() {
      return BagelForm;
    }, get Btn() {
      return Btn;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$H = { key: 0 };
function _sfc_render$Q(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      createVNode(Transition, {
        duration: 600,
        name: "fade",
        mode: "out-in"
      }, {
        default: withCtx(() => [
          !$setup.isStepping ? (openBlock(), createElementBlock("div", _hoisted_1$H, [
            createVNode($setup["BagelForm"], mergeProps({
              ref: "formRef",
              modelValue: $setup.formData,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.formData = $event),
              schema: [$setup.currentStepSchema]
            }, $props.bagelFormProps), {
              success: withCtx(() => [
                renderSlot(_ctx.$slots, "success")
              ]),
              error: withCtx(() => [
                renderSlot(_ctx.$slots, "error")
              ]),
              _: 3
              /* FORWARDED */
            }, 16, ["modelValue", "schema"])
          ])) : createCommentVNode("v-if", true)
        ]),
        _: 3
        /* FORWARDED */
      }),
      renderSlot(_ctx.$slots, "steppers", normalizeProps(guardReactiveProps({ prevStep: $setup.prevStep, nextStep: $setup.nextStep, submit: $setup.handleSubmit })), () => [
        createVNode($setup["Btn"], {
          disabled: $setup.currentStep === 0,
          value: "Back",
          onClick: $setup.prevStep
        }, null, 8, ["disabled"]),
        $setup.canDoNext ? (openBlock(), createBlock($setup["Btn"], {
          key: 0,
          value: "Next",
          onClick: $setup.nextStep
        })) : (openBlock(), createBlock($setup["Btn"], {
          key: 1,
          value: "Submit",
          onClick: $setup.handleSubmit
        }))
      ])
    ],
    64
    /* STABLE_FRAGMENT */
  );
}
const BglMultiStepForm = /* @__PURE__ */ _export_sfc(_sfc_main$Q, [["render", _sfc_render$Q], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/BglMultiStepForm.vue"]]);
const _sfc_main$P = /* @__PURE__ */ defineComponent({
  __name: "FieldArray",
  props: {
    el: { type: null, required: false, default: "div" },
    id: { type: String, required: true },
    label: { type: String, required: false },
    placeholder: { type: String, required: false },
    children: { type: Array, required: false },
    class: { type: [String, Number, Boolean, Object], required: false, skipCheck: true },
    attrs: { type: Object, required: false },
    required: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
    helptext: { type: String, required: false },
    options: { type: null, required: false },
    defaultValue: { type: null, required: false },
    add: { type: Boolean, required: false, default: true },
    delete: { type: Boolean, required: false, default: true },
    schema: { type: null, required: true },
    modelValue: { type: Array, required: true }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const data2 = ref(props2.modelValue || []);
    function emitValue() {
      emit2("update:modelValue", data2.value);
    }
    function deleteItem(i) {
      data2.value.splice(i, 1);
      emitValue();
    }
    function addItem() {
      data2.value.push({});
      emitValue();
    }
    const __returned__ = { props: props2, emit: emit2, data: data2, emitValue, deleteItem, addItem, get BglForm() {
      return BagelForm;
    }, get Btn() {
      return Btn;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$G = { class: "label mb-05" };
const _hoisted_2$v = { class: "-ms-05 ps-05 border-start" };
function _sfc_render$P(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createElementVNode(
      "p",
      _hoisted_1$G,
      toDisplayString($props.label),
      1
      /* TEXT */
    ),
    createElementVNode("div", _hoisted_2$v, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($setup.data, (_2, i) => {
          return openBlock(), createElementBlock("div", {
            key: i,
            outline: "",
            thin: "",
            class: "mb-05 itemBox transition p-05"
          }, [
            $props.schema ? (openBlock(), createBlock($setup["BglForm"], {
              key: 0,
              modelValue: $setup.data[i],
              "onUpdate:modelValue": [($event) => $setup.data[i] = $event, $setup.emitValue],
              schema: $props.schema
            }, null, 8, ["modelValue", "onUpdate:modelValue", "schema"])) : createCommentVNode("v-if", true),
            $setup.props.delete ? (openBlock(), createBlock($setup["Btn"], {
              key: 1,
              icon: "delete",
              value: "Delete",
              class: "txt10 opacity-7 color-red",
              thin: "",
              flat: "",
              onClick: ($event) => $setup.deleteItem(i)
            }, null, 8, ["onClick"])) : createCommentVNode("v-if", true)
          ]);
        }),
        128
        /* KEYED_FRAGMENT */
      )),
      $props.add ? (openBlock(), createBlock($setup["Btn"], {
        key: 0,
        thin: "",
        icon: "add",
        color: "gray",
        class: "txt12",
        onClick: $setup.addItem
      }, {
        default: withCtx(() => [
          createElementVNode(
            "p",
            null,
            "Add " + toDisplayString($props.label),
            1
            /* TEXT */
          )
        ]),
        _: 1
        /* STABLE */
      })) : createCommentVNode("v-if", true)
    ])
  ]);
}
const FieldArray = /* @__PURE__ */ _export_sfc(_sfc_main$P, [["render", _sfc_render$P], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/FieldArray.vue"]]);
const _sfc_main$O = /* @__PURE__ */ defineComponent({
  __name: "Checkbox",
  props: {
    "modelValue": { type: Boolean, ...{ default: false } },
    "modelModifiers": {}
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const val = useModel(__props, "modelValue");
    const __returned__ = { val };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$F = { class: "primary-checkbox" };
function _sfc_render$O(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("label", _hoisted_1$F, [
    renderSlot(_ctx.$slots, "label", {}, void 0, true),
    withDirectives(createElementVNode(
      "input",
      {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.val = $event),
        type: "checkbox"
      },
      null,
      512
      /* NEED_PATCH */
    ), [
      [vModelCheckbox, $setup.val]
    ])
  ]);
}
const Checkbox = /* @__PURE__ */ _export_sfc(_sfc_main$O, [["render", _sfc_render$O], ["__scopeId", "data-v-f63c100f"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/Checkbox.vue"]]);
const _sfc_main$N = /* @__PURE__ */ defineComponent({
  __name: "CheckInput",
  props: /* @__PURE__ */ mergeModels({
    label: { type: String, required: false },
    id: { type: String, required: false },
    title: { type: String, required: false },
    small: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    defaultValue: { type: Boolean, required: false, default: false },
    value: { type: null, required: false }
  }, {
    "modelValue": { type: [Boolean, Array], skipCheck: true, ...{ default: void 0 } },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const inputId = computed(() => props2.id || Math.random().toString(36).slice(7));
    const checked = useModel(__props, "modelValue");
    onMounted(() => {
      if (checked.value === void 0) checked.value = props2.defaultValue;
    });
    const __returned__ = { props: props2, inputId, checked };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$E = ["title"];
const _hoisted_2$u = ["id", "value", "required"];
const _hoisted_3$n = ["for"];
function _sfc_render$N(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["bagel-input bgl-checkbox align-items-center ps-025", { small: $props.small }]),
    title: $props.title
  }, [
    withDirectives(createElementVNode("input", {
      id: $setup.inputId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.checked = $event),
      value: $props.value,
      required: $props.required,
      type: "checkbox",
      class: "me-05"
    }, null, 8, _hoisted_2$u), [
      [vModelCheckbox, $setup.checked]
    ]),
    createElementVNode("label", { for: $setup.inputId }, [
      renderSlot(_ctx.$slots, "label", {}, () => [
        createTextVNode(
          toDisplayString($props.label),
          1
          /* TEXT */
        )
      ], true)
    ], 8, _hoisted_3$n)
  ], 10, _hoisted_1$E);
}
const CheckInput = /* @__PURE__ */ _export_sfc(_sfc_main$N, [["render", _sfc_render$N], ["__scopeId", "data-v-b8cbf850"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/CheckInput.vue"]]);
const _sfc_main$M = /* @__PURE__ */ defineComponent({
  __name: "Index",
  props: {
    language: { type: null, required: false },
    readonly: { type: Boolean, required: false, default: false },
    modelValue: { type: String, required: false, default: "" },
    autodetect: { type: Boolean, required: false },
    ignoreIllegals: { type: Boolean, required: false, default: true }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit2 = __emit;
    let hljs = ref(null);
    let code = ref("");
    const textarea = ref();
    let height = ref("300px");
    let loaded = ref(false);
    const cannotDetectLanguage = computed(() => {
      var _a2;
      const lang = __props.language || "";
      return !(__props.autodetect ?? !lang) && !((_a2 = hljs.value) == null ? void 0 : _a2.getLanguage(lang));
    });
    const className = computed(() => {
      if (cannotDetectLanguage.value) return "";
      return `hljs ${__props.language || ""}`;
    });
    const highlightedCode = computed(() => {
      var _a2, _b;
      if (cannotDetectLanguage.value) {
        console.warn(`The language "${__props.language}" you specified could not be found.`);
        return escapeHtml(code.value);
      }
      const lang = __props.language || "";
      const result2 = __props.autodetect ? (_a2 = hljs.value) == null ? void 0 : _a2.highlightAuto(code.value) : (_b = hljs.value) == null ? void 0 : _b.highlight(code.value, { language: lang, ignoreIllegals: __props.ignoreIllegals });
      return (result2 == null ? void 0 : result2.value) || "";
    });
    function escapeHtml(unsafe) {
      return unsafe.replace(/[&<>"']/g, (m2) => {
        const replacements = {
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          '"': "&quot;",
          "'": "&#039;"
        };
        return replacements[m2] || "";
      });
    }
    function handleTab(event) {
      const target = event.target;
      const start = target.selectionStart;
      const tab = "  ";
      code.value = code.value.slice(0, start) + tab + code.value.slice(start);
      nextTick(() => {
        target.selectionStart = target.selectionEnd = start + tab.length;
      });
    }
    function adjustHeight() {
      var _a2;
      if (((_a2 = textarea.value) == null ? void 0 : _a2.scrollHeight) && textarea.value.scrollHeight > 300) {
        height.value = `${textarea.value.scrollHeight}px`;
      }
    }
    onMounted(async () => {
      await appendScript("https://cdnjs.cloudflare.com/ajax/libs/highlight.js/11.11.0/highlight.min.js", { id: "hljs-cdn" });
      await appendStyle("https://cdn.jsdelivr.net/npm/highlight.js/styles/atom-one-dark.min.css");
      if (window.hljs) {
        hljs.value = window.hljs;
        loaded.value = true;
      } else {
        console.error("Highlight.js failed to load.");
      }
    });
    watch(() => __props.modelValue, (newVal) => {
      adjustHeight();
      if (newVal !== code.value) {
        code.value = newVal;
      }
    }, { immediate: true });
    const __returned__ = { emit: emit2, get hljs() {
      return hljs;
    }, set hljs(v) {
      hljs = v;
    }, get code() {
      return code;
    }, set code(v) {
      code = v;
    }, textarea, get height() {
      return height;
    }, set height(v) {
      height = v;
    }, get loaded() {
      return loaded;
    }, set loaded(v) {
      loaded = v;
    }, cannotDetectLanguage, className, highlightedCode, escapeHtml, handleTab, adjustHeight };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$D = {
  key: 0,
  class: "code-editor-wrap grid rounded p-1 overflow hm-300px"
};
const _hoisted_2$t = { class: "overflow-hidden absolute inset-0 p-0 m-0 h-100 codeText" };
const _hoisted_3$m = ["innerHTML"];
const _hoisted_4$f = ["onKeydown"];
function _sfc_render$M(_ctx, _cache, $props, $setup, $data, $options) {
  return $setup.loaded ? (openBlock(), createElementBlock("div", _hoisted_1$D, [
    createElementVNode(
      "div",
      {
        class: "relative block h-100",
        style: normalizeStyle({ height: $setup.height })
      },
      [
        createElementVNode("pre", _hoisted_2$t, [
          _cache[2] || (_cache[2] = createTextVNode("				")),
          createElementVNode("code", {
            class: normalizeClass($setup.className),
            innerHTML: $setup.highlightedCode
          }, null, 10, _hoisted_3$m),
          _cache[3] || (_cache[3] = createTextVNode("\n			"))
        ]),
        !$props.readonly ? withDirectives((openBlock(), createElementBlock("textarea", {
          key: 0,
          ref: "textarea",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.code = $event),
          class: "code-editor absolute inset-0 bg-transparent overflow-hidden h-100 p-0 m-0 codeText border-none",
          spellcheck: "false",
          placeholder: "Write your code here",
          "aria-label": "Code Editor",
          "data-gramm": "false",
          onKeydown: withKeys(withModifiers($setup.handleTab, ["prevent"]), ["tab"]),
          onInput: _cache[1] || (_cache[1] = ($event) => $setup.emit("update:modelValue", $setup.code))
        }, null, 40, _hoisted_4$f)), [
          [vModelText, $setup.code]
        ]) : createCommentVNode("v-if", true)
      ],
      4
      /* STYLE */
    )
  ])) : createCommentVNode("v-if", true);
}
const CodeEditor = /* @__PURE__ */ _export_sfc(_sfc_main$M, [["render", _sfc_render$M], ["__scopeId", "data-v-c6474dd9"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/CodeEditor/Index.vue"]]);
const _sfc_main$L = /* @__PURE__ */ defineComponent({
  __name: "ColorPicker",
  props: {
    label: { type: String, required: false },
    id: { type: String, required: false },
    placeholder: { type: String, required: false },
    modelValue: { type: null, required: true },
    editMode: { type: Boolean, required: false, default: true },
    small: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    nativeInputAttrs: { type: Object, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emits = __emit;
    const inputVal = ref(props2.modelValue);
    watch(
      () => inputVal.value,
      (newVal) => {
        emits("update:modelValue", newVal);
      }
    );
    const __returned__ = { props: props2, emits, inputVal };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$C = ["title"];
const _hoisted_2$s = ["id", "placeholder", "required"];
function _sfc_render$L(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.id ? (openBlock(), createElementBlock("div", {
    key: 0,
    class: normalizeClass(["bagel-input", { small: $props.small }]),
    title: $props.label
  }, [
    createElementVNode("label", null, [
      createTextVNode(
        toDisplayString($props.label) + " ",
        1
        /* TEXT */
      ),
      withDirectives(createElementVNode("input", mergeProps({
        id: $props.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.inputVal = $event),
        type: "color",
        placeholder: $props.placeholder || $props.label,
        class: { "no-edit": !$props.editMode },
        required: $props.required
      }, $props.nativeInputAttrs), null, 16, _hoisted_2$s), [
        [vModelText, $setup.inputVal]
      ])
    ])
  ], 10, _hoisted_1$C)) : createCommentVNode("v-if", true);
}
const ColorPicker = /* @__PURE__ */ _export_sfc(_sfc_main$L, [["render", _sfc_render$L], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/ColorPicker.vue"]]);
function toDate(argument) {
  const argStr = Object.prototype.toString.call(argument);
  if (argument instanceof Date || typeof argument === "object" && argStr === "[object Date]") {
    return new argument.constructor(+argument);
  } else if (typeof argument === "number" || argStr === "[object Number]" || typeof argument === "string" || argStr === "[object String]") {
    return new Date(argument);
  } else {
    return /* @__PURE__ */ new Date(NaN);
  }
}
function constructFrom(date2, value) {
  if (date2 instanceof Date) {
    return new date2.constructor(value);
  } else {
    return new Date(value);
  }
}
function addDays(date2, amount) {
  const _date = toDate(date2);
  if (isNaN(amount)) return constructFrom(date2, NaN);
  if (!amount) {
    return _date;
  }
  _date.setDate(_date.getDate() + amount);
  return _date;
}
function addMonths(date2, amount) {
  const _date = toDate(date2);
  if (isNaN(amount)) return constructFrom(date2, NaN);
  if (!amount) {
    return _date;
  }
  const dayOfMonth = _date.getDate();
  const endOfDesiredMonth = constructFrom(date2, _date.getTime());
  endOfDesiredMonth.setMonth(_date.getMonth() + amount + 1, 0);
  const daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    return endOfDesiredMonth;
  } else {
    _date.setFullYear(
      endOfDesiredMonth.getFullYear(),
      endOfDesiredMonth.getMonth(),
      dayOfMonth
    );
    return _date;
  }
}
function add(date2, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const _date = toDate(date2);
  const dateWithMonths = months || years ? addMonths(_date, months + years * 12) : _date;
  const dateWithDays = days || weeks ? addDays(dateWithMonths, days + weeks * 7) : dateWithMonths;
  const minutesToAdd = minutes + hours * 60;
  const secondsToAdd = seconds + minutesToAdd * 60;
  const msToAdd = secondsToAdd * 1e3;
  const finalDate = constructFrom(date2, dateWithDays.getTime() + msToAdd);
  return finalDate;
}
function addMilliseconds(date2, amount) {
  const timestamp = +toDate(date2);
  return constructFrom(date2, timestamp + amount);
}
const millisecondsInWeek = 6048e5;
const millisecondsInDay = 864e5;
const millisecondsInMinute = 6e4;
const millisecondsInHour = 36e5;
const millisecondsInSecond = 1e3;
function addHours(date2, amount) {
  return addMilliseconds(date2, amount * millisecondsInHour);
}
let defaultOptions = {};
function getDefaultOptions$1() {
  return defaultOptions;
}
function startOfWeek(date2, options) {
  var _a2, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a2 = options == null ? void 0 : options.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date2);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  _date.setDate(_date.getDate() - diff);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function startOfISOWeek(date2) {
  return startOfWeek(date2, { weekStartsOn: 1 });
}
function getISOWeekYear(date2) {
  const _date = toDate(date2);
  const year = _date.getFullYear();
  const fourthOfJanuaryOfNextYear = constructFrom(date2, 0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  const fourthOfJanuaryOfThisYear = constructFrom(date2, 0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfDay(date2) {
  const _date = toDate(date2);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function getTimezoneOffsetInMilliseconds(date2) {
  const _date = toDate(date2);
  const utcDate = new Date(
    Date.UTC(
      _date.getFullYear(),
      _date.getMonth(),
      _date.getDate(),
      _date.getHours(),
      _date.getMinutes(),
      _date.getSeconds(),
      _date.getMilliseconds()
    )
  );
  utcDate.setUTCFullYear(_date.getFullYear());
  return +date2 - +utcDate;
}
function differenceInCalendarDays(dateLeft, dateRight) {
  const startOfDayLeft = startOfDay(dateLeft);
  const startOfDayRight = startOfDay(dateRight);
  const timestampLeft = +startOfDayLeft - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  const timestampRight = +startOfDayRight - getTimezoneOffsetInMilliseconds(startOfDayRight);
  return Math.round((timestampLeft - timestampRight) / millisecondsInDay);
}
function startOfISOWeekYear(date2) {
  const year = getISOWeekYear(date2);
  const fourthOfJanuary = constructFrom(date2, 0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  return startOfISOWeek(fourthOfJanuary);
}
function addQuarters(date2, amount) {
  const months = amount * 3;
  return addMonths(date2, months);
}
function addYears(date2, amount) {
  return addMonths(date2, amount * 12);
}
function compareAsc(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const diff = _dateLeft.getTime() - _dateRight.getTime();
  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1;
  } else {
    return diff;
  }
}
function isDate$2(value) {
  return value instanceof Date || typeof value === "object" && Object.prototype.toString.call(value) === "[object Date]";
}
function isValid(date2) {
  if (!isDate$2(date2) && typeof date2 !== "number") {
    return false;
  }
  const _date = toDate(date2);
  return !isNaN(Number(_date));
}
function getQuarter(date2) {
  const _date = toDate(date2);
  const quarter = Math.trunc(_date.getMonth() / 3) + 1;
  return quarter;
}
function differenceInCalendarYears(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  return _dateLeft.getFullYear() - _dateRight.getFullYear();
}
function differenceInYears(dateLeft, dateRight) {
  const _dateLeft = toDate(dateLeft);
  const _dateRight = toDate(dateRight);
  const sign2 = compareAsc(_dateLeft, _dateRight);
  const difference = Math.abs(differenceInCalendarYears(_dateLeft, _dateRight));
  _dateLeft.setFullYear(1584);
  _dateRight.setFullYear(1584);
  const isLastYearNotFull = compareAsc(_dateLeft, _dateRight) === -sign2;
  const result2 = sign2 * (difference - +isLastYearNotFull);
  return result2 === 0 ? 0 : result2;
}
function eachDayOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startDate : +endDate;
  const currentDate = reversed ? endDate : startDate;
  currentDate.setHours(0, 0, 0, 0);
  let step = 1;
  const dates = [];
  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    currentDate.setDate(currentDate.getDate() + step);
    currentDate.setHours(0, 0, 0, 0);
  }
  return reversed ? dates.reverse() : dates;
}
function startOfQuarter(date2) {
  const _date = toDate(date2);
  const currentMonth = _date.getMonth();
  const month = currentMonth - currentMonth % 3;
  _date.setMonth(month, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function eachQuarterOfInterval(interval, options) {
  const startDate = toDate(interval.start);
  const endDate = toDate(interval.end);
  let reversed = +startDate > +endDate;
  const endTime = reversed ? +startOfQuarter(startDate) : +startOfQuarter(endDate);
  let currentDate = reversed ? startOfQuarter(endDate) : startOfQuarter(startDate);
  let step = 1;
  const dates = [];
  while (+currentDate <= endTime) {
    dates.push(toDate(currentDate));
    currentDate = addQuarters(currentDate, step);
  }
  return reversed ? dates.reverse() : dates;
}
function startOfMonth(date2) {
  const _date = toDate(date2);
  _date.setDate(1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function endOfYear(date2) {
  const _date = toDate(date2);
  const year = _date.getFullYear();
  _date.setFullYear(year + 1, 0, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function startOfYear(date2) {
  const cleanDate = toDate(date2);
  const _date = constructFrom(date2, 0);
  _date.setFullYear(cleanDate.getFullYear(), 0, 1);
  _date.setHours(0, 0, 0, 0);
  return _date;
}
function endOfWeek(date2, options) {
  var _a2, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a2 = options == null ? void 0 : options.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date2);
  const day = _date.getDay();
  const diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn);
  _date.setDate(_date.getDate() + diff);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
function endOfQuarter(date2) {
  const _date = toDate(date2);
  const currentMonth = _date.getMonth();
  const month = currentMonth - currentMonth % 3 + 3;
  _date.setMonth(month, 0);
  _date.setHours(23, 59, 59, 999);
  return _date;
}
const formatDistanceLocale = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
};
const formatDistance = (token, count2, options) => {
  let result2;
  const tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === "string") {
    result2 = tokenValue;
  } else if (count2 === 1) {
    result2 = tokenValue.one;
  } else {
    result2 = tokenValue.other.replace("{{count}}", count2.toString());
  }
  if (options == null ? void 0 : options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return "in " + result2;
    } else {
      return result2 + " ago";
    }
  }
  return result2;
};
function buildFormatLongFn(args) {
  return (options = {}) => {
    const width = options.width ? String(options.width) : args.defaultWidth;
    const format2 = args.formats[width] || args.formats[args.defaultWidth];
    return format2;
  };
}
const dateFormats = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
};
const timeFormats = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
};
const dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
};
const formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: "full"
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: "full"
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: "full"
  })
};
const formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
};
const formatRelative = (token, _date, _baseDate, _options) => formatRelativeLocale[token];
function buildLocalizeFn(args) {
  return (value, options) => {
    const context = (options == null ? void 0 : options.context) ? String(options.context) : "standalone";
    let valuesArray;
    if (context === "formatting" && args.formattingValues) {
      const defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      const defaultWidth = args.defaultWidth;
      const width = (options == null ? void 0 : options.width) ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[width] || args.values[defaultWidth];
    }
    const index2 = args.argumentCallback ? args.argumentCallback(value) : value;
    return valuesArray[index2];
  };
}
const eraValues = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
};
const quarterValues = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
};
const monthValues = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
};
const dayValues = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
};
const dayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
};
const formattingDayPeriodValues = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
};
const ordinalNumber = (dirtyNumber, _options) => {
  const number2 = Number(dirtyNumber);
  const rem100 = number2 % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number2 + "st";
      case 2:
        return number2 + "nd";
      case 3:
        return number2 + "rd";
    }
  }
  return number2 + "th";
};
const localize = {
  ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: "wide"
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: "wide",
    argumentCallback: (quarter) => quarter - 1
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: "wide"
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: "wide"
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: "wide",
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: "wide"
  })
};
function buildMatchFn(args) {
  return (string2, options = {}) => {
    const width = options.width;
    const matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    const matchResult = string2.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    const matchedString = matchResult[0];
    const parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    const key = Array.isArray(parsePatterns) ? findIndex(parsePatterns, (pattern2) => pattern2.test(matchedString)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      findKey$1(parsePatterns, (pattern2) => pattern2.test(matchedString))
    );
    let value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      options.valueCallback(value)
    ) : value;
    const rest = string2.slice(matchedString.length);
    return { value, rest };
  };
}
function findKey$1(object2, predicate) {
  for (const key in object2) {
    if (Object.prototype.hasOwnProperty.call(object2, key) && predicate(object2[key])) {
      return key;
    }
  }
  return void 0;
}
function findIndex(array2, predicate) {
  for (let key = 0; key < array2.length; key++) {
    if (predicate(array2[key])) {
      return key;
    }
  }
  return void 0;
}
function buildMatchPatternFn(args) {
  return (string2, options = {}) => {
    const matchResult = string2.match(args.matchPattern);
    if (!matchResult) return null;
    const matchedString = matchResult[0];
    const parseResult = string2.match(args.parsePattern);
    if (!parseResult) return null;
    let value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    const rest = string2.slice(matchedString.length);
    return { value, rest };
  };
}
const matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
const parseOrdinalNumberPattern = /\d+/i;
const matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
const parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
const matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
const parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
const matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
const parseMonthPatterns = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
};
const matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
const parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
const matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
const parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
const match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: (value) => parseInt(value, 10)
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseEraPatterns,
    defaultParseWidth: "any"
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: "any",
    valueCallback: (index2) => index2 + 1
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: "any"
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: "wide",
    parsePatterns: parseDayPatterns,
    defaultParseWidth: "any"
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: "any",
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: "any"
  })
};
const enUS = {
  code: "en-US",
  formatDistance,
  formatLong,
  formatRelative,
  localize,
  match,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function getDayOfYear(date2) {
  const _date = toDate(date2);
  const diff = differenceInCalendarDays(_date, startOfYear(_date));
  const dayOfYear = diff + 1;
  return dayOfYear;
}
function getISOWeek(date2) {
  const _date = toDate(date2);
  const diff = +startOfISOWeek(_date) - +startOfISOWeekYear(_date);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function getWeekYear(date2, options) {
  var _a2, _b, _c, _d;
  const _date = toDate(date2);
  const year = _date.getFullYear();
  const defaultOptions2 = getDefaultOptions$1();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a2 = options == null ? void 0 : options.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const firstWeekOfNextYear = constructFrom(date2, 0);
  firstWeekOfNextYear.setFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setHours(0, 0, 0, 0);
  const startOfNextYear = startOfWeek(firstWeekOfNextYear, options);
  const firstWeekOfThisYear = constructFrom(date2, 0);
  firstWeekOfThisYear.setFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setHours(0, 0, 0, 0);
  const startOfThisYear = startOfWeek(firstWeekOfThisYear, options);
  if (_date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (_date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}
function startOfWeekYear(date2, options) {
  var _a2, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a2 = options == null ? void 0 : options.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const year = getWeekYear(date2, options);
  const firstWeek = constructFrom(date2, 0);
  firstWeek.setFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setHours(0, 0, 0, 0);
  const _date = startOfWeek(firstWeek, options);
  return _date;
}
function getWeek(date2, options) {
  const _date = toDate(date2);
  const diff = +startOfWeek(_date, options) - +startOfWeekYear(_date, options);
  return Math.round(diff / millisecondsInWeek) + 1;
}
function addLeadingZeros(number2, targetLength) {
  const sign2 = number2 < 0 ? "-" : "";
  const output = Math.abs(number2).toString().padStart(targetLength, "0");
  return sign2 + output;
}
const lightFormatters = {
  // Year
  y(date2, token) {
    const signedYear = date2.getFullYear();
    const year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === "yy" ? year % 100 : year, token.length);
  },
  // Month
  M(date2, token) {
    const month = date2.getMonth();
    return token === "M" ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d(date2, token) {
    return addLeadingZeros(date2.getDate(), token.length);
  },
  // AM or PM
  a(date2, token) {
    const dayPeriodEnumValue = date2.getHours() / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return dayPeriodEnumValue.toUpperCase();
      case "aaa":
        return dayPeriodEnumValue;
      case "aaaaa":
        return dayPeriodEnumValue[0];
      case "aaaa":
      default:
        return dayPeriodEnumValue === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(date2, token) {
    return addLeadingZeros(date2.getHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H(date2, token) {
    return addLeadingZeros(date2.getHours(), token.length);
  },
  // Minute
  m(date2, token) {
    return addLeadingZeros(date2.getMinutes(), token.length);
  },
  // Second
  s(date2, token) {
    return addLeadingZeros(date2.getSeconds(), token.length);
  },
  // Fraction of second
  S(date2, token) {
    const numberOfDigits = token.length;
    const milliseconds = date2.getMilliseconds();
    const fractionalSeconds = Math.trunc(
      milliseconds * Math.pow(10, numberOfDigits - 3)
    );
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
const dayPeriodEnum = {
  am: "am",
  pm: "pm",
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
};
const formatters = {
  // Era
  G: function(date2, token, localize2) {
    const era = date2.getFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return localize2.era(era, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return localize2.era(era, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return localize2.era(era, { width: "wide" });
    }
  },
  // Year
  y: function(date2, token, localize2) {
    if (token === "yo") {
      const signedYear = date2.getFullYear();
      const year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize2.ordinalNumber(year, { unit: "year" });
    }
    return lightFormatters.y(date2, token);
  },
  // Local week-numbering year
  Y: function(date2, token, localize2, options) {
    const signedWeekYear = getWeekYear(date2, options);
    const weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;
    if (token === "YY") {
      const twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }
    if (token === "Yo") {
      return localize2.ordinalNumber(weekYear, { unit: "year" });
    }
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function(date2, token) {
    const isoWeekYear = getISOWeekYear(date2);
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(date2, token) {
    const year = date2.getFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function(date2, token, localize2) {
    const quarter = Math.ceil((date2.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
        return String(quarter);
      // 01, 02, 03, 04
      case "QQ":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(date2, token, localize2) {
    const quarter = Math.ceil((date2.getMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case "q":
        return String(quarter);
      // 01, 02, 03, 04
      case "qq":
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return localize2.ordinalNumber(quarter, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return localize2.quarter(quarter, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return localize2.quarter(quarter, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return localize2.quarter(quarter, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(date2, token, localize2) {
    const month = date2.getMonth();
    switch (token) {
      case "M":
      case "MM":
        return lightFormatters.M(date2, token);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return localize2.month(month, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return localize2.month(month, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return localize2.month(month, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(date2, token, localize2) {
    const month = date2.getMonth();
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return String(month + 1);
      // 01, 02, ..., 12
      case "LL":
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return localize2.ordinalNumber(month + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return localize2.month(month, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return localize2.month(month, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return localize2.month(month, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(date2, token, localize2, options) {
    const week = getWeek(date2, options);
    if (token === "wo") {
      return localize2.ordinalNumber(week, { unit: "week" });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function(date2, token, localize2) {
    const isoWeek = getISOWeek(date2);
    if (token === "Io") {
      return localize2.ordinalNumber(isoWeek, { unit: "week" });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function(date2, token, localize2) {
    if (token === "do") {
      return localize2.ordinalNumber(date2.getDate(), { unit: "date" });
    }
    return lightFormatters.d(date2, token);
  },
  // Day of year
  D: function(date2, token, localize2) {
    const dayOfYear = getDayOfYear(date2);
    if (token === "Do") {
      return localize2.ordinalNumber(dayOfYear, { unit: "dayOfYear" });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function(date2, token, localize2) {
    const dayOfWeek = date2.getDay();
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(date2, token, localize2, options) {
    const dayOfWeek = date2.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(localDayOfWeek);
      // Padded numerical value
      case "ee":
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "eee":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(date2, token, localize2, options) {
    const dayOfWeek = date2.getDay();
    const localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case "c":
        return String(localDayOfWeek);
      // Padded numerical value
      case "cc":
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return localize2.ordinalNumber(localDayOfWeek, { unit: "day" });
      case "ccc":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(date2, token, localize2) {
    const dayOfWeek = date2.getDay();
    const isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case "i":
        return String(isoDayOfWeek);
      // 02
      case "ii":
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case "io":
        return localize2.ordinalNumber(isoDayOfWeek, { unit: "day" });
      // Tue
      case "iii":
        return localize2.day(dayOfWeek, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return localize2.day(dayOfWeek, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return localize2.day(dayOfWeek, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return localize2.day(dayOfWeek, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(date2, token, localize2) {
    const hours = date2.getHours();
    const dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    switch (token) {
      case "a":
      case "aa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(date2, token, localize2) {
    const hours = date2.getHours();
    let dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? "pm" : "am";
    }
    switch (token) {
      case "b":
      case "bb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(date2, token, localize2) {
    const hours = date2.getHours();
    let dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return localize2.dayPeriod(dayPeriodEnumValue, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(date2, token, localize2) {
    if (token === "ho") {
      let hours = date2.getHours() % 12;
      if (hours === 0) hours = 12;
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return lightFormatters.h(date2, token);
  },
  // Hour [0-23]
  H: function(date2, token, localize2) {
    if (token === "Ho") {
      return localize2.ordinalNumber(date2.getHours(), { unit: "hour" });
    }
    return lightFormatters.H(date2, token);
  },
  // Hour [0-11]
  K: function(date2, token, localize2) {
    const hours = date2.getHours() % 12;
    if (token === "Ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function(date2, token, localize2) {
    let hours = date2.getHours();
    if (hours === 0) hours = 24;
    if (token === "ko") {
      return localize2.ordinalNumber(hours, { unit: "hour" });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function(date2, token, localize2) {
    if (token === "mo") {
      return localize2.ordinalNumber(date2.getMinutes(), { unit: "minute" });
    }
    return lightFormatters.m(date2, token);
  },
  // Second
  s: function(date2, token, localize2) {
    if (token === "so") {
      return localize2.ordinalNumber(date2.getSeconds(), { unit: "second" });
    }
    return lightFormatters.s(date2, token);
  },
  // Fraction of second
  S: function(date2, token) {
    return lightFormatters.S(date2, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(date2, token, _localize) {
    const timezoneOffset = date2.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return "Z";
    }
    switch (token) {
      // Hours and optional minutes
      case "X":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(date2, token, _localize) {
    const timezoneOffset = date2.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case "x":
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (GMT)
  O: function(date2, token, _localize) {
    const timezoneOffset = date2.getTimezoneOffset();
    switch (token) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(date2, token, _localize) {
    const timezoneOffset = date2.getTimezoneOffset();
    switch (token) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + formatTimezoneShort(timezoneOffset, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + formatTimezone(timezoneOffset, ":");
    }
  },
  // Seconds timestamp
  t: function(date2, token, _localize) {
    const timestamp = Math.trunc(date2.getTime() / 1e3);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function(date2, token, _localize) {
    const timestamp = date2.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset2, delimiter = "") {
  const sign2 = offset2 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset2);
  const hours = Math.trunc(absOffset / 60);
  const minutes = absOffset % 60;
  if (minutes === 0) {
    return sign2 + String(hours);
  }
  return sign2 + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset2, delimiter) {
  if (offset2 % 60 === 0) {
    const sign2 = offset2 > 0 ? "-" : "+";
    return sign2 + addLeadingZeros(Math.abs(offset2) / 60, 2);
  }
  return formatTimezone(offset2, delimiter);
}
function formatTimezone(offset2, delimiter = "") {
  const sign2 = offset2 > 0 ? "-" : "+";
  const absOffset = Math.abs(offset2);
  const hours = addLeadingZeros(Math.trunc(absOffset / 60), 2);
  const minutes = addLeadingZeros(absOffset % 60, 2);
  return sign2 + hours + delimiter + minutes;
}
const dateLongFormatter = (pattern2, formatLong2) => {
  switch (pattern2) {
    case "P":
      return formatLong2.date({ width: "short" });
    case "PP":
      return formatLong2.date({ width: "medium" });
    case "PPP":
      return formatLong2.date({ width: "long" });
    case "PPPP":
    default:
      return formatLong2.date({ width: "full" });
  }
};
const timeLongFormatter = (pattern2, formatLong2) => {
  switch (pattern2) {
    case "p":
      return formatLong2.time({ width: "short" });
    case "pp":
      return formatLong2.time({ width: "medium" });
    case "ppp":
      return formatLong2.time({ width: "long" });
    case "pppp":
    default:
      return formatLong2.time({ width: "full" });
  }
};
const dateTimeLongFormatter = (pattern2, formatLong2) => {
  const matchResult = pattern2.match(/(P+)(p+)?/) || [];
  const datePattern = matchResult[1];
  const timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern2, formatLong2);
  }
  let dateTimeFormat;
  switch (datePattern) {
    case "P":
      dateTimeFormat = formatLong2.dateTime({ width: "short" });
      break;
    case "PP":
      dateTimeFormat = formatLong2.dateTime({ width: "medium" });
      break;
    case "PPP":
      dateTimeFormat = formatLong2.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      dateTimeFormat = formatLong2.dateTime({ width: "full" });
      break;
  }
  return dateTimeFormat.replace("{{date}}", dateLongFormatter(datePattern, formatLong2)).replace("{{time}}", timeLongFormatter(timePattern, formatLong2));
};
const longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
const dayOfYearTokenRE = /^D+$/;
const weekYearTokenRE = /^Y+$/;
const throwTokens = ["D", "DD", "YY", "YYYY"];
function isProtectedDayOfYearToken(token) {
  return dayOfYearTokenRE.test(token);
}
function isProtectedWeekYearToken(token) {
  return weekYearTokenRE.test(token);
}
function warnOrThrowProtectedError(token, format2, input) {
  const _message = message(token, format2, input);
  console.warn(_message);
  if (throwTokens.includes(token)) throw new RangeError(_message);
}
function message(token, format2, input) {
  const subject = token[0] === "Y" ? "years" : "days of the month";
  return `Use \`${token.toLowerCase()}\` instead of \`${token}\` (in \`${format2}\`) for formatting ${subject} to the input \`${input}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp$1 = /^'([^]*?)'?$/;
const doubleQuoteRegExp$1 = /''/g;
const unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;
function format(date2, formatStr, options) {
  var _a2, _b, _c, _d, _e2, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions$1();
  const locale2 = (options == null ? void 0 : options.locale) ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a2 = options == null ? void 0 : options.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_f = (_e2 = options == null ? void 0 : options.locale) == null ? void 0 : _e2.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  const originalDate = toDate(date2);
  if (!isValid(originalDate)) {
    throw new RangeError("Invalid time value");
  }
  let parts = formatStr.match(longFormattingTokensRegExp$1).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter === "p" || firstCharacter === "P") {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp$1).map((substring) => {
    if (substring === "''") {
      return { isToken: false, value: "'" };
    }
    const firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return { isToken: false, value: cleanEscapedString$1(substring) };
    }
    if (formatters[firstCharacter]) {
      return { isToken: true, value: substring };
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
      );
    }
    return { isToken: false, value: substring };
  });
  if (locale2.localize.preprocessor) {
    parts = locale2.localize.preprocessor(originalDate, parts);
  }
  const formatterOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  return parts.map((part) => {
    if (!part.isToken) return part.value;
    const token = part.value;
    if (!(options == null ? void 0 : options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token) || !(options == null ? void 0 : options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, String(date2));
    }
    const formatter = formatters[token[0]];
    return formatter(originalDate, token, locale2.localize, formatterOptions);
  }).join("");
}
function cleanEscapedString$1(input) {
  const matched = input.match(escapedStringRegExp$1);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}
function getDay(date2) {
  const _date = toDate(date2);
  const day = _date.getDay();
  return day;
}
function getDaysInMonth(date2) {
  const _date = toDate(date2);
  const year = _date.getFullYear();
  const monthIndex = _date.getMonth();
  const lastDayOfMonth = constructFrom(date2, 0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}
function getDefaultOptions() {
  return Object.assign({}, getDefaultOptions$1());
}
function getHours(date2) {
  const _date = toDate(date2);
  const hours = _date.getHours();
  return hours;
}
function getISODay(date2) {
  const _date = toDate(date2);
  let day = _date.getDay();
  if (day === 0) {
    day = 7;
  }
  return day;
}
function getMinutes(date2) {
  const _date = toDate(date2);
  const minutes = _date.getMinutes();
  return minutes;
}
function getMonth(date2) {
  const _date = toDate(date2);
  const month = _date.getMonth();
  return month;
}
function getSeconds(date2) {
  const _date = toDate(date2);
  const seconds = _date.getSeconds();
  return seconds;
}
function getYear(date2) {
  return toDate(date2).getFullYear();
}
function isAfter(date2, dateToCompare) {
  const _date = toDate(date2);
  const _dateToCompare = toDate(dateToCompare);
  return _date.getTime() > _dateToCompare.getTime();
}
function isBefore(date2, dateToCompare) {
  const _date = toDate(date2);
  const _dateToCompare = toDate(dateToCompare);
  return +_date < +_dateToCompare;
}
function isEqual(leftDate, rightDate) {
  const _dateLeft = toDate(leftDate);
  const _dateRight = toDate(rightDate);
  return +_dateLeft === +_dateRight;
}
function transpose(fromDate, constructor) {
  const date2 = constructor instanceof Date ? constructFrom(constructor, 0) : new constructor(0);
  date2.setFullYear(
    fromDate.getFullYear(),
    fromDate.getMonth(),
    fromDate.getDate()
  );
  date2.setHours(
    fromDate.getHours(),
    fromDate.getMinutes(),
    fromDate.getSeconds(),
    fromDate.getMilliseconds()
  );
  return date2;
}
const TIMEZONE_UNIT_PRIORITY = 10;
class Setter {
  constructor() {
    __publicField2(this, "subPriority", 0);
  }
  validate(_utcDate, _options) {
    return true;
  }
}
class ValueSetter extends Setter {
  constructor(value, validateValue, setValue, priority, subPriority) {
    super();
    this.value = value;
    this.validateValue = validateValue;
    this.setValue = setValue;
    this.priority = priority;
    if (subPriority) {
      this.subPriority = subPriority;
    }
  }
  validate(date2, options) {
    return this.validateValue(date2, this.value, options);
  }
  set(date2, flags, options) {
    return this.setValue(date2, flags, this.value, options);
  }
}
class DateToSystemTimezoneSetter extends Setter {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", TIMEZONE_UNIT_PRIORITY);
    __publicField2(this, "subPriority", -1);
  }
  set(date2, flags) {
    if (flags.timestampIsSet) return date2;
    return constructFrom(date2, transpose(date2, Date));
  }
}
class Parser {
  run(dateString, token, match2, options) {
    const result2 = this.parse(dateString, token, match2, options);
    if (!result2) {
      return null;
    }
    return {
      setter: new ValueSetter(
        result2.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: result2.rest
    };
  }
  validate(_utcDate, _value, _options) {
    return true;
  }
}
class EraParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 140);
    __publicField2(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return match2.era(dateString, { width: "abbreviated" }) || match2.era(dateString, { width: "narrow" });
      // A, B
      case "GGGGG":
        return match2.era(dateString, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return match2.era(dateString, { width: "wide" }) || match2.era(dateString, { width: "abbreviated" }) || match2.era(dateString, { width: "narrow" });
    }
  }
  set(date2, flags, value) {
    flags.era = value;
    date2.setFullYear(value, 0, 1);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
const numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
};
const timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern2, dateString) {
  const matchResult = dateString.match(pattern2);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern2, dateString) {
  const matchResult = dateString.match(pattern2);
  if (!matchResult) {
    return null;
  }
  if (matchResult[0] === "Z") {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  const sign2 = matchResult[1] === "+" ? 1 : -1;
  const hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  const minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  const seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign2 * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp("^\\d{1," + n2 + "}"), dateString);
  }
}
function parseNDigitsSigned(n2, dateString) {
  switch (n2) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp("^-?\\d{1," + n2 + "}"), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  const isCommonEra = currentYear > 0;
  const absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  let result2;
  if (absCurrentYear <= 50) {
    result2 = twoDigitYear || 100;
  } else {
    const rangeEnd = absCurrentYear + 50;
    const rangeEndCentury = Math.trunc(rangeEnd / 100) * 100;
    const isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result2 = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result2 : 1 - result2;
}
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
class YearParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 130);
    __publicField2(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "yy"
    });
    switch (token) {
      case "y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "yo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "year"
          }),
          valueCallback
        );
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date2, flags, value) {
    const currentYear = date2.getFullYear();
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear
      );
      date2.setFullYear(normalizedTwoDigitYear, 0, 1);
      date2.setHours(0, 0, 0, 0);
      return date2;
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date2.setFullYear(year, 0, 1);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class LocalWeekYearParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 130);
    __publicField2(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    const valueCallback = (year) => ({
      year,
      isTwoDigitYear: token === "YY"
    });
    switch (token) {
      case "Y":
        return mapValue(parseNDigits(4, dateString), valueCallback);
      case "Yo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "year"
          }),
          valueCallback
        );
      default:
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }
  validate(_date, value) {
    return value.isTwoDigitYear || value.year > 0;
  }
  set(date2, flags, value, options) {
    const currentYear = getWeekYear(date2, options);
    if (value.isTwoDigitYear) {
      const normalizedTwoDigitYear = normalizeTwoDigitYear(
        value.year,
        currentYear
      );
      date2.setFullYear(
        normalizedTwoDigitYear,
        0,
        options.firstWeekContainsDate
      );
      date2.setHours(0, 0, 0, 0);
      return startOfWeek(date2, options);
    }
    const year = !("era" in flags) || flags.era === 1 ? value.year : 1 - value.year;
    date2.setFullYear(year, 0, options.firstWeekContainsDate);
    date2.setHours(0, 0, 0, 0);
    return startOfWeek(date2, options);
  }
}
class ISOWeekYearParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 130);
    __publicField2(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token) {
    if (token === "R") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date2, _flags, value) {
    const firstWeekOfYear = constructFrom(date2, 0);
    firstWeekOfYear.setFullYear(value, 0, 4);
    firstWeekOfYear.setHours(0, 0, 0, 0);
    return startOfISOWeek(firstWeekOfYear);
  }
}
class ExtendedYearParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 130);
    __publicField2(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token) {
    if (token === "u") {
      return parseNDigitsSigned(4, dateString);
    }
    return parseNDigitsSigned(token.length, dateString);
  }
  set(date2, _flags, value) {
    date2.setFullYear(value, 0, 1);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class QuarterParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 120);
    __publicField2(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return parseNDigits(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return match2.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return match2.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return match2.quarter(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date2, _flags, value) {
    date2.setMonth((value - 1) * 3, 1);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class StandAloneQuarterParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 120);
    __publicField2(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return parseNDigits(token.length, dateString);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return match2.ordinalNumber(dateString, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return match2.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return match2.quarter(dateString, {
          width: "wide",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.quarter(dateString, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 4;
  }
  set(date2, _flags, value) {
    date2.setMonth((value - 1) * 3, 1);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class MonthParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    __publicField2(this, "priority", 110);
  }
  parse(dateString, token, match2) {
    const valueCallback = (value) => value - 1;
    switch (token) {
      // 1, 2, ..., 12
      case "M":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback
        );
      // 01, 02, ..., 12
      case "MM":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "month"
          }),
          valueCallback
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return match2.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.month(dateString, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return match2.month(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return match2.month(dateString, { width: "wide", context: "formatting" }) || match2.month(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.month(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date2, _flags, value) {
    date2.setMonth(value, 1);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class StandAloneMonthParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 110);
    __publicField2(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    const valueCallback = (value) => value - 1;
    switch (token) {
      // 1, 2, ..., 12
      case "L":
        return mapValue(
          parseNumericPattern(numericPatterns.month, dateString),
          valueCallback
        );
      // 01, 02, ..., 12
      case "LL":
        return mapValue(parseNDigits(2, dateString), valueCallback);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "month"
          }),
          valueCallback
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return match2.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.month(dateString, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return match2.month(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return match2.month(dateString, { width: "wide", context: "standalone" }) || match2.month(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.month(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date2, _flags, value) {
    date2.setMonth(value, 1);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
function setWeek(date2, week, options) {
  const _date = toDate(date2);
  const diff = getWeek(_date, options) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}
class LocalWeekParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 100);
    __publicField2(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "w":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "wo":
        return match2.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date2, _flags, value, options) {
    return startOfWeek(setWeek(date2, value, options), options);
  }
}
function setISOWeek(date2, week) {
  const _date = toDate(date2);
  const diff = getISOWeek(_date) - week;
  _date.setDate(_date.getDate() - diff * 7);
  return _date;
}
class ISOWeekParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 100);
    __publicField2(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "I":
        return parseNumericPattern(numericPatterns.week, dateString);
      case "Io":
        return match2.ordinalNumber(dateString, { unit: "week" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 53;
  }
  set(date2, _flags, value) {
    return startOfISOWeek(setISOWeek(date2, value));
  }
}
const DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
const DAYS_IN_MONTH_LEAP_YEAR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class DateParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 90);
    __publicField2(this, "subPriority", 1);
    __publicField2(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "d":
        return parseNumericPattern(numericPatterns.date, dateString);
      case "do":
        return match2.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date2, value) {
    const year = date2.getFullYear();
    const isLeapYear = isLeapYearIndex(year);
    const month = date2.getMonth();
    if (isLeapYear) {
      return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
    } else {
      return value >= 1 && value <= DAYS_IN_MONTH[month];
    }
  }
  set(date2, _flags, value) {
    date2.setDate(value);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class DayOfYearParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 90);
    __publicField2(this, "subpriority", 1);
    __publicField2(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "D":
      case "DD":
        return parseNumericPattern(numericPatterns.dayOfYear, dateString);
      case "Do":
        return match2.ordinalNumber(dateString, { unit: "date" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(date2, value) {
    const year = date2.getFullYear();
    const isLeapYear = isLeapYearIndex(year);
    if (isLeapYear) {
      return value >= 1 && value <= 366;
    } else {
      return value >= 1 && value <= 365;
    }
  }
  set(date2, _flags, value) {
    date2.setMonth(0, value);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
function setDay(date2, day, options) {
  var _a2, _b, _c, _d;
  const defaultOptions2 = getDefaultOptions$1();
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_b = (_a2 = options == null ? void 0 : options.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.weekStartsOn) ?? 0;
  const _date = toDate(date2);
  const currentDay = _date.getDay();
  const remainder = day % 7;
  const dayIndex = (remainder + 7) % 7;
  const delta = 7 - weekStartsOn;
  const diff = day < 0 || day > 6 ? day - (currentDay + delta) % 7 : (dayIndex + delta) % 7 - (currentDay + delta) % 7;
  return addDays(_date, diff);
}
class DayParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 90);
    __publicField2(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return match2.day(dateString, { width: "wide", context: "formatting" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date2, _flags, value, options) {
    date2 = setDay(date2, value, options);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class LocalDayParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 90);
    __publicField2(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token) {
      // 3
      case "e":
      case "ee":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      // 3rd
      case "eo":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "day"
          }),
          valueCallback
        );
      // Tue
      case "eee":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return match2.day(dateString, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return match2.day(dateString, { width: "wide", context: "formatting" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.day(dateString, { width: "short", context: "formatting" }) || match2.day(dateString, { width: "narrow", context: "formatting" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date2, _flags, value, options) {
    date2 = setDay(date2, value, options);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class StandAloneLocalDayParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 90);
    __publicField2(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2, options) {
    const valueCallback = (value) => {
      const wholeWeekDays = Math.floor((value - 1) / 7) * 7;
      return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
    };
    switch (token) {
      // 3
      case "c":
      case "cc":
        return mapValue(parseNDigits(token.length, dateString), valueCallback);
      // 3rd
      case "co":
        return mapValue(
          match2.ordinalNumber(dateString, {
            unit: "day"
          }),
          valueCallback
        );
      // Tue
      case "ccc":
        return match2.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return match2.day(dateString, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return match2.day(dateString, { width: "wide", context: "standalone" }) || match2.day(dateString, {
          width: "abbreviated",
          context: "standalone"
        }) || match2.day(dateString, { width: "short", context: "standalone" }) || match2.day(dateString, { width: "narrow", context: "standalone" });
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 6;
  }
  set(date2, _flags, value, options) {
    date2 = setDay(date2, value, options);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
function setISODay(date2, day) {
  const _date = toDate(date2);
  const currentDay = getISODay(_date);
  const diff = day - currentDay;
  return addDays(_date, diff);
}
class ISODayParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 90);
    __publicField2(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(dateString, token, match2) {
    const valueCallback = (value) => {
      if (value === 0) {
        return 7;
      }
      return value;
    };
    switch (token) {
      // 2
      case "i":
      case "ii":
        return parseNDigits(token.length, dateString);
      // 2nd
      case "io":
        return match2.ordinalNumber(dateString, { unit: "day" });
      // Tue
      case "iii":
        return mapValue(
          match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // T
      case "iiiii":
        return mapValue(
          match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // Tu
      case "iiiiii":
        return mapValue(
          match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
      // Tuesday
      case "iiii":
      default:
        return mapValue(
          match2.day(dateString, {
            width: "wide",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "abbreviated",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "short",
            context: "formatting"
          }) || match2.day(dateString, {
            width: "narrow",
            context: "formatting"
          }),
          valueCallback
        );
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 7;
  }
  set(date2, _flags, value) {
    date2 = setISODay(date2, value);
    date2.setHours(0, 0, 0, 0);
    return date2;
  }
}
class AMPMParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 80);
    __publicField2(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "a":
      case "aa":
      case "aaa":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date2, _flags, value) {
    date2.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date2;
  }
}
class AMPMMidnightParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 80);
    __publicField2(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "b":
      case "bb":
      case "bbb":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date2, _flags, value) {
    date2.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date2;
  }
}
class DayPeriodParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 80);
    __publicField2(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "B":
      case "BB":
      case "BBB":
        return match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return match2.dayPeriod(dateString, {
          width: "wide",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "abbreviated",
          context: "formatting"
        }) || match2.dayPeriod(dateString, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(date2, _flags, value) {
    date2.setHours(dayPeriodEnumToHours(value), 0, 0, 0);
    return date2;
  }
}
class Hour1to12Parser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 70);
    __publicField2(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "h":
        return parseNumericPattern(numericPatterns.hour12h, dateString);
      case "ho":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 12;
  }
  set(date2, _flags, value) {
    const isPM = date2.getHours() >= 12;
    if (isPM && value < 12) {
      date2.setHours(value + 12, 0, 0, 0);
    } else if (!isPM && value === 12) {
      date2.setHours(0, 0, 0, 0);
    } else {
      date2.setHours(value, 0, 0, 0);
    }
    return date2;
  }
}
class Hour0to23Parser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 70);
    __publicField2(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "H":
        return parseNumericPattern(numericPatterns.hour23h, dateString);
      case "Ho":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 23;
  }
  set(date2, _flags, value) {
    date2.setHours(value, 0, 0, 0);
    return date2;
  }
}
class Hour0To11Parser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 70);
    __publicField2(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "K":
        return parseNumericPattern(numericPatterns.hour11h, dateString);
      case "Ko":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 11;
  }
  set(date2, _flags, value) {
    const isPM = date2.getHours() >= 12;
    if (isPM && value < 12) {
      date2.setHours(value + 12, 0, 0, 0);
    } else {
      date2.setHours(value, 0, 0, 0);
    }
    return date2;
  }
}
class Hour1To24Parser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 70);
    __publicField2(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "k":
        return parseNumericPattern(numericPatterns.hour24h, dateString);
      case "ko":
        return match2.ordinalNumber(dateString, { unit: "hour" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 1 && value <= 24;
  }
  set(date2, _flags, value) {
    const hours = value <= 24 ? value % 24 : value;
    date2.setHours(hours, 0, 0, 0);
    return date2;
  }
}
class MinuteParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 60);
    __publicField2(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "m":
        return parseNumericPattern(numericPatterns.minute, dateString);
      case "mo":
        return match2.ordinalNumber(dateString, { unit: "minute" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date2, _flags, value) {
    date2.setMinutes(value, 0, 0);
    return date2;
  }
}
class SecondParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 50);
    __publicField2(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token, match2) {
    switch (token) {
      case "s":
        return parseNumericPattern(numericPatterns.second, dateString);
      case "so":
        return match2.ordinalNumber(dateString, { unit: "second" });
      default:
        return parseNDigits(token.length, dateString);
    }
  }
  validate(_date, value) {
    return value >= 0 && value <= 59;
  }
  set(date2, _flags, value) {
    date2.setSeconds(value, 0);
    return date2;
  }
}
class FractionOfSecondParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 30);
    __publicField2(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(dateString, token) {
    const valueCallback = (value) => Math.trunc(value * Math.pow(10, -token.length + 3));
    return mapValue(parseNDigits(token.length, dateString), valueCallback);
  }
  set(date2, _flags, value) {
    date2.setMilliseconds(value);
    return date2;
  }
}
class ISOTimezoneWithZParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 10);
    __publicField2(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(dateString, token) {
    switch (token) {
      case "X":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString
        );
      case "XX":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "XXXX":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString
        );
      case "XXXXX":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString
        );
      case "XXX":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date2, flags, value) {
    if (flags.timestampIsSet) return date2;
    return constructFrom(
      date2,
      date2.getTime() - getTimezoneOffsetInMilliseconds(date2) - value
    );
  }
}
class ISOTimezoneParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 10);
    __publicField2(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(dateString, token) {
    switch (token) {
      case "x":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalMinutes,
          dateString
        );
      case "xx":
        return parseTimezonePattern(timezonePatterns.basic, dateString);
      case "xxxx":
        return parseTimezonePattern(
          timezonePatterns.basicOptionalSeconds,
          dateString
        );
      case "xxxxx":
        return parseTimezonePattern(
          timezonePatterns.extendedOptionalSeconds,
          dateString
        );
      case "xxx":
      default:
        return parseTimezonePattern(timezonePatterns.extended, dateString);
    }
  }
  set(date2, flags, value) {
    if (flags.timestampIsSet) return date2;
    return constructFrom(
      date2,
      date2.getTime() - getTimezoneOffsetInMilliseconds(date2) - value
    );
  }
}
class TimestampSecondsParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 40);
    __publicField2(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date2, _flags, value) {
    return [constructFrom(date2, value * 1e3), { timestampIsSet: true }];
  }
}
class TimestampMillisecondsParser extends Parser {
  constructor() {
    super(...arguments);
    __publicField2(this, "priority", 20);
    __publicField2(this, "incompatibleTokens", "*");
  }
  parse(dateString) {
    return parseAnyDigitsSigned(dateString);
  }
  set(date2, _flags, value) {
    return [constructFrom(date2, value), { timestampIsSet: true }];
  }
}
const parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};
const formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;
const longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
const escapedStringRegExp = /^'([^]*?)'?$/;
const doubleQuoteRegExp = /''/g;
const notWhitespaceRegExp = /\S/;
const unescapedLatinCharacterRegExp = /[a-zA-Z]/;
function parse$1(dateStr, formatStr, referenceDate, options) {
  var _a2, _b, _c, _d, _e2, _f, _g, _h;
  const defaultOptions2 = getDefaultOptions();
  const locale2 = (options == null ? void 0 : options.locale) ?? defaultOptions2.locale ?? enUS;
  const firstWeekContainsDate = (options == null ? void 0 : options.firstWeekContainsDate) ?? ((_b = (_a2 = options == null ? void 0 : options.locale) == null ? void 0 : _a2.options) == null ? void 0 : _b.firstWeekContainsDate) ?? defaultOptions2.firstWeekContainsDate ?? ((_d = (_c = defaultOptions2.locale) == null ? void 0 : _c.options) == null ? void 0 : _d.firstWeekContainsDate) ?? 1;
  const weekStartsOn = (options == null ? void 0 : options.weekStartsOn) ?? ((_f = (_e2 = options == null ? void 0 : options.locale) == null ? void 0 : _e2.options) == null ? void 0 : _f.weekStartsOn) ?? defaultOptions2.weekStartsOn ?? ((_h = (_g = defaultOptions2.locale) == null ? void 0 : _g.options) == null ? void 0 : _h.weekStartsOn) ?? 0;
  if (formatStr === "") {
    if (dateStr === "") {
      return toDate(referenceDate);
    } else {
      return constructFrom(referenceDate, NaN);
    }
  }
  const subFnOptions = {
    firstWeekContainsDate,
    weekStartsOn,
    locale: locale2
  };
  const setters = [new DateToSystemTimezoneSetter()];
  const tokens = formatStr.match(longFormattingTokensRegExp).map((substring) => {
    const firstCharacter = substring[0];
    if (firstCharacter in longFormatters) {
      const longFormatter = longFormatters[firstCharacter];
      return longFormatter(substring, locale2.formatLong);
    }
    return substring;
  }).join("").match(formattingTokensRegExp);
  const usedTokens = [];
  for (let token of tokens) {
    if (!(options == null ? void 0 : options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    if (!(options == null ? void 0 : options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
      warnOrThrowProtectedError(token, formatStr, dateStr);
    }
    const firstCharacter = token[0];
    const parser = parsers[firstCharacter];
    if (parser) {
      const { incompatibleTokens } = parser;
      if (Array.isArray(incompatibleTokens)) {
        const incompatibleToken = usedTokens.find(
          (usedToken) => incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter
        );
        if (incompatibleToken) {
          throw new RangeError(
            `The format string mustn't contain \`${incompatibleToken.fullToken}\` and \`${token}\` at the same time`
          );
        }
      } else if (parser.incompatibleTokens === "*" && usedTokens.length > 0) {
        throw new RangeError(
          `The format string mustn't contain \`${token}\` and any other token at the same time`
        );
      }
      usedTokens.push({ token: firstCharacter, fullToken: token });
      const parseResult = parser.run(
        dateStr,
        token,
        locale2.match,
        subFnOptions
      );
      if (!parseResult) {
        return constructFrom(referenceDate, NaN);
      }
      setters.push(parseResult.setter);
      dateStr = parseResult.rest;
    } else {
      if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + firstCharacter + "`"
        );
      }
      if (token === "''") {
        token = "'";
      } else if (firstCharacter === "'") {
        token = cleanEscapedString(token);
      }
      if (dateStr.indexOf(token) === 0) {
        dateStr = dateStr.slice(token.length);
      } else {
        return constructFrom(referenceDate, NaN);
      }
    }
  }
  if (dateStr.length > 0 && notWhitespaceRegExp.test(dateStr)) {
    return constructFrom(referenceDate, NaN);
  }
  const uniquePrioritySetters = setters.map((setter) => setter.priority).sort((a, b2) => b2 - a).filter((priority, index2, array2) => array2.indexOf(priority) === index2).map(
    (priority) => setters.filter((setter) => setter.priority === priority).sort((a, b2) => b2.subPriority - a.subPriority)
  ).map((setterArray) => setterArray[0]);
  let date2 = toDate(referenceDate);
  if (isNaN(date2.getTime())) {
    return constructFrom(referenceDate, NaN);
  }
  const flags = {};
  for (const setter of uniquePrioritySetters) {
    if (!setter.validate(date2, subFnOptions)) {
      return constructFrom(referenceDate, NaN);
    }
    const result2 = setter.set(date2, flags, subFnOptions);
    if (Array.isArray(result2)) {
      date2 = result2[0];
      Object.assign(flags, result2[1]);
    } else {
      date2 = result2;
    }
  }
  return constructFrom(referenceDate, date2);
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}
function isSameQuarter(dateLeft, dateRight) {
  const dateLeftStartOfQuarter = startOfQuarter(dateLeft);
  const dateRightStartOfQuarter = startOfQuarter(dateRight);
  return +dateLeftStartOfQuarter === +dateRightStartOfQuarter;
}
function subDays(date2, amount) {
  return addDays(date2, -amount);
}
function setMonth(date2, month) {
  const _date = toDate(date2);
  const year = _date.getFullYear();
  const day = _date.getDate();
  const dateWithDesiredMonth = constructFrom(date2, 0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  const daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  _date.setMonth(month, Math.min(day, daysInMonth));
  return _date;
}
function set(date2, values3) {
  let _date = toDate(date2);
  if (isNaN(+_date)) {
    return constructFrom(date2, NaN);
  }
  if (values3.year != null) {
    _date.setFullYear(values3.year);
  }
  if (values3.month != null) {
    _date = setMonth(_date, values3.month);
  }
  if (values3.date != null) {
    _date.setDate(values3.date);
  }
  if (values3.hours != null) {
    _date.setHours(values3.hours);
  }
  if (values3.minutes != null) {
    _date.setMinutes(values3.minutes);
  }
  if (values3.seconds != null) {
    _date.setSeconds(values3.seconds);
  }
  if (values3.milliseconds != null) {
    _date.setMilliseconds(values3.milliseconds);
  }
  return _date;
}
function setHours(date2, hours) {
  const _date = toDate(date2);
  _date.setHours(hours);
  return _date;
}
function setMilliseconds(date2, milliseconds) {
  const _date = toDate(date2);
  _date.setMilliseconds(milliseconds);
  return _date;
}
function setMinutes(date2, minutes) {
  const _date = toDate(date2);
  _date.setMinutes(minutes);
  return _date;
}
function setSeconds(date2, seconds) {
  const _date = toDate(date2);
  _date.setSeconds(seconds);
  return _date;
}
function setYear(date2, year) {
  const _date = toDate(date2);
  if (isNaN(+_date)) {
    return constructFrom(date2, NaN);
  }
  _date.setFullYear(year);
  return _date;
}
function subMonths(date2, amount) {
  return addMonths(date2, -amount);
}
function sub(date2, duration) {
  const {
    years = 0,
    months = 0,
    weeks = 0,
    days = 0,
    hours = 0,
    minutes = 0,
    seconds = 0
  } = duration;
  const dateWithoutMonths = subMonths(date2, months + years * 12);
  const dateWithoutDays = subDays(dateWithoutMonths, days + weeks * 7);
  const minutestoSub = minutes + hours * 60;
  const secondstoSub = seconds + minutestoSub * 60;
  const mstoSub = secondstoSub * 1e3;
  const finalDate = constructFrom(date2, dateWithoutDays.getTime() - mstoSub);
  return finalDate;
}
function subYears(date2, amount) {
  return addYears(date2, -amount);
}
function Et() {
  return openBlock(), createElementBlock(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      createElementVNode("path", {
        d: "M29.333 8c0-2.208-1.792-4-4-4h-18.667c-2.208 0-4 1.792-4 4v18.667c0 2.208 1.792 4 4 4h18.667c2.208 0 4-1.792 4-4v-18.667zM26.667 8v18.667c0 0.736-0.597 1.333-1.333 1.333 0 0-18.667 0-18.667 0-0.736 0-1.333-0.597-1.333-1.333 0 0 0-18.667 0-18.667 0-0.736 0.597-1.333 1.333-1.333 0 0 18.667 0 18.667 0 0.736 0 1.333 0.597 1.333 1.333z"
      }),
      createElementVNode("path", {
        d: "M20 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      createElementVNode("path", {
        d: "M9.333 2.667v5.333c0 0.736 0.597 1.333 1.333 1.333s1.333-0.597 1.333-1.333v-5.333c0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      }),
      createElementVNode("path", {
        d: "M4 14.667h24c0.736 0 1.333-0.597 1.333-1.333s-0.597-1.333-1.333-1.333h-24c-0.736 0-1.333 0.597-1.333 1.333s0.597 1.333 1.333 1.333z"
      })
    ]
  );
}
Et.compatConfig = {
  MODE: 3
};
function wn() {
  return openBlock(), createElementBlock(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      createElementVNode("path", {
        d: "M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"
      }),
      createElementVNode("path", {
        d: "M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
wn.compatConfig = {
  MODE: 3
};
function La() {
  return openBlock(), createElementBlock(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      createElementVNode("path", {
        d: "M20.943 23.057l-7.057-7.057c0 0 7.057-7.057 7.057-7.057 0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-8 8c-0.521 0.521-0.521 1.365 0 1.885l8 8c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
La.compatConfig = {
  MODE: 3
};
function za() {
  return openBlock(), createElementBlock(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      createElementVNode("path", {
        d: "M12.943 24.943l8-8c0.521-0.521 0.521-1.365 0-1.885l-8-8c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885l7.057 7.057c0 0-7.057 7.057-7.057 7.057-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0z"
      })
    ]
  );
}
za.compatConfig = {
  MODE: 3
};
function Ha() {
  return openBlock(), createElementBlock(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      createElementVNode("path", {
        d: "M16 1.333c-8.095 0-14.667 6.572-14.667 14.667s6.572 14.667 14.667 14.667c8.095 0 14.667-6.572 14.667-14.667s-6.572-14.667-14.667-14.667zM16 4c6.623 0 12 5.377 12 12s-5.377 12-12 12c-6.623 0-12-5.377-12-12s5.377-12 12-12z"
      }),
      createElementVNode("path", {
        d: "M14.667 8v8c0 0.505 0.285 0.967 0.737 1.193l5.333 2.667c0.658 0.329 1.46 0.062 1.789-0.596s0.062-1.46-0.596-1.789l-4.596-2.298c0 0 0-7.176 0-7.176 0-0.736-0.597-1.333-1.333-1.333s-1.333 0.597-1.333 1.333z"
      })
    ]
  );
}
Ha.compatConfig = {
  MODE: 3
};
function Va() {
  return openBlock(), createElementBlock(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      createElementVNode("path", {
        d: "M24.943 19.057l-8-8c-0.521-0.521-1.365-0.521-1.885 0l-8 8c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l7.057-7.057c0 0 7.057 7.057 7.057 7.057 0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885z"
      })
    ]
  );
}
Va.compatConfig = {
  MODE: 3
};
function Ua() {
  return openBlock(), createElementBlock(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 32 32",
      fill: "currentColor",
      "aria-hidden": "true",
      class: "dp__icon"
    },
    [
      createElementVNode("path", {
        d: "M7.057 12.943l8 8c0.521 0.521 1.365 0.521 1.885 0l8-8c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0l-7.057 7.057c0 0-7.057-7.057-7.057-7.057-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"
      })
    ]
  );
}
Ua.compatConfig = {
  MODE: 3
};
const Xe = (e, t) => t ? new Date(e.toLocaleString("en-US", { timeZone: t })) : new Date(e), Wa = (e, t, l) => {
  const a = Na(e, t, l);
  return a || j();
}, il = (e, t, l) => {
  const a = t.dateInTz ? Xe(new Date(e), t.dateInTz) : j(e);
  return l ? Ke(a, true) : a;
}, Na = (e, t, l) => {
  if (!e) return null;
  const a = l ? Ke(j(e), true) : j(e);
  return t ? t.exactMatch ? il(e, t, l) : Xe(a, t.timezone) : a;
}, dl = (e) => {
  if (!e) return 0;
  const t = /* @__PURE__ */ new Date(), l = new Date(t.toLocaleString("en-US", { timeZone: "UTC" })), a = new Date(t.toLocaleString("en-US", { timeZone: e })), n2 = a.getTimezoneOffset() / 60;
  return (+l - +a) / (1e3 * 60 * 60) - n2;
};
var nt = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e))(nt || {}), Mt = /* @__PURE__ */ ((e) => (e.top = "top", e.bottom = "bottom", e))(Mt || {}), Tt = /* @__PURE__ */ ((e) => (e.header = "header", e.calendar = "calendar", e.timePicker = "timePicker", e))(Tt || {}), He = /* @__PURE__ */ ((e) => (e.month = "month", e.year = "year", e.calendar = "calendar", e.time = "time", e.minutes = "minutes", e.hours = "hours", e.seconds = "seconds", e))(He || {});
const cl = ["timestamp", "date", "iso"];
var je = /* @__PURE__ */ ((e) => (e.up = "up", e.down = "down", e.left = "left", e.right = "right", e))(je || {}), Re = /* @__PURE__ */ ((e) => (e.arrowUp = "ArrowUp", e.arrowDown = "ArrowDown", e.arrowLeft = "ArrowLeft", e.arrowRight = "ArrowRight", e.enter = "Enter", e.space = " ", e.esc = "Escape", e.tab = "Tab", e.home = "Home", e.end = "End", e.pageUp = "PageUp", e.pageDown = "PageDown", e))(Re || {});
function nn(e) {
  return (t) => new Intl.DateTimeFormat(e, { weekday: "short", timeZone: "UTC" }).format(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`)).slice(0, 2);
}
function fl(e) {
  return (t) => format(Xe(/* @__PURE__ */ new Date(`2017-01-0${t}T00:00:00+00:00`), "UTC"), "EEEEEE", { locale: e });
}
const vl = (e, t, l) => {
  const a = [1, 2, 3, 4, 5, 6, 7];
  let n2;
  if (e !== null)
    try {
      n2 = a.map(fl(e));
    } catch {
      n2 = a.map(nn(t));
    }
  else
    n2 = a.map(nn(t));
  const c2 = n2.slice(0, l), v = n2.slice(l + 1, n2.length);
  return [n2[l]].concat(...v).concat(...c2);
}, ja = (e, t, l) => {
  const a = [];
  for (let n2 = +e[0]; n2 <= +e[1]; n2++)
    a.push({ value: +n2, text: An(n2, t) });
  return l ? a.reverse() : a;
}, Dn = (e, t, l) => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((c2) => {
    const v = c2 < 10 ? `0${c2}` : c2;
    return /* @__PURE__ */ new Date(`2017-${v}-01T00:00:00+00:00`);
  });
  if (e !== null)
    try {
      const c2 = l === "long" ? "LLLL" : "LLL";
      return a.map((v, b2) => {
        const i = format(Xe(v, "UTC"), c2, { locale: e });
        return {
          text: i.charAt(0).toUpperCase() + i.substring(1),
          value: b2
        };
      });
    } catch {
    }
  const n2 = new Intl.DateTimeFormat(t, { month: l, timeZone: "UTC" });
  return a.map((c2, v) => {
    const b2 = n2.format(c2);
    return {
      text: b2.charAt(0).toUpperCase() + b2.substring(1),
      value: v
    };
  });
}, ml = (e) => [12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11][e], Ie = (e) => {
  const t = unref(e);
  return t != null && t.$el ? t == null ? void 0 : t.$el : t;
}, gl = (e) => ({ type: "dot", ...e ?? {} }), Mn = (e) => Array.isArray(e) ? !!e[0] && !!e[1] : false, Ka = {
  prop: (e) => `"${e}" prop must be enabled!`,
  dateArr: (e) => `You need to use array as "model-value" binding in order to support "${e}"`
}, Ye = (e) => e, ln = (e) => e === 0 ? e : !e || isNaN(+e) ? null : +e, rn = (e) => e === null, $n = (e) => {
  if (e)
    return [...e.querySelectorAll("input, button, select, textarea, a[href]")][0];
}, yl = (e) => {
  const t = [], l = (a) => a.filter((n2) => n2);
  for (let a = 0; a < e.length; a += 3) {
    const n2 = [e[a], e[a + 1], e[a + 2]];
    t.push(l(n2));
  }
  return t;
}, Gt = (e, t, l) => {
  const a = l != null, n2 = t != null;
  if (!a && !n2) return false;
  const c2 = +l, v = +t;
  return a && n2 ? +e > c2 || +e < v : a ? +e > c2 : n2 ? +e < v : false;
}, Yt = (e, t) => yl(e).map((l) => l.map((a) => {
  const { active: n2, disabled: c2, isBetween: v, highlighted: b2 } = t(a);
  return {
    ...a,
    active: n2,
    disabled: c2,
    className: {
      dp__overlay_cell_active: n2,
      dp__overlay_cell: !n2,
      dp__overlay_cell_disabled: c2,
      dp__overlay_cell_pad: true,
      dp__overlay_cell_active_disabled: c2 && n2,
      dp__cell_in_between: v,
      "dp--highlighted": b2
    }
  };
})), yt = (e, t, l = false) => {
  e && t.allowStopPropagation && (l && e.stopImmediatePropagation(), e.stopPropagation());
}, pl = () => [
  "a[href]",
  "area[href]",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "button:not([disabled])",
  "[tabindex]:not([tabindex='-1'])",
  "[data-datepicker-instance]"
].join(", ");
function hl(e, t) {
  let l = [...document.querySelectorAll(pl())];
  l = l.filter((n2) => !e.contains(n2) || n2.hasAttribute("data-datepicker-instance"));
  const a = l.indexOf(e);
  if (a >= 0 && (t ? a - 1 >= 0 : a + 1 <= l.length))
    return l[a + (t ? -1 : 1)];
}
const bl = (e, t) => e == null ? void 0 : e.querySelector(`[data-dp-element="${t}"]`), An = (e, t) => new Intl.NumberFormat(t, { useGrouping: false, style: "decimal" }).format(e), Ga = (e) => format(e, "dd-MM-yyyy"), $a = (e) => Array.isArray(e), sa = (e, t) => t.get(Ga(e)), kl = (e, t) => e ? t ? t instanceof Map ? !!sa(e, t) : t(j(e)) : false : true, qe = (e, t, l = false) => {
  if (e.key === Re.enter || e.key === Re.space)
    return l && e.preventDefault(), t();
}, on$1 = (e, t, l, a, n2, c2) => {
  const v = parse$1(e, t.slice(0, e.length), /* @__PURE__ */ new Date(), { locale: c2 });
  return isValid(v) && isDate$2(v) ? a || n2 ? v : set(v, {
    hours: +l.hours,
    minutes: +(l == null ? void 0 : l.minutes),
    seconds: +(l == null ? void 0 : l.seconds),
    milliseconds: 0
  }) : null;
}, wl = (e, t, l, a, n2, c2) => {
  const v = Array.isArray(l) ? l[0] : l;
  if (typeof t == "string")
    return on$1(e, t, v, a, n2, c2);
  if (Array.isArray(t)) {
    let b2 = null;
    for (const i of t)
      if (b2 = on$1(e, i, v, a, n2, c2), b2)
        break;
    return b2;
  }
  return typeof t == "function" ? t(e) : null;
}, j = (e) => e ? new Date(e) : /* @__PURE__ */ new Date(), Dl = (e, t, l) => {
  if (t) {
    const n2 = (e.getMonth() + 1).toString().padStart(2, "0"), c2 = e.getDate().toString().padStart(2, "0"), v = e.getHours().toString().padStart(2, "0"), b2 = e.getMinutes().toString().padStart(2, "0"), i = l ? e.getSeconds().toString().padStart(2, "0") : "00";
    return `${e.getFullYear()}-${n2}-${c2}T${v}:${b2}:${i}.000Z`;
  }
  const a = Date.UTC(
    e.getUTCFullYear(),
    e.getUTCMonth(),
    e.getUTCDate(),
    e.getUTCHours(),
    e.getUTCMinutes(),
    e.getUTCSeconds()
  );
  return new Date(a).toISOString();
}, Ke = (e, t) => {
  const l = j(JSON.parse(JSON.stringify(e))), a = set(l, { hours: 0, minutes: 0, seconds: 0, milliseconds: 0 });
  return t ? startOfMonth(a) : a;
}, pt = (e, t, l, a) => {
  let n2 = e ? j(e) : j();
  return (t || t === 0) && (n2 = setHours(n2, +t)), (l || l === 0) && (n2 = setMinutes(n2, +l)), (a || a === 0) && (n2 = setSeconds(n2, +a)), setMilliseconds(n2, 0);
}, _e = (e, t) => !e || !t ? false : isBefore(Ke(e), Ke(t)), De = (e, t) => !e || !t ? false : isEqual(Ke(e), Ke(t)), Be = (e, t) => !e || !t ? false : isAfter(Ke(e), Ke(t)), da = (e, t, l) => e != null && e[0] && (e != null && e[1]) ? Be(l, e[0]) && _e(l, e[1]) : e != null && e[0] && t ? Be(l, e[0]) && _e(l, t) || _e(l, e[0]) && Be(l, t) : false, lt = (e) => {
  const t = set(new Date(e), { date: 1 });
  return Ke(t);
}, Aa = (e, t, l) => t && (l || l === 0) ? Object.fromEntries(
  ["hours", "minutes", "seconds"].map((a) => a === t ? [a, l] : [a, isNaN(+e[a]) ? void 0 : +e[a]])
) : {
  hours: isNaN(+e.hours) ? void 0 : +e.hours,
  minutes: isNaN(+e.minutes) ? void 0 : +e.minutes,
  seconds: isNaN(+e.seconds) ? void 0 : +e.seconds
}, St = (e) => ({
  hours: getHours(e),
  minutes: getMinutes(e),
  seconds: getSeconds(e)
}), Tn = (e, t) => {
  if (t) {
    const l = getYear(j(t));
    if (l > e) return 12;
    if (l === e) return getMonth(j(t));
  }
}, Sn = (e, t) => {
  if (t) {
    const l = getYear(j(t));
    return l < e ? -1 : l === e ? getMonth(j(t)) : void 0;
  }
}, It = (e) => {
  if (e) return getYear(j(e));
}, Pn = (e, t) => {
  const l = Be(e, t) ? t : e, a = Be(t, e) ? t : e;
  return eachDayOfInterval({ start: l, end: a });
}, Ml = (e) => {
  const t = addMonths(e, 1);
  return { month: getMonth(t), year: getYear(t) };
}, it = (e, t) => {
  const l = startOfWeek(e, { weekStartsOn: +t }), a = endOfWeek(e, { weekStartsOn: +t });
  return [l, a];
}, Rn = (e, t) => {
  const l = {
    hours: getHours(j()),
    minutes: getMinutes(j()),
    seconds: t ? getSeconds(j()) : 0
  };
  return Object.assign(l, e);
}, gt = (e, t, l) => [set(j(e), { date: 1 }), set(j(), { month: t, year: l, date: 1 })], dt = (e, t, l) => {
  let a = e ? j(e) : j();
  return (t || t === 0) && (a = setMonth(a, t)), l && (a = setYear(a, l)), a;
}, Cn = (e, t, l, a, n2) => {
  if (!a || n2 && !t || !n2 && !l) return false;
  const c2 = n2 ? addMonths(e, 1) : subMonths(e, 1), v = [getMonth(c2), getYear(c2)];
  return n2 ? !Al(...v, t) : !$l(...v, l);
}, $l = (e, t, l) => _e(...gt(l, e, t)) || De(...gt(l, e, t)), Al = (e, t, l) => Be(...gt(l, e, t)) || De(...gt(l, e, t)), _n = (e, t, l, a, n2, c2, v) => {
  if (typeof t == "function" && !v) return t(e);
  const b2 = l ? { locale: l } : void 0;
  return Array.isArray(e) ? `${format(e[0], c2, b2)}${n2 && !e[1] ? "" : a}${e[1] ? format(e[1], c2, b2) : ""}` : format(e, c2, b2);
}, Rt = (e) => {
  if (e) return null;
  throw new Error(Ka.prop("partial-range"));
}, ta = (e, t) => {
  if (t) return e();
  throw new Error(Ka.prop("range"));
}, Ea = (e) => Array.isArray(e) ? isValid(e[0]) && (e[1] ? isValid(e[1]) : true) : e ? isValid(e) : false, Tl = (e, t) => set(t ?? j(), {
  hours: +e.hours || 0,
  minutes: +e.minutes || 0,
  seconds: +e.seconds || 0
}), Ta = (e, t, l, a) => {
  if (!e) return true;
  if (a) {
    const n2 = l === "max" ? isBefore(e, t) : isAfter(e, t), c2 = { seconds: 0, milliseconds: 0 };
    return n2 || isEqual(set(e, c2), set(t, c2));
  }
  return l === "max" ? e.getTime() <= t.getTime() : e.getTime() >= t.getTime();
}, Sa = (e, t, l) => e ? Tl(e, t) : j(l ?? t), sn = (e, t, l, a, n2) => {
  if (Array.isArray(a)) {
    const v = Sa(e, a[0], t), b2 = Sa(e, a[1], t);
    return Ta(a[0], v, l, !!t) && Ta(a[1], b2, l, !!t) && n2;
  }
  const c2 = Sa(e, a, t);
  return Ta(a, c2, l, !!t) && n2;
}, Pa = (e) => set(j(), St(e)), Sl = (e, t) => e instanceof Map ? Array.from(e.values()).filter((l) => getYear(j(l)) === t).map((l) => getMonth(l)) : [], On = (e, t, l) => typeof e == "function" ? e({ month: t, year: l }) : !!e.months.find((a) => a.month === t && a.year === l), Qa = (e, t) => typeof e == "function" ? e(t) : e.years.includes(t), Bn = (e) => format(e, "yyyy-MM-dd"), Ht = reactive({
  menuFocused: false,
  shiftKeyInMenu: false
}), Yn = () => {
  const e = (a) => {
    Ht.menuFocused = a;
  }, t = (a) => {
    Ht.shiftKeyInMenu !== a && (Ht.shiftKeyInMenu = a);
  };
  return {
    control: computed(() => ({ shiftKeyInMenu: Ht.shiftKeyInMenu, menuFocused: Ht.menuFocused })),
    setMenuFocused: e,
    setShiftKey: t
  };
}, Se = reactive({
  monthYear: [],
  calendar: [],
  time: [],
  actionRow: [],
  selectionGrid: [],
  timePicker: {
    0: [],
    1: []
  },
  monthPicker: []
}), Ra = ref(null), aa = ref(false), Ca = ref(false), _a = ref(false), Oa = ref(false), ze = ref(0), Oe = ref(0), bt = () => {
  const e = computed(() => aa.value ? [...Se.selectionGrid, Se.actionRow].filter((y2) => y2.length) : Ca.value ? [
    ...Se.timePicker[0],
    ...Se.timePicker[1],
    Oa.value ? [] : [Ra.value],
    Se.actionRow
  ].filter((y2) => y2.length) : _a.value ? [...Se.monthPicker, Se.actionRow] : [Se.monthYear, ...Se.calendar, Se.time, Se.actionRow].filter((y2) => y2.length)), t = (y2) => {
    ze.value = y2 ? ze.value + 1 : ze.value - 1;
    let F = null;
    e.value[Oe.value] && (F = e.value[Oe.value][ze.value]), !F && e.value[Oe.value + (y2 ? 1 : -1)] ? (Oe.value = Oe.value + (y2 ? 1 : -1), ze.value = y2 ? 0 : e.value[Oe.value].length - 1) : F || (ze.value = y2 ? ze.value - 1 : ze.value + 1);
  }, l = (y2) => {
    if (Oe.value === 0 && !y2 || Oe.value === e.value.length && y2) return;
    Oe.value = y2 ? Oe.value + 1 : Oe.value - 1, e.value[Oe.value] ? e.value[Oe.value] && !e.value[Oe.value][ze.value] && ze.value !== 0 && (ze.value = e.value[Oe.value].length - 1) : Oe.value = y2 ? Oe.value - 1 : Oe.value + 1;
  }, a = (y2) => {
    let F = null;
    e.value[Oe.value] && (F = e.value[Oe.value][ze.value]), F ? F.focus({ preventScroll: !aa.value }) : ze.value = y2 ? ze.value - 1 : ze.value + 1;
  }, n2 = () => {
    t(true), a(true);
  }, c2 = () => {
    t(false), a(false);
  }, v = () => {
    l(false), a(true);
  }, b2 = () => {
    l(true), a(true);
  }, i = (y2, F) => {
    Se[F] = y2;
  }, L = (y2, F) => {
    Se[F] = y2;
  }, m2 = () => {
    ze.value = 0, Oe.value = 0;
  };
  return {
    buildMatrix: i,
    buildMultiLevelMatrix: L,
    setTimePickerBackRef: (y2) => {
      Ra.value = y2;
    },
    setSelectionGrid: (y2) => {
      aa.value = y2, m2(), y2 || (Se.selectionGrid = []);
    },
    setTimePicker: (y2, F = false) => {
      Ca.value = y2, Oa.value = F, m2(), y2 || (Se.timePicker[0] = [], Se.timePicker[1] = []);
    },
    setTimePickerElements: (y2, F = 0) => {
      Se.timePicker[F] = y2;
    },
    arrowRight: n2,
    arrowLeft: c2,
    arrowUp: v,
    arrowDown: b2,
    clearArrowNav: () => {
      Se.monthYear = [], Se.calendar = [], Se.time = [], Se.actionRow = [], Se.selectionGrid = [], Se.timePicker[0] = [], Se.timePicker[1] = [], aa.value = false, Ca.value = false, Oa.value = false, _a.value = false, m2(), Ra.value = null;
    },
    setMonthPicker: (y2) => {
      _a.value = y2, m2();
    },
    refSets: Se
    // exposed for testing
  };
}, un = (e) => ({
  menuAppearTop: "dp-menu-appear-top",
  menuAppearBottom: "dp-menu-appear-bottom",
  open: "dp-slide-down",
  close: "dp-slide-up",
  next: "calendar-next",
  previous: "calendar-prev",
  vNext: "dp-slide-up",
  vPrevious: "dp-slide-down",
  ...e ?? {}
}), Pl = (e) => ({
  toggleOverlay: "Toggle overlay",
  menu: "Datepicker menu",
  input: "Datepicker input",
  calendarWrap: "Calendar wrapper",
  calendarDays: "Calendar days",
  openTimePicker: "Open time picker",
  closeTimePicker: "Close time Picker",
  incrementValue: (t) => `Increment ${t}`,
  decrementValue: (t) => `Decrement ${t}`,
  openTpOverlay: (t) => `Open ${t} overlay`,
  amPmButton: "Switch AM/PM mode",
  openYearsOverlay: "Open years overlay",
  openMonthsOverlay: "Open months overlay",
  nextMonth: "Next month",
  prevMonth: "Previous month",
  nextYear: "Next year",
  prevYear: "Previous year",
  day: void 0,
  weekDay: void 0,
  ...e ?? {}
}), dn = (e) => e ? typeof e == "boolean" ? e ? 2 : 0 : +e >= 2 ? +e : 2 : 0, Rl = (e) => {
  const t = typeof e == "object" && e, l = {
    static: true,
    solo: false
  };
  if (!e) return { ...l, count: dn(false) };
  const a = t ? e : {}, n2 = t ? a.count ?? true : e, c2 = dn(n2);
  return Object.assign(l, a, { count: c2 });
}, Cl = (e, t, l) => e || (typeof l == "string" ? l : t), _l = (e) => typeof e == "boolean" ? e ? un({}) : false : un(e), Ol = (e) => {
  const t = {
    enterSubmit: true,
    tabSubmit: true,
    openMenu: true,
    selectOnFocus: false,
    rangeSeparator: " - "
  };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: true } : { ...t, enabled: e };
}, Bl = (e) => ({
  months: [],
  years: [],
  times: { hours: [], minutes: [], seconds: [] },
  ...e ?? {}
}), Yl = (e) => ({
  showSelect: true,
  showCancel: true,
  showNow: false,
  showPreview: true,
  ...e ?? {}
}), Il = (e) => {
  const t = { input: false };
  return typeof e == "object" ? { ...t, ...e ?? {}, enabled: true } : {
    enabled: e,
    ...t
  };
}, Nl = (e) => ({ ...{
  allowStopPropagation: true,
  closeOnScroll: false,
  modeHeight: 255,
  allowPreventDefault: false,
  closeOnClearValue: true,
  closeOnAutoApply: true,
  noSwipe: false,
  keepActionRow: false,
  onClickOutside: void 0,
  tabOutClosesMenu: true,
  arrowLeft: void 0,
  keepViewOnOffsetClick: false,
  timeArrowHoldThreshold: 0
}, ...e ?? {} }), El = (e) => {
  const t = {
    dates: Array.isArray(e) ? e.map((l) => j(l)) : [],
    years: [],
    months: [],
    quarters: [],
    weeks: [],
    weekdays: [],
    options: { highlightDisabled: false }
  };
  return typeof e == "function" ? e : { ...t, ...e ?? {} };
}, Fl = (e) => typeof e == "object" ? {
  type: (e == null ? void 0 : e.type) ?? "local",
  hideOnOffsetDates: (e == null ? void 0 : e.hideOnOffsetDates) ?? false
} : {
  type: e,
  hideOnOffsetDates: false
}, Ll = (e, t) => {
  const l = {
    noDisabledRange: false,
    showLastInRange: true,
    minMaxRawRange: false,
    partialRange: true,
    disableTimeRangeValidation: false,
    maxRange: void 0,
    minRange: void 0,
    autoRange: void 0,
    fixedStart: false,
    fixedEnd: false
  };
  return typeof e == "object" ? { enabled: true, ...l, ...e } : {
    enabled: e,
    noDisabledRange: t.noDisabledRange,
    showLastInRange: t.showLastInRange,
    minMaxRawRange: t.minMaxRawRange,
    partialRange: t.partialRange,
    disableTimeRangeValidation: t.disableTimeRangeValidation,
    maxRange: t.maxRange,
    minRange: t.minRange,
    autoRange: t.autoRange,
    fixedStart: t.fixedStart,
    fixedEnd: t.fixedEnd
  };
}, zl = (e, t) => e ? typeof e == "string" ? { timezone: e, exactMatch: false, dateInTz: void 0, emitTimezone: t, convertModel: true } : {
  timezone: e.timezone,
  exactMatch: e.exactMatch ?? false,
  dateInTz: e.dateInTz ?? void 0,
  emitTimezone: t ?? e.emitTimezone,
  convertModel: e.convertModel ?? true
} : { timezone: void 0, exactMatch: false, emitTimezone: t }, Ba = (e, t, l) => new Map(
  e.map((a) => {
    const n2 = Wa(a, t, l);
    return [Ga(n2), n2];
  })
), Hl = (e, t) => e.length ? new Map(
  e.map((l) => {
    const a = Wa(l.date, t);
    return [Ga(a), l];
  })
) : null, Vl = (e) => {
  var t;
  return {
    minDate: Na(e.minDate, e.timezone, e.isSpecific),
    maxDate: Na(e.maxDate, e.timezone, e.isSpecific),
    disabledDates: $a(e.disabledDates) ? Ba(e.disabledDates, e.timezone, e.isSpecific) : e.disabledDates,
    allowedDates: $a(e.allowedDates) ? Ba(e.allowedDates, e.timezone, e.isSpecific) : null,
    highlight: typeof e.highlight == "object" && $a((t = e.highlight) == null ? void 0 : t.dates) ? Ba(e.highlight.dates, e.timezone) : e.highlight,
    markers: Hl(e.markers, e.timezone)
  };
}, Ul = (e, t) => typeof e == "boolean" ? { enabled: e, dragSelect: true, limit: +t } : {
  enabled: !!e,
  limit: e.limit ? +e.limit : null,
  dragSelect: e.dragSelect ?? true
}, Wl = (e) => ({
  ...Object.fromEntries(
    Object.keys(e).map((l) => {
      const a = l, n2 = e[a], c2 = typeof e[a] == "string" ? { [n2]: true } : Object.fromEntries(n2.map((v) => [v, true]));
      return [l, c2];
    })
  )
}), Ce = (e) => {
  const t = () => {
    const le2 = e.enableSeconds ? ":ss" : "", q2 = e.enableMinutes ? ":mm" : "";
    return e.is24 ? `HH${q2}${le2}` : `hh${q2}${le2} aa`;
  }, l = () => {
    var le2;
    return e.format ? e.format : e.monthPicker ? "MM/yyyy" : e.timePicker ? t() : e.weekPicker ? `${((le2 = S2.value) == null ? void 0 : le2.type) === "iso" ? "RR" : "ww"}-yyyy` : e.yearPicker ? "yyyy" : e.quarterPicker ? "QQQ/yyyy" : e.enableTimePicker ? `MM/dd/yyyy, ${t()}` : "MM/dd/yyyy";
  }, a = (le2) => Rn(le2, e.enableSeconds), n2 = () => J.value.enabled ? e.startTime && Array.isArray(e.startTime) ? [a(e.startTime[0]), a(e.startTime[1])] : null : e.startTime && !Array.isArray(e.startTime) ? a(e.startTime) : null, c2 = computed(() => Rl(e.multiCalendars)), v = computed(() => n2()), b2 = computed(() => Pl(e.ariaLabels)), i = computed(() => Bl(e.filters)), L = computed(() => _l(e.transitions)), m2 = computed(() => Yl(e.actionRow)), E2 = computed(
    () => Cl(e.previewFormat, e.format, l())
  ), k2 = computed(() => Ol(e.textInput)), _2 = computed(() => Il(e.inline)), H2 = computed(() => Nl(e.config)), N = computed(() => El(e.highlight)), S2 = computed(() => Fl(e.weekNumbers)), y2 = computed(() => zl(e.timezone, e.emitTimezone)), F = computed(() => Ul(e.multiDates, e.multiDatesLimit)), P = computed(
    () => Vl({
      minDate: e.minDate,
      maxDate: e.maxDate,
      disabledDates: e.disabledDates,
      allowedDates: e.allowedDates,
      highlight: N.value,
      markers: e.markers,
      timezone: y2.value,
      isSpecific: e.monthPicker || e.yearPicker || e.quarterPicker
    })
  ), J = computed(
    () => Ll(e.range, {
      minMaxRawRange: false,
      maxRange: e.maxRange,
      minRange: e.minRange,
      noDisabledRange: e.noDisabledRange,
      showLastInRange: e.showLastInRange,
      partialRange: e.partialRange,
      disableTimeRangeValidation: e.disableTimeRangeValidation,
      autoRange: e.autoRange,
      fixedStart: e.fixedStart,
      fixedEnd: e.fixedEnd
    })
  ), Z2 = computed(() => Wl(e.ui));
  return {
    defaultedTransitions: L,
    defaultedMultiCalendars: c2,
    defaultedStartTime: v,
    defaultedAriaLabels: b2,
    defaultedFilters: i,
    defaultedActionRow: m2,
    defaultedPreviewFormat: E2,
    defaultedTextInput: k2,
    defaultedInline: _2,
    defaultedConfig: H2,
    defaultedHighlight: N,
    defaultedWeekNumbers: S2,
    defaultedRange: J,
    propDates: P,
    defaultedTz: y2,
    defaultedMultiDates: F,
    defaultedUI: Z2,
    getDefaultPattern: l,
    getDefaultStartTime: n2
  };
}, jl = (e, t, l) => {
  const a = ref(), { defaultedTextInput: n2, defaultedRange: c2, defaultedTz: v, defaultedMultiDates: b2, getDefaultPattern: i } = Ce(t), L = ref(""), m2 = toRef(t, "format"), E2 = toRef(t, "formatLocale");
  watch(
    a,
    () => {
      typeof t.onInternalModelChange == "function" && e("internal-model-change", a.value, T(true));
    },
    { deep: true }
  ), watch(c2, (s, oe2) => {
    s.enabled !== oe2.enabled && (a.value = null);
  }), watch(m2, () => {
    z2();
  });
  const k2 = (s) => v.value.timezone && v.value.convertModel ? Xe(s, v.value.timezone) : s, _2 = (s) => {
    if (v.value.timezone && v.value.convertModel) {
      const oe2 = dl(v.value.timezone);
      return addHours(s, oe2);
    }
    return s;
  }, H2 = (s, oe2, M = false) => _n(
    s,
    t.format,
    t.formatLocale,
    n2.value.rangeSeparator,
    t.modelAuto,
    oe2 ?? i(),
    M
  ), N = (s) => s ? t.modelType ? ee2(s) : {
    hours: getHours(s),
    minutes: getMinutes(s),
    seconds: t.enableSeconds ? getSeconds(s) : 0
  } : null, S2 = (s) => t.modelType ? ee2(s) : { month: getMonth(s), year: getYear(s) }, y2 = (s) => Array.isArray(s) ? b2.value.enabled ? s.map((oe2) => F(oe2, setYear(j(), oe2))) : ta(
    () => [
      setYear(j(), s[0]),
      s[1] ? setYear(j(), s[1]) : Rt(c2.value.partialRange)
    ],
    c2.value.enabled
  ) : setYear(j(), +s), F = (s, oe2) => (typeof s == "string" || typeof s == "number") && t.modelType ? D(s) : oe2, P = (s) => Array.isArray(s) ? [
    F(
      s[0],
      pt(null, +s[0].hours, +s[0].minutes, s[0].seconds)
    ),
    F(
      s[1],
      pt(null, +s[1].hours, +s[1].minutes, s[1].seconds)
    )
  ] : F(s, pt(null, s.hours, s.minutes, s.seconds)), J = (s) => {
    const oe2 = set(j(), { date: 1 });
    return Array.isArray(s) ? b2.value.enabled ? s.map((M) => F(M, dt(oe2, +M.month, +M.year))) : ta(
      () => [
        F(s[0], dt(oe2, +s[0].month, +s[0].year)),
        F(
          s[1],
          s[1] ? dt(oe2, +s[1].month, +s[1].year) : Rt(c2.value.partialRange)
        )
      ],
      c2.value.enabled
    ) : F(s, dt(oe2, +s.month, +s.year));
  }, Z2 = (s) => {
    if (Array.isArray(s))
      return s.map((oe2) => D(oe2));
    throw new Error(Ka.dateArr("multi-dates"));
  }, le2 = (s) => {
    if (Array.isArray(s) && c2.value.enabled) {
      const oe2 = s[0], M = s[1];
      return [
        j(Array.isArray(oe2) ? oe2[0] : null),
        j(Array.isArray(M) ? M[0] : null)
      ];
    }
    return j(s[0]);
  }, q2 = (s) => t.modelAuto ? Array.isArray(s) ? [D(s[0]), D(s[1])] : t.autoApply ? [D(s)] : [D(s), null] : Array.isArray(s) ? ta(
    () => s[1] ? [
      D(s[0]),
      s[1] ? D(s[1]) : Rt(c2.value.partialRange)
    ] : [D(s[0])],
    c2.value.enabled
  ) : D(s), R = () => {
    Array.isArray(a.value) && c2.value.enabled && a.value.length === 1 && a.value.push(Rt(c2.value.partialRange));
  }, re2 = () => {
    const s = a.value;
    return [
      ee2(s[0]),
      s[1] ? ee2(s[1]) : Rt(c2.value.partialRange)
    ];
  }, B2 = () => a.value[1] ? re2() : ee2(Ye(a.value[0])), K2 = () => (a.value || []).map((s) => ee2(s)), fe2 = (s = false) => (s || R(), t.modelAuto ? B2() : b2.value.enabled ? K2() : Array.isArray(a.value) ? ta(() => re2(), c2.value.enabled) : ee2(Ye(a.value))), ce2 = (s) => !s || Array.isArray(s) && !s.length ? null : t.timePicker ? P(Ye(s)) : t.monthPicker ? J(Ye(s)) : t.yearPicker ? y2(Ye(s)) : b2.value.enabled ? Z2(Ye(s)) : t.weekPicker ? le2(Ye(s)) : q2(Ye(s)), O = (s) => {
    const oe2 = ce2(s);
    Ea(Ye(oe2)) ? (a.value = Ye(oe2), z2()) : (a.value = null, L.value = "");
  }, A = () => {
    const s = (oe2) => format(oe2, n2.value.format);
    return `${s(a.value[0])} ${n2.value.rangeSeparator} ${a.value[1] ? s(a.value[1]) : ""}`;
  }, w = () => l.value && a.value ? Array.isArray(a.value) ? A() : format(a.value, n2.value.format) : H2(a.value), o = () => a.value ? b2.value.enabled ? a.value.map((s) => H2(s)).join("; ") : n2.value.enabled && typeof n2.value.format == "string" ? w() : H2(a.value) : "", z2 = () => {
    !t.format || typeof t.format == "string" || n2.value.enabled && typeof n2.value.format == "string" ? L.value = o() : L.value = t.format(a.value);
  }, D = (s) => {
    if (t.utc) {
      const oe2 = new Date(s);
      return t.utc === "preserve" ? new Date(oe2.getTime() + oe2.getTimezoneOffset() * 6e4) : oe2;
    }
    return t.modelType ? cl.includes(t.modelType) ? k2(new Date(s)) : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? k2(
      parse$1(s, i(), /* @__PURE__ */ new Date(), { locale: E2.value })
    ) : k2(
      parse$1(s, t.modelType, /* @__PURE__ */ new Date(), { locale: E2.value })
    ) : k2(new Date(s));
  }, ee2 = (s) => s ? t.utc ? Dl(s, t.utc === "preserve", t.enableSeconds) : t.modelType ? t.modelType === "timestamp" ? +_2(s) : t.modelType === "iso" ? _2(s).toISOString() : t.modelType === "format" && (typeof t.format == "string" || !t.format) ? H2(_2(s)) : H2(_2(s), t.modelType, true) : _2(s) : "", de2 = (s, oe2 = false, M = false) => {
    if (M) return s;
    if (e("update:model-value", s), v.value.emitTimezone && oe2) {
      const me2 = Array.isArray(s) ? s.map((d2) => Xe(Ye(d2), v.value.emitTimezone)) : Xe(Ye(s), v.value.emitTimezone);
      e("update:model-timezone-value", me2);
    }
  }, u = (s) => Array.isArray(a.value) ? b2.value.enabled ? a.value.map((oe2) => s(oe2)) : [
    s(a.value[0]),
    a.value[1] ? s(a.value[1]) : Rt(c2.value.partialRange)
  ] : s(Ye(a.value)), I = () => {
    if (Array.isArray(a.value)) {
      const s = it(a.value[0], t.weekStart), oe2 = a.value[1] ? it(a.value[1], t.weekStart) : [];
      return [s.map((M) => j(M)), oe2.map((M) => j(M))];
    }
    return it(a.value, t.weekStart).map((s) => j(s));
  }, se = (s, oe2) => de2(Ye(u(s)), false, oe2), f = (s) => {
    const oe2 = I();
    return s ? oe2 : e("update:model-value", I());
  }, T = (s = false) => (s || z2(), t.monthPicker ? se(S2, s) : t.timePicker ? se(N, s) : t.yearPicker ? se(getYear, s) : t.weekPicker ? f(s) : de2(fe2(s), true, s));
  return {
    inputValue: L,
    internalModelValue: a,
    checkBeforeEmit: () => a.value ? c2.value.enabled ? c2.value.partialRange ? a.value.length >= 1 : a.value.length === 2 : !!a.value : false,
    parseExternalModelValue: O,
    formatInputValue: z2,
    emitModelValue: T
  };
}, Kl = (e, t) => {
  const { defaultedFilters: l, propDates: a } = Ce(e), { validateMonthYearInRange: n2 } = kt(e), c2 = (m2, E2) => {
    let k2 = m2;
    return l.value.months.includes(getMonth(k2)) ? (k2 = E2 ? addMonths(m2, 1) : subMonths(m2, 1), c2(k2, E2)) : k2;
  }, v = (m2, E2) => {
    let k2 = m2;
    return l.value.years.includes(getYear(k2)) ? (k2 = E2 ? addYears(m2, 1) : subYears(m2, 1), v(k2, E2)) : k2;
  }, b2 = (m2, E2 = false) => {
    const k2 = set(j(), { month: e.month, year: e.year });
    let _2 = m2 ? addMonths(k2, 1) : subMonths(k2, 1);
    e.disableYearSelect && (_2 = setYear(_2, e.year));
    let H2 = getMonth(_2), N = getYear(_2);
    l.value.months.includes(H2) && (_2 = c2(_2, m2), H2 = getMonth(_2), N = getYear(_2)), l.value.years.includes(N) && (_2 = v(_2, m2), N = getYear(_2)), n2(H2, N, m2, e.preventMinMaxNavigation) && i(H2, N, E2);
  }, i = (m2, E2, k2) => {
    t("update-month-year", { month: m2, year: E2, fromNav: k2 });
  }, L = computed(() => (m2) => Cn(
    set(j(), { month: e.month, year: e.year }),
    a.value.maxDate,
    a.value.minDate,
    e.preventMinMaxNavigation,
    m2
  ));
  return { handleMonthYearChange: b2, isDisabled: L, updateMonthYear: i };
}, ca = {
  multiCalendars: { type: [Boolean, Number, String, Object], default: void 0 },
  modelValue: { type: [String, Date, Array, Object, Number], default: null },
  modelType: { type: String, default: null },
  position: { type: String, default: "center" },
  dark: { type: Boolean, default: false },
  format: {
    type: [String, Function],
    default: () => null
  },
  autoPosition: { type: Boolean, default: true },
  altPosition: { type: Function, default: null },
  transitions: { type: [Boolean, Object], default: true },
  formatLocale: { type: Object, default: null },
  utc: { type: [Boolean, String], default: false },
  ariaLabels: { type: Object, default: () => ({}) },
  offset: { type: [Number, String], default: 10 },
  hideNavigation: { type: Array, default: () => [] },
  timezone: { type: [String, Object], default: null },
  emitTimezone: { type: String, default: null },
  vertical: { type: Boolean, default: false },
  disableMonthYearSelect: { type: Boolean, default: false },
  disableYearSelect: { type: Boolean, default: false },
  menuClassName: { type: String, default: null },
  dayClass: {
    type: Function,
    default: null
  },
  yearRange: { type: Array, default: () => [1900, 2100] },
  calendarCellClassName: { type: String, default: null },
  enableTimePicker: { type: Boolean, default: true },
  autoApply: { type: Boolean, default: false },
  disabledDates: { type: [Array, Function], default: () => [] },
  monthNameFormat: { type: String, default: "short" },
  startDate: { type: [Date, String], default: null },
  startTime: { type: [Object, Array], default: null },
  hideOffsetDates: { type: Boolean, default: false },
  autoRange: { type: [Number, String], default: null },
  noToday: { type: Boolean, default: false },
  disabledWeekDays: { type: Array, default: () => [] },
  allowedDates: { type: Array, default: null },
  nowButtonLabel: { type: String, default: "Now" },
  markers: { type: Array, default: () => [] },
  escClose: { type: Boolean, default: true },
  spaceConfirm: { type: Boolean, default: true },
  monthChangeOnArrows: { type: Boolean, default: true },
  presetDates: { type: Array, default: () => [] },
  flow: { type: Array, default: () => [] },
  partialFlow: { type: Boolean, default: false },
  preventMinMaxNavigation: { type: Boolean, default: false },
  minRange: { type: [Number, String], default: null },
  maxRange: { type: [Number, String], default: null },
  multiDatesLimit: { type: [Number, String], default: null },
  reverseYears: { type: Boolean, default: false },
  weekPicker: { type: Boolean, default: false },
  filters: { type: Object, default: () => ({}) },
  arrowNavigation: { type: Boolean, default: false },
  disableTimeRangeValidation: { type: Boolean, default: false },
  highlight: {
    type: [Function, Object],
    default: null
  },
  teleport: { type: [Boolean, String, Object], default: null },
  teleportCenter: { type: Boolean, default: false },
  locale: { type: String, default: "en-Us" },
  weekNumName: { type: String, default: "W" },
  weekStart: { type: [Number, String], default: 1 },
  weekNumbers: {
    type: [String, Function, Object],
    default: null
  },
  calendarClassName: { type: String, default: null },
  monthChangeOnScroll: { type: [Boolean, String], default: true },
  dayNames: {
    type: [Function, Array],
    default: null
  },
  monthPicker: { type: Boolean, default: false },
  customProps: { type: Object, default: null },
  yearPicker: { type: Boolean, default: false },
  modelAuto: { type: Boolean, default: false },
  selectText: { type: String, default: "Select" },
  cancelText: { type: String, default: "Cancel" },
  previewFormat: {
    type: [String, Function],
    default: () => ""
  },
  multiDates: { type: [Object, Boolean], default: false },
  partialRange: { type: Boolean, default: true },
  ignoreTimeValidation: { type: Boolean, default: false },
  minDate: { type: [Date, String], default: null },
  maxDate: { type: [Date, String], default: null },
  minTime: { type: Object, default: null },
  maxTime: { type: Object, default: null },
  name: { type: String, default: null },
  placeholder: { type: String, default: "" },
  hideInputIcon: { type: Boolean, default: false },
  clearable: { type: Boolean, default: true },
  state: { type: Boolean, default: null },
  required: { type: Boolean, default: false },
  autocomplete: { type: String, default: "off" },
  inputClassName: { type: String, default: null },
  fixedStart: { type: Boolean, default: false },
  fixedEnd: { type: Boolean, default: false },
  timePicker: { type: Boolean, default: false },
  enableSeconds: { type: Boolean, default: false },
  is24: { type: Boolean, default: true },
  noHoursOverlay: { type: Boolean, default: false },
  noMinutesOverlay: { type: Boolean, default: false },
  noSecondsOverlay: { type: Boolean, default: false },
  hoursGridIncrement: { type: [String, Number], default: 1 },
  minutesGridIncrement: { type: [String, Number], default: 5 },
  secondsGridIncrement: { type: [String, Number], default: 5 },
  hoursIncrement: { type: [Number, String], default: 1 },
  minutesIncrement: { type: [Number, String], default: 1 },
  secondsIncrement: { type: [Number, String], default: 1 },
  range: { type: [Boolean, Object], default: false },
  uid: { type: String, default: null },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  inline: { type: [Boolean, Object], default: false },
  textInput: { type: [Boolean, Object], default: false },
  noDisabledRange: { type: Boolean, default: false },
  sixWeeks: { type: [Boolean, String], default: false },
  actionRow: { type: Object, default: () => ({}) },
  focusStartDate: { type: Boolean, default: false },
  disabledTimes: { type: [Function, Array], default: void 0 },
  showLastInRange: { type: Boolean, default: true },
  timePickerInline: { type: Boolean, default: false },
  calendar: { type: Function, default: null },
  config: { type: Object, default: void 0 },
  quarterPicker: { type: Boolean, default: false },
  yearFirst: { type: Boolean, default: false },
  loading: { type: Boolean, default: false },
  onInternalModelChange: { type: [Function, Object], default: null },
  enableMinutes: { type: Boolean, default: true },
  ui: { type: Object, default: () => ({}) }
}, rt = {
  ...ca,
  shadow: { type: Boolean, default: false },
  flowStep: { type: Number, default: 0 },
  internalModelValue: { type: [Date, Array], default: null },
  noOverlayFocus: { type: Boolean, default: false },
  collapse: { type: Boolean, default: false },
  menuWrapRef: { type: Object, default: null },
  getInputRect: { type: Function, default: () => ({}) },
  isTextInputDate: { type: Boolean, default: false }
}, Gl = ["title"], Ql = ["disabled"], ql = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "ActionRow",
  props: {
    menuMount: { type: Boolean, default: false },
    calendarWidth: { type: Number, default: 0 },
    ...rt
  },
  emits: ["close-picker", "select-date", "select-now", "invalid-select"],
  setup(e, { emit: t }) {
    const l = t, a = e, {
      defaultedActionRow: n2,
      defaultedPreviewFormat: c2,
      defaultedMultiCalendars: v,
      defaultedTextInput: b2,
      defaultedInline: i,
      defaultedRange: L,
      defaultedMultiDates: m2,
      getDefaultPattern: E2
    } = Ce(a), { isTimeValid: k2, isMonthValid: _2 } = kt(a), { buildMatrix: H2 } = bt(), N = ref(null), S2 = ref(null), y2 = ref(false), F = ref({}), P = ref(null), J = ref(null);
    onMounted(() => {
      a.arrowNavigation && H2([Ie(N), Ie(S2)], "actionRow"), Z2(), window.addEventListener("resize", Z2);
    }), onUnmounted(() => {
      window.removeEventListener("resize", Z2);
    });
    const Z2 = () => {
      y2.value = false, setTimeout(() => {
        var o, z2;
        const A = (o = P.value) == null ? void 0 : o.getBoundingClientRect(), w = (z2 = J.value) == null ? void 0 : z2.getBoundingClientRect();
        A && w && (F.value.maxWidth = `${w.width - A.width - 20}px`), y2.value = true;
      }, 0);
    }, le2 = computed(() => L.value.enabled && !L.value.partialRange && a.internalModelValue ? a.internalModelValue.length === 2 : true), q2 = computed(
      () => !k2.value(a.internalModelValue) || !_2.value(a.internalModelValue) || !le2.value
    ), R = () => {
      const A = c2.value;
      return a.timePicker || a.monthPicker, A(Ye(a.internalModelValue));
    }, re2 = () => {
      const A = a.internalModelValue;
      return v.value.count > 0 ? `${B2(A[0])} - ${B2(A[1])}` : [B2(A[0]), B2(A[1])];
    }, B2 = (A) => _n(
      A,
      c2.value,
      a.formatLocale,
      b2.value.rangeSeparator,
      a.modelAuto,
      E2()
    ), K2 = computed(() => !a.internalModelValue || !a.menuMount ? "" : typeof c2.value == "string" ? Array.isArray(a.internalModelValue) ? a.internalModelValue.length === 2 && a.internalModelValue[1] ? re2() : m2.value.enabled ? a.internalModelValue.map((A) => `${B2(A)}`) : a.modelAuto ? `${B2(a.internalModelValue[0])}` : `${B2(a.internalModelValue[0])} -` : B2(a.internalModelValue) : R()), fe2 = () => m2.value.enabled ? "; " : " - ", ce2 = computed(
      () => Array.isArray(K2.value) ? K2.value.join(fe2()) : K2.value
    ), O = () => {
      k2.value(a.internalModelValue) && _2.value(a.internalModelValue) && le2.value ? l("select-date") : l("invalid-select");
    };
    return (A, w) => (openBlock(), createElementBlock("div", {
      ref_key: "actionRowRef",
      ref: J,
      class: "dp__action_row"
    }, [
      A.$slots["action-row"] ? renderSlot(A.$slots, "action-row", normalizeProps(mergeProps({ key: 0 }, {
        internalModelValue: A.internalModelValue,
        disabled: q2.value,
        selectDate: () => A.$emit("select-date"),
        closePicker: () => A.$emit("close-picker")
      }))) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
        unref(n2).showPreview ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: "dp__selection_preview",
          title: ce2.value,
          style: normalizeStyle(F.value)
        }, [
          A.$slots["action-preview"] && y2.value ? renderSlot(A.$slots, "action-preview", {
            key: 0,
            value: A.internalModelValue
          }) : createCommentVNode("", true),
          !A.$slots["action-preview"] && y2.value ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(ce2.value), 1)
          ], 64)) : createCommentVNode("", true)
        ], 12, Gl)) : createCommentVNode("", true),
        createElementVNode("div", {
          ref_key: "actionBtnContainer",
          ref: P,
          class: "dp__action_buttons",
          "data-dp-element": "action-row"
        }, [
          A.$slots["action-buttons"] ? renderSlot(A.$slots, "action-buttons", {
            key: 0,
            value: A.internalModelValue
          }) : createCommentVNode("", true),
          A.$slots["action-buttons"] ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            !unref(i).enabled && unref(n2).showCancel ? (openBlock(), createElementBlock("button", {
              key: 0,
              ref_key: "cancelButtonRef",
              ref: N,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: w[0] || (w[0] = (o) => A.$emit("close-picker")),
              onKeydown: w[1] || (w[1] = (o) => unref(qe)(o, () => A.$emit("close-picker")))
            }, toDisplayString(A.cancelText), 545)) : createCommentVNode("", true),
            unref(n2).showNow ? (openBlock(), createElementBlock("button", {
              key: 1,
              type: "button",
              class: "dp__action_button dp__action_cancel",
              onClick: w[2] || (w[2] = (o) => A.$emit("select-now")),
              onKeydown: w[3] || (w[3] = (o) => unref(qe)(o, () => A.$emit("select-now")))
            }, toDisplayString(A.nowButtonLabel), 33)) : createCommentVNode("", true),
            unref(n2).showSelect ? (openBlock(), createElementBlock("button", {
              key: 2,
              ref_key: "selectButtonRef",
              ref: S2,
              type: "button",
              class: "dp__action_button dp__action_select",
              disabled: q2.value,
              "data-test": "select-button",
              onKeydown: w[4] || (w[4] = (o) => unref(qe)(o, () => O())),
              onClick: O
            }, toDisplayString(A.selectText), 41, Ql)) : createCommentVNode("", true)
          ], 64))
        ], 512)
      ], 64))
    ], 512));
  }
}), Xl = { class: "dp__selection_grid_header" }, Jl = ["aria-selected", "aria-disabled", "data-test", "onClick", "onKeydown", "onMouseover"], Zl = ["aria-label"], qt = /* @__PURE__ */ defineComponent({
  __name: "SelectionOverlay",
  props: {
    items: {},
    type: {},
    isLast: { type: Boolean },
    arrowNavigation: { type: Boolean },
    skipButtonRef: { type: Boolean },
    headerRefs: {},
    hideNavigation: {},
    escClose: { type: Boolean },
    useRelative: { type: Boolean },
    height: {},
    textInput: { type: [Boolean, Object] },
    config: {},
    noOverlayFocus: { type: Boolean },
    focusValue: {},
    menuWrapRef: {},
    ariaLabels: {}
  },
  emits: ["selected", "toggle", "reset-flow", "hover-value"],
  setup(e, { expose: t, emit: l }) {
    const { setSelectionGrid: a, buildMultiLevelMatrix: n2, setMonthPicker: c2 } = bt(), v = l, b2 = e, { defaultedAriaLabels: i, defaultedTextInput: L, defaultedConfig: m2 } = Ce(
      b2
    ), { hideNavigationButtons: E2 } = ma(), k2 = ref(false), _2 = ref(null), H2 = ref(null), N = ref([]), S2 = ref(), y2 = ref(null), F = ref(0), P = ref(null);
    onBeforeUpdate(() => {
      _2.value = null;
    }), onMounted(() => {
      nextTick().then(() => K2()), b2.noOverlayFocus || Z2(), J(true);
    }), onUnmounted(() => J(false));
    const J = (u) => {
      var I;
      b2.arrowNavigation && ((I = b2.headerRefs) != null && I.length ? c2(u) : a(u));
    }, Z2 = () => {
      var I;
      const u = Ie(H2);
      u && (L.value.enabled || (_2.value ? (I = _2.value) == null || I.focus({ preventScroll: true }) : u.focus({ preventScroll: true })), k2.value = u.clientHeight < u.scrollHeight);
    }, le2 = computed(
      () => ({
        dp__overlay: true,
        "dp--overlay-absolute": !b2.useRelative,
        "dp--overlay-relative": b2.useRelative
      })
    ), q2 = computed(
      () => b2.useRelative ? { height: `${b2.height}px`, width: "260px" } : void 0
    ), R = computed(() => ({
      dp__overlay_col: true
    })), re2 = computed(
      () => ({
        dp__btn: true,
        dp__button: true,
        dp__overlay_action: true,
        dp__over_action_scroll: k2.value,
        dp__button_bottom: b2.isLast
      })
    ), B2 = computed(() => {
      var u, I;
      return {
        dp__overlay_container: true,
        dp__container_flex: ((u = b2.items) == null ? void 0 : u.length) <= 6,
        dp__container_block: ((I = b2.items) == null ? void 0 : I.length) > 6
      };
    });
    watch(
      () => b2.items,
      () => K2(false),
      { deep: true }
    );
    const K2 = (u = true) => {
      nextTick().then(() => {
        const I = Ie(_2), se = Ie(H2), f = Ie(y2), T = Ie(P), Q2 = f ? f.getBoundingClientRect().height : 0;
        se && (se.getBoundingClientRect().height ? F.value = se.getBoundingClientRect().height - Q2 : F.value = m2.value.modeHeight - Q2), I && T && u && (T.scrollTop = I.offsetTop - T.offsetTop - (F.value / 2 - I.getBoundingClientRect().height) - Q2);
      });
    }, fe2 = (u) => {
      u.disabled || v("selected", u.value);
    }, ce2 = () => {
      v("toggle"), v("reset-flow");
    }, O = () => {
      b2.escClose && ce2();
    }, A = (u, I, se, f) => {
      u && ((I.active || I.value === b2.focusValue) && (_2.value = u), b2.arrowNavigation && (Array.isArray(N.value[se]) ? N.value[se][f] = u : N.value[se] = [u], w()));
    }, w = () => {
      var I, se;
      const u = (I = b2.headerRefs) != null && I.length ? [b2.headerRefs].concat(N.value) : N.value.concat([b2.skipButtonRef ? [] : [y2.value]]);
      n2(Ye(u), (se = b2.headerRefs) != null && se.length ? "monthPicker" : "selectionGrid");
    }, o = (u) => {
      b2.arrowNavigation || yt(u, m2.value, true);
    }, z2 = (u) => {
      S2.value = u, v("hover-value", u);
    }, D = () => {
      if (ce2(), !b2.isLast) {
        const u = bl(b2.menuWrapRef ?? null, "action-row");
        if (u) {
          const I = $n(u);
          I == null || I.focus();
        }
      }
    }, ee2 = (u) => {
      switch (u.key) {
        case Re.esc:
          return O();
        case Re.arrowLeft:
          return o(u);
        case Re.arrowRight:
          return o(u);
        case Re.arrowUp:
          return o(u);
        case Re.arrowDown:
          return o(u);
        default:
          return;
      }
    }, de2 = (u) => {
      if (u.key === Re.enter) return ce2();
      if (u.key === Re.tab) return D();
    };
    return t({ focusGrid: Z2 }), (u, I) => {
      var se;
      return openBlock(), createElementBlock("div", {
        ref_key: "gridWrapRef",
        ref: H2,
        class: normalizeClass(le2.value),
        style: normalizeStyle(q2.value),
        role: "dialog",
        tabindex: "0",
        onKeydown: ee2,
        onClick: I[0] || (I[0] = withModifiers(() => {
        }, ["prevent"]))
      }, [
        createElementVNode("div", {
          ref_key: "containerRef",
          ref: P,
          class: normalizeClass(B2.value),
          role: "grid",
          style: normalizeStyle({ "--dp-overlay-height": `${F.value}px` })
        }, [
          createElementVNode("div", Xl, [
            renderSlot(u.$slots, "header")
          ]),
          u.$slots.overlay ? renderSlot(u.$slots, "overlay", { key: 0 }) : (openBlock(true), createElementBlock(Fragment, { key: 1 }, renderList(u.items, (f, T) => (openBlock(), createElementBlock("div", {
            key: T,
            class: normalizeClass(["dp__overlay_row", { dp__flex_row: u.items.length >= 3 }]),
            role: "row"
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(f, (Q2, s) => (openBlock(), createElementBlock("div", {
              key: Q2.value,
              ref_for: true,
              ref: (oe2) => A(oe2, Q2, T, s),
              role: "gridcell",
              class: normalizeClass(R.value),
              "aria-selected": Q2.active || void 0,
              "aria-disabled": Q2.disabled || void 0,
              tabindex: "0",
              "data-test": Q2.text,
              onClick: withModifiers((oe2) => fe2(Q2), ["prevent"]),
              onKeydown: (oe2) => unref(qe)(oe2, () => fe2(Q2), true),
              onMouseover: (oe2) => z2(Q2.value)
            }, [
              createElementVNode("div", {
                class: normalizeClass(Q2.className)
              }, [
                u.$slots.item ? renderSlot(u.$slots, "item", {
                  key: 0,
                  item: Q2
                }) : createCommentVNode("", true),
                u.$slots.item ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(Q2.text), 1)
                ], 64))
              ], 2)
            ], 42, Jl))), 128))
          ], 2))), 128))
        ], 6),
        u.$slots["button-icon"] ? withDirectives((openBlock(), createElementBlock("button", {
          key: 0,
          ref_key: "toggleButton",
          ref: y2,
          type: "button",
          "aria-label": (se = unref(i)) == null ? void 0 : se.toggleOverlay,
          class: normalizeClass(re2.value),
          tabindex: "0",
          onClick: ce2,
          onKeydown: de2
        }, [
          renderSlot(u.$slots, "button-icon")
        ], 42, Zl)), [
          [vShow, !unref(E2)(u.hideNavigation, u.type)]
        ]) : createCommentVNode("", true)
      ], 38);
    };
  }
}), fa = /* @__PURE__ */ defineComponent({
  __name: "InstanceWrap",
  props: {
    multiCalendars: {},
    stretch: { type: Boolean },
    collapse: { type: Boolean }
  },
  setup(e) {
    const t = e, l = computed(
      () => t.multiCalendars > 0 ? [...Array(t.multiCalendars).keys()] : [0]
    ), a = computed(() => ({
      dp__instance_calendar: t.multiCalendars > 0
    }));
    return (n2, c2) => (openBlock(), createElementBlock("div", {
      class: normalizeClass({
        dp__menu_inner: !n2.stretch,
        "dp--menu--inner-stretched": n2.stretch,
        dp__flex_display: n2.multiCalendars > 0,
        "dp--flex-display-collapsed": n2.collapse
      })
    }, [
      (openBlock(true), createElementBlock(Fragment, null, renderList(l.value, (v, b2) => (openBlock(), createElementBlock("div", {
        key: v,
        class: normalizeClass(a.value)
      }, [
        renderSlot(n2.$slots, "default", {
          instance: v,
          index: b2
        })
      ], 2))), 128))
    ], 2));
  }
}), xl = ["aria-label", "aria-disabled"], Vt = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "ArrowBtn",
  props: {
    ariaLabel: {},
    disabled: { type: Boolean }
  },
  emits: ["activate", "set-ref"],
  setup(e, { emit: t }) {
    const l = t, a = ref(null);
    return onMounted(() => l("set-ref", a)), (n2, c2) => (openBlock(), createElementBlock("button", {
      ref_key: "elRef",
      ref: a,
      type: "button",
      class: "dp__btn dp--arrow-btn-nav",
      tabindex: "0",
      "aria-label": n2.ariaLabel,
      "aria-disabled": n2.disabled || void 0,
      onClick: c2[0] || (c2[0] = (v) => n2.$emit("activate")),
      onKeydown: c2[1] || (c2[1] = (v) => unref(qe)(v, () => n2.$emit("activate"), true))
    }, [
      createElementVNode("span", {
        class: normalizeClass(["dp__inner_nav", { dp__inner_nav_disabled: n2.disabled }])
      }, [
        renderSlot(n2.$slots, "default")
      ], 2)
    ], 40, xl));
  }
}), er = { class: "dp--year-mode-picker" }, tr = ["aria-label", "data-test"], In = /* @__PURE__ */ defineComponent({
  __name: "YearModePicker",
  props: {
    ...rt,
    showYearPicker: { type: Boolean, default: false },
    items: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    isDisabled: { type: Function, default: () => false }
  },
  emits: ["toggle-year-picker", "year-select", "handle-year"],
  setup(e, { emit: t }) {
    const l = t, a = e, { showRightIcon: n2, showLeftIcon: c2 } = ma(), { defaultedConfig: v, defaultedMultiCalendars: b2, defaultedAriaLabels: i, defaultedTransitions: L, defaultedUI: m2 } = Ce(a), { showTransition: E2, transitionName: k2 } = Xt(L), _2 = (S2 = false, y2) => {
      l("toggle-year-picker", { flow: S2, show: y2 });
    }, H2 = (S2) => {
      l("year-select", S2);
    }, N = (S2 = false) => {
      l("handle-year", S2);
    };
    return (S2, y2) => {
      var F, P, J, Z2, le2;
      return openBlock(), createElementBlock("div", er, [
        unref(c2)(unref(b2), e.instance) ? (openBlock(), createBlock(Vt, {
          key: 0,
          ref: "mpPrevIconRef",
          "aria-label": (F = unref(i)) == null ? void 0 : F.prevYear,
          disabled: e.isDisabled(false),
          class: normalizeClass((P = unref(m2)) == null ? void 0 : P.navBtnPrev),
          onActivate: y2[0] || (y2[0] = (q2) => N(false))
        }, {
          default: withCtx(() => [
            S2.$slots["arrow-left"] ? renderSlot(S2.$slots, "arrow-left", { key: 0 }) : createCommentVNode("", true),
            S2.$slots["arrow-left"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(La), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : createCommentVNode("", true),
        createElementVNode("button", {
          ref: "mpYearButtonRef",
          class: "dp__btn dp--year-select",
          type: "button",
          "aria-label": (J = unref(i)) == null ? void 0 : J.openYearsOverlay,
          "data-test": `year-mode-btn-${e.instance}`,
          onClick: y2[1] || (y2[1] = () => _2(false)),
          onKeydown: y2[2] || (y2[2] = withKeys(() => _2(false), ["enter"]))
        }, [
          S2.$slots.year ? renderSlot(S2.$slots, "year", {
            key: 0,
            year: e.year
          }) : createCommentVNode("", true),
          S2.$slots.year ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
            createTextVNode(toDisplayString(e.year), 1)
          ], 64))
        ], 40, tr),
        unref(n2)(unref(b2), e.instance) ? (openBlock(), createBlock(Vt, {
          key: 1,
          ref: "mpNextIconRef",
          "aria-label": (Z2 = unref(i)) == null ? void 0 : Z2.nextYear,
          disabled: e.isDisabled(true),
          class: normalizeClass((le2 = unref(m2)) == null ? void 0 : le2.navBtnNext),
          onActivate: y2[3] || (y2[3] = (q2) => N(true))
        }, {
          default: withCtx(() => [
            S2.$slots["arrow-right"] ? renderSlot(S2.$slots, "arrow-right", { key: 0 }) : createCommentVNode("", true),
            S2.$slots["arrow-right"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(za), { key: 1 }))
          ]),
          _: 3
        }, 8, ["aria-label", "disabled", "class"])) : createCommentVNode("", true),
        createVNode(Transition, {
          name: unref(k2)(e.showYearPicker),
          css: unref(E2)
        }, {
          default: withCtx(() => [
            e.showYearPicker ? (openBlock(), createBlock(qt, {
              key: 0,
              items: e.items,
              "text-input": S2.textInput,
              "esc-close": S2.escClose,
              config: S2.config,
              "is-last": S2.autoApply && !unref(v).keepActionRow,
              "hide-navigation": S2.hideNavigation,
              "aria-labels": S2.ariaLabels,
              type: "year",
              onToggle: _2,
              onSelected: y2[4] || (y2[4] = (q2) => H2(q2))
            }, createSlots({
              "button-icon": withCtx(() => [
                S2.$slots["calendar-icon"] ? renderSlot(S2.$slots, "calendar-icon", { key: 0 }) : createCommentVNode("", true),
                S2.$slots["calendar-icon"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(Et), { key: 1 }))
              ]),
              _: 2
            }, [
              S2.$slots["year-overlay-value"] ? {
                name: "item",
                fn: withCtx(({ item: q2 }) => [
                  renderSlot(S2.$slots, "year-overlay-value", {
                    text: q2.text,
                    value: q2.value
                  })
                ]),
                key: "0"
              } : void 0
            ]), 1032, ["items", "text-input", "esc-close", "config", "is-last", "hide-navigation", "aria-labels"])) : createCommentVNode("", true)
          ]),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), qa = (e, t, l) => {
  if (t.value && Array.isArray(t.value))
    if (t.value.some((a) => De(e, a))) {
      const a = t.value.filter((n2) => !De(n2, e));
      t.value = a.length ? a : null;
    } else (l && +l > t.value.length || !l) && t.value.push(e);
  else
    t.value = [e];
}, Xa = (e, t, l) => {
  let a = e.value ? e.value.slice() : [];
  return a.length === 2 && a[1] !== null && (a = []), a.length ? _e(t, a[0]) ? (a.unshift(t), l("range-start", a[0]), l("range-start", a[1])) : (a[1] = t, l("range-end", t)) : (a = [t], l("range-start", t)), a;
}, va = (e, t, l, a) => {
  e && (e[0] && e[1] && l && t("auto-apply"), e[0] && !e[1] && a && l && t("auto-apply"));
}, Nn = (e) => {
  Array.isArray(e.value) && e.value.length <= 2 && e.range ? e.modelValue.value = e.value.map((t) => Xe(j(t), e.timezone)) : Array.isArray(e.value) || (e.modelValue.value = Xe(j(e.value), e.timezone));
}, En = (e, t, l, a) => Array.isArray(t.value) && (t.value.length === 2 || t.value.length === 1 && a.value.partialRange) ? a.value.fixedStart && (Be(e, t.value[0]) || De(e, t.value[0])) ? [t.value[0], e] : a.value.fixedEnd && (_e(e, t.value[1]) || De(e, t.value[1])) ? [e, t.value[1]] : (l("invalid-fixed-range", e), t.value) : [], Fn = ({
  multiCalendars: e,
  range: t,
  highlight: l,
  propDates: a,
  calendars: n2,
  modelValue: c2,
  props: v,
  filters: b2,
  year: i,
  month: L,
  emit: m2
}) => {
  const E2 = computed(() => ja(v.yearRange, v.locale, v.reverseYears)), k2 = ref([false]), _2 = computed(() => (B2, K2) => {
    const fe2 = set(lt(/* @__PURE__ */ new Date()), {
      month: L.value(B2),
      year: i.value(B2)
    }), ce2 = K2 ? endOfYear(fe2) : startOfYear(fe2);
    return Cn(
      ce2,
      a.value.maxDate,
      a.value.minDate,
      v.preventMinMaxNavigation,
      K2
    );
  }), H2 = () => Array.isArray(c2.value) && e.value.solo && c2.value[1], N = () => {
    for (let B2 = 0; B2 < e.value.count; B2++)
      if (B2 === 0)
        n2.value[B2] = n2.value[0];
      else if (B2 === e.value.count - 1 && H2())
        n2.value[B2] = {
          month: getMonth(c2.value[1]),
          year: getYear(c2.value[1])
        };
      else {
        const K2 = set(j(), n2.value[B2 - 1]);
        n2.value[B2] = { month: getMonth(K2), year: getYear(addYears(K2, 1)) };
      }
  }, S2 = (B2) => {
    if (!B2) return N();
    const K2 = set(j(), n2.value[B2]);
    return n2.value[0].year = getYear(subYears(K2, e.value.count - 1)), N();
  }, y2 = (B2, K2) => {
    const fe2 = differenceInYears(K2, B2);
    return t.value.showLastInRange && fe2 > 1 ? K2 : B2;
  }, F = (B2) => v.focusStartDate || e.value.solo ? B2[0] : B2[1] ? y2(B2[0], B2[1]) : B2[0], P = () => {
    if (c2.value) {
      const B2 = Array.isArray(c2.value) ? F(c2.value) : c2.value;
      n2.value[0] = { month: getMonth(B2), year: getYear(B2) };
    }
  }, J = () => {
    P(), e.value.count && N();
  };
  watch(c2, (B2, K2) => {
    v.isTextInputDate && JSON.stringify(B2 ?? {}) !== JSON.stringify(K2 ?? {}) && J();
  }), onMounted(() => {
    J();
  });
  const Z2 = (B2, K2) => {
    n2.value[K2].year = B2, m2("update-month-year", { instance: K2, year: B2, month: n2.value[K2].month }), e.value.count && !e.value.solo && S2(K2);
  }, le2 = computed(() => (B2) => Yt(E2.value, (K2) => {
    var A;
    const fe2 = i.value(B2) === K2.value, ce2 = Gt(
      K2.value,
      It(a.value.minDate),
      It(a.value.maxDate)
    ) || ((A = b2.value.years) == null ? void 0 : A.includes(i.value(B2))), O = Qa(l.value, K2.value);
    return { active: fe2, disabled: ce2, highlighted: O };
  })), q2 = (B2, K2) => {
    Z2(B2, K2), re2(K2);
  }, R = (B2, K2 = false) => {
    if (!_2.value(B2, K2)) {
      const fe2 = K2 ? i.value(B2) + 1 : i.value(B2) - 1;
      Z2(fe2, B2);
    }
  }, re2 = (B2, K2 = false, fe2) => {
    K2 || m2("reset-flow"), fe2 !== void 0 ? k2.value[B2] = fe2 : k2.value[B2] = !k2.value[B2], k2.value[B2] ? m2("overlay-toggle", { open: true, overlay: He.year }) : (m2("overlay-closed"), m2("overlay-toggle", { open: false, overlay: He.year }));
  };
  return {
    isDisabled: _2,
    groupedYears: le2,
    showYearPicker: k2,
    selectYear: Z2,
    toggleYearPicker: re2,
    handleYearSelect: q2,
    handleYear: R
  };
}, ar = (e, t) => {
  const {
    defaultedMultiCalendars: l,
    defaultedAriaLabels: a,
    defaultedTransitions: n2,
    defaultedConfig: c2,
    defaultedRange: v,
    defaultedHighlight: b2,
    propDates: i,
    defaultedTz: L,
    defaultedFilters: m2,
    defaultedMultiDates: E2
  } = Ce(e), k2 = () => {
    e.isTextInputDate && J(getYear(j(e.startDate)), 0);
  }, { modelValue: _2, year: H2, month: N, calendars: S2 } = Jt(e, t, k2), y2 = computed(() => Dn(e.formatLocale, e.locale, e.monthNameFormat)), F = ref(null), { checkMinMaxRange: P } = kt(e), {
    selectYear: J,
    groupedYears: Z2,
    showYearPicker: le2,
    toggleYearPicker: q2,
    handleYearSelect: R,
    handleYear: re2,
    isDisabled: B2
  } = Fn({
    modelValue: _2,
    multiCalendars: l,
    range: v,
    highlight: b2,
    calendars: S2,
    year: H2,
    propDates: i,
    month: N,
    filters: m2,
    props: e,
    emit: t
  });
  onMounted(() => {
    e.startDate && (_2.value && e.focusStartDate || !_2.value) && J(getYear(j(e.startDate)), 0);
  });
  const K2 = (T) => T ? { month: getMonth(T), year: getYear(T) } : { month: null, year: null }, fe2 = () => _2.value ? Array.isArray(_2.value) ? _2.value.map((T) => K2(T)) : K2(_2.value) : K2(), ce2 = (T, Q2) => {
    const s = S2.value[T], oe2 = fe2();
    return Array.isArray(oe2) ? oe2.some((M) => M.year === (s == null ? void 0 : s.year) && M.month === Q2) : (s == null ? void 0 : s.year) === oe2.year && Q2 === oe2.month;
  }, O = (T, Q2, s) => {
    var M, me2;
    const oe2 = fe2();
    return Array.isArray(oe2) ? H2.value(Q2) === ((M = oe2[s]) == null ? void 0 : M.year) && T === ((me2 = oe2[s]) == null ? void 0 : me2.month) : false;
  }, A = (T, Q2) => {
    if (v.value.enabled) {
      const s = fe2();
      if (Array.isArray(_2.value) && Array.isArray(s)) {
        const oe2 = O(T, Q2, 0) || O(T, Q2, 1), M = dt(lt(j()), T, H2.value(Q2));
        return da(_2.value, F.value, M) && !oe2;
      }
      return false;
    }
    return false;
  }, w = computed(() => (T) => Yt(y2.value, (Q2) => {
    var d2;
    const s = ce2(T, Q2.value), oe2 = Gt(
      Q2.value,
      Tn(H2.value(T), i.value.minDate),
      Sn(H2.value(T), i.value.maxDate)
    ) || Sl(i.value.disabledDates, H2.value(T)).includes(Q2.value) || ((d2 = m2.value.months) == null ? void 0 : d2.includes(Q2.value)), M = A(Q2.value, T), me2 = On(b2.value, Q2.value, H2.value(T));
    return { active: s, disabled: oe2, isBetween: M, highlighted: me2 };
  })), o = (T, Q2) => dt(lt(j()), T, H2.value(Q2)), z2 = (T, Q2) => {
    const s = _2.value ? _2.value : lt(/* @__PURE__ */ new Date());
    _2.value = dt(s, T, H2.value(Q2)), t("auto-apply"), t("update-flow-step");
  }, D = (T, Q2) => {
    const s = o(T, Q2);
    v.value.fixedEnd || v.value.fixedStart ? _2.value = En(s, _2, t, v) : _2.value ? P(s, _2.value) && (_2.value = Xa(_2, o(T, Q2), t)) : _2.value = [o(T, Q2)], nextTick().then(() => {
      va(_2.value, t, e.autoApply, e.modelAuto);
    });
  }, ee2 = (T, Q2) => {
    qa(o(T, Q2), _2, E2.value.limit), t("auto-apply", true);
  }, de2 = (T, Q2) => (S2.value[Q2].month = T, I(Q2, S2.value[Q2].year, T), E2.value.enabled ? ee2(T, Q2) : v.value.enabled ? D(T, Q2) : z2(T, Q2)), u = (T, Q2) => {
    J(T, Q2), I(Q2, T, null);
  }, I = (T, Q2, s) => {
    let oe2 = s;
    if (!oe2 && oe2 !== 0) {
      const M = fe2();
      oe2 = Array.isArray(M) ? M[T].month : M.month;
    }
    t("update-month-year", { instance: T, year: Q2, month: oe2 });
  };
  return {
    groupedMonths: w,
    groupedYears: Z2,
    year: H2,
    isDisabled: B2,
    defaultedMultiCalendars: l,
    defaultedAriaLabels: a,
    defaultedTransitions: n2,
    defaultedConfig: c2,
    showYearPicker: le2,
    modelValue: _2,
    presetDate: (T, Q2) => {
      Nn({
        value: T,
        modelValue: _2,
        range: v.value.enabled,
        timezone: Q2 ? void 0 : L.value.timezone
      }), t("auto-apply");
    },
    setHoverDate: (T, Q2) => {
      F.value = o(T, Q2);
    },
    selectMonth: de2,
    selectYear: u,
    toggleYearPicker: q2,
    handleYearSelect: R,
    handleYear: re2,
    getModelMonthYear: fe2
  };
}, nr = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "MonthPicker",
  props: {
    ...rt
  },
  emits: [
    "update:internal-model-value",
    "overlay-closed",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year",
    "update-flow-step",
    "mount",
    "invalid-fixed-range",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = useSlots(), c2 = Ze(n2, "yearMode"), v = e;
    onMounted(() => {
      v.shadow || a("mount", null);
    });
    const {
      groupedMonths: b2,
      groupedYears: i,
      year: L,
      isDisabled: m2,
      defaultedMultiCalendars: E2,
      defaultedConfig: k2,
      showYearPicker: _2,
      modelValue: H2,
      presetDate: N,
      setHoverDate: S2,
      selectMonth: y2,
      selectYear: F,
      toggleYearPicker: P,
      handleYearSelect: J,
      handleYear: Z2,
      getModelMonthYear: le2
    } = ar(v, a);
    return t({ getSidebarProps: () => ({
      modelValue: H2,
      year: L,
      getModelMonthYear: le2,
      selectMonth: y2,
      selectYear: F,
      handleYear: Z2
    }), presetDate: N, toggleYearPicker: (R) => P(0, R) }), (R, re2) => (openBlock(), createBlock(fa, {
      "multi-calendars": unref(E2).count,
      collapse: R.collapse,
      stretch: ""
    }, {
      default: withCtx(({ instance: B2 }) => [
        R.$slots["top-extra"] ? renderSlot(R.$slots, "top-extra", {
          key: 0,
          value: R.internalModelValue
        }) : createCommentVNode("", true),
        R.$slots["month-year"] ? renderSlot(R.$slots, "month-year", normalizeProps(mergeProps({ key: 1 }, {
          year: unref(L),
          months: unref(b2)(B2),
          years: unref(i)(B2),
          selectMonth: unref(y2),
          selectYear: unref(F),
          instance: B2
        }))) : (openBlock(), createBlock(qt, {
          key: 2,
          items: unref(b2)(B2),
          "arrow-navigation": R.arrowNavigation,
          "is-last": R.autoApply && !unref(k2).keepActionRow,
          "esc-close": R.escClose,
          height: unref(k2).modeHeight,
          config: R.config,
          "no-overlay-focus": !!(R.noOverlayFocus || R.textInput),
          "use-relative": "",
          type: "month",
          onSelected: (K2) => unref(y2)(K2, B2),
          onHoverValue: (K2) => unref(S2)(K2, B2)
        }, createSlots({
          header: withCtx(() => [
            createVNode(In, mergeProps(R.$props, {
              items: unref(i)(B2),
              instance: B2,
              "show-year-picker": unref(_2)[B2],
              year: unref(L)(B2),
              "is-disabled": (K2) => unref(m2)(B2, K2),
              onHandleYear: (K2) => unref(Z2)(B2, K2),
              onYearSelect: (K2) => unref(J)(K2, B2),
              onToggleYearPicker: (K2) => unref(P)(B2, K2 == null ? void 0 : K2.flow, K2 == null ? void 0 : K2.show)
            }), createSlots({ _: 2 }, [
              renderList(unref(c2), (K2, fe2) => ({
                name: K2,
                fn: withCtx((ce2) => [
                  renderSlot(R.$slots, K2, normalizeProps(guardReactiveProps(ce2)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          _: 2
        }, [
          R.$slots["month-overlay-value"] ? {
            name: "item",
            fn: withCtx(({ item: K2 }) => [
              renderSlot(R.$slots, "month-overlay-value", {
                text: K2.text,
                value: K2.value
              })
            ]),
            key: "0"
          } : void 0
        ]), 1032, ["items", "arrow-navigation", "is-last", "esc-close", "height", "config", "no-overlay-focus", "onSelected", "onHoverValue"]))
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), lr = (e, t) => {
  const l = () => {
    e.isTextInputDate && (m2.value = getYear(j(e.startDate)));
  }, { modelValue: a } = Jt(e, t, l), n2 = ref(null), { defaultedHighlight: c2, defaultedMultiDates: v, defaultedFilters: b2, defaultedRange: i, propDates: L } = Ce(e), m2 = ref();
  onMounted(() => {
    e.startDate && (a.value && e.focusStartDate || !a.value) && (m2.value = getYear(j(e.startDate)));
  });
  const E2 = (y2) => Array.isArray(a.value) ? a.value.some((F) => getYear(F) === y2) : a.value ? getYear(a.value) === y2 : false, k2 = (y2) => i.value.enabled && Array.isArray(a.value) ? da(a.value, n2.value, H2(y2)) : false, _2 = computed(() => Yt(ja(e.yearRange, e.locale, e.reverseYears), (y2) => {
    const F = E2(y2.value), P = Gt(
      y2.value,
      It(L.value.minDate),
      It(L.value.maxDate)
    ) || b2.value.years.includes(y2.value), J = k2(y2.value) && !F, Z2 = Qa(c2.value, y2.value);
    return { active: F, disabled: P, isBetween: J, highlighted: Z2 };
  })), H2 = (y2) => setYear(lt(startOfYear(/* @__PURE__ */ new Date())), y2);
  return {
    groupedYears: _2,
    modelValue: a,
    focusYear: m2,
    setHoverValue: (y2) => {
      n2.value = setYear(lt(/* @__PURE__ */ new Date()), y2);
    },
    selectYear: (y2) => {
      var F;
      if (t("update-month-year", { instance: 0, year: y2 }), v.value.enabled)
        return a.value ? Array.isArray(a.value) && (((F = a.value) == null ? void 0 : F.map((J) => getYear(J))).includes(y2) ? a.value = a.value.filter((J) => getYear(J) !== y2) : a.value.push(setYear(Ke(j()), y2))) : a.value = [setYear(Ke(startOfYear(j())), y2)], t("auto-apply", true);
      i.value.enabled ? (a.value = Xa(a, H2(y2), t), nextTick().then(() => {
        va(a.value, t, e.autoApply, e.modelAuto);
      })) : (a.value = H2(y2), t("auto-apply"));
    }
  };
}, rr = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "YearPicker",
  props: {
    ...rt
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "range-start",
    "range-end",
    "auto-apply",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, { groupedYears: c2, modelValue: v, focusYear: b2, selectYear: i, setHoverValue: L } = lr(n2, a), { defaultedConfig: m2 } = Ce(n2);
    return t({ getSidebarProps: () => ({
      modelValue: v,
      selectYear: i
    }) }), (k2, _2) => (openBlock(), createElementBlock("div", null, [
      k2.$slots["top-extra"] ? renderSlot(k2.$slots, "top-extra", {
        key: 0,
        value: k2.internalModelValue
      }) : createCommentVNode("", true),
      k2.$slots["month-year"] ? renderSlot(k2.$slots, "month-year", normalizeProps(mergeProps({ key: 1 }, {
        years: unref(c2),
        selectYear: unref(i)
      }))) : (openBlock(), createBlock(qt, {
        key: 2,
        items: unref(c2),
        "is-last": k2.autoApply && !unref(m2).keepActionRow,
        height: unref(m2).modeHeight,
        config: k2.config,
        "no-overlay-focus": !!(k2.noOverlayFocus || k2.textInput),
        "focus-value": unref(b2),
        type: "year",
        "use-relative": "",
        onSelected: unref(i),
        onHoverValue: unref(L)
      }, createSlots({ _: 2 }, [
        k2.$slots["year-overlay-value"] ? {
          name: "item",
          fn: withCtx(({ item: H2 }) => [
            renderSlot(k2.$slots, "year-overlay-value", {
              text: H2.text,
              value: H2.value
            })
          ]),
          key: "0"
        } : void 0
      ]), 1032, ["items", "is-last", "height", "config", "no-overlay-focus", "focus-value", "onSelected", "onHoverValue"]))
    ]));
  }
}), or = {
  key: 0,
  class: "dp__time_input"
}, sr = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], ur = /* @__PURE__ */ createElementVNode("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), ir = /* @__PURE__ */ createElementVNode("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), dr = ["aria-label", "disabled", "data-test", "onKeydown", "onClick"], cr = ["data-test", "aria-label", "onKeydown", "onClick", "onMousedown"], fr = /* @__PURE__ */ createElementVNode("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_l" }, null, -1), vr = /* @__PURE__ */ createElementVNode("span", { class: "dp__tp_inline_btn_bar dp__tp_btn_in_r" }, null, -1), mr = { key: 0 }, gr = ["aria-label"], yr = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "TimeInput",
  props: {
    hours: { type: Number, default: 0 },
    minutes: { type: Number, default: 0 },
    seconds: { type: Number, default: 0 },
    closeTimePickerBtn: { type: Object, default: null },
    order: { type: Number, default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: { type: Function, default: () => false },
    ...rt
  },
  emits: [
    "set-hours",
    "set-minutes",
    "update:hours",
    "update:minutes",
    "update:seconds",
    "reset-flow",
    "mounted",
    "overlay-closed",
    "overlay-opened",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, { setTimePickerElements: c2, setTimePickerBackRef: v } = bt(), { defaultedAriaLabels: b2, defaultedTransitions: i, defaultedFilters: L, defaultedConfig: m2, defaultedRange: E2 } = Ce(n2), { transitionName: k2, showTransition: _2 } = Xt(i), H2 = reactive({
      hours: false,
      minutes: false,
      seconds: false
    }), N = ref("AM"), S2 = ref(null), y2 = ref([]), F = ref();
    onMounted(() => {
      a("mounted");
    });
    const P = (d2) => set(/* @__PURE__ */ new Date(), {
      hours: d2.hours,
      minutes: d2.minutes,
      seconds: n2.enableSeconds ? d2.seconds : 0,
      milliseconds: 0
    }), J = computed(
      () => (d2) => w(d2, n2[d2]) || le2(d2, n2[d2])
    ), Z2 = computed(() => ({ hours: n2.hours, minutes: n2.minutes, seconds: n2.seconds })), le2 = (d2, Y2) => E2.value.enabled && !E2.value.disableTimeRangeValidation ? !n2.validateTime(d2, Y2) : false, q2 = (d2, Y2) => {
      if (E2.value.enabled && !E2.value.disableTimeRangeValidation) {
        const W = Y2 ? +n2[`${d2}Increment`] : -+n2[`${d2}Increment`], C2 = n2[d2] + W;
        return !n2.validateTime(d2, C2);
      }
      return false;
    }, R = computed(() => (d2) => !de2(+n2[d2] + +n2[`${d2}Increment`], d2) || q2(d2, true)), re2 = computed(() => (d2) => !de2(+n2[d2] - +n2[`${d2}Increment`], d2) || q2(d2, false)), B2 = (d2, Y2) => add(set(j(), d2), Y2), K2 = (d2, Y2) => sub(set(j(), d2), Y2), fe2 = computed(
      () => ({
        dp__time_col: true,
        dp__time_col_block: !n2.timePickerInline,
        dp__time_col_reg_block: !n2.enableSeconds && n2.is24 && !n2.timePickerInline,
        dp__time_col_reg_inline: !n2.enableSeconds && n2.is24 && n2.timePickerInline,
        dp__time_col_reg_with_button: !n2.enableSeconds && !n2.is24,
        dp__time_col_sec: n2.enableSeconds && n2.is24,
        dp__time_col_sec_with_button: n2.enableSeconds && !n2.is24
      })
    ), ce2 = computed(() => {
      const d2 = [{ type: "hours" }];
      return n2.enableMinutes && d2.push({ type: "", separator: true }, {
        type: "minutes"
      }), n2.enableSeconds && d2.push({ type: "", separator: true }, {
        type: "seconds"
      }), d2;
    }), O = computed(() => ce2.value.filter((d2) => !d2.separator)), A = computed(() => (d2) => {
      if (d2 === "hours") {
        const Y2 = Q2(+n2.hours);
        return { text: Y2 < 10 ? `0${Y2}` : `${Y2}`, value: Y2 };
      }
      return { text: n2[d2] < 10 ? `0${n2[d2]}` : `${n2[d2]}`, value: n2[d2] };
    }), w = (d2, Y2) => {
      var C2;
      if (!n2.disabledTimesConfig) return false;
      const W = n2.disabledTimesConfig(n2.order, d2 === "hours" ? Y2 : void 0);
      return W[d2] ? !!((C2 = W[d2]) != null && C2.includes(Y2)) : true;
    }, o = (d2, Y2) => Y2 !== "hours" || N.value === "AM" ? d2 : d2 + 12, z2 = (d2) => {
      const Y2 = n2.is24 ? 24 : 12, W = d2 === "hours" ? Y2 : 60, C2 = +n2[`${d2}GridIncrement`], te2 = d2 === "hours" && !n2.is24 ? C2 : 0, ue2 = [];
      for (let p = te2; p < W; p += C2)
        ue2.push({ value: n2.is24 ? p : o(p, d2), text: p < 10 ? `0${p}` : `${p}` });
      return d2 === "hours" && !n2.is24 && ue2.unshift({ value: N.value === "PM" ? 12 : 0, text: "12" }), Yt(ue2, (p) => ({ active: false, disabled: L.value.times[d2].includes(p.value) || !de2(p.value, d2) || w(d2, p.value) || le2(d2, p.value) }));
    }, D = (d2) => d2 >= 0 ? d2 : 59, ee2 = (d2) => d2 >= 0 ? d2 : 23, de2 = (d2, Y2) => {
      const W = n2.minTime ? P(Aa(n2.minTime)) : null, C2 = n2.maxTime ? P(Aa(n2.maxTime)) : null, te2 = P(
        Aa(
          Z2.value,
          Y2,
          Y2 === "minutes" || Y2 === "seconds" ? D(d2) : ee2(d2)
        )
      );
      return W && C2 ? (isBefore(te2, C2) || isEqual(te2, C2)) && (isAfter(te2, W) || isEqual(te2, W)) : W ? isAfter(te2, W) || isEqual(te2, W) : C2 ? isBefore(te2, C2) || isEqual(te2, C2) : true;
    }, u = (d2) => n2[`no${d2[0].toUpperCase() + d2.slice(1)}Overlay`], I = (d2) => {
      u(d2) || (H2[d2] = !H2[d2], H2[d2] ? a("overlay-opened", d2) : a("overlay-closed", d2));
    }, se = (d2) => d2 === "hours" ? getHours : d2 === "minutes" ? getMinutes : getSeconds, f = () => {
      F.value && clearTimeout(F.value);
    }, T = (d2, Y2 = true, W) => {
      const C2 = Y2 ? B2 : K2, te2 = Y2 ? +n2[`${d2}Increment`] : -+n2[`${d2}Increment`];
      de2(+n2[d2] + te2, d2) && a(
        `update:${d2}`,
        se(d2)(C2({ [d2]: +n2[d2] }, { [d2]: +n2[`${d2}Increment`] }))
      ), !(W != null && W.keyboard) && m2.value.timeArrowHoldThreshold && (F.value = setTimeout(() => {
        T(d2, Y2);
      }, m2.value.timeArrowHoldThreshold));
    }, Q2 = (d2) => n2.is24 ? d2 : (d2 >= 12 ? N.value = "PM" : N.value = "AM", ml(d2)), s = () => {
      N.value === "PM" ? (N.value = "AM", a("update:hours", n2.hours - 12)) : (N.value = "PM", a("update:hours", n2.hours + 12)), a("am-pm-change", N.value);
    }, oe2 = (d2) => {
      H2[d2] = true;
    }, M = (d2, Y2, W) => {
      if (d2 && n2.arrowNavigation) {
        Array.isArray(y2.value[Y2]) ? y2.value[Y2][W] = d2 : y2.value[Y2] = [d2];
        const C2 = y2.value.reduce(
          (te2, ue2) => ue2.map((p, V) => [...te2[V] || [], ue2[V]]),
          []
        );
        v(n2.closeTimePickerBtn), S2.value && (C2[1] = C2[1].concat(S2.value)), c2(C2, n2.order);
      }
    }, me2 = (d2, Y2) => (I(d2), a(`update:${d2}`, Y2));
    return t({ openChildCmp: oe2 }), (d2, Y2) => {
      var W;
      return d2.disabled ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", or, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(ce2.value, (C2, te2) => {
          var ue2, p, V;
          return openBlock(), createElementBlock("div", {
            key: te2,
            class: normalizeClass(fe2.value)
          }, [
            C2.separator ? (openBlock(), createElementBlock(Fragment, { key: 0 }, [
              createTextVNode(" : ")
            ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
              createElementVNode("button", {
                ref_for: true,
                ref: (pe2) => M(pe2, te2, 0),
                type: "button",
                class: normalizeClass({
                  dp__btn: true,
                  dp__inc_dec_button: !d2.timePickerInline,
                  dp__inc_dec_button_inline: d2.timePickerInline,
                  dp__tp_inline_btn_top: d2.timePickerInline,
                  dp__inc_dec_button_disabled: R.value(C2.type)
                }),
                "data-test": `${C2.type}-time-inc-btn-${n2.order}`,
                "aria-label": (ue2 = unref(b2)) == null ? void 0 : ue2.incrementValue(C2.type),
                tabindex: "0",
                onKeydown: (pe2) => unref(qe)(pe2, () => T(C2.type, true, { keyboard: true }), true),
                onClick: (pe2) => unref(m2).timeArrowHoldThreshold ? void 0 : T(C2.type, true),
                onMousedown: (pe2) => unref(m2).timeArrowHoldThreshold ? T(C2.type, true) : void 0,
                onMouseup: f
              }, [
                n2.timePickerInline ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  d2.$slots["tp-inline-arrow-up"] ? renderSlot(d2.$slots, "tp-inline-arrow-up", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    ur,
                    ir
                  ], 64))
                ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  d2.$slots["arrow-up"] ? renderSlot(d2.$slots, "arrow-up", { key: 0 }) : createCommentVNode("", true),
                  d2.$slots["arrow-up"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(Va), { key: 1 }))
                ], 64))
              ], 42, sr),
              createElementVNode("button", {
                ref_for: true,
                ref: (pe2) => M(pe2, te2, 1),
                type: "button",
                "aria-label": (p = unref(b2)) == null ? void 0 : p.openTpOverlay(C2.type),
                class: normalizeClass({
                  dp__time_display: true,
                  dp__time_display_block: !d2.timePickerInline,
                  dp__time_display_inline: d2.timePickerInline,
                  "dp--time-invalid": J.value(C2.type),
                  "dp--time-overlay-btn": !J.value(C2.type)
                }),
                disabled: u(C2.type),
                tabindex: "0",
                "data-test": `${C2.type}-toggle-overlay-btn-${n2.order}`,
                onKeydown: (pe2) => unref(qe)(pe2, () => I(C2.type), true),
                onClick: (pe2) => I(C2.type)
              }, [
                d2.$slots[C2.type] ? renderSlot(d2.$slots, C2.type, {
                  key: 0,
                  text: A.value(C2.type).text,
                  value: A.value(C2.type).value
                }) : createCommentVNode("", true),
                d2.$slots[C2.type] ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(A.value(C2.type).text), 1)
                ], 64))
              ], 42, dr),
              createElementVNode("button", {
                ref_for: true,
                ref: (pe2) => M(pe2, te2, 2),
                type: "button",
                class: normalizeClass({
                  dp__btn: true,
                  dp__inc_dec_button: !d2.timePickerInline,
                  dp__inc_dec_button_inline: d2.timePickerInline,
                  dp__tp_inline_btn_bottom: d2.timePickerInline,
                  dp__inc_dec_button_disabled: re2.value(C2.type)
                }),
                "data-test": `${C2.type}-time-dec-btn-${n2.order}`,
                "aria-label": (V = unref(b2)) == null ? void 0 : V.decrementValue(C2.type),
                tabindex: "0",
                onKeydown: (pe2) => unref(qe)(pe2, () => T(C2.type, false, { keyboard: true }), true),
                onClick: (pe2) => unref(m2).timeArrowHoldThreshold ? void 0 : T(C2.type, false),
                onMousedown: (pe2) => unref(m2).timeArrowHoldThreshold ? T(C2.type, false) : void 0,
                onMouseup: f
              }, [
                n2.timePickerInline ? (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  d2.$slots["tp-inline-arrow-down"] ? renderSlot(d2.$slots, "tp-inline-arrow-down", { key: 0 }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    fr,
                    vr
                  ], 64))
                ], 64)) : (openBlock(), createElementBlock(Fragment, { key: 0 }, [
                  d2.$slots["arrow-down"] ? renderSlot(d2.$slots, "arrow-down", { key: 0 }) : createCommentVNode("", true),
                  d2.$slots["arrow-down"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(Ua), { key: 1 }))
                ], 64))
              ], 42, cr)
            ], 64))
          ], 2);
        }), 128)),
        d2.is24 ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", mr, [
          d2.$slots["am-pm-button"] ? renderSlot(d2.$slots, "am-pm-button", {
            key: 0,
            toggle: s,
            value: N.value
          }) : createCommentVNode("", true),
          d2.$slots["am-pm-button"] ? createCommentVNode("", true) : (openBlock(), createElementBlock("button", {
            key: 1,
            ref_key: "amPmButton",
            ref: S2,
            type: "button",
            class: "dp__pm_am_button",
            role: "button",
            "aria-label": (W = unref(b2)) == null ? void 0 : W.amPmButton,
            tabindex: "0",
            onClick: s,
            onKeydown: Y2[0] || (Y2[0] = (C2) => unref(qe)(C2, () => s(), true))
          }, toDisplayString(N.value), 41, gr))
        ])),
        (openBlock(true), createElementBlock(Fragment, null, renderList(O.value, (C2, te2) => (openBlock(), createBlock(Transition, {
          key: te2,
          name: unref(k2)(H2[C2.type]),
          css: unref(_2)
        }, {
          default: withCtx(() => [
            H2[C2.type] ? (openBlock(), createBlock(qt, {
              key: 0,
              items: z2(C2.type),
              "is-last": d2.autoApply && !unref(m2).keepActionRow,
              "esc-close": d2.escClose,
              type: C2.type,
              "text-input": d2.textInput,
              config: d2.config,
              "arrow-navigation": d2.arrowNavigation,
              "aria-labels": d2.ariaLabels,
              onSelected: (ue2) => me2(C2.type, ue2),
              onToggle: (ue2) => I(C2.type),
              onResetFlow: Y2[1] || (Y2[1] = (ue2) => d2.$emit("reset-flow"))
            }, createSlots({
              "button-icon": withCtx(() => [
                d2.$slots["clock-icon"] ? renderSlot(d2.$slots, "clock-icon", { key: 0 }) : createCommentVNode("", true),
                d2.$slots["clock-icon"] ? createCommentVNode("", true) : (openBlock(), createBlock(resolveDynamicComponent(d2.timePickerInline ? unref(Et) : unref(Ha)), { key: 1 }))
              ]),
              _: 2
            }, [
              d2.$slots[`${C2.type}-overlay-value`] ? {
                name: "item",
                fn: withCtx(({ item: ue2 }) => [
                  renderSlot(d2.$slots, `${C2.type}-overlay-value`, {
                    text: ue2.text,
                    value: ue2.value
                  })
                ]),
                key: "0"
              } : void 0,
              d2.$slots[`${C2.type}-overlay-header`] ? {
                name: "header",
                fn: withCtx(() => [
                  renderSlot(d2.$slots, `${C2.type}-overlay-header`, {
                    toggle: () => I(C2.type)
                  })
                ]),
                key: "1"
              } : void 0
            ]), 1032, ["items", "is-last", "esc-close", "type", "text-input", "config", "arrow-navigation", "aria-labels", "onSelected", "onToggle"])) : createCommentVNode("", true)
          ]),
          _: 2
        }, 1032, ["name", "css"]))), 128))
      ]));
    };
  }
}), pr = { class: "dp--tp-wrap" }, hr = ["aria-label", "tabindex"], br = ["tabindex"], kr = ["aria-label"], Ln = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePicker",
  props: {
    hours: { type: [Number, Array], default: 0 },
    minutes: { type: [Number, Array], default: 0 },
    seconds: { type: [Number, Array], default: 0 },
    disabledTimesConfig: { type: Function, default: null },
    validateTime: {
      type: Function,
      default: () => false
    },
    ...rt
  },
  emits: [
    "update:hours",
    "update:minutes",
    "update:seconds",
    "mount",
    "reset-flow",
    "overlay-opened",
    "overlay-closed",
    "am-pm-change"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, { buildMatrix: c2, setTimePicker: v } = bt(), b2 = useSlots(), { defaultedTransitions: i, defaultedAriaLabels: L, defaultedTextInput: m2, defaultedConfig: E2, defaultedRange: k2 } = Ce(n2), { transitionName: _2, showTransition: H2 } = Xt(i), { hideNavigationButtons: N } = ma(), S2 = ref(null), y2 = ref(null), F = ref([]), P = ref(null);
    onMounted(() => {
      a("mount"), !n2.timePicker && n2.arrowNavigation ? c2([Ie(S2.value)], "time") : v(true, n2.timePicker);
    });
    const J = computed(() => k2.value.enabled && n2.modelAuto ? Mn(n2.internalModelValue) : true), Z2 = ref(false), le2 = (o) => ({
      hours: Array.isArray(n2.hours) ? n2.hours[o] : n2.hours,
      minutes: Array.isArray(n2.minutes) ? n2.minutes[o] : n2.minutes,
      seconds: Array.isArray(n2.seconds) ? n2.seconds[o] : n2.seconds
    }), q2 = computed(() => {
      const o = [];
      if (k2.value.enabled)
        for (let z2 = 0; z2 < 2; z2++)
          o.push(le2(z2));
      else
        o.push(le2(0));
      return o;
    }), R = (o, z2 = false, D = "") => {
      z2 || a("reset-flow"), Z2.value = o, a(o ? "overlay-opened" : "overlay-closed", He.time), n2.arrowNavigation && v(o), nextTick(() => {
        D !== "" && F.value[0] && F.value[0].openChildCmp(D);
      });
    }, re2 = computed(() => ({
      dp__btn: true,
      dp__button: true,
      dp__button_bottom: n2.autoApply && !E2.value.keepActionRow
    })), B2 = Ze(b2, "timePicker"), K2 = (o, z2, D) => k2.value.enabled ? z2 === 0 ? [o, q2.value[1][D]] : [q2.value[0][D], o] : o, fe2 = (o) => {
      a("update:hours", o);
    }, ce2 = (o) => {
      a("update:minutes", o);
    }, O = (o) => {
      a("update:seconds", o);
    }, A = () => {
      if (P.value && !m2.value.enabled && !n2.noOverlayFocus) {
        const o = $n(P.value);
        o && o.focus({ preventScroll: true });
      }
    }, w = (o) => {
      a("overlay-closed", o);
    };
    return t({ toggleTimePicker: R }), (o, z2) => {
      var D;
      return openBlock(), createElementBlock("div", pr, [
        !o.timePicker && !o.timePickerInline ? withDirectives((openBlock(), createElementBlock("button", {
          key: 0,
          ref_key: "openTimePickerBtn",
          ref: S2,
          type: "button",
          class: normalizeClass(re2.value),
          "aria-label": (D = unref(L)) == null ? void 0 : D.openTimePicker,
          tabindex: o.noOverlayFocus ? void 0 : 0,
          "data-test": "open-time-picker-btn",
          onKeydown: z2[0] || (z2[0] = (ee2) => unref(qe)(ee2, () => R(true))),
          onClick: z2[1] || (z2[1] = (ee2) => R(true))
        }, [
          o.$slots["clock-icon"] ? renderSlot(o.$slots, "clock-icon", { key: 0 }) : createCommentVNode("", true),
          o.$slots["clock-icon"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(Ha), { key: 1 }))
        ], 42, hr)), [
          [vShow, !unref(N)(o.hideNavigation, "time")]
        ]) : createCommentVNode("", true),
        createVNode(Transition, {
          name: unref(_2)(Z2.value),
          css: unref(H2) && !o.timePickerInline
        }, {
          default: withCtx(() => {
            var ee2;
            return [
              Z2.value || o.timePicker || o.timePickerInline ? (openBlock(), createElementBlock("div", {
                key: 0,
                ref_key: "overlayRef",
                ref: P,
                class: normalizeClass({
                  dp__overlay: !o.timePickerInline,
                  "dp--overlay-absolute": !n2.timePicker && !o.timePickerInline,
                  "dp--overlay-relative": n2.timePicker
                }),
                style: normalizeStyle(o.timePicker ? { height: `${unref(E2).modeHeight}px` } : void 0),
                tabindex: o.timePickerInline ? void 0 : 0
              }, [
                createElementVNode("div", {
                  class: normalizeClass(
                    o.timePickerInline ? "dp__time_picker_inline_container" : "dp__overlay_container dp__container_flex dp__time_picker_overlay_container"
                  ),
                  style: { display: "flex" }
                }, [
                  o.$slots["time-picker-overlay"] ? renderSlot(o.$slots, "time-picker-overlay", {
                    key: 0,
                    hours: e.hours,
                    minutes: e.minutes,
                    seconds: e.seconds,
                    setHours: fe2,
                    setMinutes: ce2,
                    setSeconds: O
                  }) : createCommentVNode("", true),
                  o.$slots["time-picker-overlay"] ? createCommentVNode("", true) : (openBlock(), createElementBlock("div", {
                    key: 1,
                    class: normalizeClass(o.timePickerInline ? "dp__flex" : "dp__overlay_row dp__flex_row")
                  }, [
                    (openBlock(true), createElementBlock(Fragment, null, renderList(q2.value, (de2, u) => withDirectives((openBlock(), createBlock(yr, mergeProps({
                      key: u,
                      ref_for: true
                    }, {
                      ...o.$props,
                      order: u,
                      hours: de2.hours,
                      minutes: de2.minutes,
                      seconds: de2.seconds,
                      closeTimePickerBtn: y2.value,
                      disabledTimesConfig: e.disabledTimesConfig,
                      disabled: u === 0 ? o.fixedStart : o.fixedEnd
                    }, {
                      ref_for: true,
                      ref_key: "timeInputRefs",
                      ref: F,
                      "validate-time": (I, se) => e.validateTime(I, K2(se, u, I)),
                      "onUpdate:hours": (I) => fe2(K2(I, u, "hours")),
                      "onUpdate:minutes": (I) => ce2(K2(I, u, "minutes")),
                      "onUpdate:seconds": (I) => O(K2(I, u, "seconds")),
                      onMounted: A,
                      onOverlayClosed: w,
                      onOverlayOpened: z2[2] || (z2[2] = (I) => o.$emit("overlay-opened", I)),
                      onAmPmChange: z2[3] || (z2[3] = (I) => o.$emit("am-pm-change", I))
                    }), createSlots({ _: 2 }, [
                      renderList(unref(B2), (I, se) => ({
                        name: I,
                        fn: withCtx((f) => [
                          renderSlot(o.$slots, I, mergeProps({ ref_for: true }, f))
                        ])
                      }))
                    ]), 1040, ["validate-time", "onUpdate:hours", "onUpdate:minutes", "onUpdate:seconds"])), [
                      [vShow, u === 0 ? true : J.value]
                    ])), 128))
                  ], 2)),
                  !o.timePicker && !o.timePickerInline ? withDirectives((openBlock(), createElementBlock("button", {
                    key: 2,
                    ref_key: "closeTimePickerBtn",
                    ref: y2,
                    type: "button",
                    class: normalizeClass(re2.value),
                    "aria-label": (ee2 = unref(L)) == null ? void 0 : ee2.closeTimePicker,
                    tabindex: "0",
                    onKeydown: z2[4] || (z2[4] = (de2) => unref(qe)(de2, () => R(false))),
                    onClick: z2[5] || (z2[5] = (de2) => R(false))
                  }, [
                    o.$slots["calendar-icon"] ? renderSlot(o.$slots, "calendar-icon", { key: 0 }) : createCommentVNode("", true),
                    o.$slots["calendar-icon"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(Et), { key: 1 }))
                  ], 42, kr)), [
                    [vShow, !unref(N)(o.hideNavigation, "time")]
                  ]) : createCommentVNode("", true)
                ], 2)
              ], 14, br)) : createCommentVNode("", true)
            ];
          }),
          _: 3
        }, 8, ["name", "css"])
      ]);
    };
  }
}), zn = (e, t, l, a) => {
  const { defaultedRange: n2 } = Ce(e), c2 = (P, J) => Array.isArray(t[P]) ? t[P][J] : t[P], v = (P) => e.enableSeconds ? Array.isArray(t.seconds) ? t.seconds[P] : t.seconds : 0, b2 = (P, J) => P ? J !== void 0 ? pt(P, c2("hours", J), c2("minutes", J), v(J)) : pt(P, t.hours, t.minutes, v()) : setSeconds(j(), v(J)), i = (P, J) => {
    t[P] = J;
  }, L = computed(() => e.modelAuto && n2.value.enabled ? Array.isArray(l.value) ? l.value.length > 1 : false : n2.value.enabled), m2 = (P, J) => {
    const Z2 = Object.fromEntries(
      Object.keys(t).map((le2) => le2 === P ? [le2, J] : [le2, t[le2]].slice())
    );
    if (L.value && !n2.value.disableTimeRangeValidation) {
      const le2 = (R) => l.value ? pt(
        l.value[R],
        Z2.hours[R],
        Z2.minutes[R],
        Z2.seconds[R]
      ) : null, q2 = (R) => setMilliseconds(l.value[R], 0);
      return !(De(le2(0), le2(1)) && (isAfter(le2(0), q2(1)) || isBefore(le2(1), q2(0))));
    }
    return true;
  }, E2 = (P, J) => {
    m2(P, J) && (i(P, J), a && a());
  }, k2 = (P) => {
    E2("hours", P);
  }, _2 = (P) => {
    E2("minutes", P);
  }, H2 = (P) => {
    E2("seconds", P);
  }, N = (P, J, Z2, le2) => {
    J && k2(P), !J && !Z2 && _2(P), Z2 && H2(P), l.value && le2(l.value);
  }, S2 = (P) => {
    if (P) {
      const J = Array.isArray(P), Z2 = J ? [+P[0].hours, +P[1].hours] : +P.hours, le2 = J ? [+P[0].minutes, +P[1].minutes] : +P.minutes, q2 = J ? [+P[0].seconds, +P[1].seconds] : +P.seconds;
      i("hours", Z2), i("minutes", le2), e.enableSeconds && i("seconds", q2);
    }
  }, y2 = (P, J) => {
    const Z2 = {
      hours: Array.isArray(t.hours) ? t.hours[P] : t.hours,
      disabledArr: []
    };
    return (J || J === 0) && (Z2.hours = J), Array.isArray(e.disabledTimes) && (Z2.disabledArr = n2.value.enabled && Array.isArray(e.disabledTimes[P]) ? e.disabledTimes[P] : e.disabledTimes), Z2;
  }, F = computed(() => (P, J) => {
    var Z2;
    if (Array.isArray(e.disabledTimes)) {
      const { disabledArr: le2, hours: q2 } = y2(P, J), R = le2.filter((re2) => +re2.hours === q2);
      return ((Z2 = R[0]) == null ? void 0 : Z2.minutes) === "*" ? { hours: [q2], minutes: void 0, seconds: void 0 } : {
        hours: [],
        minutes: (R == null ? void 0 : R.map((re2) => +re2.minutes)) ?? [],
        seconds: (R == null ? void 0 : R.map((re2) => re2.seconds ? +re2.seconds : void 0)) ?? []
      };
    }
    return { hours: [], minutes: [], seconds: [] };
  });
  return {
    setTime: i,
    updateHours: k2,
    updateMinutes: _2,
    updateSeconds: H2,
    getSetDateTime: b2,
    updateTimeValues: N,
    getSecondsValue: v,
    assignStartTime: S2,
    validateTime: m2,
    disabledTimesConfig: F
  };
}, wr = (e, t) => {
  const l = () => {
    e.isTextInputDate && J();
  }, { modelValue: a, time: n2 } = Jt(e, t, l), { defaultedStartTime: c2, defaultedRange: v, defaultedTz: b2 } = Ce(e), { updateTimeValues: i, getSetDateTime: L, setTime: m2, assignStartTime: E2, disabledTimesConfig: k2, validateTime: _2 } = zn(e, n2, a, H2);
  function H2() {
    t("update-flow-step");
  }
  const N = (q2) => {
    const { hours: R, minutes: re2, seconds: B2 } = q2;
    return { hours: +R, minutes: +re2, seconds: B2 ? +B2 : 0 };
  }, S2 = () => {
    if (e.startTime) {
      if (Array.isArray(e.startTime)) {
        const R = N(e.startTime[0]), re2 = N(e.startTime[1]);
        return [set(j(), R), set(j(), re2)];
      }
      const q2 = N(e.startTime);
      return set(j(), q2);
    }
    return v.value.enabled ? [null, null] : null;
  }, y2 = () => {
    if (v.value.enabled) {
      const [q2, R] = S2();
      a.value = [
        Xe(L(q2, 0), b2.value.timezone),
        Xe(L(R, 1), b2.value.timezone)
      ];
    } else
      a.value = Xe(L(S2()), b2.value.timezone);
  }, F = (q2) => Array.isArray(q2) ? [St(j(q2[0])), St(j(q2[1]))] : [St(q2 ?? j())], P = (q2, R, re2) => {
    m2("hours", q2), m2("minutes", R), m2("seconds", e.enableSeconds ? re2 : 0);
  }, J = () => {
    const [q2, R] = F(a.value);
    return v.value.enabled ? P(
      [q2.hours, R.hours],
      [q2.minutes, R.minutes],
      [q2.seconds, R.seconds]
    ) : P(q2.hours, q2.minutes, q2.seconds);
  };
  onMounted(() => {
    if (!e.shadow)
      return E2(c2.value), a.value ? J() : y2();
  });
  const Z2 = () => {
    Array.isArray(a.value) ? a.value = a.value.map((q2, R) => q2 && L(q2, R)) : a.value = L(a.value), t("time-update");
  };
  return {
    modelValue: a,
    time: n2,
    disabledTimesConfig: k2,
    updateTime: (q2, R = true, re2 = false) => {
      i(q2, R, re2, Z2);
    },
    validateTime: _2
  };
}, Dr = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "TimePickerSolo",
  props: {
    ...rt
  },
  emits: [
    "update:internal-model-value",
    "time-update",
    "am-pm-change",
    "mount",
    "reset-flow",
    "update-flow-step",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, c2 = useSlots(), v = Ze(c2, "timePicker"), b2 = ref(null), { time: i, modelValue: L, disabledTimesConfig: m2, updateTime: E2, validateTime: k2 } = wr(n2, a);
    return onMounted(() => {
      n2.shadow || a("mount", null);
    }), t({ getSidebarProps: () => ({
      modelValue: L,
      time: i,
      updateTime: E2
    }), toggleTimePicker: (N, S2 = false, y2 = "") => {
      var F;
      (F = b2.value) == null || F.toggleTimePicker(N, S2, y2);
    } }), (N, S2) => (openBlock(), createBlock(fa, {
      "multi-calendars": 0,
      stretch: ""
    }, {
      default: withCtx(() => [
        createVNode(Ln, mergeProps({
          ref_key: "tpRef",
          ref: b2
        }, N.$props, {
          hours: unref(i).hours,
          minutes: unref(i).minutes,
          seconds: unref(i).seconds,
          "internal-model-value": N.internalModelValue,
          "disabled-times-config": unref(m2),
          "validate-time": unref(k2),
          "onUpdate:hours": S2[0] || (S2[0] = (y2) => unref(E2)(y2)),
          "onUpdate:minutes": S2[1] || (S2[1] = (y2) => unref(E2)(y2, false)),
          "onUpdate:seconds": S2[2] || (S2[2] = (y2) => unref(E2)(y2, false, true)),
          onAmPmChange: S2[3] || (S2[3] = (y2) => N.$emit("am-pm-change", y2)),
          onResetFlow: S2[4] || (S2[4] = (y2) => N.$emit("reset-flow")),
          onOverlayClosed: S2[5] || (S2[5] = (y2) => N.$emit("overlay-toggle", { open: false, overlay: y2 })),
          onOverlayOpened: S2[6] || (S2[6] = (y2) => N.$emit("overlay-toggle", { open: true, overlay: y2 }))
        }), createSlots({ _: 2 }, [
          renderList(unref(v), (y2, F) => ({
            name: y2,
            fn: withCtx((P) => [
              renderSlot(N.$slots, y2, normalizeProps(guardReactiveProps(P)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"])
      ]),
      _: 3
    }));
  }
}), Mr = { class: "dp--header-wrap" }, $r = {
  key: 0,
  class: "dp__month_year_wrap"
}, Ar = { key: 0 }, Tr = { class: "dp__month_year_wrap" }, Sr = ["aria-label", "data-test", "onClick", "onKeydown"], Pr = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "DpHeader",
  props: {
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    instance: { type: Number, default: 0 },
    years: { type: Array, default: () => [] },
    months: { type: Array, default: () => [] },
    ...rt
  },
  emits: ["update-month-year", "mount", "reset-flow", "overlay-closed", "overlay-opened"],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, {
      defaultedTransitions: c2,
      defaultedAriaLabels: v,
      defaultedMultiCalendars: b2,
      defaultedFilters: i,
      defaultedConfig: L,
      defaultedHighlight: m2,
      propDates: E2,
      defaultedUI: k2
    } = Ce(n2), { transitionName: _2, showTransition: H2 } = Xt(c2), { buildMatrix: N } = bt(), { handleMonthYearChange: S2, isDisabled: y2, updateMonthYear: F } = Kl(n2, a), { showLeftIcon: P, showRightIcon: J } = ma(), Z2 = ref(false), le2 = ref(false), q2 = ref([null, null, null, null]);
    onMounted(() => {
      a("mount");
    });
    const R = (u) => ({
      get: () => n2[u],
      set: (I) => {
        const se = u === nt.month ? nt.year : nt.month;
        a("update-month-year", { [u]: I, [se]: n2[se] }), u === nt.month ? w(true) : o(true);
      }
    }), re2 = computed(R(nt.month)), B2 = computed(R(nt.year)), K2 = computed(() => (u) => ({
      month: n2.month,
      year: n2.year,
      items: u === nt.month ? n2.months : n2.years,
      instance: n2.instance,
      updateMonthYear: F,
      toggle: u === nt.month ? w : o
    })), fe2 = computed(() => {
      const u = n2.months.find((I) => I.value === n2.month);
      return u || { text: "", value: 0 };
    }), ce2 = computed(() => Yt(n2.months, (u) => {
      const I = n2.month === u.value, se = Gt(
        u.value,
        Tn(n2.year, E2.value.minDate),
        Sn(n2.year, E2.value.maxDate)
      ) || i.value.months.includes(u.value), f = On(m2.value, u.value, n2.year);
      return { active: I, disabled: se, highlighted: f };
    })), O = computed(() => Yt(n2.years, (u) => {
      const I = n2.year === u.value, se = Gt(
        u.value,
        It(E2.value.minDate),
        It(E2.value.maxDate)
      ) || i.value.years.includes(u.value), f = Qa(m2.value, u.value);
      return { active: I, disabled: se, highlighted: f };
    })), A = (u, I, se) => {
      se !== void 0 ? u.value = se : u.value = !u.value, u.value ? a("overlay-opened", I) : a("overlay-closed", I);
    }, w = (u = false, I) => {
      z2(u), A(Z2, He.month, I);
    }, o = (u = false, I) => {
      z2(u), A(le2, He.year, I);
    }, z2 = (u) => {
      u || a("reset-flow");
    }, D = (u, I) => {
      n2.arrowNavigation && (q2.value[I] = Ie(u), N(q2.value, "monthYear"));
    }, ee2 = computed(() => {
      var u, I;
      return [
        {
          type: nt.month,
          index: 1,
          toggle: w,
          modelValue: re2.value,
          updateModelValue: (se) => re2.value = se,
          text: fe2.value.text,
          showSelectionGrid: Z2.value,
          items: ce2.value,
          ariaLabel: (u = v.value) == null ? void 0 : u.openMonthsOverlay
        },
        {
          type: nt.year,
          index: 2,
          toggle: o,
          modelValue: B2.value,
          updateModelValue: (se) => B2.value = se,
          text: An(n2.year, n2.locale),
          showSelectionGrid: le2.value,
          items: O.value,
          ariaLabel: (I = v.value) == null ? void 0 : I.openYearsOverlay
        }
      ];
    }), de2 = computed(() => n2.disableYearSelect ? [ee2.value[0]] : n2.yearFirst ? [...ee2.value].reverse() : ee2.value);
    return t({
      toggleMonthPicker: w,
      toggleYearPicker: o,
      handleMonthYearChange: S2
    }), (u, I) => {
      var se, f, T, Q2, s, oe2;
      return openBlock(), createElementBlock("div", Mr, [
        u.$slots["month-year"] ? (openBlock(), createElementBlock("div", $r, [
          renderSlot(u.$slots, "month-year", normalizeProps(guardReactiveProps({ month: e.month, year: e.year, months: e.months, years: e.years, updateMonthYear: unref(F), handleMonthYearChange: unref(S2), instance: e.instance })))
        ])) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
          u.$slots["top-extra"] ? (openBlock(), createElementBlock("div", Ar, [
            renderSlot(u.$slots, "top-extra", { value: u.internalModelValue })
          ])) : createCommentVNode("", true),
          createElementVNode("div", Tr, [
            unref(P)(unref(b2), e.instance) && !u.vertical ? (openBlock(), createBlock(Vt, {
              key: 0,
              "aria-label": (se = unref(v)) == null ? void 0 : se.prevMonth,
              disabled: unref(y2)(false),
              class: normalizeClass((f = unref(k2)) == null ? void 0 : f.navBtnPrev),
              onActivate: I[0] || (I[0] = (M) => unref(S2)(false, true)),
              onSetRef: I[1] || (I[1] = (M) => D(M, 0))
            }, {
              default: withCtx(() => [
                u.$slots["arrow-left"] ? renderSlot(u.$slots, "arrow-left", { key: 0 }) : createCommentVNode("", true),
                u.$slots["arrow-left"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(La), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : createCommentVNode("", true),
            createElementVNode("div", {
              class: normalizeClass(["dp__month_year_wrap", {
                dp__year_disable_select: u.disableYearSelect
              }])
            }, [
              (openBlock(true), createElementBlock(Fragment, null, renderList(de2.value, (M, me2) => (openBlock(), createElementBlock(Fragment, {
                key: M.type
              }, [
                createElementVNode("button", {
                  ref_for: true,
                  ref: (d2) => D(d2, me2 + 1),
                  type: "button",
                  class: "dp__btn dp__month_year_select",
                  tabindex: "0",
                  "aria-label": M.ariaLabel,
                  "data-test": `${M.type}-toggle-overlay-${e.instance}`,
                  onClick: M.toggle,
                  onKeydown: (d2) => unref(qe)(d2, () => M.toggle(), true)
                }, [
                  u.$slots[M.type] ? renderSlot(u.$slots, M.type, {
                    key: 0,
                    text: M.text,
                    value: n2[M.type]
                  }) : createCommentVNode("", true),
                  u.$slots[M.type] ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                    createTextVNode(toDisplayString(M.text), 1)
                  ], 64))
                ], 40, Sr),
                createVNode(Transition, {
                  name: unref(_2)(M.showSelectionGrid),
                  css: unref(H2)
                }, {
                  default: withCtx(() => [
                    M.showSelectionGrid ? (openBlock(), createBlock(qt, {
                      key: 0,
                      items: M.items,
                      "arrow-navigation": u.arrowNavigation,
                      "hide-navigation": u.hideNavigation,
                      "is-last": u.autoApply && !unref(L).keepActionRow,
                      "skip-button-ref": false,
                      config: u.config,
                      type: M.type,
                      "header-refs": [],
                      "esc-close": u.escClose,
                      "menu-wrap-ref": u.menuWrapRef,
                      "text-input": u.textInput,
                      "aria-labels": u.ariaLabels,
                      onSelected: M.updateModelValue,
                      onToggle: M.toggle
                    }, createSlots({
                      "button-icon": withCtx(() => [
                        u.$slots["calendar-icon"] ? renderSlot(u.$slots, "calendar-icon", { key: 0 }) : createCommentVNode("", true),
                        u.$slots["calendar-icon"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(Et), { key: 1 }))
                      ]),
                      _: 2
                    }, [
                      u.$slots[`${M.type}-overlay-value`] ? {
                        name: "item",
                        fn: withCtx(({ item: d2 }) => [
                          renderSlot(u.$slots, `${M.type}-overlay-value`, {
                            text: d2.text,
                            value: d2.value
                          })
                        ]),
                        key: "0"
                      } : void 0,
                      u.$slots[`${M.type}-overlay`] ? {
                        name: "overlay",
                        fn: withCtx(() => [
                          renderSlot(u.$slots, `${M.type}-overlay`, mergeProps({ ref_for: true }, K2.value(M.type)))
                        ]),
                        key: "1"
                      } : void 0,
                      u.$slots[`${M.type}-overlay-header`] ? {
                        name: "header",
                        fn: withCtx(() => [
                          renderSlot(u.$slots, `${M.type}-overlay-header`, {
                            toggle: M.toggle
                          })
                        ]),
                        key: "2"
                      } : void 0
                    ]), 1032, ["items", "arrow-navigation", "hide-navigation", "is-last", "config", "type", "esc-close", "menu-wrap-ref", "text-input", "aria-labels", "onSelected", "onToggle"])) : createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["name", "css"])
              ], 64))), 128))
            ], 2),
            unref(P)(unref(b2), e.instance) && u.vertical ? (openBlock(), createBlock(Vt, {
              key: 1,
              "aria-label": (T = unref(v)) == null ? void 0 : T.prevMonth,
              disabled: unref(y2)(false),
              class: normalizeClass((Q2 = unref(k2)) == null ? void 0 : Q2.navBtnPrev),
              onActivate: I[2] || (I[2] = (M) => unref(S2)(false, true))
            }, {
              default: withCtx(() => [
                u.$slots["arrow-up"] ? renderSlot(u.$slots, "arrow-up", { key: 0 }) : createCommentVNode("", true),
                u.$slots["arrow-up"] ? createCommentVNode("", true) : (openBlock(), createBlock(unref(Va), { key: 1 }))
              ]),
              _: 3
            }, 8, ["aria-label", "disabled", "class"])) : createCommentVNode("", true),
            unref(J)(unref(b2), e.instance) ? (openBlock(), createBlock(Vt, {
              key: 2,
              ref: "rightIcon",
              disabled: unref(y2)(true),
              "aria-label": (s = unref(v)) == null ? void 0 : s.nextMonth,
              class: normalizeClass((oe2 = unref(k2)) == null ? void 0 : oe2.navBtnNext),
              onActivate: I[3] || (I[3] = (M) => unref(S2)(true, true)),
              onSetRef: I[4] || (I[4] = (M) => D(M, u.disableYearSelect ? 2 : 3))
            }, {
              default: withCtx(() => [
                u.$slots[u.vertical ? "arrow-down" : "arrow-right"] ? renderSlot(u.$slots, u.vertical ? "arrow-down" : "arrow-right", { key: 0 }) : createCommentVNode("", true),
                u.$slots[u.vertical ? "arrow-down" : "arrow-right"] ? createCommentVNode("", true) : (openBlock(), createBlock(resolveDynamicComponent(u.vertical ? unref(Ua) : unref(za)), { key: 1 }))
              ]),
              _: 3
            }, 8, ["disabled", "aria-label", "class"])) : createCommentVNode("", true)
          ])
        ], 64))
      ]);
    };
  }
}), Rr = ["aria-label"], Cr = {
  class: "dp__calendar_header",
  role: "row"
}, _r = {
  key: 0,
  class: "dp__calendar_header_item",
  role: "gridcell"
}, Or = ["aria-label"], Br = /* @__PURE__ */ createElementVNode("div", { class: "dp__calendar_header_separator" }, null, -1), Yr = ["aria-label"], Ir = {
  key: 0,
  role: "gridcell",
  class: "dp__calendar_item dp__week_num"
}, Nr = { class: "dp__cell_inner" }, Er = ["id", "aria-selected", "aria-disabled", "aria-label", "data-test", "onClick", "onKeydown", "onMouseenter", "onMouseleave", "onMousedown"], Fr = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "DpCalendar",
  props: {
    mappedDates: { type: Array, default: () => [] },
    instance: { type: Number, default: 0 },
    month: { type: Number, default: 0 },
    year: { type: Number, default: 0 },
    ...rt
  },
  emits: [
    "select-date",
    "set-hover-date",
    "handle-scroll",
    "mount",
    "handle-swipe",
    "handle-space",
    "tooltip-open",
    "tooltip-close"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, { buildMultiLevelMatrix: c2 } = bt(), {
      defaultedTransitions: v,
      defaultedConfig: b2,
      defaultedAriaLabels: i,
      defaultedMultiCalendars: L,
      defaultedWeekNumbers: m2,
      defaultedMultiDates: E2,
      defaultedUI: k2
    } = Ce(n2), _2 = ref(null), H2 = ref({
      bottom: "",
      left: "",
      transform: ""
    }), N = ref([]), S2 = ref(null), y2 = ref(true), F = ref(""), P = ref({ startX: 0, endX: 0, startY: 0, endY: 0 }), J = ref([]), Z2 = ref({ left: "50%" }), le2 = ref(false), q2 = computed(() => n2.calendar ? n2.calendar(n2.mappedDates) : n2.mappedDates), R = computed(() => n2.dayNames ? Array.isArray(n2.dayNames) ? n2.dayNames : n2.dayNames(n2.locale, +n2.weekStart) : vl(n2.formatLocale, n2.locale, +n2.weekStart));
    onMounted(() => {
      a("mount", { cmp: "calendar", refs: N }), b2.value.noSwipe || S2.value && (S2.value.addEventListener("touchstart", D, { passive: false }), S2.value.addEventListener("touchend", ee2, { passive: false }), S2.value.addEventListener("touchmove", de2, { passive: false })), n2.monthChangeOnScroll && S2.value && S2.value.addEventListener("wheel", se, { passive: false });
    });
    const re2 = (M) => M ? n2.vertical ? "vNext" : "next" : n2.vertical ? "vPrevious" : "previous", B2 = (M, me2) => {
      if (n2.transitions) {
        const d2 = Ke(dt(j(), n2.month, n2.year));
        F.value = Be(Ke(dt(j(), M, me2)), d2) ? v.value[re2(true)] : v.value[re2(false)], y2.value = false, nextTick(() => {
          y2.value = true;
        });
      }
    }, K2 = computed(
      () => ({
        [n2.calendarClassName]: !!n2.calendarClassName,
        ...k2.value.calendar ?? {}
      })
    ), fe2 = computed(() => (M) => {
      const me2 = gl(M);
      return {
        dp__marker_dot: me2.type === "dot",
        dp__marker_line: me2.type === "line"
      };
    }), ce2 = computed(() => (M) => De(M, _2.value)), O = computed(() => ({
      dp__calendar: true,
      dp__calendar_next: L.value.count > 0 && n2.instance !== 0
    })), A = computed(() => (M) => n2.hideOffsetDates ? M.current : true), w = async (M, me2, d2) => {
      const Y2 = Ie(N.value[me2][d2]);
      if (Y2) {
        const { width: W, height: C2 } = Y2.getBoundingClientRect();
        _2.value = M.value;
        let te2 = { left: `${W / 2}px` }, ue2 = -50;
        if (await nextTick(), J.value[0]) {
          const { left: p, width: V } = J.value[0].getBoundingClientRect();
          p < 0 && (te2 = { left: "0" }, ue2 = 0, Z2.value.left = `${W / 2}px`), window.innerWidth < p + V && (te2 = { right: "0" }, ue2 = 0, Z2.value.left = `${V - W / 2}px`);
        }
        H2.value = {
          bottom: `${C2}px`,
          ...te2,
          transform: `translateX(${ue2}%)`
        }, a("tooltip-open", M.marker);
      }
    }, o = async (M, me2, d2) => {
      var Y2, W;
      if (le2.value && E2.value.enabled && E2.value.dragSelect)
        return a("select-date", M);
      a("set-hover-date", M), (W = (Y2 = M.marker) == null ? void 0 : Y2.tooltip) != null && W.length && await w(M, me2, d2);
    }, z2 = (M) => {
      _2.value && (_2.value = null, H2.value = JSON.parse(JSON.stringify({ bottom: "", left: "", transform: "" })), a("tooltip-close", M.marker));
    }, D = (M) => {
      P.value.startX = M.changedTouches[0].screenX, P.value.startY = M.changedTouches[0].screenY;
    }, ee2 = (M) => {
      P.value.endX = M.changedTouches[0].screenX, P.value.endY = M.changedTouches[0].screenY, u();
    }, de2 = (M) => {
      n2.vertical && !n2.inline && M.preventDefault();
    }, u = () => {
      const M = n2.vertical ? "Y" : "X";
      Math.abs(P.value[`start${M}`] - P.value[`end${M}`]) > 10 && a("handle-swipe", P.value[`start${M}`] > P.value[`end${M}`] ? "right" : "left");
    }, I = (M, me2, d2) => {
      M && (Array.isArray(N.value[me2]) ? N.value[me2][d2] = M : N.value[me2] = [M]), n2.arrowNavigation && c2(N.value, "calendar");
    }, se = (M) => {
      n2.monthChangeOnScroll && (M.preventDefault(), a("handle-scroll", M));
    }, f = (M) => m2.value.type === "local" ? getWeek(M.value, { weekStartsOn: +n2.weekStart }) : m2.value.type === "iso" ? getISOWeek(M.value) : typeof m2.value.type == "function" ? m2.value.type(M.value) : "", T = (M) => {
      const me2 = M[0];
      return m2.value.hideOnOffsetDates ? M.some((d2) => d2.current) ? f(me2) : "" : f(me2);
    }, Q2 = (M, me2) => {
      E2.value.enabled || (yt(M, b2.value), a("select-date", me2));
    }, s = (M) => {
      yt(M, b2.value);
    }, oe2 = (M) => {
      E2.value.enabled && E2.value.dragSelect ? (le2.value = true, a("select-date", M)) : E2.value.enabled && a("select-date", M);
    };
    return t({ triggerTransition: B2 }), (M, me2) => {
      var d2;
      return openBlock(), createElementBlock("div", {
        class: normalizeClass(O.value)
      }, [
        createElementVNode("div", {
          ref_key: "calendarWrapRef",
          ref: S2,
          role: "grid",
          class: normalizeClass(K2.value),
          "aria-label": (d2 = unref(i)) == null ? void 0 : d2.calendarWrap
        }, [
          createElementVNode("div", Cr, [
            M.weekNumbers ? (openBlock(), createElementBlock("div", _r, toDisplayString(M.weekNumName), 1)) : createCommentVNode("", true),
            (openBlock(true), createElementBlock(Fragment, null, renderList(R.value, (Y2, W) => {
              var C2, te2;
              return openBlock(), createElementBlock("div", {
                key: W,
                class: "dp__calendar_header_item",
                role: "gridcell",
                "data-test": "calendar-header",
                "aria-label": (te2 = (C2 = unref(i)) == null ? void 0 : C2.weekDay) == null ? void 0 : te2.call(C2, W)
              }, [
                M.$slots["calendar-header"] ? renderSlot(M.$slots, "calendar-header", {
                  key: 0,
                  day: Y2,
                  index: W
                }) : createCommentVNode("", true),
                M.$slots["calendar-header"] ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(Y2), 1)
                ], 64))
              ], 8, Or);
            }), 128))
          ]),
          Br,
          createVNode(Transition, {
            name: F.value,
            css: !!M.transitions
          }, {
            default: withCtx(() => {
              var Y2;
              return [
                y2.value ? (openBlock(), createElementBlock("div", {
                  key: 0,
                  class: "dp__calendar",
                  role: "rowgroup",
                  "aria-label": ((Y2 = unref(i)) == null ? void 0 : Y2.calendarDays) || void 0,
                  onMouseleave: me2[1] || (me2[1] = (W) => le2.value = false)
                }, [
                  (openBlock(true), createElementBlock(Fragment, null, renderList(q2.value, (W, C2) => (openBlock(), createElementBlock("div", {
                    key: C2,
                    class: "dp__calendar_row",
                    role: "row"
                  }, [
                    M.weekNumbers ? (openBlock(), createElementBlock("div", Ir, [
                      createElementVNode("div", Nr, toDisplayString(T(W.days)), 1)
                    ])) : createCommentVNode("", true),
                    (openBlock(true), createElementBlock(Fragment, null, renderList(W.days, (te2, ue2) => {
                      var p, V, pe2;
                      return openBlock(), createElementBlock("div", {
                        id: unref(Bn)(te2.value),
                        ref_for: true,
                        ref: ($e) => I($e, C2, ue2),
                        key: ue2 + C2,
                        role: "gridcell",
                        class: "dp__calendar_item",
                        "aria-selected": (te2.classData.dp__active_date || te2.classData.dp__range_start || te2.classData.dp__range_start) ?? void 0,
                        "aria-disabled": te2.classData.dp__cell_disabled || void 0,
                        "aria-label": (V = (p = unref(i)) == null ? void 0 : p.day) == null ? void 0 : V.call(p, te2),
                        tabindex: "0",
                        "data-test": te2.value,
                        onClick: withModifiers(($e) => Q2($e, te2), ["prevent"]),
                        onKeydown: ($e) => unref(qe)($e, () => M.$emit("select-date", te2)),
                        onMouseenter: ($e) => o(te2, C2, ue2),
                        onMouseleave: ($e) => z2(te2),
                        onMousedown: ($e) => oe2(te2),
                        onMouseup: me2[0] || (me2[0] = ($e) => le2.value = false)
                      }, [
                        createElementVNode("div", {
                          class: normalizeClass(["dp__cell_inner", te2.classData])
                        }, [
                          M.$slots.day && A.value(te2) ? renderSlot(M.$slots, "day", {
                            key: 0,
                            day: +te2.text,
                            date: te2.value
                          }) : createCommentVNode("", true),
                          M.$slots.day ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                            createTextVNode(toDisplayString(te2.text), 1)
                          ], 64)),
                          te2.marker && A.value(te2) ? (openBlock(), createElementBlock(Fragment, { key: 2 }, [
                            M.$slots.marker ? renderSlot(M.$slots, "marker", {
                              key: 0,
                              marker: te2.marker,
                              day: +te2.text,
                              date: te2.value
                            }) : (openBlock(), createElementBlock("div", {
                              key: 1,
                              class: normalizeClass(fe2.value(te2.marker)),
                              style: normalizeStyle(te2.marker.color ? { backgroundColor: te2.marker.color } : {})
                            }, null, 6))
                          ], 64)) : createCommentVNode("", true),
                          ce2.value(te2.value) ? (openBlock(), createElementBlock("div", {
                            key: 3,
                            ref_for: true,
                            ref_key: "activeTooltip",
                            ref: J,
                            class: "dp__marker_tooltip",
                            style: normalizeStyle(H2.value)
                          }, [
                            (pe2 = te2.marker) != null && pe2.tooltip ? (openBlock(), createElementBlock("div", {
                              key: 0,
                              class: "dp__tooltip_content",
                              onClick: s
                            }, [
                              (openBlock(true), createElementBlock(Fragment, null, renderList(te2.marker.tooltip, ($e, Ge) => (openBlock(), createElementBlock("div", {
                                key: Ge,
                                class: "dp__tooltip_text"
                              }, [
                                M.$slots["marker-tooltip"] ? renderSlot(M.$slots, "marker-tooltip", {
                                  key: 0,
                                  tooltip: $e,
                                  day: te2.value
                                }) : createCommentVNode("", true),
                                M.$slots["marker-tooltip"] ? createCommentVNode("", true) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                                  createElementVNode("div", {
                                    class: "dp__tooltip_mark",
                                    style: normalizeStyle($e.color ? { backgroundColor: $e.color } : {})
                                  }, null, 4),
                                  createElementVNode("div", null, toDisplayString($e.text), 1)
                                ], 64))
                              ]))), 128)),
                              createElementVNode("div", {
                                class: "dp__arrow_bottom_tp",
                                style: normalizeStyle(Z2.value)
                              }, null, 4)
                            ])) : createCommentVNode("", true)
                          ], 4)) : createCommentVNode("", true)
                        ], 2)
                      ], 40, Er);
                    }), 128))
                  ]))), 128))
                ], 40, Yr)) : createCommentVNode("", true)
              ];
            }),
            _: 3
          }, 8, ["name", "css"])
        ], 10, Rr)
      ], 2);
    };
  }
}), cn = (e) => Array.isArray(e), Lr = (e, t, l, a) => {
  const n2 = ref([]), c2 = ref(/* @__PURE__ */ new Date()), v = ref(), b2 = () => ee2(e.isTextInputDate), { modelValue: i, calendars: L, time: m2, today: E2 } = Jt(e, t, b2), {
    defaultedMultiCalendars: k2,
    defaultedStartTime: _2,
    defaultedRange: H2,
    defaultedConfig: N,
    defaultedTz: S2,
    propDates: y2,
    defaultedMultiDates: F
  } = Ce(e), { validateMonthYearInRange: P, isDisabled: J, isDateRangeAllowed: Z2, checkMinMaxRange: le2 } = kt(e), { updateTimeValues: q2, getSetDateTime: R, setTime: re2, assignStartTime: B2, validateTime: K2, disabledTimesConfig: fe2 } = zn(e, m2, i, a), ce2 = computed(
    () => (h2) => L.value[h2] ? L.value[h2].month : 0
  ), O = computed(
    () => (h2) => L.value[h2] ? L.value[h2].year : 0
  ), A = (h2) => !N.value.keepViewOnOffsetClick || h2 ? true : !v.value, w = (h2, g2, U, ne = false) => {
    var Ae2, Fe;
    A(ne) && (L.value[h2] || (L.value[h2] = { month: 0, year: 0 }), L.value[h2].month = rn(g2) ? (Ae2 = L.value[h2]) == null ? void 0 : Ae2.month : g2, L.value[h2].year = rn(U) ? (Fe = L.value[h2]) == null ? void 0 : Fe.year : U);
  }, o = () => {
    e.autoApply && t("select-date");
  };
  onMounted(() => {
    e.shadow || (i.value || (me2(), _2.value && B2(_2.value)), ee2(true), e.focusStartDate && e.startDate && me2());
  });
  const z2 = computed(() => {
    var h2;
    return (h2 = e.flow) != null && h2.length && !e.partialFlow ? e.flowStep === e.flow.length : true;
  }), D = () => {
    e.autoApply && z2.value && t("auto-apply");
  }, ee2 = (h2 = false) => {
    if (i.value)
      return Array.isArray(i.value) ? (n2.value = i.value, Q2(h2)) : I(i.value, h2);
    if (k2.value.count && h2 && !e.startDate)
      return u(j(), h2);
  }, de2 = () => Array.isArray(i.value) && H2.value.enabled ? getMonth(i.value[0]) === getMonth(i.value[1] ?? i.value[0]) : false, u = (h2 = /* @__PURE__ */ new Date(), g2 = false) => {
    if ((!k2.value.count || !k2.value.static || g2) && w(0, getMonth(h2), getYear(h2)), k2.value.count && (!k2.value.solo || !i.value || de2()))
      for (let U = 1; U < k2.value.count; U++) {
        const ne = set(j(), { month: ce2.value(U - 1), year: O.value(U - 1) }), Ae2 = add(ne, { months: 1 });
        L.value[U] = { month: getMonth(Ae2), year: getYear(Ae2) };
      }
  }, I = (h2, g2) => {
    u(h2), re2("hours", getHours(h2)), re2("minutes", getMinutes(h2)), re2("seconds", getSeconds(h2)), k2.value.count && g2 && M();
  }, se = (h2) => {
    if (k2.value.count) {
      if (k2.value.solo) return 0;
      const g2 = getMonth(h2[0]), U = getMonth(h2[1]);
      return Math.abs(U - g2) < k2.value.count ? 0 : 1;
    }
    return 1;
  }, f = (h2, g2) => {
    h2[1] && H2.value.showLastInRange ? u(h2[se(h2)], g2) : u(h2[0], g2);
    const U = (ne, Ae2) => [
      ne(h2[0]),
      h2[1] ? ne(h2[1]) : m2[Ae2][1]
    ];
    re2("hours", U(getHours, "hours")), re2("minutes", U(getMinutes, "minutes")), re2("seconds", U(getSeconds, "seconds"));
  }, T = (h2, g2) => {
    if ((H2.value.enabled || e.weekPicker) && !F.value.enabled)
      return f(h2, g2);
    if (F.value.enabled && g2) {
      const U = h2[h2.length - 1];
      return I(U, g2);
    }
  }, Q2 = (h2) => {
    const g2 = i.value;
    T(g2, h2), k2.value.count && k2.value.solo && M();
  }, s = (h2, g2) => {
    const U = set(j(), { month: ce2.value(g2), year: O.value(g2) }), ne = h2 < 0 ? addMonths(U, 1) : subMonths(U, 1);
    P(getMonth(ne), getYear(ne), h2 < 0, e.preventMinMaxNavigation) && (w(g2, getMonth(ne), getYear(ne)), t("update-month-year", { instance: g2, month: getMonth(ne), year: getYear(ne) }), k2.value.count && !k2.value.solo && oe2(g2), l());
  }, oe2 = (h2) => {
    for (let g2 = h2 - 1; g2 >= 0; g2--) {
      const U = subMonths(set(j(), { month: ce2.value(g2 + 1), year: O.value(g2 + 1) }), 1);
      w(g2, getMonth(U), getYear(U));
    }
    for (let g2 = h2 + 1; g2 <= k2.value.count - 1; g2++) {
      const U = addMonths(set(j(), { month: ce2.value(g2 - 1), year: O.value(g2 - 1) }), 1);
      w(g2, getMonth(U), getYear(U));
    }
  }, M = () => {
    if (Array.isArray(i.value) && i.value.length === 2) {
      const h2 = j(
        j(i.value[1] ? i.value[1] : addMonths(i.value[0], 1))
      ), [g2, U] = [getMonth(i.value[0]), getYear(i.value[0])], [ne, Ae2] = [getMonth(i.value[1]), getYear(i.value[1])];
      (g2 !== ne || g2 === ne && U !== Ae2) && k2.value.solo && w(1, getMonth(h2), getYear(h2));
    } else i.value && !Array.isArray(i.value) && (w(0, getMonth(i.value), getYear(i.value)), u(j()));
  }, me2 = () => {
    e.startDate && (w(0, getMonth(j(e.startDate)), getYear(j(e.startDate))), k2.value.count && oe2(0));
  }, d2 = (h2, g2) => {
    if (e.monthChangeOnScroll) {
      const U = (/* @__PURE__ */ new Date()).getTime() - c2.value.getTime(), ne = Math.abs(h2.deltaY);
      let Ae2 = 500;
      ne > 1 && (Ae2 = 100), ne > 100 && (Ae2 = 0), U > Ae2 && (c2.value = /* @__PURE__ */ new Date(), s(e.monthChangeOnScroll !== "inverse" ? -h2.deltaY : h2.deltaY, g2));
    }
  }, Y2 = (h2, g2, U = false) => {
    e.monthChangeOnArrows && e.vertical === U && W(h2, g2);
  }, W = (h2, g2) => {
    s(h2 === "right" ? -1 : 1, g2);
  }, C2 = (h2) => {
    if (y2.value.markers)
      return sa(h2.value, y2.value.markers);
  }, te2 = (h2, g2) => {
    switch (e.sixWeeks === true ? "append" : e.sixWeeks) {
      case "prepend":
        return [true, false];
      case "center":
        return [h2 == 0, true];
      case "fair":
        return [h2 == 0 || g2 > h2, true];
      case "append":
        return [false, false];
      default:
        return [false, false];
    }
  }, ue2 = (h2, g2, U, ne) => {
    if (e.sixWeeks && h2.length < 6) {
      const Ae2 = 6 - h2.length, Fe = (g2.getDay() + 7 - ne) % 7, xt = 6 - (U.getDay() + 7 - ne) % 7, [zt, Da] = te2(Fe, xt);
      for (let Dt = 1; Dt <= Ae2; Dt++)
        if (Da ? !!(Dt % 2) == zt : zt) {
          const ea = h2[0].days[0], Ma = p(addDays(ea.value, -7), getMonth(g2));
          h2.unshift({ days: Ma });
        } else {
          const ea = h2[h2.length - 1], Ma = ea.days[ea.days.length - 1], Vn = p(addDays(Ma.value, 1), getMonth(g2));
          h2.push({ days: Vn });
        }
    }
    return h2;
  }, p = (h2, g2) => {
    const U = j(h2), ne = [];
    for (let Ae2 = 0; Ae2 < 7; Ae2++) {
      const Fe = addDays(U, Ae2), wt2 = getMonth(Fe) !== g2;
      ne.push({
        text: e.hideOffsetDates && wt2 ? "" : Fe.getDate(),
        value: Fe,
        current: !wt2,
        classData: {}
      });
    }
    return ne;
  }, V = (h2, g2) => {
    const U = [], ne = new Date(g2, h2), Ae2 = new Date(g2, h2 + 1, 0), Fe = e.weekStart, wt2 = startOfWeek(ne, { weekStartsOn: Fe }), xt = (zt) => {
      const Da = p(zt, h2);
      if (U.push({ days: Da }), !U[U.length - 1].days.some(
        (Dt) => De(Ke(Dt.value), Ke(Ae2))
      )) {
        const Dt = addDays(zt, 7);
        xt(Dt);
      }
    };
    return xt(wt2), ue2(U, ne, Ae2, Fe);
  }, pe2 = (h2) => {
    const g2 = pt(j(h2.value), m2.hours, m2.minutes, Je());
    t("date-update", g2), F.value.enabled ? qa(g2, i, F.value.limit) : i.value = g2, a(), nextTick().then(() => {
      D();
    });
  }, $e = (h2) => H2.value.noDisabledRange ? Pn(n2.value[0], h2).some((U) => J(U)) : false, Ge = () => {
    n2.value = i.value ? i.value.slice() : [], n2.value.length === 2 && !(H2.value.fixedStart || H2.value.fixedEnd) && (n2.value = []);
  }, ve = (h2, g2) => {
    const U = [
      j(h2.value),
      addDays(j(h2.value), +H2.value.autoRange)
    ];
    Z2(U) ? (g2 && vt2(h2.value), n2.value = U) : t("invalid-date", h2.value);
  }, vt2 = (h2) => {
    const g2 = getMonth(j(h2)), U = getYear(j(h2));
    if (w(0, g2, U), k2.value.count > 0)
      for (let ne = 1; ne < k2.value.count; ne++) {
        const Ae2 = Ml(
          set(j(h2), { year: ce2.value(ne - 1), month: O.value(ne - 1) })
        );
        w(ne, Ae2.month, Ae2.year);
      }
  }, ot2 = (h2) => {
    if ($e(h2.value) || !le2(h2.value, i.value, H2.value.fixedStart ? 0 : 1))
      return t("invalid-date", h2.value);
    n2.value = En(j(h2.value), i, t, H2);
  }, Ft = (h2, g2) => {
    if (Ge(), H2.value.autoRange) return ve(h2, g2);
    if (H2.value.fixedStart || H2.value.fixedEnd) return ot2(h2);
    n2.value[0] ? le2(j(h2.value), i.value) && !$e(h2.value) ? _e(j(h2.value), j(n2.value[0])) ? (n2.value.unshift(j(h2.value)), t("range-end", n2.value[0])) : (n2.value[1] = j(h2.value), t("range-end", n2.value[1])) : (e.autoApply && t("auto-apply-invalid", h2.value), t("invalid-date", h2.value)) : (n2.value[0] = j(h2.value), t("range-start", n2.value[0]));
  }, Je = (h2 = true) => e.enableSeconds ? Array.isArray(m2.seconds) ? h2 ? m2.seconds[0] : m2.seconds[1] : m2.seconds : 0, Lt = (h2) => {
    n2.value[h2] = pt(
      n2.value[h2],
      m2.hours[h2],
      m2.minutes[h2],
      Je(h2 !== 1)
    );
  }, ga = () => {
    var h2, g2;
    n2.value[0] && n2.value[1] && +((h2 = n2.value) == null ? void 0 : h2[0]) > +((g2 = n2.value) == null ? void 0 : g2[1]) && (n2.value.reverse(), t("range-start", n2.value[0]), t("range-end", n2.value[1]));
  }, Zt = () => {
    n2.value.length && (n2.value[0] && !n2.value[1] ? Lt(0) : (Lt(0), Lt(1), a()), ga(), i.value = n2.value.slice(), va(n2.value, t, e.autoApply, e.modelAuto));
  }, ya = (h2, g2 = false) => {
    if (J(h2.value) || !h2.current && e.hideOffsetDates) return t("invalid-date", h2.value);
    if (v.value = JSON.parse(JSON.stringify(h2)), !H2.value.enabled) return pe2(h2);
    cn(m2.hours) && cn(m2.minutes) && !F.value.enabled && (Ft(h2, g2), Zt());
  }, pa = (h2, g2) => {
    var ne;
    w(h2, g2.month, g2.year, true), k2.value.count && !k2.value.solo && oe2(h2), t("update-month-year", { instance: h2, month: g2.month, year: g2.year }), l(k2.value.solo ? h2 : void 0);
    const U = (ne = e.flow) != null && ne.length ? e.flow[e.flowStep] : void 0;
    !g2.fromNav && (U === He.month || U === He.year) && a();
  }, ha = (h2, g2) => {
    Nn({
      value: h2,
      modelValue: i,
      range: H2.value.enabled,
      timezone: g2 ? void 0 : S2.value.timezone
    }), o(), e.multiCalendars && nextTick().then(() => ee2(true));
  }, ba = () => {
    const h2 = Wa(j(), S2.value);
    H2.value.enabled ? i.value && Array.isArray(i.value) && i.value[0] ? i.value = _e(h2, i.value[0]) ? [h2, i.value[0]] : [i.value[0], h2] : i.value = [h2] : i.value = h2, o();
  }, ka = () => {
    if (Array.isArray(i.value))
      if (F.value.enabled) {
        const h2 = wa();
        i.value[i.value.length - 1] = R(h2);
      } else
        i.value = i.value.map((h2, g2) => h2 && R(h2, g2));
    else
      i.value = R(i.value);
    t("time-update");
  }, wa = () => Array.isArray(i.value) && i.value.length ? i.value[i.value.length - 1] : null;
  return {
    calendars: L,
    modelValue: i,
    month: ce2,
    year: O,
    time: m2,
    disabledTimesConfig: fe2,
    today: E2,
    validateTime: K2,
    getCalendarDays: V,
    getMarker: C2,
    handleScroll: d2,
    handleSwipe: W,
    handleArrow: Y2,
    selectDate: ya,
    updateMonthYear: pa,
    presetDate: ha,
    selectCurrentDate: ba,
    updateTime: (h2, g2 = true, U = false) => {
      q2(h2, g2, U, ka);
    },
    assignMonthAndYear: u
  };
}, zr = { key: 0 }, Hr = /* @__PURE__ */ defineComponent({
  __name: "DatePicker",
  props: {
    ...rt
  },
  emits: [
    "tooltip-open",
    "tooltip-close",
    "mount",
    "update:internal-model-value",
    "update-flow-step",
    "reset-flow",
    "auto-apply",
    "focus-menu",
    "select-date",
    "range-start",
    "range-end",
    "invalid-fixed-range",
    "time-update",
    "am-pm-change",
    "time-picker-open",
    "time-picker-close",
    "recalculate-position",
    "update-month-year",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, {
      calendars: c2,
      month: v,
      year: b2,
      modelValue: i,
      time: L,
      disabledTimesConfig: m2,
      today: E2,
      validateTime: k2,
      getCalendarDays: _2,
      getMarker: H2,
      handleArrow: N,
      handleScroll: S2,
      handleSwipe: y2,
      selectDate: F,
      updateMonthYear: P,
      presetDate: J,
      selectCurrentDate: Z2,
      updateTime: le2,
      assignMonthAndYear: q2
    } = Lr(n2, a, de2, u), R = useSlots(), { setHoverDate: re2, getDayClassData: B2, clearHoverDate: K2 } = no(i, n2), { defaultedMultiCalendars: fe2 } = Ce(n2), ce2 = ref([]), O = ref([]), A = ref(null), w = Ze(R, "calendar"), o = Ze(R, "monthYear"), z2 = Ze(R, "timePicker"), D = (Y2) => {
      n2.shadow || a("mount", Y2);
    };
    watch(
      c2,
      () => {
        n2.shadow || setTimeout(() => {
          a("recalculate-position");
        }, 0);
      },
      { deep: true }
    ), watch(
      fe2,
      (Y2, W) => {
        Y2.count - W.count > 0 && q2();
      },
      { deep: true }
    );
    const ee2 = computed(() => (Y2) => _2(v.value(Y2), b2.value(Y2)).map((W) => ({
      ...W,
      days: W.days.map((C2) => (C2.marker = H2(C2), C2.classData = B2(C2), C2))
    })));
    function de2(Y2) {
      var W;
      Y2 || Y2 === 0 ? (W = O.value[Y2]) == null || W.triggerTransition(v.value(Y2), b2.value(Y2)) : O.value.forEach((C2, te2) => C2.triggerTransition(v.value(te2), b2.value(te2)));
    }
    function u() {
      a("update-flow-step");
    }
    const I = (Y2, W = false) => {
      F(Y2, W), n2.spaceConfirm && a("select-date");
    }, se = (Y2, W, C2 = 0) => {
      var te2;
      (te2 = ce2.value[C2]) == null || te2.toggleMonthPicker(Y2, W);
    }, f = (Y2, W, C2 = 0) => {
      var te2;
      (te2 = ce2.value[C2]) == null || te2.toggleYearPicker(Y2, W);
    }, T = (Y2, W, C2) => {
      var te2;
      (te2 = A.value) == null || te2.toggleTimePicker(Y2, W, C2);
    }, Q2 = (Y2, W) => {
      var C2;
      if (!n2.range) {
        const te2 = i.value ? i.value : E2, ue2 = W ? new Date(W) : te2, p = Y2 ? startOfWeek(ue2, { weekStartsOn: 1 }) : endOfWeek(ue2, { weekStartsOn: 1 });
        F({
          value: p,
          current: getMonth(ue2) === v.value(0),
          text: "",
          classData: {}
        }), (C2 = document.getElementById(Bn(p))) == null || C2.focus();
      }
    }, s = (Y2) => {
      var W;
      (W = ce2.value[0]) == null || W.handleMonthYearChange(Y2, true);
    }, oe2 = (Y2) => {
      P(0, { month: v.value(0), year: b2.value(0) + (Y2 ? 1 : -1), fromNav: true });
    }, M = (Y2, W) => {
      Y2 === He.time && a(`time-picker-${W ? "open" : "close"}`), a("overlay-toggle", { open: W, overlay: Y2 });
    }, me2 = (Y2) => {
      a("overlay-toggle", { open: false, overlay: Y2 }), a("focus-menu");
    };
    return t({
      clearHoverDate: K2,
      presetDate: J,
      selectCurrentDate: Z2,
      toggleMonthPicker: se,
      toggleYearPicker: f,
      toggleTimePicker: T,
      handleArrow: N,
      updateMonthYear: P,
      getSidebarProps: () => ({
        modelValue: i,
        month: v,
        year: b2,
        time: L,
        updateTime: le2,
        updateMonthYear: P,
        selectDate: F,
        presetDate: J
      }),
      changeMonth: s,
      changeYear: oe2,
      selectWeekDate: Q2
    }), (Y2, W) => (openBlock(), createElementBlock(Fragment, null, [
      createVNode(fa, {
        "multi-calendars": unref(fe2).count,
        collapse: Y2.collapse
      }, {
        default: withCtx(({ instance: C2, index: te2 }) => [
          Y2.disableMonthYearSelect ? createCommentVNode("", true) : (openBlock(), createBlock(Pr, mergeProps({
            key: 0,
            ref: (ue2) => {
              ue2 && (ce2.value[te2] = ue2);
            },
            months: unref(Dn)(Y2.formatLocale, Y2.locale, Y2.monthNameFormat),
            years: unref(ja)(Y2.yearRange, Y2.locale, Y2.reverseYears),
            month: unref(v)(C2),
            year: unref(b2)(C2),
            instance: C2
          }, Y2.$props, {
            onMount: W[0] || (W[0] = (ue2) => D(unref(Tt).header)),
            onResetFlow: W[1] || (W[1] = (ue2) => Y2.$emit("reset-flow")),
            onUpdateMonthYear: (ue2) => unref(P)(C2, ue2),
            onOverlayClosed: me2,
            onOverlayOpened: W[2] || (W[2] = (ue2) => Y2.$emit("overlay-toggle", { open: true, overlay: ue2 }))
          }), createSlots({ _: 2 }, [
            renderList(unref(o), (ue2, p) => ({
              name: ue2,
              fn: withCtx((V) => [
                renderSlot(Y2.$slots, ue2, normalizeProps(guardReactiveProps(V)))
              ])
            }))
          ]), 1040, ["months", "years", "month", "year", "instance", "onUpdateMonthYear"])),
          createVNode(Fr, mergeProps({
            ref: (ue2) => {
              ue2 && (O.value[te2] = ue2);
            },
            "mapped-dates": ee2.value(C2),
            month: unref(v)(C2),
            year: unref(b2)(C2),
            instance: C2
          }, Y2.$props, {
            onSelectDate: (ue2) => unref(F)(ue2, C2 !== 1),
            onHandleSpace: (ue2) => I(ue2, C2 !== 1),
            onSetHoverDate: W[3] || (W[3] = (ue2) => unref(re2)(ue2)),
            onHandleScroll: (ue2) => unref(S2)(ue2, C2),
            onHandleSwipe: (ue2) => unref(y2)(ue2, C2),
            onMount: W[4] || (W[4] = (ue2) => D(unref(Tt).calendar)),
            onResetFlow: W[5] || (W[5] = (ue2) => Y2.$emit("reset-flow")),
            onTooltipOpen: W[6] || (W[6] = (ue2) => Y2.$emit("tooltip-open", ue2)),
            onTooltipClose: W[7] || (W[7] = (ue2) => Y2.$emit("tooltip-close", ue2))
          }), createSlots({ _: 2 }, [
            renderList(unref(w), (ue2, p) => ({
              name: ue2,
              fn: withCtx((V) => [
                renderSlot(Y2.$slots, ue2, normalizeProps(guardReactiveProps({ ...V })))
              ])
            }))
          ]), 1040, ["mapped-dates", "month", "year", "instance", "onSelectDate", "onHandleSpace", "onHandleScroll", "onHandleSwipe"])
        ]),
        _: 3
      }, 8, ["multi-calendars", "collapse"]),
      Y2.enableTimePicker ? (openBlock(), createElementBlock("div", zr, [
        Y2.$slots["time-picker"] ? renderSlot(Y2.$slots, "time-picker", normalizeProps(mergeProps({ key: 0 }, { time: unref(L), updateTime: unref(le2) }))) : (openBlock(), createBlock(Ln, mergeProps({
          key: 1,
          ref_key: "timePickerRef",
          ref: A
        }, Y2.$props, {
          hours: unref(L).hours,
          minutes: unref(L).minutes,
          seconds: unref(L).seconds,
          "internal-model-value": Y2.internalModelValue,
          "disabled-times-config": unref(m2),
          "validate-time": unref(k2),
          onMount: W[8] || (W[8] = (C2) => D(unref(Tt).timePicker)),
          "onUpdate:hours": W[9] || (W[9] = (C2) => unref(le2)(C2)),
          "onUpdate:minutes": W[10] || (W[10] = (C2) => unref(le2)(C2, false)),
          "onUpdate:seconds": W[11] || (W[11] = (C2) => unref(le2)(C2, false, true)),
          onResetFlow: W[12] || (W[12] = (C2) => Y2.$emit("reset-flow")),
          onOverlayClosed: W[13] || (W[13] = (C2) => M(C2, false)),
          onOverlayOpened: W[14] || (W[14] = (C2) => M(C2, true)),
          onAmPmChange: W[15] || (W[15] = (C2) => Y2.$emit("am-pm-change", C2))
        }), createSlots({ _: 2 }, [
          renderList(unref(z2), (C2, te2) => ({
            name: C2,
            fn: withCtx((ue2) => [
              renderSlot(Y2.$slots, C2, normalizeProps(guardReactiveProps(ue2)))
            ])
          }))
        ]), 1040, ["hours", "minutes", "seconds", "internal-model-value", "disabled-times-config", "validate-time"]))
      ])) : createCommentVNode("", true)
    ], 64));
  }
}), Vr = (e, t) => {
  const l = ref(), {
    defaultedMultiCalendars: a,
    defaultedConfig: n2,
    defaultedHighlight: c2,
    defaultedRange: v,
    propDates: b2,
    defaultedFilters: i,
    defaultedMultiDates: L
  } = Ce(e), { modelValue: m2, year: E2, month: k2, calendars: _2 } = Jt(e, t), { isDisabled: H2 } = kt(e), { selectYear: N, groupedYears: S2, showYearPicker: y2, isDisabled: F, toggleYearPicker: P, handleYearSelect: J, handleYear: Z2 } = Fn({
    modelValue: m2,
    multiCalendars: a,
    range: v,
    highlight: c2,
    calendars: _2,
    propDates: b2,
    month: k2,
    year: E2,
    filters: i,
    props: e,
    emit: t
  }), le2 = (o, z2) => [o, z2].map((D) => format(D, "MMMM", { locale: e.formatLocale })).join("-"), q2 = computed(() => (o) => m2.value ? Array.isArray(m2.value) ? m2.value.some((z2) => isSameQuarter(o, z2)) : isSameQuarter(m2.value, o) : false), R = (o) => {
    if (v.value.enabled) {
      if (Array.isArray(m2.value)) {
        const z2 = De(o, m2.value[0]) || De(o, m2.value[1]);
        return da(m2.value, l.value, o) && !z2;
      }
      return false;
    }
    return false;
  }, re2 = (o, z2) => o.quarter === getQuarter(z2) && o.year === getYear(z2), B2 = (o) => typeof c2.value == "function" ? c2.value({ quarter: getQuarter(o), year: getYear(o) }) : !!c2.value.quarters.find((z2) => re2(z2, o)), K2 = computed(() => (o) => {
    const z2 = set(/* @__PURE__ */ new Date(), { year: E2.value(o) });
    return eachQuarterOfInterval({
      start: startOfYear(z2),
      end: endOfYear(z2)
    }).map((D) => {
      const ee2 = startOfQuarter(D), de2 = endOfQuarter(D), u = H2(D), I = R(ee2), se = B2(ee2);
      return {
        text: le2(ee2, de2),
        value: ee2,
        active: q2.value(ee2),
        highlighted: se,
        disabled: u,
        isBetween: I
      };
    });
  }), fe2 = (o) => {
    qa(o, m2, L.value.limit), t("auto-apply", true);
  }, ce2 = (o) => {
    m2.value = Xa(m2, o, t), va(m2.value, t, e.autoApply, e.modelAuto);
  }, O = (o) => {
    m2.value = o, t("auto-apply");
  };
  return {
    defaultedConfig: n2,
    defaultedMultiCalendars: a,
    groupedYears: S2,
    year: E2,
    isDisabled: F,
    quarters: K2,
    showYearPicker: y2,
    modelValue: m2,
    setHoverDate: (o) => {
      l.value = o;
    },
    selectYear: N,
    selectQuarter: (o, z2, D) => {
      if (!D)
        return _2.value[z2].month = getMonth(endOfQuarter(o)), L.value.enabled ? fe2(o) : v.value.enabled ? ce2(o) : O(o);
    },
    toggleYearPicker: P,
    handleYearSelect: J,
    handleYear: Z2
  };
}, Ur = { class: "dp--quarter-items" }, Wr = ["data-test", "disabled", "onClick", "onMouseover"], jr = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "QuarterPicker",
  props: {
    ...rt
  },
  emits: [
    "update:internal-model-value",
    "reset-flow",
    "overlay-closed",
    "auto-apply",
    "range-start",
    "range-end",
    "overlay-toggle",
    "update-month-year"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, c2 = useSlots(), v = Ze(c2, "yearMode"), {
      defaultedMultiCalendars: b2,
      defaultedConfig: i,
      groupedYears: L,
      year: m2,
      isDisabled: E2,
      quarters: k2,
      modelValue: _2,
      showYearPicker: H2,
      setHoverDate: N,
      selectQuarter: S2,
      toggleYearPicker: y2,
      handleYearSelect: F,
      handleYear: P
    } = Vr(n2, a);
    return t({ getSidebarProps: () => ({
      modelValue: _2,
      year: m2,
      selectQuarter: S2,
      handleYearSelect: F,
      handleYear: P
    }) }), (Z2, le2) => (openBlock(), createBlock(fa, {
      "multi-calendars": unref(b2).count,
      collapse: Z2.collapse,
      stretch: ""
    }, {
      default: withCtx(({ instance: q2 }) => [
        createElementVNode("div", {
          class: "dp-quarter-picker-wrap",
          style: normalizeStyle({ minHeight: `${unref(i).modeHeight}px` })
        }, [
          Z2.$slots["top-extra"] ? renderSlot(Z2.$slots, "top-extra", {
            key: 0,
            value: Z2.internalModelValue
          }) : createCommentVNode("", true),
          createElementVNode("div", null, [
            createVNode(In, mergeProps(Z2.$props, {
              items: unref(L)(q2),
              instance: q2,
              "show-year-picker": unref(H2)[q2],
              year: unref(m2)(q2),
              "is-disabled": (R) => unref(E2)(q2, R),
              onHandleYear: (R) => unref(P)(q2, R),
              onYearSelect: (R) => unref(F)(R, q2),
              onToggleYearPicker: (R) => unref(y2)(q2, R == null ? void 0 : R.flow, R == null ? void 0 : R.show)
            }), createSlots({ _: 2 }, [
              renderList(unref(v), (R, re2) => ({
                name: R,
                fn: withCtx((B2) => [
                  renderSlot(Z2.$slots, R, normalizeProps(guardReactiveProps(B2)))
                ])
              }))
            ]), 1040, ["items", "instance", "show-year-picker", "year", "is-disabled", "onHandleYear", "onYearSelect", "onToggleYearPicker"])
          ]),
          createElementVNode("div", Ur, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(unref(k2)(q2), (R, re2) => (openBlock(), createElementBlock("div", { key: re2 }, [
              createElementVNode("button", {
                type: "button",
                class: normalizeClass(["dp--qr-btn", {
                  "dp--qr-btn-active": R.active,
                  "dp--qr-btn-between": R.isBetween,
                  "dp--qr-btn-disabled": R.disabled,
                  "dp--highlighted": R.highlighted
                }]),
                "data-test": R.value,
                disabled: R.disabled,
                onClick: (B2) => unref(S2)(R.value, q2, R.disabled),
                onMouseover: (B2) => unref(N)(R.value)
              }, [
                Z2.$slots.quarter ? renderSlot(Z2.$slots, "quarter", {
                  key: 0,
                  value: R.value,
                  text: R.text
                }) : (openBlock(), createElementBlock(Fragment, { key: 1 }, [
                  createTextVNode(toDisplayString(R.text), 1)
                ], 64))
              ], 42, Wr)
            ]))), 128))
          ])
        ], 4)
      ]),
      _: 3
    }, 8, ["multi-calendars", "collapse"]));
  }
}), Kr = ["id", "aria-label"], Gr = {
  key: 0,
  class: "dp--menu-load-container"
}, Qr = /* @__PURE__ */ createElementVNode("span", { class: "dp--menu-loader" }, null, -1), qr = [
  Qr
], Xr = {
  key: 0,
  class: "dp__sidebar_left"
}, Jr = ["data-test", "onClick", "onKeydown"], Zr = {
  key: 2,
  class: "dp__sidebar_right"
}, xr = {
  key: 3,
  class: "dp__action_extra"
}, fn = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerMenu",
  props: {
    ...ca,
    shadow: { type: Boolean, default: false },
    openOnTop: { type: Boolean, default: false },
    internalModelValue: { type: [Date, Array], default: null },
    noOverlayFocus: { type: Boolean, default: false },
    collapse: { type: Boolean, default: false },
    getInputRect: { type: Function, default: () => ({}) },
    isTextInputDate: { type: Boolean, default: false }
  },
  emits: [
    "close-picker",
    "select-date",
    "auto-apply",
    "time-update",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "update:internal-model-value",
    "recalculate-position",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "auto-apply-invalid",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, c2 = ref(null), v = computed(() => {
      const { openOnTop: p, ...V } = n2;
      return {
        ...V,
        flowStep: re2.value,
        collapse: n2.collapse,
        noOverlayFocus: n2.noOverlayFocus,
        menuWrapRef: c2.value
      };
    }), { setMenuFocused: b2, setShiftKey: i, control: L } = Yn(), m2 = useSlots(), { defaultedTextInput: E2, defaultedInline: k2, defaultedConfig: _2, defaultedUI: H2 } = Ce(n2), N = ref(null), S2 = ref(0), y2 = ref(null), F = ref(false), P = ref(null);
    onMounted(() => {
      if (!n2.shadow) {
        F.value = true, J(), window.addEventListener("resize", J);
        const p = Ie(c2);
        if (p && !E2.value.enabled && !k2.value.enabled && (b2(true), w()), p) {
          const V = (pe2) => {
            _2.value.allowPreventDefault && pe2.preventDefault(), yt(pe2, _2.value, true);
          };
          p.addEventListener("pointerdown", V), p.addEventListener("mousedown", V);
        }
      }
    }), onUnmounted(() => {
      window.removeEventListener("resize", J);
    });
    const J = () => {
      const p = Ie(y2);
      p && (S2.value = p.getBoundingClientRect().width);
    }, { arrowRight: Z2, arrowLeft: le2, arrowDown: q2, arrowUp: R } = bt(), { flowStep: re2, updateFlowStep: B2, childMount: K2, resetFlow: fe2, handleFlow: ce2 } = lo(n2, a, P), O = computed(() => n2.monthPicker ? nr : n2.yearPicker ? rr : n2.timePicker ? Dr : n2.quarterPicker ? jr : Hr), A = computed(() => {
      var pe2;
      if (_2.value.arrowLeft) return _2.value.arrowLeft;
      const p = (pe2 = c2.value) == null ? void 0 : pe2.getBoundingClientRect(), V = n2.getInputRect();
      return (V == null ? void 0 : V.width) < (S2 == null ? void 0 : S2.value) && (V == null ? void 0 : V.left) <= ((p == null ? void 0 : p.left) ?? 0) ? `${(V == null ? void 0 : V.width) / 2}px` : (V == null ? void 0 : V.right) >= ((p == null ? void 0 : p.right) ?? 0) && (V == null ? void 0 : V.width) < (S2 == null ? void 0 : S2.value) ? `${(S2 == null ? void 0 : S2.value) - (V == null ? void 0 : V.width) / 2}px` : "50%";
    }), w = () => {
      const p = Ie(c2);
      p && p.focus({ preventScroll: true });
    }, o = computed(() => {
      var p;
      return ((p = P.value) == null ? void 0 : p.getSidebarProps()) || {};
    }), z2 = () => {
      n2.openOnTop && a("recalculate-position");
    }, D = Ze(m2, "action"), ee2 = computed(() => n2.monthPicker || n2.yearPicker ? Ze(m2, "monthYear") : n2.timePicker ? Ze(m2, "timePicker") : Ze(m2, "shared")), de2 = computed(() => n2.openOnTop ? "dp__arrow_bottom" : "dp__arrow_top"), u = computed(() => ({
      dp__menu_disabled: n2.disabled,
      dp__menu_readonly: n2.readonly,
      "dp-menu-loading": n2.loading
    })), I = computed(
      () => ({
        dp__menu: true,
        dp__menu_index: !k2.value.enabled,
        dp__relative: k2.value.enabled,
        [n2.menuClassName]: !!n2.menuClassName,
        ...H2.value.menu ?? {}
      })
    ), se = (p) => {
      yt(p, _2.value, true);
    }, f = () => {
      n2.escClose && a("close-picker");
    }, T = (p) => {
      if (n2.arrowNavigation) {
        if (p === je.up) return R();
        if (p === je.down) return q2();
        if (p === je.left) return le2();
        if (p === je.right) return Z2();
      } else p === je.left || p === je.up ? me2("handleArrow", je.left, 0, p === je.up) : me2("handleArrow", je.right, 0, p === je.down);
    }, Q2 = (p) => {
      i(p.shiftKey), !n2.disableMonthYearSelect && p.code === Re.tab && p.target.classList.contains("dp__menu") && L.value.shiftKeyInMenu && (p.preventDefault(), yt(p, _2.value, true), a("close-picker"));
    }, s = () => {
      w(), a("time-picker-close");
    }, oe2 = (p) => {
      var V, pe2, $e;
      (V = P.value) == null || V.toggleTimePicker(false, false), (pe2 = P.value) == null || pe2.toggleMonthPicker(false, false, p), ($e = P.value) == null || $e.toggleYearPicker(false, false, p);
    }, M = (p, V = 0) => {
      var pe2, $e, Ge;
      return p === "month" ? (pe2 = P.value) == null ? void 0 : pe2.toggleMonthPicker(false, true, V) : p === "year" ? ($e = P.value) == null ? void 0 : $e.toggleYearPicker(false, true, V) : p === "time" ? (Ge = P.value) == null ? void 0 : Ge.toggleTimePicker(true, false) : oe2(V);
    }, me2 = (p, ...V) => {
      var pe2, $e;
      (pe2 = P.value) != null && pe2[p] && (($e = P.value) == null || $e[p](...V));
    }, d2 = () => {
      me2("selectCurrentDate");
    }, Y2 = (p, V) => {
      me2("presetDate", p, V);
    }, W = () => {
      me2("clearHoverDate");
    }, C2 = (p, V) => {
      me2("updateMonthYear", p, V);
    }, te2 = (p, V) => {
      p.preventDefault(), T(V);
    }, ue2 = (p) => {
      var V;
      if (Q2(p), p.key === Re.home || p.key === Re.end)
        return me2(
          "selectWeekDate",
          p.key === Re.home,
          p.target.getAttribute("id")
        );
      switch ((p.key === Re.pageUp || p.key === Re.pageDown) && (p.shiftKey ? me2("changeYear", p.key === Re.pageUp) : me2("changeMonth", p.key === Re.pageUp), p.target.getAttribute("id") && ((V = c2.value) == null || V.focus({ preventScroll: true }))), p.key) {
        case Re.esc:
          return f();
        case Re.arrowLeft:
          return te2(p, je.left);
        case Re.arrowRight:
          return te2(p, je.right);
        case Re.arrowUp:
          return te2(p, je.up);
        case Re.arrowDown:
          return te2(p, je.down);
        default:
          return;
      }
    };
    return t({
      updateMonthYear: C2,
      switchView: M,
      handleFlow: ce2
    }), (p, V) => {
      var pe2, $e, Ge;
      return openBlock(), createElementBlock("div", {
        id: p.uid ? `dp-menu-${p.uid}` : void 0,
        ref_key: "dpMenuRef",
        ref: c2,
        tabindex: "0",
        role: "dialog",
        "aria-label": (pe2 = p.ariaLabels) == null ? void 0 : pe2.menu,
        class: normalizeClass(I.value),
        style: normalizeStyle({ "--dp-arrow-left": A.value }),
        onMouseleave: W,
        onClick: se,
        onKeydown: ue2
      }, [
        (p.disabled || p.readonly) && unref(k2).enabled || p.loading ? (openBlock(), createElementBlock("div", {
          key: 0,
          class: normalizeClass(u.value)
        }, [
          p.loading ? (openBlock(), createElementBlock("div", Gr, qr)) : createCommentVNode("", true)
        ], 2)) : createCommentVNode("", true),
        !unref(k2).enabled && !p.teleportCenter ? (openBlock(), createElementBlock("div", {
          key: 1,
          class: normalizeClass(de2.value)
        }, null, 2)) : createCommentVNode("", true),
        createElementVNode("div", {
          ref_key: "innerMenuRef",
          ref: y2,
          class: normalizeClass({
            dp__menu_content_wrapper: (($e = p.presetDates) == null ? void 0 : $e.length) || !!p.$slots["left-sidebar"] || !!p.$slots["right-sidebar"],
            "dp--menu-content-wrapper-collapsed": e.collapse && (((Ge = p.presetDates) == null ? void 0 : Ge.length) || !!p.$slots["left-sidebar"] || !!p.$slots["right-sidebar"])
          }),
          style: normalizeStyle({ "--dp-menu-width": `${S2.value}px` })
        }, [
          p.$slots["left-sidebar"] ? (openBlock(), createElementBlock("div", Xr, [
            renderSlot(p.$slots, "left-sidebar", normalizeProps(guardReactiveProps(o.value)))
          ])) : createCommentVNode("", true),
          p.presetDates.length ? (openBlock(), createElementBlock("div", {
            key: 1,
            class: normalizeClass({ "dp--preset-dates-collapsed": e.collapse, "dp--preset-dates": true })
          }, [
            (openBlock(true), createElementBlock(Fragment, null, renderList(p.presetDates, (ve, vt2) => (openBlock(), createElementBlock(Fragment, { key: vt2 }, [
              ve.slot ? renderSlot(p.$slots, ve.slot, {
                key: 0,
                presetDate: Y2,
                label: ve.label,
                value: ve.value
              }) : (openBlock(), createElementBlock("button", {
                key: 1,
                type: "button",
                style: normalizeStyle(ve.style || {}),
                class: normalizeClass(["dp__btn dp--preset-range", { "dp--preset-range-collapsed": e.collapse }]),
                "data-test": ve.testId ?? void 0,
                onClick: withModifiers((ot2) => Y2(ve.value, ve.noTz), ["prevent"]),
                onKeydown: (ot2) => unref(qe)(ot2, () => Y2(ve.value, ve.noTz), true)
              }, toDisplayString(ve.label), 47, Jr))
            ], 64))), 128))
          ], 2)) : createCommentVNode("", true),
          createElementVNode("div", {
            ref_key: "calendarWrapperRef",
            ref: N,
            class: "dp__instance_calendar",
            role: "document"
          }, [
            (openBlock(), createBlock(resolveDynamicComponent(O.value), mergeProps({
              ref_key: "dynCmpRef",
              ref: P
            }, v.value, {
              "flow-step": unref(re2),
              onMount: unref(K2),
              onUpdateFlowStep: unref(B2),
              onResetFlow: unref(fe2),
              onFocusMenu: w,
              onSelectDate: V[0] || (V[0] = (ve) => p.$emit("select-date")),
              onDateUpdate: V[1] || (V[1] = (ve) => p.$emit("date-update", ve)),
              onTooltipOpen: V[2] || (V[2] = (ve) => p.$emit("tooltip-open", ve)),
              onTooltipClose: V[3] || (V[3] = (ve) => p.$emit("tooltip-close", ve)),
              onAutoApply: V[4] || (V[4] = (ve) => p.$emit("auto-apply", ve)),
              onRangeStart: V[5] || (V[5] = (ve) => p.$emit("range-start", ve)),
              onRangeEnd: V[6] || (V[6] = (ve) => p.$emit("range-end", ve)),
              onInvalidFixedRange: V[7] || (V[7] = (ve) => p.$emit("invalid-fixed-range", ve)),
              onTimeUpdate: V[8] || (V[8] = (ve) => p.$emit("time-update")),
              onAmPmChange: V[9] || (V[9] = (ve) => p.$emit("am-pm-change", ve)),
              onTimePickerOpen: V[10] || (V[10] = (ve) => p.$emit("time-picker-open", ve)),
              onTimePickerClose: s,
              onRecalculatePosition: z2,
              onUpdateMonthYear: V[11] || (V[11] = (ve) => p.$emit("update-month-year", ve)),
              onAutoApplyInvalid: V[12] || (V[12] = (ve) => p.$emit("auto-apply-invalid", ve)),
              onInvalidDate: V[13] || (V[13] = (ve) => p.$emit("invalid-date", ve)),
              onOverlayToggle: V[14] || (V[14] = (ve) => p.$emit("overlay-toggle", ve)),
              "onUpdate:internalModelValue": V[15] || (V[15] = (ve) => p.$emit("update:internal-model-value", ve))
            }), createSlots({ _: 2 }, [
              renderList(ee2.value, (ve, vt2) => ({
                name: ve,
                fn: withCtx((ot2) => [
                  renderSlot(p.$slots, ve, normalizeProps(guardReactiveProps({ ...ot2 })))
                ])
              }))
            ]), 1040, ["flow-step", "onMount", "onUpdateFlowStep", "onResetFlow"]))
          ], 512),
          p.$slots["right-sidebar"] ? (openBlock(), createElementBlock("div", Zr, [
            renderSlot(p.$slots, "right-sidebar", normalizeProps(guardReactiveProps(o.value)))
          ])) : createCommentVNode("", true),
          p.$slots["action-extra"] ? (openBlock(), createElementBlock("div", xr, [
            p.$slots["action-extra"] ? renderSlot(p.$slots, "action-extra", {
              key: 0,
              selectCurrentDate: d2
            }) : createCommentVNode("", true)
          ])) : createCommentVNode("", true)
        ], 6),
        !p.autoApply || unref(_2).keepActionRow ? (openBlock(), createBlock(ql, mergeProps({
          key: 2,
          "menu-mount": F.value
        }, v.value, {
          "calendar-width": S2.value,
          onClosePicker: V[16] || (V[16] = (ve) => p.$emit("close-picker")),
          onSelectDate: V[17] || (V[17] = (ve) => p.$emit("select-date")),
          onInvalidSelect: V[18] || (V[18] = (ve) => p.$emit("invalid-select")),
          onSelectNow: d2
        }), createSlots({ _: 2 }, [
          renderList(unref(D), (ve, vt2) => ({
            name: ve,
            fn: withCtx((ot2) => [
              renderSlot(p.$slots, ve, normalizeProps(guardReactiveProps({ ...ot2 })))
            ])
          }))
        ]), 1040, ["menu-mount", "calendar-width"])) : createCommentVNode("", true)
      ], 46, Kr);
    };
  }
});
var Ct = /* @__PURE__ */ ((e) => (e.center = "center", e.left = "left", e.right = "right", e))(Ct || {});
const eo = ({
  menuRef: e,
  menuRefInner: t,
  inputRef: l,
  pickerWrapperRef: a,
  inline: n2,
  emit: c2,
  props: v,
  slots: b2
}) => {
  const i = ref({}), L = ref(false), m2 = ref({
    top: "0",
    left: "0"
  }), E2 = ref(false), k2 = toRef(v, "teleportCenter");
  watch(k2, () => {
    m2.value = JSON.parse(JSON.stringify({})), J();
  });
  const _2 = (w) => {
    if (v.teleport) {
      const o = w.getBoundingClientRect();
      return {
        left: o.left + window.scrollX,
        top: o.top + window.scrollY
      };
    }
    return { top: 0, left: 0 };
  }, H2 = (w, o) => {
    m2.value.left = `${w + o - i.value.width}px`;
  }, N = (w) => {
    m2.value.left = `${w}px`;
  }, S2 = (w, o) => {
    v.position === Ct.left && N(w), v.position === Ct.right && H2(w, o), v.position === Ct.center && (m2.value.left = `${w + o / 2 - i.value.width / 2}px`);
  }, y2 = (w) => {
    const { width: o, height: z2 } = w.getBoundingClientRect(), { top: D, left: ee2 } = v.altPosition ? v.altPosition(w) : _2(w);
    return { top: +D, left: +ee2, width: o, height: z2 };
  }, F = () => {
    m2.value.left = "50%", m2.value.top = "50%", m2.value.transform = "translate(-50%, -50%)", m2.value.position = "fixed", delete m2.value.opacity;
  }, P = () => {
    const w = Ie(l), { top: o, left: z2, transform: D } = v.altPosition(w);
    m2.value = { top: `${o}px`, left: `${z2}px`, transform: D ?? "" };
  }, J = (w = true) => {
    var o;
    if (!n2.value.enabled) {
      if (k2.value) return F();
      if (v.altPosition !== null) return P();
      if (w) {
        const z2 = v.teleport ? (o = t.value) == null ? void 0 : o.$el : e.value;
        z2 && (i.value = z2.getBoundingClientRect()), c2("recalculate-position");
      }
      return K2();
    }
  }, Z2 = ({ inputEl: w, left: o, width: z2 }) => {
    window.screen.width > 768 && !L.value && S2(o, z2), R(w);
  }, le2 = (w) => {
    const { top: o, left: z2, height: D, width: ee2 } = y2(w);
    m2.value.top = `${D + o + +v.offset}px`, E2.value = false, L.value || (m2.value.left = `${z2 + ee2 / 2 - i.value.width / 2}px`), Z2({ inputEl: w, left: z2, width: ee2 });
  }, q2 = (w) => {
    const { top: o, left: z2, width: D } = y2(w);
    m2.value.top = `${o - +v.offset - i.value.height}px`, E2.value = true, Z2({ inputEl: w, left: z2, width: D });
  }, R = (w) => {
    if (v.autoPosition) {
      const { left: o, width: z2 } = y2(w), { left: D, right: ee2 } = i.value;
      if (!L.value) {
        if (Math.abs(D) !== Math.abs(ee2)) {
          if (D <= 0)
            return L.value = true, N(o);
          if (ee2 >= document.documentElement.clientWidth)
            return L.value = true, H2(o, z2);
        }
        return S2(o, z2);
      }
    }
  }, re2 = () => {
    const w = Ie(l);
    if (w) {
      const { height: o } = i.value, { top: z2, height: D } = w.getBoundingClientRect(), de2 = window.innerHeight - z2 - D, u = z2;
      return o <= de2 ? Mt.bottom : o > de2 && o <= u ? Mt.top : de2 >= u ? Mt.bottom : Mt.top;
    }
    return Mt.bottom;
  }, B2 = (w) => re2() === Mt.bottom ? le2(w) : q2(w), K2 = () => {
    const w = Ie(l);
    if (w)
      return v.autoPosition ? B2(w) : le2(w);
  }, fe2 = function(w) {
    if (w) {
      const o = w.scrollHeight > w.clientHeight, D = window.getComputedStyle(w).overflowY.indexOf("hidden") !== -1;
      return o && !D;
    }
    return true;
  }, ce2 = function(w) {
    return !w || w === document.body || w.nodeType === Node.DOCUMENT_FRAGMENT_NODE ? window : fe2(w) ? w : ce2(w.assignedSlot ? w.assignedSlot.parentNode : w.parentNode);
  }, O = (w) => {
    if (w)
      switch (v.position) {
        case Ct.left:
          return { left: 0, transform: "translateX(0)" };
        case Ct.right:
          return { left: `${w.width}px`, transform: "translateX(-100%)" };
        default:
          return { left: `${w.width / 2}px`, transform: "translateX(-50%)" };
      }
    return {};
  };
  return {
    openOnTop: E2,
    menuStyle: m2,
    xCorrect: L,
    setMenuPosition: J,
    getScrollableParent: ce2,
    shadowRender: (w, o) => {
      var I, se, f;
      const z2 = document.createElement("div"), D = (I = Ie(l)) == null ? void 0 : I.getBoundingClientRect();
      z2.setAttribute("id", "dp--temp-container");
      const ee2 = (se = a.value) != null && se.clientWidth ? a.value : document.body;
      ee2.append(z2);
      const de2 = O(D), u = h$1(
        w,
        {
          ...o,
          shadow: true,
          style: { opacity: 0, position: "absolute", ...de2 }
        },
        Object.fromEntries(
          Object.keys(b2).filter((T) => ["right-sidebar", "left-sidebar", "top-extra", "action-extra"].includes(T)).map((T) => [T, b2[T]])
        )
      );
      render$e(u, z2), i.value = (f = u.el) == null ? void 0 : f.getBoundingClientRect(), render$e(null, z2), ee2.removeChild(z2);
    }
  };
}, mt = [
  { name: "clock-icon", use: ["time", "calendar", "shared"] },
  { name: "arrow-left", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-right", use: ["month-year", "calendar", "shared", "year-mode"] },
  { name: "arrow-up", use: ["time", "calendar", "month-year", "shared"] },
  { name: "arrow-down", use: ["time", "calendar", "month-year", "shared"] },
  { name: "calendar-icon", use: ["month-year", "time", "calendar", "shared", "year-mode"] },
  { name: "day", use: ["calendar", "shared"] },
  { name: "month-overlay-value", use: ["calendar", "month-year", "shared"] },
  { name: "year-overlay-value", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "year-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay", use: ["month-year", "shared"] },
  { name: "month-overlay-header", use: ["month-year", "shared"] },
  { name: "year-overlay-header", use: ["month-year", "shared"] },
  { name: "hours-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "hours-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "minutes-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-value", use: ["calendar", "time", "shared"] },
  { name: "seconds-overlay-header", use: ["calendar", "time", "shared"] },
  { name: "hours", use: ["calendar", "time", "shared"] },
  { name: "minutes", use: ["calendar", "time", "shared"] },
  { name: "month", use: ["calendar", "month-year", "shared"] },
  { name: "year", use: ["calendar", "month-year", "shared", "year-mode"] },
  { name: "action-buttons", use: ["action"] },
  { name: "action-preview", use: ["action"] },
  { name: "calendar-header", use: ["calendar", "shared"] },
  { name: "marker-tooltip", use: ["calendar", "shared"] },
  { name: "action-extra", use: ["menu"] },
  { name: "time-picker-overlay", use: ["calendar", "time", "shared"] },
  { name: "am-pm-button", use: ["calendar", "time", "shared"] },
  { name: "left-sidebar", use: ["menu"] },
  { name: "right-sidebar", use: ["menu"] },
  { name: "month-year", use: ["month-year", "shared"] },
  { name: "time-picker", use: ["menu", "shared"] },
  { name: "action-row", use: ["action"] },
  { name: "marker", use: ["calendar", "shared"] },
  { name: "quarter", use: ["shared"] },
  { name: "top-extra", use: ["shared", "month-year"] },
  { name: "tp-inline-arrow-up", use: ["shared", "time"] },
  { name: "tp-inline-arrow-down", use: ["shared", "time"] }
], to = [{ name: "trigger" }, { name: "input-icon" }, { name: "clear-icon" }, { name: "dp-input" }], ao = {
  all: () => mt,
  monthYear: () => mt.filter((e) => e.use.includes("month-year")),
  input: () => to,
  timePicker: () => mt.filter((e) => e.use.includes("time")),
  action: () => mt.filter((e) => e.use.includes("action")),
  calendar: () => mt.filter((e) => e.use.includes("calendar")),
  menu: () => mt.filter((e) => e.use.includes("menu")),
  shared: () => mt.filter((e) => e.use.includes("shared")),
  yearMode: () => mt.filter((e) => e.use.includes("year-mode"))
}, Ze = (e, t, l) => {
  const a = [];
  return ao[t]().forEach((n2) => {
    e[n2.name] && a.push(n2.name);
  }), l != null && l.length && l.forEach((n2) => {
    n2.slot && a.push(n2.slot);
  }), a;
}, Xt = (e) => {
  const t = computed(() => (a) => e.value ? a ? e.value.open : e.value.close : ""), l = computed(() => (a) => e.value ? a ? e.value.menuAppearTop : e.value.menuAppearBottom : "");
  return { transitionName: t, showTransition: !!e.value, menuTransition: l };
}, Jt = (e, t, l) => {
  const { defaultedRange: a, defaultedTz: n2 } = Ce(e), c2 = j(Xe(j(), n2.value.timezone)), v = ref([{ month: getMonth(c2), year: getYear(c2) }]), b2 = (k2) => {
    const _2 = {
      hours: getHours(c2),
      minutes: getMinutes(c2),
      seconds: 0
    };
    return a.value.enabled ? [_2[k2], _2[k2]] : _2[k2];
  }, i = reactive({
    hours: b2("hours"),
    minutes: b2("minutes"),
    seconds: b2("seconds")
  });
  watch(
    a,
    (k2, _2) => {
      k2.enabled !== _2.enabled && (i.hours = b2("hours"), i.minutes = b2("minutes"), i.seconds = b2("seconds"));
    },
    { deep: true }
  );
  const L = computed({
    get: () => e.internalModelValue,
    set: (k2) => {
      !e.readonly && !e.disabled && t("update:internal-model-value", k2);
    }
  }), m2 = computed(
    () => (k2) => v.value[k2] ? v.value[k2].month : 0
  ), E2 = computed(
    () => (k2) => v.value[k2] ? v.value[k2].year : 0
  );
  return watch(
    L,
    (k2, _2) => {
      l && JSON.stringify(k2 ?? {}) !== JSON.stringify(_2 ?? {}) && l();
    },
    { deep: true }
  ), {
    calendars: v,
    time: i,
    modelValue: L,
    month: m2,
    year: E2,
    today: c2
  };
}, no = (e, t) => {
  const {
    defaultedMultiCalendars: l,
    defaultedMultiDates: a,
    defaultedUI: n2,
    defaultedHighlight: c2,
    defaultedTz: v,
    propDates: b2,
    defaultedRange: i
  } = Ce(t), { isDisabled: L } = kt(t), m2 = ref(null), E2 = ref(Xe(/* @__PURE__ */ new Date(), v.value.timezone)), k2 = (f) => {
    !f.current && t.hideOffsetDates || (m2.value = f.value);
  }, _2 = () => {
    m2.value = null;
  }, H2 = (f) => Array.isArray(e.value) && i.value.enabled && e.value[0] && m2.value ? f ? Be(m2.value, e.value[0]) : _e(m2.value, e.value[0]) : true, N = (f, T) => {
    const Q2 = () => e.value ? T ? e.value[0] || null : e.value[1] : null, s = e.value && Array.isArray(e.value) ? Q2() : null;
    return De(j(f.value), s);
  }, S2 = (f) => {
    const T = Array.isArray(e.value) ? e.value[0] : null;
    return f ? !_e(m2.value ?? null, T) : true;
  }, y2 = (f, T = true) => (i.value.enabled || t.weekPicker) && Array.isArray(e.value) && e.value.length === 2 ? t.hideOffsetDates && !f.current ? false : De(j(f.value), e.value[T ? 0 : 1]) : i.value.enabled ? N(f, T) && S2(T) || De(f.value, Array.isArray(e.value) ? e.value[0] : null) && H2(T) : false, F = (f, T) => {
    if (Array.isArray(e.value) && e.value[0] && e.value.length === 1) {
      const Q2 = De(f.value, m2.value);
      return T ? Be(e.value[0], f.value) && Q2 : _e(e.value[0], f.value) && Q2;
    }
    return false;
  }, P = (f) => !e.value || t.hideOffsetDates && !f.current ? false : i.value.enabled ? t.modelAuto && Array.isArray(e.value) ? De(f.value, e.value[0] ? e.value[0] : E2.value) : false : a.value.enabled && Array.isArray(e.value) ? e.value.some((T) => De(T, f.value)) : De(f.value, e.value ? e.value : E2.value), J = (f) => {
    if (i.value.autoRange || t.weekPicker) {
      if (m2.value) {
        if (t.hideOffsetDates && !f.current) return false;
        const T = addDays(m2.value, +i.value.autoRange), Q2 = it(j(m2.value), t.weekStart);
        return t.weekPicker ? De(Q2[1], j(f.value)) : De(T, j(f.value));
      }
      return false;
    }
    return false;
  }, Z2 = (f) => {
    if (i.value.autoRange || t.weekPicker) {
      if (m2.value) {
        const T = addDays(m2.value, +i.value.autoRange);
        if (t.hideOffsetDates && !f.current) return false;
        const Q2 = it(j(m2.value), t.weekStart);
        return t.weekPicker ? Be(f.value, Q2[0]) && _e(f.value, Q2[1]) : Be(f.value, m2.value) && _e(f.value, T);
      }
      return false;
    }
    return false;
  }, le2 = (f) => {
    if (i.value.autoRange || t.weekPicker) {
      if (m2.value) {
        if (t.hideOffsetDates && !f.current) return false;
        const T = it(j(m2.value), t.weekStart);
        return t.weekPicker ? De(T[0], f.value) : De(m2.value, f.value);
      }
      return false;
    }
    return false;
  }, q2 = (f) => da(e.value, m2.value, f.value), R = () => t.modelAuto && Array.isArray(t.internalModelValue) ? !!t.internalModelValue[0] : false, re2 = () => t.modelAuto ? Mn(t.internalModelValue) : true, B2 = (f) => {
    if (t.weekPicker) return false;
    const T = i.value.enabled ? !y2(f) && !y2(f, false) : true;
    return !L(f.value) && !P(f) && !(!f.current && t.hideOffsetDates) && T;
  }, K2 = (f) => i.value.enabled ? t.modelAuto ? R() && P(f) : false : P(f), fe2 = (f) => c2.value ? kl(f.value, b2.value.highlight) : false, ce2 = (f) => {
    const T = L(f.value);
    return T && (typeof c2.value == "function" ? !c2.value(f.value, T) : !c2.value.options.highlightDisabled);
  }, O = (f) => {
    var T;
    return typeof c2.value == "function" ? c2.value(f.value) : (T = c2.value.weekdays) == null ? void 0 : T.includes(f.value.getDay());
  }, A = (f) => (i.value.enabled || t.weekPicker) && (!(l.value.count > 0) || f.current) && re2() && !(!f.current && t.hideOffsetDates) && !P(f) ? q2(f) : false, w = (f) => {
    const { isRangeStart: T, isRangeEnd: Q2 } = ee2(f), s = i.value.enabled ? T || Q2 : false;
    return {
      dp__cell_offset: !f.current,
      dp__pointer: !t.disabled && !(!f.current && t.hideOffsetDates) && !L(f.value),
      dp__cell_disabled: L(f.value),
      dp__cell_highlight: !ce2(f) && (fe2(f) || O(f)) && !K2(f) && !s && !le2(f) && !(A(f) && t.weekPicker) && !Q2,
      dp__cell_highlight_active: !ce2(f) && (fe2(f) || O(f)) && K2(f),
      dp__today: !t.noToday && De(f.value, E2.value) && f.current,
      "dp--past": _e(f.value, E2.value),
      "dp--future": Be(f.value, E2.value)
    };
  }, o = (f) => ({
    dp__active_date: K2(f),
    dp__date_hover: B2(f)
  }), z2 = (f) => {
    if (e.value && !Array.isArray(e.value)) {
      const T = it(e.value, t.weekStart);
      return {
        ...u(f),
        dp__range_start: De(T[0], f.value),
        dp__range_end: De(T[1], f.value),
        dp__range_between_week: Be(f.value, T[0]) && _e(f.value, T[1])
      };
    }
    return {
      ...u(f)
    };
  }, D = (f) => {
    if (e.value && Array.isArray(e.value)) {
      const T = it(e.value[0], t.weekStart), Q2 = e.value[1] ? it(e.value[1], t.weekStart) : [];
      return {
        ...u(f),
        dp__range_start: De(T[0], f.value) || De(Q2[0], f.value),
        dp__range_end: De(T[1], f.value) || De(Q2[1], f.value),
        dp__range_between_week: Be(f.value, T[0]) && _e(f.value, T[1]) || Be(f.value, Q2[0]) && _e(f.value, Q2[1]),
        dp__range_between: Be(f.value, T[1]) && _e(f.value, Q2[0])
      };
    }
    return {
      ...u(f)
    };
  }, ee2 = (f) => {
    const T = l.value.count > 0 ? f.current && y2(f) && re2() : y2(f) && re2(), Q2 = l.value.count > 0 ? f.current && y2(f, false) && re2() : y2(f, false) && re2();
    return { isRangeStart: T, isRangeEnd: Q2 };
  }, de2 = (f) => {
    const { isRangeStart: T, isRangeEnd: Q2 } = ee2(f);
    return {
      dp__range_start: T,
      dp__range_end: Q2,
      dp__range_between: A(f),
      dp__date_hover: De(f.value, m2.value) && !T && !Q2 && !t.weekPicker,
      dp__date_hover_start: F(f, true),
      dp__date_hover_end: F(f, false)
    };
  }, u = (f) => ({
    ...de2(f),
    dp__cell_auto_range: Z2(f),
    dp__cell_auto_range_start: le2(f),
    dp__cell_auto_range_end: J(f)
  }), I = (f) => i.value.enabled ? i.value.autoRange ? u(f) : t.modelAuto ? { ...o(f), ...de2(f) } : t.weekPicker ? D(f) : de2(f) : t.weekPicker ? z2(f) : o(f);
  return {
    setHoverDate: k2,
    clearHoverDate: _2,
    getDayClassData: (f) => t.hideOffsetDates && !f.current ? {} : {
      ...w(f),
      ...I(f),
      [t.dayClass ? t.dayClass(f.value, t.internalModelValue) : ""]: true,
      [t.calendarCellClassName]: !!t.calendarCellClassName,
      ...n2.value.calendarCell ?? {}
    }
  };
}, kt = (e) => {
  const { defaultedFilters: t, defaultedRange: l, propDates: a, defaultedMultiDates: n2 } = Ce(e), c2 = (O) => a.value.disabledDates ? typeof a.value.disabledDates == "function" ? a.value.disabledDates(j(O)) : !!sa(O, a.value.disabledDates) : false, v = (O) => a.value.maxDate ? e.yearPicker ? getYear(O) > getYear(a.value.maxDate) : Be(O, a.value.maxDate) : false, b2 = (O) => a.value.minDate ? e.yearPicker ? getYear(O) < getYear(a.value.minDate) : _e(O, a.value.minDate) : false, i = (O) => {
    const A = v(O), w = b2(O), o = c2(O), D = t.value.months.map((se) => +se).includes(getMonth(O)), ee2 = e.disabledWeekDays.length ? e.disabledWeekDays.some((se) => +se === getDay(O)) : false, de2 = _2(O), u = getYear(O), I = u < +e.yearRange[0] || u > +e.yearRange[1];
    return !(A || w || o || D || I || ee2 || de2);
  }, L = (O, A) => _e(...gt(a.value.minDate, O, A)) || De(...gt(a.value.minDate, O, A)), m2 = (O, A) => Be(...gt(a.value.maxDate, O, A)) || De(...gt(a.value.maxDate, O, A)), E2 = (O, A, w) => {
    let o = false;
    return a.value.maxDate && w && m2(O, A) && (o = true), a.value.minDate && !w && L(O, A) && (o = true), o;
  }, k2 = (O, A, w, o) => {
    let z2 = false;
    return o ? a.value.minDate && a.value.maxDate ? z2 = E2(O, A, w) : (a.value.minDate && L(O, A) || a.value.maxDate && m2(O, A)) && (z2 = true) : z2 = true, z2;
  }, _2 = (O) => Array.isArray(a.value.allowedDates) && !a.value.allowedDates.length ? true : a.value.allowedDates ? !sa(O, a.value.allowedDates) : false, H2 = (O) => !i(O), N = (O) => l.value.noDisabledRange ? !eachDayOfInterval({ start: O[0], end: O[1] }).some((w) => H2(w)) : true, S2 = (O) => {
    if (O) {
      const A = getYear(O);
      return A >= +e.yearRange[0] && A <= e.yearRange[1];
    }
    return true;
  }, y2 = (O, A) => !!(Array.isArray(O) && O[A] && (l.value.maxRange || l.value.minRange) && S2(O[A])), F = (O, A, w = 0) => {
    if (y2(A, w) && S2(O)) {
      const o = differenceInCalendarDays(O, A[w]), z2 = Pn(A[w], O), D = z2.length === 1 ? 0 : z2.filter((de2) => H2(de2)).length, ee2 = Math.abs(o) - (l.value.minMaxRawRange ? 0 : D);
      if (l.value.minRange && l.value.maxRange)
        return ee2 >= +l.value.minRange && ee2 <= +l.value.maxRange;
      if (l.value.minRange) return ee2 >= +l.value.minRange;
      if (l.value.maxRange) return ee2 <= +l.value.maxRange;
    }
    return true;
  }, P = () => !e.enableTimePicker || e.monthPicker || e.yearPicker || e.ignoreTimeValidation, J = (O) => Array.isArray(O) ? [O[0] ? Pa(O[0]) : null, O[1] ? Pa(O[1]) : null] : Pa(O), Z2 = (O, A, w) => O.find(
    (o) => +o.hours === getHours(A) && o.minutes === "*" ? true : +o.minutes === getMinutes(A) && +o.hours === getHours(A)
  ) && w, le2 = (O, A, w) => {
    const [o, z2] = O, [D, ee2] = A;
    return !Z2(o, D, w) && !Z2(z2, ee2, w) && w;
  }, q2 = (O, A) => {
    const w = Array.isArray(A) ? A : [A];
    return Array.isArray(e.disabledTimes) ? Array.isArray(e.disabledTimes[0]) ? le2(e.disabledTimes, w, O) : !w.some((o) => Z2(e.disabledTimes, o, O)) : O;
  }, R = (O, A) => {
    const w = Array.isArray(A) ? [St(A[0]), A[1] ? St(A[1]) : void 0] : St(A), o = !e.disabledTimes(w);
    return O && o;
  }, re2 = (O, A) => e.disabledTimes ? Array.isArray(e.disabledTimes) ? q2(A, O) : R(A, O) : A, B2 = (O) => {
    let A = true;
    if (!O || P()) return true;
    const w = !a.value.minDate && !a.value.maxDate ? J(O) : O;
    return (e.maxTime || a.value.maxDate) && (A = sn(
      e.maxTime,
      a.value.maxDate,
      "max",
      Ye(w),
      A
    )), (e.minTime || a.value.minDate) && (A = sn(
      e.minTime,
      a.value.minDate,
      "min",
      Ye(w),
      A
    )), re2(O, A);
  }, K2 = (O) => {
    if (!e.monthPicker) return true;
    let A = true;
    const w = j(lt(O));
    if (a.value.minDate && a.value.maxDate) {
      const o = j(lt(a.value.minDate)), z2 = j(lt(a.value.maxDate));
      return Be(w, o) && _e(w, z2) || De(w, o) || De(w, z2);
    }
    if (a.value.minDate) {
      const o = j(lt(a.value.minDate));
      A = Be(w, o) || De(w, o);
    }
    if (a.value.maxDate) {
      const o = j(lt(a.value.maxDate));
      A = _e(w, o) || De(w, o);
    }
    return A;
  }, fe2 = computed(() => (O) => !e.enableTimePicker || e.ignoreTimeValidation ? true : B2(O)), ce2 = computed(() => (O) => e.monthPicker ? Array.isArray(O) && (l.value.enabled || n2.value.enabled) ? !O.filter((w) => !K2(w)).length : K2(O) : true);
  return {
    isDisabled: H2,
    validateDate: i,
    validateMonthYearInRange: k2,
    isDateRangeAllowed: N,
    checkMinMaxRange: F,
    isValidTime: B2,
    isTimeValid: fe2,
    isMonthValid: ce2
  };
}, ma = () => {
  const e = computed(() => (a, n2) => a == null ? void 0 : a.includes(n2)), t = computed(() => (a, n2) => a.count ? a.solo ? true : n2 === 0 : true), l = computed(() => (a, n2) => a.count ? a.solo ? true : n2 === a.count - 1 : true);
  return { hideNavigationButtons: e, showLeftIcon: t, showRightIcon: l };
}, lo = (e, t, l) => {
  const a = ref(0), n2 = reactive({
    [Tt.timePicker]: !e.enableTimePicker || e.timePicker || e.monthPicker,
    [Tt.calendar]: false,
    [Tt.header]: false
  }), c2 = computed(() => e.monthPicker || e.timePicker), v = (E2) => {
    var k2;
    if ((k2 = e.flow) != null && k2.length) {
      if (!E2 && c2.value) return m2();
      n2[E2] = true, Object.keys(n2).filter((_2) => !n2[_2]).length || m2();
    }
  }, b2 = () => {
    var E2, k2;
    (E2 = e.flow) != null && E2.length && a.value !== -1 && (a.value += 1, t("flow-step", a.value), m2()), ((k2 = e.flow) == null ? void 0 : k2.length) === a.value && nextTick().then(() => i());
  }, i = () => {
    a.value = -1;
  }, L = (E2, k2, ..._2) => {
    var H2, N;
    e.flow[a.value] === E2 && l.value && ((N = (H2 = l.value)[k2]) == null || N.call(H2, ..._2));
  }, m2 = (E2 = 0) => {
    E2 && (a.value += E2), L(He.month, "toggleMonthPicker", true), L(He.year, "toggleYearPicker", true), L(He.calendar, "toggleTimePicker", false, true), L(He.time, "toggleTimePicker", true, true);
    const k2 = e.flow[a.value];
    (k2 === He.hours || k2 === He.minutes || k2 === He.seconds) && L(k2, "toggleTimePicker", true, true, k2);
  };
  return { childMount: v, updateFlowStep: b2, resetFlow: i, handleFlow: m2, flowStep: a };
}, ro = {
  key: 1,
  class: "dp__input_wrap"
}, oo = ["id", "name", "inputmode", "placeholder", "disabled", "readonly", "required", "value", "autocomplete", "aria-label", "aria-disabled", "aria-invalid"], so = {
  key: 2,
  class: "dp__clear_icon"
}, uo = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "DatepickerInput",
  props: {
    isMenuOpen: { type: Boolean, default: false },
    inputValue: { type: String, default: "" },
    ...ca
  },
  emits: [
    "clear",
    "open",
    "update:input-value",
    "set-input-date",
    "close",
    "select-date",
    "set-empty-date",
    "toggle",
    "focus-prev",
    "focus",
    "blur",
    "real-blur"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, {
      defaultedTextInput: c2,
      defaultedAriaLabels: v,
      defaultedInline: b2,
      defaultedConfig: i,
      defaultedRange: L,
      defaultedMultiDates: m2,
      defaultedUI: E2,
      getDefaultPattern: k2,
      getDefaultStartTime: _2
    } = Ce(n2), { checkMinMaxRange: H2 } = kt(n2), N = ref(), S2 = ref(null), y2 = ref(false), F = ref(false), P = computed(
      () => ({
        dp__pointer: !n2.disabled && !n2.readonly && !c2.value.enabled,
        dp__disabled: n2.disabled,
        dp__input_readonly: !c2.value.enabled,
        dp__input: true,
        dp__input_icon_pad: !n2.hideInputIcon,
        dp__input_valid: !!n2.state,
        dp__input_invalid: n2.state === false,
        dp__input_focus: y2.value || n2.isMenuOpen,
        dp__input_reg: !c2.value.enabled,
        [n2.inputClassName]: !!n2.inputClassName,
        ...E2.value.input ?? {}
      })
    ), J = () => {
      a("set-input-date", null), n2.clearable && n2.autoApply && (a("set-empty-date"), N.value = null);
    }, Z2 = (D) => {
      const ee2 = _2();
      return wl(
        D,
        c2.value.format ?? k2(),
        ee2 ?? Rn({}, n2.enableSeconds),
        n2.inputValue,
        F.value,
        n2.formatLocale
      );
    }, le2 = (D) => {
      const { rangeSeparator: ee2 } = c2.value, [de2, u] = D.split(`${ee2}`);
      if (de2) {
        const I = Z2(de2.trim()), se = u ? Z2(u.trim()) : null;
        if (isAfter(I, se)) return;
        const f = I && se ? [I, se] : [I];
        H2(se, f, 0) && (N.value = I ? f : null);
      }
    }, q2 = () => {
      F.value = true;
    }, R = (D) => {
      if (L.value.enabled)
        le2(D);
      else if (m2.value.enabled) {
        const ee2 = D.split(";");
        N.value = ee2.map((de2) => Z2(de2.trim())).filter((de2) => de2);
      } else
        N.value = Z2(D);
    }, re2 = (D) => {
      var de2;
      const ee2 = typeof D == "string" ? D : (de2 = D.target) == null ? void 0 : de2.value;
      ee2 !== "" ? (c2.value.openMenu && !n2.isMenuOpen && a("open"), R(ee2), a("set-input-date", N.value)) : J(), F.value = false, a("update:input-value", ee2);
    }, B2 = (D) => {
      c2.value.enabled ? (R(D.target.value), c2.value.enterSubmit && Ea(N.value) && n2.inputValue !== "" ? (a("set-input-date", N.value, true), N.value = null) : c2.value.enterSubmit && n2.inputValue === "" && (N.value = null, a("clear"))) : ce2(D);
    }, K2 = (D) => {
      c2.value.enabled && c2.value.tabSubmit && R(D.target.value), c2.value.tabSubmit && Ea(N.value) && n2.inputValue !== "" ? (a("set-input-date", N.value, true, true), N.value = null) : c2.value.tabSubmit && n2.inputValue === "" && (N.value = null, a("clear", true));
    }, fe2 = () => {
      y2.value = true, a("focus"), nextTick().then(() => {
        var D;
        c2.value.enabled && c2.value.selectOnFocus && ((D = S2.value) == null || D.select());
      });
    }, ce2 = (D) => {
      D.preventDefault(), yt(D, i.value, true), c2.value.enabled && c2.value.openMenu && !b2.value.input && !n2.isMenuOpen ? a("open") : c2.value.enabled || a("toggle");
    }, O = () => {
      a("real-blur"), y2.value = false, (!n2.isMenuOpen || b2.value.enabled && b2.value.input) && a("blur"), n2.autoApply && c2.value.enabled && N.value && !n2.isMenuOpen && (a("set-input-date", N.value), a("select-date"), N.value = null);
    }, A = (D) => {
      yt(D, i.value, true), a("clear");
    }, w = (D) => {
      if (D.key === "Tab" && K2(D), D.key === "Enter" && B2(D), !c2.value.enabled) {
        if (D.code === "Tab") return;
        D.preventDefault();
      }
    };
    return t({
      focusInput: () => {
        var D;
        (D = S2.value) == null || D.focus({ preventScroll: true });
      },
      setParsedDate: (D) => {
        N.value = D;
      }
    }), (D, ee2) => {
      var de2;
      return openBlock(), createElementBlock("div", { onClick: ce2 }, [
        D.$slots.trigger && !D.$slots["dp-input"] && !unref(b2).enabled ? renderSlot(D.$slots, "trigger", { key: 0 }) : createCommentVNode("", true),
        !D.$slots.trigger && (!unref(b2).enabled || unref(b2).input) ? (openBlock(), createElementBlock("div", ro, [
          D.$slots["dp-input"] && !D.$slots.trigger && (!unref(b2).enabled || unref(b2).enabled && unref(b2).input) ? renderSlot(D.$slots, "dp-input", {
            key: 0,
            value: e.inputValue,
            isMenuOpen: e.isMenuOpen,
            onInput: re2,
            onEnter: B2,
            onTab: K2,
            onClear: A,
            onBlur: O,
            onKeypress: w,
            onPaste: q2,
            onFocus: fe2,
            openMenu: () => D.$emit("open"),
            closeMenu: () => D.$emit("close"),
            toggleMenu: () => D.$emit("toggle")
          }) : createCommentVNode("", true),
          D.$slots["dp-input"] ? createCommentVNode("", true) : (openBlock(), createElementBlock("input", {
            key: 1,
            id: D.uid ? `dp-input-${D.uid}` : void 0,
            ref_key: "inputRef",
            ref: S2,
            "data-test": "dp-input",
            name: D.name,
            class: normalizeClass(P.value),
            inputmode: unref(c2).enabled ? "text" : "none",
            placeholder: D.placeholder,
            disabled: D.disabled,
            readonly: D.readonly,
            required: D.required,
            value: e.inputValue,
            autocomplete: D.autocomplete,
            "aria-label": (de2 = unref(v)) == null ? void 0 : de2.input,
            "aria-disabled": D.disabled || void 0,
            "aria-invalid": D.state === false ? true : void 0,
            onInput: re2,
            onBlur: O,
            onFocus: fe2,
            onKeypress: w,
            onKeydown: w,
            onPaste: q2
          }, null, 42, oo)),
          createElementVNode("div", {
            onClick: ee2[2] || (ee2[2] = (u) => a("toggle"))
          }, [
            D.$slots["input-icon"] && !D.hideInputIcon ? (openBlock(), createElementBlock("span", {
              key: 0,
              class: "dp__input_icon",
              onClick: ee2[0] || (ee2[0] = (u) => a("toggle"))
            }, [
              renderSlot(D.$slots, "input-icon")
            ])) : createCommentVNode("", true),
            !D.$slots["input-icon"] && !D.hideInputIcon && !D.$slots["dp-input"] ? (openBlock(), createBlock(unref(Et), {
              key: 1,
              class: "dp__input_icon dp__input_icons",
              onClick: ee2[1] || (ee2[1] = (u) => a("toggle"))
            })) : createCommentVNode("", true)
          ]),
          D.$slots["clear-icon"] && e.inputValue && D.clearable && !D.disabled && !D.readonly ? (openBlock(), createElementBlock("span", so, [
            renderSlot(D.$slots, "clear-icon", { clear: A })
          ])) : createCommentVNode("", true),
          D.clearable && !D.$slots["clear-icon"] && e.inputValue && !D.disabled && !D.readonly ? (openBlock(), createBlock(unref(wn), {
            key: 3,
            class: "dp__clear_icon dp__input_icons",
            "data-test": "clear-icon",
            onClick: ee2[3] || (ee2[3] = withModifiers((u) => A(u), ["prevent"]))
          })) : createCommentVNode("", true)
        ])) : createCommentVNode("", true)
      ]);
    };
  }
}), io = typeof window < "u" ? window : void 0, Ya = () => {
}, co = (e) => getCurrentScope() ? (onScopeDispose(e), true) : false, fo = (e, t, l, a) => {
  if (!e) return Ya;
  let n2 = Ya;
  const c2 = watch(
    () => unref(e),
    (b2) => {
      n2(), b2 && (b2.addEventListener(t, l, a), n2 = () => {
        b2.removeEventListener(t, l, a), n2 = Ya;
      });
    },
    { immediate: true, flush: "post" }
  ), v = () => {
    c2(), n2();
  };
  return co(v), v;
}, vo = (e, t, l, a = {}) => {
  const { window: n2 = io, event: c2 = "pointerdown" } = a;
  return n2 ? fo(n2, c2, (b2) => {
    const i = Ie(e), L = Ie(t);
    !i || !L || i === b2.target || b2.composedPath().includes(i) || b2.composedPath().includes(L) || l(b2);
  }, { passive: true }) : void 0;
}, mo = /* @__PURE__ */ defineComponent({
  compatConfig: {
    MODE: 3
  },
  __name: "VueDatePicker",
  props: {
    ...ca
  },
  emits: [
    "update:model-value",
    "update:model-timezone-value",
    "text-submit",
    "closed",
    "cleared",
    "open",
    "focus",
    "blur",
    "internal-model-change",
    "recalculate-position",
    "flow-step",
    "update-month-year",
    "invalid-select",
    "invalid-fixed-range",
    "tooltip-open",
    "tooltip-close",
    "time-picker-open",
    "time-picker-close",
    "am-pm-change",
    "range-start",
    "range-end",
    "date-update",
    "invalid-date",
    "overlay-toggle"
  ],
  setup(e, { expose: t, emit: l }) {
    const a = l, n2 = e, c2 = useSlots(), v = ref(false), b2 = toRef(n2, "modelValue"), i = toRef(n2, "timezone"), L = ref(null), m2 = ref(null), E2 = ref(null), k2 = ref(false), _2 = ref(null), H2 = ref(false), N = ref(false), S2 = ref(false), y2 = ref(false), { setMenuFocused: F, setShiftKey: P } = Yn(), { clearArrowNav: J } = bt(), { validateDate: Z2, isValidTime: le2 } = kt(n2), {
      defaultedTransitions: q2,
      defaultedTextInput: R,
      defaultedInline: re2,
      defaultedConfig: B2,
      defaultedRange: K2,
      defaultedMultiDates: fe2
    } = Ce(n2), { menuTransition: ce2, showTransition: O } = Xt(q2);
    onMounted(() => {
      f(n2.modelValue), nextTick().then(() => {
        if (!re2.value.enabled) {
          const g2 = de2(_2.value);
          g2 == null || g2.addEventListener("scroll", C2), window == null || window.addEventListener("resize", te2);
        }
      }), re2.value.enabled && (v.value = true), window == null || window.addEventListener("keyup", ue2), window == null || window.addEventListener("keydown", p);
    }), onUnmounted(() => {
      if (!re2.value.enabled) {
        const g2 = de2(_2.value);
        g2 == null || g2.removeEventListener("scroll", C2), window == null || window.removeEventListener("resize", te2);
      }
      window == null || window.removeEventListener("keyup", ue2), window == null || window.removeEventListener("keydown", p);
    });
    const A = Ze(c2, "all", n2.presetDates), w = Ze(c2, "input");
    watch(
      [b2, i],
      () => {
        f(b2.value);
      },
      { deep: true }
    );
    const { openOnTop: o, menuStyle: z2, xCorrect: D, setMenuPosition: ee2, getScrollableParent: de2, shadowRender: u } = eo({
      menuRef: L,
      menuRefInner: m2,
      inputRef: E2,
      pickerWrapperRef: _2,
      inline: re2,
      emit: a,
      props: n2,
      slots: c2
    }), {
      inputValue: I,
      internalModelValue: se,
      parseExternalModelValue: f,
      emitModelValue: T,
      formatInputValue: Q2,
      checkBeforeEmit: s
    } = jl(a, n2, k2), oe2 = computed(
      () => ({
        dp__main: true,
        dp__theme_dark: n2.dark,
        dp__theme_light: !n2.dark,
        dp__flex_display: re2.value.enabled,
        "dp--flex-display-collapsed": S2.value,
        dp__flex_display_with_input: re2.value.input
      })
    ), M = computed(() => n2.dark ? "dp__theme_dark" : "dp__theme_light"), me2 = computed(() => n2.teleport ? {
      to: typeof n2.teleport == "boolean" ? "body" : n2.teleport,
      disabled: !n2.teleport || re2.value.enabled
    } : {}), d2 = computed(() => ({ class: "dp__outer_menu_wrap" })), Y2 = computed(() => re2.value.enabled && (n2.timePicker || n2.monthPicker || n2.yearPicker || n2.quarterPicker)), W = () => {
      var g2, U;
      return (U = (g2 = E2.value) == null ? void 0 : g2.$el) == null ? void 0 : U.getBoundingClientRect();
    }, C2 = () => {
      v.value && (B2.value.closeOnScroll ? Je() : ee2());
    }, te2 = () => {
      var U;
      v.value && ee2();
      const g2 = (U = m2.value) == null ? void 0 : U.$el.getBoundingClientRect().width;
      S2.value = document.body.offsetWidth <= g2;
    }, ue2 = (g2) => {
      g2.key === "Tab" && !re2.value.enabled && !n2.teleport && B2.value.tabOutClosesMenu && (_2.value.contains(document.activeElement) || Je()), N.value = g2.shiftKey;
    }, p = (g2) => {
      N.value = g2.shiftKey;
    }, V = () => {
      !n2.disabled && !n2.readonly && (u(fn, n2), ee2(false), v.value = true, v.value && a("open"), v.value || Ft(), f(n2.modelValue));
    }, pe2 = () => {
      var g2;
      I.value = "", Ft(), (g2 = E2.value) == null || g2.setParsedDate(null), a("update:model-value", null), a("update:model-timezone-value", null), a("cleared"), B2.value.closeOnClearValue && Je();
    }, $e = () => {
      const g2 = se.value;
      return !g2 || !Array.isArray(g2) && Z2(g2) ? true : Array.isArray(g2) ? fe2.value.enabled || g2.length === 2 && Z2(g2[0]) && Z2(g2[1]) ? true : K2.value.partialRange && !n2.timePicker ? Z2(g2[0]) : false : false;
    }, Ge = () => {
      s() && $e() ? (T(), Je()) : a("invalid-select", se.value);
    }, ve = (g2) => {
      vt2(), T(), B2.value.closeOnAutoApply && !g2 && Je();
    }, vt2 = () => {
      E2.value && R.value.enabled && E2.value.setParsedDate(se.value);
    }, ot2 = (g2 = false) => {
      n2.autoApply && le2(se.value) && $e() && (K2.value.enabled && Array.isArray(se.value) ? (K2.value.partialRange || se.value.length === 2) && ve(g2) : ve(g2));
    }, Ft = () => {
      R.value.enabled || (se.value = null);
    }, Je = () => {
      re2.value.enabled || (v.value && (v.value = false, D.value = false, F(false), P(false), J(), a("closed"), I.value && f(b2.value)), Ft(), a("blur"));
    }, Lt = (g2, U, ne = false) => {
      if (!g2) {
        se.value = null;
        return;
      }
      const Ae2 = Array.isArray(g2) ? !g2.some((wt2) => !Z2(wt2)) : Z2(g2), Fe = le2(g2);
      Ae2 && Fe && (y2.value = true, se.value = g2, U && (H2.value = ne, Ge(), a("text-submit")), nextTick().then(() => {
        y2.value = false;
      }));
    }, ga = () => {
      n2.autoApply && le2(se.value) && T(), vt2();
    }, Zt = () => v.value ? Je() : V(), ya = (g2) => {
      se.value = g2;
    }, pa = () => {
      R.value.enabled && (k2.value = true, Q2()), a("focus");
    }, ha = () => {
      if (R.value.enabled && (k2.value = false, f(n2.modelValue), H2.value)) {
        const g2 = hl(_2.value, N.value);
        g2 == null || g2.focus();
      }
      a("blur");
    }, ba = (g2) => {
      m2.value && m2.value.updateMonthYear(0, {
        month: ln(g2.month),
        year: ln(g2.year)
      });
    }, ka = (g2) => {
      f(g2 ?? n2.modelValue);
    }, wa = (g2, U) => {
      var ne;
      (ne = m2.value) == null || ne.switchView(g2, U);
    }, Ja = (g2) => B2.value.onClickOutside ? B2.value.onClickOutside(g2) : Je(), h2 = (g2 = 0) => {
      var U;
      (U = m2.value) == null || U.handleFlow(g2);
    };
    return vo(L, E2, () => Ja($e)), t({
      closeMenu: Je,
      selectDate: Ge,
      clearValue: pe2,
      openMenu: V,
      onScroll: C2,
      formatInputValue: Q2,
      // exposed for testing purposes
      updateInternalModelValue: ya,
      // modify internal modelValue
      setMonthYear: ba,
      parseModel: ka,
      switchView: wa,
      toggleMenu: Zt,
      handleFlow: h2
    }), (g2, U) => (openBlock(), createElementBlock("div", {
      ref_key: "pickerWrapperRef",
      ref: _2,
      class: normalizeClass(oe2.value),
      "data-datepicker-instance": ""
    }, [
      createVNode(uo, mergeProps({
        ref_key: "inputRef",
        ref: E2,
        "input-value": unref(I),
        "onUpdate:inputValue": U[0] || (U[0] = (ne) => isRef(I) ? I.value = ne : null),
        "is-menu-open": v.value
      }, g2.$props, {
        onClear: pe2,
        onOpen: V,
        onSetInputDate: Lt,
        onSetEmptyDate: unref(T),
        onSelectDate: Ge,
        onToggle: Zt,
        onClose: Je,
        onFocus: pa,
        onBlur: ha,
        onRealBlur: U[1] || (U[1] = (ne) => k2.value = false)
      }), createSlots({ _: 2 }, [
        renderList(unref(w), (ne, Ae2) => ({
          name: ne,
          fn: withCtx((Fe) => [
            renderSlot(g2.$slots, ne, normalizeProps(guardReactiveProps(Fe)))
          ])
        }))
      ]), 1040, ["input-value", "is-menu-open", "onSetEmptyDate"]),
      (openBlock(), createBlock(resolveDynamicComponent(g2.teleport ? Teleport : "div"), normalizeProps(guardReactiveProps(me2.value)), {
        default: withCtx(() => [
          createVNode(Transition, {
            name: unref(ce2)(unref(o)),
            css: unref(O) && !unref(re2).enabled
          }, {
            default: withCtx(() => [
              v.value ? (openBlock(), createElementBlock("div", mergeProps({
                key: 0,
                ref_key: "dpWrapMenuRef",
                ref: L
              }, d2.value, {
                class: { "dp--menu-wrapper": !unref(re2).enabled },
                style: unref(re2).enabled ? void 0 : unref(z2)
              }), [
                createVNode(fn, mergeProps({
                  ref_key: "dpMenuRef",
                  ref: m2
                }, g2.$props, {
                  "internal-model-value": unref(se),
                  "onUpdate:internalModelValue": U[2] || (U[2] = (ne) => isRef(se) ? se.value = ne : null),
                  class: { [M.value]: true, "dp--menu-wrapper": g2.teleport },
                  "open-on-top": unref(o),
                  "no-overlay-focus": Y2.value,
                  collapse: S2.value,
                  "get-input-rect": W,
                  "is-text-input-date": y2.value,
                  onClosePicker: Je,
                  onSelectDate: Ge,
                  onAutoApply: ot2,
                  onTimeUpdate: ga,
                  onFlowStep: U[3] || (U[3] = (ne) => g2.$emit("flow-step", ne)),
                  onUpdateMonthYear: U[4] || (U[4] = (ne) => g2.$emit("update-month-year", ne)),
                  onInvalidSelect: U[5] || (U[5] = (ne) => g2.$emit("invalid-select", unref(se))),
                  onAutoApplyInvalid: U[6] || (U[6] = (ne) => g2.$emit("invalid-select", ne)),
                  onInvalidFixedRange: U[7] || (U[7] = (ne) => g2.$emit("invalid-fixed-range", ne)),
                  onRecalculatePosition: unref(ee2),
                  onTooltipOpen: U[8] || (U[8] = (ne) => g2.$emit("tooltip-open", ne)),
                  onTooltipClose: U[9] || (U[9] = (ne) => g2.$emit("tooltip-close", ne)),
                  onTimePickerOpen: U[10] || (U[10] = (ne) => g2.$emit("time-picker-open", ne)),
                  onTimePickerClose: U[11] || (U[11] = (ne) => g2.$emit("time-picker-close", ne)),
                  onAmPmChange: U[12] || (U[12] = (ne) => g2.$emit("am-pm-change", ne)),
                  onRangeStart: U[13] || (U[13] = (ne) => g2.$emit("range-start", ne)),
                  onRangeEnd: U[14] || (U[14] = (ne) => g2.$emit("range-end", ne)),
                  onDateUpdate: U[15] || (U[15] = (ne) => g2.$emit("date-update", ne)),
                  onInvalidDate: U[16] || (U[16] = (ne) => g2.$emit("invalid-date", ne)),
                  onOverlayToggle: U[17] || (U[17] = (ne) => g2.$emit("overlay-toggle", ne))
                }), createSlots({ _: 2 }, [
                  renderList(unref(A), (ne, Ae2) => ({
                    name: ne,
                    fn: withCtx((Fe) => [
                      renderSlot(g2.$slots, ne, normalizeProps(guardReactiveProps({ ...Fe })))
                    ])
                  }))
                ]), 1040, ["internal-model-value", "class", "open-on-top", "no-overlay-focus", "collapse", "is-text-input-date", "onRecalculatePosition"])
              ], 16)) : createCommentVNode("", true)
            ]),
            _: 3
          }, 8, ["name", "css"])
        ]),
        _: 3
      }, 16))
    ], 2));
  }
}), Hn = /* @__PURE__ */ (() => {
  const e = mo;
  return e.install = (t) => {
    t.component("Vue3DatePicker", e);
  }, e;
})(), go = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: Hn
}, Symbol.toStringTag, { value: "Module" }));
Object.entries(go).forEach(([e, t]) => {
  e !== "default" && (Hn[e] = t);
});
const _sfc_main$K = /* @__PURE__ */ defineComponent({
  __name: "DateInput",
  props: {
    required: { type: Boolean, required: false },
    label: { type: String, required: false },
    editMode: { type: Boolean, required: false, default: true },
    small: { type: Boolean, required: false, default: false },
    enableTime: { type: Boolean, required: false, default: false },
    modelValue: { type: [String, Date], required: false },
    defaultValue: { type: [String, Date], required: false },
    extraProps: { type: Object, required: false },
    allowedDates: { type: Array, required: false },
    timePickerInline: { type: Boolean, required: false },
    minutesIncrement: { type: [String, Number], required: false },
    minutesGridIncrement: { type: [String, Number], required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const datePicker = ref();
    const date2 = computed({
      get: () => props2.modelValue || "",
      set: (val) => {
        const d2 = typeof val === "string" ? new Date(val) : val;
        if (props2.enableTime) {
          emit2("update:modelValue", d2.toISOString());
        } else {
          emit2("update:modelValue", d2.toISOString().split("T")[0]);
        }
      }
    });
    onMounted(() => {
      if (props2.defaultValue && date2.value === "") {
        Object.assign(date2.value, { date: props2.defaultValue });
      }
    });
    const __returned__ = { props: props2, emit: emit2, datePicker, date: date2, get VDatepicker() {
      return Hn;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$B = ["title"];
const _hoisted_2$r = { key: 0 };
function _sfc_render$K(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["bagel-input", { small: $props.small }]),
    title: $props.label
  }, [
    $props.label ? (openBlock(), createElementBlock(
      "label",
      _hoisted_2$r,
      toDisplayString($props.label),
      1
      /* TEXT */
    )) : createCommentVNode("v-if", true),
    createVNode($setup["VDatepicker"], mergeProps({
      ref: "datePicker",
      modelValue: $setup.date,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.date = $event),
      required: $props.required,
      "auto-apply": true,
      "enable-time-picker": $props.enableTime,
      "allowed-dates": $props.allowedDates
    }, $props.extraProps, {
      "time-picker-inline": $props.timePickerInline,
      "minutes-increment": $props.minutesIncrement,
      "minutes-grid-increment": $props.minutesGridIncrement,
      "start-time": { hours: 8, minutes: 0 }
    }), null, 16, ["modelValue", "required", "enable-time-picker", "allowed-dates", "time-picker-inline", "minutes-increment", "minutes-grid-increment"])
  ], 10, _hoisted_1$B);
}
const DateInput = /* @__PURE__ */ _export_sfc(_sfc_main$K, [["render", _sfc_render$K], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/DateInput.vue"]]);
const _sfc_main$J = /* @__PURE__ */ defineComponent({
  __name: "DatePicker",
  props: {
    label: { type: String, required: false },
    id: { type: String, required: false },
    options: { type: Object, required: false },
    showTimeWrap: { type: Boolean, required: false },
    modelValue: { type: Date, required: false },
    allowedDates: { type: Array, required: false },
    disabledDates: { type: Array, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const selectedDate = computed({
      get: () => props2.modelValue || /* @__PURE__ */ new Date(),
      set: (value) => {
        emit2("update:modelValue", value);
      }
    });
    const selectedHour = ref();
    const hours = Array.from({ length: 18 }, (_2, index2) => {
      const hour = Math.floor(index2 / 2) + 9;
      const minute = index2 % 2 === 0 ? "00" : "30";
      return `${hour}:${minute}`;
    });
    const __returned__ = { props: props2, emit: emit2, selectedDate, selectedHour, hours, get VDatepicker() {
      return Hn;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$A = { class: "datetime-wrap" };
const _hoisted_2$q = { class: "date-wrap" };
const _hoisted_3$l = {
  key: 0,
  class: "time-wrap"
};
const _hoisted_4$e = ["id", "name", "value"];
const _hoisted_5$d = ["for"];
function _sfc_render$J(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$A, [
    createElementVNode("div", _hoisted_2$q, [
      createVNode($setup["VDatepicker"], mergeProps({
        modelValue: $setup.selectedDate,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.selectedDate = $event),
        inline: "",
        "week-start": "0",
        "allowed-dates": $props.allowedDates,
        "disabled-dates": $props.disabledDates,
        "auto-apply": true,
        "highlight-week-days": [6],
        "enable-time-picker": false,
        "month-change-on-scroll": false
      }, $props.options), {
        "action-buttons": withCtx(() => _cache[2] || (_cache[2] = [])),
        "action-preview": withCtx(() => _cache[3] || (_cache[3] = [])),
        _: 1
        /* STABLE */
      }, 16, ["modelValue", "allowed-dates", "disabled-dates"])
    ]),
    $props.showTimeWrap ? (openBlock(), createElementBlock("div", _hoisted_3$l, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($setup.hours, (hr2) => {
          return openBlock(), createElementBlock(
            Fragment,
            { key: hr2 },
            [
              withDirectives(createElementVNode("input", {
                id: `${hr2}_${$props.id}`,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.selectedHour = $event),
                type: "radio",
                name: $props.label,
                value: hr2
              }, null, 8, _hoisted_4$e), [
                [vModelRadio, $setup.selectedHour]
              ]),
              createElementVNode("label", {
                for: `${hr2}_${$props.id}`
              }, toDisplayString(hr2), 9, _hoisted_5$d)
            ],
            64
            /* STABLE_FRAGMENT */
          );
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])) : createCommentVNode("v-if", true)
  ]);
}
const DatePicker = /* @__PURE__ */ _export_sfc(_sfc_main$J, [["render", _sfc_render$J], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/DatePicker.vue"]]);
const _sfc_main$I = /* @__PURE__ */ defineComponent({
  __name: "Image",
  props: {
    src: { type: String, required: false },
    pathKey: { type: String, required: false },
    alt: { type: String, required: false, default: "" },
    width: { type: [String, Number], required: false },
    height: { type: [String, Number], required: false },
    caption: { type: String, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    let imageSrc = ref(null);
    const bagel = useBagel();
    const fileBaseUrl = computed(() => (bagel.fileBaseUrl || "https://files.bagel.design").replace(/\/$/, ""));
    const pathToUrl = () => `${fileBaseUrl.value}/${__props.pathKey}`;
    async function loadImage() {
      var _a2;
      const url = __props.src || pathToUrl();
      console.log(url);
      if (!url) {
        imageSrc.value = null;
        return;
      }
      const ext = (_a2 = url.split(".").pop()) == null ? void 0 : _a2.toLowerCase().split("?").shift();
      if (ext === "heic") {
        if (!("caches" in window)) {
          console.warn("Caching is not available. Proceeding without cache.");
        } else {
          try {
            const imgCache = await window.caches.open("img-cache");
            const cachedResponse = await imgCache.match(url);
            if (cachedResponse) {
              imageSrc.value = URL.createObjectURL(await cachedResponse.blob());
              return;
            }
          } catch (error) {
            console.warn("Error accessing cache:", error);
          }
        }
        try {
          await appendScript("https://cdnjs.cloudflare.com/ajax/libs/heic2any/0.0.1/index.min.js");
          const response = await fetch(url);
          const blob = await response.blob();
          const convertedBlob = await window.heic2any({ blob });
          imageSrc.value = URL.createObjectURL(convertedBlob);
          if ("caches" in window) {
            try {
              const imgCache = await window.caches.open("img-cache");
              imgCache.put(url, new Response(convertedBlob));
            } catch (cacheError) {
              console.warn("Failed to cache the image:", cacheError);
            }
          }
        } catch (error) {
          console.error("Error converting HEIC file:", error);
        }
      } else {
        imageSrc.value = url;
      }
    }
    watch(() => [__props.src, __props.pathKey], loadImage, { immediate: true });
    const __returned__ = { get imageSrc() {
      return imageSrc;
    }, set imageSrc(v) {
      imageSrc = v;
    }, bagel, fileBaseUrl, pathToUrl, loadImage, get Skeleton() {
      return Skeleton;
    }, get normalizeDimension() {
      return normalizeDimension;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$z = { key: 0 };
const _hoisted_2$p = ["src", "alt", "width", "height"];
const _hoisted_3$k = ["src", "alt", "width", "height"];
function _sfc_render$I(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.caption ? (openBlock(), createElementBlock("figcaption", _hoisted_1$z, [
    $setup.imageSrc ? (openBlock(), createElementBlock("img", mergeProps({
      key: 0,
      src: $setup.imageSrc
    }, _ctx.$attrs, {
      alt: $props.alt,
      width: $setup.normalizeDimension($props.width),
      height: $setup.normalizeDimension($props.height)
    }), null, 16, _hoisted_2$p)) : (openBlock(), createBlock($setup["Skeleton"], {
      key: 1,
      class: "img-web-kit",
      width: $setup.normalizeDimension($props.width),
      height: $setup.normalizeDimension($props.height)
    }, null, 8, ["width", "height"]))
  ])) : $setup.imageSrc ? (openBlock(), createElementBlock("img", mergeProps({
    key: 1,
    src: $setup.imageSrc
  }, _ctx.$attrs, {
    alt: $props.alt,
    width: $setup.normalizeDimension($props.width),
    height: $setup.normalizeDimension($props.height)
  }), null, 16, _hoisted_3$k)) : (openBlock(), createBlock($setup["Skeleton"], {
    key: 2,
    class: "img-web-kit",
    width: $setup.normalizeDimension($props.width),
    height: $setup.normalizeDimension($props.height)
  }, null, 8, ["width", "height"]));
}
const Image$1 = /* @__PURE__ */ _export_sfc(_sfc_main$I, [["render", _sfc_render$I], ["__scopeId", "data-v-ca72a3d6"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Image.vue"]]);
const _sfc_main$H = /* @__PURE__ */ defineComponent({
  __name: "FileUpload",
  props: /* @__PURE__ */ mergeModels({
    label: { type: String, required: false },
    multiple: { type: Boolean, required: false },
    files: { type: [Object, Array], required: false },
    bindkey: { type: String, required: false, default: "id" },
    modelValue: { type: [Array, String, Number], required: false },
    width: { type: String, required: false },
    height: { type: String, required: false, default: "215px" },
    topic: { type: String, required: false },
    fill: { type: Boolean, required: false },
    oval: { type: Boolean, required: false },
    theme: { type: String, required: false, default: "dropzone" },
    accept: { type: String, required: false, default: "*" },
    required: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false }
  }, {
    "modelValue": {
      default: () => []
    },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:modelValue", "addFileStart"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit2 = __emit;
    const bindKey2 = __props.bindkey;
    const bagel = useBagel();
    const isImage = (str) => IMAGE_FORMATS_REGEXP.test(str);
    const file_bindkeys = useModel(__props, "modelValue");
    const storageFiles = ref([]);
    async function fetchTopicFiles() {
      const files2 = await bagel.get(`/files?topic=${__props.topic}`);
      storageFiles.value.push(...files2);
    }
    function loadFiles() {
      const ids = [file_bindkeys.value].flat().filter(Boolean);
      if (!ids.length) {
        storageFiles.value.splice(0, storageFiles.value.length);
        return;
      }
      const currentIds = storageFiles.value.map((file) => file[bindKey2]);
      const idsToAdd = ids.filter((id) => !currentIds.includes(id));
      const idsToRemove = currentIds.filter(
        (id) => (typeof id === "string" || typeof id === "number") && !ids.includes(id)
      );
      idsToRemove.forEach((id) => {
        const index2 = storageFiles.value.findIndex((file) => file[bindKey2] === id);
        if (index2 !== -1) storageFiles.value.splice(index2, 1);
      });
      if (bindKey2 === "url") {
        idsToAdd.forEach((url) => {
          storageFiles.value.push({ url });
        });
        return;
      }
      if (__props.multiple) {
        idsToAdd.forEach((id) => {
          void bagel.get(`/files/${id}`).then((file) => {
            storageFiles.value.push(file);
          }).catch(console.error);
        });
      } else {
        void bagel.get(`/files/${idsToAdd[0]}`).then((file) => {
          storageFiles.value.push(file);
        }).catch(console.error);
      }
    }
    onMounted(() => {
      if (__props.topic) fetchTopicFiles();
      if (!__props.files && [file_bindkeys.value].flat().length > 0) {
        loadFiles();
      }
    });
    watch(() => __props.topic, fetchTopicFiles);
    watch(() => __props.modelValue, loadFiles);
    watch(
      () => __props.files,
      (newFiles) => {
        if (newFiles) {
          const filesToAdd = [newFiles].flat().filter((f) => !storageFiles.value.some((sf) => sf[bindKey2] === f[bindKey2]));
          for (const file of filesToAdd) {
            storageFiles.value.push(file);
          }
        }
      },
      { immediate: true }
    );
    function compareLists(a, b2) {
      return [a].flat().every((id) => [b2].flat().includes(id)) && [b2].flat().every((id) => [a].flat().includes(id));
    }
    function updateModelValue() {
      let idValue;
      if (__props.multiple) {
        idValue = storageFiles.value.map((f) => f[bindKey2]);
      } else {
        idValue = storageFiles.value[0][bindKey2] || "";
      }
      const isSame = compareLists(file_bindkeys.value, idValue);
      if (!isSame) {
        file_bindkeys.value = idValue;
      }
    }
    const fileQueue = ref([]);
    let isDragOver = ref(false);
    function preventDefault(e) {
      e.preventDefault();
      e.stopPropagation();
    }
    const fileToUrl = (file) => URL.createObjectURL(file);
    function removeFile(file) {
      const index2 = storageFiles.value.indexOf(file);
      storageFiles.value.splice(index2, 1);
      void bagel.delete(`/static_files/${file.id}`);
      updateModelValue();
    }
    async function flushQueue() {
      emit2("addFileStart");
      for (const file of fileQueue.value) {
        file.uploading = true;
        if (!__props.multiple) storageFiles.value.splice(0, 1);
        const serverFile = await bagel.uploadFile(file.file, {
          onUploadProgress: (e) => file.progress = e.progress * 100 - 1,
          topic: __props.topic
        });
        storageFiles.value.push(serverFile);
      }
      fileQueue.value.splice(0, fileQueue.value.length);
      updateModelValue();
    }
    function browse() {
      if (__props.disabled) return;
      const input = document.createElement("input");
      input.type = "file";
      input.multiple = __props.multiple;
      input.accept = __props.accept;
      input.onchange = (e) => {
        const target = e.target;
        if (target.files) {
          const files2 = Array.from(target.files);
          for (const file of files2) {
            fileQueue.value.push({ name: file.name, file, progress: 0 });
          }
        }
        flushQueue();
      };
      console.log(fileQueue.value);
      input.click();
    }
    function dragleave(e) {
      preventDefault(e);
      if (e.dataTransfer) isDragOver.value = false;
      else isDragOver.value = false;
    }
    function dragover(e) {
      if (__props.disabled) return;
      preventDefault(e);
      if (e.dataTransfer) isDragOver.value = true;
      else isDragOver.value = false;
    }
    function drop3(e) {
      if (__props.disabled) return;
      preventDefault(e);
      if (e.dataTransfer) {
        Array.from(e.dataTransfer.files).forEach(
          (file) => fileQueue.value.push({ name: file.name, file, progress: 0 })
        );
      }
      isDragOver.value = false;
      flushQueue();
    }
    const __returned__ = { emit: emit2, bindKey: bindKey2, bagel, isImage, file_bindkeys, storageFiles, fetchTopicFiles, loadFiles, compareLists, updateModelValue, fileQueue, get isDragOver() {
      return isDragOver;
    }, set isDragOver(v) {
      isDragOver = v;
    }, preventDefault, fileToUrl, removeFile, flushQueue, browse, dragleave, dragover, drop: drop3, get Btn() {
      return Btn;
    }, get Icon() {
      return Icon;
    }, get Card() {
      return Card;
    }, Image: Image$1 };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$y = { class: "bagel-input" };
const _hoisted_2$o = {
  key: 0,
  placeholder: "required",
  type: "text",
  required: "",
  class: "pixel"
};
const _hoisted_3$j = { class: "m-05 flex opacity-7 z-99" };
const _hoisted_4$d = { class: "ellipsis-1 word-break-all h-20 m-0" };
const _hoisted_5$c = {
  key: 1,
  class: "txt-gray txt-12"
};
const _hoisted_6$a = {
  key: 0,
  class: "bgl-multi-preview"
};
const _hoisted_7$6 = { class: "m-0" };
const _hoisted_8$4 = { class: "no-margin multi-preview-txt" };
const _hoisted_9$3 = {
  key: 0,
  class: "progress"
};
const _hoisted_10$3 = {
  key: 1,
  class: "bgl-single-preview"
};
const _hoisted_11$3 = { class: "position-start m-05 flex opacity-7 z-99 gap-025" };
const _hoisted_12$2 = {
  key: 0,
  class: "h-100"
};
const _hoisted_13$2 = {
  key: 0,
  class: "progress"
};
const _hoisted_14$1 = { class: "p-1 flex column hover fileUploadPlaceHolder justify-content-center mb-05" };
function _sfc_render$H(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_tooltip = resolveDirective("tooltip");
  const _directive_lightbox = resolveDirective("lightbox");
  return openBlock(), createElementBlock("div", _hoisted_1$y, [
    createElementVNode(
      "label",
      null,
      toDisplayString($props.label),
      1
      /* TEXT */
    ),
    $props.required && !$setup.storageFiles.length ? (openBlock(), createElementBlock("input", _hoisted_2$o)) : createCommentVNode("v-if", true),
    $props.theme === "basic" ? (openBlock(), createBlock($setup["Card"], {
      key: 1,
      outline: "",
      class: "flex p-05 gap-1",
      onDragover: $setup.dragover,
      onDrop: $setup.drop
    }, {
      default: withCtx(() => [
        !$setup.storageFiles.length && !$setup.fileQueue.length ? (openBlock(), createBlock($setup["Btn"], {
          key: 0,
          class: "px-1-5",
          icon: "upload",
          outline: "",
          onClick: $setup.browse
        }, {
          default: withCtx(() => _cache[2] || (_cache[2] = [
            createTextVNode(" Upload ")
          ])),
          _: 1
          /* STABLE */
        })) : createCommentVNode("v-if", true),
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList($setup.storageFiles, (file) => {
            return openBlock(), createElementBlock("div", {
              key: file.id,
              class: "txt-gray txt-12 flex"
            }, [
              createElementVNode("div", _hoisted_3$j, [
                withDirectives(createVNode($setup["Btn"], {
                  color: "gray",
                  thin: "",
                  icon: "delete",
                  onClick: withModifiers(($event) => $setup.removeFile(file), ["stop"])
                }, null, 8, ["onClick"]), [
                  [_directive_tooltip, "Delete"]
                ]),
                withDirectives(createVNode(
                  $setup["Btn"],
                  {
                    color: "gray",
                    thin: "",
                    icon: "autorenew",
                    onClick: $setup.browse
                  },
                  null,
                  512
                  /* NEED_PATCH */
                ), [
                  [_directive_tooltip, "Replace"]
                ]),
                withDirectives(createVNode($setup["Btn"], {
                  href: file.url,
                  download: file.name,
                  color: "gray",
                  thin: "",
                  icon: "download",
                  target: "_blank",
                  onClick: _cache[0] || (_cache[0] = withModifiers(() => {
                  }, ["stop"]))
                }, null, 8, ["href", "download"]), [
                  [_directive_tooltip, "Download"]
                ]),
                withDirectives((openBlock(), createElementBlock("p", _hoisted_4$d, [
                  createTextVNode(
                    toDisplayString(file.name),
                    1
                    /* TEXT */
                  )
                ])), [
                  [_directive_lightbox, { src: file.url, download: true }]
                ]),
                createVNode($setup["Btn"], {
                  thin: "",
                  flat: "",
                  icon: "delete",
                  color: "red",
                  onClick: withModifiers(($event) => $setup.removeFile(file), ["stop"])
                }, null, 8, ["onClick"])
              ])
            ]);
          }),
          128
          /* KEYED_FRAGMENT */
        )),
        !$setup.storageFiles.length && !$setup.fileQueue.length ? (openBlock(), createElementBlock("span", _hoisted_5$c, " No file selected ")) : createCommentVNode("v-if", true)
      ]),
      _: 1
      /* STABLE */
    })) : (openBlock(), createElementBlock(
      "div",
      {
        key: 2,
        class: normalizeClass(["fileUploadWrap", {
          "fileDropZone": !$setup.storageFiles.length && !$setup.fileQueue.length,
          "dragover": $setup.isDragOver,
          "bgl_oval-upload": $props.oval
        }]),
        style: normalizeStyle({ width: $props.width, height: $props.height }),
        onClick: $setup.browse,
        onDragover: $setup.dragover,
        onDrop: $setup.drop,
        onDragleave: $setup.dragleave
      },
      [
        renderSlot(_ctx.$slots, "files", {
          files: $setup.storageFiles,
          fileQueue: $setup.fileQueue
        }, () => [
          $props.multiple ? (openBlock(), createElementBlock("div", _hoisted_6$a, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.storageFiles, (file) => {
                return withDirectives((openBlock(), createElementBlock("div", {
                  key: file.id,
                  class: "multi-image-item-preview"
                }, [
                  $setup.isImage(file.extension || file.url) ? (openBlock(), createBlock($setup["Image"], {
                    key: 0,
                    class: "multi-preview",
                    src: file.url,
                    alt: ""
                  }, null, 8, ["src"])) : (openBlock(), createBlock($setup["Icon"], {
                    key: 1,
                    icon: "draft",
                    class: "multi-preview"
                  })),
                  createElementVNode(
                    "p",
                    _hoisted_7$6,
                    toDisplayString(file.name),
                    1
                    /* TEXT */
                  ),
                  createVNode($setup["Btn"], {
                    thin: "",
                    flat: "",
                    icon: "delete",
                    color: "red",
                    onClick: withModifiers(($event) => $setup.removeFile(file), ["stop"])
                  }, null, 8, ["onClick"])
                ])), [
                  [_directive_lightbox, { src: file.url, download: true }]
                ]);
              }),
              128
              /* KEYED_FRAGMENT */
            )),
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.fileQueue, (fileQ) => {
                return openBlock(), createElementBlock("div", {
                  key: fileQ.file.name,
                  class: "multi-image-item-preview"
                }, [
                  $setup.isImage(fileQ.file.type) ? (openBlock(), createElementBlock(
                    Fragment,
                    { key: 0 },
                    [
                      $props.multiple ? (openBlock(), createBlock($setup["Image"], {
                        key: 0,
                        width: $props.width || "220",
                        class: "multi-preview",
                        src: $setup.fileToUrl(fileQ.file),
                        alt: ""
                      }, null, 8, ["width", "src"])) : createCommentVNode("v-if", true)
                    ],
                    64
                    /* STABLE_FRAGMENT */
                  )) : (openBlock(), createBlock($setup["Icon"], {
                    key: 1,
                    icon: "draft",
                    class: "multi-preview"
                  })),
                  createElementVNode(
                    "p",
                    _hoisted_8$4,
                    toDisplayString(fileQ.name),
                    1
                    /* TEXT */
                  ),
                  createElementVNode(
                    "div",
                    {
                      class: normalizeClass(["pie", { complete: fileQ.progress === 100 }]),
                      style: normalizeStyle([`--p:${fileQ.progress}`, { "--b": "2px" }])
                    },
                    [
                      fileQ.progress < 100 ? (openBlock(), createElementBlock(
                        "span",
                        _hoisted_9$3,
                        toDisplayString(`${fileQ.progress.toFixed(0)}`),
                        1
                        /* TEXT */
                      )) : createCommentVNode("v-if", true),
                      createVNode($setup["Icon"], {
                        class: "success",
                        icon: "check"
                      })
                    ],
                    6
                    /* CLASS, STYLE */
                  )
                ]);
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])) : createCommentVNode("v-if", true),
          !$props.multiple && ($setup.storageFiles.length > 0 || $setup.fileQueue.length > 0) ? (openBlock(), createElementBlock("div", _hoisted_10$3, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.storageFiles, (file) => {
                return openBlock(), createElementBlock(
                  "div",
                  {
                    key: file.id,
                    class: normalizeClass(["single-image-item-preview", { "bgl_fill-image": $props.fill }])
                  },
                  [
                    createElementVNode("div", _hoisted_11$3, [
                      withDirectives(createVNode($setup["Btn"], {
                        color: "gray",
                        thin: "",
                        icon: "delete",
                        onClick: withModifiers(($event) => $setup.removeFile(file), ["stop"])
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, "Delete"]
                      ]),
                      withDirectives(createVNode(
                        $setup["Btn"],
                        {
                          color: "gray",
                          thin: "",
                          icon: "autorenew",
                          onClick: $setup.browse
                        },
                        null,
                        512
                        /* NEED_PATCH */
                      ), [
                        [_directive_tooltip, "Replace"]
                      ]),
                      withDirectives(createVNode($setup["Btn"], {
                        href: file.url,
                        download: file.name,
                        color: "gray",
                        thin: "",
                        icon: "download",
                        target: "_blank",
                        onClick: _cache[1] || (_cache[1] = withModifiers(() => {
                        }, ["stop"]))
                      }, null, 8, ["href", "download"]), [
                        [_directive_tooltip, "Download"]
                      ])
                    ]),
                    $setup.isImage(file.extension || file.url) ? (openBlock(), createElementBlock("div", _hoisted_12$2, [
                      withDirectives(createVNode($setup["Image"], {
                        class: "single-preview",
                        src: file.url,
                        alt: ""
                      }, null, 8, ["src"]), [
                        [_directive_lightbox, { src: file.url, download: true }]
                      ])
                    ])) : withDirectives((openBlock(), createBlock(
                      $setup["Icon"],
                      {
                        key: 1,
                        size: 4,
                        weight: "2",
                        icon: "draft",
                        class: "color-primary w-100"
                      },
                      null,
                      512
                      /* NEED_PATCH */
                    )), [
                      [_directive_lightbox, { src: file.url, download: true }]
                    ])
                  ],
                  2
                  /* CLASS */
                );
              }),
              128
              /* KEYED_FRAGMENT */
            )),
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.fileQueue, (fileQ) => {
                return openBlock(), createElementBlock(
                  "div",
                  {
                    key: fileQ.file.name,
                    class: normalizeClass(["single-image-item-preview", { "bgl_fill-image": $props.fill }])
                  },
                  [
                    createElementVNode(
                      "div",
                      {
                        class: normalizeClass(["pie", { complete: fileQ.progress === 100 }]),
                        style: normalizeStyle([`--p:${fileQ.progress}`, { "--b": "2px" }])
                      },
                      [
                        fileQ.progress < 100 ? (openBlock(), createElementBlock(
                          "span",
                          _hoisted_13$2,
                          toDisplayString(`${fileQ.progress.toFixed(0)}`),
                          1
                          /* TEXT */
                        )) : createCommentVNode("v-if", true),
                        createVNode($setup["Icon"], {
                          class: "success",
                          icon: "check"
                        })
                      ],
                      6
                      /* CLASS, STYLE */
                    ),
                    $setup.isImage(fileQ.file.type) ? (openBlock(), createBlock($setup["Image"], {
                      key: 0,
                      class: "single-preview",
                      src: $setup.fileToUrl(fileQ.file),
                      alt: ""
                    }, null, 8, ["src"])) : createCommentVNode("v-if", true),
                    createCommentVNode(' <Icon v-else :size="8" weight="2" icon="draft" class="color-primary" /> ')
                  ],
                  2
                  /* CLASS */
                );
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])) : createCommentVNode("v-if", true)
        ], true),
        !$setup.storageFiles.length && !$setup.fileQueue.length || $props.multiple ? renderSlot(_ctx.$slots, "placeholder", {
          key: 0,
          files: $setup.storageFiles,
          fileQueue: $setup.fileQueue,
          browse: $setup.browse
        }, () => [
          createElementVNode("p", _hoisted_14$1, [
            createVNode($setup["Icon"], { icon: "upload_2" }),
            _cache[3] || (_cache[3] = createTextVNode(" Drop files here or click to upload "))
          ])
        ], true) : createCommentVNode("v-if", true)
      ],
      38
      /* CLASS, STYLE, NEED_HYDRATION */
    ))
  ]);
}
const FileUpload = /* @__PURE__ */ _export_sfc(_sfc_main$H, [["render", _sfc_render$H], ["__scopeId", "data-v-cad6e90b"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/FileUpload.vue"]]);
const _sfc_main$G = /* @__PURE__ */ defineComponent({
  __name: "JSONInput",
  props: {
    description: { type: String, required: false, default: "" },
    label: { type: String, required: false, default: "" },
    modelValue: { type: null, required: true },
    placeholder: { type: String, required: false, default: "" },
    editMode: { type: Boolean, required: false, default: true },
    small: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emits = __emit;
    function handleInput(e) {
      const el = e.target;
      emits("update:modelValue", el.value);
    }
    const __returned__ = { emits, handleInput };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$x = ["title"];
const _hoisted_2$n = { key: 0 };
const _hoisted_3$i = ["value", "placeholder"];
function _sfc_render$G(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_LangText = resolveComponent("LangText");
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["bagel-input", { small: $props.small }]),
    title: $props.description
  }, [
    $props.label ? (openBlock(), createElementBlock("label", _hoisted_2$n, [
      createVNode(_component_LangText, { input: $props.label }, null, 8, ["input"])
    ])) : createCommentVNode("v-if", true),
    createElementVNode("textarea", {
      value: $props.modelValue,
      class: normalizeClass({ "no-edit": !$props.editMode }),
      placeholder: $props.placeholder,
      onInput: $setup.handleInput
    }, null, 42, _hoisted_3$i)
  ], 10, _hoisted_1$x);
}
const JSONInput = /* @__PURE__ */ _export_sfc(_sfc_main$G, [["render", _sfc_render$G], ["__scopeId", "data-v-846f4108"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/JSONInput.vue"]]);
const _sfc_main$F = /* @__PURE__ */ defineComponent({
  __name: "NumberInput",
  props: {
    modelValue: { type: Number, required: false },
    min: { type: Number, required: false },
    max: { type: Number, required: false },
    step: { type: Number, required: false, default: 1 },
    spinner: { type: Boolean, required: false, default: true },
    iconStart: { type: null, required: false },
    icon: { type: null, required: false },
    label: { type: String, required: false },
    placeholder: { type: String, required: false },
    disabled: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    id: { type: String, required: false },
    helptext: { type: String, required: false },
    layout: { type: String, required: false },
    center: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit2 = __emit;
    let numberValue = ref(__props.modelValue || 0);
    const btnLayouts = ["horizontal", "vertical"];
    function increment() {
      if (!__props.max || numberValue.value + __props.step <= __props.max) {
        numberValue.value = (numberValue.value || 0) + __props.step;
        emit2("update:modelValue", numberValue.value);
      }
    }
    function decrement() {
      if (!__props.min || numberValue.value - __props.step >= __props.min) {
        numberValue.value = (numberValue.value || 0) - __props.step;
        emit2("update:modelValue", numberValue.value);
      }
    }
    function formatNumber2(num) {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue = ref("");
    function inputHandler() {
      const numeric = formattedValue.value.replace(/[^\d.-]/g, "");
      if (numeric === "" || numeric === "-" || numeric === "." || numeric === "-." || numeric.endsWith(".")) return;
      numberValue.value = Number.parseFloat(numeric);
      formattedValue.value = formatNumber2(numberValue.value);
      emit2("update:modelValue", numberValue.value);
    }
    watch(() => numberValue.value, () => {
      formattedValue.value = formatNumber2(numberValue.value);
    }, { immediate: true });
    watch(() => __props.modelValue, (newVal) => {
      if (newVal !== numberValue.value) {
        numberValue.value = newVal || 0;
      }
    }, { immediate: true });
    const __returned__ = { emit: emit2, get numberValue() {
      return numberValue;
    }, set numberValue(v) {
      numberValue = v;
    }, btnLayouts, increment, decrement, formatNumber: formatNumber2, get formattedValue() {
      return formattedValue;
    }, set formattedValue(v) {
      formattedValue = v;
    }, inputHandler, get Icon() {
      return Icon;
    }, get Btn() {
      return Btn;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$w = ["for"];
const _hoisted_2$m = ["id", "placeholder", "disabled", "required", "readonly", "onKeydown"];
const _hoisted_3$h = { key: 1 };
const _hoisted_4$c = {
  key: 5,
  class: "flex column spinner"
};
function _sfc_render$F(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_pattern = resolveDirective("pattern");
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["bagel-input num-input", {
        textInputSpinnerWrap: $props.icon || $props.spinner,
        txtInputIconStart: $props.iconStart
      }])
    },
    [
      createElementVNode("label", { for: $props.id }, [
        createTextVNode(
          toDisplayString($props.label) + " ",
          1
          /* TEXT */
        ),
        createElementVNode(
          "div",
          {
            class: normalizeClass(["gap-025", { "column flex": $props.layout === "vertical", "flex": $props.layout === "horizontal" }])
          },
          [
            $props.layout && $setup.btnLayouts.includes($props.layout) ? (openBlock(), createBlock($setup["Btn"], {
              key: 0,
              flat: "",
              icon: "add",
              class: normalizeClass(["radius", [{ "bgl-big-ctrl-num-btn": $props.layout === "vertical" }]]),
              onClick: $setup.increment
            }, null, 8, ["class"])) : createCommentVNode("v-if", true),
            withDirectives(createElementVNode("input", {
              id: $props.id,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.formattedValue = $event),
              type: "text",
              class: normalizeClass({
                "txt-center": $props.center,
                "min0": $props.layout,
                "bgl-number-input": $props.layout !== "vertical" && $props.layout !== "horizontal"
              }),
              placeholder: $props.placeholder || $props.label,
              disabled: $props.disabled,
              required: $props.required,
              readonly: $props.disabled,
              inputmode: "numeric",
              autocomplete: "off",
              autocorrect: "off",
              spellcheck: "false",
              onInput: $setup.inputHandler,
              onKeydown: [
                withKeys(withModifiers($setup.increment, ["prevent"]), ["up"]),
                withKeys(withModifiers($setup.decrement, ["prevent"]), ["down"])
              ]
            }, null, 42, _hoisted_2$m), [
              [
                vModelText,
                $setup.formattedValue,
                void 0,
                { trim: true }
              ],
              [
                _directive_pattern,
                void 0,
                void 0,
                { number: true }
              ]
            ]),
            $props.helptext ? (openBlock(), createElementBlock(
              "p",
              _hoisted_3$h,
              toDisplayString($props.helptext),
              1
              /* TEXT */
            )) : createCommentVNode("v-if", true),
            $props.iconStart ? (openBlock(), createBlock($setup["Icon"], {
              key: 2,
              class: "iconStart",
              icon: $props.iconStart
            }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
            $props.icon ? (openBlock(), createBlock($setup["Icon"], {
              key: 3,
              icon: $props.icon
            }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
            $props.layout && $setup.btnLayouts.includes($props.layout) ? (openBlock(), createBlock($setup["Btn"], {
              key: 4,
              flat: "",
              icon: "remove",
              class: normalizeClass(["radius", [{ "bgl-big-ctrl-num-btn": $props.layout === "vertical" }]]),
              onClick: $setup.decrement
            }, null, 8, ["class"])) : createCommentVNode("v-if", true),
            $props.spinner && (!$props.layout || !$setup.btnLayouts.includes($props.layout)) ? (openBlock(), createElementBlock("div", _hoisted_4$c, [
              createVNode($setup["Btn"], {
                icon: "add",
                flat: "",
                thin: "",
                class: "bgl-ctrl-num-btn",
                onClick: $setup.increment
              }),
              createVNode($setup["Btn"], {
                icon: "remove",
                flat: "",
                thin: "",
                class: "bgl-ctrl-num-btn",
                onClick: $setup.decrement
              })
            ])) : createCommentVNode("v-if", true)
          ],
          2
          /* CLASS */
        )
      ], 8, _hoisted_1$w)
    ],
    2
    /* CLASS */
  );
}
const NumberInput = /* @__PURE__ */ _export_sfc(_sfc_main$F, [["render", _sfc_render$F], ["__scopeId", "data-v-621d7834"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/NumberInput.vue"]]);
const _sfc_main$E = /* @__PURE__ */ defineComponent({
  __name: "OTP",
  props: {
    digitCount: { type: Number, required: true },
    default: { type: String, required: false },
    modelValue: { type: String, required: false }
  },
  emits: ["update:modelValue", "complete"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const digits = reactive([]);
    const otpCont = ref();
    function handlePaste(event, index2) {
      event.preventDefault();
      const { clipboardData } = event;
      const pastedText = clipboardData == null ? void 0 : clipboardData.getData("text").replaceAll(/\D/g, "");
      const pastedDigits = [...pastedText ?? ""];
      if (!pastedDigits) return;
      for (let i = 0; i < pastedDigits.length; i++) {
        const digit = pastedDigits[i];
        if (index2 + i < digits.length) {
          digits[index2 + i] = digit;
        }
      }
      emitUpdate();
    }
    function emitUpdate() {
      if (isDigitsFull()) {
        emit2("complete", digits.join(""));
      } else {
        emit2("update:modelValue", digits.join(""));
      }
    }
    function handleKeyDown(event, index2) {
      var _a2;
      const noPreventKeys = ["Tab", "ArrowRight", "ArrowLeft", "Control", "Shift", "Alt", "Meta"];
      if (noPreventKeys.includes(event.key)) {
        return;
      }
      if (event.key === "Backspace") {
        digits[index2] = void 0;
        if (index2 !== 0) {
          const prevDigit = (_a2 = otpCont.value) == null ? void 0 : _a2.children[index2 - 1];
          prevDigit.focus();
        }
        emitUpdate();
        return;
      }
      const numberRegex = /^\d$/;
      if (numberRegex.test(event.key)) {
        digits[index2] = event.key;
        if (index2 !== props2.digitCount - 1) {
          setTimeout(() => {
            var _a3;
            const nextDigit = (_a3 = otpCont.value) == null ? void 0 : _a3.children[index2 + 1];
            nextDigit.focus();
          }, 10);
        }
        emitUpdate();
      }
    }
    if (props2.default && props2.default.length === props2.digitCount) {
      for (let i = 0; i < props2.digitCount; i++) {
        digits[i] = props2.default.charAt(i);
      }
    } else {
      for (let i = 0; i < props2.digitCount; i++) {
        digits[i] = void 0;
      }
    }
    function isDigitsFull() {
      for (const elem of digits) {
        if (elem === void 0) {
          return false;
        }
      }
      return true;
    }
    const __returned__ = { props: props2, emit: emit2, digits, otpCont, handlePaste, emitUpdate, handleKeyDown, isDigitsFull };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$v = {
  ref: "otpCont",
  class: "otp_wrap"
};
const _hoisted_2$l = ["value", "autofocus", "onKeydown", "onPaste"];
function _sfc_render$E(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    _hoisted_1$v,
    [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($setup.digits, (_el, ind) => {
          return openBlock(), createElementBlock("input", {
            key: ind,
            value: $setup.digits[ind] || "",
            type: "number",
            inputmode: "numeric",
            class: "digit-box",
            autofocus: ind === 0,
            maxlength: "1",
            pattern: "[0-9]*",
            oninput: "this.value = this.value.slice(0, 1);",
            onKeydown: ($event) => $setup.handleKeyDown($event, ind),
            onPaste: ($event) => $setup.handlePaste($event, ind)
          }, null, 40, _hoisted_2$l);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ],
    512
    /* NEED_PATCH */
  );
}
const OTP = /* @__PURE__ */ _export_sfc(_sfc_main$E, [["render", _sfc_render$E], ["__scopeId", "data-v-52c30e3d"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/OTP.vue"]]);
const _sfc_main$D = /* @__PURE__ */ defineComponent({
  __name: "PasswordInput",
  props: /* @__PURE__ */ mergeModels({
    id: { type: String, required: false },
    title: { type: String, required: false },
    helptext: { type: String, required: false },
    placeholder: { type: String, required: false },
    label: { type: String, required: false, default: "" },
    small: { type: Boolean, required: false },
    dense: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    pattern: { type: String, required: false },
    shrink: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
    nativeInputAttrs: { type: Object, required: false },
    icon: { type: null, required: false },
    iconStart: { type: null, required: false },
    multiline: { type: Boolean, required: false },
    autoheight: { type: Boolean, required: false },
    code: { type: Boolean, required: false },
    lines: { type: Number, required: false },
    autofocus: { type: Boolean, required: false },
    debounceDelay: { type: Number, required: false },
    autocomplete: { type: null, required: false, default: "current-password" },
    onFocusout: { type: Function, required: false }
  }, {
    "modelValue": { type: String },
    "modelModifiers": {},
    "showPwd": { type: Boolean, ...{ default: false } },
    "showPwdModifiers": {}
  }),
  emits: ["update:modelValue", "update:showPwd"],
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const hasLabel = computed(() => props2.label && props2.label.trim() !== "");
    const password = useModel(__props, "modelValue");
    const showPwd = useModel(__props, "showPwd");
    const toggleShowPwdIcon = computed(
      () => showPwd.value ? "visibility_off" : "visibility"
    );
    const inputType = computed(() => showPwd.value ? "text" : "password");
    const __returned__ = { props: props2, hasLabel, password, showPwd, toggleShowPwdIcon, inputType, get Btn() {
      return Btn;
    }, get TextInput() {
      return TextInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$D(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["relative", { "has-label": $setup.hasLabel }])
    },
    [
      createVNode($setup["TextInput"], mergeProps({
        modelValue: $setup.password,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.password = $event)
      }, $setup.props, {
        type: $setup.inputType,
        class: "mb-0"
      }), null, 16, ["modelValue", "type"]),
      createVNode($setup["Btn"], {
        flat: "",
        thin: "",
        class: "mx-05 m-password position-bottom-end",
        icon: $setup.toggleShowPwdIcon,
        onClick: _cache[1] || (_cache[1] = ($event) => $setup.showPwd = !$setup.showPwd)
      }, null, 8, ["icon"])
    ],
    2
    /* CLASS */
  );
}
const PasswordInput = /* @__PURE__ */ _export_sfc(_sfc_main$D, [["render", _sfc_render$D], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/PasswordInput.vue"]]);
const _sfc_main$C = /* @__PURE__ */ defineComponent({
  __name: "RadioGroup",
  props: /* @__PURE__ */ mergeModels({
    groupName: { type: String, required: true },
    options: { type: Array, required: true },
    deletable: { type: Boolean, required: false }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["delete"], ["update:modelValue"]),
  setup(__props, { expose: __expose }) {
    __expose();
    const selectedOption = useModel(__props, "modelValue");
    const __returned__ = { selectedOption, get Btn() {
      return Btn;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$u = ["for"];
const _hoisted_2$k = ["id", "name", "value"];
const _hoisted_3$g = { class: "flex w-100 gap-1 flex-wrap m_gap-05 m_gap-row-025" };
const _hoisted_4$b = ["src", "alt"];
const _hoisted_5$b = { class: "" };
const _hoisted_6$9 = {
  key: 0,
  class: "m-0 m_txt-14"
};
const _hoisted_7$5 = {
  key: 1,
  class: "txt-gray txt-12 m-0"
};
function _sfc_render$C(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    (openBlock(true), createElementBlock(
      Fragment,
      null,
      renderList($props.options, (opt) => {
        return openBlock(), createElementBlock("label", {
          key: opt.id,
          class: "border rounded p-1 flex bg-gray-light mb-05 gap-075 active-list-item hover",
          for: opt.id
        }, [
          withDirectives(createElementVNode("input", {
            id: opt.id,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.selectedOption = $event),
            class: "radio-input-list",
            type: "radio",
            name: $props.groupName,
            value: opt.value
          }, null, 8, _hoisted_2$k), [
            [vModelRadio, $setup.selectedOption]
          ]),
          createElementVNode("div", _hoisted_3$g, [
            opt.imgSrc ? (openBlock(), createElementBlock("img", {
              key: 0,
              class: "bg-popup shadow-light py-025 radius-05 m_w40",
              width: "60",
              src: opt.imgSrc,
              alt: opt.imgAlt
            }, null, 8, _hoisted_4$b)) : createCommentVNode("v-if", true),
            createElementVNode("div", _hoisted_5$b, [
              opt.label ? (openBlock(), createElementBlock(
                "p",
                _hoisted_6$9,
                toDisplayString(opt.label),
                1
                /* TEXT */
              )) : createCommentVNode("v-if", true),
              opt.subLabel ? (openBlock(), createElementBlock(
                "p",
                _hoisted_7$5,
                toDisplayString(opt.subLabel),
                1
                /* TEXT */
              )) : createCommentVNode("v-if", true)
            ]),
            renderSlot(_ctx.$slots, "radioItem", mergeProps({ ref_for: true }, opt), void 0, true)
          ]),
          $props.deletable ? (openBlock(), createBlock($setup["Btn"], {
            key: 0,
            class: "ms-auto",
            flat: "",
            thin: "",
            icon: "delete",
            onClick: ($event) => _ctx.$emit("delete", opt)
          }, null, 8, ["onClick"])) : createCommentVNode("v-if", true)
        ], 8, _hoisted_1$u);
      }),
      128
      /* KEYED_FRAGMENT */
    ))
  ]);
}
const RadioGroup = /* @__PURE__ */ _export_sfc(_sfc_main$C, [["render", _sfc_render$C], ["__scopeId", "data-v-029ad04d"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/RadioGroup.vue"]]);
const _sfc_main$B = /* @__PURE__ */ defineComponent({
  __name: "RadioPillsInput",
  props: {
    options: { type: Array, required: false },
    modelValue: { type: null, required: false, default: "" },
    id: { type: String, required: false, default: () => `radio-pill-${Math.random().toString(36).slice(2, 9)}` },
    label: { type: String, required: false, default: "" }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emits = __emit;
    function getLabel(option2) {
      if (typeof option2 === "string") return option2;
      if (typeof option2 === "number") return `${option2}`;
      return option2.label;
    }
    function getValue(option2) {
      if (typeof option2 === "string") return option2;
      if (typeof option2 === "number") return option2;
      return option2.value;
    }
    let selectedValue = ref(props2.modelValue);
    function handleSelect(e) {
      var _a2;
      const newVal = (_a2 = e.target) == null ? void 0 : _a2.value;
      emits("update:modelValue", newVal);
      selectedValue.value = newVal;
    }
    watch(
      () => props2.modelValue,
      (newVal, oldVal) => {
        if (newVal === oldVal || oldVal === void 0) return;
        if (selectedValue.value !== newVal) selectedValue.value = newVal;
      },
      { immediate: true }
    );
    onMounted(() => {
      selectedValue.value = props2.modelValue;
    });
    const __returned__ = { props: props2, emits, getLabel, getValue, get selectedValue() {
      return selectedValue;
    }, set selectedValue(v) {
      selectedValue = v;
    }, handleSelect };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$t = { class: "bagel-input" };
const _hoisted_2$j = { class: "pb-025" };
const _hoisted_3$f = { class: "flex gap-05 flex-wrap" };
const _hoisted_4$a = ["id", "name", "value", "checked"];
const _hoisted_5$a = ["for"];
function _sfc_render$B(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$t, [
    createElementVNode(
      "label",
      _hoisted_2$j,
      toDisplayString($props.label),
      1
      /* TEXT */
    ),
    createElementVNode("div", _hoisted_3$f, [
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($props.options, (option2, index2) => {
          return openBlock(), createElementBlock("div", {
            key: index2,
            class: "radio-pill"
          }, [
            createElementVNode("input", {
              id: `${$props.id}-${$setup.getValue(option2)}`,
              type: "radio",
              name: $props.id,
              value: $setup.getValue(option2),
              checked: $setup.selectedValue === $setup.getValue(option2),
              onChange: $setup.handleSelect
            }, null, 40, _hoisted_4$a),
            createElementVNode("label", {
              for: `${$props.id}-${$setup.getValue(option2)}`
            }, toDisplayString($setup.getLabel(option2)), 9, _hoisted_5$a)
          ]);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ])
  ]);
}
const RadioPillsInput = /* @__PURE__ */ _export_sfc(_sfc_main$B, [["render", _sfc_render$B], ["__scopeId", "data-v-f75d8f8a"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/RadioPillsInput.vue"]]);
const _sfc_main$A = /* @__PURE__ */ defineComponent({
  __name: "RangeInput",
  props: {
    modelValue: { type: [Number, Array], required: true },
    min: { type: Number, required: false, default: 0 },
    max: { type: Number, required: false, default: 100 },
    step: { type: Number, required: false, default: 1 },
    required: { type: Boolean, required: false },
    label: { type: String, required: false },
    disabled: { type: Boolean, required: false },
    id: { type: String, required: false },
    rtl: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit2 = __emit;
    const isRange = computed(() => Array.isArray(__props.modelValue));
    let from = ref(__props.min);
    let to2 = ref(__props.max);
    const validFrom = computed(() => Math.min(Math.max(from.value, __props.min), to2.value));
    const validTo = computed(() => Math.max(Math.min(to2.value, __props.max), from.value));
    function emitValue() {
      emit2("update:modelValue", isRange.value ? [validFrom.value, validTo.value] : validFrom.value);
    }
    watch(() => validFrom.value, (newVal) => {
      if (from.value !== newVal) from.value = newVal;
    });
    watch(() => validTo.value, (newVal) => {
      if (to2.value !== newVal) to2.value = newVal;
    });
    const fromPercentage = computed(() => (validFrom.value - __props.min) / (__props.max - __props.min) * 100);
    const toPercentage = computed(() => (validTo.value - __props.min) / (__props.max - __props.min) * 100);
    const rangeStyle = computed(() => {
      const width = (validTo.value - validFrom.value) / (__props.max - __props.min) * 100;
      if (isRange.value) return { left: `${fromPercentage.value}%`, width: `${width}%` };
      if (__props.rtl) return { left: `${width}%`, width: `${fromPercentage.value}%` };
      return { right: `${width}%`, width: `${fromPercentage.value}%` };
    });
    const __returned__ = { emit: emit2, isRange, get from() {
      return from;
    }, set from(v) {
      from = v;
    }, get to() {
      return to2;
    }, set to(v) {
      to2 = v;
    }, validFrom, validTo, emitValue, fromPercentage, toPercentage, rangeStyle };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$s = { class: "label" };
const _hoisted_2$i = ["dir"];
const _hoisted_3$e = ["id", "min", "max", "step", "required", "disabled"];
const _hoisted_4$9 = ["min", "max", "step", "required", "disabled"];
const _hoisted_5$9 = { class: "track absolute pointer-events-none overflow-hidden round" };
const _hoisted_6$8 = { class: "txt-center txt-14 range-slider-txt flex space-between opacity-4 mx-05" };
function _sfc_render$A(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", null, [
    createElementVNode(
      "label",
      _hoisted_1$s,
      toDisplayString($props.label),
      1
      /* TEXT */
    ),
    createElementVNode("div", {
      class: "range-slider relative w-100",
      dir: $props.rtl ? "rtl" : "ltr"
    }, [
      withDirectives(createElementVNode("input", {
        id: $props.id,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.from = $event),
        class: "from",
        type: "range",
        min: $props.min,
        max: $props.max,
        step: $props.step,
        required: $props.required,
        disabled: $props.disabled,
        "aria-label": "Minimum value",
        onChange: $setup.emitValue
      }, null, 40, _hoisted_3$e), [
        [vModelText, $setup.from]
      ]),
      $setup.isRange ? withDirectives((openBlock(), createElementBlock("input", {
        key: 0,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.to = $event),
        class: "to",
        type: "range",
        min: $props.min,
        max: $props.max,
        step: $props.step,
        required: $props.required,
        disabled: $props.disabled,
        "aria-label": "Maximum value",
        onChange: $setup.emitValue
      }, null, 40, _hoisted_4$9)), [
        [vModelText, $setup.to]
      ]) : createCommentVNode("v-if", true),
      createElementVNode("div", _hoisted_5$9, [
        createElementVNode(
          "div",
          {
            class: "active-range absolute h-100 pointer-events-none bg-primary",
            style: normalizeStyle($setup.rangeStyle)
          },
          null,
          4
          /* STYLE */
        )
      ]),
      $setup.from !== $props.min ? (openBlock(), createElementBlock(
        "p",
        {
          key: 1,
          class: "txt-center txt-12 range-slider-position-txt absolute line-height-1 opacity-0",
          style: normalizeStyle({ "--progress": `${$setup.fromPercentage}` })
        },
        [
          createElementVNode(
            "span",
            null,
            toDisplayString($setup.from),
            1
            /* TEXT */
          )
        ],
        4
        /* STYLE */
      )) : createCommentVNode("v-if", true),
      $setup.isRange && $setup.to !== $props.max ? (openBlock(), createElementBlock(
        "p",
        {
          key: 2,
          class: "txt-center txt-12 range-slider-position-txt opacity-0 line-height-1 absolute",
          style: normalizeStyle({ "--progress": `${$setup.toPercentage}` })
        },
        [
          createElementVNode(
            "span",
            null,
            toDisplayString($setup.to),
            1
            /* TEXT */
          )
        ],
        4
        /* STYLE */
      )) : createCommentVNode("v-if", true)
    ], 8, _hoisted_2$i),
    createElementVNode("p", _hoisted_6$8, [
      createElementVNode(
        "span",
        null,
        toDisplayString($props.min),
        1
        /* TEXT */
      ),
      createElementVNode(
        "span",
        null,
        toDisplayString($props.max),
        1
        /* TEXT */
      )
    ])
  ]);
}
const RangeInput = /* @__PURE__ */ _export_sfc(_sfc_main$A, [["render", _sfc_render$A], ["__scopeId", "data-v-8cb4198d"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/RangeInput.vue"]]);
const tableTools = [
  "mergeCells",
  "splitCells",
  "addRowBefore",
  "addRowAfter",
  "deleteRow",
  "insertColumnLeft",
  "insertColumnRight",
  "deleteColumn",
  "alignLeft",
  "alignCenter",
  "alignRight",
  "alignJustify",
  "deleteTable"
];
const defaultToolbarConfig = [
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "separator",
  "bold",
  "italic",
  "underline",
  "separator",
  "fontColor",
  "bgColor",
  "separator",
  "p",
  "blockquote",
  "orderedList",
  "unorderedList",
  "indent",
  "outdent",
  "separator",
  "link",
  "image",
  // 'youtube',
  "separator",
  "splitView",
  "clear",
  "insertTable",
  ...tableTools,
  "separator",
  "undo",
  "redo",
  "fullScreen"
];
const toolbarOptions = [
  { name: "h2", label: "h2", icon: "format_h2" },
  { name: "h3", label: "h3", icon: "format_h3" },
  { name: "h4", label: "h4", icon: "format_h4" },
  { name: "h5", label: "h5", icon: "format_h5" },
  { name: "h6", label: "h6", icon: "format_h6" },
  { name: "p", label: "Paragraph", icon: "format_paragraph" },
  { name: "blockquote", label: "Blockquote", icon: "format_quote" },
  { name: "bold", label: "Bold", icon: "format_bold" },
  { name: "italic", label: "Italic", icon: "format_italic" },
  { name: "underline", label: "Underline", icon: "format_underlined" },
  { name: "orderedList", label: "Ordered List", icon: "format_list_numbered" },
  { name: "unorderedList", label: "Unordered List", icon: "format_list_bulleted" },
  { name: "link", label: "Link", icon: "add_link" },
  { name: "image", label: "Image", icon: "add_photo_alternate" },
  { name: "youtube", label: "YouTube", icon: "youtube_activity" },
  { name: "splitView", label: "Split View", icon: "code" },
  { name: "clear", label: "Clear Formatting", icon: "format_clear" },
  { name: "alignLeft", label: "Align Left", icon: "format_align_left" },
  { name: "alignCenter", label: "Align Center", icon: "format_align_center" },
  { name: "alignRight", label: "Align Right", icon: "format_align_right" },
  { name: "alignJustify", label: "Align Justify", icon: "format_align_justify" },
  { name: "indent", label: "Indent", icon: "format_indent_increase" },
  { name: "outdent", label: "Outdent", icon: "format_indent_decrease" },
  { name: "fontColor", label: "Font Color", icon: "format_color_text" },
  { name: "bgColor", label: "Background Color", icon: "format_color_fill" },
  { name: "insertTable", label: "Insert Table", icon: "table" },
  { name: "deleteTable", label: "Delete Table", icon: "table_rows" },
  { name: "insertRowAbove", label: "Insert Row Above", icon: "table_rows" },
  { name: "insertRowBelow", label: "Insert Row Below", icon: "table_rows" },
  { name: "deleteRow", label: "Delete Row", icon: "table_rows" },
  { name: "insertColumnLeft", label: "Insert Column Left", icon: "add_column_left" },
  { name: "insertColumnRight", label: "Insert Column Right", icon: "add_column_right" },
  { name: "deleteColumn", label: "Delete Column", icon: "view_column" },
  { name: "separator" },
  { name: "undo", label: "Undo", icon: "undo" },
  { name: "redo", label: "Redo", icon: "redo" },
  { name: "separator" },
  { name: "fullScreen", label: "Full Screen", icon: "fullscreen", class: "ms-auto" }
];
const fb = 1;
const base = 5;
const _sfc_main$z = /* @__PURE__ */ defineComponent({
  __name: "gridBox",
  emits: ["select"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit2 = __emit;
    const hoveredRow = ref(fb);
    const hoveredCol = ref(fb);
    const rowSize = computed(() => {
      const enlarge = Math.min(hoveredRow.value + 1, 20);
      return hoveredRow.value > base - 1 ? enlarge : base;
    });
    const colSize = computed(() => {
      const enlarge = Math.min(hoveredCol.value + 1, 20);
      return hoveredCol.value > base - 1 ? enlarge : base;
    });
    const __returned__ = { emit: emit2, fb, base, hoveredRow, hoveredCol, rowSize, colSize };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$r = { class: "grid grid-wrap p-05" };
const _hoisted_2$h = ["onMousemove", "onClick"];
const _hoisted_3$d = { class: "txt-center txt-12 color-gray" };
function _sfc_render$z(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$r, [
    (openBlock(true), createElementBlock(
      Fragment,
      null,
      renderList($setup.rowSize, (row) => {
        return openBlock(), createElementBlock(
          "div",
          {
            key: `row-${row}`,
            class: "flex",
            onMouseout: _cache[0] || (_cache[0] = ($event) => {
              $setup.hoveredRow = $setup.fb;
              $setup.hoveredCol = $setup.fb;
            }),
            onFocusout: _cache[1] || (_cache[1] = ($event) => {
              $setup.hoveredRow = $setup.fb;
              $setup.hoveredCol = $setup.fb;
            })
          },
          [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.colSize, (col) => {
                return openBlock(), createElementBlock("div", {
                  key: `col-${col}`,
                  role: "button",
                  tabindex: "0",
                  "aria-label": "Insert Table",
                  style: { width: "20px", height: "20px" },
                  class: normalizeClass(["flex pointer gap-025 tableBoxSelect", { borderSelect: $setup.hoveredRow >= row && $setup.hoveredCol >= col }]),
                  onMousemove: ($event) => {
                    $setup.hoveredRow = row;
                    $setup.hoveredCol = col;
                  },
                  onClick: ($event) => $setup.emit("select", `${row}x${col}`)
                }, null, 42, _hoisted_2$h);
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ],
          32
          /* NEED_HYDRATION */
        );
      }),
      128
      /* KEYED_FRAGMENT */
    )),
    createElementVNode(
      "p",
      _hoisted_3$d,
      toDisplayString($setup.hoveredRow) + "x" + toDisplayString($setup.hoveredCol),
      1
      /* TEXT */
    )
  ]);
}
const GridBox = /* @__PURE__ */ _export_sfc(_sfc_main$z, [["render", _sfc_render$z], ["__scopeId", "data-v-c15cd1b3"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/RichText/components/gridBox.vue"]]);
const _sfc_main$y = /* @__PURE__ */ defineComponent({
  __name: "EditorToolbar",
  props: {
    config: { type: Array, required: false, default: defaultToolbarConfig },
    selectedStyles: { type: Set, required: true }
  },
  emits: ["action"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const emit2 = __emit;
    const configToOption = (action) => toolbarOptions.find((option2) => option2.name === action);
    function runAction(name, value) {
      emit2("action", name, value);
    }
    const __returned__ = { emit: emit2, configToOption, runAction, get Btn() {
      return Btn;
    }, get Dropdown() {
      return Dropdown;
    }, GridBox };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$q = {
  class: "toolbar flex gap-025 pb-05 flex-wrap",
  role: "toolbar"
};
function _sfc_render$y(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_tooltip = resolveDirective("tooltip");
  return openBlock(), createElementBlock("div", _hoisted_1$q, [
    (openBlock(true), createElementBlock(
      Fragment,
      null,
      renderList($props.config.map($setup.configToOption).filter(Boolean), (action, index2) => {
        return openBlock(), createElementBlock(
          Fragment,
          { key: index2 },
          [
            action.name === "insertTable" ? (openBlock(), createBlock($setup["Dropdown"], {
              key: 0,
              placement: "bottom-start",
              thin: "",
              flat: "",
              icon: "table"
            }, {
              default: withCtx(({ hide }) => [
                createVNode($setup["GridBox"], {
                  gridSize: 5,
                  onSelect: ($event) => {
                    var _a2;
                    $setup.runAction("insertTable", $event);
                    (_a2 = $event.target) == null ? void 0 : _a2.blur();
                    hide();
                  }
                }, null, 8, ["onSelect"])
              ]),
              _: 1
              /* STABLE */
            })) : action.name !== "separator" ? withDirectives((openBlock(), createBlock($setup["Btn"], {
              key: 1,
              icon: action.icon,
              thin: "",
              flat: "",
              "aria-label": action.name,
              class: normalizeClass([action.class, { active: $props.selectedStyles.has(action.name) }]),
              onClick: ($event) => $setup.runAction(action.name)
            }, null, 8, ["icon", "aria-label", "class", "onClick"])), [
              [_directive_tooltip, action.label]
            ]) : action.name === "separator" ? (openBlock(), createElementBlock("span", {
              key: `separator-${index2}`,
              class: "opacity-2 mb-025"
            }, "|")) : createCommentVNode("v-if", true)
          ],
          64
          /* STABLE_FRAGMENT */
        );
      }),
      128
      /* KEYED_FRAGMENT */
    ))
  ]);
}
const EditorToolbar = /* @__PURE__ */ _export_sfc(_sfc_main$y, [["render", _sfc_render$y], ["__scopeId", "data-v-6de33b3d"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/RichText/components/EditorToolbar.vue"]]);
function createCommandExecutor(state2, commands) {
  return {
    execute(command, value) {
      const cmd = commands[command];
      if (cmd) {
        cmd.execute(state2, value);
      }
    },
    isActive(command) {
      var _a2;
      const cmd = commands[command];
      return ((_a2 = cmd.isActive) == null ? void 0 : _a2.call(cmd, state2)) || false;
    },
    getValue(command) {
      var _a2;
      const cmd = commands[command];
      return ((_a2 = cmd.getValue) == null ? void 0 : _a2.call(cmd, state2)) || null;
    }
  };
}
function isStyleActive(style, doc) {
  const selection = doc.getSelection();
  if (!selection || !selection.rangeCount) return false;
  const range2 = selection.getRangeAt(0);
  const container = range2.commonAncestorContainer;
  const parent = container.nodeType === 3 ? container.parentElement : container;
  if (!parent) return false;
  const checkParent = (element, tags) => {
    if (!element) return false;
    if (tags.includes(element.tagName.toLowerCase())) return true;
    return checkParent(element.parentElement, tags);
  };
  const styleTags = {
    bold: ["strong", "b"],
    italic: ["em", "i"],
    underline: ["u"]
  };
  return checkParent(parent, styleTags[style] ?? [style]);
}
function analyzeSelection(doc, range2) {
  const container = range2.commonAncestorContainer;
  const parent = container.nodeType === 3 ? container.parentElement : container;
  if (!parent) return null;
  const startBlock = parent.closest("p,h1,h2,h3,h4,h5,h6,blockquote,li") || parent;
  const isMultiBlock = (() => {
    if (!range2.collapsed) {
      const { endContainer: endContainer2 } = range2;
      const endParent2 = endContainer2.nodeType === 3 ? endContainer2.parentElement : endContainer2;
      const endBlock2 = (endParent2 == null ? void 0 : endParent2.closest("p,h1,h2,h3,h4,h5,h6,blockquote,li")) || endParent2;
      return startBlock !== endBlock2;
    }
    return false;
  })();
  const { endContainer } = range2;
  const endParent = endContainer.nodeType === 3 ? endContainer.parentElement : endContainer;
  const endBlock = (endParent == null ? void 0 : endParent.closest("p,h1,h2,h3,h4,h5,h6,blockquote,li")) || endParent;
  if (!endBlock) return null;
  return {
    startBlock,
    endBlock,
    isMultiBlock,
    originalStart: range2.startContainer,
    originalEnd: range2.endContainer,
    originalStartOffset: range2.startOffset,
    originalEndOffset: range2.endOffset,
    parent
  };
}
function restoreSelection(doc, range2, selection, info, fallbackNode) {
  try {
    range2.setStart(info.originalStart, info.originalStartOffset);
    range2.setEnd(info.originalEnd, info.originalEndOffset);
  } catch (e) {
    if (fallbackNode) {
      range2.selectNodeContents(fallbackNode);
    }
  }
  selection.removeAllRanges();
  selection.addRange(range2);
}
function getBlocksBetween(startBlock, endBlock) {
  const blocks = [];
  let currentBlock = startBlock;
  while (currentBlock) {
    blocks.push(currentBlock);
    if (currentBlock === endBlock) break;
    currentBlock = currentBlock.nextElementSibling;
  }
  return blocks;
}
function formatting(state2) {
  const { doc } = state2;
  if (!doc) return { text: () => {
  }, block: () => {
  }, list: () => {
  }, clear: () => {
  } };
  const text = (command) => {
    const selection = doc.getSelection();
    if (!selection || !selection.rangeCount) return;
    const range2 = selection.getRangeAt(0);
    const container = range2.commonAncestorContainer;
    const parentBlock = container.nodeType === 3 ? container.parentElement : container;
    const isRTL = (parentBlock == null ? void 0 : parentBlock.closest('[dir="rtl"]')) !== null;
    if (parentBlock == null ? void 0 : parentBlock.tagName.match(/^H[1-6]|P|BLOCKQUOTE|LI$/)) {
      if (!range2.collapsed && range2.toString().trim()) {
        const span = doc.createElement("span");
        if (command === "underline") span.style.textDecoration = "underline";
        else if (command === "bold") span.style.fontWeight = "bold";
        else if (command === "italic") span.style.fontStyle = "italic";
        if (isRTL) span.dir = "rtl";
        range2.surroundContents(span);
      }
    } else {
      doc.execCommand(command, false);
    }
  };
  const block = (command, tag) => {
    var _a2, _b;
    const selection = doc.getSelection();
    if (!selection || !selection.rangeCount) return;
    const range2 = selection.getRangeAt(0);
    const container = range2.commonAncestorContainer;
    const parentBlock = container.nodeType === 3 ? container.parentElement : container;
    const isRTL = (parentBlock == null ? void 0 : parentBlock.closest('[dir="rtl"]')) !== null;
    if (parentBlock == null ? void 0 : parentBlock.closest("u, b, i")) {
      const wrapper = parentBlock.closest("u, b, i");
      if (wrapper) {
        const parent = wrapper.parentNode;
        while (wrapper.firstChild) {
          parent == null ? void 0 : parent.insertBefore(wrapper.firstChild, wrapper);
        }
        wrapper.remove();
      }
    }
    doc.execCommand("formatBlock", false, tag);
    if (isRTL) {
      const newBlock = (_b = (_a2 = selection.anchorNode) == null ? void 0 : _a2.parentElement) == null ? void 0 : _b.closest(tag.toLowerCase());
      if (newBlock) newBlock.dir = "rtl";
    }
  };
  const list = (command) => {
    var _a2, _b, _c, _d;
    if (!state2.doc || !state2.range || !state2.selection) return;
    const listTag = command === "orderedList" ? "ol" : "ul";
    const selectionInfo = analyzeSelection(state2.doc, state2.range);
    if (!selectionInfo) return;
    const isRTL = selectionInfo.parent.closest('[dir="rtl"]') !== null;
    const listItem = selectionInfo.parent.closest("li");
    if (listItem) {
      const listParent = listItem.parentElement;
      if (!listParent) return;
      if (listParent.tagName.toLowerCase() === listTag) {
        const p = state2.doc.createElement("p");
        if (isRTL) p.dir = "rtl";
        while (listItem.firstChild) {
          p.appendChild(listItem.firstChild);
        }
        (_a2 = listParent.parentNode) == null ? void 0 : _a2.insertBefore(p, listParent);
        listItem.remove();
        if (!listParent.querySelector("li")) {
          listParent.remove();
        }
        restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo, p);
        return;
      }
      const newList = state2.doc.createElement(listTag);
      if (isRTL) newList.dir = "rtl";
      const allItems = Array.from(listParent.children);
      allItems.forEach((item) => newList.appendChild(item.cloneNode(true)));
      (_b = listParent.parentNode) == null ? void 0 : _b.replaceChild(newList, listParent);
      const newListItem = newList.children[Array.from(allItems).indexOf(listItem)];
      restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo, newListItem);
      return;
    }
    if (!selectionInfo.isMultiBlock) {
      const li = state2.doc.createElement("li");
      const listEl2 = state2.doc.createElement(listTag);
      if (isRTL) listEl2.dir = "rtl";
      while (selectionInfo.startBlock.firstChild) {
        li.appendChild(selectionInfo.startBlock.firstChild);
      }
      listEl2.appendChild(li);
      (_c = selectionInfo.startBlock.parentNode) == null ? void 0 : _c.replaceChild(listEl2, selectionInfo.startBlock);
      restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo, li);
      return;
    }
    const blocks = getBlocksBetween(selectionInfo.startBlock, selectionInfo.endBlock);
    const listEl = state2.doc.createElement(listTag);
    if (isRTL) listEl.dir = "rtl";
    blocks.forEach((block2) => {
      if (!state2.doc) return;
      const li = state2.doc.createElement("li");
      while (block2.firstChild) {
        li.appendChild(block2.firstChild);
      }
      listEl.appendChild(li);
      block2.remove();
    });
    (_d = selectionInfo.startBlock.parentNode) == null ? void 0 : _d.insertBefore(listEl, selectionInfo.startBlock);
    restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo, listEl);
  };
  const clear = () => {
    if (!state2.doc || !state2.range || !state2.selection) return;
    const selectionInfo = analyzeSelection(state2.doc, state2.range);
    if (!selectionInfo) return;
    const inlineTags = ["b", "i", "u", "strong", "em", "span"];
    const fragment = state2.range.cloneContents();
    const tempDiv = state2.doc.createElement("div");
    tempDiv.appendChild(fragment);
    const cleanNode = (node) => {
      if (!state2.doc) return node;
      if (node.nodeType === 3) {
        return node.cloneNode(true);
      }
      if (node.nodeType === 1) {
        const el = node;
        const nodeName = el.nodeName.toLowerCase();
        if (inlineTags.includes(nodeName)) {
          return state2.doc.createTextNode(el.textContent || "");
        }
        const newEl = state2.doc.createElement(nodeName);
        newEl.removeAttribute("style");
        newEl.removeAttribute("class");
        Array.from(el.childNodes).forEach((child) => {
          newEl.appendChild(cleanNode(child));
        });
        return newEl;
      }
      return node.cloneNode(true);
    };
    const cleanedFragment = state2.doc.createDocumentFragment();
    Array.from(tempDiv.childNodes).forEach((node) => {
      cleanedFragment.appendChild(cleanNode(node));
    });
    state2.range.deleteContents();
    state2.range.insertNode(cleanedFragment);
    restoreSelection(state2.doc, state2.range, state2.selection, selectionInfo);
  };
  return { text, block, list, clear };
}
const { frmRow: frmRow$1, numField: numField$1 } = bagelFormUtils;
function insertImage(modal, state2) {
  const { range: range2, doc } = state2;
  if (!range2 || !doc) return;
  modal.showModalForm({
    title: "Upload Image",
    schema: [
      { id: "src", $el: "file", attrs: { bindkey: "url" } },
      { id: "alt", $el: "text", label: "Alt Text" },
      frmRow$1(
        numField$1("width", "Width", { min: 1 }),
        numField$1("height", "Height", { min: 1 })
      ),
      { id: "figcaption", $el: "check", label: "Show Caption" }
    ],
    onSubmit: (data2) => {
      if (data2.src) {
        const img = doc.createElement("img");
        Object.assign(img, {
          src: data2.src,
          alt: data2.alt || "",
          width: data2.width || void 0,
          height: data2.height || void 0
        });
        const node = data2.figcaption ? (() => {
          const figcaption = doc.createElement("figcaption");
          figcaption.textContent = data2.alt;
          const figure = doc.createElement("figure");
          figure.append(img, figcaption);
          return figure;
        })() : img;
        range2.collapse(false);
        range2.insertNode(node);
      }
    }
  });
}
function insertLink(modal, state2) {
  const { range: range2, doc } = state2;
  if (!range2 || !doc) return;
  modal.showModalForm({
    title: "Insert Link",
    schema: [
      { id: "url", $el: "text", label: "URL" },
      { id: "openInNewTab", $el: "check", label: "Open in new tab" }
    ],
    onSubmit: (data2) => {
      if (data2.url) {
        const anchor = doc.createElement("a");
        anchor.href = data2.url;
        if (data2.openInNewTab) anchor.target = "_blank";
        range2.surroundContents(anchor);
      }
    }
  });
}
function insertTable(rows, cols, state2) {
  if (!state2.doc) return;
  const table = state2.doc.createElement("table");
  table.style.width = "100%";
  table.style.borderCollapse = "collapse";
  for (let i = 0; i < rows; i++) {
    const row = table.insertRow();
    for (let j2 = 0; j2 < cols; j2++) {
      const cell = row.insertCell();
      cell.innerHTML = "&nbsp;";
    }
  }
  const { range: range2 } = state2;
  if (range2) {
    range2.insertNode(table);
  } else {
    state2.doc.body.appendChild(table);
  }
}
function mergeCells(range2, doc) {
  var _a2;
  const cells = Array.from(range2.cloneContents().querySelectorAll("td"));
  if (cells.length < 2) return;
  const firstCell = (_a2 = range2.startContainer.parentElement) == null ? void 0 : _a2.closest("td");
  if (!firstCell) return;
  firstCell.colSpan = cells.length;
  firstCell.innerHTML = cells.map((cell) => cell.innerHTML).join(" ");
  cells.slice(1).forEach((cell) => {
    const actualCell = doc.getElementById(cell.id);
    actualCell == null ? void 0 : actualCell.remove();
  });
}
function splitCell(range2, doc) {
  var _a2;
  const cell = (_a2 = range2.startContainer.parentElement) == null ? void 0 : _a2.closest("td");
  if (!cell || !cell.colSpan || cell.colSpan === 1) return;
  const newCells = new Array(cell.colSpan - 1).fill(0).map(() => {
    const newCell = doc.createElement("td");
    newCell.style.border = "1px solid var(--border-color)";
    newCell.style.padding = "8px";
    newCell.innerHTML = "&nbsp;";
    return newCell;
  });
  cell.colSpan = 1;
  cell.insertAdjacentElement("afterend", newCells[0]);
  newCells.slice(1).forEach((newCell) => {
    newCells[0].insertAdjacentElement("afterend", newCell);
  });
}
function addRow(position, range2, doc) {
  var _a2;
  const cell = (_a2 = range2.startContainer.parentElement) == null ? void 0 : _a2.closest("td");
  if (!cell) return;
  const row = cell.parentElement;
  const table = row == null ? void 0 : row.parentElement;
  if (!row || !table) return;
  const newRow = row.cloneNode(true);
  Array.from(newRow.cells).forEach((cell2) => cell2.innerHTML = "&nbsp;");
  row.insertAdjacentElement(position === "before" ? "beforebegin" : "afterend", newRow);
}
function deleteRow(range2) {
  var _a2;
  const cell = (_a2 = range2.startContainer.parentElement) == null ? void 0 : _a2.closest("td");
  if (!cell) return;
  const row = cell.parentElement;
  if (!row) return;
  row.remove();
}
function deleteTable(range2) {
  var _a2;
  const cell = (_a2 = range2.startContainer.parentElement) == null ? void 0 : _a2.closest("td");
  if (!cell) return;
  const table = cell.closest("table");
  if (!table) return;
  table.remove();
}
function insertColumn(position, range2) {
  var _a2;
  const cell = (_a2 = range2.startContainer.parentElement) == null ? void 0 : _a2.closest("td");
  if (!cell) return;
  const table = cell.closest("table");
  if (!table) return;
  const columnIndex = cell.cellIndex;
  const { rows } = table;
  for (let i = 0; i < rows.length; i++) {
    const newCell = rows[i].insertCell(position === "after" ? columnIndex + 1 : columnIndex);
    newCell.innerHTML = "&nbsp;";
    newCell.style.border = "1px solid var(--border-color)";
    newCell.style.padding = "8px";
  }
}
function deleteColumn(range2) {
  var _a2;
  const cell = (_a2 = range2.startContainer.parentElement) == null ? void 0 : _a2.closest("td");
  if (!cell) return;
  const table = cell.closest("table");
  if (!table) return;
  const columnIndex = cell.cellIndex;
  const { rows } = table;
  for (let i = 0; i < rows.length; i++) {
    rows[i].deleteCell(columnIndex);
  }
  if (rows[0].cells.length === 0) {
    table.remove();
  }
}
function alignColumn(range2, alignment) {
  var _a2;
  const cell = (_a2 = range2.startContainer.parentElement) == null ? void 0 : _a2.closest("td");
  if (!cell) return;
  const table = cell.closest("table");
  if (!table) return;
  const columnIndex = cell.cellIndex;
  const { rows } = table;
  for (let i = 0; i < rows.length; i++) {
    const cell2 = rows[i].cells[columnIndex];
    if (cell2) {
      cell2.style.textAlign = alignment;
    }
  }
}
function useCommands(state2, debug) {
  const format2 = () => formatting(state2);
  const commands = {
    // Text formatting commands
    bold: {
      name: "Bold",
      execute: (state22) => {
        format2().text("bold");
      },
      isActive: (state22) => state22.selectedStyles.has("bold")
    },
    italic: {
      name: "Italic",
      execute: (state22) => {
        format2().text("italic");
      },
      isActive: (state22) => state22.selectedStyles.has("italic")
    },
    underline: {
      name: "Underline",
      execute: (state22) => {
        format2().text("underline");
      },
      isActive: (state22) => state22.selectedStyles.has("underline")
    },
    // Block formatting commands
    h1: { name: "Heading 1", execute: (state22) => {
      format2().block("h1", "h1");
    }, isActive: (state22) => state22.selectedStyles.has("h1") },
    h2: { name: "Heading 2", execute: (state22) => {
      format2().block("h2", "h2");
    }, isActive: (state22) => state22.selectedStyles.has("h2") },
    h3: { name: "Heading 3", execute: (state22) => {
      format2().block("h3", "h3");
    }, isActive: (state22) => state22.selectedStyles.has("h3") },
    h4: { name: "Heading 4", execute: (state22) => {
      format2().block("h4", "h4");
    }, isActive: (state22) => state22.selectedStyles.has("h4") },
    h5: { name: "Heading 5", execute: (state22) => {
      format2().block("h5", "h5");
    }, isActive: (state22) => state22.selectedStyles.has("h5") },
    h6: { name: "Heading 6", execute: (state22) => {
      format2().block("h6", "h6");
    }, isActive: (state22) => state22.selectedStyles.has("h6") },
    p: { name: "Paragraph", execute: (state22) => {
      format2().block("p", "p");
    }, isActive: (state22) => state22.selectedStyles.has("p") },
    blockquote: {
      name: "Blockquote",
      execute: (state22) => {
        format2().block("blockquote", "blockquote");
      },
      isActive: (state22) => state22.selectedStyles.has("blockquote")
    },
    // List commands
    orderedList: {
      name: "Ordered List",
      execute: (state22) => {
        format2().list("orderedList");
      },
      isActive: (state22) => state22.selectedStyles.has("orderedList")
    },
    unorderedList: {
      name: "Unordered List",
      execute: (state22) => {
        format2().list("unorderedList");
      },
      isActive: (state22) => state22.selectedStyles.has("unorderedList")
    },
    // Table commands
    insertTable: {
      name: "Insert Table",
      execute: (state22, value) => {
        const [rows, cols] = (value == null ? void 0 : value.split("x").map(Number)) || [3, 3];
        insertTable(rows, cols, state22);
      }
    },
    deleteTable: { name: "Delete Table", execute: (state22) => state22.range && deleteTable(state22.range) },
    mergeCells: { name: "Merge Cells", execute: (state22) => state22.range && state22.doc && mergeCells(state22.range, state22.doc) },
    splitCells: { name: "Split Cells", execute: (state22) => state22.range && state22.doc && splitCell(state22.range, state22.doc) },
    addRowBefore: { name: "Add Row Before", execute: (state22) => state22.range && state22.doc && addRow("before", state22.range, state22.doc) },
    addRowAfter: { name: "Add Row After", execute: (state22) => state22.range && state22.doc && addRow("after", state22.range, state22.doc) },
    deleteRow: { name: "Delete Row", execute: (state22) => state22.range && deleteRow(state22.range) },
    insertColumnLeft: { name: "Insert Column Left", execute: (state22) => state22.range && insertColumn("before", state22.range) },
    insertColumnRight: { name: "Insert Column Right", execute: (state22) => state22.range && insertColumn("after", state22.range) },
    deleteColumn: { name: "Delete Column", execute: (state22) => state22.range && deleteColumn(state22.range) },
    // Alignment commands
    alignLeft: { name: "Align Left", execute: (state22) => state22.range && alignColumn(state22.range, "left") },
    alignCenter: { name: "Align Center", execute: (state22) => state22.range && alignColumn(state22.range, "center") },
    alignRight: { name: "Align Right", execute: (state22) => state22.range && alignColumn(state22.range, "right") },
    alignJustify: { name: "Align Justify", execute: (state22) => state22.range && alignColumn(state22.range, "justify") },
    // Media commands
    image: { name: "Insert Image", execute: (state22) => state22.modal && insertImage(state22.modal, state22) },
    link: { name: "Insert Link", execute: (state22) => state22.modal && state22.range && insertLink(state22.modal, state22) },
    // Other commands
    clear: { name: "Clear Formatting", execute: (state22) => {
      format2().clear();
    } },
    indent: { name: "Indent", execute: (state22) => {
      format2().text("indent");
    } },
    outdent: { name: "Outdent", execute: (state22) => {
      format2().text("outdent");
    } },
    fullScreen: {
      name: "Full Screen",
      execute: (state22) => {
        state22.isFullscreen = !state22.isFullscreen;
      },
      isActive: (state22) => state22.isFullscreen
    },
    splitView: {
      name: "Split View",
      execute: (state22) => {
        state22.isSplitView = !state22.isSplitView;
      },
      isActive: (state22) => state22.isSplitView
    },
    codeView: {
      name: "Code View",
      execute: (state22) => {
        state22.isCodeView = !state22.isCodeView;
      },
      isActive: (state22) => state22.isCodeView
    }
  };
  const executor = createCommandExecutor(state2, commands);
  return {
    execute: (command, value) => {
      debug == null ? void 0 : debug.logCommand(command, value);
      executor.execute(command, value);
    },
    isActive: executor.isActive,
    getValue: executor.getValue
  };
}
function useEditor() {
  const editorDebugger = ref();
  const modal = useModal();
  const state2 = reactive({
    content: "",
    doc: void 0,
    selection: null,
    selectedStyles: /* @__PURE__ */ new Set(),
    isFullscreen: false,
    isSplitView: false,
    isCodeView: false,
    hasInit: false,
    undoStack: [],
    redoStack: [],
    rangeCount: 0,
    range: null,
    modal
  });
  function updateActiveStyles() {
    if (!state2.doc) return;
    const styles = /* @__PURE__ */ new Set();
    const styleTypes = [
      "bold",
      "italic",
      "underline",
      "h1",
      "h2",
      "h3",
      "h4",
      "h5",
      "h6",
      "blockquote",
      "table",
      "p",
      "ol",
      "li"
    ];
    styleTypes.forEach((style) => {
      if (state2.doc && isStyleActive(style, state2.doc)) {
        styles.add(style);
      }
    });
    state2.selectedStyles = styles;
  }
  function updateContent(source) {
    if (!state2.doc) return;
    state2.undoStack.push(state2.content);
    state2.redoStack = [];
    if (source === "html") {
      state2.doc.body.innerHTML = state2.content;
    } else {
      state2.doc.body.textContent = state2.content;
    }
    updateActiveStyles();
  }
  function updateSelection() {
    if (!state2.doc) return;
    state2.selection = state2.doc.getSelection();
    if (!state2.selection) return;
    try {
      if (!state2.doc.body.contains(state2.selection.anchorNode)) {
        state2.doc.body.focus();
        return;
      }
      state2.rangeCount = state2.selection.rangeCount;
      if (!state2.rangeCount) {
        const range2 = state2.doc.createRange();
        range2.selectNodeContents(state2.doc.body);
        range2.collapse(false);
        state2.selection.removeAllRanges();
        state2.selection.addRange(range2);
      }
      state2.range = state2.selection.getRangeAt(0).cloneRange();
      updateActiveStyles();
    } catch (e) {
      console.warn("Selection error:", e);
      state2.selection = null;
      state2.range = null;
      state2.rangeCount = 0;
      state2.selectedStyles = /* @__PURE__ */ new Set();
    }
  }
  function setupEventListeners(doc) {
    doc.addEventListener("input", () => {
      state2.content = doc.body.innerHTML;
      updateActiveStyles();
    });
    doc.addEventListener("selectionchange", () => {
      updateSelection();
    });
    doc.addEventListener("mouseup", () => {
      updateSelection();
    });
    doc.addEventListener("keyup", (e) => {
      if (["ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight"].includes(e.key)) {
        updateSelection();
      }
    });
    const cleanEmptyTags = () => {
      var _a2, _b;
      const walker = doc.createTreeWalker(
        doc.body,
        NodeFilter.SHOW_ELEMENT,
        null
      );
      const nodesToRemove = [];
      let node = walker.nextNode();
      while (node) {
        if (["br", "img", "hr", "input"].includes(node.tagName.toLowerCase())) {
          node = walker.nextNode();
          continue;
        }
        const textContent = ((_a2 = node.textContent) == null ? void 0 : _a2.trim()) || "";
        const innerHTML = node.innerHTML.trim();
        const hasOnlyBr = innerHTML === "<br>" || innerHTML === "<br/>";
        const hasOnlyNbsp = innerHTML === "&nbsp;" || textContent === " ";
        const isEmpty = !textContent && !innerHTML;
        const isDirectChildOfBody = node.parentElement === doc.body;
        if (isEmpty || hasOnlyNbsp || hasOnlyBr && !isDirectChildOfBody) {
          if (isDirectChildOfBody) {
            if (!node.matches("p")) {
              const p = doc.createElement("p");
              p.innerHTML = "<br>";
              (_b = node.parentNode) == null ? void 0 : _b.replaceChild(p, node);
            }
          } else {
            nodesToRemove.push(node);
          }
        }
        node = walker.nextNode();
      }
      nodesToRemove.forEach((node2) => {
        node2.remove();
      });
    };
    const observer = new MutationObserver(() => {
      cleanEmptyTags();
    });
    observer.observe(doc.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }
  function init(doc) {
    state2.doc = doc;
    state2.hasInit = true;
    setupEventListeners(doc);
    updateContent("html");
  }
  function handleUndo() {
    if (state2.undoStack.length === 0) return;
    state2.redoStack.push(state2.content);
    const lastContent = state2.undoStack.pop();
    if (lastContent !== void 0) {
      state2.content = lastContent;
      updateContent("html");
    }
  }
  function handleRedo() {
    if (state2.redoStack.length === 0) return;
    state2.undoStack.push(state2.content);
    const nextContent = state2.redoStack.pop();
    if (nextContent !== void 0) {
      state2.content = nextContent;
      updateContent("html");
    }
  }
  function handleToolbarAction(action, value) {
    if (!state2.doc) return;
    if (action === "undo") {
      handleUndo();
      return;
    }
    if (action === "redo") {
      handleRedo();
      return;
    }
    if (action === "fullScreen") {
      state2.isFullscreen = !state2.isFullscreen;
      return;
    }
    if (action === "splitView") {
      state2.isSplitView = !state2.isSplitView;
      return;
    }
    if (action === "codeView") {
      state2.isCodeView = !state2.isCodeView;
      return;
    }
    const format2 = formatting(state2);
    state2.doc.body.focus();
    switch (action) {
      case "bold":
      case "italic":
      case "underline":
        format2.text(action);
        break;
      case "orderedList":
        format2.list("ol");
        break;
      case "unorderedList":
        format2.list("ul");
        break;
      case "blockquote":
      case "p":
      case "h1":
      case "h2":
      case "h3":
      case "h4":
      case "h5":
      case "h6":
        format2.block(action, action);
        break;
      case "insertTable": {
        const [rows, cols] = (value == null ? void 0 : value.split("x").map(Number)) || [3, 3];
        insertTable(rows, cols, state2);
        break;
      }
      case "deleteTable":
        if (state2.range) deleteTable(state2.range);
        break;
      case "mergeCells":
        if (state2.range && state2.doc) mergeCells(state2.range, state2.doc);
        break;
      case "splitCells":
        if (state2.range && state2.doc) splitCell(state2.range, state2.doc);
        break;
      case "addRowBefore":
      case "addRowAfter":
        if (state2.range && state2.doc) {
          addRow(action === "addRowBefore" ? "before" : "after", state2.range, state2.doc);
        }
        break;
      case "deleteRow":
        if (state2.range) deleteRow(state2.range);
        break;
      case "insertColumnLeft":
      case "insertColumnRight":
        if (state2.range) {
          insertColumn(action === "insertColumnLeft" ? "before" : "after", state2.range);
        }
        break;
      case "deleteColumn":
        if (state2.range) deleteColumn(state2.range);
        break;
      case "alignLeft":
      case "alignCenter":
      case "alignRight":
      case "alignJustify":
        if (state2.range) {
          alignColumn(state2.range, action.replace("align", "").toLowerCase());
        }
        break;
      case "clear":
        format2.clear();
        break;
      default:
        format2.text(action);
    }
    updateContent("html");
  }
  const getDebugSession = () => {
    var _a2;
    return (_a2 = editorDebugger.value) == null ? void 0 : _a2.getSession();
  };
  const clearDebugSession = () => {
    var _a2;
    return (_a2 = editorDebugger.value) == null ? void 0 : _a2.clearSession();
  };
  const downloadDebugSession = () => {
    var _a2;
    return (_a2 = editorDebugger.value) == null ? void 0 : _a2.downloadSession();
  };
  const logCommand = (command, value) => {
    var _a2;
    return (_a2 = editorDebugger.value) == null ? void 0 : _a2.logCommand(command, value, state2);
  };
  const exportDebugWithPrompt = (message2) => {
    var _a2;
    return (_a2 = editorDebugger.value) == null ? void 0 : _a2.exportSessionWithPrompt(message2);
  };
  return {
    state: state2,
    init,
    handleToolbarAction,
    updateContent,
    handleUndo,
    handleRedo,
    // Debug methods
    debug: {
      getSession: getDebugSession,
      clearSession: clearDebugSession,
      downloadSession: downloadDebugSession,
      logCommand,
      exportDebugWithPrompt
    }
  };
}
function useEditorKeyboard(doc, handleToolbarAction) {
  doc.addEventListener("keydown", (e) => {
    if (e.ctrlKey || e.metaKey) {
      switch (e.key) {
        case "b":
          e.preventDefault();
          handleToolbarAction("bold");
          break;
        case "i":
          e.preventDefault();
          handleToolbarAction("italic");
          break;
        case "u":
          e.preventDefault();
          handleToolbarAction("underline");
          break;
        case "z":
          e.preventDefault();
          if (e.shiftKey) {
            handleToolbarAction("redo");
          } else {
            handleToolbarAction("undo");
          }
          break;
        case "y":
          e.preventDefault();
          handleToolbarAction("redo");
          break;
        // List shortcuts
        case ".":
          if (e.shiftKey) {
            e.preventDefault();
            handleToolbarAction("orderedList");
          }
          break;
        case "/":
          if (e.shiftKey) {
            e.preventDefault();
            handleToolbarAction("unorderedList");
          }
          break;
        // Heading shortcuts
        case "1":
        case "2":
        case "3":
        case "4":
        case "5":
        case "6":
          if (e.altKey) {
            e.preventDefault();
            handleToolbarAction(`h${e.key}`);
          }
          break;
        // Indentation
        case "]":
          e.preventDefault();
          handleToolbarAction("indent");
          break;
        case "[":
          e.preventDefault();
          handleToolbarAction("outdent");
          break;
      }
    }
  });
}
const _sfc_main$x = /* @__PURE__ */ defineComponent({
  __name: "index",
  props: {
    modelValue: { type: String, required: true },
    toolbarConfig: { type: Array, required: false },
    debug: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const iframe = ref();
    const editor = useEditor();
    const commands = useCommands(editor.state, props2.debug ? editor.debug : void 0);
    const debugMethods = computed(() => props2.debug ? editor.debug : void 0);
    async function initEditor() {
      var _a2;
      if (!iframe.value) {
        setTimeout(initEditor, 100);
        return;
      }
      editor.state.content = props2.modelValue || "";
      const doc = iframe.value.contentDocument || ((_a2 = iframe.value.contentWindow) == null ? void 0 : _a2.document);
      if (!doc) return;
      doc.designMode = "on";
      doc.body.contentEditable = "true";
      const hasRTL = /[\u0591-\u07FF\uFB1D-\uFDFD\uFE70-\uFEFC]/.test(props2.modelValue);
      doc.body.dir = hasRTL ? "rtl" : "ltr";
      const style = doc.createElement("style");
      style.textContent = (await import("./editor-BKPRpAjr.js")).default;
      doc.head.appendChild(style);
      editor.init(doc);
      useEditorKeyboard(doc, commands.execute);
      if (!doc.body.firstElementChild) {
        const p = doc.createElement("p");
        p.dir = doc.body.dir;
        p.innerHTML = "<br>";
        doc.body.appendChild(p);
      } else {
        const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
        const textNodes = [];
        let node;
        while (node = walker.nextNode()) {
          if (node.parentElement === doc.body) {
            textNodes.push(node);
          }
        }
        textNodes.forEach((textNode) => {
          var _a3;
          if ((_a3 = textNode.textContent) == null ? void 0 : _a3.trim()) {
            const p = doc.createElement("p");
            p.dir = doc.body.dir;
            p.appendChild(textNode.cloneNode());
            doc.body.replaceChild(p, textNode);
          } else {
            doc.body.removeChild(textNode);
          }
        });
      }
      doc.body.focus();
    }
    watch(() => props2.modelValue, (newValue) => {
      if (newValue !== editor.state.content) {
        editor.state.content = newValue;
        editor.updateContent("html");
      }
    });
    watch(() => editor.state.content, (newValue) => {
      emit2("update:modelValue", newValue);
    });
    const __returned__ = { props: props2, emit: emit2, iframe, editor, commands, debugMethods, initEditor, get CodeEditor() {
      return CodeEditor;
    }, get copyText() {
      return copyText;
    }, get Btn() {
      return Btn;
    }, EditorToolbar };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$p = { class: "content-area radius-05" };
const _hoisted_2$g = {
  key: 1,
  class: "flex"
};
function _sfc_render$x(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b;
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["rich-text-editor rounded pt-05 px-05 pb-075 mb-05", { "fullscreen-mode": $setup.editor.state.isFullscreen }])
    },
    [
      $setup.editor.state.hasInit ? (openBlock(), createBlock($setup["EditorToolbar"], {
        key: 0,
        config: $props.toolbarConfig,
        selectedStyles: $setup.editor.state.selectedStyles,
        onAction: $setup.commands.execute
      }, null, 8, ["config", "selectedStyles", "onAction"])) : createCommentVNode("v-if", true),
      createElementVNode(
        "div",
        {
          class: normalizeClass(["editor-container", { "split-view": $setup.editor.state.isSplitView }])
        },
        [
          createElementVNode("div", _hoisted_1$p, [
            createElementVNode(
              "iframe",
              {
                id: "rich-text-iframe",
                ref: "iframe",
                class: "editableContent",
                title: "Editor",
                onLoad: $setup.initEditor
              },
              null,
              544
              /* NEED_HYDRATION, NEED_PATCH */
            )
          ]),
          $setup.editor.state.isSplitView ? (openBlock(), createBlock($setup["CodeEditor"], {
            key: 0,
            modelValue: $setup.editor.state.content,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event) => $setup.editor.state.content = $event),
              _cache[1] || (_cache[1] = ($event) => $setup.editor.updateContent("html"))
            ],
            language: "html"
          }, null, 8, ["modelValue"])) : createCommentVNode("v-if", true)
        ],
        2
        /* CLASS */
      ),
      $props.debug ? (openBlock(), createElementBlock("div", _hoisted_2$g, [
        _cache[6] || (_cache[6] = createElementVNode(
          "p",
          { class: "text12 txt-gray mb-0 p-0" },
          " Debug ",
          -1
          /* HOISTED */
        )),
        createVNode($setup["Btn"], {
          thin: "",
          color: "gray",
          icon: "delete",
          onClick: (_a2 = $setup.debugMethods) == null ? void 0 : _a2.clearSession
        }, {
          default: withCtx(() => _cache[3] || (_cache[3] = [
            createTextVNode(" Clear Session ")
          ])),
          _: 1
          /* STABLE */
        }, 8, ["onClick"]),
        createVNode($setup["Btn"], {
          thin: "",
          color: "gray",
          icon: "download",
          onClick: (_b = $setup.debugMethods) == null ? void 0 : _b.downloadSession
        }, {
          default: withCtx(() => _cache[4] || (_cache[4] = [
            createTextVNode(" Download Log ")
          ])),
          _: 1
          /* STABLE */
        }, 8, ["onClick"]),
        createVNode($setup["Btn"], {
          thin: "",
          color: "gray",
          icon: "content_copy",
          onClick: _cache[2] || (_cache[2] = ($event) => {
            var _a3;
            return $setup.copyText(((_a3 = $setup.debugMethods) == null ? void 0 : _a3.exportDebugWithPrompt()) || "");
          })
        }, {
          default: withCtx(() => _cache[5] || (_cache[5] = [
            createTextVNode(" Copy Log ")
          ])),
          _: 1
          /* STABLE */
        })
      ])) : createCommentVNode("v-if", true)
    ],
    2
    /* CLASS */
  );
}
const RichText = /* @__PURE__ */ _export_sfc(_sfc_main$x, [["render", _sfc_render$x], ["__scopeId", "data-v-6e688c3a"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/RichText/index.vue"]]);
const _sfc_main$w = /* @__PURE__ */ defineComponent({
  __name: "SelectInput",
  props: {
    options: { type: Array, required: true },
    placeholder: { type: String, required: false, default: "Select" },
    disabled: { type: Boolean, required: false },
    modelValue: { type: [String, Number, Object], required: false },
    searchable: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    label: { type: String, required: false },
    fullWidth: { type: Boolean, required: false },
    multiselect: { type: Boolean, required: false },
    icon: { type: null, required: false },
    hideLabel: { type: Boolean, required: false },
    defaultValue: { type: [String, Number, Object], required: false },
    clearable: { type: Boolean, required: false },
    searchPlaceholder: { type: String, required: false, default: "Search" },
    onSearch: { type: Function, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const searchPlaceholder = computed(() => props2.searchPlaceholder);
    const searchInput = ref();
    let selectedItems = ref([]);
    const selectedItemCount = computed(() => selectedItems.value.length ?? 0);
    const search = ref("");
    const dropdown = ref();
    let selected = ref(false);
    let open = ref(false);
    const selectedLabel = computed(() => {
      if (selectedItemCount.value === 0) return props2.placeholder;
      if (selectedItemCount.value > 4) {
        const str = selectedItems.value.slice(0, 4).map((item) => getLabel(item)).join(", ");
        return `${str}... +${selectedItemCount.value - 4}`;
      }
      return selectedItems.value.map((item) => getLabel(item)).join(", ");
    });
    let serverOptions = ref([]);
    let isSearching = ref(false);
    async function runServerSearch() {
      if (props2.onSearch !== void 0) {
        isSearching.value = true;
        serverOptions.value = await props2.onSearch(search.value);
        isSearching.value = false;
      }
    }
    const filteredOptions = computed(() => {
      if (props2.onSearch !== void 0) {
        if (isSearching.value) return [];
        if (search.value.trim().length) return serverOptions.value;
        return props2.options;
      }
      return props2.options.filter((option2) => {
        const searchTerm = search.value.split(/\s+/).filter(Boolean).map((t) => new RegExp(t.replaceAll(/[.*+?^${}()|[\]\\]/g, "\\$&"), "gi"));
        return Boolean(option2) && searchTerm.every((s) => getLabel(option2).match(s));
      });
    });
    let highlightedIndex = ref(-1);
    const selectOptions = ref();
    function navigate(direction) {
      if (!open.value) {
        open.value = true;
        setTimeout(() => {
          navigate(direction);
        }, 210);
        return;
      }
      if (direction === "up") {
        highlightedIndex.value = highlightedIndex.value > 0 ? highlightedIndex.value - 1 : filteredOptions.value.length - 1;
      } else if (direction === "down") {
        highlightedIndex.value = highlightedIndex.value < filteredOptions.value.length - 1 ? highlightedIndex.value + 1 : 0;
      }
      setTimeout(() => {
        var _a2;
        const el = (_a2 = selectOptions.value) == null ? void 0 : _a2.children[highlightedIndex.value];
        if (el) el.focus();
        else highlightedIndex.value = -1;
      }, 10);
    }
    const isSelected = (option2) => selectedItems.value.find((item) => getValue(option2) === getValue(item)) !== void 0;
    function getLabel(option2) {
      if (!option2) return "";
      if (typeof option2 === "string") return option2;
      if (typeof option2 === "number") return `${option2}`;
      return option2.label;
    }
    function getValue(option2) {
      if (!option2) return;
      if (typeof option2 === "string") return option2;
      if (typeof option2 === "number") return option2;
      return option2.value;
    }
    function focusInput() {
      open.value = true;
      setTimeout(() => {
        if (searchInput.value) searchInput.value.focus();
      }, 10);
    }
    function select2(option2) {
      selected.value = true;
      const existingIndex = selectedItems.value.findIndex(
        (item) => getValue(item) === getValue(option2)
      );
      if (existingIndex > -1) {
        selectedItems.value.splice(existingIndex, 1);
      } else if (props2.multiselect) {
        const current = [...selectedItems.value];
        current.push(option2);
        selectedItems.value = current;
      } else {
        selectedItems.value.splice(0, selectedItemCount.value, option2);
      }
      if (!props2.multiselect) open.value = false;
      emitUpdate();
    }
    function emitUpdate() {
      if (props2.multiselect) {
        emit2("update:modelValue", selectedItems.value.map(getValue).filter(Boolean));
      } else {
        const [item] = selectedItems.value;
        emit2("update:modelValue", getValue(item));
      }
    }
    function compareArrays(arr1, arr2) {
      const arr1Values = [...arr1].map((a) => getValue(a)).filter(Boolean);
      const arr2Values = [...arr2].map((a) => getValue(a)).filter(Boolean);
      const isSame = arr1Values.every((item) => arr2Values.includes(item));
      return isSame;
    }
    watch(
      () => props2.modelValue,
      (newVal) => {
        if (!props2.multiselect) {
          const newOption = props2.options.find((o) => getValue(o) === newVal) ?? newVal;
          if (newOption && !isSelected(newOption)) selectedItems.value = [newOption];
        } else {
          const isSame = compareArrays([newVal].flat(), selectedItems.value);
          if (!isSame) {
            selectedItems.value.splice(0, selectedItemCount.value, ...[newVal].flat());
          }
        }
      },
      { immediate: true }
    );
    watch(() => open.value, (value) => {
      if (value) {
        highlightedIndex.value = -1;
      }
    });
    watch(
      () => props2.options,
      () => {
        selectedItems.value.forEach((option2, i) => {
          const exists = props2.options.find(
            (o) => getValue(o) === getValue(option2)
          );
          if (exists === void 0) selectedItems.value.splice(i, 1);
          else selectedItems.value.splice(i, 1, exists);
        });
      },
      { deep: true, immediate: true }
    );
    onMounted(() => {
      if (props2.defaultValue !== void 0) {
        const defaultOption = props2.options.find(
          (o) => getValue(o) === getValue(props2.defaultValue)
        );
        if (defaultOption === void 0) return;
        selectedItems.value = [defaultOption];
      }
    });
    const __returned__ = { props: props2, emit: emit2, searchPlaceholder, searchInput, get selectedItems() {
      return selectedItems;
    }, set selectedItems(v) {
      selectedItems = v;
    }, selectedItemCount, search, dropdown, get selected() {
      return selected;
    }, set selected(v) {
      selected = v;
    }, get open() {
      return open;
    }, set open(v) {
      open = v;
    }, selectedLabel, get serverOptions() {
      return serverOptions;
    }, set serverOptions(v) {
      serverOptions = v;
    }, get isSearching() {
      return isSearching;
    }, set isSearching(v) {
      isSearching = v;
    }, runServerSearch, filteredOptions, get highlightedIndex() {
      return highlightedIndex;
    }, set highlightedIndex(v) {
      highlightedIndex = v;
    }, selectOptions, navigate, isSelected, getLabel, getValue, focusInput, select: select2, emitUpdate, compareArrays, get Btn() {
      return Btn;
    }, get Card() {
      return Card;
    }, get Skeleton() {
      return Skeleton;
    }, get Dropdown() {
      return Dropdown;
    }, get Icon() {
      return Icon;
    }, get TextInput() {
      return TextInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$o = { class: "flex gap-05" };
const _hoisted_2$f = ["disabled"];
const _hoisted_3$c = { key: 1 };
const _hoisted_4$8 = {
  key: 2,
  class: "ms-auto ps-05 me-05"
};
const _hoisted_5$8 = ["value"];
const _hoisted_6$7 = ["aria-selected", "onClick", "onKeydown"];
const _hoisted_7$4 = { class: "block" };
function _sfc_render$w(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["Dropdown"], {
    ref: "dropdown",
    shown: $setup.open,
    "onUpdate:shown": _cache[9] || (_cache[9] = ($event) => $setup.open = $event),
    placement: "bottom-start",
    class: "bagel-input selectinput",
    "no-auto-focus": ""
  }, {
    trigger: withCtx(() => [
      createElementVNode("label", null, [
        createTextVNode(
          toDisplayString($props.label) + " ",
          1
          /* TEXT */
        ),
        createElementVNode("div", _hoisted_1$o, [
          $props.searchable && $setup.open ? (openBlock(), createBlock($setup["TextInput"], {
            key: 0,
            ref: "searchInput",
            modelValue: $setup.search,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.search = $event),
            class: "mb-0",
            placeholder: $setup.searchPlaceholder,
            icon: "search",
            onDebounce: $setup.runServerSearch,
            onInput: _cache[1] || (_cache[1] = ($event) => $setup.selected = false),
            onClick: $setup.focusInput,
            onKeydown: [
              _cache[2] || (_cache[2] = withKeys(withModifiers(($event) => $setup.navigate("down"), ["prevent"]), ["down"])),
              _cache[3] || (_cache[3] = withKeys(withModifiers(($event) => $setup.navigate("up"), ["prevent"]), ["up"]))
            ]
          }, null, 8, ["modelValue", "placeholder"])) : (openBlock(), createElementBlock("button", {
            key: 1,
            disabled: $props.disabled,
            type: "button",
            class: normalizeClass(["selectinput-btn", { isEmpty: $setup.selectedItemCount === 0 }]),
            onKeydown: [
              _cache[5] || (_cache[5] = withKeys(withModifiers(($event) => $setup.navigate("down"), ["prevent"]), ["down"])),
              _cache[6] || (_cache[6] = withKeys(withModifiers(($event) => $setup.navigate("up"), ["prevent"]), ["up"]))
            ]
          }, [
            $props.icon ? (openBlock(), createBlock($setup["Icon"], {
              key: 0,
              icon: $props.icon
            }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
            !$props.hideLabel ? (openBlock(), createElementBlock(
              "p",
              _hoisted_3$c,
              toDisplayString($setup.selectedLabel),
              1
              /* TEXT */
            )) : createCommentVNode("v-if", true),
            $props.clearable && $setup.selectedItemCount > 0 ? (openBlock(), createElementBlock("div", _hoisted_4$8, [
              createVNode($setup["Btn"], {
                flat: "",
                thin: "",
                icon: "clear",
                class: "color-gray",
                onClick: _cache[4] || (_cache[4] = ($event) => {
                  $setup.selectedItems = [];
                  $setup.emitUpdate();
                })
              })
            ])) : createCommentVNode("v-if", true),
            !$props.disabled ? (openBlock(), createBlock(
              $setup["Icon"],
              mergeProps({
                key: 3,
                thin: ""
              }, { icon: $setup.open ? "unfold_less" : "unfold_more" }),
              null,
              16
              /* FULL_PROPS */
            )) : createCommentVNode("v-if", true)
          ], 42, _hoisted_2$f)),
          $props.required ? (openBlock(), createElementBlock("input", {
            key: 2,
            tabindex: "-1",
            style: { "width": "0", "height": "0", "position": "absolute", "opacity": "0", "z-index": "-1" },
            value: $setup.selectedItems,
            required: ""
          }, null, 8, _hoisted_5$8)) : createCommentVNode("v-if", true)
        ])
      ])
    ]),
    default: withCtx(() => [
      $setup.isSearching ? (openBlock(), createBlock($setup["Skeleton"], {
        key: 0,
        count: 6,
        width: "200px",
        height: "25px",
        class: "mx-1 my-1"
      })) : createCommentVNode("v-if", true),
      createVNode($setup["Card"], {
        class: "p-05",
        style: normalizeStyle({ width: $props.fullWidth ? "100%" : "auto" })
      }, {
        default: withCtx(() => [
          createElementVNode(
            "div",
            {
              ref: "selectOptions",
              class: normalizeClass(["selectinput-options", { multiselect: $props.multiselect }])
            },
            [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList($setup.filteredOptions, (option2, i) => {
                  return openBlock(), createElementBlock("div", {
                    key: `${option2}${i}`,
                    class: normalizeClass(["selectinput-option hover gap-1 align-items-center", { selected: $setup.isSelected(option2) }]),
                    role: "option",
                    tabindex: "0",
                    "aria-selected": $setup.isSelected(option2),
                    onClick: ($event) => $setup.select(option2),
                    onKeydown: [
                      withKeys(($event) => $setup.select(option2), ["enter"]),
                      _cache[7] || (_cache[7] = withKeys(withModifiers(($event) => $setup.navigate("down"), ["prevent"]), ["down"])),
                      _cache[8] || (_cache[8] = withKeys(withModifiers(($event) => $setup.navigate("up"), ["prevent"]), ["up"]))
                    ]
                  }, [
                    $props.multiselect ? (openBlock(), createElementBlock(
                      Fragment,
                      { key: 0 },
                      [
                        $setup.isSelected(option2) ? (openBlock(), createBlock($setup["Icon"], {
                          key: 0,
                          size: 1.1,
                          icon: "select_check_box"
                        })) : createCommentVNode("v-if", true),
                        !$setup.isSelected(option2) ? (openBlock(), createBlock($setup["Icon"], {
                          key: 1,
                          class: "opacity-3",
                          icon: "check_box_outline_blank",
                          size: 1.1
                        })) : createCommentVNode("v-if", true)
                      ],
                      64
                      /* STABLE_FRAGMENT */
                    )) : createCommentVNode("v-if", true),
                    createElementVNode(
                      "span",
                      _hoisted_7$4,
                      toDisplayString($setup.getLabel(option2)),
                      1
                      /* TEXT */
                    )
                  ], 42, _hoisted_6$7);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ],
            2
            /* CLASS */
          ),
          renderSlot(_ctx.$slots, "last", {}, void 0, true)
        ]),
        _: 3
        /* FORWARDED */
      }, 8, ["style"])
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["shown"]);
}
const SelectInput = /* @__PURE__ */ _export_sfc(_sfc_main$w, [["render", _sfc_render$w], ["__scopeId", "data-v-15ada451"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/SelectInput.vue"]]);
/*!
 * Signature Pad v5.0.4 | https://github.com/szimek/signature_pad
 * (c) 2024 Szymon Nowak | Released under the MIT license
 */
class Point {
  constructor(x2, y2, pressure, time) {
    if (isNaN(x2) || isNaN(y2)) {
      throw new Error(`Point is invalid: (${x2}, ${y2})`);
    }
    this.x = +x2;
    this.y = +y2;
    this.pressure = pressure || 0;
    this.time = time || Date.now();
  }
  distanceTo(start) {
    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
  }
  equals(other) {
    return this.x === other.x && this.y === other.y && this.pressure === other.pressure && this.time === other.time;
  }
  velocityFrom(start) {
    return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
  }
}
class Bezier {
  static fromPoints(points, widths) {
    const c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
    const c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
    return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
  }
  static calculateControlPoints(s1, s2, s3) {
    const dx1 = s1.x - s2.x;
    const dy1 = s1.y - s2.y;
    const dx2 = s2.x - s3.x;
    const dy2 = s2.y - s3.y;
    const m1 = { x: (s1.x + s2.x) / 2, y: (s1.y + s2.y) / 2 };
    const m2 = { x: (s2.x + s3.x) / 2, y: (s2.y + s3.y) / 2 };
    const l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
    const l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
    const dxm = m1.x - m2.x;
    const dym = m1.y - m2.y;
    const k2 = l1 + l2 == 0 ? 0 : l2 / (l1 + l2);
    const cm = { x: m2.x + dxm * k2, y: m2.y + dym * k2 };
    const tx = s2.x - cm.x;
    const ty = s2.y - cm.y;
    return {
      c1: new Point(m1.x + tx, m1.y + ty),
      c2: new Point(m2.x + tx, m2.y + ty)
    };
  }
  constructor(startPoint, control2, control1, endPoint, startWidth, endWidth) {
    this.startPoint = startPoint;
    this.control2 = control2;
    this.control1 = control1;
    this.endPoint = endPoint;
    this.startWidth = startWidth;
    this.endWidth = endWidth;
  }
  length() {
    const steps = 10;
    let length = 0;
    let px;
    let py;
    for (let i = 0; i <= steps; i += 1) {
      const t = i / steps;
      const cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
      const cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
      if (i > 0) {
        const xdiff = cx - px;
        const ydiff = cy - py;
        length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
      }
      px = cx;
      py = cy;
    }
    return length;
  }
  point(t, start, c1, c2, end) {
    return start * (1 - t) * (1 - t) * (1 - t) + 3 * c1 * (1 - t) * (1 - t) * t + 3 * c2 * (1 - t) * t * t + end * t * t * t;
  }
}
class SignatureEventTarget {
  constructor() {
    try {
      this._et = new EventTarget();
    } catch (_a2) {
      this._et = document;
    }
  }
  addEventListener(type3, listener, options) {
    this._et.addEventListener(type3, listener, options);
  }
  dispatchEvent(event) {
    return this._et.dispatchEvent(event);
  }
  removeEventListener(type3, callback, options) {
    this._et.removeEventListener(type3, callback, options);
  }
}
function throttle$2(fn2, wait = 250) {
  let previous = 0;
  let timeout = null;
  let result2;
  let storedContext;
  let storedArgs;
  const later = () => {
    previous = Date.now();
    timeout = null;
    result2 = fn2.apply(storedContext, storedArgs);
    if (!timeout) {
      storedContext = null;
      storedArgs = [];
    }
  };
  return function wrapper(...args) {
    const now = Date.now();
    const remaining = wait - (now - previous);
    storedContext = this;
    storedArgs = args;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = now;
      result2 = fn2.apply(storedContext, storedArgs);
      if (!timeout) {
        storedContext = null;
        storedArgs = [];
      }
    } else if (!timeout) {
      timeout = window.setTimeout(later, remaining);
    }
    return result2;
  };
}
let SignaturePad$1 = class SignaturePad2 extends SignatureEventTarget {
  constructor(canvas, options = {}) {
    var _a2, _b, _c;
    super();
    this.canvas = canvas;
    this._drawingStroke = false;
    this._isEmpty = true;
    this._lastPoints = [];
    this._data = [];
    this._lastVelocity = 0;
    this._lastWidth = 0;
    this._handleMouseDown = (event) => {
      if (!this._isLeftButtonPressed(event, true) || this._drawingStroke) {
        return;
      }
      this._strokeBegin(this._pointerEventToSignatureEvent(event));
    };
    this._handleMouseMove = (event) => {
      if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
        this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
        return;
      }
      this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
    };
    this._handleMouseUp = (event) => {
      if (this._isLeftButtonPressed(event)) {
        return;
      }
      this._strokeEnd(this._pointerEventToSignatureEvent(event));
    };
    this._handleTouchStart = (event) => {
      if (event.targetTouches.length !== 1 || this._drawingStroke) {
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      this._strokeBegin(this._touchEventToSignatureEvent(event));
    };
    this._handleTouchMove = (event) => {
      if (event.targetTouches.length !== 1) {
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      if (!this._drawingStroke) {
        this._strokeEnd(this._touchEventToSignatureEvent(event), false);
        return;
      }
      this._strokeMoveUpdate(this._touchEventToSignatureEvent(event));
    };
    this._handleTouchEnd = (event) => {
      if (event.targetTouches.length !== 0) {
        return;
      }
      if (event.cancelable) {
        event.preventDefault();
      }
      this.canvas.removeEventListener("touchmove", this._handleTouchMove);
      this._strokeEnd(this._touchEventToSignatureEvent(event));
    };
    this._handlePointerDown = (event) => {
      if (!event.isPrimary || !this._isLeftButtonPressed(event) || this._drawingStroke) {
        return;
      }
      event.preventDefault();
      this._strokeBegin(this._pointerEventToSignatureEvent(event));
    };
    this._handlePointerMove = (event) => {
      if (!event.isPrimary) {
        return;
      }
      if (!this._isLeftButtonPressed(event, true) || !this._drawingStroke) {
        this._strokeEnd(this._pointerEventToSignatureEvent(event), false);
        return;
      }
      event.preventDefault();
      this._strokeMoveUpdate(this._pointerEventToSignatureEvent(event));
    };
    this._handlePointerUp = (event) => {
      if (!event.isPrimary || this._isLeftButtonPressed(event)) {
        return;
      }
      event.preventDefault();
      this._strokeEnd(this._pointerEventToSignatureEvent(event));
    };
    this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
    this.minWidth = options.minWidth || 0.5;
    this.maxWidth = options.maxWidth || 2.5;
    this.throttle = (_a2 = options.throttle) !== null && _a2 !== void 0 ? _a2 : 16;
    this.minDistance = (_b = options.minDistance) !== null && _b !== void 0 ? _b : 5;
    this.dotSize = options.dotSize || 0;
    this.penColor = options.penColor || "black";
    this.backgroundColor = options.backgroundColor || "rgba(0,0,0,0)";
    this.compositeOperation = options.compositeOperation || "source-over";
    this.canvasContextOptions = (_c = options.canvasContextOptions) !== null && _c !== void 0 ? _c : {};
    this._strokeMoveUpdate = this.throttle ? throttle$2(SignaturePad2.prototype._strokeUpdate, this.throttle) : SignaturePad2.prototype._strokeUpdate;
    this._ctx = canvas.getContext("2d", this.canvasContextOptions);
    this.clear();
    this.on();
  }
  clear() {
    const { _ctx: ctx, canvas } = this;
    ctx.fillStyle = this.backgroundColor;
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.fillRect(0, 0, canvas.width, canvas.height);
    this._data = [];
    this._reset(this._getPointGroupOptions());
    this._isEmpty = true;
  }
  fromDataURL(dataUrl, options = {}) {
    return new Promise((resolve, reject3) => {
      const image = new Image();
      const ratio = options.ratio || window.devicePixelRatio || 1;
      const width = options.width || this.canvas.width / ratio;
      const height = options.height || this.canvas.height / ratio;
      const xOffset = options.xOffset || 0;
      const yOffset = options.yOffset || 0;
      this._reset(this._getPointGroupOptions());
      image.onload = () => {
        this._ctx.drawImage(image, xOffset, yOffset, width, height);
        resolve();
      };
      image.onerror = (error) => {
        reject3(error);
      };
      image.crossOrigin = "anonymous";
      image.src = dataUrl;
      this._isEmpty = false;
    });
  }
  toDataURL(type3 = "image/png", encoderOptions) {
    switch (type3) {
      case "image/svg+xml":
        if (typeof encoderOptions !== "object") {
          encoderOptions = void 0;
        }
        return `data:image/svg+xml;base64,${btoa(this.toSVG(encoderOptions))}`;
      default:
        if (typeof encoderOptions !== "number") {
          encoderOptions = void 0;
        }
        return this.canvas.toDataURL(type3, encoderOptions);
    }
  }
  on() {
    this.canvas.style.touchAction = "none";
    this.canvas.style.msTouchAction = "none";
    this.canvas.style.userSelect = "none";
    const isIOS = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
    if (window.PointerEvent && !isIOS) {
      this._handlePointerEvents();
    } else {
      this._handleMouseEvents();
      if ("ontouchstart" in window) {
        this._handleTouchEvents();
      }
    }
  }
  off() {
    this.canvas.style.touchAction = "auto";
    this.canvas.style.msTouchAction = "auto";
    this.canvas.style.userSelect = "auto";
    this.canvas.removeEventListener("pointerdown", this._handlePointerDown);
    this.canvas.removeEventListener("mousedown", this._handleMouseDown);
    this.canvas.removeEventListener("touchstart", this._handleTouchStart);
    this._removeMoveUpEventListeners();
  }
  _getListenerFunctions() {
    var _a2;
    const canvasWindow = window.document === this.canvas.ownerDocument ? window : (_a2 = this.canvas.ownerDocument.defaultView) !== null && _a2 !== void 0 ? _a2 : this.canvas.ownerDocument;
    return {
      addEventListener: canvasWindow.addEventListener.bind(canvasWindow),
      removeEventListener: canvasWindow.removeEventListener.bind(canvasWindow)
    };
  }
  _removeMoveUpEventListeners() {
    const { removeEventListener } = this._getListenerFunctions();
    removeEventListener("pointermove", this._handlePointerMove);
    removeEventListener("pointerup", this._handlePointerUp);
    removeEventListener("mousemove", this._handleMouseMove);
    removeEventListener("mouseup", this._handleMouseUp);
    removeEventListener("touchmove", this._handleTouchMove);
    removeEventListener("touchend", this._handleTouchEnd);
  }
  isEmpty() {
    return this._isEmpty;
  }
  fromData(pointGroups, { clear = true } = {}) {
    if (clear) {
      this.clear();
    }
    this._fromData(pointGroups, this._drawCurve.bind(this), this._drawDot.bind(this));
    this._data = this._data.concat(pointGroups);
  }
  toData() {
    return this._data;
  }
  _isLeftButtonPressed(event, only) {
    if (only) {
      return event.buttons === 1;
    }
    return (event.buttons & 1) === 1;
  }
  _pointerEventToSignatureEvent(event) {
    return {
      event,
      type: event.type,
      x: event.clientX,
      y: event.clientY,
      pressure: "pressure" in event ? event.pressure : 0
    };
  }
  _touchEventToSignatureEvent(event) {
    const touch = event.changedTouches[0];
    return {
      event,
      type: event.type,
      x: touch.clientX,
      y: touch.clientY,
      pressure: touch.force
    };
  }
  _getPointGroupOptions(group) {
    return {
      penColor: group && "penColor" in group ? group.penColor : this.penColor,
      dotSize: group && "dotSize" in group ? group.dotSize : this.dotSize,
      minWidth: group && "minWidth" in group ? group.minWidth : this.minWidth,
      maxWidth: group && "maxWidth" in group ? group.maxWidth : this.maxWidth,
      velocityFilterWeight: group && "velocityFilterWeight" in group ? group.velocityFilterWeight : this.velocityFilterWeight,
      compositeOperation: group && "compositeOperation" in group ? group.compositeOperation : this.compositeOperation
    };
  }
  _strokeBegin(event) {
    const cancelled = !this.dispatchEvent(new CustomEvent("beginStroke", { detail: event, cancelable: true }));
    if (cancelled) {
      return;
    }
    const { addEventListener } = this._getListenerFunctions();
    switch (event.event.type) {
      case "mousedown":
        addEventListener("mousemove", this._handleMouseMove);
        addEventListener("mouseup", this._handleMouseUp);
        break;
      case "touchstart":
        addEventListener("touchmove", this._handleTouchMove);
        addEventListener("touchend", this._handleTouchEnd);
        break;
      case "pointerdown":
        addEventListener("pointermove", this._handlePointerMove);
        addEventListener("pointerup", this._handlePointerUp);
        break;
    }
    this._drawingStroke = true;
    const pointGroupOptions = this._getPointGroupOptions();
    const newPointGroup = Object.assign(Object.assign({}, pointGroupOptions), { points: [] });
    this._data.push(newPointGroup);
    this._reset(pointGroupOptions);
    this._strokeUpdate(event);
  }
  _strokeUpdate(event) {
    if (!this._drawingStroke) {
      return;
    }
    if (this._data.length === 0) {
      this._strokeBegin(event);
      return;
    }
    this.dispatchEvent(new CustomEvent("beforeUpdateStroke", { detail: event }));
    const point2 = this._createPoint(event.x, event.y, event.pressure);
    const lastPointGroup = this._data[this._data.length - 1];
    const lastPoints = lastPointGroup.points;
    const lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
    const isLastPointTooClose = lastPoint ? point2.distanceTo(lastPoint) <= this.minDistance : false;
    const pointGroupOptions = this._getPointGroupOptions(lastPointGroup);
    if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
      const curve = this._addPoint(point2, pointGroupOptions);
      if (!lastPoint) {
        this._drawDot(point2, pointGroupOptions);
      } else if (curve) {
        this._drawCurve(curve, pointGroupOptions);
      }
      lastPoints.push({
        time: point2.time,
        x: point2.x,
        y: point2.y,
        pressure: point2.pressure
      });
    }
    this.dispatchEvent(new CustomEvent("afterUpdateStroke", { detail: event }));
  }
  _strokeEnd(event, shouldUpdate = true) {
    this._removeMoveUpEventListeners();
    if (!this._drawingStroke) {
      return;
    }
    if (shouldUpdate) {
      this._strokeUpdate(event);
    }
    this._drawingStroke = false;
    this.dispatchEvent(new CustomEvent("endStroke", { detail: event }));
  }
  _handlePointerEvents() {
    this._drawingStroke = false;
    this.canvas.addEventListener("pointerdown", this._handlePointerDown);
  }
  _handleMouseEvents() {
    this._drawingStroke = false;
    this.canvas.addEventListener("mousedown", this._handleMouseDown);
  }
  _handleTouchEvents() {
    this.canvas.addEventListener("touchstart", this._handleTouchStart);
  }
  _reset(options) {
    this._lastPoints = [];
    this._lastVelocity = 0;
    this._lastWidth = (options.minWidth + options.maxWidth) / 2;
    this._ctx.fillStyle = options.penColor;
    this._ctx.globalCompositeOperation = options.compositeOperation;
  }
  _createPoint(x2, y2, pressure) {
    const rect = this.canvas.getBoundingClientRect();
    return new Point(x2 - rect.left, y2 - rect.top, pressure, (/* @__PURE__ */ new Date()).getTime());
  }
  _addPoint(point2, options) {
    const { _lastPoints } = this;
    _lastPoints.push(point2);
    if (_lastPoints.length > 2) {
      if (_lastPoints.length === 3) {
        _lastPoints.unshift(_lastPoints[0]);
      }
      const widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2], options);
      const curve = Bezier.fromPoints(_lastPoints, widths);
      _lastPoints.shift();
      return curve;
    }
    return null;
  }
  _calculateCurveWidths(startPoint, endPoint, options) {
    const velocity = options.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - options.velocityFilterWeight) * this._lastVelocity;
    const newWidth = this._strokeWidth(velocity, options);
    const widths = {
      end: newWidth,
      start: this._lastWidth
    };
    this._lastVelocity = velocity;
    this._lastWidth = newWidth;
    return widths;
  }
  _strokeWidth(velocity, options) {
    return Math.max(options.maxWidth / (velocity + 1), options.minWidth);
  }
  _drawCurveSegment(x2, y2, width) {
    const ctx = this._ctx;
    ctx.moveTo(x2, y2);
    ctx.arc(x2, y2, width, 0, 2 * Math.PI, false);
    this._isEmpty = false;
  }
  _drawCurve(curve, options) {
    const ctx = this._ctx;
    const widthDelta = curve.endWidth - curve.startWidth;
    const drawSteps = Math.ceil(curve.length()) * 2;
    ctx.beginPath();
    ctx.fillStyle = options.penColor;
    for (let i = 0; i < drawSteps; i += 1) {
      const t = i / drawSteps;
      const tt2 = t * t;
      const ttt = tt2 * t;
      const u = 1 - t;
      const uu = u * u;
      const uuu = uu * u;
      let x2 = uuu * curve.startPoint.x;
      x2 += 3 * uu * t * curve.control1.x;
      x2 += 3 * u * tt2 * curve.control2.x;
      x2 += ttt * curve.endPoint.x;
      let y2 = uuu * curve.startPoint.y;
      y2 += 3 * uu * t * curve.control1.y;
      y2 += 3 * u * tt2 * curve.control2.y;
      y2 += ttt * curve.endPoint.y;
      const width = Math.min(curve.startWidth + ttt * widthDelta, options.maxWidth);
      this._drawCurveSegment(x2, y2, width);
    }
    ctx.closePath();
    ctx.fill();
  }
  _drawDot(point2, options) {
    const ctx = this._ctx;
    const width = options.dotSize > 0 ? options.dotSize : (options.minWidth + options.maxWidth) / 2;
    ctx.beginPath();
    this._drawCurveSegment(point2.x, point2.y, width);
    ctx.closePath();
    ctx.fillStyle = options.penColor;
    ctx.fill();
  }
  _fromData(pointGroups, drawCurve, drawDot) {
    for (const group of pointGroups) {
      const { points } = group;
      const pointGroupOptions = this._getPointGroupOptions(group);
      if (points.length > 1) {
        for (let j2 = 0; j2 < points.length; j2 += 1) {
          const basicPoint = points[j2];
          const point2 = new Point(basicPoint.x, basicPoint.y, basicPoint.pressure, basicPoint.time);
          if (j2 === 0) {
            this._reset(pointGroupOptions);
          }
          const curve = this._addPoint(point2, pointGroupOptions);
          if (curve) {
            drawCurve(curve, pointGroupOptions);
          }
        }
      } else {
        this._reset(pointGroupOptions);
        drawDot(points[0], pointGroupOptions);
      }
    }
  }
  toSVG({ includeBackgroundColor = false } = {}) {
    const pointGroups = this._data;
    const ratio = Math.max(window.devicePixelRatio || 1, 1);
    const minX = 0;
    const minY = 0;
    const maxX = this.canvas.width / ratio;
    const maxY = this.canvas.height / ratio;
    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
    svg.setAttribute("viewBox", `${minX} ${minY} ${maxX} ${maxY}`);
    svg.setAttribute("width", maxX.toString());
    svg.setAttribute("height", maxY.toString());
    if (includeBackgroundColor && this.backgroundColor) {
      const rect = document.createElement("rect");
      rect.setAttribute("width", "100%");
      rect.setAttribute("height", "100%");
      rect.setAttribute("fill", this.backgroundColor);
      svg.appendChild(rect);
    }
    this._fromData(pointGroups, (curve, { penColor }) => {
      const path = document.createElement("path");
      if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
        const attr = `M ${curve.startPoint.x.toFixed(3)},${curve.startPoint.y.toFixed(3)} C ${curve.control1.x.toFixed(3)},${curve.control1.y.toFixed(3)} ${curve.control2.x.toFixed(3)},${curve.control2.y.toFixed(3)} ${curve.endPoint.x.toFixed(3)},${curve.endPoint.y.toFixed(3)}`;
        path.setAttribute("d", attr);
        path.setAttribute("stroke-width", (curve.endWidth * 2.25).toFixed(3));
        path.setAttribute("stroke", penColor);
        path.setAttribute("fill", "none");
        path.setAttribute("stroke-linecap", "round");
        svg.appendChild(path);
      }
    }, (point2, { penColor, dotSize, minWidth, maxWidth }) => {
      const circle = document.createElement("circle");
      const size2 = dotSize > 0 ? dotSize : (minWidth + maxWidth) / 2;
      circle.setAttribute("r", size2.toString());
      circle.setAttribute("cx", point2.x.toString());
      circle.setAttribute("cy", point2.y.toString());
      circle.setAttribute("fill", penColor);
      svg.appendChild(circle);
    });
    return svg.outerHTML;
  }
};
const _sfc_main$v = /* @__PURE__ */ defineComponent({
  __name: "SignaturePad",
  props: /* @__PURE__ */ mergeModels({
    sigOption: { type: Object, required: false },
    width: { type: String, required: false },
    height: { type: String, required: false },
    ratio: { type: Number, required: false },
    clearOnResize: { type: Boolean, required: false },
    waterMark: { type: Object, required: false },
    disabled: { type: Boolean, required: false },
    defaultUrl: { type: String, required: false },
    format: { type: String, required: false },
    clearable: { type: Boolean, required: false, default: true },
    required: { type: Boolean, required: false }
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    const props2 = __props;
    const sigData = useModel(__props, "modelValue");
    const vCanvas = ref();
    let sig = ref();
    let _isEmpty = ref(true);
    function clear() {
      var _a2;
      (_a2 = sig.value) == null ? void 0 : _a2.clear();
      _isEmpty.value = true;
      sigData.value = void 0;
    }
    function save2(format2) {
      var _a2, _b;
      format2 = format2 || props2.format;
      return format2 ? (_a2 = sig.value) == null ? void 0 : _a2.toDataURL(format2) : (_b = sig.value) == null ? void 0 : _b.toDataURL();
    }
    const fromDataURL = (url) => {
      var _a2;
      return (_a2 = sig.value) == null ? void 0 : _a2.fromDataURL(url);
    };
    const isEmpty = () => {
      var _a2;
      return (_a2 = sig.value) == null ? void 0 : _a2.isEmpty();
    };
    function undo() {
      var _a2, _b;
      const data2 = (_a2 = sig.value) == null ? void 0 : _a2.toData();
      if (data2) {
        data2.pop();
        (_b = sig.value) == null ? void 0 : _b.fromData(data2);
      }
    }
    const defaultOptions2 = ref({
      penColor: "rgb(0, 0, 0)",
      backgroundColor: "rgb(255, 255, 255)"
    });
    const signatureOptions = computed(() => ({ ...defaultOptions2.value, ...props2.sigOption }));
    watch(
      () => props2.disabled,
      (val) => {
        var _a2, _b;
        if (val) (_a2 = sig.value) == null ? void 0 : _a2.off();
        else (_b = sig.value) == null ? void 0 : _b.on();
      }
    );
    function addWaterMark(data2) {
      var _a2;
      if (!(Object.prototype.toString.call(data2) === "[object Object]")) {
        throw new Error(`Expected Object, got ${typeof data2}.`);
      } else {
        const textData = {
          text: data2.text || "",
          x: data2.x || 20,
          y: data2.y || 20,
          sx: data2.sx || 40,
          sy: data2.sy || 40
        };
        const ctx = (_a2 = vCanvas.value) == null ? void 0 : _a2.getContext("2d");
        if (!ctx) return;
        ctx.font = data2.font || "20px sans-serif";
        ctx.fillStyle = data2.fillStyle || "#333";
        ctx.strokeStyle = data2.strokeStyle || "#333";
        if (data2.style === "all") {
          ctx.fillText(textData.text, textData.x, textData.y);
          ctx.strokeText(textData.text, textData.sx, textData.sy);
        } else if (data2.style === "stroke") {
          ctx.strokeText(textData.text, textData.sx, textData.sy);
        } else {
          ctx.fillText(textData.text, textData.x, textData.y);
        }
      }
    }
    function onEndStroke() {
      var _a2;
      _isEmpty.value = ((_a2 = sig.value) == null ? void 0 : _a2.isEmpty()) ?? false;
      const data2 = save2();
      sigData.value = data2;
    }
    function draw() {
      const canvas = vCanvas.value;
      sig.value = new SignaturePad$1(canvas, signatureOptions.value);
      function resizeCanvas(c2) {
        let url;
        if (!isEmpty()) url = save2();
        const ratio = props2.ratio ?? 1 / 2;
        const { width } = c2.getBoundingClientRect();
        c2.width = props2.width ? Number(props2.width.replaceAll("px", "")) : width;
        c2.height = props2.height ? Number(props2.height.replaceAll("px", "")) : width * ratio;
        clear();
        if (!props2.clearOnResize && url !== void 0) fromDataURL(url);
        if (props2.waterMark) addWaterMark(props2.waterMark);
      }
      window.addEventListener("resize", () => {
        resizeCanvas(canvas);
      });
      resizeCanvas(canvas);
      if (props2.disabled) sig.value.off();
      else sig.value.on();
      _isEmpty.value = sig.value.isEmpty();
      sig.value.addEventListener("endStroke", onEndStroke);
    }
    onMounted(draw);
    onUnmounted(() => {
      var _a2;
      (_a2 = sig.value) == null ? void 0 : _a2.removeEventListener("endStroke", onEndStroke);
    });
    __expose({
      save: save2,
      clear,
      isEmpty,
      undo,
      addWaterMark,
      fromDataURL
    });
    const __returned__ = { props: props2, sigData, vCanvas, get sig() {
      return sig;
    }, set sig(v) {
      sig = v;
    }, get _isEmpty() {
      return _isEmpty;
    }, set _isEmpty(v) {
      _isEmpty = v;
    }, clear, save: save2, fromDataURL, isEmpty, undo, defaultOptions: defaultOptions2, signatureOptions, addWaterMark, onEndStroke, draw, get Btn() {
      return Btn;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$n = ["disabled"];
const _hoisted_2$e = {
  key: 1,
  placeholder: "required",
  type: "text",
  required: "",
  class: "pixel"
};
function _sfc_render$v(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["bgl_input signature-pad relative", { "bg-transparent": $props.disabled }]),
      onTouchmove: _cache[0] || (_cache[0] = withModifiers(() => {
      }, ["prevent"]))
    },
    [
      $props.clearable && !$props.disabled ? (openBlock(), createBlock($setup["Btn"], {
        key: 0,
        flat: "",
        thin: "",
        icon: "refresh",
        class: "position-bottom-end",
        onClick: $setup.clear
      })) : createCommentVNode("v-if", true),
      createElementVNode("canvas", {
        ref: "vCanvas",
        class: "canvas",
        disabled: $props.disabled
      }, null, 8, _hoisted_1$n),
      $props.required && $setup._isEmpty ? (openBlock(), createElementBlock("input", _hoisted_2$e)) : createCommentVNode("v-if", true)
    ],
    34
    /* CLASS, NEED_HYDRATION */
  );
}
const SignaturePad = /* @__PURE__ */ _export_sfc(_sfc_main$v, [["render", _sfc_render$v], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/SignaturePad.vue"]]);
/*!
  * vue-draggable-next v2.2.0
  * (c) 2023 Anish George
  * @license MIT
  */
/**!
 * Sortable 1.14.0
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function ownKeys$5(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys$5(Object(source), true).forEach(function(key) {
        _defineProperty$5(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys$5(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _typeof$2(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$2 = function(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof$2 = function(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof$2(obj);
}
function _defineProperty$5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign || function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
var version = "1.14.0";
function userAgent(pattern2) {
  if (typeof window !== "undefined" && window.navigator) {
    return !!/* @__PURE__ */ navigator.userAgent.match(pattern2);
  }
}
var IE11OrLess = userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var Edge = userAgent(/Edge/i);
var FireFox = userAgent(/firefox/i);
var Safari = userAgent(/safari/i) && !userAgent(/chrome/i) && !userAgent(/android/i);
var IOS = userAgent(/iP(ad|od|hone)/i);
var ChromeForAndroid = userAgent(/chrome/i) && userAgent(/android/i);
var captureMode = {
  capture: false,
  passive: false
};
function on(el, event, fn2) {
  el.addEventListener(event, fn2, !IE11OrLess && captureMode);
}
function off(el, event, fn2) {
  el.removeEventListener(event, fn2, !IE11OrLess && captureMode);
}
function matches(el, selector2) {
  if (!selector2) return;
  selector2[0] === ">" && (selector2 = selector2.substring(1));
  if (el) {
    try {
      if (el.matches) {
        return el.matches(selector2);
      } else if (el.msMatchesSelector) {
        return el.msMatchesSelector(selector2);
      } else if (el.webkitMatchesSelector) {
        return el.webkitMatchesSelector(selector2);
      }
    } catch (_2) {
      return false;
    }
  }
  return false;
}
function getParentOrHost(el) {
  return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function closest(el, selector2, ctx, includeCTX) {
  if (el) {
    ctx = ctx || document;
    do {
      if (selector2 != null && (selector2[0] === ">" ? el.parentNode === ctx && matches(el, selector2) : matches(el, selector2)) || includeCTX && el === ctx) {
        return el;
      }
      if (el === ctx) break;
    } while (el = getParentOrHost(el));
  }
  return null;
}
var R_SPACE = /\s+/g;
function toggleClass(el, name, state2) {
  if (el && name) {
    if (el.classList) {
      el.classList[state2 ? "add" : "remove"](name);
    } else {
      var className = (" " + el.className + " ").replace(R_SPACE, " ").replace(" " + name + " ", " ");
      el.className = (className + (state2 ? " " + name : "")).replace(R_SPACE, " ");
    }
  }
}
function css(el, prop3, val) {
  var style = el && el.style;
  if (style) {
    if (val === void 0) {
      if (document.defaultView && document.defaultView.getComputedStyle) {
        val = document.defaultView.getComputedStyle(el, "");
      } else if (el.currentStyle) {
        val = el.currentStyle;
      }
      return prop3 === void 0 ? val : val[prop3];
    } else {
      if (!(prop3 in style) && prop3.indexOf("webkit") === -1) {
        prop3 = "-webkit-" + prop3;
      }
      style[prop3] = val + (typeof val === "string" ? "" : "px");
    }
  }
}
function matrix(el, selfOnly) {
  var appliedTransforms = "";
  if (typeof el === "string") {
    appliedTransforms = el;
  } else {
    do {
      var transform = css(el, "transform");
      if (transform && transform !== "none") {
        appliedTransforms = transform + " " + appliedTransforms;
      }
    } while (!selfOnly && (el = el.parentNode));
  }
  var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return matrixFn && new matrixFn(appliedTransforms);
}
function find(ctx, tagName, iterator) {
  if (ctx) {
    var list = ctx.getElementsByTagName(tagName), i = 0, n2 = list.length;
    if (iterator) {
      for (; i < n2; i++) {
        iterator(list[i], i);
      }
    }
    return list;
  }
  return [];
}
function getWindowScrollingElement() {
  var scrollingElement = document.scrollingElement;
  if (scrollingElement) {
    return scrollingElement;
  } else {
    return document.documentElement;
  }
}
function getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
  if (!el.getBoundingClientRect && el !== window) return;
  var elRect, top2, left2, bottom2, right2, height, width;
  if (el !== window && el.parentNode && el !== getWindowScrollingElement()) {
    elRect = el.getBoundingClientRect();
    top2 = elRect.top;
    left2 = elRect.left;
    bottom2 = elRect.bottom;
    right2 = elRect.right;
    height = elRect.height;
    width = elRect.width;
  } else {
    top2 = 0;
    left2 = 0;
    bottom2 = window.innerHeight;
    right2 = window.innerWidth;
    height = window.innerHeight;
    width = window.innerWidth;
  }
  if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
    container = container || el.parentNode;
    if (!IE11OrLess) {
      do {
        if (container && container.getBoundingClientRect && (css(container, "transform") !== "none" || relativeToNonStaticParent && css(container, "position") !== "static")) {
          var containerRect = container.getBoundingClientRect();
          top2 -= containerRect.top + parseInt(css(container, "border-top-width"));
          left2 -= containerRect.left + parseInt(css(container, "border-left-width"));
          bottom2 = top2 + elRect.height;
          right2 = left2 + elRect.width;
          break;
        }
      } while (container = container.parentNode);
    }
  }
  if (undoScale && el !== window) {
    var elMatrix = matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
    if (elMatrix) {
      top2 /= scaleY;
      left2 /= scaleX;
      width /= scaleX;
      height /= scaleY;
      bottom2 = top2 + height;
      right2 = left2 + width;
    }
  }
  return {
    top: top2,
    left: left2,
    bottom: bottom2,
    right: right2,
    width,
    height
  };
}
function isScrolledPast(el, elSide, parentSide) {
  var parent = getParentAutoScrollElement(el, true), elSideVal = getRect(el)[elSide];
  while (parent) {
    var parentSideVal = getRect(parent)[parentSide], visible = void 0;
    {
      visible = elSideVal >= parentSideVal;
    }
    if (!visible) return parent;
    if (parent === getWindowScrollingElement()) break;
    parent = getParentAutoScrollElement(parent, false);
  }
  return false;
}
function getChild(el, childNum, options, includeDragEl) {
  var currentChild = 0, i = 0, children2 = el.children;
  while (i < children2.length) {
    if (children2[i].style.display !== "none" && children2[i] !== Sortable.ghost && (includeDragEl || children2[i] !== Sortable.dragged) && closest(children2[i], options.draggable, el, false)) {
      if (currentChild === childNum) {
        return children2[i];
      }
      currentChild++;
    }
    i++;
  }
  return null;
}
function lastChild(el, selector2) {
  var last = el.lastElementChild;
  while (last && (last === Sortable.ghost || css(last, "display") === "none" || selector2 && !matches(last, selector2))) {
    last = last.previousElementSibling;
  }
  return last || null;
}
function index(el, selector2) {
  var index2 = 0;
  if (!el || !el.parentNode) {
    return -1;
  }
  while (el = el.previousElementSibling) {
    if (el.nodeName.toUpperCase() !== "TEMPLATE" && el !== Sortable.clone && (!selector2 || matches(el, selector2))) {
      index2++;
    }
  }
  return index2;
}
function getRelativeScrollOffset(el) {
  var offsetLeft = 0, offsetTop = 0, winScroller = getWindowScrollingElement();
  if (el) {
    do {
      var elMatrix = matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
      offsetLeft += el.scrollLeft * scaleX;
      offsetTop += el.scrollTop * scaleY;
    } while (el !== winScroller && (el = el.parentNode));
  }
  return [offsetLeft, offsetTop];
}
function indexOfObject(arr, obj) {
  for (var i in arr) {
    if (!arr.hasOwnProperty(i)) continue;
    for (var key in obj) {
      if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
    }
  }
  return -1;
}
function getParentAutoScrollElement(el, includeSelf) {
  if (!el || !el.getBoundingClientRect) return getWindowScrollingElement();
  var elem = el;
  var gotSelf = false;
  do {
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
      var elemCSS = css(elem);
      if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == "auto" || elemCSS.overflowX == "scroll") || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == "auto" || elemCSS.overflowY == "scroll")) {
        if (!elem.getBoundingClientRect || elem === document.body) return getWindowScrollingElement();
        if (gotSelf || includeSelf) return elem;
        gotSelf = true;
      }
    }
  } while (elem = elem.parentNode);
  return getWindowScrollingElement();
}
function extend$1(dst, src) {
  if (dst && src) {
    for (var key in src) {
      if (src.hasOwnProperty(key)) {
        dst[key] = src[key];
      }
    }
  }
  return dst;
}
function isRectEqual(rect1, rect2) {
  return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var _throttleTimeout;
function throttle$1(callback, ms) {
  return function() {
    if (!_throttleTimeout) {
      var args = arguments, _this = this;
      if (args.length === 1) {
        callback.call(_this, args[0]);
      } else {
        callback.apply(_this, args);
      }
      _throttleTimeout = setTimeout(function() {
        _throttleTimeout = void 0;
      }, ms);
    }
  };
}
function cancelThrottle() {
  clearTimeout(_throttleTimeout);
  _throttleTimeout = void 0;
}
function scrollBy(el, x2, y2) {
  el.scrollLeft += x2;
  el.scrollTop += y2;
}
function clone(el) {
  var Polymer = window.Polymer;
  var $2 = window.jQuery || window.Zepto;
  if (Polymer && Polymer.dom) {
    return Polymer.dom(el).cloneNode(true);
  } else if ($2) {
    return $2(el).clone(true)[0];
  } else {
    return el.cloneNode(true);
  }
}
var expando = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function AnimationStateManager() {
  var animationStates = [], animationCallbackId;
  return {
    captureAnimationState: function captureAnimationState() {
      animationStates = [];
      if (!this.options.animation) return;
      var children2 = [].slice.call(this.el.children);
      children2.forEach(function(child) {
        if (css(child, "display") === "none" || child === Sortable.ghost) return;
        animationStates.push({
          target: child,
          rect: getRect(child)
        });
        var fromRect = _objectSpread2({}, animationStates[animationStates.length - 1].rect);
        if (child.thisAnimationDuration) {
          var childMatrix = matrix(child, true);
          if (childMatrix) {
            fromRect.top -= childMatrix.f;
            fromRect.left -= childMatrix.e;
          }
        }
        child.fromRect = fromRect;
      });
    },
    addAnimationState: function addAnimationState(state2) {
      animationStates.push(state2);
    },
    removeAnimationState: function removeAnimationState(target) {
      animationStates.splice(indexOfObject(animationStates, {
        target
      }), 1);
    },
    animateAll: function animateAll(callback) {
      var _this = this;
      if (!this.options.animation) {
        clearTimeout(animationCallbackId);
        if (typeof callback === "function") callback();
        return;
      }
      var animating = false, animationTime = 0;
      animationStates.forEach(function(state2) {
        var time = 0, target = state2.target, fromRect = target.fromRect, toRect = getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state2.rect, targetMatrix = matrix(target, true);
        if (targetMatrix) {
          toRect.top -= targetMatrix.f;
          toRect.left -= targetMatrix.e;
        }
        target.toRect = toRect;
        if (target.thisAnimationDuration) {
          if (isRectEqual(prevFromRect, toRect) && !isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
          (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) {
            time = calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
          }
        }
        if (!isRectEqual(toRect, fromRect)) {
          target.prevFromRect = fromRect;
          target.prevToRect = toRect;
          if (!time) {
            time = _this.options.animation;
          }
          _this.animate(target, animatingRect, toRect, time);
        }
        if (time) {
          animating = true;
          animationTime = Math.max(animationTime, time);
          clearTimeout(target.animationResetTimer);
          target.animationResetTimer = setTimeout(function() {
            target.animationTime = 0;
            target.prevFromRect = null;
            target.fromRect = null;
            target.prevToRect = null;
            target.thisAnimationDuration = null;
          }, time);
          target.thisAnimationDuration = time;
        }
      });
      clearTimeout(animationCallbackId);
      if (!animating) {
        if (typeof callback === "function") callback();
      } else {
        animationCallbackId = setTimeout(function() {
          if (typeof callback === "function") callback();
        }, animationTime);
      }
      animationStates = [];
    },
    animate: function animate(target, currentRect, toRect, duration) {
      if (duration) {
        css(target, "transition", "");
        css(target, "transform", "");
        var elMatrix = matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX2 = (currentRect.left - toRect.left) / (scaleX || 1), translateY2 = (currentRect.top - toRect.top) / (scaleY || 1);
        target.animatingX = !!translateX2;
        target.animatingY = !!translateY2;
        css(target, "transform", "translate3d(" + translateX2 + "px," + translateY2 + "px,0)");
        this.forRepaintDummy = repaint(target);
        css(target, "transition", "transform " + duration + "ms" + (this.options.easing ? " " + this.options.easing : ""));
        css(target, "transform", "translate3d(0,0,0)");
        typeof target.animated === "number" && clearTimeout(target.animated);
        target.animated = setTimeout(function() {
          css(target, "transition", "");
          css(target, "transform", "");
          target.animated = false;
          target.animatingX = false;
          target.animatingY = false;
        }, duration);
      }
    }
  };
}
function repaint(target) {
  return target.offsetWidth;
}
function calculateRealTime(animatingRect, fromRect, toRect, options) {
  return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var plugins = [];
var defaults$1 = {
  initializeByDefault: true
};
var PluginManager = {
  mount: function mount(plugin) {
    for (var option2 in defaults$1) {
      if (defaults$1.hasOwnProperty(option2) && !(option2 in plugin)) {
        plugin[option2] = defaults$1[option2];
      }
    }
    plugins.forEach(function(p) {
      if (p.pluginName === plugin.pluginName) {
        throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
      }
    });
    plugins.push(plugin);
  },
  pluginEvent: function pluginEvent2(eventName, sortable, evt) {
    var _this = this;
    this.eventCanceled = false;
    evt.cancel = function() {
      _this.eventCanceled = true;
    };
    var eventNameGlobal = eventName + "Global";
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName]) return;
      if (sortable[plugin.pluginName][eventNameGlobal]) {
        sortable[plugin.pluginName][eventNameGlobal](_objectSpread2({
          sortable
        }, evt));
      }
      if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) {
        sortable[plugin.pluginName][eventName](_objectSpread2({
          sortable
        }, evt));
      }
    });
  },
  initializePlugins: function initializePlugins(sortable, el, defaults2, options) {
    plugins.forEach(function(plugin) {
      var pluginName = plugin.pluginName;
      if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
      var initialized = new plugin(sortable, el, sortable.options);
      initialized.sortable = sortable;
      initialized.options = sortable.options;
      sortable[pluginName] = initialized;
      _extends(defaults2, initialized.defaults);
    });
    for (var option2 in sortable.options) {
      if (!sortable.options.hasOwnProperty(option2)) continue;
      var modified = this.modifyOption(sortable, option2, sortable.options[option2]);
      if (typeof modified !== "undefined") {
        sortable.options[option2] = modified;
      }
    }
  },
  getEventProperties: function getEventProperties(name, sortable) {
    var eventProperties = {};
    plugins.forEach(function(plugin) {
      if (typeof plugin.eventProperties !== "function") return;
      _extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
    });
    return eventProperties;
  },
  modifyOption: function modifyOption(sortable, name, value) {
    var modifiedValue;
    plugins.forEach(function(plugin) {
      if (!sortable[plugin.pluginName]) return;
      if (plugin.optionListeners && typeof plugin.optionListeners[name] === "function") {
        modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
      }
    });
    return modifiedValue;
  }
};
function dispatchEvent(_ref) {
  var sortable = _ref.sortable, rootEl2 = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl2 = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex2 = _ref.oldIndex, newIndex2 = _ref.newIndex, oldDraggableIndex2 = _ref.oldDraggableIndex, newDraggableIndex2 = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
  sortable = sortable || rootEl2 && rootEl2[expando];
  if (!sortable) return;
  var evt, options = sortable.options, onName = "on" + name.charAt(0).toUpperCase() + name.substr(1);
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent(name, {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent(name, true, true);
  }
  evt.to = toEl || rootEl2;
  evt.from = fromEl || rootEl2;
  evt.item = targetEl || rootEl2;
  evt.clone = cloneEl2;
  evt.oldIndex = oldIndex2;
  evt.newIndex = newIndex2;
  evt.oldDraggableIndex = oldDraggableIndex2;
  evt.newDraggableIndex = newDraggableIndex2;
  evt.originalEvent = originalEvent;
  evt.pullMode = putSortable2 ? putSortable2.lastPutMode : void 0;
  var allEventProperties = _objectSpread2(_objectSpread2({}, extraEventProperties), PluginManager.getEventProperties(name, sortable));
  for (var option2 in allEventProperties) {
    evt[option2] = allEventProperties[option2];
  }
  if (rootEl2) {
    rootEl2.dispatchEvent(evt);
  }
  if (options[onName]) {
    options[onName].call(sortable, evt);
  }
}
var _excluded = ["evt"];
var pluginEvent = function pluginEvent3(eventName, sortable) {
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, originalEvent = _ref.evt, data2 = _objectWithoutProperties(_ref, _excluded);
  PluginManager.pluginEvent.bind(Sortable)(eventName, sortable, _objectSpread2({
    dragEl,
    parentEl,
    ghostEl,
    rootEl,
    nextEl,
    lastDownEl,
    cloneEl,
    cloneHidden,
    dragStarted: moved,
    putSortable,
    activeSortable: Sortable.active,
    originalEvent,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex,
    hideGhostForTarget: _hideGhostForTarget,
    unhideGhostForTarget: _unhideGhostForTarget,
    cloneNowHidden: function cloneNowHidden() {
      cloneHidden = true;
    },
    cloneNowShown: function cloneNowShown() {
      cloneHidden = false;
    },
    dispatchSortableEvent: function dispatchSortableEvent(name) {
      _dispatchEvent({
        sortable,
        name,
        originalEvent
      });
    }
  }, data2));
};
function _dispatchEvent(info) {
  dispatchEvent(_objectSpread2({
    putSortable,
    cloneEl,
    targetEl: dragEl,
    rootEl,
    oldIndex,
    oldDraggableIndex,
    newIndex,
    newDraggableIndex
  }, info));
}
var dragEl, parentEl, ghostEl, rootEl, nextEl, lastDownEl, cloneEl, cloneHidden, oldIndex, newIndex, oldDraggableIndex, newDraggableIndex, activeGroup, putSortable, awaitingDragStarted = false, ignoreNextClick = false, sortables = [], tapEvt, touchEvt, lastDx, lastDy, tapDistanceLeft, tapDistanceTop, moved, lastTarget, lastDirection, pastFirstInvertThresh = false, isCircumstantialInvert = false, targetMoveDistance, ghostRelativeParent, ghostRelativeParentInitialScroll = [], _silent = false, savedInputChecked = [];
var documentExists = typeof document !== "undefined", PositionGhostAbsolutely = IOS, CSSFloatProperty = Edge || IE11OrLess ? "cssFloat" : "float", supportDraggable = documentExists && !ChromeForAndroid && !IOS && "draggable" in document.createElement("div"), supportCssPointerEvents = function() {
  if (!documentExists) return;
  if (IE11OrLess) {
    return false;
  }
  var el = document.createElement("x");
  el.style.cssText = "pointer-events:auto";
  return el.style.pointerEvents === "auto";
}(), _detectDirection = function _detectDirection2(el, options) {
  var elCSS = css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = getChild(el, 0, options), child2 = getChild(el, 1, options), firstChildCSS = child1 && css(child1), secondChildCSS = child2 && css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + getRect(child2).width;
  if (elCSS.display === "flex") {
    return elCSS.flexDirection === "column" || elCSS.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  }
  if (elCSS.display === "grid") {
    return elCSS.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  }
  if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== "none") {
    var touchingSideChild2 = firstChildCSS["float"] === "left" ? "left" : "right";
    return child2 && (secondChildCSS.clear === "both" || secondChildCSS.clear === touchingSideChild2) ? "vertical" : "horizontal";
  }
  return child1 && (firstChildCSS.display === "block" || firstChildCSS.display === "flex" || firstChildCSS.display === "table" || firstChildCSS.display === "grid" || firstChildWidth >= elWidth && elCSS[CSSFloatProperty] === "none" || child2 && elCSS[CSSFloatProperty] === "none" && firstChildWidth + secondChildWidth > elWidth) ? "vertical" : "horizontal";
}, _dragElInRowColumn = function _dragElInRowColumn2(dragRect, targetRect, vertical) {
  var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
  return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, _detectNearestEmptySortable = function _detectNearestEmptySortable2(x2, y2) {
  var ret;
  sortables.some(function(sortable) {
    var threshold = sortable[expando].options.emptyInsertThreshold;
    if (!threshold || lastChild(sortable)) return;
    var rect = getRect(sortable), insideHorizontally = x2 >= rect.left - threshold && x2 <= rect.right + threshold, insideVertically = y2 >= rect.top - threshold && y2 <= rect.bottom + threshold;
    if (insideHorizontally && insideVertically) {
      return ret = sortable;
    }
  });
  return ret;
}, _prepareGroup = function _prepareGroup2(options) {
  function toFn(value, pull) {
    return function(to2, from, dragEl2, evt) {
      var sameGroup = to2.options.group.name && from.options.group.name && to2.options.group.name === from.options.group.name;
      if (value == null && (pull || sameGroup)) {
        return true;
      } else if (value == null || value === false) {
        return false;
      } else if (pull && value === "clone") {
        return value;
      } else if (typeof value === "function") {
        return toFn(value(to2, from, dragEl2, evt), pull)(to2, from, dragEl2, evt);
      } else {
        var otherGroup = (pull ? to2 : from).options.group.name;
        return value === true || typeof value === "string" && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
      }
    };
  }
  var group = {};
  var originalGroup = options.group;
  if (!originalGroup || _typeof$2(originalGroup) != "object") {
    originalGroup = {
      name: originalGroup
    };
  }
  group.name = originalGroup.name;
  group.checkPull = toFn(originalGroup.pull, true);
  group.checkPut = toFn(originalGroup.put);
  group.revertClone = originalGroup.revertClone;
  options.group = group;
}, _hideGhostForTarget = function _hideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "none");
  }
}, _unhideGhostForTarget = function _unhideGhostForTarget2() {
  if (!supportCssPointerEvents && ghostEl) {
    css(ghostEl, "display", "");
  }
};
if (documentExists) {
  document.addEventListener("click", function(evt) {
    if (ignoreNextClick) {
      evt.preventDefault();
      evt.stopPropagation && evt.stopPropagation();
      evt.stopImmediatePropagation && evt.stopImmediatePropagation();
      ignoreNextClick = false;
      return false;
    }
  }, true);
}
var nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent2(evt) {
  if (dragEl) {
    evt = evt.touches ? evt.touches[0] : evt;
    var nearest = _detectNearestEmptySortable(evt.clientX, evt.clientY);
    if (nearest) {
      var event = {};
      for (var i in evt) {
        if (evt.hasOwnProperty(i)) {
          event[i] = evt[i];
        }
      }
      event.target = event.rootEl = nearest;
      event.preventDefault = void 0;
      event.stopPropagation = void 0;
      nearest[expando]._onDragOver(event);
    }
  }
};
var _checkOutsideTargetEl = function _checkOutsideTargetEl2(evt) {
  if (dragEl) {
    dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
  }
};
function Sortable(el, options) {
  if (!(el && el.nodeType && el.nodeType === 1)) {
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(el));
  }
  this.el = el;
  this.options = options = _extends({}, options);
  el[expando] = this;
  var defaults2 = {
    group: null,
    sort: true,
    disabled: false,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(el.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: false,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: true,
    direction: function direction() {
      return _detectDirection(el, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: true,
    animation: 0,
    easing: null,
    setData: function setData(dataTransfer, dragEl2) {
      dataTransfer.setData("Text", dragEl2.textContent);
    },
    dropBubble: false,
    dragoverBubble: false,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: false,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: false,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: false,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    supportPointer: Sortable.supportPointer !== false && "PointerEvent" in window && !Safari,
    emptyInsertThreshold: 5
  };
  PluginManager.initializePlugins(this, el, defaults2);
  for (var name in defaults2) {
    !(name in options) && (options[name] = defaults2[name]);
  }
  _prepareGroup(options);
  for (var fn2 in this) {
    if (fn2.charAt(0) === "_" && typeof this[fn2] === "function") {
      this[fn2] = this[fn2].bind(this);
    }
  }
  this.nativeDraggable = options.forceFallback ? false : supportDraggable;
  if (this.nativeDraggable) {
    this.options.touchStartThreshold = 1;
  }
  if (options.supportPointer) {
    on(el, "pointerdown", this._onTapStart);
  } else {
    on(el, "mousedown", this._onTapStart);
    on(el, "touchstart", this._onTapStart);
  }
  if (this.nativeDraggable) {
    on(el, "dragover", this);
    on(el, "dragenter", this);
  }
  sortables.push(this.el);
  options.store && options.store.get && this.sort(options.store.get(this) || []);
  _extends(this, AnimationStateManager());
}
Sortable.prototype = /** @lends Sortable.prototype */
{
  constructor: Sortable,
  _isOutsideThisEl: function _isOutsideThisEl(target) {
    if (!this.el.contains(target) && target !== this.el) {
      lastTarget = null;
    }
  },
  _getDirection: function _getDirection(evt, target) {
    return typeof this.options.direction === "function" ? this.options.direction.call(this, evt, target, dragEl) : this.options.direction;
  },
  _onTapStart: function _onTapStart(evt) {
    if (!evt.cancelable) return;
    var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type3 = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === "touch" && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter3 = options.filter;
    _saveInputCheckedState(el);
    if (dragEl) {
      return;
    }
    if (/mousedown|pointerdown/.test(type3) && evt.button !== 0 || options.disabled) {
      return;
    }
    if (originalTarget.isContentEditable) {
      return;
    }
    if (!this.nativeDraggable && Safari && target && target.tagName.toUpperCase() === "SELECT") {
      return;
    }
    target = closest(target, options.draggable, el, false);
    if (target && target.animated) {
      return;
    }
    if (lastDownEl === target) {
      return;
    }
    oldIndex = index(target);
    oldDraggableIndex = index(target, options.draggable);
    if (typeof filter3 === "function") {
      if (filter3.call(this, evt, target, this)) {
        _dispatchEvent({
          sortable: _this,
          rootEl: originalTarget,
          name: "filter",
          targetEl: target,
          toEl: el,
          fromEl: el
        });
        pluginEvent("filter", _this, {
          evt
        });
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    } else if (filter3) {
      filter3 = filter3.split(",").some(function(criteria) {
        criteria = closest(originalTarget, criteria.trim(), el, false);
        if (criteria) {
          _dispatchEvent({
            sortable: _this,
            rootEl: criteria,
            name: "filter",
            targetEl: target,
            fromEl: el,
            toEl: el
          });
          pluginEvent("filter", _this, {
            evt
          });
          return true;
        }
      });
      if (filter3) {
        preventOnFilter && evt.cancelable && evt.preventDefault();
        return;
      }
    }
    if (options.handle && !closest(originalTarget, options.handle, el, false)) {
      return;
    }
    this._prepareDragStart(evt, touch, target);
  },
  _prepareDragStart: function _prepareDragStart(evt, touch, target) {
    var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
    if (target && !dragEl && target.parentNode === el) {
      var dragRect = getRect(target);
      rootEl = el;
      dragEl = target;
      parentEl = dragEl.parentNode;
      nextEl = dragEl.nextSibling;
      lastDownEl = target;
      activeGroup = options.group;
      Sortable.dragged = dragEl;
      tapEvt = {
        target: dragEl,
        clientX: (touch || evt).clientX,
        clientY: (touch || evt).clientY
      };
      tapDistanceLeft = tapEvt.clientX - dragRect.left;
      tapDistanceTop = tapEvt.clientY - dragRect.top;
      this._lastX = (touch || evt).clientX;
      this._lastY = (touch || evt).clientY;
      dragEl.style["will-change"] = "all";
      dragStartFn = function dragStartFn2() {
        pluginEvent("delayEnded", _this, {
          evt
        });
        if (Sortable.eventCanceled) {
          _this._onDrop();
          return;
        }
        _this._disableDelayedDragEvents();
        if (!FireFox && _this.nativeDraggable) {
          dragEl.draggable = true;
        }
        _this._triggerDragStart(evt, touch);
        _dispatchEvent({
          sortable: _this,
          name: "choose",
          originalEvent: evt
        });
        toggleClass(dragEl, options.chosenClass, true);
      };
      options.ignore.split(",").forEach(function(criteria) {
        find(dragEl, criteria.trim(), _disableDraggable);
      });
      on(ownerDocument, "dragover", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mousemove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "touchmove", nearestEmptyInsertDetectEvent);
      on(ownerDocument, "mouseup", _this._onDrop);
      on(ownerDocument, "touchend", _this._onDrop);
      on(ownerDocument, "touchcancel", _this._onDrop);
      if (FireFox && this.nativeDraggable) {
        this.options.touchStartThreshold = 4;
        dragEl.draggable = true;
      }
      pluginEvent("delayStart", this, {
        evt
      });
      if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !(Edge || IE11OrLess))) {
        if (Sortable.eventCanceled) {
          this._onDrop();
          return;
        }
        on(ownerDocument, "mouseup", _this._disableDelayedDrag);
        on(ownerDocument, "touchend", _this._disableDelayedDrag);
        on(ownerDocument, "touchcancel", _this._disableDelayedDrag);
        on(ownerDocument, "mousemove", _this._delayedDragTouchMoveHandler);
        on(ownerDocument, "touchmove", _this._delayedDragTouchMoveHandler);
        options.supportPointer && on(ownerDocument, "pointermove", _this._delayedDragTouchMoveHandler);
        _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
      } else {
        dragStartFn();
      }
    }
  },
  _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(e) {
    var touch = e.touches ? e.touches[0] : e;
    if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) {
      this._disableDelayedDrag();
    }
  },
  _disableDelayedDrag: function _disableDelayedDrag() {
    dragEl && _disableDraggable(dragEl);
    clearTimeout(this._dragStartTimer);
    this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function _disableDelayedDragEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._disableDelayedDrag);
    off(ownerDocument, "touchend", this._disableDelayedDrag);
    off(ownerDocument, "touchcancel", this._disableDelayedDrag);
    off(ownerDocument, "mousemove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "touchmove", this._delayedDragTouchMoveHandler);
    off(ownerDocument, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function _triggerDragStart(evt, touch) {
    touch = touch || evt.pointerType == "touch" && evt;
    if (!this.nativeDraggable || touch) {
      if (this.options.supportPointer) {
        on(document, "pointermove", this._onTouchMove);
      } else if (touch) {
        on(document, "touchmove", this._onTouchMove);
      } else {
        on(document, "mousemove", this._onTouchMove);
      }
    } else {
      on(dragEl, "dragend", this);
      on(rootEl, "dragstart", this._onDragStart);
    }
    try {
      if (document.selection) {
        _nextTick(function() {
          document.selection.empty();
        });
      } else {
        window.getSelection().removeAllRanges();
      }
    } catch (err) {
    }
  },
  _dragStarted: function _dragStarted(fallback, evt) {
    awaitingDragStarted = false;
    if (rootEl && dragEl) {
      pluginEvent("dragStarted", this, {
        evt
      });
      if (this.nativeDraggable) {
        on(document, "dragover", _checkOutsideTargetEl);
      }
      var options = this.options;
      !fallback && toggleClass(dragEl, options.dragClass, false);
      toggleClass(dragEl, options.ghostClass, true);
      Sortable.active = this;
      fallback && this._appendGhost();
      _dispatchEvent({
        sortable: this,
        name: "start",
        originalEvent: evt
      });
    } else {
      this._nulling();
    }
  },
  _emulateDragOver: function _emulateDragOver() {
    if (touchEvt) {
      this._lastX = touchEvt.clientX;
      this._lastY = touchEvt.clientY;
      _hideGhostForTarget();
      var target = document.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
      var parent = target;
      while (target && target.shadowRoot) {
        target = target.shadowRoot.elementFromPoint(touchEvt.clientX, touchEvt.clientY);
        if (target === parent) break;
        parent = target;
      }
      dragEl.parentNode[expando]._isOutsideThisEl(target);
      if (parent) {
        do {
          if (parent[expando]) {
            var inserted = void 0;
            inserted = parent[expando]._onDragOver({
              clientX: touchEvt.clientX,
              clientY: touchEvt.clientY,
              target,
              rootEl: parent
            });
            if (inserted && !this.options.dragoverBubble) {
              break;
            }
          }
          target = parent;
        } while (parent = parent.parentNode);
      }
      _unhideGhostForTarget();
    }
  },
  _onTouchMove: function _onTouchMove(evt) {
    if (tapEvt) {
      var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = ghostEl && matrix(ghostEl, true), scaleX = ghostEl && ghostMatrix && ghostMatrix.a, scaleY = ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = PositionGhostAbsolutely && ghostRelativeParent && getRelativeScrollOffset(ghostRelativeParent), dx = (touch.clientX - tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
      if (!Sortable.active && !awaitingDragStarted) {
        if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) {
          return;
        }
        this._onDragStart(evt, true);
      }
      if (ghostEl) {
        if (ghostMatrix) {
          ghostMatrix.e += dx - (lastDx || 0);
          ghostMatrix.f += dy - (lastDy || 0);
        } else {
          ghostMatrix = {
            a: 1,
            b: 0,
            c: 0,
            d: 1,
            e: dx,
            f: dy
          };
        }
        var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
        css(ghostEl, "webkitTransform", cssMatrix);
        css(ghostEl, "mozTransform", cssMatrix);
        css(ghostEl, "msTransform", cssMatrix);
        css(ghostEl, "transform", cssMatrix);
        lastDx = dx;
        lastDy = dy;
        touchEvt = touch;
      }
      evt.cancelable && evt.preventDefault();
    }
  },
  _appendGhost: function _appendGhost() {
    if (!ghostEl) {
      var container = this.options.fallbackOnBody ? document.body : rootEl, rect = getRect(dragEl, true, PositionGhostAbsolutely, true, container), options = this.options;
      if (PositionGhostAbsolutely) {
        ghostRelativeParent = container;
        while (css(ghostRelativeParent, "position") === "static" && css(ghostRelativeParent, "transform") === "none" && ghostRelativeParent !== document) {
          ghostRelativeParent = ghostRelativeParent.parentNode;
        }
        if (ghostRelativeParent !== document.body && ghostRelativeParent !== document.documentElement) {
          if (ghostRelativeParent === document) ghostRelativeParent = getWindowScrollingElement();
          rect.top += ghostRelativeParent.scrollTop;
          rect.left += ghostRelativeParent.scrollLeft;
        } else {
          ghostRelativeParent = getWindowScrollingElement();
        }
        ghostRelativeParentInitialScroll = getRelativeScrollOffset(ghostRelativeParent);
      }
      ghostEl = dragEl.cloneNode(true);
      toggleClass(ghostEl, options.ghostClass, false);
      toggleClass(ghostEl, options.fallbackClass, true);
      toggleClass(ghostEl, options.dragClass, true);
      css(ghostEl, "transition", "");
      css(ghostEl, "transform", "");
      css(ghostEl, "box-sizing", "border-box");
      css(ghostEl, "margin", 0);
      css(ghostEl, "top", rect.top);
      css(ghostEl, "left", rect.left);
      css(ghostEl, "width", rect.width);
      css(ghostEl, "height", rect.height);
      css(ghostEl, "opacity", "0.8");
      css(ghostEl, "position", PositionGhostAbsolutely ? "absolute" : "fixed");
      css(ghostEl, "zIndex", "100000");
      css(ghostEl, "pointerEvents", "none");
      Sortable.ghost = ghostEl;
      container.appendChild(ghostEl);
      css(ghostEl, "transform-origin", tapDistanceLeft / parseInt(ghostEl.style.width) * 100 + "% " + tapDistanceTop / parseInt(ghostEl.style.height) * 100 + "%");
    }
  },
  _onDragStart: function _onDragStart(evt, fallback) {
    var _this = this;
    var dataTransfer = evt.dataTransfer;
    var options = _this.options;
    pluginEvent("dragStart", this, {
      evt
    });
    if (Sortable.eventCanceled) {
      this._onDrop();
      return;
    }
    pluginEvent("setupClone", this);
    if (!Sortable.eventCanceled) {
      cloneEl = clone(dragEl);
      cloneEl.draggable = false;
      cloneEl.style["will-change"] = "";
      this._hideClone();
      toggleClass(cloneEl, this.options.chosenClass, false);
      Sortable.clone = cloneEl;
    }
    _this.cloneId = _nextTick(function() {
      pluginEvent("clone", _this);
      if (Sortable.eventCanceled) return;
      if (!_this.options.removeCloneOnHide) {
        rootEl.insertBefore(cloneEl, dragEl);
      }
      _this._hideClone();
      _dispatchEvent({
        sortable: _this,
        name: "clone"
      });
    });
    !fallback && toggleClass(dragEl, options.dragClass, true);
    if (fallback) {
      ignoreNextClick = true;
      _this._loopId = setInterval(_this._emulateDragOver, 50);
    } else {
      off(document, "mouseup", _this._onDrop);
      off(document, "touchend", _this._onDrop);
      off(document, "touchcancel", _this._onDrop);
      if (dataTransfer) {
        dataTransfer.effectAllowed = "move";
        options.setData && options.setData.call(_this, dataTransfer, dragEl);
      }
      on(document, "drop", _this);
      css(dragEl, "transform", "translateZ(0)");
    }
    awaitingDragStarted = true;
    _this._dragStartId = _nextTick(_this._dragStarted.bind(_this, fallback, evt));
    on(document, "selectstart", _this);
    moved = true;
    if (Safari) {
      css(document.body, "user-select", "none");
    }
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function _onDragOver(evt) {
    var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = Sortable.active, isOwner = activeGroup === group, canSort = options.sort, fromSortable = putSortable || activeSortable, vertical, _this = this, completedFired = false;
    if (_silent) return;
    function dragOverEvent(name, extra) {
      pluginEvent(name, _this, _objectSpread2({
        evt,
        isOwner,
        axis: vertical ? "vertical" : "horizontal",
        revert,
        dragRect,
        targetRect,
        canSort,
        fromSortable,
        target,
        completed,
        onMove: function onMove(target2, after2) {
          return _onMove(rootEl, el, dragEl, dragRect, target2, getRect(target2), evt, after2);
        },
        changed
      }, extra));
    }
    function capture() {
      dragOverEvent("dragOverAnimationCapture");
      _this.captureAnimationState();
      if (_this !== fromSortable) {
        fromSortable.captureAnimationState();
      }
    }
    function completed(insertion) {
      dragOverEvent("dragOverCompleted", {
        insertion
      });
      if (insertion) {
        if (isOwner) {
          activeSortable._hideClone();
        } else {
          activeSortable._showClone(_this);
        }
        if (_this !== fromSortable) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
          toggleClass(dragEl, options.ghostClass, true);
        }
        if (putSortable !== _this && _this !== Sortable.active) {
          putSortable = _this;
        } else if (_this === Sortable.active && putSortable) {
          putSortable = null;
        }
        if (fromSortable === _this) {
          _this._ignoreWhileAnimating = target;
        }
        _this.animateAll(function() {
          dragOverEvent("dragOverAnimationComplete");
          _this._ignoreWhileAnimating = null;
        });
        if (_this !== fromSortable) {
          fromSortable.animateAll();
          fromSortable._ignoreWhileAnimating = null;
        }
      }
      if (target === dragEl && !dragEl.animated || target === el && !target.animated) {
        lastTarget = null;
      }
      if (!options.dragoverBubble && !evt.rootEl && target !== document) {
        dragEl.parentNode[expando]._isOutsideThisEl(evt.target);
        !insertion && nearestEmptyInsertDetectEvent(evt);
      }
      !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
      return completedFired = true;
    }
    function changed() {
      newIndex = index(dragEl);
      newDraggableIndex = index(dragEl, options.draggable);
      _dispatchEvent({
        sortable: _this,
        name: "change",
        toEl: el,
        newIndex,
        newDraggableIndex,
        originalEvent: evt
      });
    }
    if (evt.preventDefault !== void 0) {
      evt.cancelable && evt.preventDefault();
    }
    target = closest(target, options.draggable, el, true);
    dragOverEvent("dragOver");
    if (Sortable.eventCanceled) return completedFired;
    if (dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) {
      return completed(false);
    }
    ignoreNextClick = false;
    if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = parentEl !== rootEl) : putSortable === this || (this.lastPutMode = activeGroup.checkPull(this, activeSortable, dragEl, evt)) && group.checkPut(this, activeSortable, dragEl, evt))) {
      vertical = this._getDirection(evt, target) === "vertical";
      dragRect = getRect(dragEl);
      dragOverEvent("dragOverValid");
      if (Sortable.eventCanceled) return completedFired;
      if (revert) {
        parentEl = rootEl;
        capture();
        this._hideClone();
        dragOverEvent("revert");
        if (!Sortable.eventCanceled) {
          if (nextEl) {
            rootEl.insertBefore(dragEl, nextEl);
          } else {
            rootEl.appendChild(dragEl);
          }
        }
        return completed(true);
      }
      var elLastChild = lastChild(el, options.draggable);
      if (!elLastChild || _ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
        if (elLastChild === dragEl) {
          return completed(false);
        }
        if (elLastChild && el === evt.target) {
          target = elLastChild;
        }
        if (target) {
          targetRect = getRect(target);
        }
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
          capture();
          el.appendChild(dragEl);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (elLastChild && _ghostIsFirst(evt, vertical, this)) {
        var firstChild = getChild(el, 0, options, true);
        if (firstChild === dragEl) {
          return completed(false);
        }
        target = firstChild;
        targetRect = getRect(target);
        if (_onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, false) !== false) {
          capture();
          el.insertBefore(dragEl, firstChild);
          parentEl = el;
          changed();
          return completed(true);
        }
      } else if (target.parentNode === el) {
        targetRect = getRect(target);
        var direction = 0, targetBeforeFirstSwap, differentLevel = dragEl.parentNode !== el, differentRowCol = !_dragElInRowColumn(dragEl.animated && dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? "top" : "left", scrolledPastTop = isScrolledPast(target, "top", "top") || isScrolledPast(dragEl, "top", "top"), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
        if (lastTarget !== target) {
          targetBeforeFirstSwap = targetRect[side1];
          pastFirstInvertThresh = false;
          isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
        }
        direction = _getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, isCircumstantialInvert, lastTarget === target);
        var sibling;
        if (direction !== 0) {
          var dragIndex = index(dragEl);
          do {
            dragIndex -= direction;
            sibling = parentEl.children[dragIndex];
          } while (sibling && (css(sibling, "display") === "none" || sibling === ghostEl));
        }
        if (direction === 0 || sibling === target) {
          return completed(false);
        }
        lastTarget = target;
        lastDirection = direction;
        var nextSibling = target.nextElementSibling, after = false;
        after = direction === 1;
        var moveVector = _onMove(rootEl, el, dragEl, dragRect, target, targetRect, evt, after);
        if (moveVector !== false) {
          if (moveVector === 1 || moveVector === -1) {
            after = moveVector === 1;
          }
          _silent = true;
          setTimeout(_unsilent, 30);
          capture();
          if (after && !nextSibling) {
            el.appendChild(dragEl);
          } else {
            target.parentNode.insertBefore(dragEl, after ? nextSibling : target);
          }
          if (scrolledPastTop) {
            scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
          }
          parentEl = dragEl.parentNode;
          if (targetBeforeFirstSwap !== void 0 && !isCircumstantialInvert) {
            targetMoveDistance = Math.abs(targetBeforeFirstSwap - getRect(target)[side1]);
          }
          changed();
          return completed(true);
        }
      }
      if (el.contains(dragEl)) {
        return completed(false);
      }
    }
    return false;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function _offMoveEvents() {
    off(document, "mousemove", this._onTouchMove);
    off(document, "touchmove", this._onTouchMove);
    off(document, "pointermove", this._onTouchMove);
    off(document, "dragover", nearestEmptyInsertDetectEvent);
    off(document, "mousemove", nearestEmptyInsertDetectEvent);
    off(document, "touchmove", nearestEmptyInsertDetectEvent);
  },
  _offUpEvents: function _offUpEvents() {
    var ownerDocument = this.el.ownerDocument;
    off(ownerDocument, "mouseup", this._onDrop);
    off(ownerDocument, "touchend", this._onDrop);
    off(ownerDocument, "pointerup", this._onDrop);
    off(ownerDocument, "touchcancel", this._onDrop);
    off(document, "selectstart", this);
  },
  _onDrop: function _onDrop(evt) {
    var el = this.el, options = this.options;
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    pluginEvent("drop", this, {
      evt
    });
    parentEl = dragEl && dragEl.parentNode;
    newIndex = index(dragEl);
    newDraggableIndex = index(dragEl, options.draggable);
    if (Sortable.eventCanceled) {
      this._nulling();
      return;
    }
    awaitingDragStarted = false;
    isCircumstantialInvert = false;
    pastFirstInvertThresh = false;
    clearInterval(this._loopId);
    clearTimeout(this._dragStartTimer);
    _cancelNextTick(this.cloneId);
    _cancelNextTick(this._dragStartId);
    if (this.nativeDraggable) {
      off(document, "drop", this);
      off(el, "dragstart", this._onDragStart);
    }
    this._offMoveEvents();
    this._offUpEvents();
    if (Safari) {
      css(document.body, "user-select", "");
    }
    css(dragEl, "transform", "");
    if (evt) {
      if (moved) {
        evt.cancelable && evt.preventDefault();
        !options.dropBubble && evt.stopPropagation();
      }
      ghostEl && ghostEl.parentNode && ghostEl.parentNode.removeChild(ghostEl);
      if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== "clone") {
        cloneEl && cloneEl.parentNode && cloneEl.parentNode.removeChild(cloneEl);
      }
      if (dragEl) {
        if (this.nativeDraggable) {
          off(dragEl, "dragend", this);
        }
        _disableDraggable(dragEl);
        dragEl.style["will-change"] = "";
        if (moved && !awaitingDragStarted) {
          toggleClass(dragEl, putSortable ? putSortable.options.ghostClass : this.options.ghostClass, false);
        }
        toggleClass(dragEl, this.options.chosenClass, false);
        _dispatchEvent({
          sortable: this,
          name: "unchoose",
          toEl: parentEl,
          newIndex: null,
          newDraggableIndex: null,
          originalEvent: evt
        });
        if (rootEl !== parentEl) {
          if (newIndex >= 0) {
            _dispatchEvent({
              rootEl: parentEl,
              name: "add",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "remove",
              toEl: parentEl,
              originalEvent: evt
            });
            _dispatchEvent({
              rootEl: parentEl,
              name: "sort",
              toEl: parentEl,
              fromEl: rootEl,
              originalEvent: evt
            });
            _dispatchEvent({
              sortable: this,
              name: "sort",
              toEl: parentEl,
              originalEvent: evt
            });
          }
          putSortable && putSortable.save();
        } else {
          if (newIndex !== oldIndex) {
            if (newIndex >= 0) {
              _dispatchEvent({
                sortable: this,
                name: "update",
                toEl: parentEl,
                originalEvent: evt
              });
              _dispatchEvent({
                sortable: this,
                name: "sort",
                toEl: parentEl,
                originalEvent: evt
              });
            }
          }
        }
        if (Sortable.active) {
          if (newIndex == null || newIndex === -1) {
            newIndex = oldIndex;
            newDraggableIndex = oldDraggableIndex;
          }
          _dispatchEvent({
            sortable: this,
            name: "end",
            toEl: parentEl,
            originalEvent: evt
          });
          this.save();
        }
      }
    }
    this._nulling();
  },
  _nulling: function _nulling() {
    pluginEvent("nulling", this);
    rootEl = dragEl = parentEl = ghostEl = nextEl = cloneEl = lastDownEl = cloneHidden = tapEvt = touchEvt = moved = newIndex = newDraggableIndex = oldIndex = oldDraggableIndex = lastTarget = lastDirection = putSortable = activeGroup = Sortable.dragged = Sortable.ghost = Sortable.clone = Sortable.active = null;
    savedInputChecked.forEach(function(el) {
      el.checked = true;
    });
    savedInputChecked.length = lastDx = lastDy = 0;
  },
  handleEvent: function handleEvent(evt) {
    switch (evt.type) {
      case "drop":
      case "dragend":
        this._onDrop(evt);
        break;
      case "dragenter":
      case "dragover":
        if (dragEl) {
          this._onDragOver(evt);
          _globalDragOver(evt);
        }
        break;
      case "selectstart":
        evt.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function toArray2() {
    var order = [], el, children2 = this.el.children, i = 0, n2 = children2.length, options = this.options;
    for (; i < n2; i++) {
      el = children2[i];
      if (closest(el, options.draggable, this.el, false)) {
        order.push(el.getAttribute(options.dataIdAttr) || _generateId(el));
      }
    }
    return order;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function sort(order, useAnimation) {
    var items = {}, rootEl2 = this.el;
    this.toArray().forEach(function(id, i) {
      var el = rootEl2.children[i];
      if (closest(el, this.options.draggable, rootEl2, false)) {
        items[id] = el;
      }
    }, this);
    useAnimation && this.captureAnimationState();
    order.forEach(function(id) {
      if (items[id]) {
        rootEl2.removeChild(items[id]);
        rootEl2.appendChild(items[id]);
      }
    });
    useAnimation && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function save() {
    var store = this.options.store;
    store && store.set && store.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function closest$1(el, selector2) {
    return closest(el, selector2 || this.options.draggable, this.el, false);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function option(name, value) {
    var options = this.options;
    if (value === void 0) {
      return options[name];
    } else {
      var modifiedValue = PluginManager.modifyOption(this, name, value);
      if (typeof modifiedValue !== "undefined") {
        options[name] = modifiedValue;
      } else {
        options[name] = value;
      }
      if (name === "group") {
        _prepareGroup(options);
      }
    }
  },
  /**
   * Destroy
   */
  destroy: function destroy() {
    pluginEvent("destroy", this);
    var el = this.el;
    el[expando] = null;
    off(el, "mousedown", this._onTapStart);
    off(el, "touchstart", this._onTapStart);
    off(el, "pointerdown", this._onTapStart);
    if (this.nativeDraggable) {
      off(el, "dragover", this);
      off(el, "dragenter", this);
    }
    Array.prototype.forEach.call(el.querySelectorAll("[draggable]"), function(el2) {
      el2.removeAttribute("draggable");
    });
    this._onDrop();
    this._disableDelayedDragEvents();
    sortables.splice(sortables.indexOf(this.el), 1);
    this.el = el = null;
  },
  _hideClone: function _hideClone() {
    if (!cloneHidden) {
      pluginEvent("hideClone", this);
      if (Sortable.eventCanceled) return;
      css(cloneEl, "display", "none");
      if (this.options.removeCloneOnHide && cloneEl.parentNode) {
        cloneEl.parentNode.removeChild(cloneEl);
      }
      cloneHidden = true;
    }
  },
  _showClone: function _showClone(putSortable2) {
    if (putSortable2.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (cloneHidden) {
      pluginEvent("showClone", this);
      if (Sortable.eventCanceled) return;
      if (dragEl.parentNode == rootEl && !this.options.group.revertClone) {
        rootEl.insertBefore(cloneEl, dragEl);
      } else if (nextEl) {
        rootEl.insertBefore(cloneEl, nextEl);
      } else {
        rootEl.appendChild(cloneEl);
      }
      if (this.options.group.revertClone) {
        this.animate(dragEl, cloneEl);
      }
      css(cloneEl, "display", "");
      cloneHidden = false;
    }
  }
};
function _globalDragOver(evt) {
  if (evt.dataTransfer) {
    evt.dataTransfer.dropEffect = "move";
  }
  evt.cancelable && evt.preventDefault();
}
function _onMove(fromEl, toEl, dragEl2, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
  var evt, sortable = fromEl[expando], onMoveFn = sortable.options.onMove, retVal;
  if (window.CustomEvent && !IE11OrLess && !Edge) {
    evt = new CustomEvent("move", {
      bubbles: true,
      cancelable: true
    });
  } else {
    evt = document.createEvent("Event");
    evt.initEvent("move", true, true);
  }
  evt.to = toEl;
  evt.from = fromEl;
  evt.dragged = dragEl2;
  evt.draggedRect = dragRect;
  evt.related = targetEl || toEl;
  evt.relatedRect = targetRect || getRect(toEl);
  evt.willInsertAfter = willInsertAfter;
  evt.originalEvent = originalEvent;
  fromEl.dispatchEvent(evt);
  if (onMoveFn) {
    retVal = onMoveFn.call(sortable, evt, originalEvent);
  }
  return retVal;
}
function _disableDraggable(el) {
  el.draggable = false;
}
function _unsilent() {
  _silent = false;
}
function _ghostIsFirst(evt, vertical, sortable) {
  var rect = getRect(getChild(sortable.el, 0, sortable.options, true));
  var spacer = 10;
  return vertical ? evt.clientX < rect.left - spacer || evt.clientY < rect.top && evt.clientX < rect.right : evt.clientY < rect.top - spacer || evt.clientY < rect.bottom && evt.clientX < rect.left;
}
function _ghostIsLast(evt, vertical, sortable) {
  var rect = getRect(lastChild(sortable.el, sortable.options.draggable));
  var spacer = 10;
  return vertical ? evt.clientX > rect.right + spacer || evt.clientX <= rect.right && evt.clientY > rect.bottom && evt.clientX >= rect.left : evt.clientX > rect.right && evt.clientY > rect.top || evt.clientX <= rect.right && evt.clientY > rect.bottom + spacer;
}
function _getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
  var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
  if (!invertSwap) {
    if (isLastTarget && targetMoveDistance < targetLength * swapThreshold) {
      if (!pastFirstInvertThresh && (lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) {
        pastFirstInvertThresh = true;
      }
      if (!pastFirstInvertThresh) {
        if (lastDirection === 1 ? mouseOnAxis < targetS1 + targetMoveDistance : mouseOnAxis > targetS2 - targetMoveDistance) {
          return -lastDirection;
        }
      } else {
        invert = true;
      }
    } else {
      if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) {
        return _getInsertDirection(target);
      }
    }
  }
  invert = invert || invertSwap;
  if (invert) {
    if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) {
      return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
  }
  return 0;
}
function _getInsertDirection(target) {
  if (index(dragEl) < index(target)) {
    return 1;
  } else {
    return -1;
  }
}
function _generateId(el) {
  var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
  while (i--) {
    sum += str.charCodeAt(i);
  }
  return sum.toString(36);
}
function _saveInputCheckedState(root2) {
  savedInputChecked.length = 0;
  var inputs = root2.getElementsByTagName("input");
  var idx = inputs.length;
  while (idx--) {
    var el = inputs[idx];
    el.checked && savedInputChecked.push(el);
  }
}
function _nextTick(fn2) {
  return setTimeout(fn2, 0);
}
function _cancelNextTick(id) {
  return clearTimeout(id);
}
if (documentExists) {
  on(document, "touchmove", function(evt) {
    if ((Sortable.active || awaitingDragStarted) && evt.cancelable) {
      evt.preventDefault();
    }
  });
}
Sortable.utils = {
  on,
  off,
  css,
  find,
  is: function is3(el, selector2) {
    return !!closest(el, selector2, el, false);
  },
  extend: extend$1,
  throttle: throttle$1,
  closest,
  toggleClass,
  clone,
  index,
  nextTick: _nextTick,
  cancelNextTick: _cancelNextTick,
  detectDirection: _detectDirection,
  getChild
};
Sortable.get = function(element) {
  return element[expando];
};
Sortable.mount = function() {
  for (var _len = arguments.length, plugins2 = new Array(_len), _key = 0; _key < _len; _key++) {
    plugins2[_key] = arguments[_key];
  }
  if (plugins2[0].constructor === Array) plugins2 = plugins2[0];
  plugins2.forEach(function(plugin) {
    if (!plugin.prototype || !plugin.prototype.constructor) {
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(plugin));
    }
    if (plugin.utils) Sortable.utils = _objectSpread2(_objectSpread2({}, Sortable.utils), plugin.utils);
    PluginManager.mount(plugin);
  });
};
Sortable.create = function(el, options) {
  return new Sortable(el, options);
};
Sortable.version = version;
var autoScrolls = [], scrollEl, scrollRootEl, scrolling = false, lastAutoScrollX, lastAutoScrollY, touchEvt$1, pointerElemChangedInterval;
function AutoScrollPlugin() {
  function AutoScroll() {
    this.defaults = {
      scroll: true,
      forceAutoScrollFallback: false,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: true
    };
    for (var fn2 in this) {
      if (fn2.charAt(0) === "_" && typeof this[fn2] === "function") {
        this[fn2] = this[fn2].bind(this);
      }
    }
  }
  AutoScroll.prototype = {
    dragStarted: function dragStarted(_ref) {
      var originalEvent = _ref.originalEvent;
      if (this.sortable.nativeDraggable) {
        on(document, "dragover", this._handleAutoScroll);
      } else {
        if (this.options.supportPointer) {
          on(document, "pointermove", this._handleFallbackAutoScroll);
        } else if (originalEvent.touches) {
          on(document, "touchmove", this._handleFallbackAutoScroll);
        } else {
          on(document, "mousemove", this._handleFallbackAutoScroll);
        }
      }
    },
    dragOverCompleted: function dragOverCompleted(_ref2) {
      var originalEvent = _ref2.originalEvent;
      if (!this.options.dragOverBubble && !originalEvent.rootEl) {
        this._handleAutoScroll(originalEvent);
      }
    },
    drop: function drop3() {
      if (this.sortable.nativeDraggable) {
        off(document, "dragover", this._handleAutoScroll);
      } else {
        off(document, "pointermove", this._handleFallbackAutoScroll);
        off(document, "touchmove", this._handleFallbackAutoScroll);
        off(document, "mousemove", this._handleFallbackAutoScroll);
      }
      clearPointerElemChangedInterval();
      clearAutoScrolls();
      cancelThrottle();
    },
    nulling: function nulling() {
      touchEvt$1 = scrollRootEl = scrollEl = scrolling = pointerElemChangedInterval = lastAutoScrollX = lastAutoScrollY = null;
      autoScrolls.length = 0;
    },
    _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
      this._handleAutoScroll(evt, true);
    },
    _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
      var _this = this;
      var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y2 = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x2, y2);
      touchEvt$1 = evt;
      if (fallback || this.options.forceAutoScrollFallback || Edge || IE11OrLess || Safari) {
        autoScroll(evt, this.options, elem, fallback);
        var ogElemScroller = getParentAutoScrollElement(elem, true);
        if (scrolling && (!pointerElemChangedInterval || x2 !== lastAutoScrollX || y2 !== lastAutoScrollY)) {
          pointerElemChangedInterval && clearPointerElemChangedInterval();
          pointerElemChangedInterval = setInterval(function() {
            var newElem = getParentAutoScrollElement(document.elementFromPoint(x2, y2), true);
            if (newElem !== ogElemScroller) {
              ogElemScroller = newElem;
              clearAutoScrolls();
            }
            autoScroll(evt, _this.options, newElem, fallback);
          }, 10);
          lastAutoScrollX = x2;
          lastAutoScrollY = y2;
        }
      } else {
        if (!this.options.bubbleScroll || getParentAutoScrollElement(elem, true) === getWindowScrollingElement()) {
          clearAutoScrolls();
          return;
        }
        autoScroll(evt, this.options, getParentAutoScrollElement(elem, false), false);
      }
    }
  };
  return _extends(AutoScroll, {
    pluginName: "scroll",
    initializeByDefault: true
  });
}
function clearAutoScrolls() {
  autoScrolls.forEach(function(autoScroll2) {
    clearInterval(autoScroll2.pid);
  });
  autoScrolls = [];
}
function clearPointerElemChangedInterval() {
  clearInterval(pointerElemChangedInterval);
}
var autoScroll = throttle$1(function(evt, options, rootEl2, isFallback) {
  if (!options.scroll) return;
  var x2 = (evt.touches ? evt.touches[0] : evt).clientX, y2 = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = getWindowScrollingElement();
  var scrollThisInstance = false, scrollCustomFn;
  if (scrollRootEl !== rootEl2) {
    scrollRootEl = rootEl2;
    clearAutoScrolls();
    scrollEl = options.scroll;
    scrollCustomFn = options.scrollFn;
    if (scrollEl === true) {
      scrollEl = getParentAutoScrollElement(rootEl2, true);
    }
  }
  var layersOut = 0;
  var currentParent = scrollEl;
  do {
    var el = currentParent, rect = getRect(el), top2 = rect.top, bottom2 = rect.bottom, left2 = rect.left, right2 = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
    if (el === winScroller) {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll" || elCSS.overflowX === "visible");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll" || elCSS.overflowY === "visible");
    } else {
      canScrollX = width < scrollWidth && (elCSS.overflowX === "auto" || elCSS.overflowX === "scroll");
      canScrollY = height < scrollHeight && (elCSS.overflowY === "auto" || elCSS.overflowY === "scroll");
    }
    var vx = canScrollX && (Math.abs(right2 - x2) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left2 - x2) <= sens && !!scrollPosX);
    var vy = canScrollY && (Math.abs(bottom2 - y2) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top2 - y2) <= sens && !!scrollPosY);
    if (!autoScrolls[layersOut]) {
      for (var i = 0; i <= layersOut; i++) {
        if (!autoScrolls[i]) {
          autoScrolls[i] = {};
        }
      }
    }
    if (autoScrolls[layersOut].vx != vx || autoScrolls[layersOut].vy != vy || autoScrolls[layersOut].el !== el) {
      autoScrolls[layersOut].el = el;
      autoScrolls[layersOut].vx = vx;
      autoScrolls[layersOut].vy = vy;
      clearInterval(autoScrolls[layersOut].pid);
      if (vx != 0 || vy != 0) {
        scrollThisInstance = true;
        autoScrolls[layersOut].pid = setInterval((function() {
          if (isFallback && this.layer === 0) {
            Sortable.active._onTouchMove(touchEvt$1);
          }
          var scrollOffsetY = autoScrolls[this.layer].vy ? autoScrolls[this.layer].vy * speed : 0;
          var scrollOffsetX = autoScrolls[this.layer].vx ? autoScrolls[this.layer].vx * speed : 0;
          if (typeof scrollCustomFn === "function") {
            if (scrollCustomFn.call(Sortable.dragged.parentNode[expando], scrollOffsetX, scrollOffsetY, evt, touchEvt$1, autoScrolls[this.layer].el) !== "continue") {
              return;
            }
          }
          scrollBy(autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
        }).bind({
          layer: layersOut
        }), 24);
      }
    }
    layersOut++;
  } while (options.bubbleScroll && currentParent !== winScroller && (currentParent = getParentAutoScrollElement(currentParent, false)));
  scrolling = scrollThisInstance;
}, 30);
var drop = function drop2(_ref) {
  var originalEvent = _ref.originalEvent, putSortable2 = _ref.putSortable, dragEl2 = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
  if (!originalEvent) return;
  var toSortable = putSortable2 || activeSortable;
  hideGhostForTarget();
  var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
  var target = document.elementFromPoint(touch.clientX, touch.clientY);
  unhideGhostForTarget();
  if (toSortable && !toSortable.el.contains(target)) {
    dispatchSortableEvent("spill");
    this.onSpill({
      dragEl: dragEl2,
      putSortable: putSortable2
    });
  }
};
function Revert() {
}
Revert.prototype = {
  startIndex: null,
  dragStart: function dragStart(_ref2) {
    var oldDraggableIndex2 = _ref2.oldDraggableIndex;
    this.startIndex = oldDraggableIndex2;
  },
  onSpill: function onSpill(_ref3) {
    var dragEl2 = _ref3.dragEl, putSortable2 = _ref3.putSortable;
    this.sortable.captureAnimationState();
    if (putSortable2) {
      putSortable2.captureAnimationState();
    }
    var nextSibling = getChild(this.sortable.el, this.startIndex, this.options);
    if (nextSibling) {
      this.sortable.el.insertBefore(dragEl2, nextSibling);
    } else {
      this.sortable.el.appendChild(dragEl2);
    }
    this.sortable.animateAll();
    if (putSortable2) {
      putSortable2.animateAll();
    }
  },
  drop
};
_extends(Revert, {
  pluginName: "revertOnSpill"
});
function Remove() {
}
Remove.prototype = {
  onSpill: function onSpill2(_ref4) {
    var dragEl2 = _ref4.dragEl, putSortable2 = _ref4.putSortable;
    var parentSortable = putSortable2 || this.sortable;
    parentSortable.captureAnimationState();
    dragEl2.parentNode && dragEl2.parentNode.removeChild(dragEl2);
    parentSortable.animateAll();
  },
  drop
};
_extends(Remove, {
  pluginName: "removeOnSpill"
});
Sortable.mount(new AutoScrollPlugin());
Sortable.mount(Remove, Revert);
function getConsole() {
  if (typeof window !== "undefined") {
    return window.console;
  }
  return global.console;
}
const console$1 = getConsole();
function cached(fn2) {
  const cache = /* @__PURE__ */ Object.create(null);
  return function cachedFn(str) {
    const hit = cache[str];
    return hit || (cache[str] = fn2(str));
  };
}
const regex = /-(\w)/g;
const camelize = cached((str) => str.replace(regex, (_2, c2) => c2 ? c2.toUpperCase() : ""));
function removeNode(node) {
  if (node.parentElement !== null) {
    node.parentElement.removeChild(node);
  }
}
function insertNodeAt(fatherNode, node, position) {
  const refNode = position === 0 ? fatherNode.children[0] : fatherNode.children[position - 1].nextSibling;
  fatherNode.insertBefore(node, refNode);
}
function computeVmIndex(vnodes, element) {
  return Object.values(vnodes).indexOf(element);
}
function computeIndexes(slots, children2, isTransition2, footerOffset) {
  if (!slots) {
    return [];
  }
  const elmFromNodes = Object.values(slots);
  const footerIndex = children2.length - footerOffset;
  const rawIndexes = [...children2].map((elt, idx) => idx >= footerIndex ? elmFromNodes.length : elmFromNodes.indexOf(elt));
  return rawIndexes;
}
function emit(evtName, evtData) {
  this.$nextTick(() => this.$emit(evtName.toLowerCase(), evtData));
}
function delegateAndEmit(evtName) {
  return (evtData) => {
    if (this.realList !== null) {
      this["onDrag" + evtName](evtData);
    }
    emit.call(this, evtName, evtData);
  };
}
function isTransitionName(name) {
  return ["transition-group", "TransitionGroup"].includes(name);
}
function isTransition(slots) {
  if (!slots || slots.length !== 1) {
    return false;
  }
  const [{ type: type3 }] = slots;
  if (!type3) {
    return false;
  }
  return isTransitionName(type3.name);
}
function getComponentAttributes($attrs, componentData) {
  if (!componentData) {
    return $attrs;
  }
  return { ...componentData.props, ...componentData.attrs };
}
const eventsListened = ["Start", "Add", "Remove", "Update", "End"];
const eventsToEmit = ["Choose", "Unchoose", "Sort", "Filter", "Clone"];
const readonlyProperties = ["Move", ...eventsListened, ...eventsToEmit].map((evt) => "on" + evt);
let draggingElement = null;
const props = {
  options: Object,
  list: {
    type: Array,
    required: false,
    default: null
  },
  noTransitionOnDrag: {
    type: Boolean,
    default: false
  },
  clone: {
    type: Function,
    default: (original) => {
      return original;
    }
  },
  tag: {
    type: String,
    default: "div"
  },
  move: {
    type: Function,
    default: null
  },
  componentData: {
    type: Object,
    required: false,
    default: null
  },
  component: {
    type: String,
    default: null
  },
  modelValue: {
    type: Array,
    required: false,
    default: null
  }
};
const VueDraggableNext = defineComponent({
  name: "VueDraggableNext",
  inheritAttrs: false,
  emits: [
    "update:modelValue",
    "move",
    "change",
    ...eventsListened.map((s) => s.toLowerCase()),
    ...eventsToEmit.map((s) => s.toLowerCase())
  ],
  props,
  data() {
    return {
      transitionMode: false,
      noneFunctionalComponentMode: false,
      headerOffset: 0,
      footerOffset: 0,
      _sortable: {},
      visibleIndexes: [],
      context: {}
    };
  },
  render() {
    const slots = this.$slots.default ? this.$slots.default() : null;
    const attrs = getComponentAttributes(this.$attrs, this.componentData);
    if (!slots)
      return h$1(this.getTag(), attrs, []);
    this.transitionMode = isTransition(slots);
    return h$1(this.getTag(), attrs, slots);
  },
  created() {
    if (this.list !== null && this.modelValue !== null) {
      console$1.error("list props are mutually exclusive! Please set one.");
    }
  },
  mounted() {
    const optionsAdded = {};
    eventsListened.forEach((elt) => {
      optionsAdded["on" + elt] = delegateAndEmit.call(this, elt);
    });
    eventsToEmit.forEach((elt) => {
      optionsAdded["on" + elt] = emit.bind(this, elt);
    });
    const attributes = Object.keys(this.$attrs).reduce((res, key) => {
      res[camelize(key)] = this.$attrs[key];
      return res;
    }, {});
    const options = Object.assign({}, attributes, optionsAdded, {
      onMove: (evt, originalEvent) => {
        return this.onDragMove(evt, originalEvent);
      }
    });
    !("draggable" in options) && (options.draggable = ">*");
    const targetDomElement = this.$el.nodeType === 1 ? this.$el : this.$el.parentElement;
    this._sortable = new Sortable(targetDomElement, options);
    targetDomElement.__draggable_component__ = this;
    this.computeIndexes();
  },
  beforeUnmount() {
    try {
      if (this._sortable !== void 0)
        this._sortable.destroy();
    } catch (error) {
    }
  },
  computed: {
    realList() {
      return this.list ? this.list : this.modelValue;
    }
  },
  watch: {
    $attrs: {
      handler(newOptionValue) {
        this.updateOptions(newOptionValue);
      },
      deep: true
    },
    realList() {
      this.computeIndexes();
    }
  },
  methods: {
    getTag() {
      return this.component ? resolveComponent(this.component) : this.tag;
    },
    updateOptions(newOptionValue) {
      for (var property in newOptionValue) {
        const value = camelize(property);
        if (readonlyProperties.indexOf(value) === -1) {
          this._sortable.option(value, newOptionValue[property]);
        }
      }
    },
    getChildrenNodes() {
      return this.$el.children;
    },
    computeIndexes() {
      this.$nextTick(() => {
        this.visibleIndexes = computeIndexes(this.getChildrenNodes(), this.$el.children, this.transitionMode, this.footerOffset);
      });
    },
    getUnderlyingVm(htmlElt) {
      const index2 = computeVmIndex(this.getChildrenNodes() || [], htmlElt);
      if (index2 === -1) {
        return null;
      }
      const element = this.realList[index2];
      return { index: index2, element };
    },
    emitChanges(evt) {
      this.$nextTick(() => {
        this.$emit("change", evt);
      });
    },
    alterList(onList) {
      if (this.list) {
        onList(this.list);
        return;
      }
      const newList = [...this.modelValue];
      onList(newList);
      this.$emit("update:modelValue", newList);
    },
    spliceList() {
      const spliceList = (list) => list.splice(...arguments);
      this.alterList(spliceList);
    },
    updatePosition(oldIndex2, newIndex2) {
      const updatePosition = (list) => list.splice(newIndex2, 0, list.splice(oldIndex2, 1)[0]);
      this.alterList(updatePosition);
    },
    getVmIndex(domIndex) {
      const indexes = this.visibleIndexes;
      const numberIndexes = indexes.length;
      return domIndex > numberIndexes - 1 ? numberIndexes : indexes[domIndex];
    },
    getComponent() {
      return this.$slots.default ? (
        //@ts-ignore
        this.$slots.default()[0].componentInstance
      ) : null;
    },
    resetTransitionData(index2) {
      if (!this.noTransitionOnDrag || !this.transitionMode) {
        return;
      }
      var nodes = this.getChildrenNodes();
      nodes[index2].data = null;
      const transitionContainer = this.getComponent();
      transitionContainer.children = [];
      transitionContainer.kept = void 0;
    },
    onDragStart(evt) {
      this.computeIndexes();
      this.context = this.getUnderlyingVm(evt.item);
      if (!this.context)
        return;
      evt.item._underlying_vm_ = this.clone(this.context.element);
      draggingElement = evt.item;
    },
    onDragAdd(evt) {
      const element = evt.item._underlying_vm_;
      if (element === void 0) {
        return;
      }
      removeNode(evt.item);
      const newIndex2 = this.getVmIndex(evt.newIndex);
      this.spliceList(newIndex2, 0, element);
      this.computeIndexes();
      const added = { element, newIndex: newIndex2 };
      this.emitChanges({ added });
    },
    onDragRemove(evt) {
      insertNodeAt(this.$el, evt.item, evt.oldIndex);
      if (evt.pullMode === "clone") {
        removeNode(evt.clone);
        return;
      }
      if (!this.context)
        return;
      const oldIndex2 = this.context.index;
      this.spliceList(oldIndex2, 1);
      const removed = { element: this.context.element, oldIndex: oldIndex2 };
      this.resetTransitionData(oldIndex2);
      this.emitChanges({ removed });
    },
    onDragUpdate(evt) {
      removeNode(evt.item);
      insertNodeAt(evt.from, evt.item, evt.oldIndex);
      const oldIndex2 = this.context.index;
      const newIndex2 = this.getVmIndex(evt.newIndex);
      this.updatePosition(oldIndex2, newIndex2);
      const moved2 = { element: this.context.element, oldIndex: oldIndex2, newIndex: newIndex2 };
      this.emitChanges({ moved: moved2 });
    },
    updateProperty(evt, propertyName) {
      evt.hasOwnProperty(propertyName) && (evt[propertyName] += this.headerOffset);
    },
    onDragMove(evt, originalEvent) {
      const onMove = this.move;
      if (!onMove || !this.realList) {
        return true;
      }
      const relatedContext = this.getRelatedContextFromMoveEvent(evt);
      const draggedContext = this.context;
      const futureIndex = this.computeFutureIndex(relatedContext, evt);
      Object.assign(draggedContext, { futureIndex });
      const sendEvt = Object.assign({}, evt, {
        relatedContext,
        draggedContext
      });
      return onMove(sendEvt, originalEvent);
    },
    onDragEnd() {
      this.computeIndexes();
      draggingElement = null;
    },
    getTrargetedComponent(htmElement) {
      return htmElement.__draggable_component__;
    },
    getRelatedContextFromMoveEvent({ to: to2, related }) {
      const component = this.getTrargetedComponent(to2);
      if (!component) {
        return { component };
      }
      const list = component.realList;
      const context = { list, component };
      if (to2 !== related && list && component.getUnderlyingVm) {
        const destination = component.getUnderlyingVm(related);
        if (destination) {
          return Object.assign(destination, context);
        }
      }
      return context;
    },
    computeFutureIndex(relatedContext, evt) {
      const domChildren = [...evt.to.children].filter((el) => el.style["display"] !== "none");
      if (domChildren.length === 0)
        return 0;
      const currentDOMIndex = domChildren.indexOf(evt.related);
      const currentIndex = relatedContext.component.getVmIndex(currentDOMIndex);
      const draggedInList = domChildren.indexOf(draggingElement) !== -1;
      return draggedInList || !evt.willInsertAfter ? currentIndex : currentIndex + 1;
    }
  }
});
const _sfc_main$u = /* @__PURE__ */ defineComponent({
  __name: "TableField",
  props: {
    description: { type: String, required: false, default: "" },
    meta: { type: Object, required: true },
    fieldname: { type: String, required: true },
    bagelApp: { type: null, required: false, default: void 0 },
    modelValue: { type: null, required: true }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emits = __emit;
    let bagel;
    let api;
    const listRef = ref(props2.modelValue);
    const fieldMeta = props2.meta.doc_meta.fields.find(
      (field) => field.fieldname === props2.fieldname
    );
    const entityMeta = props2.meta.links.find(
      (link) => link.id === (fieldMeta == null ? void 0 : fieldMeta.options)
    );
    function handleUpdateModelValue(value, index2, fieldname) {
      const rows = [...props2.modelValue];
      rows[index2][fieldname] = value;
      emits("update:modelValue", rows);
    }
    function addRow2() {
      const rows = [...props2.modelValue];
      const entry = {
        idx: rows.length
      };
      entityMeta == null ? void 0 : entityMeta.fields.forEach((field) => {
        if (field.default) {
          if (field.fieldtype === "Check") {
            entry[field.fieldname] = Number.parseInt(field.default);
          } else {
            entry[field.fieldname] = field.default;
          }
        }
      });
      rows.push(entry);
      emits("update:modelValue", rows);
    }
    function removeRow(idx) {
      const rows = [...props2.modelValue];
      rows.splice(idx, 1);
      emits("update:modelValue", rows);
    }
    function ended() {
      listRef.value.forEach((item, index2) => {
        item.idx = index2 + 1;
      });
      emits("update:modelValue", listRef.value);
    }
    onMounted(() => {
      bagel = props2.bagelApp || api;
    });
    const __returned__ = { props: props2, emits, get bagel() {
      return bagel;
    }, set bagel(v) {
      bagel = v;
    }, get api() {
      return api;
    }, set api(v) {
      api = v;
    }, listRef, fieldMeta, entityMeta, handleUpdateModelValue, addRow: addRow2, removeRow, ended, get Btn() {
      return Btn;
    }, get MaterialIcon() {
      return Icon;
    }, get formatString() {
      return formatString;
    }, get VueDraggableNext() {
      return VueDraggableNext;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$m = ["title"];
const _hoisted_2$d = { class: "bagel-input" };
const _hoisted_3$b = { class: "table-side-scroll" };
const _hoisted_4$7 = { class: "table-header" };
const _hoisted_5$7 = { class: "table-reorder" };
const _hoisted_6$6 = { class: "table-action" };
function _sfc_render$u(_ctx, _cache, $props, $setup, $data, $options) {
  var _a2, _b;
  const _component_BagelInput = resolveComponent("BagelInput");
  return openBlock(), createElementBlock("div", {
    class: "table-field-wrap",
    title: $props.description
  }, [
    createElementVNode("div", _hoisted_2$d, [
      createElementVNode(
        "label",
        null,
        toDisplayString((_a2 = $setup.fieldMeta) == null ? void 0 : _a2.label),
        1
        /* TEXT */
      )
    ]),
    createElementVNode("div", _hoisted_3$b, [
      createElementVNode("div", _hoisted_4$7, [
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList((_b = $setup.entityMeta) == null ? void 0 : _b.fields, (field) => {
            return openBlock(), createElementBlock(
              "div",
              {
                key: `${field.fieldname}header`,
                class: normalizeClass(["header-col", $setup.formatString(field.fieldtype, "pascal")])
              },
              toDisplayString(field.label),
              3
              /* TEXT, CLASS */
            );
          }),
          128
          /* KEYED_FRAGMENT */
        ))
      ]),
      createVNode($setup["VueDraggableNext"], {
        modelValue: $setup.listRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.listRef = $event),
        animation: "150",
        handle: ".table-reorder",
        group: "mainGroup",
        easing: "cubic-bezier(1, 0, 0, 1)",
        "ghost-class": "ghost",
        onEnd: $setup.ended
      }, {
        default: withCtx(() => [
          createVNode(TransitionGroup, null, {
            default: withCtx(() => [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList($props.modelValue, (row, index2) => {
                  var _a3;
                  return openBlock(), createElementBlock("div", {
                    key: row.id,
                    class: "flex table-row"
                  }, [
                    createElementVNode("div", _hoisted_5$7, [
                      createVNode($setup["MaterialIcon"], { icon: "more_vert" })
                    ]),
                    (openBlock(true), createElementBlock(
                      Fragment,
                      null,
                      renderList((_a3 = $setup.entityMeta) == null ? void 0 : _a3.fields, (field) => {
                        return openBlock(), createElementBlock(
                          "div",
                          {
                            key: `${field.fieldname}${row.id}`,
                            class: normalizeClass(["table-cell", $setup.formatString(field.fieldtype, "pascal")])
                          },
                          [
                            createVNode(_component_BagelInput, {
                              "no-label": "",
                              "field-meta": field,
                              "bagel-app": $setup.bagel,
                              "model-value": row[field.fieldname],
                              "onUpdate:modelValue": (value) => $setup.handleUpdateModelValue(value, index2, field.fieldname)
                            }, null, 8, ["field-meta", "bagel-app", "model-value", "onUpdate:modelValue"])
                          ],
                          2
                          /* CLASS */
                        );
                      }),
                      128
                      /* KEYED_FRAGMENT */
                    )),
                    createElementVNode("div", _hoisted_6$6, [
                      createVNode($setup["MaterialIcon"], {
                        icon: "delete",
                        onClick: ($event) => $setup.removeRow(index2)
                      }, null, 8, ["onClick"])
                    ])
                  ]);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ]),
            _: 1
            /* STABLE */
          })
        ]),
        _: 1
        /* STABLE */
      }, 8, ["modelValue"])
    ]),
    createVNode($setup["Btn"], {
      thin: "",
      flat: "",
      icon: "add",
      color: "light",
      onClick: $setup.addRow
    }, {
      default: withCtx(() => _cache[1] || (_cache[1] = [
        createTextVNode(" New ")
      ])),
      _: 1
      /* STABLE */
    })
  ], 8, _hoisted_1$m);
}
const TableField = /* @__PURE__ */ _export_sfc(_sfc_main$u, [["render", _sfc_render$u], ["__scopeId", "data-v-ebd7e287"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/TableField.vue"]]);
function bind(fn2, thisArg) {
  return function wrap() {
    return fn2.apply(thisArg, arguments);
  };
}
const { toString } = Object.prototype;
const { getPrototypeOf } = Object;
const kindOf = /* @__PURE__ */ ((cache) => (thing) => {
  const str = toString.call(thing);
  return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null));
const kindOfTest = (type3) => {
  type3 = type3.toLowerCase();
  return (thing) => kindOf(thing) === type3;
};
const typeOfTest = (type3) => (thing) => typeof thing === type3;
const { isArray } = Array;
const isUndefined = typeOfTest("undefined");
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
const isArrayBuffer = kindOfTest("ArrayBuffer");
function isArrayBufferView(val) {
  let result2;
  if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
    result2 = ArrayBuffer.isView(val);
  } else {
    result2 = val && val.buffer && isArrayBuffer(val.buffer);
  }
  return result2;
}
const isString = typeOfTest("string");
const isFunction = typeOfTest("function");
const isNumber = typeOfTest("number");
const isObject$1 = (thing) => thing !== null && typeof thing === "object";
const isBoolean = (thing) => thing === true || thing === false;
const isPlainObject = (val) => {
  if (kindOf(val) !== "object") {
    return false;
  }
  const prototype2 = getPrototypeOf(val);
  return (prototype2 === null || prototype2 === Object.prototype || Object.getPrototypeOf(prototype2) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
const isDate$1 = kindOfTest("Date");
const isFile = kindOfTest("File");
const isBlob = kindOfTest("Blob");
const isFileList = kindOfTest("FileList");
const isStream = (val) => isObject$1(val) && isFunction(val.pipe);
const isFormData = (thing) => {
  let kind;
  return thing && (typeof FormData === "function" && thing instanceof FormData || isFunction(thing.append) && ((kind = kindOf(thing)) === "formdata" || // detect form-data instance
  kind === "object" && isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
const isURLSearchParams = kindOfTest("URLSearchParams");
const [isReadableStream, isRequest, isResponse, isHeaders] = ["ReadableStream", "Request", "Response", "Headers"].map(kindOfTest);
const trim = (str) => str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function forEach(obj, fn2, { allOwnKeys = false } = {}) {
  if (obj === null || typeof obj === "undefined") {
    return;
  }
  let i;
  let l;
  if (typeof obj !== "object") {
    obj = [obj];
  }
  if (isArray(obj)) {
    for (i = 0, l = obj.length; i < l; i++) {
      fn2.call(null, obj[i], i, obj);
    }
  } else {
    const keys4 = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
    const len = keys4.length;
    let key;
    for (i = 0; i < len; i++) {
      key = keys4[i];
      fn2.call(null, obj[key], key, obj);
    }
  }
}
function findKey(obj, key) {
  key = key.toLowerCase();
  const keys4 = Object.keys(obj);
  let i = keys4.length;
  let _key;
  while (i-- > 0) {
    _key = keys4[i];
    if (key === _key.toLowerCase()) {
      return _key;
    }
  }
  return null;
}
const _global = (() => {
  if (typeof globalThis !== "undefined") return globalThis;
  return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : global;
})();
const isContextDefined = (context) => !isUndefined(context) && context !== _global;
function merge() {
  const { caseless } = isContextDefined(this) && this || {};
  const result2 = {};
  const assignValue = (val, key) => {
    const targetKey = caseless && findKey(result2, key) || key;
    if (isPlainObject(result2[targetKey]) && isPlainObject(val)) {
      result2[targetKey] = merge(result2[targetKey], val);
    } else if (isPlainObject(val)) {
      result2[targetKey] = merge({}, val);
    } else if (isArray(val)) {
      result2[targetKey] = val.slice();
    } else {
      result2[targetKey] = val;
    }
  };
  for (let i = 0, l = arguments.length; i < l; i++) {
    arguments[i] && forEach(arguments[i], assignValue);
  }
  return result2;
}
const extend = (a, b2, thisArg, { allOwnKeys } = {}) => {
  forEach(b2, (val, key) => {
    if (thisArg && isFunction(val)) {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  }, { allOwnKeys });
  return a;
};
const stripBOM = (content) => {
  if (content.charCodeAt(0) === 65279) {
    content = content.slice(1);
  }
  return content;
};
const inherits = (constructor, superConstructor, props2, descriptors2) => {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors2);
  constructor.prototype.constructor = constructor;
  Object.defineProperty(constructor, "super", {
    value: superConstructor.prototype
  });
  props2 && Object.assign(constructor.prototype, props2);
};
const toFlatObject = (sourceObj, destObj, filter3, propFilter) => {
  let props2;
  let i;
  let prop3;
  const merged = {};
  destObj = destObj || {};
  if (sourceObj == null) return destObj;
  do {
    props2 = Object.getOwnPropertyNames(sourceObj);
    i = props2.length;
    while (i-- > 0) {
      prop3 = props2[i];
      if ((!propFilter || propFilter(prop3, sourceObj, destObj)) && !merged[prop3]) {
        destObj[prop3] = sourceObj[prop3];
        merged[prop3] = true;
      }
    }
    sourceObj = filter3 !== false && getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter3 || filter3(sourceObj, destObj)) && sourceObj !== Object.prototype);
  return destObj;
};
const endsWith = (str, searchString, position) => {
  str = String(str);
  if (position === void 0 || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  const lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
};
const toArray = (thing) => {
  if (!thing) return null;
  if (isArray(thing)) return thing;
  let i = thing.length;
  if (!isNumber(i)) return null;
  const arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
};
const isTypedArray = /* @__PURE__ */ ((TypedArray) => {
  return (thing) => {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== "undefined" && getPrototypeOf(Uint8Array));
const forEachEntry = (obj, fn2) => {
  const generator = obj && obj[Symbol.iterator];
  const iterator = generator.call(obj);
  let result2;
  while ((result2 = iterator.next()) && !result2.done) {
    const pair = result2.value;
    fn2.call(obj, pair[0], pair[1]);
  }
};
const matchAll = (regExp, str) => {
  let matches2;
  const arr = [];
  while ((matches2 = regExp.exec(str)) !== null) {
    arr.push(matches2);
  }
  return arr;
};
const isHTMLForm = kindOfTest("HTMLFormElement");
const toCamelCase = (str) => {
  return str.toLowerCase().replace(
    /[-_\s]([a-z\d])(\w*)/g,
    function replacer(m2, p1, p2) {
      return p1.toUpperCase() + p2;
    }
  );
};
const hasOwnProperty = (({ hasOwnProperty: hasOwnProperty2 }) => (obj, prop3) => hasOwnProperty2.call(obj, prop3))(Object.prototype);
const isRegExp = kindOfTest("RegExp");
const reduceDescriptors = (obj, reducer) => {
  const descriptors2 = Object.getOwnPropertyDescriptors(obj);
  const reducedDescriptors = {};
  forEach(descriptors2, (descriptor, name) => {
    let ret;
    if ((ret = reducer(descriptor, name, obj)) !== false) {
      reducedDescriptors[name] = ret || descriptor;
    }
  });
  Object.defineProperties(obj, reducedDescriptors);
};
const freezeMethods = (obj) => {
  reduceDescriptors(obj, (descriptor, name) => {
    if (isFunction(obj) && ["arguments", "caller", "callee"].indexOf(name) !== -1) {
      return false;
    }
    const value = obj[name];
    if (!isFunction(value)) return;
    descriptor.enumerable = false;
    if ("writable" in descriptor) {
      descriptor.writable = false;
      return;
    }
    if (!descriptor.set) {
      descriptor.set = () => {
        throw Error("Can not rewrite read-only method '" + name + "'");
      };
    }
  });
};
const toObjectSet = (arrayOrString, delimiter) => {
  const obj = {};
  const define2 = (arr) => {
    arr.forEach((value) => {
      obj[value] = true;
    });
  };
  isArray(arrayOrString) ? define2(arrayOrString) : define2(String(arrayOrString).split(delimiter));
  return obj;
};
const noop$1 = () => {
};
const toFiniteNumber = (value, defaultValue) => {
  return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
const ALPHA = "abcdefghijklmnopqrstuvwxyz";
const DIGIT = "0123456789";
const ALPHABET = {
  DIGIT,
  ALPHA,
  ALPHA_DIGIT: ALPHA + ALPHA.toUpperCase() + DIGIT
};
const generateString = (size2 = 16, alphabet = ALPHABET.ALPHA_DIGIT) => {
  let str = "";
  const { length } = alphabet;
  while (size2--) {
    str += alphabet[Math.random() * length | 0];
  }
  return str;
};
function isSpecCompliantForm(thing) {
  return !!(thing && isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const toJSONObject = (obj) => {
  const stack2 = new Array(10);
  const visit = (source, i) => {
    if (isObject$1(source)) {
      if (stack2.indexOf(source) >= 0) {
        return;
      }
      if (!("toJSON" in source)) {
        stack2[i] = source;
        const target = isArray(source) ? [] : {};
        forEach(source, (value, key) => {
          const reducedValue = visit(value, i + 1);
          !isUndefined(reducedValue) && (target[key] = reducedValue);
        });
        stack2[i] = void 0;
        return target;
      }
    }
    return source;
  };
  return visit(obj, 0);
};
const isAsyncFn = kindOfTest("AsyncFunction");
const isThenable = (thing) => thing && (isObject$1(thing) || isFunction(thing)) && isFunction(thing.then) && isFunction(thing.catch);
const _setImmediate = ((setImmediateSupported, postMessageSupported) => {
  if (setImmediateSupported) {
    return setImmediate;
  }
  return postMessageSupported ? ((token, callbacks) => {
    _global.addEventListener("message", ({ source, data: data2 }) => {
      if (source === _global && data2 === token) {
        callbacks.length && callbacks.shift()();
      }
    }, false);
    return (cb) => {
      callbacks.push(cb);
      _global.postMessage(token, "*");
    };
  })(`axios@${Math.random()}`, []) : (cb) => setTimeout(cb);
})(
  typeof setImmediate === "function",
  isFunction(_global.postMessage)
);
const asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind(_global) : typeof process !== "undefined" && process.nextTick || _setImmediate;
const utils$1 = {
  isArray,
  isArrayBuffer,
  isBuffer,
  isFormData,
  isArrayBufferView,
  isString,
  isNumber,
  isBoolean,
  isObject: isObject$1,
  isPlainObject,
  isReadableStream,
  isRequest,
  isResponse,
  isHeaders,
  isUndefined,
  isDate: isDate$1,
  isFile,
  isBlob,
  isRegExp,
  isFunction,
  isStream,
  isURLSearchParams,
  isTypedArray,
  isFileList,
  forEach,
  merge,
  extend,
  trim,
  stripBOM,
  inherits,
  toFlatObject,
  kindOf,
  kindOfTest,
  endsWith,
  toArray,
  forEachEntry,
  matchAll,
  isHTMLForm,
  hasOwnProperty,
  hasOwnProp: hasOwnProperty,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors,
  freezeMethods,
  toObjectSet,
  toCamelCase,
  noop: noop$1,
  toFiniteNumber,
  findKey,
  global: _global,
  isContextDefined,
  ALPHABET,
  generateString,
  isSpecCompliantForm,
  toJSONObject,
  isAsyncFn,
  isThenable,
  setImmediate: _setImmediate,
  asap
};
function AxiosError(message2, code, config, request, response) {
  Error.call(this);
  if (Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  } else {
    this.stack = new Error().stack;
  }
  this.message = message2;
  this.name = "AxiosError";
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  if (response) {
    this.response = response;
    this.status = response.status ? response.status : null;
  }
}
utils$1.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: utils$1.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const prototype$1 = AxiosError.prototype;
const descriptors = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((code) => {
  descriptors[code] = { value: code };
});
Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype$1, "isAxiosError", { value: true });
AxiosError.from = (error, code, config, request, response, customProps) => {
  const axiosError = Object.create(prototype$1);
  utils$1.toFlatObject(error, axiosError, function filter3(obj) {
    return obj !== Error.prototype;
  }, (prop3) => {
    return prop3 !== "isAxiosError";
  });
  AxiosError.call(axiosError, error.message, code, config, request, response);
  axiosError.cause = error;
  axiosError.name = error.name;
  customProps && Object.assign(axiosError, customProps);
  return axiosError;
};
const httpAdapter = null;
function isVisitable(thing) {
  return utils$1.isPlainObject(thing) || utils$1.isArray(thing);
}
function removeBrackets(key) {
  return utils$1.endsWith(key, "[]") ? key.slice(0, -2) : key;
}
function renderKey(path, key, dots) {
  if (!path) return key;
  return path.concat(key).map(function each(token, i) {
    token = removeBrackets(token);
    return !dots && i ? "[" + token + "]" : token;
  }).join(dots ? "." : "");
}
function isFlatArray(arr) {
  return utils$1.isArray(arr) && !arr.some(isVisitable);
}
const predicates = utils$1.toFlatObject(utils$1, {}, null, function filter2(prop3) {
  return /^is[A-Z]/.test(prop3);
});
function toFormData(obj, formData, options) {
  if (!utils$1.isObject(obj)) {
    throw new TypeError("target must be an object");
  }
  formData = formData || new FormData();
  options = utils$1.toFlatObject(options, {
    metaTokens: true,
    dots: false,
    indexes: false
  }, false, function defined(option2, source) {
    return !utils$1.isUndefined(source[option2]);
  });
  const metaTokens = options.metaTokens;
  const visitor = options.visitor || defaultVisitor;
  const dots = options.dots;
  const indexes = options.indexes;
  const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
  const useBlob = _Blob && utils$1.isSpecCompliantForm(formData);
  if (!utils$1.isFunction(visitor)) {
    throw new TypeError("visitor must be a function");
  }
  function convertValue(value) {
    if (value === null) return "";
    if (utils$1.isDate(value)) {
      return value.toISOString();
    }
    if (!useBlob && utils$1.isBlob(value)) {
      throw new AxiosError("Blob is not supported. Use a Buffer instead.");
    }
    if (utils$1.isArrayBuffer(value) || utils$1.isTypedArray(value)) {
      return useBlob && typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
    }
    return value;
  }
  function defaultVisitor(value, key, path) {
    let arr = value;
    if (value && !path && typeof value === "object") {
      if (utils$1.endsWith(key, "{}")) {
        key = metaTokens ? key : key.slice(0, -2);
        value = JSON.stringify(value);
      } else if (utils$1.isArray(value) && isFlatArray(value) || (utils$1.isFileList(value) || utils$1.endsWith(key, "[]")) && (arr = utils$1.toArray(value))) {
        key = removeBrackets(key);
        arr.forEach(function each(el, index2) {
          !(utils$1.isUndefined(el) || el === null) && formData.append(
            // eslint-disable-next-line no-nested-ternary
            indexes === true ? renderKey([key], index2, dots) : indexes === null ? key : key + "[]",
            convertValue(el)
          );
        });
        return false;
      }
    }
    if (isVisitable(value)) {
      return true;
    }
    formData.append(renderKey(path, key, dots), convertValue(value));
    return false;
  }
  const stack2 = [];
  const exposedHelpers = Object.assign(predicates, {
    defaultVisitor,
    convertValue,
    isVisitable
  });
  function build(value, path) {
    if (utils$1.isUndefined(value)) return;
    if (stack2.indexOf(value) !== -1) {
      throw Error("Circular reference detected in " + path.join("."));
    }
    stack2.push(value);
    utils$1.forEach(value, function each(el, key) {
      const result2 = !(utils$1.isUndefined(el) || el === null) && visitor.call(
        formData,
        el,
        utils$1.isString(key) ? key.trim() : key,
        path,
        exposedHelpers
      );
      if (result2 === true) {
        build(el, path ? path.concat(key) : [key]);
      }
    });
    stack2.pop();
  }
  if (!utils$1.isObject(obj)) {
    throw new TypeError("data must be an object");
  }
  build(obj);
  return formData;
}
function encode$1(str) {
  const charMap = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match2) {
    return charMap[match2];
  });
}
function AxiosURLSearchParams(params, options) {
  this._pairs = [];
  params && toFormData(params, this, options);
}
const prototype = AxiosURLSearchParams.prototype;
prototype.append = function append2(name, value) {
  this._pairs.push([name, value]);
};
prototype.toString = function toString3(encoder) {
  const _encode = encoder ? function(value) {
    return encoder.call(this, value, encode$1);
  } : encode$1;
  return this._pairs.map(function each(pair) {
    return _encode(pair[0]) + "=" + _encode(pair[1]);
  }, "").join("&");
};
function encode(val) {
  return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function buildURL(url, params, options) {
  if (!params) {
    return url;
  }
  const _encode = options && options.encode || encode;
  if (utils$1.isFunction(options)) {
    options = {
      serialize: options
    };
  }
  const serializeFn = options && options.serialize;
  let serializedParams;
  if (serializeFn) {
    serializedParams = serializeFn(params, options);
  } else {
    serializedParams = utils$1.isURLSearchParams(params) ? params.toString() : new AxiosURLSearchParams(params, options).toString(_encode);
  }
  if (serializedParams) {
    const hashmarkIndex = url.indexOf("#");
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }
    url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
  }
  return url;
}
class InterceptorManager {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(fulfilled, rejected, options) {
    this.handlers.push({
      fulfilled,
      rejected,
      synchronous: options ? options.synchronous : false,
      runWhen: options ? options.runWhen : null
    });
    return this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(id) {
    if (this.handlers[id]) {
      this.handlers[id] = null;
    }
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    if (this.handlers) {
      this.handlers = [];
    }
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(fn2) {
    utils$1.forEach(this.handlers, function forEachHandler(h2) {
      if (h2 !== null) {
        fn2(h2);
      }
    });
  }
}
const transitionalDefaults = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};
const URLSearchParams$1 = typeof URLSearchParams !== "undefined" ? URLSearchParams : AxiosURLSearchParams;
const FormData$1 = typeof FormData !== "undefined" ? FormData : null;
const Blob$1 = typeof Blob !== "undefined" ? Blob : null;
const platform$1 = {
  isBrowser: true,
  classes: {
    URLSearchParams: URLSearchParams$1,
    FormData: FormData$1,
    Blob: Blob$1
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const hasBrowserEnv = typeof window !== "undefined" && typeof document !== "undefined";
const _navigator = typeof navigator === "object" && navigator || void 0;
const hasStandardBrowserEnv = hasBrowserEnv && (!_navigator || ["ReactNative", "NativeScript", "NS"].indexOf(_navigator.product) < 0);
const hasStandardBrowserWebWorkerEnv = (() => {
  return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
  self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const origin = hasBrowserEnv && window.location.href || "http://localhost";
const utils = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv,
  hasStandardBrowserEnv,
  hasStandardBrowserWebWorkerEnv,
  navigator: _navigator,
  origin
}, Symbol.toStringTag, { value: "Module" }));
const platform = {
  ...utils,
  ...platform$1
};
function toURLEncodedForm(data2, options) {
  return toFormData(data2, new platform.classes.URLSearchParams(), Object.assign({
    visitor: function(value, key, path, helpers) {
      if (platform.isNode && utils$1.isBuffer(value)) {
        this.append(key, value.toString("base64"));
        return false;
      }
      return helpers.defaultVisitor.apply(this, arguments);
    }
  }, options));
}
function parsePropPath(name) {
  return utils$1.matchAll(/\w+|\[(\w*)]/g, name).map((match2) => {
    return match2[0] === "[]" ? "" : match2[1] || match2[0];
  });
}
function arrayToObject(arr) {
  const obj = {};
  const keys4 = Object.keys(arr);
  let i;
  const len = keys4.length;
  let key;
  for (i = 0; i < len; i++) {
    key = keys4[i];
    obj[key] = arr[key];
  }
  return obj;
}
function formDataToJSON(formData) {
  function buildPath(path, value, target, index2) {
    let name = path[index2++];
    if (name === "__proto__") return true;
    const isNumericKey = Number.isFinite(+name);
    const isLast = index2 >= path.length;
    name = !name && utils$1.isArray(target) ? target.length : name;
    if (isLast) {
      if (utils$1.hasOwnProp(target, name)) {
        target[name] = [target[name], value];
      } else {
        target[name] = value;
      }
      return !isNumericKey;
    }
    if (!target[name] || !utils$1.isObject(target[name])) {
      target[name] = [];
    }
    const result2 = buildPath(path, value, target[name], index2);
    if (result2 && utils$1.isArray(target[name])) {
      target[name] = arrayToObject(target[name]);
    }
    return !isNumericKey;
  }
  if (utils$1.isFormData(formData) && utils$1.isFunction(formData.entries)) {
    const obj = {};
    utils$1.forEachEntry(formData, (name, value) => {
      buildPath(parsePropPath(name), value, obj, 0);
    });
    return obj;
  }
  return null;
}
function stringifySafely(rawValue, parser, encoder) {
  if (utils$1.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils$1.trim(rawValue);
    } catch (e) {
      if (e.name !== "SyntaxError") {
        throw e;
      }
    }
  }
  return (0, JSON.stringify)(rawValue);
}
const defaults = {
  transitional: transitionalDefaults,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function transformRequest(data2, headers) {
    const contentType = headers.getContentType() || "";
    const hasJSONContentType = contentType.indexOf("application/json") > -1;
    const isObjectPayload = utils$1.isObject(data2);
    if (isObjectPayload && utils$1.isHTMLForm(data2)) {
      data2 = new FormData(data2);
    }
    const isFormData2 = utils$1.isFormData(data2);
    if (isFormData2) {
      return hasJSONContentType ? JSON.stringify(formDataToJSON(data2)) : data2;
    }
    if (utils$1.isArrayBuffer(data2) || utils$1.isBuffer(data2) || utils$1.isStream(data2) || utils$1.isFile(data2) || utils$1.isBlob(data2) || utils$1.isReadableStream(data2)) {
      return data2;
    }
    if (utils$1.isArrayBufferView(data2)) {
      return data2.buffer;
    }
    if (utils$1.isURLSearchParams(data2)) {
      headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
      return data2.toString();
    }
    let isFileList2;
    if (isObjectPayload) {
      if (contentType.indexOf("application/x-www-form-urlencoded") > -1) {
        return toURLEncodedForm(data2, this.formSerializer).toString();
      }
      if ((isFileList2 = utils$1.isFileList(data2)) || contentType.indexOf("multipart/form-data") > -1) {
        const _FormData = this.env && this.env.FormData;
        return toFormData(
          isFileList2 ? { "files[]": data2 } : data2,
          _FormData && new _FormData(),
          this.formSerializer
        );
      }
    }
    if (isObjectPayload || hasJSONContentType) {
      headers.setContentType("application/json", false);
      return stringifySafely(data2);
    }
    return data2;
  }],
  transformResponse: [function transformResponse(data2) {
    const transitional2 = this.transitional || defaults.transitional;
    const forcedJSONParsing = transitional2 && transitional2.forcedJSONParsing;
    const JSONRequested = this.responseType === "json";
    if (utils$1.isResponse(data2) || utils$1.isReadableStream(data2)) {
      return data2;
    }
    if (data2 && utils$1.isString(data2) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
      const silentJSONParsing = transitional2 && transitional2.silentJSONParsing;
      const strictJSONParsing = !silentJSONParsing && JSONRequested;
      try {
        return JSON.parse(data2);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === "SyntaxError") {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }
    return data2;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: platform.classes.FormData,
    Blob: platform.classes.Blob
  },
  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },
  headers: {
    common: {
      "Accept": "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
utils$1.forEach(["delete", "get", "head", "post", "put", "patch"], (method) => {
  defaults.headers[method] = {};
});
const ignoreDuplicateOf = utils$1.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
const parseHeaders = (rawHeaders) => {
  const parsed = {};
  let key;
  let val;
  let i;
  rawHeaders && rawHeaders.split("\n").forEach(function parser(line2) {
    i = line2.indexOf(":");
    key = line2.substring(0, i).trim().toLowerCase();
    val = line2.substring(i + 1).trim();
    if (!key || parsed[key] && ignoreDuplicateOf[key]) {
      return;
    }
    if (key === "set-cookie") {
      if (parsed[key]) {
        parsed[key].push(val);
      } else {
        parsed[key] = [val];
      }
    } else {
      parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    }
  });
  return parsed;
};
const $internals = Symbol("internals");
function normalizeHeader(header) {
  return header && String(header).trim().toLowerCase();
}
function normalizeValue(value) {
  if (value === false || value == null) {
    return value;
  }
  return utils$1.isArray(value) ? value.map(normalizeValue) : String(value);
}
function parseTokens(str) {
  const tokens = /* @__PURE__ */ Object.create(null);
  const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let match2;
  while (match2 = tokensRE.exec(str)) {
    tokens[match2[1]] = match2[2];
  }
  return tokens;
}
const isValidHeaderName = (str) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function matchHeaderValue(context, value, header, filter3, isHeaderNameFilter) {
  if (utils$1.isFunction(filter3)) {
    return filter3.call(this, value, header);
  }
  if (isHeaderNameFilter) {
    value = header;
  }
  if (!utils$1.isString(value)) return;
  if (utils$1.isString(filter3)) {
    return value.indexOf(filter3) !== -1;
  }
  if (utils$1.isRegExp(filter3)) {
    return filter3.test(value);
  }
}
function formatHeader(header) {
  return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str) => {
    return char.toUpperCase() + str;
  });
}
function buildAccessors(obj, header) {
  const accessorName = utils$1.toCamelCase(" " + header);
  ["get", "set", "has"].forEach((methodName) => {
    Object.defineProperty(obj, methodName + accessorName, {
      value: function(arg1, arg2, arg3) {
        return this[methodName].call(this, header, arg1, arg2, arg3);
      },
      configurable: true
    });
  });
}
class AxiosHeaders {
  constructor(headers) {
    headers && this.set(headers);
  }
  set(header, valueOrRewrite, rewrite) {
    const self2 = this;
    function setHeader(_value, _header, _rewrite) {
      const lHeader = normalizeHeader(_header);
      if (!lHeader) {
        throw new Error("header name must be a non-empty string");
      }
      const key = utils$1.findKey(self2, lHeader);
      if (!key || self2[key] === void 0 || _rewrite === true || _rewrite === void 0 && self2[key] !== false) {
        self2[key || _header] = normalizeValue(_value);
      }
    }
    const setHeaders = (headers, _rewrite) => utils$1.forEach(headers, (_value, _header) => setHeader(_value, _header, _rewrite));
    if (utils$1.isPlainObject(header) || header instanceof this.constructor) {
      setHeaders(header, valueOrRewrite);
    } else if (utils$1.isString(header) && (header = header.trim()) && !isValidHeaderName(header)) {
      setHeaders(parseHeaders(header), valueOrRewrite);
    } else if (utils$1.isHeaders(header)) {
      for (const [key, value] of header.entries()) {
        setHeader(value, key, rewrite);
      }
    } else {
      header != null && setHeader(valueOrRewrite, header, rewrite);
    }
    return this;
  }
  get(header, parser) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      if (key) {
        const value = this[key];
        if (!parser) {
          return value;
        }
        if (parser === true) {
          return parseTokens(value);
        }
        if (utils$1.isFunction(parser)) {
          return parser.call(this, value, key);
        }
        if (utils$1.isRegExp(parser)) {
          return parser.exec(value);
        }
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(header, matcher2) {
    header = normalizeHeader(header);
    if (header) {
      const key = utils$1.findKey(this, header);
      return !!(key && this[key] !== void 0 && (!matcher2 || matchHeaderValue(this, this[key], key, matcher2)));
    }
    return false;
  }
  delete(header, matcher2) {
    const self2 = this;
    let deleted = false;
    function deleteHeader(_header) {
      _header = normalizeHeader(_header);
      if (_header) {
        const key = utils$1.findKey(self2, _header);
        if (key && (!matcher2 || matchHeaderValue(self2, self2[key], key, matcher2))) {
          delete self2[key];
          deleted = true;
        }
      }
    }
    if (utils$1.isArray(header)) {
      header.forEach(deleteHeader);
    } else {
      deleteHeader(header);
    }
    return deleted;
  }
  clear(matcher2) {
    const keys4 = Object.keys(this);
    let i = keys4.length;
    let deleted = false;
    while (i--) {
      const key = keys4[i];
      if (!matcher2 || matchHeaderValue(this, this[key], key, matcher2, true)) {
        delete this[key];
        deleted = true;
      }
    }
    return deleted;
  }
  normalize(format2) {
    const self2 = this;
    const headers = {};
    utils$1.forEach(this, (value, header) => {
      const key = utils$1.findKey(headers, header);
      if (key) {
        self2[key] = normalizeValue(value);
        delete self2[header];
        return;
      }
      const normalized = format2 ? formatHeader(header) : String(header).trim();
      if (normalized !== header) {
        delete self2[header];
      }
      self2[normalized] = normalizeValue(value);
      headers[normalized] = true;
    });
    return this;
  }
  concat(...targets) {
    return this.constructor.concat(this, ...targets);
  }
  toJSON(asStrings) {
    const obj = /* @__PURE__ */ Object.create(null);
    utils$1.forEach(this, (value, header) => {
      value != null && value !== false && (obj[header] = asStrings && utils$1.isArray(value) ? value.join(", ") : value);
    });
    return obj;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([header, value]) => header + ": " + value).join("\n");
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(thing) {
    return thing instanceof this ? thing : new this(thing);
  }
  static concat(first, ...targets) {
    const computed2 = new this(first);
    targets.forEach((target) => computed2.set(target));
    return computed2;
  }
  static accessor(header) {
    const internals = this[$internals] = this[$internals] = {
      accessors: {}
    };
    const accessors = internals.accessors;
    const prototype2 = this.prototype;
    function defineAccessor(_header) {
      const lHeader = normalizeHeader(_header);
      if (!accessors[lHeader]) {
        buildAccessors(prototype2, _header);
        accessors[lHeader] = true;
      }
    }
    utils$1.isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
    return this;
  }
}
AxiosHeaders.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
utils$1.reduceDescriptors(AxiosHeaders.prototype, ({ value }, key) => {
  let mapped = key[0].toUpperCase() + key.slice(1);
  return {
    get: () => value,
    set(headerValue) {
      this[mapped] = headerValue;
    }
  };
});
utils$1.freezeMethods(AxiosHeaders);
function transformData(fns, response) {
  const config = this || defaults;
  const context = response || config;
  const headers = AxiosHeaders.from(context.headers);
  let data2 = context.data;
  utils$1.forEach(fns, function transform(fn2) {
    data2 = fn2.call(config, data2, headers.normalize(), response ? response.status : void 0);
  });
  headers.normalize();
  return data2;
}
function isCancel(value) {
  return !!(value && value.__CANCEL__);
}
function CanceledError(message2, config, request) {
  AxiosError.call(this, message2 == null ? "canceled" : message2, AxiosError.ERR_CANCELED, config, request);
  this.name = "CanceledError";
}
utils$1.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});
function settle(resolve, reject3, response) {
  const validateStatus2 = response.config.validateStatus;
  if (!response.status || !validateStatus2 || validateStatus2(response.status)) {
    resolve(response);
  } else {
    reject3(new AxiosError(
      "Request failed with status code " + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
}
function parseProtocol(url) {
  const match2 = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match2 && match2[1] || "";
}
function speedometer(samplesCount, min2) {
  samplesCount = samplesCount || 10;
  const bytes = new Array(samplesCount);
  const timestamps = new Array(samplesCount);
  let head = 0;
  let tail2 = 0;
  let firstSampleTS;
  min2 = min2 !== void 0 ? min2 : 1e3;
  return function push(chunkLength) {
    const now = Date.now();
    const startedAt = timestamps[tail2];
    if (!firstSampleTS) {
      firstSampleTS = now;
    }
    bytes[head] = chunkLength;
    timestamps[head] = now;
    let i = tail2;
    let bytesCount = 0;
    while (i !== head) {
      bytesCount += bytes[i++];
      i = i % samplesCount;
    }
    head = (head + 1) % samplesCount;
    if (head === tail2) {
      tail2 = (tail2 + 1) % samplesCount;
    }
    if (now - firstSampleTS < min2) {
      return;
    }
    const passed = startedAt && now - startedAt;
    return passed ? Math.round(bytesCount * 1e3 / passed) : void 0;
  };
}
function throttle(fn2, freq) {
  let timestamp = 0;
  let threshold = 1e3 / freq;
  let lastArgs;
  let timer;
  const invoke = (args, now = Date.now()) => {
    timestamp = now;
    lastArgs = null;
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    fn2.apply(null, args);
  };
  const throttled = (...args) => {
    const now = Date.now();
    const passed = now - timestamp;
    if (passed >= threshold) {
      invoke(args, now);
    } else {
      lastArgs = args;
      if (!timer) {
        timer = setTimeout(() => {
          timer = null;
          invoke(lastArgs);
        }, threshold - passed);
      }
    }
  };
  const flush = () => lastArgs && invoke(lastArgs);
  return [throttled, flush];
}
const progressEventReducer = (listener, isDownloadStream, freq = 3) => {
  let bytesNotified = 0;
  const _speedometer = speedometer(50, 250);
  return throttle((e) => {
    const loaded = e.loaded;
    const total = e.lengthComputable ? e.total : void 0;
    const progressBytes = loaded - bytesNotified;
    const rate = _speedometer(progressBytes);
    const inRange = loaded <= total;
    bytesNotified = loaded;
    const data2 = {
      loaded,
      total,
      progress: total ? loaded / total : void 0,
      bytes: progressBytes,
      rate: rate ? rate : void 0,
      estimated: rate && total && inRange ? (total - loaded) / rate : void 0,
      event: e,
      lengthComputable: total != null,
      [isDownloadStream ? "download" : "upload"]: true
    };
    listener(data2);
  }, freq);
};
const progressEventDecorator = (total, throttled) => {
  const lengthComputable = total != null;
  return [(loaded) => throttled[0]({
    lengthComputable,
    total,
    loaded
  }), throttled[1]];
};
const asyncDecorator = (fn2) => (...args) => utils$1.asap(() => fn2(...args));
const isURLSameOrigin = platform.hasStandardBrowserEnv ? /* @__PURE__ */ ((origin2, isMSIE) => (url) => {
  url = new URL(url, platform.origin);
  return origin2.protocol === url.protocol && origin2.host === url.host && (isMSIE || origin2.port === url.port);
})(
  new URL(platform.origin),
  platform.navigator && /(msie|trident)/i.test(platform.navigator.userAgent)
) : () => true;
const cookies = platform.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(name, value, expires, path, domain2, secure) {
      const cookie = [name + "=" + encodeURIComponent(value)];
      utils$1.isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
      utils$1.isString(path) && cookie.push("path=" + path);
      utils$1.isString(domain2) && cookie.push("domain=" + domain2);
      secure === true && cookie.push("secure");
      document.cookie = cookie.join("; ");
    },
    read(name) {
      const match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
      return match2 ? decodeURIComponent(match2[3]) : null;
    },
    remove(name) {
      this.write(name, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function isAbsoluteURL(url) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}
function combineURLs(baseURL, relativeURL) {
  return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}
function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
}
const headersToObject = (thing) => thing instanceof AxiosHeaders ? { ...thing } : thing;
function mergeConfig(config1, config2) {
  config2 = config2 || {};
  const config = {};
  function getMergedValue(target, source, prop3, caseless) {
    if (utils$1.isPlainObject(target) && utils$1.isPlainObject(source)) {
      return utils$1.merge.call({ caseless }, target, source);
    } else if (utils$1.isPlainObject(source)) {
      return utils$1.merge({}, source);
    } else if (utils$1.isArray(source)) {
      return source.slice();
    }
    return source;
  }
  function mergeDeepProperties(a, b2, prop3, caseless) {
    if (!utils$1.isUndefined(b2)) {
      return getMergedValue(a, b2, prop3, caseless);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a, prop3, caseless);
    }
  }
  function valueFromConfig2(a, b2) {
    if (!utils$1.isUndefined(b2)) {
      return getMergedValue(void 0, b2);
    }
  }
  function defaultToConfig2(a, b2) {
    if (!utils$1.isUndefined(b2)) {
      return getMergedValue(void 0, b2);
    } else if (!utils$1.isUndefined(a)) {
      return getMergedValue(void 0, a);
    }
  }
  function mergeDirectKeys(a, b2, prop3) {
    if (prop3 in config2) {
      return getMergedValue(a, b2);
    } else if (prop3 in config1) {
      return getMergedValue(void 0, a);
    }
  }
  const mergeMap = {
    url: valueFromConfig2,
    method: valueFromConfig2,
    data: valueFromConfig2,
    baseURL: defaultToConfig2,
    transformRequest: defaultToConfig2,
    transformResponse: defaultToConfig2,
    paramsSerializer: defaultToConfig2,
    timeout: defaultToConfig2,
    timeoutMessage: defaultToConfig2,
    withCredentials: defaultToConfig2,
    withXSRFToken: defaultToConfig2,
    adapter: defaultToConfig2,
    responseType: defaultToConfig2,
    xsrfCookieName: defaultToConfig2,
    xsrfHeaderName: defaultToConfig2,
    onUploadProgress: defaultToConfig2,
    onDownloadProgress: defaultToConfig2,
    decompress: defaultToConfig2,
    maxContentLength: defaultToConfig2,
    maxBodyLength: defaultToConfig2,
    beforeRedirect: defaultToConfig2,
    transport: defaultToConfig2,
    httpAgent: defaultToConfig2,
    httpsAgent: defaultToConfig2,
    cancelToken: defaultToConfig2,
    socketPath: defaultToConfig2,
    responseEncoding: defaultToConfig2,
    validateStatus: mergeDirectKeys,
    headers: (a, b2, prop3) => mergeDeepProperties(headersToObject(a), headersToObject(b2), prop3, true)
  };
  utils$1.forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop3) {
    const merge2 = mergeMap[prop3] || mergeDeepProperties;
    const configValue = merge2(config1[prop3], config2[prop3], prop3);
    utils$1.isUndefined(configValue) && merge2 !== mergeDirectKeys || (config[prop3] = configValue);
  });
  return config;
}
const resolveConfig = (config) => {
  const newConfig = mergeConfig({}, config);
  let { data: data2, withXSRFToken, xsrfHeaderName, xsrfCookieName, headers, auth } = newConfig;
  newConfig.headers = headers = AxiosHeaders.from(headers);
  newConfig.url = buildURL(buildFullPath(newConfig.baseURL, newConfig.url), config.params, config.paramsSerializer);
  if (auth) {
    headers.set(
      "Authorization",
      "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : ""))
    );
  }
  let contentType;
  if (utils$1.isFormData(data2)) {
    if (platform.hasStandardBrowserEnv || platform.hasStandardBrowserWebWorkerEnv) {
      headers.setContentType(void 0);
    } else if ((contentType = headers.getContentType()) !== false) {
      const [type3, ...tokens] = contentType ? contentType.split(";").map((token) => token.trim()).filter(Boolean) : [];
      headers.setContentType([type3 || "multipart/form-data", ...tokens].join("; "));
    }
  }
  if (platform.hasStandardBrowserEnv) {
    withXSRFToken && utils$1.isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
    if (withXSRFToken || withXSRFToken !== false && isURLSameOrigin(newConfig.url)) {
      const xsrfValue = xsrfHeaderName && xsrfCookieName && cookies.read(xsrfCookieName);
      if (xsrfValue) {
        headers.set(xsrfHeaderName, xsrfValue);
      }
    }
  }
  return newConfig;
};
const isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
const xhrAdapter = isXHRAdapterSupported && function(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject3) {
    const _config = resolveConfig(config);
    let requestData = _config.data;
    const requestHeaders = AxiosHeaders.from(_config.headers).normalize();
    let { responseType, onUploadProgress, onDownloadProgress } = _config;
    let onCanceled;
    let uploadThrottled, downloadThrottled;
    let flushUpload, flushDownload;
    function done() {
      flushUpload && flushUpload();
      flushDownload && flushDownload();
      _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
      _config.signal && _config.signal.removeEventListener("abort", onCanceled);
    }
    let request = new XMLHttpRequest();
    request.open(_config.method.toUpperCase(), _config.url, true);
    request.timeout = _config.timeout;
    function onloadend() {
      if (!request) {
        return;
      }
      const responseHeaders = AxiosHeaders.from(
        "getAllResponseHeaders" in request && request.getAllResponseHeaders()
      );
      const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
      const response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config,
        request
      };
      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject3(err);
        done();
      }, response);
      request = null;
    }
    if ("onloadend" in request) {
      request.onloadend = onloadend;
    } else {
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
          return;
        }
        setTimeout(onloadend);
      };
    }
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }
      reject3(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config, request));
      request = null;
    };
    request.onerror = function handleError() {
      reject3(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request));
      request = null;
    };
    request.ontimeout = function handleTimeout() {
      let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
      const transitional2 = _config.transitional || transitionalDefaults;
      if (_config.timeoutErrorMessage) {
        timeoutErrorMessage = _config.timeoutErrorMessage;
      }
      reject3(new AxiosError(
        timeoutErrorMessage,
        transitional2.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request
      ));
      request = null;
    };
    requestData === void 0 && requestHeaders.setContentType(null);
    if ("setRequestHeader" in request) {
      utils$1.forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
        request.setRequestHeader(key, val);
      });
    }
    if (!utils$1.isUndefined(_config.withCredentials)) {
      request.withCredentials = !!_config.withCredentials;
    }
    if (responseType && responseType !== "json") {
      request.responseType = _config.responseType;
    }
    if (onDownloadProgress) {
      [downloadThrottled, flushDownload] = progressEventReducer(onDownloadProgress, true);
      request.addEventListener("progress", downloadThrottled);
    }
    if (onUploadProgress && request.upload) {
      [uploadThrottled, flushUpload] = progressEventReducer(onUploadProgress);
      request.upload.addEventListener("progress", uploadThrottled);
      request.upload.addEventListener("loadend", flushUpload);
    }
    if (_config.cancelToken || _config.signal) {
      onCanceled = (cancel) => {
        if (!request) {
          return;
        }
        reject3(!cancel || cancel.type ? new CanceledError(null, config, request) : cancel);
        request.abort();
        request = null;
      };
      _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
      if (_config.signal) {
        _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
      }
    }
    const protocol = parseProtocol(_config.url);
    if (protocol && platform.protocols.indexOf(protocol) === -1) {
      reject3(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config));
      return;
    }
    request.send(requestData || null);
  });
};
const composeSignals = (signals, timeout) => {
  const { length } = signals = signals ? signals.filter(Boolean) : [];
  if (timeout || length) {
    let controller = new AbortController();
    let aborted;
    const onabort = function(reason) {
      if (!aborted) {
        aborted = true;
        unsubscribe();
        const err = reason instanceof Error ? reason : this.reason;
        controller.abort(err instanceof AxiosError ? err : new CanceledError(err instanceof Error ? err.message : err));
      }
    };
    let timer = timeout && setTimeout(() => {
      timer = null;
      onabort(new AxiosError(`timeout ${timeout} of ms exceeded`, AxiosError.ETIMEDOUT));
    }, timeout);
    const unsubscribe = () => {
      if (signals) {
        timer && clearTimeout(timer);
        timer = null;
        signals.forEach((signal2) => {
          signal2.unsubscribe ? signal2.unsubscribe(onabort) : signal2.removeEventListener("abort", onabort);
        });
        signals = null;
      }
    };
    signals.forEach((signal2) => signal2.addEventListener("abort", onabort));
    const { signal } = controller;
    signal.unsubscribe = () => utils$1.asap(unsubscribe);
    return signal;
  }
};
const streamChunk = function* (chunk, chunkSize) {
  let len = chunk.byteLength;
  if (len < chunkSize) {
    yield chunk;
    return;
  }
  let pos = 0;
  let end;
  while (pos < len) {
    end = pos + chunkSize;
    yield chunk.slice(pos, end);
    pos = end;
  }
};
const readBytes = async function* (iterable, chunkSize) {
  for await (const chunk of readStream(iterable)) {
    yield* streamChunk(chunk, chunkSize);
  }
};
const readStream = async function* (stream) {
  if (stream[Symbol.asyncIterator]) {
    yield* stream;
    return;
  }
  const reader = stream.getReader();
  try {
    for (; ; ) {
      const { done, value } = await reader.read();
      if (done) {
        break;
      }
      yield value;
    }
  } finally {
    await reader.cancel();
  }
};
const trackStream = (stream, chunkSize, onProgress, onFinish) => {
  const iterator = readBytes(stream, chunkSize);
  let bytes = 0;
  let done;
  let _onFinish = (e) => {
    if (!done) {
      done = true;
      onFinish && onFinish(e);
    }
  };
  return new ReadableStream({
    async pull(controller) {
      try {
        const { done: done2, value } = await iterator.next();
        if (done2) {
          _onFinish();
          controller.close();
          return;
        }
        let len = value.byteLength;
        if (onProgress) {
          let loadedBytes = bytes += len;
          onProgress(loadedBytes);
        }
        controller.enqueue(new Uint8Array(value));
      } catch (err) {
        _onFinish(err);
        throw err;
      }
    },
    cancel(reason) {
      _onFinish(reason);
      return iterator.return();
    }
  }, {
    highWaterMark: 2
  });
};
const isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const isReadableStreamSupported = isFetchSupported && typeof ReadableStream === "function";
const encodeText = isFetchSupported && (typeof TextEncoder === "function" ? /* @__PURE__ */ ((encoder) => (str) => encoder.encode(str))(new TextEncoder()) : async (str) => new Uint8Array(await new Response(str).arrayBuffer()));
const test = (fn2, ...args) => {
  try {
    return !!fn2(...args);
  } catch (e) {
    return false;
  }
};
const supportsRequestStream = isReadableStreamSupported && test(() => {
  let duplexAccessed = false;
  const hasContentType = new Request(platform.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      duplexAccessed = true;
      return "half";
    }
  }).headers.has("Content-Type");
  return duplexAccessed && !hasContentType;
});
const DEFAULT_CHUNK_SIZE = 64 * 1024;
const supportsResponseStream = isReadableStreamSupported && test(() => utils$1.isReadableStream(new Response("").body));
const resolvers = {
  stream: supportsResponseStream && ((res) => res.body)
};
isFetchSupported && ((res) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((type3) => {
    !resolvers[type3] && (resolvers[type3] = utils$1.isFunction(res[type3]) ? (res2) => res2[type3]() : (_2, config) => {
      throw new AxiosError(`Response type '${type3}' is not supported`, AxiosError.ERR_NOT_SUPPORT, config);
    });
  });
})(new Response());
const getBodyLength = async (body) => {
  if (body == null) {
    return 0;
  }
  if (utils$1.isBlob(body)) {
    return body.size;
  }
  if (utils$1.isSpecCompliantForm(body)) {
    const _request = new Request(platform.origin, {
      method: "POST",
      body
    });
    return (await _request.arrayBuffer()).byteLength;
  }
  if (utils$1.isArrayBufferView(body) || utils$1.isArrayBuffer(body)) {
    return body.byteLength;
  }
  if (utils$1.isURLSearchParams(body)) {
    body = body + "";
  }
  if (utils$1.isString(body)) {
    return (await encodeText(body)).byteLength;
  }
};
const resolveBodyLength = async (headers, body) => {
  const length = utils$1.toFiniteNumber(headers.getContentLength());
  return length == null ? getBodyLength(body) : length;
};
const fetchAdapter = isFetchSupported && (async (config) => {
  let {
    url,
    method,
    data: data2,
    signal,
    cancelToken,
    timeout,
    onDownloadProgress,
    onUploadProgress,
    responseType,
    headers,
    withCredentials = "same-origin",
    fetchOptions
  } = resolveConfig(config);
  responseType = responseType ? (responseType + "").toLowerCase() : "text";
  let composedSignal = composeSignals([signal, cancelToken && cancelToken.toAbortSignal()], timeout);
  let request;
  const unsubscribe = composedSignal && composedSignal.unsubscribe && (() => {
    composedSignal.unsubscribe();
  });
  let requestContentLength;
  try {
    if (onUploadProgress && supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await resolveBodyLength(headers, data2)) !== 0) {
      let _request = new Request(url, {
        method: "POST",
        body: data2,
        duplex: "half"
      });
      let contentTypeHeader;
      if (utils$1.isFormData(data2) && (contentTypeHeader = _request.headers.get("content-type"))) {
        headers.setContentType(contentTypeHeader);
      }
      if (_request.body) {
        const [onProgress, flush] = progressEventDecorator(
          requestContentLength,
          progressEventReducer(asyncDecorator(onUploadProgress))
        );
        data2 = trackStream(_request.body, DEFAULT_CHUNK_SIZE, onProgress, flush);
      }
    }
    if (!utils$1.isString(withCredentials)) {
      withCredentials = withCredentials ? "include" : "omit";
    }
    const isCredentialsSupported = "credentials" in Request.prototype;
    request = new Request(url, {
      ...fetchOptions,
      signal: composedSignal,
      method: method.toUpperCase(),
      headers: headers.normalize().toJSON(),
      body: data2,
      duplex: "half",
      credentials: isCredentialsSupported ? withCredentials : void 0
    });
    let response = await fetch(request);
    const isStreamResponse = supportsResponseStream && (responseType === "stream" || responseType === "response");
    if (supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
      const options = {};
      ["status", "statusText", "headers"].forEach((prop3) => {
        options[prop3] = response[prop3];
      });
      const responseContentLength = utils$1.toFiniteNumber(response.headers.get("content-length"));
      const [onProgress, flush] = onDownloadProgress && progressEventDecorator(
        responseContentLength,
        progressEventReducer(asyncDecorator(onDownloadProgress), true)
      ) || [];
      response = new Response(
        trackStream(response.body, DEFAULT_CHUNK_SIZE, onProgress, () => {
          flush && flush();
          unsubscribe && unsubscribe();
        }),
        options
      );
    }
    responseType = responseType || "text";
    let responseData = await resolvers[utils$1.findKey(resolvers, responseType) || "text"](response, config);
    !isStreamResponse && unsubscribe && unsubscribe();
    return await new Promise((resolve, reject3) => {
      settle(resolve, reject3, {
        data: responseData,
        headers: AxiosHeaders.from(response.headers),
        status: response.status,
        statusText: response.statusText,
        config,
        request
      });
    });
  } catch (err) {
    unsubscribe && unsubscribe();
    if (err && err.name === "TypeError" && /fetch/i.test(err.message)) {
      throw Object.assign(
        new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request),
        {
          cause: err.cause || err
        }
      );
    }
    throw AxiosError.from(err, err && err.code, config, request);
  }
});
const knownAdapters = {
  http: httpAdapter,
  xhr: xhrAdapter,
  fetch: fetchAdapter
};
utils$1.forEach(knownAdapters, (fn2, value) => {
  if (fn2) {
    try {
      Object.defineProperty(fn2, "name", { value });
    } catch (e) {
    }
    Object.defineProperty(fn2, "adapterName", { value });
  }
});
const renderReason = (reason) => `- ${reason}`;
const isResolvedHandle = (adapter) => utils$1.isFunction(adapter) || adapter === null || adapter === false;
const adapters = {
  getAdapter: (adapters2) => {
    adapters2 = utils$1.isArray(adapters2) ? adapters2 : [adapters2];
    const { length } = adapters2;
    let nameOrAdapter;
    let adapter;
    const rejectedReasons = {};
    for (let i = 0; i < length; i++) {
      nameOrAdapter = adapters2[i];
      let id;
      adapter = nameOrAdapter;
      if (!isResolvedHandle(nameOrAdapter)) {
        adapter = knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
        if (adapter === void 0) {
          throw new AxiosError(`Unknown adapter '${id}'`);
        }
      }
      if (adapter) {
        break;
      }
      rejectedReasons[id || "#" + i] = adapter;
    }
    if (!adapter) {
      const reasons = Object.entries(rejectedReasons).map(
        ([id, state2]) => `adapter ${id} ` + (state2 === false ? "is not supported by the environment" : "is not available in the build")
      );
      let s = length ? reasons.length > 1 ? "since :\n" + reasons.map(renderReason).join("\n") : " " + renderReason(reasons[0]) : "as no adapter specified";
      throw new AxiosError(
        `There is no suitable adapter to dispatch the request ` + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return adapter;
  },
  adapters: knownAdapters
};
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
  if (config.signal && config.signal.aborted) {
    throw new CanceledError(null, config);
  }
}
function dispatchRequest(config) {
  throwIfCancellationRequested(config);
  config.headers = AxiosHeaders.from(config.headers);
  config.data = transformData.call(
    config,
    config.transformRequest
  );
  if (["post", "put", "patch"].indexOf(config.method) !== -1) {
    config.headers.setContentType("application/x-www-form-urlencoded", false);
  }
  const adapter = adapters.getAdapter(config.adapter || defaults.adapter);
  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);
    response.data = transformData.call(
      config,
      config.transformResponse,
      response
    );
    response.headers = AxiosHeaders.from(response.headers);
    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          config.transformResponse,
          reason.response
        );
        reason.response.headers = AxiosHeaders.from(reason.response.headers);
      }
    }
    return Promise.reject(reason);
  });
}
const VERSION = "1.7.9";
const validators$1 = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((type3, i) => {
  validators$1[type3] = function validator2(thing) {
    return typeof thing === type3 || "a" + (i < 1 ? "n " : " ") + type3;
  };
});
const deprecatedWarnings = {};
validators$1.transitional = function transitional(validator2, version2, message2) {
  function formatMessage(opt, desc) {
    return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message2 ? ". " + message2 : "");
  }
  return (value, opt, opts) => {
    if (validator2 === false) {
      throw new AxiosError(
        formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
        AxiosError.ERR_DEPRECATED
      );
    }
    if (version2 && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      console.warn(
        formatMessage(
          opt,
          " has been deprecated since v" + version2 + " and will be removed in the near future"
        )
      );
    }
    return validator2 ? validator2(value, opt, opts) : true;
  };
};
validators$1.spelling = function spelling(correctSpelling) {
  return (value, opt) => {
    console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
    return true;
  };
};
function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== "object") {
    throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
  }
  const keys4 = Object.keys(options);
  let i = keys4.length;
  while (i-- > 0) {
    const opt = keys4[i];
    const validator2 = schema[opt];
    if (validator2) {
      const value = options[opt];
      const result2 = value === void 0 || validator2(value, opt, options);
      if (result2 !== true) {
        throw new AxiosError("option " + opt + " must be " + result2, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}
const validator = {
  assertOptions,
  validators: validators$1
};
const validators = validator.validators;
class Axios {
  constructor(instanceConfig) {
    this.defaults = instanceConfig;
    this.interceptors = {
      request: new InterceptorManager(),
      response: new InterceptorManager()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(configOrUrl, config) {
    try {
      return await this._request(configOrUrl, config);
    } catch (err) {
      if (err instanceof Error) {
        let dummy = {};
        Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
        const stack2 = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
        try {
          if (!err.stack) {
            err.stack = stack2;
          } else if (stack2 && !String(err.stack).endsWith(stack2.replace(/^.+\n.+\n/, ""))) {
            err.stack += "\n" + stack2;
          }
        } catch (e) {
        }
      }
      throw err;
    }
  }
  _request(configOrUrl, config) {
    if (typeof configOrUrl === "string") {
      config = config || {};
      config.url = configOrUrl;
    } else {
      config = configOrUrl || {};
    }
    config = mergeConfig(this.defaults, config);
    const { transitional: transitional2, paramsSerializer, headers } = config;
    if (transitional2 !== void 0) {
      validator.assertOptions(transitional2, {
        silentJSONParsing: validators.transitional(validators.boolean),
        forcedJSONParsing: validators.transitional(validators.boolean),
        clarifyTimeoutError: validators.transitional(validators.boolean)
      }, false);
    }
    if (paramsSerializer != null) {
      if (utils$1.isFunction(paramsSerializer)) {
        config.paramsSerializer = {
          serialize: paramsSerializer
        };
      } else {
        validator.assertOptions(paramsSerializer, {
          encode: validators.function,
          serialize: validators.function
        }, true);
      }
    }
    validator.assertOptions(config, {
      baseUrl: validators.spelling("baseURL"),
      withXsrfToken: validators.spelling("withXSRFToken")
    }, true);
    config.method = (config.method || this.defaults.method || "get").toLowerCase();
    let contextHeaders = headers && utils$1.merge(
      headers.common,
      headers[config.method]
    );
    headers && utils$1.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (method) => {
        delete headers[method];
      }
    );
    config.headers = AxiosHeaders.concat(contextHeaders, headers);
    const requestInterceptorChain = [];
    let synchronousRequestInterceptors = true;
    this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
      if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
        return;
      }
      synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
      requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
    });
    const responseInterceptorChain = [];
    this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
      responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
    });
    let promise;
    let i = 0;
    let len;
    if (!synchronousRequestInterceptors) {
      const chain = [dispatchRequest.bind(this), void 0];
      chain.unshift.apply(chain, requestInterceptorChain);
      chain.push.apply(chain, responseInterceptorChain);
      len = chain.length;
      promise = Promise.resolve(config);
      while (i < len) {
        promise = promise.then(chain[i++], chain[i++]);
      }
      return promise;
    }
    len = requestInterceptorChain.length;
    let newConfig = config;
    i = 0;
    while (i < len) {
      const onFulfilled = requestInterceptorChain[i++];
      const onRejected = requestInterceptorChain[i++];
      try {
        newConfig = onFulfilled(newConfig);
      } catch (error) {
        onRejected.call(this, error);
        break;
      }
    }
    try {
      promise = dispatchRequest.call(this, newConfig);
    } catch (error) {
      return Promise.reject(error);
    }
    i = 0;
    len = responseInterceptorChain.length;
    while (i < len) {
      promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
    }
    return promise;
  }
  getUri(config) {
    config = mergeConfig(this.defaults, config);
    const fullPath = buildFullPath(config.baseURL, config.url);
    return buildURL(fullPath, config.params, config.paramsSerializer);
  }
}
utils$1.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method) {
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method,
      url,
      data: (config || {}).data
    }));
  };
});
utils$1.forEach(["post", "put", "patch"], function forEachMethodWithData(method) {
  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data2, config) {
      return this.request(mergeConfig(config || {}, {
        method,
        headers: isForm ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url,
        data: data2
      }));
    };
  }
  Axios.prototype[method] = generateHTTPMethod();
  Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
class CancelToken {
  constructor(executor) {
    if (typeof executor !== "function") {
      throw new TypeError("executor must be a function.");
    }
    let resolvePromise;
    this.promise = new Promise(function promiseExecutor(resolve) {
      resolvePromise = resolve;
    });
    const token = this;
    this.promise.then((cancel) => {
      if (!token._listeners) return;
      let i = token._listeners.length;
      while (i-- > 0) {
        token._listeners[i](cancel);
      }
      token._listeners = null;
    });
    this.promise.then = (onfulfilled) => {
      let _resolve;
      const promise = new Promise((resolve) => {
        token.subscribe(resolve);
        _resolve = resolve;
      }).then(onfulfilled);
      promise.cancel = function reject3() {
        token.unsubscribe(_resolve);
      };
      return promise;
    };
    executor(function cancel(message2, config, request) {
      if (token.reason) {
        return;
      }
      token.reason = new CanceledError(message2, config, request);
      resolvePromise(token.reason);
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason) {
      throw this.reason;
    }
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(listener) {
    if (this.reason) {
      listener(this.reason);
      return;
    }
    if (this._listeners) {
      this._listeners.push(listener);
    } else {
      this._listeners = [listener];
    }
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(listener) {
    if (!this._listeners) {
      return;
    }
    const index2 = this._listeners.indexOf(listener);
    if (index2 !== -1) {
      this._listeners.splice(index2, 1);
    }
  }
  toAbortSignal() {
    const controller = new AbortController();
    const abort = (err) => {
      controller.abort(err);
    };
    this.subscribe(abort);
    controller.signal.unsubscribe = () => this.unsubscribe(abort);
    return controller.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let cancel;
    const token = new CancelToken(function executor(c2) {
      cancel = c2;
    });
    return {
      token,
      cancel
    };
  }
}
function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
}
function isAxiosError(payload) {
  return utils$1.isObject(payload) && payload.isAxiosError === true;
}
const HttpStatusCode = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(HttpStatusCode).forEach(([key, value]) => {
  HttpStatusCode[value] = key;
});
function createInstance(defaultConfig2) {
  const context = new Axios(defaultConfig2);
  const instance = bind(Axios.prototype.request, context);
  utils$1.extend(instance, Axios.prototype, context, { allOwnKeys: true });
  utils$1.extend(instance, context, null, { allOwnKeys: true });
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig2, instanceConfig));
  };
  return instance;
}
const axios$1 = createInstance(defaults);
axios$1.Axios = Axios;
axios$1.CanceledError = CanceledError;
axios$1.CancelToken = CancelToken;
axios$1.isCancel = isCancel;
axios$1.VERSION = VERSION;
axios$1.toFormData = toFormData;
axios$1.AxiosError = AxiosError;
axios$1.Cancel = axios$1.CanceledError;
axios$1.all = function all(promises) {
  return Promise.all(promises);
};
axios$1.spread = spread;
axios$1.isAxiosError = isAxiosError;
axios$1.mergeConfig = mergeConfig;
axios$1.AxiosHeaders = AxiosHeaders;
axios$1.formToJSON = (thing) => formDataToJSON(utils$1.isHTMLForm(thing) ? new FormData(thing) : thing);
axios$1.getAdapter = adapters.getAdapter;
axios$1.HttpStatusCode = HttpStatusCode;
axios$1.default = axios$1;
const metadata = { "version": 4, "country_calling_codes": { "1": ["US", "AG", "AI", "AS", "BB", "BM", "BS", "CA", "DM", "DO", "GD", "GU", "JM", "KN", "KY", "LC", "MP", "MS", "PR", "SX", "TC", "TT", "VC", "VG", "VI"], "7": ["RU", "KZ"], "20": ["EG"], "27": ["ZA"], "30": ["GR"], "31": ["NL"], "32": ["BE"], "33": ["FR"], "34": ["ES"], "36": ["HU"], "39": ["IT", "VA"], "40": ["RO"], "41": ["CH"], "43": ["AT"], "44": ["GB", "GG", "IM", "JE"], "45": ["DK"], "46": ["SE"], "47": ["NO", "SJ"], "48": ["PL"], "49": ["DE"], "51": ["PE"], "52": ["MX"], "53": ["CU"], "54": ["AR"], "55": ["BR"], "56": ["CL"], "57": ["CO"], "58": ["VE"], "60": ["MY"], "61": ["AU", "CC", "CX"], "62": ["ID"], "63": ["PH"], "64": ["NZ"], "65": ["SG"], "66": ["TH"], "81": ["JP"], "82": ["KR"], "84": ["VN"], "86": ["CN"], "90": ["TR"], "91": ["IN"], "92": ["PK"], "93": ["AF"], "94": ["LK"], "95": ["MM"], "98": ["IR"], "211": ["SS"], "212": ["MA", "EH"], "213": ["DZ"], "216": ["TN"], "218": ["LY"], "220": ["GM"], "221": ["SN"], "222": ["MR"], "223": ["ML"], "224": ["GN"], "225": ["CI"], "226": ["BF"], "227": ["NE"], "228": ["TG"], "229": ["BJ"], "230": ["MU"], "231": ["LR"], "232": ["SL"], "233": ["GH"], "234": ["NG"], "235": ["TD"], "236": ["CF"], "237": ["CM"], "238": ["CV"], "239": ["ST"], "240": ["GQ"], "241": ["GA"], "242": ["CG"], "243": ["CD"], "244": ["AO"], "245": ["GW"], "246": ["IO"], "247": ["AC"], "248": ["SC"], "249": ["SD"], "250": ["RW"], "251": ["ET"], "252": ["SO"], "253": ["DJ"], "254": ["KE"], "255": ["TZ"], "256": ["UG"], "257": ["BI"], "258": ["MZ"], "260": ["ZM"], "261": ["MG"], "262": ["RE", "YT"], "263": ["ZW"], "264": ["NA"], "265": ["MW"], "266": ["LS"], "267": ["BW"], "268": ["SZ"], "269": ["KM"], "290": ["SH", "TA"], "291": ["ER"], "297": ["AW"], "298": ["FO"], "299": ["GL"], "350": ["GI"], "351": ["PT"], "352": ["LU"], "353": ["IE"], "354": ["IS"], "355": ["AL"], "356": ["MT"], "357": ["CY"], "358": ["FI", "AX"], "359": ["BG"], "370": ["LT"], "371": ["LV"], "372": ["EE"], "373": ["MD"], "374": ["AM"], "375": ["BY"], "376": ["AD"], "377": ["MC"], "378": ["SM"], "380": ["UA"], "381": ["RS"], "382": ["ME"], "383": ["XK"], "385": ["HR"], "386": ["SI"], "387": ["BA"], "389": ["MK"], "420": ["CZ"], "421": ["SK"], "423": ["LI"], "500": ["FK"], "501": ["BZ"], "502": ["GT"], "503": ["SV"], "504": ["HN"], "505": ["NI"], "506": ["CR"], "507": ["PA"], "508": ["PM"], "509": ["HT"], "590": ["GP", "BL", "MF"], "591": ["BO"], "592": ["GY"], "593": ["EC"], "594": ["GF"], "595": ["PY"], "596": ["MQ"], "597": ["SR"], "598": ["UY"], "599": ["CW", "BQ"], "670": ["TL"], "672": ["NF"], "673": ["BN"], "674": ["NR"], "675": ["PG"], "676": ["TO"], "677": ["SB"], "678": ["VU"], "679": ["FJ"], "680": ["PW"], "681": ["WF"], "682": ["CK"], "683": ["NU"], "685": ["WS"], "686": ["KI"], "687": ["NC"], "688": ["TV"], "689": ["PF"], "690": ["TK"], "691": ["FM"], "692": ["MH"], "850": ["KP"], "852": ["HK"], "853": ["MO"], "855": ["KH"], "856": ["LA"], "880": ["BD"], "886": ["TW"], "960": ["MV"], "961": ["LB"], "962": ["JO"], "963": ["SY"], "964": ["IQ"], "965": ["KW"], "966": ["SA"], "967": ["YE"], "968": ["OM"], "970": ["PS"], "971": ["AE"], "972": ["IL"], "973": ["BH"], "974": ["QA"], "975": ["BT"], "976": ["MN"], "977": ["NP"], "992": ["TJ"], "993": ["TM"], "994": ["AZ"], "995": ["GE"], "996": ["KG"], "998": ["UZ"] }, "countries": { "AC": ["247", "00", "(?:[01589]\\d|[46])\\d{4}", [5, 6]], "AD": ["376", "00", "(?:1|6\\d)\\d{7}|[135-9]\\d{5}", [6, 8, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["[135-9]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["1"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]]], "AE": ["971", "00", "(?:[4-7]\\d|9[0-689])\\d{7}|800\\d{2,9}|[2-4679]\\d{7}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{2,9})", "$1 $2", ["60|8"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[236]|[479][2-8]"], "0$1"], ["(\\d{3})(\\d)(\\d{5})", "$1 $2 $3", ["[479]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AF": ["93", "00", "[2-7]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"]], "0"], "AG": ["1", "011", "(?:268|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([457]\\d{6})$|1", "268$1", 0, "268"], "AI": ["1", "011", "(?:264|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2457]\\d{6})$|1", "264$1", 0, "264"], "AL": ["355", "00", "(?:700\\d\\d|900)\\d{3}|8\\d{5,7}|(?:[2-5]|6\\d)\\d{7}", [6, 7, 8, 9], [["(\\d{3})(\\d{3,4})", "$1 $2", ["80|9"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["4[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2358][2-5]|4"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["[23578]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["6"], "0$1"]], "0"], "AM": ["374", "00", "(?:[1-489]\\d|55|60|77)\\d{6}", [8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[89]0"], "0 $1"], ["(\\d{3})(\\d{5})", "$1 $2", ["2|3[12]"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["1|47"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[3-9]"], "0$1"]], "0"], "AO": ["244", "00", "[29]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[29]"]]]], "AR": ["54", "00", "(?:11|[89]\\d\\d)\\d{8}|[2368]\\d{9}", [10, 11], [["(\\d{4})(\\d{2})(\\d{4})", "$1 $2-$3", ["2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9])", "2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8]))|2(?:2[24-9]|3[1-59]|47)", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5[56][46]|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|58|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|54(?:4|5[13-7]|6[89])|86[3-6]))|2(?:2[24-9]|3[1-59]|47)|38(?:[58][78]|7[378])|3(?:454|85[56])[46]|3(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["1"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[68]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2-$3", ["[23]"], "0$1", 1], ["(\\d)(\\d{4})(\\d{2})(\\d{4})", "$2 15-$3-$4", ["9(?:2[2-469]|3[3-578])", "9(?:2(?:2[024-9]|3[0-59]|47|6[245]|9[02-8])|3(?:3[28]|4[03-9]|5[2-46-8]|7[1-578]|8[2-9]))", "9(?:2(?:[23]02|6(?:[25]|4[6-8])|9(?:[02356]|4[02568]|72|8[23]))|3(?:3[28]|4(?:[04679]|3[5-8]|5[4-68]|8[2379])|5(?:[2467]|3[237]|8[2-5])|7[1-578]|8(?:[2469]|3[2578]|5[4-8]|7[36-8]|8[5-8])))|92(?:2[24-9]|3[1-59]|47)", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3[78]|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8[23])|7[1-578]|8(?:[2469]|3[278]|5(?:[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4[35][56]|58[45]|8(?:[38]5|54|76))[4-6]", "9(?:2(?:[23]02|6(?:[25]|4(?:64|[78]))|9(?:[02356]|4(?:[0268]|5[2-6])|72|8[23]))|3(?:3[28]|4(?:[04679]|3(?:5(?:4[0-25689]|[56])|[78])|5(?:4[46]|8)|8[2379])|5(?:[2467]|3[237]|8(?:[23]|4(?:[45]|60)|5(?:4[0-39]|5|64)))|7[1-578]|8(?:[2469]|3[278]|5(?:4(?:4|5[13-7]|6[89])|[56][46]|[78])|7[378]|8(?:6[3-6]|[78]))))|92(?:2[24-9]|3[1-59]|47)|93(?:4(?:36|5[56])|8(?:[38]5|76))[4-6]"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d)(\\d{2})(\\d{4})(\\d{4})", "$2 15-$3-$4", ["91"], "0$1", 0, "$1 $2 $3-$4"], ["(\\d{3})(\\d{3})(\\d{5})", "$1-$2-$3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{4})", "$2 15-$3-$4", ["9"], "0$1", 0, "$1 $2 $3-$4"]], "0", 0, "0?(?:(11|2(?:2(?:02?|[13]|2[13-79]|4[1-6]|5[2457]|6[124-8]|7[1-4]|8[13-6]|9[1267])|3(?:02?|1[467]|2[03-6]|3[13-8]|[49][2-6]|5[2-8]|[67])|4(?:7[3-578]|9)|6(?:[0136]|2[24-6]|4[6-8]?|5[15-8])|80|9(?:0[1-3]|[19]|2\\d|3[1-6]|4[02568]?|5[2-4]|6[2-46]|72?|8[23]?))|3(?:3(?:2[79]|6|8[2578])|4(?:0[0-24-9]|[12]|3[5-8]?|4[24-7]|5[4-68]?|6[02-9]|7[126]|8[2379]?|9[1-36-8])|5(?:1|2[1245]|3[237]?|4[1-46-9]|6[2-4]|7[1-6]|8[2-5]?)|6[24]|7(?:[069]|1[1568]|2[15]|3[145]|4[13]|5[14-8]|7[2-57]|8[126])|8(?:[01]|2[15-7]|3[2578]?|4[13-6]|5[4-8]?|6[1-357-9]|7[36-8]?|8[5-8]?|9[124])))15)?", "9$1"], "AS": ["1", "011", "(?:[58]\\d\\d|684|900)\\d{7}", [10], 0, "1", 0, "([267]\\d{6})$|1", "684$1", 0, "684"], "AT": ["43", "00", "1\\d{3,12}|2\\d{6,12}|43(?:(?:0\\d|5[02-9])\\d{3,9}|2\\d{4,5}|[3467]\\d{4}|8\\d{4,6}|9\\d{4,7})|5\\d{4,12}|8\\d{7,12}|9\\d{8,12}|(?:[367]\\d|4[0-24-9])\\d{4,11}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{3,12})", "$1 $2", ["1(?:11|[2-9])"], "0$1"], ["(\\d{3})(\\d{2})", "$1 $2", ["517"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["5[079]"], "0$1"], ["(\\d{3})(\\d{3,10})", "$1 $2", ["(?:31|4)6|51|6(?:5[0-3579]|[6-9])|7(?:20|32|8)|[89]"], "0$1"], ["(\\d{4})(\\d{3,9})", "$1 $2", ["[2-467]|5[2-6]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,7})", "$1 $2 $3", ["5"], "0$1"]], "0"], "AU": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{7}(?:\\d(?:\\d{2})?)?|8[0-24-9]\\d{7})|[2-478]\\d{8}|1\\d{4,7}", [5, 6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{3,4})", "$1 $2", ["16"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["16"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["14|4"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[2378]"], "(0$1)"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:30|[89])"]]], "0", 0, "(183[12])|0", 0, 0, 0, [["(?:(?:(?:2(?:[0-26-9]\\d|3[0-8]|4[02-9]|5[0135-9])|7(?:[013-57-9]\\d|2[0-8]))\\d|3(?:(?:[0-3589]\\d|6[1-9]|7[0-35-9])\\d|4(?:[0-578]\\d|90)))\\d\\d|8(?:51(?:0(?:0[03-9]|[12479]\\d|3[2-9]|5[0-8]|6[1-9]|8[0-7])|1(?:[0235689]\\d|1[0-69]|4[0-589]|7[0-47-9])|2(?:0[0-79]|[18][13579]|2[14-9]|3[0-46-9]|[4-6]\\d|7[89]|9[0-4])|3\\d\\d)|(?:6[0-8]|[78]\\d)\\d{3}|9(?:[02-9]\\d{3}|1(?:(?:[0-58]\\d|6[0135-9])\\d|7(?:0[0-24-9]|[1-9]\\d)|9(?:[0-46-9]\\d|5[0-79])))))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, ["163\\d{2,6}", [5, 6, 7, 8, 9]], ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "AW": ["297", "00", "(?:[25-79]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[25-9]"]]]], "AX": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "2\\d{4,9}|35\\d{4,5}|(?:60\\d\\d|800)\\d{4,6}|7\\d{5,11}|(?:[14]\\d|3[0-46-9]|50)\\d{4,8}", [5, 6, 7, 8, 9, 10, 11, 12], 0, "0", 0, 0, 0, 0, "18", 0, "00"], "AZ": ["994", "00", "365\\d{6}|(?:[124579]\\d|60|88)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[28]|2|365|46", "1[28]|2|365[45]|46", "1[28]|2|365(?:4|5[02])|46"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[13-9]"], "0$1"]], "0"], "BA": ["387", "00", "6\\d{8}|(?:[35689]\\d|49|70)\\d{6}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[1-3]|[7-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2-$3", ["[3-5]|6[56]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["6"], "0$1"]], "0"], "BB": ["1", "011", "(?:246|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "246$1", 0, "246"], "BD": ["880", "00", "[1-469]\\d{9}|8[0-79]\\d{7,8}|[2-79]\\d{8}|[2-9]\\d{7}|[3-9]\\d{6}|[57-9]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{2})(\\d{4,6})", "$1-$2", ["31[5-8]|[459]1"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1-$2", ["3(?:[67]|8[013-9])|4(?:6[168]|7|[89][18])|5(?:6[128]|9)|6(?:[15]|28|4[14])|7[2-589]|8(?:0[014-9]|[12])|9[358]|(?:3[2-5]|4[235]|5[2-578]|6[0389]|76|8[3-7]|9[24])1|(?:44|66)[01346-9]"], "0$1"], ["(\\d{4})(\\d{3,6})", "$1-$2", ["[13-9]|2[23]"], "0$1"], ["(\\d)(\\d{7,8})", "$1-$2", ["2"], "0$1"]], "0"], "BE": ["32", "00", "4\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:80|9)0"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[239]|4[23]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[15-8]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4"], "0$1"]], "0"], "BF": ["226", "00", "[025-7]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[025-7]"]]]], "BG": ["359", "00", "00800\\d{7}|[2-7]\\d{6,7}|[89]\\d{6,8}|2\\d{5}", [6, 7, 8, 9, 12], [["(\\d)(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["43[1-6]|70[1-9]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["[356]|4[124-7]|7[1-9]|8[1-6]|9[1-7]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:70|8)0"], "0$1"], ["(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3", ["43[1-7]|7"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[48]|9[08]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"]], "0"], "BH": ["973", "00", "[136-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[13679]|8[02-4679]"]]]], "BI": ["257", "00", "(?:[267]\\d|31)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2367]"]]]], "BJ": ["229", "00", "(?:01\\d|[24-689])\\d{7}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["0"]]]], "BL": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:2[7-9]|3[3-7]|5[12]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], "BM": ["1", "011", "(?:441|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "441$1", 0, "441"], "BN": ["673", "00", "[2-578]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-578]"]]]], "BO": ["591", "00(?:1\\d)?", "8001\\d{5}|(?:[2-467]\\d|50)\\d{6}", [8, 9], [["(\\d)(\\d{7})", "$1 $2", ["[235]|4[46]"]], ["(\\d{8})", "$1", ["[67]"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["8"]]], "0", 0, "0(1\\d)?"], "BQ": ["599", "00", "(?:[34]1|7\\d)\\d{5}", [7], 0, 0, 0, 0, 0, 0, "[347]"], "BR": ["55", "00(?:1[245]|2[1-35]|31|4[13]|[56]5|99)", "(?:[1-46-9]\\d\\d|5(?:[0-46-9]\\d|5[0-46-9]))\\d{8}|[1-9]\\d{9}|[3589]\\d{8}|[34]\\d{7}", [8, 9, 10, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["300|4(?:0[02]|37)", "4(?:02|37)0|[34]00"]], ["(\\d{3})(\\d{2,3})(\\d{4})", "$1 $2 $3", ["(?:[358]|90)0"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2-$3", ["(?:[14689][1-9]|2[12478]|3[1-578]|5[13-5]|7[13-579])[2-57]"], "($1)"], ["(\\d{2})(\\d{5})(\\d{4})", "$1 $2-$3", ["[16][1-9]|[2-57-9]"], "($1)"]], "0", 0, "(?:0|90)(?:(1[245]|2[1-35]|31|4[13]|[56]5|99)(\\d{10,11}))?", "$2"], "BS": ["1", "011", "(?:242|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([3-8]\\d{6})$|1", "242$1", 0, "242"], "BT": ["975", "00", "[17]\\d{7}|[2-8]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-68]|7[246]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[67]|7"]]]], "BW": ["267", "00", "(?:0800|(?:[37]|800)\\d)\\d{6}|(?:[2-6]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["90"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[24-6]|3[15-9]"]], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37]"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["8"]]]], "BY": ["375", "810", "(?:[12]\\d|33|44|902)\\d{7}|8(?:0[0-79]\\d{5,7}|[1-7]\\d{9})|8(?:1[0-489]|[5-79]\\d)\\d{7}|8[1-79]\\d{6,7}|8[0-79]\\d{5}|8\\d{5}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3})", "$1 $2", ["800"], "8 $1"], ["(\\d{3})(\\d{2})(\\d{2,4})", "$1 $2 $3", ["800"], "8 $1"], ["(\\d{4})(\\d{2})(\\d{3})", "$1 $2-$3", ["1(?:5[169]|6[3-5]|7[179])|2(?:1[35]|2[34]|3[3-5])", "1(?:5[169]|6(?:3[1-3]|4|5[125])|7(?:1[3-9]|7[0-24-6]|9[2-7]))|2(?:1[35]|2[34]|3[3-5])"], "8 0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["1(?:[56]|7[467])|2[1-3]"], "8 0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-4]"], "8 0$1"], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[89]"], "8 $1"]], "8", 0, "0|80?", 0, 0, 0, 0, "8~10"], "BZ": ["501", "00", "(?:0800\\d|[2-8])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-8]"]], ["(\\d)(\\d{3})(\\d{4})(\\d{3})", "$1-$2-$3-$4", ["0"]]]], "CA": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [7, 10], 0, "1", 0, 0, 0, 0, 0, [["(?:2(?:04|[23]6|[48]9|50|63)|3(?:06|43|54|6[578]|82)|4(?:03|1[68]|[26]8|3[178]|50|74)|5(?:06|1[49]|48|79|8[147])|6(?:04|[18]3|39|47|72)|7(?:0[59]|42|53|78|8[02])|8(?:[06]7|19|25|7[39])|9(?:0[25]|42))[2-9]\\d{6}", [10]], ["", [10]], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}", [10]], ["900[2-9]\\d{6}", [10]], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|(?:5(?:00|2[125-9]|33|44|66|77|88)|6(?:22|33))[2-9]\\d{6}", [10]], 0, ["310\\d{4}", [7]], 0, ["600[2-9]\\d{6}", [10]]]], "CC": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:02|31|60|89)|1(?:18|76)|223)|91(?:0(?:1[0-2]|29)|1(?:[28]2|50|79)|2(?:10|64)|3(?:[06]8|22)|4[29]8|62\\d|70[23]|959))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CD": ["243", "00", "(?:(?:[189]|5\\d)\\d|2)\\d{7}|[1-68]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[1-6]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["5"], "0$1"]], "0"], "CF": ["236", "00", "(?:[27]\\d{3}|8776)\\d{4}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[278]"]]]], "CG": ["242", "00", "222\\d{6}|(?:0\\d|80)\\d{7}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[02]"]]]], "CH": ["41", "00", "8\\d{11}|[2-9]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8[047]|90"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]|81"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["8"], "0$1"]], "0"], "CI": ["225", "00", "[02]\\d{9}", [10], [["(\\d{2})(\\d{2})(\\d)(\\d{5})", "$1 $2 $3 $4", ["2"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3 $4", ["0"]]]], "CK": ["682", "00", "[2-578]\\d{4}", [5], [["(\\d{2})(\\d{3})", "$1 $2", ["[2-578]"]]]], "CL": ["56", "(?:0|1(?:1[0-69]|2[02-5]|5[13-58]|69|7[0167]|8[018]))0", "12300\\d{6}|6\\d{9,10}|[2-9]\\d{8}", [9, 10, 11], [["(\\d{5})(\\d{4})", "$1 $2", ["219", "2196"], "($1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["44"]], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2[1-36]"], "($1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["9[2-9]"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["3[2-5]|[47]|5[1-3578]|6[13-57]|8(?:0[1-9]|[1-9])"], "($1)"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["60|8"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{3})(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["60"]]]], "CM": ["237", "00", "[26]\\d{8}|88\\d{6,7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["88"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[26]|88"]]]], "CN": ["86", "00|1(?:[12]\\d|79)\\d\\d00", "(?:(?:1[03-689]|2\\d)\\d\\d|6)\\d{8}|1\\d{10}|[126]\\d{6}(?:\\d(?:\\d{2})?)?|86\\d{5,6}|(?:[3-579]\\d|8[0-57-9])\\d{5,9}", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5,6})", "$1 $2", ["(?:10|2[0-57-9])[19]|3(?:[157]|35|49|9[1-68])|4(?:1[124-9]|2[179]|6[47-9]|7|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:07|1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3|4[13]|5[1-5]|7[0-79]|9[0-35-9])|(?:4[35]|59|85)[1-9]", "(?:10|2[0-57-9])(?:1[02]|9[56])|8078|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))1", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|80781|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))12", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|807812|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123", "10(?:1(?:0|23)|9[56])|2[0-57-9](?:1(?:00|23)|9[56])|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:1[124-9]|2[179]|[35][1-9]|6[47-9]|7\\d|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:078|1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|3\\d|4[13]|5[1-5]|7[0-79]|9[0-35-9]))123"], "0$1"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["3(?:[157]|35|49|9[1-68])|4(?:[17]|2[179]|6[47-9]|8[23])|5(?:[1357]|2[37]|4[36]|6[1-46]|80)|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]|4[13]|5[1-5])|(?:4[35]|59|85)[1-9]", "(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[1-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))[19]", "85[23](?:10|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:10|9[56])", "85[23](?:100|95)|(?:3(?:[157]\\d|35|49|9[1-68])|4(?:[17]\\d|2[179]|[35][1-9]|6[47-9]|8[23])|5(?:[1357]\\d|2[37]|4[36]|6[1-46]|80|9[1-9])|6(?:3[1-5]|6[0238]|9[12])|7(?:01|[1579]\\d|2[248]|3[014-9]|4[3-6]|6[023689])|8(?:1[236-8]|2[5-7]|[37]\\d|5[14-9]|8[36-8]|9[1-8])|9(?:0[1-3689]|1[1-79]|[379]\\d|4[13]|5[1-5]))(?:100|9[56])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["(?:4|80)0"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|2(?:[02-57-9]|1[1-9])", "10|2(?:[02-57-9]|1[1-9])", "10[0-79]|2(?:[02-57-9]|1[1-79])|(?:10|21)8(?:0[1-9]|[1-9])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["3(?:[3-59]|7[02-68])|4(?:[26-8]|3[3-9]|5[2-9])|5(?:3[03-9]|[468]|7[028]|9[2-46-9])|6|7(?:[0-247]|3[04-9]|5[0-4689]|6[2368])|8(?:[1-358]|9[1-7])|9(?:[013479]|5[1-5])|(?:[34]1|55|79|87)[02-9]"], "0$1", 1], ["(\\d{3})(\\d{7,8})", "$1 $2", ["9"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["80"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[3-578]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["1[3-9]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["[12]"], "0$1", 1]], "0", 0, "(1(?:[12]\\d|79)\\d\\d)|0", 0, 0, 0, 0, "00"], "CO": ["57", "00(?:4(?:[14]4|56)|[579])", "(?:46|60\\d\\d)\\d{6}|(?:1\\d|[39])\\d{9}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["46"]], ["(\\d{3})(\\d{7})", "$1 $2", ["6|90"], "($1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3[0-357]|91"]], ["(\\d)(\\d{3})(\\d{7})", "$1-$2-$3", ["1"], "0$1", 0, "$1 $2 $3"]], "0", 0, "0([3579]|4(?:[14]4|56))?"], "CR": ["506", "00", "(?:8\\d|90)\\d{8}|(?:[24-8]\\d{3}|3005)\\d{4}", [8, 10], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[3-9]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["[89]"]]], 0, 0, "(19(?:0[0-2468]|1[09]|20|66|77|99))"], "CU": ["53", "119", "(?:[2-7]|8\\d\\d)\\d{7}|[2-47]\\d{6}|[34]\\d{5}", [6, 7, 8, 10], [["(\\d{2})(\\d{4,6})", "$1 $2", ["2[1-4]|[34]"], "(0$1)"], ["(\\d)(\\d{6,7})", "$1 $2", ["7"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["[56]"], "0$1"], ["(\\d{3})(\\d{7})", "$1 $2", ["8"], "0$1"]], "0"], "CV": ["238", "0", "(?:[2-59]\\d\\d|800)\\d{4}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2-589]"]]]], "CW": ["599", "00", "(?:[34]1|60|(?:7|9\\d)\\d)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[3467]"]], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["9[4-8]"]]], 0, 0, 0, 0, 0, "[69]"], "CX": ["61", "001[14-689]|14(?:1[14]|34|4[17]|[56]6|7[47]|88)0011", "1(?:[0-79]\\d{8}(?:\\d{2})?|8[0-24-9]\\d{7})|[148]\\d{8}|1\\d{5,7}", [6, 7, 8, 9, 10, 12], 0, "0", 0, "([59]\\d{7})$|0", "8$1", 0, 0, [["8(?:51(?:0(?:01|30|59|88)|1(?:17|46|75)|2(?:22|35))|91(?:00[6-9]|1(?:[28]1|49|78)|2(?:09|63)|3(?:12|26|75)|4(?:56|97)|64\\d|7(?:0[01]|1[0-2])|958))\\d{3}", [9]], ["4(?:79[01]|83[0-389]|94[0-4])\\d{5}|4(?:[0-36]\\d|4[047-9]|5[0-25-9]|7[02-8]|8[0-24-9]|9[0-37-9])\\d{6}", [9]], ["180(?:0\\d{3}|2)\\d{3}", [7, 10]], ["190[0-26]\\d{6}", [10]], 0, 0, 0, 0, ["14(?:5(?:1[0458]|[23][458])|71\\d)\\d{4}", [9]], ["13(?:00\\d{6}(?:\\d{2})?|45[0-4]\\d{3})|13\\d{4}", [6, 8, 10, 12]]], "0011"], "CY": ["357", "00", "(?:[279]\\d|[58]0)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[257-9]"]]]], "CZ": ["420", "00", "(?:[2-578]\\d|60)\\d{7}|9\\d{8,11}", [9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]|9[015-7]"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["96"]], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]]], "DE": ["49", "00", "[2579]\\d{5,14}|49(?:[34]0|69|8\\d)\\d\\d?|49(?:37|49|60|7[089]|9\\d)\\d{1,3}|49(?:2[024-9]|3[2-689]|7[1-7])\\d{1,8}|(?:1|[368]\\d|4[0-8])\\d{3,13}|49(?:[015]\\d|2[13]|31|[46][1-8])\\d{1,9}", [4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15], [["(\\d{2})(\\d{3,13})", "$1 $2", ["3[02]|40|[68]9"], "0$1"], ["(\\d{3})(\\d{3,12})", "$1 $2", ["2(?:0[1-389]|1[124]|2[18]|3[14])|3(?:[35-9][15]|4[015])|906|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1", "2(?:0[1-389]|12[0-8])|3(?:[35-9][15]|4[015])|906|2(?:[13][14]|2[18])|(?:2[4-9]|4[2-9]|[579][1-9]|[68][1-8])1"], "0$1"], ["(\\d{4})(\\d{2,11})", "$1 $2", ["[24-6]|3(?:[3569][02-46-9]|4[2-4679]|7[2-467]|8[2-46-8])|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]", "[24-6]|3(?:3(?:0[1-467]|2[127-9]|3[124578]|7[1257-9]|8[1256]|9[145])|4(?:2[135]|4[13578]|9[1346])|5(?:0[14]|2[1-3589]|6[1-4]|7[13468]|8[13568])|6(?:2[1-489]|3[124-6]|6[13]|7[12579]|8[1-356]|9[135])|7(?:2[1-7]|4[145]|6[1-5]|7[1-4])|8(?:21|3[1468]|6|7[1467]|8[136])|9(?:0[12479]|2[1358]|4[134679]|6[1-9]|7[136]|8[147]|9[1468]))|70[2-8]|8(?:0[2-9]|[1-8])|90[7-9]|[79][1-9]|3[68]4[1347]|3(?:47|60)[1356]|3(?:3[46]|46|5[49])[1246]|3[4579]3[1357]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["138"], "0$1"], ["(\\d{5})(\\d{2,10})", "$1 $2", ["3"], "0$1"], ["(\\d{3})(\\d{5,11})", "$1 $2", ["181"], "0$1"], ["(\\d{3})(\\d)(\\d{4,10})", "$1 $2 $3", ["1(?:3|80)|9"], "0$1"], ["(\\d{3})(\\d{7,8})", "$1 $2", ["1[67]"], "0$1"], ["(\\d{3})(\\d{7,12})", "$1 $2", ["8"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["185", "1850", "18500"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["18[68]"], "0$1"], ["(\\d{4})(\\d{7})", "$1 $2", ["15[1279]"], "0$1"], ["(\\d{5})(\\d{6})", "$1 $2", ["15[03568]", "15(?:[0568]|31)"], "0$1"], ["(\\d{3})(\\d{8})", "$1 $2", ["18"], "0$1"], ["(\\d{3})(\\d{2})(\\d{7,8})", "$1 $2 $3", ["1(?:6[023]|7)"], "0$1"], ["(\\d{4})(\\d{2})(\\d{7})", "$1 $2 $3", ["15[279]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{8})", "$1 $2 $3", ["15"], "0$1"]], "0"], "DJ": ["253", "00", "(?:2\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[27]"]]]], "DK": ["45", "00", "[2-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-9]"]]]], "DM": ["1", "011", "(?:[58]\\d\\d|767|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "767$1", 0, "767"], "DO": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "8001|8[024]9"], "DZ": ["213", "00", "(?:[1-4]|[5-79]\\d|80)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["9"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-8]"], "0$1"]], "0"], "EC": ["593", "00", "1\\d{9,10}|(?:[2-7]|9\\d)\\d{7}", [8, 9, 10, 11], [["(\\d)(\\d{3})(\\d{4})", "$1 $2-$3", ["[2-7]"], "(0$1)", 0, "$1-$2-$3"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1"]]], "0"], "EE": ["372", "00", "8\\d{9}|[4578]\\d{7}|(?:[3-8]\\d|90)\\d{5}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[369]|4[3-8]|5(?:[0-2]|5[0-478]|6[45])|7[1-9]|88", "[369]|4[3-8]|5(?:[02]|1(?:[0-8]|95)|5[0-478]|6(?:4[0-4]|5[1-589]))|7[1-9]|88"]], ["(\\d{4})(\\d{3,4})", "$1 $2", ["[45]|8(?:00|[1-49])", "[45]|8(?:00[1-9]|[1-49])"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "EG": ["20", "00", "[189]\\d{8,9}|[24-6]\\d{8}|[135]\\d{7}", [8, 9, 10], [["(\\d)(\\d{7,8})", "$1 $2", ["[23]"], "0$1"], ["(\\d{2})(\\d{6,7})", "$1 $2", ["1[35]|[4-6]|8[2468]|9[235-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{8})", "$1 $2", ["1"], "0$1"]], "0"], "EH": ["212", "00", "[5-8]\\d{8}", [9], 0, "0", 0, 0, 0, 0, "528[89]"], "ER": ["291", "00", "[178]\\d{6}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[178]"], "0$1"]], "0"], "ES": ["34", "00", "[5-9]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[89]00"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-9]"]]]], "ET": ["251", "00", "(?:11|[2-579]\\d)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-579]"], "0$1"]], "0"], "FI": ["358", "00|99(?:[01469]|5(?:[14]1|3[23]|5[59]|77|88|9[09]))", "[1-35689]\\d{4}|7\\d{10,11}|(?:[124-7]\\d|3[0-46-9])\\d{8}|[1-9]\\d{5,8}", [5, 6, 7, 8, 9, 10, 11, 12], [["(\\d{5})", "$1", ["20[2-59]"], "0$1"], ["(\\d{3})(\\d{3,7})", "$1 $2", ["(?:[1-3]0|[68])0|70[07-9]"], "0$1"], ["(\\d{2})(\\d{4,8})", "$1 $2", ["[14]|2[09]|50|7[135]"], "0$1"], ["(\\d{2})(\\d{6,10})", "$1 $2", ["7"], "0$1"], ["(\\d)(\\d{4,9})", "$1 $2", ["(?:19|[2568])[1-8]|3(?:0[1-9]|[1-9])|9"], "0$1"]], "0", 0, 0, 0, 0, "1[03-79]|[2-9]", 0, "00"], "FJ": ["679", "0(?:0|52)", "45\\d{5}|(?:0800\\d|[235-9])\\d{6}", [7, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[235-9]|45"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "FK": ["500", "00", "[2-7]\\d{4}", [5]], "FM": ["691", "00", "(?:[39]\\d\\d|820)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[389]"]]]], "FO": ["298", "00", "[2-9]\\d{5}", [6], [["(\\d{6})", "$1", ["[2-9]"]]], 0, 0, "(10(?:01|[12]0|88))"], "FR": ["33", "00", "[1-9]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0 $1"], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["[1-79]"], "0$1"]], "0"], "GA": ["241", "00", "(?:[067]\\d|11)\\d{6}|[2-7]\\d{6}", [7, 8], [["(\\d)(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-7]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["11|[67]"], "0$1"]], 0, 0, "0(11\\d{6}|60\\d{6}|61\\d{6}|6[256]\\d{6}|7[467]\\d{6})", "$1"], "GB": ["44", "00", "[1-357-9]\\d{9}|[18]\\d{8}|8\\d{6}", [7, 9, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["800", "8001", "80011", "800111", "8001111"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["845", "8454", "84546", "845464"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["800"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["1(?:38|5[23]|69|76|94)", "1(?:(?:38|69)7|5(?:24|39)|768|946)", "1(?:3873|5(?:242|39[4-6])|(?:697|768)[347]|9467)"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["1(?:[2-69][02-9]|[78])"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[25]|7(?:0|6[02-9])", "[25]|7(?:0|6(?:[03-9]|2[356]))"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1389]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["(?:1(?:1(?:3(?:[0-58]\\d\\d|73[0-35])|4(?:(?:[0-5]\\d|70)\\d|69[7-9])|(?:(?:5[0-26-9]|[78][0-49])\\d|6(?:[0-4]\\d|50))\\d)|(?:2(?:(?:0[024-9]|2[3-9]|3[3-79]|4[1-689]|[58][02-9]|6[0-47-9]|7[013-9]|9\\d)\\d|1(?:[0-7]\\d|8[0-3]))|(?:3(?:0\\d|1[0-8]|[25][02-9]|3[02-579]|[468][0-46-9]|7[1-35-79]|9[2-578])|4(?:0[03-9]|[137]\\d|[28][02-57-9]|4[02-69]|5[0-8]|[69][0-79])|5(?:0[1-35-9]|[16]\\d|2[024-9]|3[015689]|4[02-9]|5[03-9]|7[0-35-9]|8[0-468]|9[0-57-9])|6(?:0[034689]|1\\d|2[0-35689]|[38][013-9]|4[1-467]|5[0-69]|6[13-9]|7[0-8]|9[0-24578])|7(?:0[0246-9]|2\\d|3[0236-8]|4[03-9]|5[0-46-9]|6[013-9]|7[0-35-9]|8[024-9]|9[02-9])|8(?:0[35-9]|2[1-57-9]|3[02-578]|4[0-578]|5[124-9]|6[2-69]|7\\d|8[02-9]|9[02569])|9(?:0[02-589]|[18]\\d|2[02-689]|3[1-57-9]|4[2-9]|5[0-579]|6[2-47-9]|7[0-24578]|9[2-57]))\\d)\\d)|2(?:0[013478]|3[0189]|4[017]|8[0-46-9]|9[0-2])\\d{3})\\d{4}|1(?:2(?:0(?:46[1-4]|87[2-9])|545[1-79]|76(?:2\\d|3[1-8]|6[1-6])|9(?:7(?:2[0-4]|3[2-5])|8(?:2[2-8]|7[0-47-9]|8[3-5])))|3(?:6(?:38[2-5]|47[23])|8(?:47[04-9]|64[0157-9]))|4(?:044[1-7]|20(?:2[23]|8\\d)|6(?:0(?:30|5[2-57]|6[1-8]|7[2-8])|140)|8(?:052|87[1-3]))|5(?:2(?:4(?:3[2-79]|6\\d)|76\\d)|6(?:26[06-9]|686))|6(?:06(?:4\\d|7[4-79])|295[5-7]|35[34]\\d|47(?:24|61)|59(?:5[08]|6[67]|74)|9(?:55[0-4]|77[23]))|7(?:26(?:6[13-9]|7[0-7])|(?:442|688)\\d|50(?:2[0-3]|[3-68]2|76))|8(?:27[56]\\d|37(?:5[2-5]|8[239])|843[2-58])|9(?:0(?:0(?:6[1-8]|85)|52\\d)|3583|4(?:66[1-8]|9(?:2[01]|81))|63(?:23|3[1-4])|9561))\\d{3}", [9, 10]], ["7(?:457[0-57-9]|700[01]|911[028])\\d{5}|7(?:[1-3]\\d\\d|4(?:[0-46-9]\\d|5[0-689])|5(?:0[0-8]|[13-9]\\d|2[0-35-9])|7(?:0[1-9]|[1-7]\\d|8[02-9]|9[0-689])|8(?:[014-9]\\d|[23][0-8])|9(?:[024-9]\\d|1[02-9]|3[0-689]))\\d{6}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[2-49]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]], 0, " x"], "GD": ["1", "011", "(?:473|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "473$1", 0, "473"], "GE": ["995", "00", "(?:[3-57]\\d\\d|800)\\d{6}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["32"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[57]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[348]"], "0$1"]], "0"], "GF": ["594", "00", "(?:[56]94\\d|7093)\\d{5}|(?:80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]|9[47]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[89]"], "0$1"]], "0"], "GG": ["44", "00", "(?:1481|[357-9]\\d{3})\\d{6}|8\\d{6}(?:\\d{2})?", [7, 9, 10], 0, "0", 0, "([25-9]\\d{5})$|0", "1481$1", 0, 0, [["1481[25-9]\\d{5}", [10]], ["7(?:(?:781|839)\\d|911[17])\\d{5}", [10]], ["80[08]\\d{7}|800\\d{6}|8001111"], ["(?:8(?:4[2-5]|7[0-3])|9(?:[01]\\d|8[0-3]))\\d{7}|845464\\d", [7, 10]], ["70\\d{8}", [10]], 0, ["(?:3[0347]|55)\\d{8}", [10]], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}", [10]], ["56\\d{8}", [10]]]], "GH": ["233", "00", "(?:[235]\\d{3}|800)\\d{5}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[235]"], "0$1"]], "0"], "GI": ["350", "00", "(?:[25]\\d|60)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["2"]]]], "GL": ["299", "00", "(?:19|[2-689]\\d|70)\\d{4}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["19|[2-9]"]]]], "GM": ["220", "00", "[2-9]\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "GN": ["224", "00", "722\\d{6}|(?:3|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["3"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[67]"]]]], "GP": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0", 0, 0, 0, 0, 0, [["590(?:0[1-68]|[14][0-24-9]|2[0-68]|3[1-9]|5[3-579]|[68][0-689]|7[08]|9\\d)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], "GQ": ["240", "00", "222\\d{6}|(?:3\\d|55|[89]0)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235]"]], ["(\\d{3})(\\d{6})", "$1 $2", ["[89]"]]]], "GR": ["30", "00", "5005000\\d{3}|8\\d{9,11}|(?:[269]\\d|70)\\d{8}", [10, 11, 12], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["21|7"]], ["(\\d{4})(\\d{6})", "$1 $2", ["2(?:2|3[2-57-9]|4[2-469]|5[2-59]|6[2-9]|7[2-69]|8[2-49])|5"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2689]"]], ["(\\d{3})(\\d{3,4})(\\d{5})", "$1 $2 $3", ["8"]]]], "GT": ["502", "00", "80\\d{6}|(?:1\\d{3}|[2-7])\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[2-8]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "GU": ["1", "011", "(?:[58]\\d\\d|671|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "671$1", 0, "671"], "GW": ["245", "00", "[49]\\d{8}|4\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["40"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"]]]], "GY": ["592", "001", "(?:[2-8]\\d{3}|9008)\\d{3}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "HK": ["852", "00(?:30|5[09]|[126-9]?)", "8[0-46-9]\\d{6,7}|9\\d{4,7}|(?:[2-7]|9\\d{3})\\d{7}", [5, 6, 7, 8, 9, 11], [["(\\d{3})(\\d{2,5})", "$1 $2", ["900", "9003"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[2-7]|8[1-4]|9(?:0[1-9]|[1-8])"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{3})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["9"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "HN": ["504", "00", "8\\d{10}|[237-9]\\d{7}", [8, 11], [["(\\d{4})(\\d{4})", "$1-$2", ["[237-9]"]]]], "HR": ["385", "00", "(?:[24-69]\\d|3[0-79])\\d{7}|80\\d{5,7}|[1-79]\\d{7}|6\\d{5,6}", [6, 7, 8, 9], [["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["6[01]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{4})(\\d{3})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6|7[245]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-57]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"]], "0"], "HT": ["509", "00", "(?:[2-489]\\d|55)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[2-589]"]]]], "HU": ["36", "00", "[235-7]\\d{8}|[1-9]\\d{7}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27][2-9]|3[2-7]|4[24-9]|5[2-79]|6|8[2-57-9]|9[2-69]"], "(06 $1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "06 $1"]], "06"], "ID": ["62", "00[89]", "00[1-9]\\d{9,14}|(?:[1-36]|8\\d{5})\\d{6}|00\\d{9}|[1-9]\\d{8,10}|[2-9]\\d{7}", [7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["15"]], ["(\\d{2})(\\d{5,9})", "$1 $2", ["2[124]|[36]1"], "(0$1)"], ["(\\d{3})(\\d{5,7})", "$1 $2", ["800"], "0$1"], ["(\\d{3})(\\d{5,8})", "$1 $2", ["[2-79]"], "(0$1)"], ["(\\d{3})(\\d{3,4})(\\d{3})", "$1-$2-$3", ["8[1-35-9]"], "0$1"], ["(\\d{3})(\\d{6,8})", "$1 $2", ["1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["804"], "0$1"], ["(\\d{3})(\\d)(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["80"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1-$2-$3", ["8"], "0$1"]], "0"], "IE": ["353", "00", "(?:1\\d|[2569])\\d{6,8}|4\\d{6,9}|7\\d{8}|8\\d{8,9}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["2[24-9]|47|58|6[237-9]|9[35-9]"], "(0$1)"], ["(\\d{3})(\\d{5})", "$1 $2", ["[45]0"], "(0$1)"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2569]|4[1-69]|7[14]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["70"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["81"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["4"], "(0$1)"], ["(\\d{2})(\\d)(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "IL": ["972", "0(?:0|1[2-9])", "1\\d{6}(?:\\d{3,5})?|[57]\\d{8}|[1-489]\\d{7}", [7, 8, 9, 10, 11, 12], [["(\\d{4})(\\d{3})", "$1-$2", ["125"]], ["(\\d{4})(\\d{2})(\\d{2})", "$1-$2-$3", ["121"]], ["(\\d)(\\d{3})(\\d{4})", "$1-$2-$3", ["[2-489]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1-$2-$3", ["12"]], ["(\\d{4})(\\d{6})", "$1-$2", ["159"]], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3-$4", ["1[7-9]"]], ["(\\d{3})(\\d{1,2})(\\d{3})(\\d{4})", "$1-$2 $3-$4", ["15"]]], "0"], "IM": ["44", "00", "1624\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([25-8]\\d{5})$|0", "1624$1", 0, "74576|(?:16|7[56])24"], "IN": ["91", "00", "(?:000800|[2-9]\\d\\d)\\d{7}|1\\d{7,12}", [8, 9, 10, 11, 12, 13], [["(\\d{8})", "$1", ["5(?:0|2[23]|3[03]|[67]1|88)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|888)", "5(?:0|2(?:21|3)|3(?:0|3[23])|616|717|8888)"], 0, 1], ["(\\d{4})(\\d{4,5})", "$1 $2", ["180", "1800"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["140"], 0, 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["11|2[02]|33|4[04]|79[1-7]|80[2-46]", "11|2[02]|33|4[04]|79(?:[1-6]|7[19])|80(?:[2-4]|6[0-589])", "11|2[02]|33|4[04]|79(?:[124-6]|3(?:[02-9]|1[0-24-9])|7(?:1|9[1-6]))|80(?:[2-4]|6[0-589])"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1(?:2[0-249]|3[0-25]|4[145]|[68]|7[1257])|2(?:1[257]|3[013]|4[01]|5[0137]|6[0158]|78|8[1568])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|5[12]|[78]1)|6(?:12|[2-4]1|5[17]|6[13]|80)|7(?:12|3[134]|4[47]|61|88)|8(?:16|2[014]|3[126]|6[136]|7[078]|8[34]|91)|(?:43|59|75)[15]|(?:1[59]|29|67|72)[14]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|674|7(?:(?:2[14]|3[34]|5[15])[2-6]|61[346]|88[0-8])|8(?:70[2-6]|84[235-7]|91[3-7])|(?:1(?:29|60|8[06])|261|552|6(?:12|[2-47]1|5[17]|6[13]|80)|7(?:12|31|4[47])|8(?:16|2[014]|3[126]|6[136]|7[78]|83))[2-7]", "1(?:2[0-24]|3[0-25]|4[145]|[59][14]|6[1-9]|7[1257]|8[1-57-9])|2(?:1[257]|3[013]|4[01]|5[0137]|6[058]|78|8[1568]|9[14])|3(?:26|4[1-3]|5[34]|6[01489]|7[02-46]|8[159])|4(?:1[36]|2[1-47]|3[15]|5[12]|6[0-26-9]|7[0-24-9]|8[013-57]|9[014-7])|5(?:1[025]|22|[36][25]|4[28]|[578]1|9[15])|6(?:12(?:[2-6]|7[0-8])|74[2-7])|7(?:(?:2[14]|5[15])[2-6]|3171|61[346]|88(?:[2-7]|82))|8(?:70[2-6]|84(?:[2356]|7[19])|91(?:[3-6]|7[19]))|73[134][2-6]|(?:74[47]|8(?:16|2[014]|3[126]|6[136]|7[78]|83))(?:[2-6]|7[19])|(?:1(?:29|60|8[06])|261|552|6(?:[2-4]1|5[17]|6[13]|7(?:1|4[0189])|80)|7(?:12|88[01]))[2-7]"], "0$1", 1], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2[2457-9]|3[2-5]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1[013-9]|28|3[129]|4[1-35689]|5[29]|6[02-5]|70)|807", "1(?:[2-479]|5[0235-9])|[2-5]|6(?:1[1358]|2(?:[2457]|84|95)|3(?:[2-4]|55)|4[235-7]|5[2-689]|6[24578]|7[235689]|8[1-6])|7(?:1(?:[013-8]|9[6-9])|28[6-8]|3(?:17|2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4|5[0-367])|70[13-7])|807[19]", "1(?:[2-479]|5(?:[0236-9]|5[013-9]))|[2-5]|6(?:2(?:84|95)|355|83)|73179|807(?:1|9[1-3])|(?:1552|6(?:1[1358]|2[2457]|3[2-4]|4[235-7]|5[2-689]|6[24578]|7[235689]|8[124-6])\\d|7(?:1(?:[013-8]\\d|9[6-9])|28[6-8]|3(?:2[0-49]|9[2-57])|4(?:1[2-4]|[29][0-7]|3[0-8]|[56]\\d|8[0-24-7])|5(?:2[1-3]|9[0-6])|6(?:0[5689]|2[5-9]|3[02-8]|4\\d|5[0-367])|70[13-7]))[2-7]"], "0$1", 1], ["(\\d{5})(\\d{5})", "$1 $2", ["[6-9]"], "0$1", 1], ["(\\d{4})(\\d{2,4})(\\d{4})", "$1 $2 $3", ["1(?:6|8[06])", "1(?:6|8[06]0)"], 0, 1], ["(\\d{4})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["18"], 0, 1]], "0"], "IO": ["246", "00", "3\\d{6}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["3"]]]], "IQ": ["964", "00", "(?:1|7\\d\\d)\\d{7}|[2-6]\\d{7,8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-6]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "IR": ["98", "00", "[1-9]\\d{9}|(?:[1-8]\\d\\d|9)\\d{3,4}", [4, 5, 6, 7, 10], [["(\\d{4,5})", "$1", ["96"], "0$1"], ["(\\d{2})(\\d{4,5})", "$1 $2", ["(?:1[137]|2[13-68]|3[1458]|4[145]|5[1468]|6[16]|7[1467]|8[13467])[12689]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["[1-8]"], "0$1"]], "0"], "IS": ["354", "00|1(?:0(?:01|[12]0)|100)", "(?:38\\d|[4-9])\\d{6}", [7, 9], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "IT": ["39", "00", "0\\d{5,10}|1\\d{8,10}|3(?:[0-8]\\d{7,10}|9\\d{7,8})|(?:43|55|70)\\d{8}|8\\d{5}(?:\\d{2,4})?", [6, 7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{4,6})", "$1 $2", ["0[26]"]], ["(\\d{3})(\\d{3,6})", "$1 $2", ["0[13-57-9][0159]|8(?:03|4[17]|9[2-5])", "0[13-57-9][0159]|8(?:03|4[17]|9(?:2|3[04]|[45][0-4]))"]], ["(\\d{4})(\\d{2,6})", "$1 $2", ["0(?:[13-579][2-46-8]|8[236-8])"]], ["(\\d{4})(\\d{4})", "$1 $2", ["894"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[26]|5"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["1(?:44|[679])|[378]|43"]], ["(\\d{3})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["0[13-57-9][0159]|14"]], ["(\\d{2})(\\d{4})(\\d{5})", "$1 $2 $3", ["0[26]"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["3"]]], 0, 0, 0, 0, 0, 0, [["0669[0-79]\\d{1,6}|0(?:1(?:[0159]\\d|[27][1-5]|31|4[1-4]|6[1356]|8[2-57])|2\\d\\d|3(?:[0159]\\d|2[1-4]|3[12]|[48][1-6]|6[2-59]|7[1-7])|4(?:[0159]\\d|[23][1-9]|4[245]|6[1-5]|7[1-4]|81)|5(?:[0159]\\d|2[1-5]|3[2-6]|4[1-79]|6[4-6]|7[1-578]|8[3-8])|6(?:[0-57-9]\\d|6[0-8])|7(?:[0159]\\d|2[12]|3[1-7]|4[2-46]|6[13569]|7[13-6]|8[1-59])|8(?:[0159]\\d|2[3-578]|3[1-356]|[6-8][1-5])|9(?:[0159]\\d|[238][1-5]|4[12]|6[1-8]|7[1-6]))\\d{2,7}", [6, 7, 8, 9, 10, 11]], ["3[2-9]\\d{7,8}|(?:31|43)\\d{8}", [9, 10]], ["80(?:0\\d{3}|3)\\d{3}", [6, 9]], ["(?:0878\\d{3}|89(?:2\\d|3[04]|4(?:[0-4]|[5-9]\\d\\d)|5[0-4]))\\d\\d|(?:1(?:44|6[346])|89(?:38|5[5-9]|9))\\d{6}", [6, 8, 9, 10]], ["1(?:78\\d|99)\\d{6}", [9, 10]], ["3[2-8]\\d{9,10}", [11, 12]], 0, 0, ["55\\d{8}", [10]], ["84(?:[08]\\d{3}|[17])\\d{3}", [6, 9]]]], "JE": ["44", "00", "1534\\d{6}|(?:[3578]\\d|90)\\d{8}", [10], 0, "0", 0, "([0-24-8]\\d{5})$|0", "1534$1", 0, 0, [["1534[0-24-8]\\d{5}"], ["7(?:(?:(?:50|82)9|937)\\d|7(?:00[378]|97\\d))\\d{5}"], ["80(?:07(?:35|81)|8901)\\d{4}"], ["(?:8(?:4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|90(?:066[59]|1810|71(?:07|55)))\\d{4}"], ["701511\\d{4}"], 0, ["(?:3(?:0(?:07(?:35|81)|8901)|3\\d{4}|4(?:4(?:4(?:05|42|69)|703)|5(?:041|800))|7(?:0002|1206))|55\\d{4})\\d{4}"], ["76(?:464|652)\\d{5}|76(?:0[0-28]|2[356]|34|4[01347]|5[49]|6[0-369]|77|8[14]|9[139])\\d{6}"], ["56\\d{8}"]]], "JM": ["1", "011", "(?:[58]\\d\\d|658|900)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "658|876"], "JO": ["962", "00", "(?:(?:[2689]|7\\d)\\d|32|53)\\d{6}", [8, 9], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2356]|87"], "(0$1)"], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["70"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["7"], "0$1"]], "0"], "JP": ["81", "010", "00[1-9]\\d{6,14}|[257-9]\\d{9}|(?:00|[1-9]\\d\\d)\\d{6}", [8, 9, 10, 11, 12, 13, 14, 15, 16, 17], [["(\\d{3})(\\d{3})(\\d{3})", "$1-$2-$3", ["(?:12|57|99)0"], "0$1"], ["(\\d{4})(\\d)(\\d{4})", "$1-$2-$3", ["1(?:26|3[79]|4[56]|5[4-68]|6[3-5])|499|5(?:76|97)|746|8(?:3[89]|47|51)|9(?:80|9[16])", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:76|97)9|7468|8(?:3(?:8[7-9]|96)|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]", "1(?:267|3(?:7[247]|9[278])|466|5(?:47|58|64)|6(?:3[245]|48|5[4-68]))|499[2468]|5(?:769|979[2-69])|7468|8(?:3(?:8[7-9]|96[2457-9])|477|51[2-9])|9(?:802|9(?:1[23]|69))|1(?:45|58)[67]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["60"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2-$3", ["[36]|4(?:2[09]|7[01])", "[36]|4(?:2(?:0|9[02-69])|7(?:0[019]|1))"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["1(?:1|5[45]|77|88|9[69])|2(?:2[1-37]|3[0-269]|4[59]|5|6[24]|7[1-358]|8[1369]|9[0-38])|4(?:[28][1-9]|3[0-57]|[45]|6[248]|7[2-579]|9[29])|5(?:2|3[0459]|4[0-369]|5[29]|8[02389]|9[0-389])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9[2-6])|8(?:2[124589]|3[26-9]|49|51|6|7[0-468]|8[68]|9[019])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9[1-489])", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2(?:[127]|3[014-9])|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9[19])|62|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|8[1-9]|9[29])|5(?:2|3(?:[045]|9[0-8])|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0-2469])|3(?:[29]|60)|49|51|6(?:[0-24]|36|5[0-3589]|7[23]|9[01459])|7[0-468]|8[68])|9(?:[23][1-9]|4[15]|5[138]|6[1-3]|7[156]|8[189]|9(?:[1289]|3[34]|4[0178]))|(?:264|837)[016-9]|2(?:57|93)[015-9]|(?:25[0468]|422|838)[01]|(?:47[59]|59[89]|8(?:6[68]|9))[019]", "1(?:1|5(?:4[018]|5[017])|77|88|9[69])|2(?:2[127]|3[0-269]|4[59]|5(?:[1-3]|5[0-69]|9(?:17|99))|6(?:2|4[016-9])|7(?:[1-35]|8[0189])|8(?:[16]|3[0134]|9[0-5])|9(?:[028]|17))|4(?:2(?:[13-79]|8[014-6])|3[0-57]|[45]|6[248]|7[2-47]|9[29])|5(?:2|3(?:[045]|9(?:[0-58]|6[4-9]|7[0-35689]))|4[0-369]|5[29]|8[02389]|9[0-3])|7(?:2[02-46-9]|34|[58]|6[0249]|7[57]|9(?:[23]|4[0-59]|5[01569]|6[0167]))|8(?:2(?:[1258]|4[0-39]|9[0169])|3(?:[29]|60|7(?:[017-9]|6[6-8]))|49|51|6(?:[0-24]|36[2-57-9]|5(?:[0-389]|5[23])|6(?:[01]|9[178])|7(?:2[2-468]|3[78])|9[0145])|7[0-468]|8[68])|9(?:4[15]|5[138]|7[156]|8[189]|9(?:[1289]|3(?:31|4[357])|4[0178]))|(?:8294|96)[1-3]|2(?:57|93)[015-9]|(?:223|8699)[014-9]|(?:25[0468]|422|838)[01]|(?:48|8292|9[23])[1-9]|(?:47[59]|59[89]|8(?:68|9))[019]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3", ["[14]|[289][2-9]|5[3-9]|7[2-4679]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2-$3", ["800"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[257-9]"], "0$1"]], "0", 0, "(000[259]\\d{6})$|(?:(?:003768)0?)|0", "$1"], "KE": ["254", "000", "(?:[17]\\d\\d|900)\\d{6}|(?:2|80)0\\d{6,7}|[4-6]\\d{6,8}", [7, 8, 9, 10], [["(\\d{2})(\\d{5,7})", "$1 $2", ["[24-6]"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[17]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0"], "KG": ["996", "00", "8\\d{9}|[235-9]\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["3(?:1[346]|[24-79])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-79]|88"], "0$1"], ["(\\d{3})(\\d{3})(\\d)(\\d{2,3})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "KH": ["855", "00[14-9]", "1\\d{9}|[1-9]\\d{7,8}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "KI": ["686", "00", "(?:[37]\\d|6[0-79])\\d{6}|(?:[2-48]\\d|50)\\d{3}", [5, 8], 0, "0"], "KM": ["269", "00", "[3478]\\d{6}", [7], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[3478]"]]]], "KN": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "869$1", 0, "869"], "KP": ["850", "00|99", "85\\d{6}|(?:19\\d|[2-7])\\d{7}", [8, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-7]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"]], "0"], "KR": ["82", "00(?:[125689]|3(?:[46]5|91)|7(?:00|27|3|55|6[126]))", "00[1-9]\\d{8,11}|(?:[12]|5\\d{3})\\d{7}|[13-6]\\d{9}|(?:[1-6]\\d|80)\\d{7}|[3-6]\\d{4,5}|(?:00|7)0\\d{8}", [5, 6, 8, 9, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3,4})", "$1-$2", ["(?:3[1-3]|[46][1-4]|5[1-5])1"], "0$1"], ["(\\d{4})(\\d{4})", "$1-$2", ["1"]], ["(\\d)(\\d{3,4})(\\d{4})", "$1-$2-$3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1-$2-$3", ["[36]0|8"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1-$2-$3", ["[1346]|5[1-5]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2-$3", ["[57]"], "0$1"], ["(\\d{2})(\\d{5})(\\d{4})", "$1-$2-$3", ["5"], "0$1"]], "0", 0, "0(8(?:[1-46-8]|5\\d\\d))?"], "KW": ["965", "00", "18\\d{5}|(?:[2569]\\d|41)\\d{6}", [7, 8], [["(\\d{4})(\\d{3,4})", "$1 $2", ["[169]|2(?:[235]|4[1-35-9])|52"]], ["(\\d{3})(\\d{5})", "$1 $2", ["[245]"]]]], "KY": ["1", "011", "(?:345|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "345$1", 0, "345"], "KZ": ["7", "810", "(?:33622|8\\d{8})\\d{5}|[78]\\d{9}", [10, 14], 0, "8", 0, 0, 0, 0, "33|7", 0, "8~10"], "LA": ["856", "00", "[23]\\d{9}|3\\d{8}|(?:[235-8]\\d|41)\\d{6}", [8, 9, 10], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2[13]|3[14]|[4-8]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["30[0135-9]"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0"], "LB": ["961", "00", "[27-9]\\d{7}|[13-9]\\d{6}", [7, 8], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[13-69]|7(?:[2-57]|62|8[0-7]|9[04-9])|8[02-9]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[27-9]"]]], "0"], "LC": ["1", "011", "(?:[58]\\d\\d|758|900)\\d{7}", [10], 0, "1", 0, "([2-8]\\d{6})$|1", "758$1", 0, "758"], "LI": ["423", "00", "[68]\\d{8}|(?:[2378]\\d|90)\\d{5}", [7, 9], [["(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3", ["[2379]|8(?:0[09]|7)", "[2379]|8(?:0(?:02|9)|7)"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["69"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]]], "0", 0, "(1001)|0"], "LK": ["94", "00", "[1-9]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[1-689]"], "0$1"]], "0"], "LR": ["231", "00", "(?:[245]\\d|33|77|88)\\d{7}|(?:2\\d|[4-6])\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["4[67]|[56]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-578]"], "0$1"]], "0"], "LS": ["266", "00", "(?:[256]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2568]"]]]], "LT": ["370", "00", "(?:[3469]\\d|52|[78]0)\\d{6}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["52[0-7]"], "(0-$1)", 1], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0 $1", 1], ["(\\d{2})(\\d{6})", "$1 $2", ["37|4(?:[15]|6[1-8])"], "(0-$1)", 1], ["(\\d{3})(\\d{5})", "$1 $2", ["[3-6]"], "(0-$1)", 1]], "0", 0, "[08]"], "LU": ["352", "00", "35[013-9]\\d{4,8}|6\\d{8}|35\\d{2,4}|(?:[2457-9]\\d|3[0-46-9])\\d{2,9}", [4, 5, 6, 7, 8, 9, 10, 11], [["(\\d{2})(\\d{3})", "$1 $2", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["2(?:0[2-689]|[2-9])|[3-57]|8(?:0[2-9]|[13-9])|9(?:0[89]|[2-579])"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["20[2-689]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4", ["2(?:[0367]|4[3-8])"]], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["80[01]|90[015]"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3 $4", ["20"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})(\\d{1,2})", "$1 $2 $3 $4 $5", ["2(?:[0367]|4[3-8])"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{1,5})", "$1 $2 $3 $4", ["[3-57]|8[13-9]|9(?:0[89]|[2-579])|(?:2|80)[2-9]"]]], 0, 0, "(15(?:0[06]|1[12]|[35]5|4[04]|6[26]|77|88|99)\\d)"], "LV": ["371", "00", "(?:[268]\\d|90)\\d{6}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[269]|8[01]"]]]], "LY": ["218", "00", "[2-9]\\d{8}", [9], [["(\\d{2})(\\d{7})", "$1-$2", ["[2-9]"], "0$1"]], "0"], "MA": ["212", "00", "[5-8]\\d{8}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5[45]"], "0$1"], ["(\\d{4})(\\d{5})", "$1-$2", ["5(?:2[2-46-9]|3[3-9]|9)|8(?:0[89]|92)"], "0$1"], ["(\\d{2})(\\d{7})", "$1-$2", ["8"], "0$1"], ["(\\d{3})(\\d{6})", "$1-$2", ["[5-7]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["5(?:2(?:[0-25-79]\\d|3[1-578]|4[02-46-8]|8[0235-7])|3(?:[0-47]\\d|5[02-9]|6[02-8]|8[014-9]|9[3-9])|(?:4[067]|5[03])\\d)\\d{5}"], ["(?:6(?:[0-79]\\d|8[0-247-9])|7(?:[0167]\\d|2[0-4]|5[01]|8[0-3]))\\d{6}"], ["80[0-7]\\d{6}"], ["89\\d{7}"], 0, 0, 0, 0, ["(?:592(?:4[0-2]|93)|80[89]\\d\\d)\\d{4}"]]], "MC": ["377", "00", "(?:[3489]|6\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["4"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[389]"]], ["(\\d)(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4 $5", ["6"], "0$1"]], "0"], "MD": ["373", "00", "(?:[235-7]\\d|[89]0)\\d{6}", [8], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["22|3"], "0$1"], ["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["[25-7]"], "0$1"]], "0"], "ME": ["382", "00", "(?:20|[3-79]\\d)\\d{6}|80\\d{6,7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[2-9]"], "0$1"]], "0"], "MF": ["590", "00", "(?:590\\d|7090)\\d{5}|(?:69|80|9\\d)\\d{7}", [9], 0, "0", 0, 0, 0, 0, 0, [["590(?:0[079]|[14]3|[27][79]|3[03-7]|5[0-268]|87)\\d{4}"], ["(?:69(?:0\\d\\d|1(?:2[2-9]|3[0-5])|4(?:0[89]|1[2-6]|9\\d)|6(?:1[016-9]|5[0-4]|[67]\\d))|7090[0-4])\\d{4}"], ["80[0-5]\\d{6}"], 0, 0, 0, 0, 0, ["9(?:(?:39[5-7]|76[018])\\d|475[0-5])\\d{4}"]]], "MG": ["261", "00", "[23]\\d{8}", [9], [["(\\d{2})(\\d{2})(\\d{3})(\\d{2})", "$1 $2 $3 $4", ["[23]"], "0$1"]], "0", 0, "([24-9]\\d{6})$|0", "20$1"], "MH": ["692", "011", "329\\d{4}|(?:[256]\\d|45)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1-$2", ["[2-6]"]]], "1"], "MK": ["389", "00", "[2-578]\\d{7}", [8], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2|34[47]|4(?:[37]7|5[47]|64)"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[347]"], "0$1"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[58]"], "0$1"]], "0"], "ML": ["223", "00", "[24-9]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24-9]"]]]], "MM": ["95", "00", "1\\d{5,7}|95\\d{6}|(?:[4-7]|9[0-46-9])\\d{6,8}|(?:2|8\\d)\\d{5,8}", [6, 7, 8, 9, 10], [["(\\d)(\\d{2})(\\d{3})", "$1 $2 $3", ["16|2"], "0$1"], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["4(?:[2-46]|5[3-5])|5|6(?:[1-689]|7[235-7])|7(?:[0-4]|5[2-7])|8[1-5]|(?:60|86)[23]"], "0$1"], ["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[12]|452|678|86", "[12]|452|6788|86"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[4-7]|8[1-35]"], "0$1"], ["(\\d)(\\d{3})(\\d{4,6})", "$1 $2 $3", ["9(?:2[0-4]|[35-9]|4[137-9])"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["92"], "0$1"], ["(\\d)(\\d{5})(\\d{4})", "$1 $2 $3", ["9"], "0$1"]], "0"], "MN": ["976", "001", "[12]\\d{7,9}|[5-9]\\d{7}", [8, 9, 10], [["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["[12]1"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[5-9]"]], ["(\\d{3})(\\d{5,6})", "$1 $2", ["[12]2[1-3]"], "0$1"], ["(\\d{4})(\\d{5,6})", "$1 $2", ["[12](?:27|3[2-8]|4[2-68]|5[1-4689])", "[12](?:27|3[2-8]|4[2-68]|5[1-4689])[0-3]"], "0$1"], ["(\\d{5})(\\d{4,5})", "$1 $2", ["[12]"], "0$1"]], "0"], "MO": ["853", "00", "0800\\d{3}|(?:28|[68]\\d)\\d{6}", [7, 8], [["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[268]"]]]], "MP": ["1", "011", "[58]\\d{9}|(?:67|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "670$1", 0, "670"], "MQ": ["596", "00", "(?:596\\d|7091)\\d{5}|(?:69|[89]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-79]|8(?:0[6-9]|[36])"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "MR": ["222", "00", "(?:[2-4]\\d\\d|800)\\d{5}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-48]"]]]], "MS": ["1", "011", "(?:[58]\\d\\d|664|900)\\d{7}", [10], 0, "1", 0, "([34]\\d{6})$|1", "664$1", 0, "664"], "MT": ["356", "00", "3550\\d{4}|(?:[2579]\\d\\d|800)\\d{5}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[2357-9]"]]]], "MU": ["230", "0(?:0|[24-7]0|3[03])", "(?:[57]|8\\d\\d)\\d{7}|[2-468]\\d{6}", [7, 8, 10], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-46]|8[013]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[57]"]], ["(\\d{5})(\\d{5})", "$1 $2", ["8"]]], 0, 0, 0, 0, 0, 0, 0, "020"], "MV": ["960", "0(?:0|19)", "(?:800|9[0-57-9]\\d)\\d{7}|[34679]\\d{6}", [7, 10], [["(\\d{3})(\\d{4})", "$1-$2", ["[34679]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MW": ["265", "00", "(?:[1289]\\d|31|77)\\d{7}|1\\d{6}", [7, 9], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["1[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[137-9]"], "0$1"]], "0"], "MX": ["52", "0[09]", "[2-9]\\d{9}", [10], [["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["33|5[56]|81"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[2-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "MY": ["60", "00", "1\\d{8,9}|(?:3\\d|[4-9])\\d{7}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1-$2 $3", ["[4-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1-$2 $3", ["1(?:[02469]|[378][1-9]|53)|8", "1(?:[02469]|[37][1-9]|53|8(?:[1-46-9]|5[7-9]))|8"], "0$1"], ["(\\d)(\\d{4})(\\d{4})", "$1-$2 $3", ["3"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{4})", "$1-$2-$3-$4", ["1(?:[367]|80)"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1-$2 $3", ["15"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4})", "$1-$2 $3", ["1"], "0$1"]], "0"], "MZ": ["258", "00", "(?:2|8\\d)\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2|8[2-79]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["8"]]]], "NA": ["264", "00", "[68]\\d{7,8}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["88"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["87"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "NC": ["687", "00", "(?:050|[2-57-9]\\d\\d)\\d{3}", [6], [["(\\d{2})(\\d{2})(\\d{2})", "$1.$2.$3", ["[02-57-9]"]]]], "NE": ["227", "00", "[027-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["08"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[089]|2[013]|7[0467]"]]]], "NF": ["672", "00", "[13]\\d{5}", [6], [["(\\d{2})(\\d{4})", "$1 $2", ["1[0-3]"]], ["(\\d)(\\d{5})", "$1 $2", ["[13]"]]], 0, 0, "([0-258]\\d{4})$", "3$1"], "NG": ["234", "009", "38\\d{6}|[78]\\d{9,13}|(?:20|9\\d)\\d{8}", [8, 10, 11, 12, 13, 14], [["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["3"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[7-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["20[129]"], "0$1"], ["(\\d{4})(\\d{2})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{3})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["[78]"], "0$1"], ["(\\d{3})(\\d{5})(\\d{5,6})", "$1 $2 $3", ["[78]"], "0$1"]], "0"], "NI": ["505", "00", "(?:1800|[25-8]\\d{3})\\d{4}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[125-8]"]]]], "NL": ["31", "00", "(?:[124-7]\\d\\d|3(?:[02-9]\\d|1[0-8]))\\d{6}|8\\d{6,9}|9\\d{6,10}|1\\d{4,5}", [5, 6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{4,7})", "$1 $2", ["[89]0"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["66"], "0$1"], ["(\\d)(\\d{8})", "$1 $2", ["6"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["1[16-8]|2[259]|3[124]|4[17-9]|5[124679]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-578]|91"], "0$1"], ["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3", ["9"], "0$1"]], "0"], "NO": ["47", "00", "(?:0|[2-9]\\d{3})\\d{4}", [5, 8], [["(\\d{3})(\\d{2})(\\d{3})", "$1 $2 $3", ["8"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[2-79]"]]], 0, 0, 0, 0, 0, "[02-689]|7[0-8]"], "NP": ["977", "00", "(?:1\\d|9)\\d{9}|[1-9]\\d{7}", [8, 10, 11], [["(\\d)(\\d{7})", "$1-$2", ["1[2-6]"], "0$1"], ["(\\d{2})(\\d{6})", "$1-$2", ["1[01]|[2-8]|9(?:[1-59]|[67][2-6])"], "0$1"], ["(\\d{3})(\\d{7})", "$1-$2", ["9"]]], "0"], "NR": ["674", "00", "(?:444|(?:55|8\\d)\\d|666)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[4-68]"]]]], "NU": ["683", "00", "(?:[4-7]|888\\d)\\d{3}", [4, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["8"]]]], "NZ": ["64", "0(?:0|161)", "[1289]\\d{9}|50\\d{5}(?:\\d{2,3})?|[27-9]\\d{7,8}|(?:[34]\\d|6[0-35-9])\\d{6}|8\\d{4,6}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,8})", "$1 $2", ["8[1-79]"], "0$1"], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["50[036-8]|8|90", "50(?:[0367]|88)|8|90"], "0$1"], ["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["24|[346]|7[2-57-9]|9[2-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:10|74)|[589]"], "0$1"], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["1|2[028]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,5})", "$1 $2 $3", ["2(?:[169]|7[0-35-9])|7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "00"], "OM": ["968", "00", "(?:1505|[279]\\d{3}|500)\\d{4}|800\\d{5,6}", [7, 8, 9], [["(\\d{3})(\\d{4,6})", "$1 $2", ["[58]"]], ["(\\d{2})(\\d{6})", "$1 $2", ["2"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[179]"]]]], "PA": ["507", "00", "(?:00800|8\\d{3})\\d{6}|[68]\\d{7}|[1-57-9]\\d{6}", [7, 8, 10, 11], [["(\\d{3})(\\d{4})", "$1-$2", ["[1-57-9]"]], ["(\\d{4})(\\d{4})", "$1-$2", ["[68]"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]]], "PE": ["51", "00|19(?:1[124]|77|90)00", "(?:[14-8]|9\\d)\\d{7}", [8, 9], [["(\\d{3})(\\d{5})", "$1 $2", ["80"], "(0$1)"], ["(\\d)(\\d{7})", "$1 $2", ["1"], "(0$1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[4-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"]]], "0", 0, 0, 0, 0, 0, 0, "00", " Anexo "], "PF": ["689", "00", "4\\d{5}(?:\\d{2})?|8\\d{7,8}", [6, 8, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["44"]], ["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["4|8[7-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "PG": ["675", "00|140[1-3]", "(?:180|[78]\\d{3})\\d{4}|(?:[2-589]\\d|64)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["18|[2-69]|85"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[78]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "PH": ["63", "00", "(?:[2-7]|9\\d)\\d{8}|2\\d{5}|(?:1800|8)\\d{7,9}", [6, 8, 9, 10, 11, 12, 13], [["(\\d)(\\d{5})", "$1 $2", ["2"], "(0$1)"], ["(\\d{4})(\\d{4,6})", "$1 $2", ["3(?:23|39|46)|4(?:2[3-6]|[35]9|4[26]|76)|544|88[245]|(?:52|64|86)2", "3(?:230|397|461)|4(?:2(?:35|[46]4|51)|396|4(?:22|63)|59[347]|76[15])|5(?:221|446)|642[23]|8(?:622|8(?:[24]2|5[13]))"], "(0$1)"], ["(\\d{5})(\\d{4})", "$1 $2", ["346|4(?:27|9[35])|883", "3469|4(?:279|9(?:30|56))|8834"], "(0$1)"], ["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["2"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|8[2-8]"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]], ["(\\d{4})(\\d{1,2})(\\d{3})(\\d{4})", "$1 $2 $3 $4", ["1"]]], "0"], "PK": ["92", "00", "122\\d{6}|[24-8]\\d{10,11}|9(?:[013-9]\\d{8,10}|2(?:[01]\\d\\d|2(?:[06-8]\\d|1[01]))\\d{7})|(?:[2-8]\\d{3}|92(?:[0-7]\\d|8[1-9]))\\d{6}|[24-9]\\d{8}|[89]\\d{7}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,7})", "$1 $2 $3", ["[89]0"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["1"]], ["(\\d{3})(\\d{6,7})", "$1 $2", ["2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:2[2-8]|3[27-9]|4[2-6]|6[3569]|9[25-8])", "9(?:2[3-8]|98)|(?:2(?:3[2358]|4[2-4]|9[2-8])|45[3479]|54[2-467]|60[468]|72[236]|8(?:2[2-689]|3[23578]|4[3478]|5[2356])|9(?:22|3[27-9]|4[2-6]|6[3569]|9[25-7]))[2-9]"], "(0$1)"], ["(\\d{2})(\\d{7,8})", "$1 $2", ["(?:2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91)[2-9]"], "(0$1)"], ["(\\d{5})(\\d{5})", "$1 $2", ["58"], "(0$1)"], ["(\\d{3})(\\d{7})", "$1 $2", ["3"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["2[125]|4[0-246-9]|5[1-35-7]|6[1-8]|7[14]|8[16]|91"], "(0$1)"], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[24-9]"], "(0$1)"]], "0"], "PL": ["48", "00", "(?:6|8\\d\\d)\\d{7}|[1-9]\\d{6}(?:\\d{2})?|[26]\\d{5}", [6, 7, 8, 9, 10], [["(\\d{5})", "$1", ["19"]], ["(\\d{3})(\\d{3})", "$1 $2", ["11|20|64"]], ["(\\d{2})(\\d{2})(\\d{3})", "$1 $2 $3", ["(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])1", "(?:1[2-8]|2[2-69]|3[2-4]|4[1-468]|5[24-689]|6[1-3578]|7[14-7]|8[1-79]|9[145])19"]], ["(\\d{3})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["64"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["21|39|45|5[0137]|6[0469]|7[02389]|8(?:0[14]|8)"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["1[2-8]|[2-7]|8[1-79]|9[145]"]], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["8"]]]], "PM": ["508", "00", "[45]\\d{5}|(?:708|8\\d\\d)\\d{6}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[45]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"], "0$1"]], "0"], "PR": ["1", "011", "(?:[589]\\d\\d|787)\\d{7}", [10], 0, "1", 0, 0, 0, 0, "787|939"], "PS": ["970", "00", "[2489]2\\d{6}|(?:1\\d|5)\\d{8}", [8, 9, 10], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["[2489]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "PT": ["351", "00", "1693\\d{5}|(?:[26-9]\\d|30)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["2[12]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["16|[236-9]"]]]], "PW": ["680", "01[12]", "(?:[24-8]\\d\\d|345|900)\\d{4}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-9]"]]]], "PY": ["595", "00", "59\\d{4,6}|9\\d{5,10}|(?:[2-46-8]\\d|5[0-8])\\d{4,7}", [6, 7, 8, 9, 10, 11], [["(\\d{3})(\\d{3,6})", "$1 $2", ["[2-9]0"], "0$1"], ["(\\d{2})(\\d{5})", "$1 $2", ["[26]1|3[289]|4[1246-8]|7[1-3]|8[1-36]"], "(0$1)"], ["(\\d{3})(\\d{4,5})", "$1 $2", ["2[279]|3[13-5]|4[359]|5|6(?:[34]|7[1-46-8])|7[46-8]|85"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2[14-68]|3[26-9]|4[1246-8]|6(?:1|75)|7[1-35]|8[1-36]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["87"]], ["(\\d{3})(\\d{6})", "$1 $2", ["9(?:[5-79]|8[1-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-8]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["9"]]], "0"], "QA": ["974", "00", "800\\d{4}|(?:2|800)\\d{6}|(?:0080|[3-7])\\d{7}", [7, 8, 9, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["2[16]|8"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[3-7]"]]]], "RE": ["262", "00", "709\\d{6}|(?:26|[689]\\d)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, [["26(?:2\\d\\d|3(?:0\\d|1[0-6]))\\d{4}"], ["(?:69(?:2\\d\\d|3(?:[06][0-6]|1[013]|2[0-2]|3[0-39]|4\\d|5[0-5]|7[0-37]|8[0-8]|9[0-479]))|7092[0-3])\\d{4}"], ["80\\d{7}"], ["89[1-37-9]\\d{6}"], 0, 0, 0, 0, ["9(?:399[0-3]|479[0-5]|76(?:2[278]|3[0-37]))\\d{4}"], ["8(?:1[019]|2[0156]|84|90)\\d{6}"]]], "RO": ["40", "00", "(?:[236-8]\\d|90)\\d{7}|[23]\\d{5}", [6, 9], [["(\\d{3})(\\d{3})", "$1 $2", ["2[3-6]", "2[3-6]\\d9"], "0$1"], ["(\\d{2})(\\d{4})", "$1 $2", ["219|31"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[23]1"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[236-9]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, " int "], "RS": ["381", "00", "38[02-9]\\d{6,9}|6\\d{7,9}|90\\d{4,8}|38\\d{5,6}|(?:7\\d\\d|800)\\d{3,9}|(?:[12]\\d|3[0-79])\\d{5,10}", [6, 7, 8, 9, 10, 11, 12], [["(\\d{3})(\\d{3,9})", "$1 $2", ["(?:2[389]|39)0|[7-9]"], "0$1"], ["(\\d{2})(\\d{5,10})", "$1 $2", ["[1-36]"], "0$1"]], "0"], "RU": ["7", "810", "8\\d{13}|[347-9]\\d{9}", [10, 14], [["(\\d{4})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-8]|2[1-9])", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:1[23]|[2-9]2))", "7(?:1(?:[0-356]2|4[29]|7|8[27])|2(?:13[03-69]|62[013-9]))|72[1-57-9]2"], "8 ($1)", 1], ["(\\d{5})(\\d)(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["7(?:1[0-68]|2[1-9])", "7(?:1(?:[06][3-6]|[18]|2[35]|[3-5][3-5])|2(?:[13][3-5]|[24-689]|7[457]))", "7(?:1(?:0(?:[356]|4[023])|[18]|2(?:3[013-9]|5)|3[45]|43[013-79]|5(?:3[1-8]|4[1-7]|5)|6(?:3[0-35-9]|[4-6]))|2(?:1(?:3[178]|[45])|[24-689]|3[35]|7[457]))|7(?:14|23)4[0-8]|71(?:33|45)[1-79]"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "8 ($1)", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[349]|8(?:[02-7]|1[1-8])"], "8 ($1)", 1], ["(\\d{4})(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["8"], "8 ($1)"]], "8", 0, 0, 0, 0, "3[04-689]|[489]", 0, "8~10"], "RW": ["250", "00", "(?:06|[27]\\d\\d|[89]00)\\d{6}", [8, 9], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[7-9]"], "0$1"]], "0"], "SA": ["966", "00", "92\\d{7}|(?:[15]|8\\d)\\d{8}", [9, 10], [["(\\d{4})(\\d{5})", "$1 $2", ["9"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["5"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["81"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]]], "0"], "SB": ["677", "0[01]", "[6-9]\\d{6}|[1-6]\\d{4}", [5, 7], [["(\\d{2})(\\d{5})", "$1 $2", ["6[89]|7|8[4-9]|9(?:[1-8]|9[0-8])"]]]], "SC": ["248", "010|0[0-2]", "(?:[2489]\\d|64)\\d{5}", [7], [["(\\d)(\\d{3})(\\d{3})", "$1 $2 $3", ["[246]|9[57]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "SD": ["249", "00", "[19]\\d{8}", [9], [["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "SE": ["46", "00", "(?:[26]\\d\\d|9)\\d{9}|[1-9]\\d{8}|[1-689]\\d{7}|[1-4689]\\d{6}|2\\d{5}", [6, 7, 8, 9, 10, 12], [["(\\d{2})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["20"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{4})", "$1-$2", ["9(?:00|39|44|9)"], "0$1", 0, "$1 $2"], ["(\\d{2})(\\d{3})(\\d{2})", "$1-$2 $3", ["[12][136]|3[356]|4[0246]|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3"], ["(\\d)(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2,3})(\\d{2})", "$1-$2 $3", ["1[2457]|2(?:[247-9]|5[0138])|3[0247-9]|4[1357-9]|5[0-35-9]|6(?:[125689]|4[02-57]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3"], ["(\\d{3})(\\d{2,3})(\\d{3})", "$1-$2 $3", ["9(?:00|39|44)"], "0$1", 0, "$1 $2 $3"], ["(\\d{2})(\\d{2,3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["1[13689]|2[0136]|3[1356]|4[0246]|54|6[03]|90[1-9]"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["10|7"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1-$2 $3 $4", ["8"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1-$2 $3 $4", ["[13-5]|2(?:[247-9]|5[0138])|6(?:[124-689]|7[0-2])|9(?:[125-8]|3[02-5]|4[0-3])"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{2})(\\d{3})", "$1-$2 $3 $4", ["9"], "0$1", 0, "$1 $2 $3 $4"], ["(\\d{3})(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1-$2 $3 $4 $5", ["[26]"], "0$1", 0, "$1 $2 $3 $4 $5"]], "0"], "SG": ["65", "0[0-3]\\d", "(?:(?:1\\d|8)\\d\\d|7000)\\d{7}|[3689]\\d{7}", [8, 10, 11], [["(\\d{4})(\\d{4})", "$1 $2", ["[369]|8(?:0[1-9]|[1-9])"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"]], ["(\\d{4})(\\d{4})(\\d{3})", "$1 $2 $3", ["7"]], ["(\\d{4})(\\d{3})(\\d{4})", "$1 $2 $3", ["1"]]]], "SH": ["290", "00", "(?:[256]\\d|8)\\d{3}", [4, 5], 0, 0, 0, 0, 0, 0, "[256]"], "SI": ["386", "00|10(?:22|66|88|99)", "[1-7]\\d{7}|8\\d{4,7}|90\\d{4,6}", [5, 6, 7, 8], [["(\\d{2})(\\d{3,6})", "$1 $2", ["8[09]|9"], "0$1"], ["(\\d{3})(\\d{5})", "$1 $2", ["59|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[37][01]|4[0139]|51|6"], "0$1"], ["(\\d)(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[1-57]"], "(0$1)"]], "0", 0, 0, 0, 0, 0, 0, "00"], "SJ": ["47", "00", "0\\d{4}|(?:[489]\\d|79)\\d{6}", [5, 8], 0, 0, 0, 0, 0, 0, "79"], "SK": ["421", "00", "[2-689]\\d{8}|[2-59]\\d{6}|[2-5]\\d{5}", [6, 7, 9], [["(\\d)(\\d{2})(\\d{3,4})", "$1 $2 $3", ["21"], "0$1"], ["(\\d{2})(\\d{2})(\\d{2,3})", "$1 $2 $3", ["[3-5][1-8]1", "[3-5][1-8]1[67]"], "0$1"], ["(\\d)(\\d{3})(\\d{3})(\\d{2})", "$1/$2 $3 $4", ["2"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[689]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1/$2 $3 $4", ["[3-5]"], "0$1"]], "0"], "SL": ["232", "00", "(?:[237-9]\\d|66)\\d{6}", [8], [["(\\d{2})(\\d{6})", "$1 $2", ["[236-9]"], "(0$1)"]], "0"], "SM": ["378", "00", "(?:0549|[5-7]\\d)\\d{6}", [8, 10], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[5-7]"]], ["(\\d{4})(\\d{6})", "$1 $2", ["0"]]], 0, 0, "([89]\\d{5})$", "0549$1"], "SN": ["221", "00", "(?:[378]\\d|93)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[379]"]]]], "SO": ["252", "00", "[346-9]\\d{8}|[12679]\\d{7}|[1-5]\\d{6}|[1348]\\d{5}", [6, 7, 8, 9], [["(\\d{2})(\\d{4})", "$1 $2", ["8[125]"]], ["(\\d{6})", "$1", ["[134]"]], ["(\\d)(\\d{6})", "$1 $2", ["[15]|2[0-79]|3[0-46-8]|4[0-7]"]], ["(\\d)(\\d{7})", "$1 $2", ["(?:2|90)4|[67]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[348]|64|79|90"]], ["(\\d{2})(\\d{5,7})", "$1 $2", ["1|28|6[0-35-9]|77|9[2-9]"]]], "0"], "SR": ["597", "00", "(?:[2-5]|68|[78]\\d)\\d{5}", [6, 7], [["(\\d{2})(\\d{2})(\\d{2})", "$1-$2-$3", ["56"]], ["(\\d{3})(\\d{3})", "$1-$2", ["[2-5]"]], ["(\\d{3})(\\d{4})", "$1-$2", ["[6-8]"]]]], "SS": ["211", "00", "[19]\\d{8}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[19]"], "0$1"]], "0"], "ST": ["239", "00", "(?:22|9\\d)\\d{5}", [7], [["(\\d{3})(\\d{4})", "$1 $2", ["[29]"]]]], "SV": ["503", "00", "[267]\\d{7}|(?:80\\d|900)\\d{4}(?:\\d{4})?", [7, 8, 11], [["(\\d{3})(\\d{4})", "$1 $2", ["[89]"]], ["(\\d{4})(\\d{4})", "$1 $2", ["[267]"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["[89]"]]]], "SX": ["1", "011", "7215\\d{6}|(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "(5\\d{6})$|1", "721$1", 0, "721"], "SY": ["963", "00", "[1-359]\\d{8}|[1-5]\\d{7}", [8, 9], [["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-4]|5[1-3]"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[59]"], "0$1", 1]], "0"], "SZ": ["268", "00", "0800\\d{4}|(?:[237]\\d|900)\\d{6}", [8, 9], [["(\\d{4})(\\d{4})", "$1 $2", ["[0237]"]], ["(\\d{5})(\\d{4})", "$1 $2", ["9"]]]], "TA": ["290", "00", "8\\d{3}", [4], 0, 0, 0, 0, 0, 0, "8"], "TC": ["1", "011", "(?:[58]\\d\\d|649|900)\\d{7}", [10], 0, "1", 0, "([2-479]\\d{6})$|1", "649$1", 0, "649"], "TD": ["235", "00|16", "(?:22|[689]\\d|77)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[26-9]"]]], 0, 0, 0, 0, 0, 0, 0, "00"], "TG": ["228", "00", "[279]\\d{7}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[279]"]]]], "TH": ["66", "00[1-9]", "(?:001800|[2-57]|[689]\\d)\\d{7}|1\\d{7,9}", [8, 9, 10, 13], [["(\\d)(\\d{3})(\\d{4})", "$1 $2 $3", ["2"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[13-9]"], "0$1"], ["(\\d{4})(\\d{3})(\\d{3})", "$1 $2 $3", ["1"]]], "0"], "TJ": ["992", "810", "[0-57-9]\\d{8}", [9], [["(\\d{6})(\\d)(\\d{2})", "$1 $2 $3", ["331", "3317"]], ["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["44[02-479]|[34]7"]], ["(\\d{4})(\\d)(\\d{4})", "$1 $2 $3", ["3(?:[1245]|3[12])"]], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[0-57-9]"]]], 0, 0, 0, 0, 0, 0, 0, "8~10"], "TK": ["690", "00", "[2-47]\\d{3,6}", [4, 5, 6, 7]], "TL": ["670", "00", "7\\d{7}|(?:[2-47]\\d|[89]0)\\d{5}", [7, 8], [["(\\d{3})(\\d{4})", "$1 $2", ["[2-489]|70"]], ["(\\d{4})(\\d{4})", "$1 $2", ["7"]]]], "TM": ["993", "810", "(?:[1-6]\\d|71)\\d{6}", [8], [["(\\d{2})(\\d{2})(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["12"], "(8 $1)"], ["(\\d{3})(\\d)(\\d{2})(\\d{2})", "$1 $2-$3-$4", ["[1-5]"], "(8 $1)"], ["(\\d{2})(\\d{6})", "$1 $2", ["[67]"], "8 $1"]], "8", 0, 0, 0, 0, 0, 0, "8~10"], "TN": ["216", "00", "[2-57-9]\\d{7}", [8], [["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-57-9]"]]]], "TO": ["676", "00", "(?:0800|(?:[5-8]\\d\\d|999)\\d)\\d{3}|[2-8]\\d{4}", [5, 7], [["(\\d{2})(\\d{3})", "$1-$2", ["[2-4]|50|6[09]|7[0-24-69]|8[05]"]], ["(\\d{4})(\\d{3})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[5-9]"]]]], "TR": ["90", "00", "4\\d{6}|8\\d{11,12}|(?:[2-58]\\d\\d|900)\\d{7}", [7, 10, 12, 13], [["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["512|8[01589]|90"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["5(?:[0-59]|61)", "5(?:[0-59]|61[06])", "5(?:[0-59]|61[06]1)"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[24][1-8]|3[1-9]"], "(0$1)", 1], ["(\\d{3})(\\d{3})(\\d{6,7})", "$1 $2 $3", ["80"], "0$1", 1]], "0"], "TT": ["1", "011", "(?:[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-46-8]\\d{6})$|1", "868$1", 0, "868"], "TV": ["688", "00", "(?:2|7\\d\\d|90)\\d{4}", [5, 6, 7], [["(\\d{2})(\\d{3})", "$1 $2", ["2"]], ["(\\d{2})(\\d{4})", "$1 $2", ["90"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "TW": ["886", "0(?:0[25-79]|19)", "[2-689]\\d{8}|7\\d{9,10}|[2-8]\\d{7}|2\\d{6}", [7, 8, 9, 10, 11], [["(\\d{2})(\\d)(\\d{4})", "$1 $2 $3", ["202"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[258]0"], "0$1"], ["(\\d)(\\d{3,4})(\\d{4})", "$1 $2 $3", ["[23568]|4(?:0[02-48]|[1-47-9])|7[1-9]", "[23568]|4(?:0[2-48]|[1-47-9])|(?:400|7)[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{2})(\\d{4})(\\d{4,5})", "$1 $2 $3", ["7"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, 0, "#"], "TZ": ["255", "00[056]", "(?:[25-8]\\d|41|90)\\d{7}", [9], [["(\\d{3})(\\d{2})(\\d{4})", "$1 $2 $3", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[24]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["5"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[67]"], "0$1"]], "0"], "UA": ["380", "00", "[89]\\d{9}|[3-9]\\d{8}", [9, 10], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["6[12][29]|(?:3[1-8]|4[136-8]|5[12457]|6[49])2|(?:56|65)[24]", "6[12][29]|(?:35|4[1378]|5[12457]|6[49])2|(?:56|65)[24]|(?:3[1-46-8]|46)2[013-9]"], "0$1"], ["(\\d{4})(\\d{5})", "$1 $2", ["3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6[0135689]|7[4-6])|6(?:[12][3-7]|[459])", "3[1-8]|4(?:[1367]|[45][6-9]|8[4-6])|5(?:[1-5]|6(?:[015689]|3[02389])|7[4-6])|6(?:[12][3-7]|[459])"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[3-7]|89|9[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[89]"], "0$1"]], "0", 0, 0, 0, 0, 0, 0, "0~0"], "UG": ["256", "00[057]", "800\\d{6}|(?:[29]0|[347]\\d)\\d{7}", [9], [["(\\d{4})(\\d{5})", "$1 $2", ["202", "2024"], "0$1"], ["(\\d{3})(\\d{6})", "$1 $2", ["[27-9]|4(?:6[45]|[7-9])"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[34]"], "0$1"]], "0"], "US": ["1", "011", "[2-9]\\d{9}|3\\d{6}", [10], [["(\\d{3})(\\d{4})", "$1-$2", ["310"], 0, 1], ["(\\d{3})(\\d{3})(\\d{4})", "($1) $2-$3", ["[2-9]"], 0, 1, "$1-$2-$3"]], "1", 0, 0, 0, 0, 0, [["(?:3052(?:0[0-8]|[1-9]\\d)|5056(?:[0-35-9]\\d|4[468])|7302[0-4]\\d)\\d{4}|(?:305[3-9]|472[24]|505[2-57-9]|7306|983[2-47-9])\\d{6}|(?:2(?:0[1-35-9]|1[02-9]|2[03-57-9]|3[1459]|4[08]|5[1-46]|6[0279]|7[0269]|8[13])|3(?:0[1-47-9]|1[02-9]|2[0135-79]|3[0-24679]|4[167]|5[0-2]|6[01349]|8[056])|4(?:0[124-9]|1[02-579]|2[3-5]|3[0245]|4[023578]|58|6[349]|7[0589]|8[04])|5(?:0[1-47-9]|1[0235-8]|20|3[0149]|4[01]|5[179]|6[1-47]|7[0-5]|8[0256])|6(?:0[1-35-9]|1[024-9]|2[03689]|3[016]|4[0156]|5[01679]|6[0-279]|78|8[0-29])|7(?:0[1-46-8]|1[2-9]|2[04-8]|3[1247]|4[037]|5[47]|6[02359]|7[0-59]|8[156])|8(?:0[1-68]|1[02-8]|2[068]|3[0-2589]|4[03578]|5[046-9]|6[02-5]|7[028])|9(?:0[1346-9]|1[02-9]|2[0589]|3[0146-8]|4[01357-9]|5[12469]|7[0-389]|8[04-69]))[2-9]\\d{6}"], [""], ["8(?:00|33|44|55|66|77|88)[2-9]\\d{6}"], ["900[2-9]\\d{6}"], ["52(?:3(?:[2-46-9][02-9]\\d|5(?:[02-46-9]\\d|5[0-46-9]))|4(?:[2-478][02-9]\\d|5(?:[034]\\d|2[024-9]|5[0-46-9])|6(?:0[1-9]|[2-9]\\d)|9(?:[05-9]\\d|2[0-5]|49)))\\d{4}|52[34][2-9]1[02-9]\\d{4}|5(?:00|2[125-9]|33|44|66|77|88)[2-9]\\d{6}"], 0, 0, 0, ["305209\\d{4}"]]], "UY": ["598", "0(?:0|1[3-9]\\d)", "0004\\d{2,9}|[1249]\\d{7}|(?:[49]\\d|80)\\d{5}", [6, 7, 8, 9, 10, 11, 12, 13], [["(\\d{3})(\\d{3,4})", "$1 $2", ["0"]], ["(\\d{3})(\\d{4})", "$1 $2", ["[49]0|8"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["9"], "0$1"], ["(\\d{4})(\\d{4})", "$1 $2", ["[124]"]], ["(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3", ["0"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{2,4})", "$1 $2 $3 $4", ["0"]]], "0", 0, 0, 0, 0, 0, 0, "00", " int. "], "UZ": ["998", "00", "(?:20|33|[5-79]\\d|88)\\d{7}", [9], [["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["[235-9]"]]]], "VA": ["39", "00", "0\\d{5,10}|3[0-8]\\d{7,10}|55\\d{8}|8\\d{5}(?:\\d{2,4})?|(?:1\\d|39)\\d{7,8}", [6, 7, 8, 9, 10, 11, 12], 0, 0, 0, 0, 0, 0, "06698"], "VC": ["1", "011", "(?:[58]\\d\\d|784|900)\\d{7}", [10], 0, "1", 0, "([2-7]\\d{6})$|1", "784$1", 0, "784"], "VE": ["58", "00", "[68]00\\d{7}|(?:[24]\\d|[59]0)\\d{8}", [10], [["(\\d{3})(\\d{7})", "$1-$2", ["[24-689]"], "0$1"]], "0"], "VG": ["1", "011", "(?:284|[58]\\d\\d|900)\\d{7}", [10], 0, "1", 0, "([2-578]\\d{6})$|1", "284$1", 0, "284"], "VI": ["1", "011", "[58]\\d{9}|(?:34|90)0\\d{7}", [10], 0, "1", 0, "([2-9]\\d{6})$|1", "340$1", 0, "340"], "VN": ["84", "00", "[12]\\d{9}|[135-9]\\d{8}|[16]\\d{7}|[16-8]\\d{6}", [7, 8, 9, 10], [["(\\d{2})(\\d{5})", "$1 $2", ["80"], "0$1", 1], ["(\\d{4})(\\d{4,6})", "$1 $2", ["1"], 0, 1], ["(\\d{2})(\\d{3})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["6"], "0$1", 1], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[357-9]"], "0$1", 1], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["2[48]"], "0$1", 1], ["(\\d{3})(\\d{4})(\\d{3})", "$1 $2 $3", ["2"], "0$1", 1]], "0"], "VU": ["678", "00", "[57-9]\\d{6}|(?:[238]\\d|48)\\d{3}", [5, 7], [["(\\d{3})(\\d{4})", "$1 $2", ["[57-9]"]]]], "WF": ["681", "00", "(?:40|72|8\\d{4})\\d{4}|[89]\\d{5}", [6, 9], [["(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3", ["[47-9]"]], ["(\\d{3})(\\d{2})(\\d{2})(\\d{2})", "$1 $2 $3 $4", ["8"]]]], "WS": ["685", "0", "(?:[2-6]|8\\d{5})\\d{4}|[78]\\d{6}|[68]\\d{5}", [5, 6, 7, 10], [["(\\d{5})", "$1", ["[2-5]|6[1-9]"]], ["(\\d{3})(\\d{3,7})", "$1 $2", ["[68]"]], ["(\\d{2})(\\d{5})", "$1 $2", ["7"]]]], "XK": ["383", "00", "2\\d{7,8}|3\\d{7,11}|(?:4\\d\\d|[89]00)\\d{5}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{5})", "$1 $2", ["[89]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3})", "$1 $2 $3", ["[2-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["2|39"], "0$1"], ["(\\d{2})(\\d{7,10})", "$1 $2", ["3"], "0$1"]], "0"], "YE": ["967", "00", "(?:1|7\\d)\\d{7}|[1-7]\\d{6}", [7, 8, 9], [["(\\d)(\\d{3})(\\d{3,4})", "$1 $2 $3", ["[1-6]|7(?:[24-6]|8[0-7])"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["7"], "0$1"]], "0"], "YT": ["262", "00", "7093\\d{5}|(?:80|9\\d)\\d{7}|(?:26|63)9\\d{6}", [9], 0, "0", 0, 0, 0, 0, 0, [["269(?:0[0-467]|15|5[0-4]|6\\d|[78]0)\\d{4}"], ["(?:639(?:0[0-79]|1[019]|[267]\\d|3[09]|40|5[05-9]|9[04-79])|7093[5-7])\\d{4}"], ["80\\d{7}"], 0, 0, 0, 0, 0, ["9(?:(?:39|47)8[01]|769\\d)\\d{4}"]]], "ZA": ["27", "00", "[1-79]\\d{8}|8\\d{4,9}", [5, 6, 7, 8, 9, 10], [["(\\d{2})(\\d{3,4})", "$1 $2", ["8[1-4]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{2,3})", "$1 $2 $3", ["8[1-4]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["860"], "0$1"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["[1-9]"], "0$1"], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["8"], "0$1"]], "0"], "ZM": ["260", "00", "800\\d{6}|(?:21|63|[79]\\d)\\d{7}", [9], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[28]"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["[79]"], "0$1"]], "0"], "ZW": ["263", "00", "2(?:[0-57-9]\\d{6,8}|6[0-24-9]\\d{6,7})|[38]\\d{9}|[35-8]\\d{8}|[3-6]\\d{7}|[1-689]\\d{6}|[1-3569]\\d{5}|[1356]\\d{4}", [5, 6, 7, 8, 9, 10], [["(\\d{3})(\\d{3,5})", "$1 $2", ["2(?:0[45]|2[278]|[49]8)|3(?:[09]8|17)|6(?:[29]8|37|75)|[23][78]|(?:33|5[15]|6[68])[78]"], "0$1"], ["(\\d)(\\d{3})(\\d{2,4})", "$1 $2 $3", ["[49]"], "0$1"], ["(\\d{3})(\\d{4})", "$1 $2", ["80"], "0$1"], ["(\\d{2})(\\d{7})", "$1 $2", ["24|8[13-59]|(?:2[05-79]|39|5[45]|6[15-8])2", "2(?:02[014]|4|[56]20|[79]2)|392|5(?:42|525)|6(?:[16-8]21|52[013])|8[13-59]"], "(0$1)"], ["(\\d{2})(\\d{3})(\\d{4})", "$1 $2 $3", ["7"], "0$1"], ["(\\d{3})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["2(?:1[39]|2[0157]|[378]|[56][14])|3(?:12|29)", "2(?:1[39]|2[0157]|[378]|[56][14])|3(?:123|29)"], "0$1"], ["(\\d{4})(\\d{6})", "$1 $2", ["8"], "0$1"], ["(\\d{2})(\\d{3,5})", "$1 $2", ["1|2(?:0[0-36-9]|12|29|[56])|3(?:1[0-689]|[24-6])|5(?:[0236-9]|1[2-4])|6(?:[013-59]|7[0-46-9])|(?:33|55|6[68])[0-69]|(?:29|3[09]|62)[0-79]"], "0$1"], ["(\\d{2})(\\d{3})(\\d{3,4})", "$1 $2 $3", ["29[013-9]|39|54"], "0$1"], ["(\\d{4})(\\d{3,5})", "$1 $2", ["(?:25|54)8", "258|5483"], "0$1"]], "0"] }, "nonGeographic": { "800": ["800", 0, "(?:00|[1-9]\\d)\\d{6}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["\\d"]]], 0, 0, 0, 0, 0, 0, [0, 0, ["(?:00|[1-9]\\d)\\d{6}"]]], "808": ["808", 0, "[1-9]\\d{7}", [8], [["(\\d{4})(\\d{4})", "$1 $2", ["[1-9]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, 0, ["[1-9]\\d{7}"]]], "870": ["870", 0, "7\\d{11}|[235-7]\\d{8}", [9, 12], [["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["[235-7]"]]], 0, 0, 0, 0, 0, 0, [0, ["(?:[356]|774[45])\\d{8}|7[6-8]\\d{7}"], 0, 0, 0, 0, 0, 0, ["2\\d{8}", [9]]]], "878": ["878", 0, "10\\d{10}", [12], [["(\\d{2})(\\d{5})(\\d{5})", "$1 $2 $3", ["1"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["10\\d{10}"]]], "881": ["881", 0, "6\\d{9}|[0-36-9]\\d{8}", [9, 10], [["(\\d)(\\d{3})(\\d{5})", "$1 $2 $3", ["[0-37-9]"]], ["(\\d)(\\d{3})(\\d{5,6})", "$1 $2 $3", ["6"]]], 0, 0, 0, 0, 0, 0, [0, ["6\\d{9}|[0-36-9]\\d{8}"]]], "882": ["882", 0, "[13]\\d{6}(?:\\d{2,5})?|[19]\\d{7}|(?:[25]\\d\\d|4)\\d{7}(?:\\d{2})?", [7, 8, 9, 10, 11, 12], [["(\\d{2})(\\d{5})", "$1 $2", ["16|342"]], ["(\\d{2})(\\d{6})", "$1 $2", ["49"]], ["(\\d{2})(\\d{2})(\\d{4})", "$1 $2 $3", ["1[36]|9"]], ["(\\d{2})(\\d{4})(\\d{3})", "$1 $2 $3", ["3[23]"]], ["(\\d{2})(\\d{3,4})(\\d{4})", "$1 $2 $3", ["16"]], ["(\\d{2})(\\d{4})(\\d{4})", "$1 $2 $3", ["10|23|3(?:[15]|4[57])|4|51"]], ["(\\d{3})(\\d{4})(\\d{4})", "$1 $2 $3", ["34"]], ["(\\d{2})(\\d{4,5})(\\d{5})", "$1 $2 $3", ["[1-35]"]]], 0, 0, 0, 0, 0, 0, [0, ["342\\d{4}|(?:337|49)\\d{6}|(?:3(?:2|47|7\\d{3})|50\\d{3})\\d{7}", [7, 8, 9, 10, 12]], 0, 0, 0, ["348[57]\\d{7}", [11]], 0, 0, ["1(?:3(?:0[0347]|[13][0139]|2[035]|4[013568]|6[0459]|7[06]|8[15-8]|9[0689])\\d{4}|6\\d{5,10})|(?:345\\d|9[89])\\d{6}|(?:10|2(?:3|85\\d)|3(?:[15]|[69]\\d\\d)|4[15-8]|51)\\d{8}"]]], "883": ["883", 0, "(?:[1-4]\\d|51)\\d{6,10}", [8, 9, 10, 11, 12], [["(\\d{3})(\\d{3})(\\d{2,8})", "$1 $2 $3", ["[14]|2[24-689]|3[02-689]|51[24-9]"]], ["(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3", ["510"]], ["(\\d{3})(\\d{3})(\\d{4})", "$1 $2 $3", ["21"]], ["(\\d{4})(\\d{4})(\\d{4})", "$1 $2 $3", ["51[13]"]], ["(\\d{3})(\\d{3})(\\d{3})(\\d{3})", "$1 $2 $3 $4", ["[235]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, 0, 0, ["(?:2(?:00\\d\\d|10)|(?:370[1-9]|51\\d0)\\d)\\d{7}|51(?:00\\d{5}|[24-9]0\\d{4,7})|(?:1[0-79]|2[24-689]|3[02-689]|4[0-4])0\\d{5,9}"]]], "888": ["888", 0, "\\d{11}", [11], [["(\\d{3})(\\d{3})(\\d{5})", "$1 $2 $3"]], 0, 0, 0, 0, 0, 0, [0, 0, 0, 0, 0, 0, ["\\d{11}"]]], "979": ["979", 0, "[1359]\\d{8}", [9], [["(\\d)(\\d{4})(\\d{4})", "$1 $2 $3", ["[1359]"]]], 0, 0, 0, 0, 0, 0, [0, 0, 0, ["[1359]\\d{8}"]]] } };
function withMetadataArgument(func, _arguments) {
  var args = Array.prototype.slice.call(_arguments);
  args.push(metadata);
  return func.apply(this, args);
}
function _typeof$1(obj) {
  "@babel/helpers - typeof";
  return _typeof$1 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof$1(obj);
}
function _createClass$2(Constructor, protoProps, staticProps) {
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
function _classCallCheck$2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } });
  Object.defineProperty(subClass, "prototype", { writable: false });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result2;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result2 = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result2 = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result2);
  };
}
function _possibleConstructorReturn(self2, call) {
  if (call && (_typeof$1(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2)) return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2)) return _cache.get(Class2);
      _cache.set(Class2, Wrapper);
    }
    function Wrapper() {
      return _construct(Class2, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class2.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } });
    return _setPrototypeOf(Wrapper, Class2);
  };
  return _wrapNativeSuper(Class);
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2) _setPrototypeOf(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _isNativeFunction(fn2) {
  return Function.toString.call(fn2).indexOf("[native code]") !== -1;
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf2(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf2(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}
var ParseError = /* @__PURE__ */ function(_Error) {
  _inherits(ParseError2, _Error);
  var _super = _createSuper(ParseError2);
  function ParseError2(code) {
    var _this;
    _classCallCheck$2(this, ParseError2);
    _this = _super.call(this, code);
    Object.setPrototypeOf(_assertThisInitialized(_this), ParseError2.prototype);
    _this.name = _this.constructor.name;
    return _this;
  }
  return _createClass$2(ParseError2);
}(/* @__PURE__ */ _wrapNativeSuper(Error));
var MIN_LENGTH_FOR_NSN = 2;
var MAX_LENGTH_FOR_NSN = 17;
var MAX_LENGTH_COUNTRY_CODE = 3;
var VALID_DIGITS = "0-9０-９٠-٩۰-۹";
var DASHES = "-‐-―−ー－";
var SLASHES = "／/";
var DOTS = "．.";
var WHITESPACE = "  ­​⁠　";
var BRACKETS = "()（）［］\\[\\]";
var TILDES = "~⁓∼～";
var VALID_PUNCTUATION = "".concat(DASHES).concat(SLASHES).concat(DOTS).concat(WHITESPACE).concat(BRACKETS).concat(TILDES);
var PLUS_CHARS = "+＋";
function compare(a, b2) {
  a = a.split("-");
  b2 = b2.split("-");
  var pa = a[0].split(".");
  var pb = b2[0].split(".");
  for (var i = 0; i < 3; i++) {
    var na = Number(pa[i]);
    var nb = Number(pb[i]);
    if (na > nb) return 1;
    if (nb > na) return -1;
    if (!isNaN(na) && isNaN(nb)) return 1;
    if (isNaN(na) && !isNaN(nb)) return -1;
  }
  if (a[1] && b2[1]) {
    return a[1] > b2[1] ? 1 : a[1] < b2[1] ? -1 : 0;
  }
  return !a[1] && b2[1] ? 1 : a[1] && !b2[1] ? -1 : 0;
}
var objectConstructor = {}.constructor;
function isObject(object2) {
  return object2 !== void 0 && object2 !== null && object2.constructor === objectConstructor;
}
function _typeof(obj) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj2) {
    return typeof obj2;
  } : function(obj2) {
    return obj2 && "function" == typeof Symbol && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
  }, _typeof(obj);
}
function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties$1(target, props2) {
  for (var i = 0; i < props2.length; i++) {
    var descriptor = props2[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var V3 = "1.2.0";
var V4 = "1.7.35";
var DEFAULT_EXT_PREFIX = " ext. ";
var CALLING_CODE_REG_EXP = /^\d+$/;
var Metadata = /* @__PURE__ */ function() {
  function Metadata2(metadata2) {
    _classCallCheck$1(this, Metadata2);
    validateMetadata(metadata2);
    this.metadata = metadata2;
    setVersion.call(this, metadata2);
  }
  _createClass$1(Metadata2, [{
    key: "getCountries",
    value: function getCountries() {
      return Object.keys(this.metadata.countries).filter(function(_2) {
        return _2 !== "001";
      });
    }
  }, {
    key: "getCountryMetadata",
    value: function getCountryMetadata(countryCode) {
      return this.metadata.countries[countryCode];
    }
  }, {
    key: "nonGeographic",
    value: function nonGeographic() {
      if (this.v1 || this.v2 || this.v3) return;
      return this.metadata.nonGeographic || this.metadata.nonGeographical;
    }
  }, {
    key: "hasCountry",
    value: function hasCountry(country) {
      return this.getCountryMetadata(country) !== void 0;
    }
  }, {
    key: "hasCallingCode",
    value: function hasCallingCode(callingCode) {
      if (this.getCountryCodesForCallingCode(callingCode)) {
        return true;
      }
      if (this.nonGeographic()) {
        if (this.nonGeographic()[callingCode]) {
          return true;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return true;
        }
      }
    }
  }, {
    key: "isNonGeographicCallingCode",
    value: function isNonGeographicCallingCode(callingCode) {
      if (this.nonGeographic()) {
        return this.nonGeographic()[callingCode] ? true : false;
      } else {
        return this.getCountryCodesForCallingCode(callingCode) ? false : true;
      }
    }
    // Deprecated.
  }, {
    key: "country",
    value: function country(countryCode) {
      return this.selectNumberingPlan(countryCode);
    }
  }, {
    key: "selectNumberingPlan",
    value: function selectNumberingPlan(countryCode, callingCode) {
      if (countryCode && CALLING_CODE_REG_EXP.test(countryCode)) {
        callingCode = countryCode;
        countryCode = null;
      }
      if (countryCode && countryCode !== "001") {
        if (!this.hasCountry(countryCode)) {
          throw new Error("Unknown country: ".concat(countryCode));
        }
        this.numberingPlan = new NumberingPlan(this.getCountryMetadata(countryCode), this);
      } else if (callingCode) {
        if (!this.hasCallingCode(callingCode)) {
          throw new Error("Unknown calling code: ".concat(callingCode));
        }
        this.numberingPlan = new NumberingPlan(this.getNumberingPlanMetadata(callingCode), this);
      } else {
        this.numberingPlan = void 0;
      }
      return this;
    }
  }, {
    key: "getCountryCodesForCallingCode",
    value: function getCountryCodesForCallingCode(callingCode) {
      var countryCodes = this.countryCallingCodes()[callingCode];
      if (countryCodes) {
        if (countryCodes.length === 1 && countryCodes[0].length === 3) {
          return;
        }
        return countryCodes;
      }
    }
  }, {
    key: "getCountryCodeForCallingCode",
    value: function getCountryCodeForCallingCode(callingCode) {
      var countryCodes = this.getCountryCodesForCallingCode(callingCode);
      if (countryCodes) {
        return countryCodes[0];
      }
    }
  }, {
    key: "getNumberingPlanMetadata",
    value: function getNumberingPlanMetadata(callingCode) {
      var countryCode = this.getCountryCodeForCallingCode(callingCode);
      if (countryCode) {
        return this.getCountryMetadata(countryCode);
      }
      if (this.nonGeographic()) {
        var metadata2 = this.nonGeographic()[callingCode];
        if (metadata2) {
          return metadata2;
        }
      } else {
        var countryCodes = this.countryCallingCodes()[callingCode];
        if (countryCodes && countryCodes.length === 1 && countryCodes[0] === "001") {
          return this.metadata.countries["001"];
        }
      }
    }
    // Deprecated.
  }, {
    key: "countryCallingCode",
    value: function countryCallingCode() {
      return this.numberingPlan.callingCode();
    }
    // Deprecated.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      return this.numberingPlan.IDDPrefix();
    }
    // Deprecated.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      return this.numberingPlan.defaultIDDPrefix();
    }
    // Deprecated.
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      return this.numberingPlan.nationalNumberPattern();
    }
    // Deprecated.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      return this.numberingPlan.possibleLengths();
    }
    // Deprecated.
  }, {
    key: "formats",
    value: function formats() {
      return this.numberingPlan.formats();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this.numberingPlan.nationalPrefixForParsing();
    }
    // Deprecated.
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.numberingPlan.nationalPrefixTransformRule();
    }
    // Deprecated.
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.numberingPlan.leadingDigits();
    }
    // Deprecated.
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      return this.numberingPlan.hasTypes();
    }
    // Deprecated.
  }, {
    key: "type",
    value: function type3(_type) {
      return this.numberingPlan.type(_type);
    }
    // Deprecated.
  }, {
    key: "ext",
    value: function ext() {
      return this.numberingPlan.ext();
    }
  }, {
    key: "countryCallingCodes",
    value: function countryCallingCodes() {
      if (this.v1) return this.metadata.country_phone_code_to_countries;
      return this.metadata.country_calling_codes;
    }
    // Deprecated.
  }, {
    key: "chooseCountryByCountryCallingCode",
    value: function chooseCountryByCountryCallingCode(callingCode) {
      return this.selectNumberingPlan(callingCode);
    }
  }, {
    key: "hasSelectedNumberingPlan",
    value: function hasSelectedNumberingPlan() {
      return this.numberingPlan !== void 0;
    }
  }]);
  return Metadata2;
}();
var NumberingPlan = /* @__PURE__ */ function() {
  function NumberingPlan2(metadata2, globalMetadataObject) {
    _classCallCheck$1(this, NumberingPlan2);
    this.globalMetadataObject = globalMetadataObject;
    this.metadata = metadata2;
    setVersion.call(this, globalMetadataObject.metadata);
  }
  _createClass$1(NumberingPlan2, [{
    key: "callingCode",
    value: function callingCode() {
      return this.metadata[0];
    }
    // Formatting information for regions which share
    // a country calling code is contained by only one region
    // for performance reasons. For example, for NANPA region
    // ("North American Numbering Plan Administration",
    //  which includes USA, Canada, Cayman Islands, Bahamas, etc)
    // it will be contained in the metadata for `US`.
  }, {
    key: "getDefaultCountryMetadataForRegion",
    value: function getDefaultCountryMetadataForRegion() {
      return this.globalMetadataObject.getNumberingPlanMetadata(this.callingCode());
    }
    // Is always present.
  }, {
    key: "IDDPrefix",
    value: function IDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[1];
    }
    // Is only present when a country supports multiple IDD prefixes.
  }, {
    key: "defaultIDDPrefix",
    value: function defaultIDDPrefix() {
      if (this.v1 || this.v2) return;
      return this.metadata[12];
    }
  }, {
    key: "nationalNumberPattern",
    value: function nationalNumberPattern() {
      if (this.v1 || this.v2) return this.metadata[1];
      return this.metadata[2];
    }
    // "possible length" data is always present in Google's metadata.
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.v1) return;
      return this.metadata[this.v2 ? 2 : 3];
    }
  }, {
    key: "_getFormats",
    value: function _getFormats(metadata2) {
      return metadata2[this.v1 ? 2 : this.v2 ? 3 : 4];
    }
    // For countries of the same region (e.g. NANPA)
    // formats are all stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "formats",
    value: function formats() {
      var _this = this;
      var formats2 = this._getFormats(this.metadata) || this._getFormats(this.getDefaultCountryMetadataForRegion()) || [];
      return formats2.map(function(_2) {
        return new Format(_2, _this);
      });
    }
  }, {
    key: "nationalPrefix",
    value: function nationalPrefix() {
      return this.metadata[this.v1 ? 3 : this.v2 ? 4 : 5];
    }
  }, {
    key: "_getNationalPrefixFormattingRule",
    value: function _getNationalPrefixFormattingRule(metadata2) {
      return metadata2[this.v1 ? 4 : this.v2 ? 5 : 6];
    }
    // For countries of the same region (e.g. NANPA)
    // national prefix formatting rule is stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._getNationalPrefixFormattingRule(this.metadata) || this._getNationalPrefixFormattingRule(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "_nationalPrefixForParsing",
    value: function _nationalPrefixForParsing() {
      return this.metadata[this.v1 ? 5 : this.v2 ? 6 : 7];
    }
  }, {
    key: "nationalPrefixForParsing",
    value: function nationalPrefixForParsing() {
      return this._nationalPrefixForParsing() || this.nationalPrefix();
    }
  }, {
    key: "nationalPrefixTransformRule",
    value: function nationalPrefixTransformRule() {
      return this.metadata[this.v1 ? 6 : this.v2 ? 7 : 8];
    }
  }, {
    key: "_getNationalPrefixIsOptionalWhenFormatting",
    value: function _getNationalPrefixIsOptionalWhenFormatting() {
      return !!this.metadata[this.v1 ? 7 : this.v2 ? 8 : 9];
    }
    // For countries of the same region (e.g. NANPA)
    // "national prefix is optional when formatting" flag is
    // stored in the "main" country for that region.
    // E.g. "RU" and "KZ", "US" and "CA".
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return this._getNationalPrefixIsOptionalWhenFormatting(this.metadata) || this._getNationalPrefixIsOptionalWhenFormatting(this.getDefaultCountryMetadataForRegion());
    }
  }, {
    key: "leadingDigits",
    value: function leadingDigits() {
      return this.metadata[this.v1 ? 8 : this.v2 ? 9 : 10];
    }
  }, {
    key: "types",
    value: function types() {
      return this.metadata[this.v1 ? 9 : this.v2 ? 10 : 11];
    }
  }, {
    key: "hasTypes",
    value: function hasTypes() {
      if (this.types() && this.types().length === 0) {
        return false;
      }
      return !!this.types();
    }
  }, {
    key: "type",
    value: function type3(_type2) {
      if (this.hasTypes() && getType(this.types(), _type2)) {
        return new Type(getType(this.types(), _type2), this);
      }
    }
  }, {
    key: "ext",
    value: function ext() {
      if (this.v1 || this.v2) return DEFAULT_EXT_PREFIX;
      return this.metadata[13] || DEFAULT_EXT_PREFIX;
    }
  }]);
  return NumberingPlan2;
}();
var Format = /* @__PURE__ */ function() {
  function Format2(format2, metadata2) {
    _classCallCheck$1(this, Format2);
    this._format = format2;
    this.metadata = metadata2;
  }
  _createClass$1(Format2, [{
    key: "pattern",
    value: function pattern2() {
      return this._format[0];
    }
  }, {
    key: "format",
    value: function format2() {
      return this._format[1];
    }
  }, {
    key: "leadingDigitsPatterns",
    value: function leadingDigitsPatterns() {
      return this._format[2] || [];
    }
  }, {
    key: "nationalPrefixFormattingRule",
    value: function nationalPrefixFormattingRule() {
      return this._format[3] || this.metadata.nationalPrefixFormattingRule();
    }
  }, {
    key: "nationalPrefixIsOptionalWhenFormattingInNationalFormat",
    value: function nationalPrefixIsOptionalWhenFormattingInNationalFormat() {
      return !!this._format[4] || this.metadata.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
  }, {
    key: "nationalPrefixIsMandatoryWhenFormattingInNationalFormat",
    value: function nationalPrefixIsMandatoryWhenFormattingInNationalFormat() {
      return this.usesNationalPrefix() && !this.nationalPrefixIsOptionalWhenFormattingInNationalFormat();
    }
    // Checks whether national prefix formatting rule contains national prefix.
  }, {
    key: "usesNationalPrefix",
    value: function usesNationalPrefix() {
      return this.nationalPrefixFormattingRule() && // Check that national prefix formatting rule is not a "dummy" one.
      !FIRST_GROUP_ONLY_PREFIX_PATTERN.test(this.nationalPrefixFormattingRule()) ? true : false;
    }
  }, {
    key: "internationalFormat",
    value: function internationalFormat() {
      return this._format[5] || this.format();
    }
  }]);
  return Format2;
}();
var FIRST_GROUP_ONLY_PREFIX_PATTERN = /^\(?\$1\)?$/;
var Type = /* @__PURE__ */ function() {
  function Type2(type3, metadata2) {
    _classCallCheck$1(this, Type2);
    this.type = type3;
    this.metadata = metadata2;
  }
  _createClass$1(Type2, [{
    key: "pattern",
    value: function pattern2() {
      if (this.metadata.v1) return this.type;
      return this.type[0];
    }
  }, {
    key: "possibleLengths",
    value: function possibleLengths() {
      if (this.metadata.v1) return;
      return this.type[1] || this.metadata.possibleLengths();
    }
  }]);
  return Type2;
}();
function getType(types, type3) {
  switch (type3) {
    case "FIXED_LINE":
      return types[0];
    case "MOBILE":
      return types[1];
    case "TOLL_FREE":
      return types[2];
    case "PREMIUM_RATE":
      return types[3];
    case "PERSONAL_NUMBER":
      return types[4];
    case "VOICEMAIL":
      return types[5];
    case "UAN":
      return types[6];
    case "PAGER":
      return types[7];
    case "VOIP":
      return types[8];
    case "SHARED_COST":
      return types[9];
  }
}
function validateMetadata(metadata2) {
  if (!metadata2) {
    throw new Error("[libphonenumber-js] `metadata` argument not passed. Check your arguments.");
  }
  if (!isObject(metadata2) || !isObject(metadata2.countries)) {
    throw new Error("[libphonenumber-js] `metadata` argument was passed but it's not a valid metadata. Must be an object having `.countries` child object property. Got ".concat(isObject(metadata2) ? "an object of shape: { " + Object.keys(metadata2).join(", ") + " }" : "a " + typeOf(metadata2) + ": " + metadata2, "."));
  }
}
var typeOf = function typeOf2(_2) {
  return _typeof(_2);
};
function getCountryCallingCode(country, metadata2) {
  metadata2 = new Metadata(metadata2);
  if (metadata2.hasCountry(country)) {
    return metadata2.country(country).countryCallingCode();
  }
  throw new Error("Unknown country: ".concat(country));
}
function isSupportedCountry(country, metadata2) {
  return metadata2.countries.hasOwnProperty(country);
}
function setVersion(metadata2) {
  var version2 = metadata2.version;
  if (typeof version2 === "number") {
    this.v1 = version2 === 1;
    this.v2 = version2 === 2;
    this.v3 = version2 === 3;
    this.v4 = version2 === 4;
  } else {
    if (!version2) {
      this.v1 = true;
    } else if (compare(version2, V3) === -1) {
      this.v2 = true;
    } else if (compare(version2, V4) === -1) {
      this.v3 = true;
    } else {
      this.v4 = true;
    }
  }
}
var RFC3966_EXTN_PREFIX = ";ext=";
var getExtensionDigitsPattern = function getExtensionDigitsPattern2(maxLength) {
  return "([".concat(VALID_DIGITS, "]{1,").concat(maxLength, "})");
};
function createExtensionPattern(purpose) {
  var extLimitAfterExplicitLabel = "20";
  var extLimitAfterLikelyLabel = "15";
  var extLimitAfterAmbiguousChar = "9";
  var extLimitWhenNotSure = "6";
  var possibleSeparatorsBetweenNumberAndExtLabel = "[  \\t,]*";
  var possibleCharsAfterExtLabel = "[:\\.．]?[  \\t,-]*";
  var optionalExtnSuffix = "#?";
  var explicitExtLabels = "(?:e?xt(?:ensi(?:ó?|ó))?n?|ｅ?ｘｔｎ?|доб|anexo)";
  var ambiguousExtLabels = "(?:[xｘ#＃~～]|int|ｉｎｔ)";
  var ambiguousSeparator = "[- ]+";
  var possibleSeparatorsNumberExtLabelNoComma = "[  \\t]*";
  var autoDiallingAndExtLabelsFound = "(?:,{2}|;)";
  var rfcExtn = RFC3966_EXTN_PREFIX + getExtensionDigitsPattern(extLimitAfterExplicitLabel);
  var explicitExtn = possibleSeparatorsBetweenNumberAndExtLabel + explicitExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterExplicitLabel) + optionalExtnSuffix;
  var ambiguousExtn = possibleSeparatorsBetweenNumberAndExtLabel + ambiguousExtLabels + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  var americanStyleExtnWithSuffix = ambiguousSeparator + getExtensionDigitsPattern(extLimitWhenNotSure) + "#";
  var autoDiallingExtn = possibleSeparatorsNumberExtLabelNoComma + autoDiallingAndExtLabelsFound + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterLikelyLabel) + optionalExtnSuffix;
  var onlyCommasExtn = possibleSeparatorsNumberExtLabelNoComma + "(?:,)+" + possibleCharsAfterExtLabel + getExtensionDigitsPattern(extLimitAfterAmbiguousChar) + optionalExtnSuffix;
  return rfcExtn + "|" + explicitExtn + "|" + ambiguousExtn + "|" + americanStyleExtnWithSuffix + "|" + autoDiallingExtn + "|" + onlyCommasExtn;
}
var MIN_LENGTH_PHONE_NUMBER_PATTERN = "[" + VALID_DIGITS + "]{" + MIN_LENGTH_FOR_NSN + "}";
var VALID_PHONE_NUMBER = "[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){3,}[" + VALID_PUNCTUATION + VALID_DIGITS + "]*";
var VALID_PHONE_NUMBER_START_REG_EXP = new RegExp("^[" + PLUS_CHARS + "]{0,1}(?:[" + VALID_PUNCTUATION + "]*[" + VALID_DIGITS + "]){1,2}$", "i");
var VALID_PHONE_NUMBER_WITH_EXTENSION = VALID_PHONE_NUMBER + // Phone number extensions
"(?:" + createExtensionPattern() + ")?";
var VALID_PHONE_NUMBER_PATTERN = new RegExp(
  // Either a short two-digit-only phone number
  "^" + MIN_LENGTH_PHONE_NUMBER_PATTERN + "$|^" + VALID_PHONE_NUMBER_WITH_EXTENSION + "$",
  "i"
);
function isViablePhoneNumber(number2) {
  return number2.length >= MIN_LENGTH_FOR_NSN && VALID_PHONE_NUMBER_PATTERN.test(number2);
}
function isViablePhoneNumberStart(number2) {
  return VALID_PHONE_NUMBER_START_REG_EXP.test(number2);
}
var EXTN_PATTERN = new RegExp("(?:" + createExtensionPattern() + ")$", "i");
function extractExtension(number2) {
  var start = number2.search(EXTN_PATTERN);
  if (start < 0) {
    return {};
  }
  var numberWithoutExtension = number2.slice(0, start);
  var matches2 = number2.match(EXTN_PATTERN);
  var i = 1;
  while (i < matches2.length) {
    if (matches2[i]) {
      return {
        number: numberWithoutExtension,
        ext: matches2[i]
      };
    }
    i++;
  }
}
var DIGITS = {
  "0": "0",
  "1": "1",
  "2": "2",
  "3": "3",
  "4": "4",
  "5": "5",
  "6": "6",
  "7": "7",
  "8": "8",
  "9": "9",
  "０": "0",
  // Fullwidth digit 0
  "１": "1",
  // Fullwidth digit 1
  "２": "2",
  // Fullwidth digit 2
  "３": "3",
  // Fullwidth digit 3
  "４": "4",
  // Fullwidth digit 4
  "５": "5",
  // Fullwidth digit 5
  "６": "6",
  // Fullwidth digit 6
  "７": "7",
  // Fullwidth digit 7
  "８": "8",
  // Fullwidth digit 8
  "９": "9",
  // Fullwidth digit 9
  "٠": "0",
  // Arabic-indic digit 0
  "١": "1",
  // Arabic-indic digit 1
  "٢": "2",
  // Arabic-indic digit 2
  "٣": "3",
  // Arabic-indic digit 3
  "٤": "4",
  // Arabic-indic digit 4
  "٥": "5",
  // Arabic-indic digit 5
  "٦": "6",
  // Arabic-indic digit 6
  "٧": "7",
  // Arabic-indic digit 7
  "٨": "8",
  // Arabic-indic digit 8
  "٩": "9",
  // Arabic-indic digit 9
  "۰": "0",
  // Eastern-Arabic digit 0
  "۱": "1",
  // Eastern-Arabic digit 1
  "۲": "2",
  // Eastern-Arabic digit 2
  "۳": "3",
  // Eastern-Arabic digit 3
  "۴": "4",
  // Eastern-Arabic digit 4
  "۵": "5",
  // Eastern-Arabic digit 5
  "۶": "6",
  // Eastern-Arabic digit 6
  "۷": "7",
  // Eastern-Arabic digit 7
  "۸": "8",
  // Eastern-Arabic digit 8
  "۹": "9"
  // Eastern-Arabic digit 9
};
function parseDigit(character) {
  return DIGITS[character];
}
function _createForOfIteratorHelperLoose$3(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2) return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$4(o)) || allowArrayLike) {
    if (it2) o = it2;
    var i = 0;
    return function() {
      if (i >= o.length) return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$4(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$4(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$4(o, minLen);
}
function _arrayLikeToArray$4(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function parseIncompletePhoneNumber(string2) {
  var result2 = "";
  for (var _iterator = _createForOfIteratorHelperLoose$3(string2.split("")), _step; !(_step = _iterator()).done; ) {
    var character = _step.value;
    result2 += parsePhoneNumberCharacter(character, result2) || "";
  }
  return result2;
}
function parsePhoneNumberCharacter(character, prevParsedCharacters, emitEvent) {
  if (character === "+") {
    if (prevParsedCharacters) {
      return;
    }
    return "+";
  }
  return parseDigit(character);
}
function checkNumberLength(nationalNumber, metadata2) {
  return checkNumberLengthForType(nationalNumber, void 0, metadata2);
}
function checkNumberLengthForType(nationalNumber, type3, metadata2) {
  var type_info = metadata2.type(type3);
  var possible_lengths = type_info && type_info.possibleLengths() || metadata2.possibleLengths();
  if (!possible_lengths) {
    return "IS_POSSIBLE";
  }
  var actual_length = nationalNumber.length;
  var minimum_length = possible_lengths[0];
  if (minimum_length === actual_length) {
    return "IS_POSSIBLE";
  }
  if (minimum_length > actual_length) {
    return "TOO_SHORT";
  }
  if (possible_lengths[possible_lengths.length - 1] < actual_length) {
    return "TOO_LONG";
  }
  return possible_lengths.indexOf(actual_length, 1) >= 0 ? "IS_POSSIBLE" : "INVALID_LENGTH";
}
function isPossiblePhoneNumber(input, options, metadata2) {
  if (options === void 0) {
    options = {};
  }
  metadata2 = new Metadata(metadata2);
  if (options.v2) {
    if (!input.countryCallingCode) {
      throw new Error("Invalid phone number object passed");
    }
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else {
    if (!input.phone) {
      return false;
    }
    if (input.country) {
      if (!metadata2.hasCountry(input.country)) {
        throw new Error("Unknown country: ".concat(input.country));
      }
      metadata2.country(input.country);
    } else {
      if (!input.countryCallingCode) {
        throw new Error("Invalid phone number object passed");
      }
      metadata2.selectNumberingPlan(input.countryCallingCode);
    }
  }
  if (metadata2.possibleLengths()) {
    return isPossibleNumber(input.phone || input.nationalNumber, metadata2);
  } else {
    if (input.countryCallingCode && metadata2.isNonGeographicCallingCode(input.countryCallingCode)) {
      return true;
    } else {
      throw new Error('Missing "possibleLengths" in metadata. Perhaps the metadata has been generated before v1.0.18.');
    }
  }
}
function isPossibleNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "IS_POSSIBLE":
      return true;
    // This library ignores "local-only" phone numbers (for simplicity).
    // See the readme for more info on what are "local-only" phone numbers.
    // case 'IS_POSSIBLE_LOCAL_ONLY':
    // 	return !isInternational
    default:
      return false;
  }
}
function matchesEntirely(text, regular_expression) {
  text = text || "";
  return new RegExp("^(?:" + regular_expression + ")$").test(text);
}
function _createForOfIteratorHelperLoose$2(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2) return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$3(o)) || allowArrayLike) {
    if (it2) o = it2;
    var i = 0;
    return function() {
      if (i >= o.length) return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$3(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$3(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$3(o, minLen);
}
function _arrayLikeToArray$3(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
var NON_FIXED_LINE_PHONE_TYPES = ["MOBILE", "PREMIUM_RATE", "TOLL_FREE", "SHARED_COST", "VOIP", "PERSONAL_NUMBER", "PAGER", "UAN", "VOICEMAIL"];
function getNumberType(input, options, metadata2) {
  options = options || {};
  if (!input.country && !input.countryCallingCode) {
    return;
  }
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern())) {
    return;
  }
  if (isNumberTypeEqualTo(nationalNumber, "FIXED_LINE", metadata2)) {
    if (metadata2.type("MOBILE") && metadata2.type("MOBILE").pattern() === "") {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (!metadata2.type("MOBILE")) {
      return "FIXED_LINE_OR_MOBILE";
    }
    if (isNumberTypeEqualTo(nationalNumber, "MOBILE", metadata2)) {
      return "FIXED_LINE_OR_MOBILE";
    }
    return "FIXED_LINE";
  }
  for (var _iterator = _createForOfIteratorHelperLoose$2(NON_FIXED_LINE_PHONE_TYPES), _step; !(_step = _iterator()).done; ) {
    var type3 = _step.value;
    if (isNumberTypeEqualTo(nationalNumber, type3, metadata2)) {
      return type3;
    }
  }
}
function isNumberTypeEqualTo(nationalNumber, type3, metadata2) {
  type3 = metadata2.type(type3);
  if (!type3 || !type3.pattern()) {
    return false;
  }
  if (type3.possibleLengths() && type3.possibleLengths().indexOf(nationalNumber.length) < 0) {
    return false;
  }
  return matchesEntirely(nationalNumber, type3.pattern());
}
function isValidNumber(input, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  metadata2.selectNumberingPlan(input.country, input.countryCallingCode);
  if (metadata2.hasTypes()) {
    return getNumberType(input, options, metadata2.metadata) !== void 0;
  }
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  return matchesEntirely(nationalNumber, metadata2.nationalNumberPattern());
}
function getPossibleCountriesForNumber(callingCode, nationalNumber, metadata2) {
  var _metadata = new Metadata(metadata2);
  var possibleCountries = _metadata.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return [];
  }
  return possibleCountries.filter(function(country) {
    return couldNationalNumberBelongToCountry(nationalNumber, country, metadata2);
  });
}
function couldNationalNumberBelongToCountry(nationalNumber, country, metadata2) {
  var _metadata = new Metadata(metadata2);
  _metadata.selectNumberingPlan(country);
  if (_metadata.numberingPlan.possibleLengths().indexOf(nationalNumber.length) >= 0) {
    return true;
  }
  return false;
}
function applyInternationalSeparatorStyle(formattedNumber) {
  return formattedNumber.replace(new RegExp("[".concat(VALID_PUNCTUATION, "]+"), "g"), " ").trim();
}
var FIRST_GROUP_PATTERN = /(\$\d)/;
function formatNationalNumberUsingFormat(number2, format2, _ref) {
  var useInternationalFormat = _ref.useInternationalFormat, withNationalPrefix = _ref.withNationalPrefix;
  var formattedNumber = number2.replace(new RegExp(format2.pattern()), useInternationalFormat ? format2.internationalFormat() : (
    // This library doesn't use `domestic_carrier_code_formatting_rule`,
    // because that one is only used when formatting phone numbers
    // for dialing from a mobile phone, and this is not a dialing library.
    // carrierCode && format.domesticCarrierCodeFormattingRule()
    // 	// First, replace the $CC in the formatting rule with the desired carrier code.
    // 	// Then, replace the $FG in the formatting rule with the first group
    // 	// and the carrier code combined in the appropriate way.
    // 	? format.format().replace(FIRST_GROUP_PATTERN, format.domesticCarrierCodeFormattingRule().replace('$CC', carrierCode))
    // 	: (
    // 		withNationalPrefix && format.nationalPrefixFormattingRule()
    // 			? format.format().replace(FIRST_GROUP_PATTERN, format.nationalPrefixFormattingRule())
    // 			: format.format()
    // 	)
    withNationalPrefix && format2.nationalPrefixFormattingRule() ? format2.format().replace(FIRST_GROUP_PATTERN, format2.nationalPrefixFormattingRule()) : format2.format()
  ));
  if (useInternationalFormat) {
    return applyInternationalSeparatorStyle(formattedNumber);
  }
  return formattedNumber;
}
var SINGLE_IDD_PREFIX_REG_EXP = /^[\d]+(?:[~\u2053\u223C\uFF5E][\d]+)?$/;
function getIddPrefix(country, callingCode, metadata2) {
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  if (countryMetadata.defaultIDDPrefix()) {
    return countryMetadata.defaultIDDPrefix();
  }
  if (SINGLE_IDD_PREFIX_REG_EXP.test(countryMetadata.IDDPrefix())) {
    return countryMetadata.IDDPrefix();
  }
}
function formatRFC3966(_ref) {
  var number2 = _ref.number, ext = _ref.ext;
  if (!number2) {
    return "";
  }
  if (number2[0] !== "+") {
    throw new Error('"formatRFC3966()" expects "number" to be in E.164 format.');
  }
  return "tel:".concat(number2).concat(ext ? ";ext=" + ext : "");
}
function _createForOfIteratorHelperLoose$1(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2) return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$2(o)) || allowArrayLike) {
    if (it2) o = it2;
    var i = 0;
    return function() {
      if (i >= o.length) return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$2(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$2(o, minLen);
}
function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys$4(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread$4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$4(Object(source), true).forEach(function(key) {
      _defineProperty$4(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$4(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DEFAULT_OPTIONS = {
  formatExtension: function formatExtension(formattedNumber, extension, metadata2) {
    return "".concat(formattedNumber).concat(metadata2.ext()).concat(extension);
  }
};
function formatNumber(input, format2, options, metadata2) {
  if (options) {
    options = _objectSpread$4(_objectSpread$4({}, DEFAULT_OPTIONS), options);
  } else {
    options = DEFAULT_OPTIONS;
  }
  metadata2 = new Metadata(metadata2);
  if (input.country && input.country !== "001") {
    if (!metadata2.hasCountry(input.country)) {
      throw new Error("Unknown country: ".concat(input.country));
    }
    metadata2.country(input.country);
  } else if (input.countryCallingCode) {
    metadata2.selectNumberingPlan(input.countryCallingCode);
  } else return input.phone || "";
  var countryCallingCode = metadata2.countryCallingCode();
  var nationalNumber = options.v2 ? input.nationalNumber : input.phone;
  var number2;
  switch (format2) {
    case "NATIONAL":
      if (!nationalNumber) {
        return "";
      }
      number2 = formatNationalNumber(nationalNumber, input.carrierCode, "NATIONAL", metadata2, options);
      return addExtension(number2, input.ext, metadata2, options.formatExtension);
    case "INTERNATIONAL":
      if (!nationalNumber) {
        return "+".concat(countryCallingCode);
      }
      number2 = formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2, options);
      number2 = "+".concat(countryCallingCode, " ").concat(number2);
      return addExtension(number2, input.ext, metadata2, options.formatExtension);
    case "E.164":
      return "+".concat(countryCallingCode).concat(nationalNumber);
    case "RFC3966":
      return formatRFC3966({
        number: "+".concat(countryCallingCode).concat(nationalNumber),
        ext: input.ext
      });
    // For reference, here's Google's IDD formatter:
    // https://github.com/google/libphonenumber/blob/32719cf74e68796788d1ca45abc85dcdc63ba5b9/java/libphonenumber/src/com/google/i18n/phonenumbers/PhoneNumberUtil.java#L1546
    // Not saying that this IDD formatter replicates it 1:1, but it seems to work.
    // Who would even need to format phone numbers in IDD format anyway?
    case "IDD":
      if (!options.fromCountry) {
        return;
      }
      var formattedNumber = formatIDD(nationalNumber, input.carrierCode, countryCallingCode, options.fromCountry, metadata2);
      return addExtension(formattedNumber, input.ext, metadata2, options.formatExtension);
    default:
      throw new Error('Unknown "format" argument passed to "formatNumber()": "'.concat(format2, '"'));
  }
}
function formatNationalNumber(number2, carrierCode, formatAs, metadata2, options) {
  var format2 = chooseFormatForNumber(metadata2.formats(), number2);
  if (!format2) {
    return number2;
  }
  return formatNationalNumberUsingFormat(number2, format2, {
    useInternationalFormat: formatAs === "INTERNATIONAL",
    withNationalPrefix: format2.nationalPrefixIsOptionalWhenFormattingInNationalFormat() && options && options.nationalPrefix === false ? false : true,
    carrierCode,
    metadata: metadata2
  });
}
function chooseFormatForNumber(availableFormats, nationalNnumber) {
  for (var _iterator = _createForOfIteratorHelperLoose$1(availableFormats), _step; !(_step = _iterator()).done; ) {
    var format2 = _step.value;
    if (format2.leadingDigitsPatterns().length > 0) {
      var lastLeadingDigitsPattern = format2.leadingDigitsPatterns()[format2.leadingDigitsPatterns().length - 1];
      if (nationalNnumber.search(lastLeadingDigitsPattern) !== 0) {
        continue;
      }
    }
    if (matchesEntirely(nationalNnumber, format2.pattern())) {
      return format2;
    }
  }
}
function addExtension(formattedNumber, ext, metadata2, formatExtension2) {
  return ext ? formatExtension2(formattedNumber, ext, metadata2) : formattedNumber;
}
function formatIDD(nationalNumber, carrierCode, countryCallingCode, fromCountry, metadata2) {
  var fromCountryCallingCode = getCountryCallingCode(fromCountry, metadata2.metadata);
  if (fromCountryCallingCode === countryCallingCode) {
    var formattedNumber = formatNationalNumber(nationalNumber, carrierCode, "NATIONAL", metadata2);
    if (countryCallingCode === "1") {
      return countryCallingCode + " " + formattedNumber;
    }
    return formattedNumber;
  }
  var iddPrefix = getIddPrefix(fromCountry, void 0, metadata2.metadata);
  if (iddPrefix) {
    return "".concat(iddPrefix, " ").concat(countryCallingCode, " ").concat(formatNationalNumber(nationalNumber, null, "INTERNATIONAL", metadata2));
  }
}
function ownKeys$3(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread$3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$3(Object(source), true).forEach(function(key) {
      _defineProperty$3(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$3(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props2) {
  for (var i = 0; i < props2.length; i++) {
    var descriptor = props2[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  _defineProperties(Constructor.prototype, protoProps);
  Object.defineProperty(Constructor, "prototype", { writable: false });
  return Constructor;
}
var PhoneNumber = /* @__PURE__ */ function() {
  function PhoneNumber2(countryOrCountryCallingCode, nationalNumber, metadata2) {
    _classCallCheck(this, PhoneNumber2);
    if (!countryOrCountryCallingCode) {
      throw new TypeError("`country` or `countryCallingCode` not passed");
    }
    if (!nationalNumber) {
      throw new TypeError("`nationalNumber` not passed");
    }
    if (!metadata2) {
      throw new TypeError("`metadata` not passed");
    }
    var _getCountryAndCountry = getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadata2), country = _getCountryAndCountry.country, countryCallingCode = _getCountryAndCountry.countryCallingCode;
    this.country = country;
    this.countryCallingCode = countryCallingCode;
    this.nationalNumber = nationalNumber;
    this.number = "+" + this.countryCallingCode + this.nationalNumber;
    this.getMetadata = function() {
      return metadata2;
    };
  }
  _createClass(PhoneNumber2, [{
    key: "setExt",
    value: function setExt(ext) {
      this.ext = ext;
    }
  }, {
    key: "getPossibleCountries",
    value: function getPossibleCountries() {
      if (this.country) {
        return [this.country];
      }
      return getPossibleCountriesForNumber(this.countryCallingCode, this.nationalNumber, this.getMetadata());
    }
  }, {
    key: "isPossible",
    value: function isPossible() {
      return isPossiblePhoneNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isValid",
    value: function isValid2() {
      return isValidNumber(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "isNonGeographic",
    value: function isNonGeographic() {
      var metadata2 = new Metadata(this.getMetadata());
      return metadata2.isNonGeographicCallingCode(this.countryCallingCode);
    }
  }, {
    key: "isEqual",
    value: function isEqual2(phoneNumber) {
      return this.number === phoneNumber.number && this.ext === phoneNumber.ext;
    }
    // This function was originally meant to be an equivalent for `validatePhoneNumberLength()`,
    // but later it was found out that it doesn't include the possible `TOO_SHORT` result
    // returned from `parsePhoneNumberWithError()` in the original `validatePhoneNumberLength()`,
    // so eventually I simply commented out this method from the `PhoneNumber` class
    // and just left the `validatePhoneNumberLength()` function, even though that one would require
    // and additional step to also validate the actual country / calling code of the phone number.
    // validateLength() {
    // 	const metadata = new Metadata(this.getMetadata())
    // 	metadata.selectNumberingPlan(this.countryCallingCode)
    // 	const result = checkNumberLength(this.nationalNumber, metadata)
    // 	if (result !== 'IS_POSSIBLE') {
    // 		return result
    // 	}
    // }
  }, {
    key: "getType",
    value: function getType2() {
      return getNumberType(this, {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "format",
    value: function format2(_format, options) {
      return formatNumber(this, _format, options ? _objectSpread$3(_objectSpread$3({}, options), {}, {
        v2: true
      }) : {
        v2: true
      }, this.getMetadata());
    }
  }, {
    key: "formatNational",
    value: function formatNational(options) {
      return this.format("NATIONAL", options);
    }
  }, {
    key: "formatInternational",
    value: function formatInternational(options) {
      return this.format("INTERNATIONAL", options);
    }
  }, {
    key: "getURI",
    value: function getURI(options) {
      return this.format("RFC3966", options);
    }
  }]);
  return PhoneNumber2;
}();
var isCountryCode = function isCountryCode2(value) {
  return /^[A-Z]{2}$/.test(value);
};
function getCountryAndCountryCallingCode(countryOrCountryCallingCode, metadataJson) {
  var country;
  var countryCallingCode;
  var metadata2 = new Metadata(metadataJson);
  if (isCountryCode(countryOrCountryCallingCode)) {
    country = countryOrCountryCallingCode;
    metadata2.selectNumberingPlan(country);
    countryCallingCode = metadata2.countryCallingCode();
  } else {
    countryCallingCode = countryOrCountryCallingCode;
  }
  return {
    country,
    countryCallingCode
  };
}
var CAPTURING_DIGIT_PATTERN = new RegExp("([" + VALID_DIGITS + "])");
function stripIddPrefix(number2, country, callingCode, metadata2) {
  if (!country) {
    return;
  }
  var countryMetadata = new Metadata(metadata2);
  countryMetadata.selectNumberingPlan(country, callingCode);
  var IDDPrefixPattern = new RegExp(countryMetadata.IDDPrefix());
  if (number2.search(IDDPrefixPattern) !== 0) {
    return;
  }
  number2 = number2.slice(number2.match(IDDPrefixPattern)[0].length);
  var matchedGroups = number2.match(CAPTURING_DIGIT_PATTERN);
  if (matchedGroups && matchedGroups[1] != null && matchedGroups[1].length > 0) {
    if (matchedGroups[1] === "0") {
      return;
    }
  }
  return number2;
}
function extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2) {
  if (number2 && metadata2.numberingPlan.nationalPrefixForParsing()) {
    var prefixPattern = new RegExp("^(?:" + metadata2.numberingPlan.nationalPrefixForParsing() + ")");
    var prefixMatch = prefixPattern.exec(number2);
    if (prefixMatch) {
      var nationalNumber;
      var carrierCode;
      var capturedGroupsCount = prefixMatch.length - 1;
      var hasCapturedGroups = capturedGroupsCount > 0 && prefixMatch[capturedGroupsCount];
      if (metadata2.nationalPrefixTransformRule() && hasCapturedGroups) {
        nationalNumber = number2.replace(prefixPattern, metadata2.nationalPrefixTransformRule());
        if (capturedGroupsCount > 1) {
          carrierCode = prefixMatch[1];
        }
      } else {
        var prefixBeforeNationalNumber = prefixMatch[0];
        nationalNumber = number2.slice(prefixBeforeNationalNumber.length);
        if (hasCapturedGroups) {
          carrierCode = prefixMatch[1];
        }
      }
      var nationalPrefix;
      if (hasCapturedGroups) {
        var possiblePositionOfTheFirstCapturedGroup = number2.indexOf(prefixMatch[1]);
        var possibleNationalPrefix = number2.slice(0, possiblePositionOfTheFirstCapturedGroup);
        if (possibleNationalPrefix === metadata2.numberingPlan.nationalPrefix()) {
          nationalPrefix = metadata2.numberingPlan.nationalPrefix();
        }
      } else {
        nationalPrefix = prefixMatch[0];
      }
      return {
        nationalNumber,
        nationalPrefix,
        carrierCode
      };
    }
  }
  return {
    nationalNumber: number2
  };
}
function extractNationalNumber(number2, metadata2) {
  var _extractNationalNumbe = extractNationalNumberFromPossiblyIncompleteNumber(number2, metadata2), carrierCode = _extractNationalNumbe.carrierCode, nationalNumber = _extractNationalNumbe.nationalNumber;
  if (nationalNumber !== number2) {
    if (!shouldHaveExtractedNationalPrefix(number2, nationalNumber, metadata2)) {
      return {
        nationalNumber: number2
      };
    }
    if (metadata2.possibleLengths()) {
      if (!isPossibleIncompleteNationalNumber(nationalNumber, metadata2)) {
        return {
          nationalNumber: number2
        };
      }
    }
  }
  return {
    nationalNumber,
    carrierCode
  };
}
function shouldHaveExtractedNationalPrefix(nationalNumberBefore, nationalNumberAfter, metadata2) {
  if (matchesEntirely(nationalNumberBefore, metadata2.nationalNumberPattern()) && !matchesEntirely(nationalNumberAfter, metadata2.nationalNumberPattern())) {
    return false;
  }
  return true;
}
function isPossibleIncompleteNationalNumber(nationalNumber, metadata2) {
  switch (checkNumberLength(nationalNumber, metadata2)) {
    case "TOO_SHORT":
    case "INVALID_LENGTH":
      return false;
    default:
      return true;
  }
}
function extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2) {
  var countryCallingCode = country ? getCountryCallingCode(country, metadata2) : callingCode;
  if (number2.indexOf(countryCallingCode) === 0) {
    metadata2 = new Metadata(metadata2);
    metadata2.selectNumberingPlan(country, callingCode);
    var possibleShorterNumber = number2.slice(countryCallingCode.length);
    var _extractNationalNumbe = extractNationalNumber(possibleShorterNumber, metadata2), possibleShorterNationalNumber = _extractNationalNumbe.nationalNumber;
    var _extractNationalNumbe2 = extractNationalNumber(number2, metadata2), nationalNumber = _extractNationalNumbe2.nationalNumber;
    if (!matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) && matchesEntirely(possibleShorterNationalNumber, metadata2.nationalNumberPattern()) || checkNumberLength(nationalNumber, metadata2) === "TOO_LONG") {
      return {
        countryCallingCode,
        number: possibleShorterNumber
      };
    }
  }
  return {
    number: number2
  };
}
function extractCountryCallingCode(number2, country, callingCode, metadata2) {
  if (!number2) {
    return {};
  }
  var isNumberWithIddPrefix;
  if (number2[0] !== "+") {
    var numberWithoutIDD = stripIddPrefix(number2, country, callingCode, metadata2);
    if (numberWithoutIDD && numberWithoutIDD !== number2) {
      isNumberWithIddPrefix = true;
      number2 = "+" + numberWithoutIDD;
    } else {
      if (country || callingCode) {
        var _extractCountryCallin = extractCountryCallingCodeFromInternationalNumberWithoutPlusSign(number2, country, callingCode, metadata2), countryCallingCode = _extractCountryCallin.countryCallingCode, shorterNumber = _extractCountryCallin.number;
        if (countryCallingCode) {
          return {
            countryCallingCodeSource: "FROM_NUMBER_WITHOUT_PLUS_SIGN",
            countryCallingCode,
            number: shorterNumber
          };
        }
      }
      return {
        // No need to set it to `UNSPECIFIED`. It can be just `undefined`.
        // countryCallingCodeSource: 'UNSPECIFIED',
        number: number2
      };
    }
  }
  if (number2[1] === "0") {
    return {};
  }
  metadata2 = new Metadata(metadata2);
  var i = 2;
  while (i - 1 <= MAX_LENGTH_COUNTRY_CODE && i <= number2.length) {
    var _countryCallingCode = number2.slice(1, i);
    if (metadata2.hasCallingCode(_countryCallingCode)) {
      metadata2.selectNumberingPlan(_countryCallingCode);
      return {
        countryCallingCodeSource: isNumberWithIddPrefix ? "FROM_NUMBER_WITH_IDD" : "FROM_NUMBER_WITH_PLUS_SIGN",
        countryCallingCode: _countryCallingCode,
        number: number2.slice(i)
      };
    }
    i++;
  }
  return {};
}
function _createForOfIteratorHelperLoose(o, allowArrayLike) {
  var it2 = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (it2) return (it2 = it2.call(o)).next.bind(it2);
  if (Array.isArray(o) || (it2 = _unsupportedIterableToArray$1(o)) || allowArrayLike) {
    if (it2) o = it2;
    var i = 0;
    return function() {
      if (i >= o.length) return { done: true };
      return { done: false, value: o[i++] };
    };
  }
  throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray$1(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray$1(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray$1(o, minLen);
}
function _arrayLikeToArray$1(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function getCountryByNationalNumber(nationalPhoneNumber, _ref) {
  var countries = _ref.countries, metadata2 = _ref.metadata;
  metadata2 = new Metadata(metadata2);
  for (var _iterator = _createForOfIteratorHelperLoose(countries), _step; !(_step = _iterator()).done; ) {
    var country = _step.value;
    metadata2.country(country);
    if (metadata2.leadingDigits()) {
      if (nationalPhoneNumber && nationalPhoneNumber.search(metadata2.leadingDigits()) === 0) {
        return country;
      }
    } else if (getNumberType({
      phone: nationalPhoneNumber,
      country
    }, void 0, metadata2.metadata)) {
      return country;
    }
  }
}
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata2 = _ref.metadata;
  var possibleCountries = metadata2.getCountryCodesForCallingCode(callingCode);
  if (!possibleCountries) {
    return;
  }
  if (possibleCountries.length === 1) {
    return possibleCountries[0];
  }
  return getCountryByNationalNumber(nationalPhoneNumber, {
    countries: possibleCountries,
    defaultCountry,
    metadata: metadata2.metadata
  });
}
var PLUS_SIGN = "+";
var RFC3966_VISUAL_SEPARATOR_ = "[\\-\\.\\(\\)]?";
var RFC3966_PHONE_DIGIT_ = "([" + VALID_DIGITS + "]|" + RFC3966_VISUAL_SEPARATOR_ + ")";
var RFC3966_GLOBAL_NUMBER_DIGITS_ = "^\\" + PLUS_SIGN + RFC3966_PHONE_DIGIT_ + "*[" + VALID_DIGITS + "]" + RFC3966_PHONE_DIGIT_ + "*$";
var RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_ = new RegExp(RFC3966_GLOBAL_NUMBER_DIGITS_, "g");
var ALPHANUM_ = VALID_DIGITS;
var RFC3966_DOMAINLABEL_ = "[" + ALPHANUM_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var VALID_ALPHA_ = "a-zA-Z";
var RFC3966_TOPLABEL_ = "[" + VALID_ALPHA_ + "]+((\\-)*[" + ALPHANUM_ + "])*";
var RFC3966_DOMAINNAME_ = "^(" + RFC3966_DOMAINLABEL_ + "\\.)*" + RFC3966_TOPLABEL_ + "\\.?$";
var RFC3966_DOMAINNAME_PATTERN_ = new RegExp(RFC3966_DOMAINNAME_, "g");
var RFC3966_PREFIX_ = "tel:";
var RFC3966_PHONE_CONTEXT_ = ";phone-context=";
var RFC3966_ISDN_SUBADDRESS_ = ";isub=";
function extractPhoneContext(numberToExtractFrom) {
  var indexOfPhoneContext = numberToExtractFrom.indexOf(RFC3966_PHONE_CONTEXT_);
  if (indexOfPhoneContext < 0) {
    return null;
  }
  var phoneContextStart = indexOfPhoneContext + RFC3966_PHONE_CONTEXT_.length;
  if (phoneContextStart >= numberToExtractFrom.length) {
    return "";
  }
  var phoneContextEnd = numberToExtractFrom.indexOf(";", phoneContextStart);
  if (phoneContextEnd >= 0) {
    return numberToExtractFrom.substring(phoneContextStart, phoneContextEnd);
  } else {
    return numberToExtractFrom.substring(phoneContextStart);
  }
}
function isPhoneContextValid(phoneContext) {
  if (phoneContext === null) {
    return true;
  }
  if (phoneContext.length === 0) {
    return false;
  }
  return RFC3966_GLOBAL_NUMBER_DIGITS_PATTERN_.test(phoneContext) || RFC3966_DOMAINNAME_PATTERN_.test(phoneContext);
}
function extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(numberToParse, _ref) {
  var extractFormattedPhoneNumber = _ref.extractFormattedPhoneNumber;
  var phoneContext = extractPhoneContext(numberToParse);
  if (!isPhoneContextValid(phoneContext)) {
    throw new ParseError("NOT_A_NUMBER");
  }
  var phoneNumberString;
  if (phoneContext === null) {
    phoneNumberString = extractFormattedPhoneNumber(numberToParse) || "";
  } else {
    phoneNumberString = "";
    if (phoneContext.charAt(0) === PLUS_SIGN) {
      phoneNumberString += phoneContext;
    }
    var indexOfRfc3966Prefix = numberToParse.indexOf(RFC3966_PREFIX_);
    var indexOfNationalNumber;
    if (indexOfRfc3966Prefix >= 0) {
      indexOfNationalNumber = indexOfRfc3966Prefix + RFC3966_PREFIX_.length;
    } else {
      indexOfNationalNumber = 0;
    }
    var indexOfPhoneContext = numberToParse.indexOf(RFC3966_PHONE_CONTEXT_);
    phoneNumberString += numberToParse.substring(indexOfNationalNumber, indexOfPhoneContext);
  }
  var indexOfIsdn = phoneNumberString.indexOf(RFC3966_ISDN_SUBADDRESS_);
  if (indexOfIsdn > 0) {
    phoneNumberString = phoneNumberString.substring(0, indexOfIsdn);
  }
  if (phoneNumberString !== "") {
    return phoneNumberString;
  }
}
var MAX_INPUT_STRING_LENGTH = 250;
var PHONE_NUMBER_START_PATTERN = new RegExp("[" + PLUS_CHARS + VALID_DIGITS + "]");
var AFTER_PHONE_NUMBER_END_PATTERN = new RegExp("[^" + VALID_DIGITS + "#]+$");
function parse(text, options, metadata2) {
  options = options || {};
  metadata2 = new Metadata(metadata2);
  if (options.defaultCountry && !metadata2.hasCountry(options.defaultCountry)) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    throw new Error("Unknown country: ".concat(options.defaultCountry));
  }
  var _parseInput = parseInput(text, options.v2, options.extract), formattedPhoneNumber = _parseInput.number, ext = _parseInput.ext, error = _parseInput.error;
  if (!formattedPhoneNumber) {
    if (options.v2) {
      if (error === "TOO_SHORT") {
        throw new ParseError("TOO_SHORT");
      }
      throw new ParseError("NOT_A_NUMBER");
    }
    return {};
  }
  var _parsePhoneNumber = parsePhoneNumber$3(formattedPhoneNumber, options.defaultCountry, options.defaultCallingCode, metadata2), country = _parsePhoneNumber.country, nationalNumber = _parsePhoneNumber.nationalNumber, countryCallingCode = _parsePhoneNumber.countryCallingCode, countryCallingCodeSource = _parsePhoneNumber.countryCallingCodeSource, carrierCode = _parsePhoneNumber.carrierCode;
  if (!metadata2.hasSelectedNumberingPlan()) {
    if (options.v2) {
      throw new ParseError("INVALID_COUNTRY");
    }
    return {};
  }
  if (!nationalNumber || nationalNumber.length < MIN_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_SHORT");
    }
    return {};
  }
  if (nationalNumber.length > MAX_LENGTH_FOR_NSN) {
    if (options.v2) {
      throw new ParseError("TOO_LONG");
    }
    return {};
  }
  if (options.v2) {
    var phoneNumber = new PhoneNumber(countryCallingCode, nationalNumber, metadata2.metadata);
    if (country) {
      phoneNumber.country = country;
    }
    if (carrierCode) {
      phoneNumber.carrierCode = carrierCode;
    }
    if (ext) {
      phoneNumber.ext = ext;
    }
    phoneNumber.__countryCallingCodeSource = countryCallingCodeSource;
    return phoneNumber;
  }
  var valid = (options.extended ? metadata2.hasSelectedNumberingPlan() : country) ? matchesEntirely(nationalNumber, metadata2.nationalNumberPattern()) : false;
  if (!options.extended) {
    return valid ? result(country, nationalNumber, ext) : {};
  }
  return {
    country,
    countryCallingCode,
    carrierCode,
    valid,
    possible: valid ? true : options.extended === true && metadata2.possibleLengths() && isPossibleNumber(nationalNumber, metadata2) ? true : false,
    phone: nationalNumber,
    ext
  };
}
function _extractFormattedPhoneNumber(text, extract, throwOnError) {
  if (!text) {
    return;
  }
  if (text.length > MAX_INPUT_STRING_LENGTH) {
    if (throwOnError) {
      throw new ParseError("TOO_LONG");
    }
    return;
  }
  if (extract === false) {
    return text;
  }
  var startsAt = text.search(PHONE_NUMBER_START_PATTERN);
  if (startsAt < 0) {
    return;
  }
  return text.slice(startsAt).replace(AFTER_PHONE_NUMBER_END_PATTERN, "");
}
function parseInput(text, v2, extract) {
  var number2 = extractFormattedPhoneNumberFromPossibleRfc3966NumberUri(text, {
    extractFormattedPhoneNumber: function extractFormattedPhoneNumber(text2) {
      return _extractFormattedPhoneNumber(text2, extract, v2);
    }
  });
  if (!number2) {
    return {};
  }
  if (!isViablePhoneNumber(number2)) {
    if (isViablePhoneNumberStart(number2)) {
      return {
        error: "TOO_SHORT"
      };
    }
    return {};
  }
  var withExtensionStripped = extractExtension(number2);
  if (withExtensionStripped.ext) {
    return withExtensionStripped;
  }
  return {
    number: number2
  };
}
function result(country, nationalNumber, ext) {
  var result2 = {
    country,
    phone: nationalNumber
  };
  if (ext) {
    result2.ext = ext;
  }
  return result2;
}
function parsePhoneNumber$3(formattedPhoneNumber, defaultCountry, defaultCallingCode, metadata2) {
  var _extractCountryCallin = extractCountryCallingCode(parseIncompletePhoneNumber(formattedPhoneNumber), defaultCountry, defaultCallingCode, metadata2.metadata), countryCallingCodeSource = _extractCountryCallin.countryCallingCodeSource, countryCallingCode = _extractCountryCallin.countryCallingCode, number2 = _extractCountryCallin.number;
  var country;
  if (countryCallingCode) {
    metadata2.selectNumberingPlan(countryCallingCode);
  } else if (number2 && (defaultCountry || defaultCallingCode)) {
    metadata2.selectNumberingPlan(defaultCountry, defaultCallingCode);
    if (defaultCountry) {
      country = defaultCountry;
    }
    countryCallingCode = defaultCallingCode || getCountryCallingCode(defaultCountry, metadata2.metadata);
  } else return {};
  if (!number2) {
    return {
      countryCallingCodeSource,
      countryCallingCode
    };
  }
  var _extractNationalNumbe = extractNationalNumber(parseIncompletePhoneNumber(number2), metadata2), nationalNumber = _extractNationalNumbe.nationalNumber, carrierCode = _extractNationalNumbe.carrierCode;
  var exactCountry = getCountryByCallingCode(countryCallingCode, {
    nationalNumber,
    defaultCountry,
    metadata: metadata2
  });
  if (exactCountry) {
    country = exactCountry;
    if (exactCountry === "001") ;
    else {
      metadata2.country(country);
    }
  }
  return {
    country,
    countryCallingCode,
    countryCallingCodeSource,
    nationalNumber,
    carrierCode
  };
}
function ownKeys$2(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread$2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$2(Object(source), true).forEach(function(key) {
      _defineProperty$2(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$2(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumberWithError(text, options, metadata2) {
  return parse(text, _objectSpread$2(_objectSpread$2({}, options), {}, {
    v2: true
  }), metadata2);
}
function ownKeys$1(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys$1(Object(source), true).forEach(function(key) {
      _defineProperty$1(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty$1(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n2 = Object.prototype.toString.call(o).slice(8, -1);
  if (n2 === "Object" && o.constructor) n2 = o.constructor.name;
  if (n2 === "Map" || n2 === "Set") return Array.from(o);
  if (n2 === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n2)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n2 = true;
  var _d = false;
  var _s, _e2;
  try {
    for (_i = _i.call(arr); !(_n2 = (_s = _i.next()).done); _n2 = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e2 = err;
  } finally {
    try {
      if (!_n2 && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e2;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function normalizeArguments(args) {
  var _Array$prototype$slic = Array.prototype.slice.call(args), _Array$prototype$slic2 = _slicedToArray(_Array$prototype$slic, 4), arg_1 = _Array$prototype$slic2[0], arg_2 = _Array$prototype$slic2[1], arg_3 = _Array$prototype$slic2[2], arg_4 = _Array$prototype$slic2[3];
  var text;
  var options;
  var metadata2;
  if (typeof arg_1 === "string") {
    text = arg_1;
  } else throw new TypeError("A text for parsing must be a string.");
  if (!arg_2 || typeof arg_2 === "string") {
    if (arg_4) {
      options = arg_3;
      metadata2 = arg_4;
    } else {
      options = void 0;
      metadata2 = arg_3;
    }
    if (arg_2) {
      options = _objectSpread$1({
        defaultCountry: arg_2
      }, options);
    }
  } else if (isObject(arg_2)) {
    if (arg_3) {
      options = arg_2;
      metadata2 = arg_3;
    } else {
      metadata2 = arg_2;
    }
  } else throw new Error("Invalid second argument: ".concat(arg_2));
  return {
    text,
    options,
    metadata: metadata2
  };
}
function ownKeys(object2, enumerableOnly) {
  var keys4 = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    enumerableOnly && (symbols = symbols.filter(function(sym) {
      return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
    })), keys4.push.apply(keys4, symbols);
  }
  return keys4;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function parsePhoneNumber$2(text, options, metadata2) {
  if (options && options.defaultCountry && !isSupportedCountry(options.defaultCountry, metadata2)) {
    options = _objectSpread(_objectSpread({}, options), {}, {
      defaultCountry: void 0
    });
  }
  try {
    return parsePhoneNumberWithError(text, options, metadata2);
  } catch (error) {
    if (error instanceof ParseError) ;
    else {
      throw error;
    }
  }
}
function parsePhoneNumber$1() {
  var _normalizeArguments = normalizeArguments(arguments), text = _normalizeArguments.text, options = _normalizeArguments.options, metadata2 = _normalizeArguments.metadata;
  return parsePhoneNumber$2(text, options, metadata2);
}
function parsePhoneNumber() {
  return withMetadataArgument(parsePhoneNumber$1, arguments);
}
const _sfc_main$t = /* @__PURE__ */ defineComponent({
  __name: "TelInput",
  props: /* @__PURE__ */ mergeModels({
    label: { type: String, required: false },
    id: { type: String, required: false },
    class: { type: String, required: false },
    autocomplete: { type: String, required: false, default: "on" },
    placeholder: { type: String, required: false, default: "Enter a phone number" },
    required: { type: Boolean, required: false, default: false },
    modelValue: { type: String, required: true, default: "" },
    allCountries: { type: Array, required: false, default: () => allCountries },
    autoFormat: { type: Boolean, required: false, default: true },
    customValidate: { type: Boolean, required: false, skipCheck: true, default: false },
    defaultCountry: { type: [String, Number], required: false, default: "" },
    disabled: { type: Boolean, required: false, default: false },
    searchable: { type: Boolean, required: false, default: true },
    autoDefaultCountry: { type: Boolean, required: false, default: true },
    inputOptions: { type: Object, required: false },
    dropdownOptions: { type: Object, required: false },
    excludeCountries: { type: Array, required: false, default: () => [] },
    mode: { type: String, required: false, default: "INTERNATIONAL" },
    onlyCountries: { type: Array, required: false, default: () => [] },
    preferredCountries: { type: Array, required: false, default: () => [] },
    parseArg: { type: Object, required: false },
    debounceDelay: { type: Number, required: false, default: 300 }
  }, {
    "modelValue": { type: String, ...{
      default: ""
    } },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels([
    "update:modelValue",
    "change",
    "input",
    "blur",
    "focus",
    "country-changed",
    "enter",
    "space",
    "debounce"
  ], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    async function getIp() {
      const apiData = sessionStorage.getItem("ipapi");
      if (apiData) return JSON.parse(apiData);
      const { data: data2 } = await axios$1.get("https://ipapi.co/json/");
      sessionStorage.setItem("ipapi", JSON.stringify(data2));
      return data2;
    }
    const defaultDropdownOptions = {
      hide: false,
      disabled: false,
      showFlags: true,
      showDialCodeInSelection: true,
      showDialCodeInList: true,
      searchable: true
    };
    const defaultInputOptions = {
      "showDialCode": true,
      "autofocus": false,
      "aria-describedby": "",
      "id": "",
      "maxlength": 25,
      "minlength": 9,
      "pattern": void 0,
      "name": "",
      "readonly": false,
      "tabindex": 0,
      "style": ""
      // 'placeholder': 'Enter a phone number',
    };
    const computedDropDownOptions = computed(() => ({
      ...defaultDropdownOptions,
      ...props2.dropdownOptions
    }));
    const computedInputOptions = computed(() => ({
      ...defaultInputOptions,
      ...props2.inputOptions
    }));
    let activeCountryCode = ref();
    let open = ref(false);
    let selectedIndex = ref();
    const dropdownOpenDirection = ref("below");
    const searchQuery = ref("");
    const activeCountry = computed(
      () => props2.allCountries.find(
        (country) => {
          var _a2;
          return country.iso2 === ((_a2 = activeCountryCode.value) == null ? void 0 : _a2.toUpperCase());
        }
      )
    );
    const isPreferred = (country) => props2.preferredCountries.includes(country == null ? void 0 : country.iso2);
    const filteredCountries = computed(() => {
      if (props2.onlyCountries.length > 0) {
        return props2.allCountries.filter(
          ({ iso2 }) => props2.onlyCountries.some((c2) => c2.toUpperCase() === iso2)
        );
      }
      if (props2.excludeCountries.length > 0) {
        return props2.allCountries.filter(
          ({ iso2 }) => !props2.excludeCountries.includes(iso2.toUpperCase()) && !props2.excludeCountries.includes(iso2.toLowerCase())
        );
      }
      return props2.allCountries;
    });
    const sortedCountries = computed(() => {
      const preferredCountries = getCountries(props2.preferredCountries);
      const countriesList = [...preferredCountries, ...filteredCountries.value];
      const cleanInput = searchQuery.value.replaceAll(
        // eslint-disable-next-line regexp/no-obscure-range
        /[~`!#$%&*()+={};:'"<>.,/?-_]/g,
        ""
      );
      return countriesList.filter(
        (c2) => new RegExp(cleanInput, "i").test(c2.name || "") || new RegExp(cleanInput, "i").test(c2.iso2 || "") || new RegExp(cleanInput, "i").test(c2.dialCode || "")
      ).filter(Boolean);
    });
    const parseArgs = computed(() => ({
      ...props2.parseArg,
      defaultCountry: activeCountryCode.value
    }));
    const phone = useModel(__props, "modelValue", {
      set: (value) => {
        let maybeFormatted = value;
        if (value.length > 5) {
          maybeFormatted = formatPhone(`${value}`);
          if (!maybeFormatted) {
            emit2("update:modelValue", "");
            return "";
          }
        }
        emit2("update:modelValue", maybeFormatted);
        debounce(() => {
          emit2("debounce", maybeFormatted);
        }, props2.debounceDelay);
        return maybeFormatted;
      },
      get: (value) => value
    });
    function formatPhone(val) {
      var _a2;
      const phoneNumber = parsePhoneNumber(val, parseArgs.value);
      if (!phoneNumber) {
        const dialCode = ((_a2 = sortedCountries.value.find((c2) => c2.iso2 === activeCountryCode.value)) == null ? void 0 : _a2.dialCode) || "";
        if (props2.mode === "INTERNATIONAL") return `+${dialCode}`;
        return dialCode;
      }
      return phoneNumber.format(props2.mode).replaceAll(" ", "") || "";
    }
    watch(
      () => activeCountry.value,
      (value, oldValue) => {
        if (!value && (oldValue == null ? void 0 : oldValue.iso2)) {
          activeCountryCode.value = oldValue.iso2;
          return;
        }
        if (value == null ? void 0 : value.iso2) emit2("country-changed", value);
      }
    );
    async function initializeCountry() {
      if (props2.defaultCountry) {
        if (typeof props2.defaultCountry === "string") {
          chooseCountry(props2.defaultCountry);
          return;
        }
        if (typeof props2.defaultCountry === "number") {
          const country = findCountryByDialCode(props2.defaultCountry);
          if (country) {
            chooseCountry(country.iso2);
            return;
          }
        }
      }
      const fallbackCountry = sortedCountries.value[0];
      if (props2.autoDefaultCountry) {
        try {
          const res = (await getIp()).country;
          chooseCountry(res || activeCountryCode.value);
        } catch (error) {
          console.warn(error);
          chooseCountry(fallbackCountry.iso2);
        }
      } else {
        chooseCountry(fallbackCountry.iso2);
      }
    }
    onMounted(initializeCountry);
    const findCountry = (iso) => filteredCountries.value.find((country) => country.iso2 === iso.toUpperCase());
    function getCountries(list) {
      const countryList = [];
      list.forEach((countryCode) => {
        const country = findCountry(countryCode);
        if (country) countryList.push(country);
      });
      return countryList;
    }
    function findCountryByDialCode(dialCode) {
      return filteredCountries.value.find((country) => Number(country.dialCode) === dialCode);
    }
    const phoneDropdown = ref();
    function chooseCountry(country) {
      var _a2, _b;
      if (!country) return;
      const parsedCountry = findCountry(country);
      if (!parsedCountry) return;
      activeCountryCode.value = parsedCountry.iso2;
      if (((_a2 = props2.inputOptions) == null ? void 0 : _a2.showDialCode) && parsedCountry) {
        phone.value = `+ ${parsedCountry.dialCode}`;
        activeCountryCode.value = parsedCountry.iso2 || "";
        return;
      }
      activeCountryCode.value = parsedCountry.iso2 || "";
      (_b = phoneDropdown.value) == null ? void 0 : _b.hide();
    }
    function onBlur() {
      emit2("blur");
    }
    function onFocus() {
      emit2("focus");
    }
    function onEnter(e) {
      emit2("enter");
    }
    function onSpace() {
      emit2("space");
    }
    function reset() {
      selectedIndex.value = sortedCountries.value.findIndex(
        (c2) => c2.iso2 === activeCountryCode.value
      );
      open.value = false;
    }
    function handleInput(e) {
      const keyVal = e.key ?? "";
      if (keyVal.length > 1 || e.metaKey) return;
      const hasBadChars = /[^+\d]/.test(keyVal);
      if (!hasBadChars) return;
      e.preventDefault();
    }
    const __returned__ = { props: props2, emit: emit2, getIp, defaultDropdownOptions, defaultInputOptions, computedDropDownOptions, computedInputOptions, get activeCountryCode() {
      return activeCountryCode;
    }, set activeCountryCode(v) {
      activeCountryCode = v;
    }, get open() {
      return open;
    }, set open(v) {
      open = v;
    }, get selectedIndex() {
      return selectedIndex;
    }, set selectedIndex(v) {
      selectedIndex = v;
    }, dropdownOpenDirection, searchQuery, activeCountry, isPreferred, filteredCountries, sortedCountries, parseArgs, phone, formatPhone, initializeCountry, findCountry, getCountries, findCountryByDialCode, phoneDropdown, chooseCountry, onBlur, onFocus, onEnter, onSpace, reset, handleInput, get Dropdown() {
      return Dropdown;
    }, get Flag() {
      return Flag;
    }, get Icon() {
      return Icon;
    }, get TextInput() {
      return TextInput;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$l = ["aria-expanded"];
const _hoisted_2$c = { class: "p-075 tel-countryp-dropdown" };
const _hoisted_3$a = ["aria-selected", "onClick", "onMousemove"];
const _hoisted_4$6 = { class: "tel-country" };
const _hoisted_5$6 = { key: 1 };
const _hoisted_6$5 = ["id", "required", "placeholder", "disabled", "autocomplete", "pattern", "minlength", "maxlength", "name", "readonly", "tabindex", "aria-describedby"];
function _sfc_render$t(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["bagel-input", { disabled: $props.disabled, [$setup.props.class || ""]: true }])
    },
    [
      createElementVNode("label", null, [
        createTextVNode(
          toDisplayString($props.label) + " ",
          1
          /* TEXT */
        ),
        createElementVNode("div", {
          dir: "ltr",
          class: "flex gap-05 tel-input",
          tabindex: "-1",
          "aria-label": "Country Code Selector",
          "aria-haspopup": "listbox",
          "aria-expanded": $setup.open,
          onKeydown: [
            withKeys($setup.reset, ["esc"]),
            withKeys($setup.reset, ["tab"])
          ]
        }, [
          !$setup.computedDropDownOptions.hide ? (openBlock(), createBlock($setup["Dropdown"], {
            key: 0,
            ref: "phoneDropdown",
            placement: "bottom-start",
            disabled: $setup.computedDropDownOptions.disabled,
            onHide: _cache[2] || (_cache[2] = ($event) => $setup.open = false)
          }, {
            trigger: withCtx(() => [
              createElementVNode("span", {
                class: "flex gap-05",
                onClick: _cache[0] || (_cache[0] = ($event) => $setup.open = true)
              }, [
                createVNode($setup["Icon"], {
                  icon: $setup.open ? "collapse_all" : "expand_all"
                }, null, 8, ["icon"]),
                $setup.computedDropDownOptions.showFlags && $setup.activeCountryCode ? (openBlock(), createBlock($setup["Flag"], {
                  key: 0,
                  country: $setup.activeCountryCode
                }, null, 8, ["country"])) : createCommentVNode("v-if", true)
              ])
            ]),
            default: withCtx(() => [
              createElementVNode("div", _hoisted_2$c, [
                $props.searchable ? (openBlock(), createBlock($setup["TextInput"], {
                  key: 0,
                  modelValue: $setup.searchQuery,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.searchQuery = $event),
                  "aria-label": "Search by country name or country code",
                  placeholder: "Search",
                  icon: "search"
                }, null, 8, ["modelValue"])) : createCommentVNode("v-if", true),
                createElementVNode(
                  "ul",
                  {
                    class: normalizeClass(["overflow-y p-0", $setup.dropdownOpenDirection]),
                    style: { "max-height": "400px" },
                    role: "listbox"
                  },
                  [
                    (openBlock(true), createElementBlock(
                      Fragment,
                      null,
                      renderList($setup.sortedCountries, (pb, index2) => {
                        return openBlock(), createElementBlock("li", {
                          key: pb.iso2 + $setup.isPreferred(pb),
                          role: "option",
                          class: "flex gap-075",
                          tabindex: "-1",
                          "aria-selected": $setup.activeCountryCode === pb.iso2 && !$setup.isPreferred(pb),
                          onClick: ($event) => $setup.chooseCountry(pb.iso2),
                          onMousemove: ($event) => $setup.selectedIndex = index2
                        }, [
                          $setup.computedDropDownOptions.showFlags ? (openBlock(), createBlock($setup["Flag"], {
                            key: 0,
                            country: pb.iso2
                          }, null, 8, ["country"])) : createCommentVNode("v-if", true),
                          createElementVNode(
                            "p",
                            _hoisted_4$6,
                            toDisplayString(pb.name),
                            1
                            /* TEXT */
                          ),
                          $setup.computedDropDownOptions.showDialCodeInList ? (openBlock(), createElementBlock(
                            "span",
                            _hoisted_5$6,
                            " +" + toDisplayString(pb.dialCode),
                            1
                            /* TEXT */
                          )) : createCommentVNode("v-if", true)
                        ], 40, _hoisted_3$a);
                      }),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ],
                  2
                  /* CLASS */
                )
              ])
            ]),
            _: 1
            /* STABLE */
          }, 8, ["disabled"])) : createCommentVNode("v-if", true),
          createCommentVNode(' ref="refInput" '),
          withDirectives(createElementVNode("input", {
            id: $props.id,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => $setup.phone = $event),
            required: $props.required,
            placeholder: $setup.props.placeholder || "Enter a phone number",
            disabled: $props.disabled,
            type: "tel",
            autocomplete: $props.autocomplete,
            class: "vti__input",
            pattern: $setup.computedInputOptions.pattern,
            minlength: $setup.computedInputOptions.minlength,
            maxlength: $setup.computedInputOptions.maxlength,
            name: $setup.computedInputOptions.name,
            readonly: $setup.computedInputOptions.readonly,
            tabindex: $setup.computedInputOptions.tabindex,
            "aria-describedby": $setup.computedInputOptions["aria-describedby"],
            style: normalizeStyle($setup.computedInputOptions.style),
            onBlur: $setup.onBlur,
            onFocus: $setup.onFocus,
            onKeyup: [
              withKeys($setup.onEnter, ["enter"]),
              withKeys($setup.onSpace, ["space"])
            ],
            onKeydown: $setup.handleInput
          }, null, 44, _hoisted_6$5), [
            [vModelText, $setup.phone]
          ])
        ], 40, _hoisted_1$l)
      ])
    ],
    2
    /* CLASS */
  );
}
const TelInput = /* @__PURE__ */ _export_sfc(_sfc_main$t, [["render", _sfc_render$t], ["__scopeId", "data-v-48d9a468"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/TelInput.vue"]]);
const _sfc_main$s = /* @__PURE__ */ defineComponent({
  __name: "TextInput",
  props: {
    id: { type: String, required: false },
    title: { type: String, required: false },
    helptext: { type: String, required: false },
    placeholder: { type: String, required: false },
    modelValue: { type: [String, Number], required: false, default: "" },
    label: { type: String, required: false },
    small: { type: Boolean, required: false },
    dense: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    pattern: { type: String, required: false },
    shrink: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
    type: { type: String, required: false, default: "text" },
    nativeInputAttrs: { type: Object, required: false },
    icon: { type: null, required: false },
    iconStart: { type: null, required: false },
    multiline: { type: Boolean, required: false },
    autoheight: { type: Boolean, required: false },
    code: { type: Boolean, required: false },
    lines: { type: [Number, String], required: false },
    autocomplete: { type: null, required: false },
    autofocus: { type: Boolean, required: false },
    debounceDelay: { type: Number, required: false, default: 300 },
    onFocusout: { type: Function, required: false }
  },
  emits: ["update:modelValue", "debounce"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    let inputVal = ref();
    const input = ref();
    const rows = computed(() => {
      if (props2.lines) return props2.lines;
      if (props2.autoheight) return `${inputVal.value}`.split("\n").length || 1;
      if (props2.multiline || props2.code) return 4;
      return 1;
    });
    const debounceUpdate = useDebounceFn(() => {
      emit2("debounce", inputVal.value);
    }, props2.debounceDelay);
    function updateInputVal() {
      if (props2.disabled) return;
      emit2("update:modelValue", inputVal.value);
      void debounceUpdate();
    }
    watch(
      () => props2.modelValue,
      (newVal) => {
        if (newVal !== inputVal.value) inputVal.value = newVal;
      },
      { immediate: true }
    );
    const hasFocus = () => document.activeElement === input.value;
    const focus = () => {
      var _a2;
      return (_a2 = input.value) == null ? void 0 : _a2.focus();
    };
    __expose({ focus, hasFocus });
    onMounted(() => {
      if (props2.autofocus) setTimeout(() => {
        var _a2;
        return (_a2 = input.value) == null ? void 0 : _a2.focus();
      }, 10);
    });
    const __returned__ = { props: props2, emit: emit2, get inputVal() {
      return inputVal;
    }, set inputVal(v) {
      inputVal = v;
    }, input, rows, debounceUpdate, updateInputVal, hasFocus, focus, get MaterialIcon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$k = ["title"];
const _hoisted_2$b = ["for"];
const _hoisted_3$9 = ["id", "title", "autocomplete", "type", "placeholder", "disabled", "required", "pattern"];
const _hoisted_4$5 = ["id", "title", "type", "rows", "placeholder", "disabled", "required", "pattern"];
const _hoisted_5$5 = { key: 2 };
function _sfc_render$s(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["bagel-input text-input", {
      dense: $props.dense,
      small: $props.small,
      shrink: $props.shrink,
      code: $props.code,
      textInputIconWrap: $props.icon,
      txtInputIconStart: $props.iconStart
    }]),
    title: $props.title
  }, [
    createElementVNode("label", { for: $props.id }, [
      createTextVNode(
        toDisplayString($props.label) + " ",
        1
        /* TEXT */
      ),
      !$props.multiline && !$props.autoheight && !$props.code ? withDirectives((openBlock(), createElementBlock("input", mergeProps({
        key: 0,
        id: $props.id,
        ref: "input",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.inputVal = $event),
        title: $props.title,
        autocomplete: $props.autocomplete,
        type: $props.type,
        rows: 1,
        placeholder: $props.placeholder || $props.label,
        disabled: $props.disabled,
        required: $props.required,
        pattern: $props.pattern
      }, $props.nativeInputAttrs, {
        onFocusout: _cache[1] || (_cache[1] = (...args) => $props.onFocusout && $props.onFocusout(...args)),
        onInput: $setup.updateInputVal
      }), null, 16, _hoisted_3$9)), [
        [
          vModelDynamic,
          $setup.inputVal,
          void 0,
          { trim: true }
        ]
      ]) : withDirectives((openBlock(), createElementBlock("textarea", mergeProps({
        key: 1,
        id: $props.id,
        ref: "input",
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => $setup.inputVal = $event),
        title: $props.title,
        type: $props.type,
        rows: $setup.rows,
        placeholder: $props.placeholder || $props.label,
        disabled: $props.disabled,
        required: $props.required,
        pattern: $props.pattern
      }, $props.nativeInputAttrs, {
        onInput: $setup.updateInputVal,
        onFocusout: _cache[3] || (_cache[3] = (...args) => $props.onFocusout && $props.onFocusout(...args))
      }), null, 16, _hoisted_4$5)), [
        [vModelText, $setup.inputVal]
      ]),
      $props.helptext ? (openBlock(), createElementBlock(
        "p",
        _hoisted_5$5,
        toDisplayString($props.helptext),
        1
        /* TEXT */
      )) : createCommentVNode("v-if", true),
      $props.iconStart ? (openBlock(), createBlock($setup["MaterialIcon"], {
        key: 3,
        class: "iconStart",
        icon: $props.iconStart
      }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
      $props.icon ? (openBlock(), createBlock($setup["MaterialIcon"], {
        key: 4,
        icon: $props.icon
      }, null, 8, ["icon"])) : createCommentVNode("v-if", true)
    ], 8, _hoisted_2$b)
  ], 10, _hoisted_1$k);
}
const TextInput = /* @__PURE__ */ _export_sfc(_sfc_main$s, [["render", _sfc_render$s], ["__scopeId", "data-v-5124e6dd"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/TextInput.vue"]]);
const _sfc_main$r = /* @__PURE__ */ defineComponent({
  __name: "ToggleInput",
  props: /* @__PURE__ */ mergeModels({
    label: { type: String, required: true },
    id: { type: String, required: false },
    title: { type: String, required: false },
    small: { type: Boolean, required: false },
    required: { type: Boolean, required: false },
    defaultValue: { type: Boolean, required: false, default: false }
  }, {
    "modelValue": { type: Boolean, skipCheck: true, ...{ default: void 0 } },
    "modelModifiers": {}
  }),
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const inputId = ref(props2.id || Math.random().toString(36).slice(7));
    const checked = useModel(__props, "modelValue");
    onMounted(() => {
      if (checked.value === void 0) checked.value = props2.defaultValue;
    });
    const __returned__ = { props: props2, inputId, checked };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$j = ["title"];
const _hoisted_2$a = ["id", "required"];
const _hoisted_3$8 = ["for"];
function _sfc_render$r(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    class: normalizeClass(["bagel-input bgl-toggle", { small: $props.small }]),
    title: $props.title
  }, [
    createElementVNode(
      "div",
      {
        class: normalizeClass(["switch", { checked: $setup.checked }])
      },
      _cache[1] || (_cache[1] = [
        createElementVNode(
          "span",
          { class: "slider rounded" },
          null,
          -1
          /* HOISTED */
        )
      ]),
      2
      /* CLASS */
    ),
    withDirectives(createElementVNode("input", {
      id: $setup.inputId,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.checked = $event),
      type: "checkbox",
      required: $props.required
    }, null, 8, _hoisted_2$a), [
      [vModelCheckbox, $setup.checked]
    ]),
    createElementVNode("label", { for: $setup.inputId }, [
      renderSlot(_ctx.$slots, "label", {}, () => [
        createTextVNode(
          toDisplayString($props.label),
          1
          /* TEXT */
        )
      ], true)
    ], 8, _hoisted_3$8)
  ], 10, _hoisted_1$j);
}
const ToggleInput = /* @__PURE__ */ _export_sfc(_sfc_main$r, [["render", _sfc_render$r], ["__scopeId", "data-v-905f82b8"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/ToggleInput.vue"]]);
const files = {
  setBaseUrl: (baseUrl) => {
    if (!baseUrl) return;
    baseUrl = baseUrl.replace(/\/$/, "");
    axios$1.defaults.baseURL = baseUrl;
  },
  get: async (pathKey) => {
    return axios$1.get("/files/", { params: { path_key: pathKey } });
  },
  put: async (bglFilePatch, pathKey) => {
    return axios$1.put("/files/", bglFilePatch, { params: { path_key: pathKey } });
  },
  delete: async (pathKey) => {
    return axios$1.delete("/files/", { params: { path_key: pathKey } });
  },
  upload: async (file, options) => {
    const formData = new FormData();
    formData.append("upload", file);
    return axios$1.post("/files/upload", formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: options == null ? void 0 : options.onUploadProgress,
      params: { dir_path: options == null ? void 0 : options.dirPath, tags: options == null ? void 0 : options.tags }
    });
  }
};
const _sfc_main$q = /* @__PURE__ */ defineComponent({
  __name: "UploadInput",
  props: {
    label: { type: String, required: false },
    multiple: { type: Boolean, required: false },
    modelValue: { type: [String, Array], required: false },
    width: { type: String, required: false },
    height: { type: String, required: false, default: "215px" },
    dirPath: { type: String, required: false },
    fill: { type: Boolean, required: false },
    oval: { type: Boolean, required: false },
    theme: { type: String, required: false, default: "dropzone" },
    accept: { type: String, required: false, default: "*" },
    required: { type: Boolean, required: false },
    disabled: { type: Boolean, required: false },
    baseURL: { type: String, required: false }
  },
  emits: ["update:modelValue", "addFileStart"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const bagel = useBagel();
    files.setBaseUrl(bagel.host);
    const fileBaseUrl = computed(() => (props2.baseURL || bagel.fileBaseUrl || "https://files.bagel.design").replace(/\/$/, ""));
    const pathToUrl = (path_key) => `${fileBaseUrl.value}/${path_key}`;
    const fileQueue = ref([]);
    let storageFiles = ref([]);
    const pk = ref([props2.modelValue].flat().filter(Boolean));
    const pathKeys = computed(() => {
      const sf = storageFiles.value.map((file) => file.path_key);
      return [...pk.value, ...sf];
    });
    watch(() => pk.value, (value) => {
      if (props2.multiple) emit2("update:modelValue", value);
      else emit2("update:modelValue", value[0] || void 0);
    }, { deep: true });
    const isImage = (str) => IMAGE_FORMATS_REGEXP.test(str);
    const fileToUrl = (file) => URL.createObjectURL(file);
    let isDragOver = ref(false);
    async function removeFile(path_key) {
      storageFiles.value = storageFiles.value.filter((file) => file.path_key !== path_key);
      const pki = pk.value.indexOf(path_key);
      if (pki !== -1) pk.value.splice(pki, 1);
      try {
        await files.delete(path_key);
      } catch (error) {
        console.error(error);
      }
    }
    async function flushQueue() {
      emit2("addFileStart");
      for (const file of fileQueue.value) {
        file.uploading = true;
        if (!props2.multiple) pk.value.splice(0, 1);
        try {
          const { data: data2 } = await files.upload(file.file, {
            onUploadProgress: (e) => {
              file.progress = e.loaded / e.total * 100 - 1;
            },
            dirPath: props2.dirPath
          });
          pk.value.push(data2.path_key);
        } catch (error) {
          console.error("error flushing queue", error);
        }
      }
      fileQueue.value.splice(0, fileQueue.value.length);
    }
    function browse() {
      if (props2.disabled) return;
      const input = document.createElement("input");
      input.type = "file";
      input.multiple = props2.multiple;
      input.accept = props2.accept;
      input.onchange = (e) => {
        const files2 = Array.from(e.target.files || []);
        fileQueue.value.push(...files2.map((file) => ({ name: file.name, file, progress: 0 })));
        flushQueue();
      };
      input.click();
    }
    function handleDrag(e, isDragging = false) {
      e.preventDefault();
      e.stopPropagation();
      if (!props2.disabled) isDragOver.value = isDragging;
    }
    function handleDrop(e) {
      var _a2;
      if (props2.disabled) return;
      e.preventDefault();
      e.stopPropagation();
      if ((_a2 = e.dataTransfer) == null ? void 0 : _a2.files) {
        fileQueue.value.push(...Array.from(e.dataTransfer.files).map((file) => ({ name: file.name, file, progress: 0 })));
        flushQueue();
      }
      isDragOver.value = false;
    }
    if (props2.dirPath) {
      files.get(props2.dirPath).then((response) => storageFiles.value.push(...[response.data].flat())).catch(console.error);
    }
    watch(() => props2.dirPath, () => {
      if (props2.dirPath) {
        files.get(props2.dirPath).then((response) => storageFiles.value.push(...[response.data].flat())).catch(console.error);
      }
    });
    const __returned__ = { props: props2, emit: emit2, bagel, fileBaseUrl, pathToUrl, fileQueue, get storageFiles() {
      return storageFiles;
    }, set storageFiles(v) {
      storageFiles = v;
    }, pk, pathKeys, isImage, fileToUrl, get isDragOver() {
      return isDragOver;
    }, set isDragOver(v) {
      isDragOver = v;
    }, removeFile, flushQueue, browse, handleDrag, handleDrop, get Btn() {
      return Btn;
    }, get Icon() {
      return Icon;
    }, get Card() {
      return Card;
    }, get Image() {
      return Image$1;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$i = { class: "bagel-input" };
const _hoisted_2$9 = { key: 0 };
const _hoisted_3$7 = {
  key: 1,
  placeholder: "required",
  type: "text",
  required: "",
  class: "pixel"
};
const _hoisted_4$4 = { class: "m-05 flex opacity-7 z-99" };
const _hoisted_5$4 = { class: "ellipsis-1 word-break-all h-20 m-0" };
const _hoisted_6$4 = {
  key: 1,
  class: "txt-gray txt-12"
};
const _hoisted_7$3 = {
  key: 0,
  class: "bgl-multi-preview"
};
const _hoisted_8$3 = { class: "m-0" };
const _hoisted_9$2 = { class: "no-margin multi-preview-txt" };
const _hoisted_10$2 = {
  key: 0,
  class: "progress"
};
const _hoisted_11$2 = {
  key: 1,
  class: "bgl-single-preview"
};
const _hoisted_12$1 = { class: "position-start m-05 flex opacity-7 z-99 gap-025" };
const _hoisted_13$1 = {
  key: 0,
  class: "h-100"
};
const _hoisted_14 = {
  key: 0,
  class: "progress"
};
const _hoisted_15 = { class: "p-1 flex column hover fileUploadPlaceHolder justify-content-center mb-05" };
function _sfc_render$q(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_tooltip = resolveDirective("tooltip");
  const _directive_lightbox = resolveDirective("lightbox");
  return openBlock(), createElementBlock("div", _hoisted_1$i, [
    $props.label ? (openBlock(), createElementBlock(
      "label",
      _hoisted_2$9,
      toDisplayString($props.label),
      1
      /* TEXT */
    )) : createCommentVNode("v-if", true),
    $props.required && !$setup.pathKeys.length ? (openBlock(), createElementBlock("input", _hoisted_3$7)) : createCommentVNode("v-if", true),
    $props.theme === "basic" ? (openBlock(), createBlock($setup["Card"], {
      key: 2,
      outline: "",
      class: "flex p-05 gap-1",
      onDragover: _cache[0] || (_cache[0] = (e) => $setup.handleDrag(e, true)),
      onDrop: $setup.handleDrop
    }, {
      default: withCtx(() => [
        !$setup.pathKeys.length && !$setup.fileQueue.length ? (openBlock(), createBlock($setup["Btn"], {
          key: 0,
          class: "px-1-5",
          icon: "upload",
          outline: "",
          onClick: $setup.browse
        }, {
          default: withCtx(() => _cache[3] || (_cache[3] = [
            createTextVNode(" Upload ")
          ])),
          _: 1
          /* STABLE */
        })) : createCommentVNode("v-if", true),
        (openBlock(true), createElementBlock(
          Fragment,
          null,
          renderList($setup.pathKeys, (path_key) => {
            return openBlock(), createElementBlock("div", {
              key: path_key,
              class: "txt-gray txt-12 flex"
            }, [
              createElementVNode("div", _hoisted_4$4, [
                withDirectives(createVNode($setup["Btn"], {
                  color: "gray",
                  thin: "",
                  icon: "delete",
                  onClick: ($event) => $setup.removeFile(path_key)
                }, null, 8, ["onClick"]), [
                  [_directive_tooltip, "Delete"]
                ]),
                withDirectives(createVNode(
                  $setup["Btn"],
                  {
                    color: "gray",
                    thin: "",
                    icon: "autorenew",
                    onClick: $setup.browse
                  },
                  null,
                  512
                  /* NEED_PATCH */
                ), [
                  [_directive_tooltip, "Replace"]
                ]),
                createVNode($setup["Btn"], {
                  icon: "download",
                  flat: "",
                  thin: "",
                  href: $setup.pathToUrl(path_key),
                  download: path_key.split("/").pop()
                }, null, 8, ["href", "download"]),
                withDirectives((openBlock(), createElementBlock("p", _hoisted_5$4, [
                  createTextVNode(
                    toDisplayString(path_key.split("/").pop()),
                    1
                    /* TEXT */
                  )
                ])), [
                  [_directive_lightbox, { src: $setup.pathToUrl(path_key), download: true }]
                ])
              ])
            ]);
          }),
          128
          /* KEYED_FRAGMENT */
        )),
        !$setup.pathKeys.length && !$setup.fileQueue.length ? (openBlock(), createElementBlock("span", _hoisted_6$4, " No file selected ")) : createCommentVNode("v-if", true)
      ]),
      _: 1
      /* STABLE */
    })) : (openBlock(), createElementBlock(
      "div",
      {
        key: 3,
        class: normalizeClass(["fileUploadWrap", {
          "fileDropZone": !$setup.pathKeys.length && !$setup.fileQueue.length,
          "dragover": $setup.isDragOver,
          "bgl_oval-upload": $props.oval
        }]),
        style: normalizeStyle({ width: $props.width, height: $props.height }),
        onClick: $setup.browse,
        onDragover: _cache[1] || (_cache[1] = (e) => $setup.handleDrag(e, true)),
        onDrop: $setup.handleDrop,
        onDragleave: _cache[2] || (_cache[2] = (e) => $setup.handleDrag(e))
      },
      [
        renderSlot(_ctx.$slots, "files", {
          files: $setup.pathKeys,
          fileQueue: $setup.fileQueue
        }, () => [
          $props.multiple ? (openBlock(), createElementBlock("div", _hoisted_7$3, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.pathKeys, (path_key) => {
                return withDirectives((openBlock(), createElementBlock(
                  "div",
                  {
                    key: path_key,
                    class: normalizeClass(["multi-image-item-preview", { "bgl_fill-image": $props.fill }])
                  },
                  [
                    $setup.isImage(path_key) ? (openBlock(), createBlock($setup["Image"], {
                      key: 0,
                      pathKey: path_key,
                      class: "multi-preview"
                    }, null, 8, ["pathKey"])) : (openBlock(), createBlock($setup["Icon"], {
                      key: 1,
                      icon: "description",
                      class: "multi-preview"
                    })),
                    createElementVNode(
                      "p",
                      _hoisted_8$3,
                      toDisplayString(path_key.split("/").pop()),
                      1
                      /* TEXT */
                    ),
                    createVNode($setup["Btn"], {
                      thin: "",
                      flat: "",
                      icon: "delete",
                      color: "red",
                      onClick: ($event) => $setup.removeFile(path_key)
                    }, null, 8, ["onClick"])
                  ],
                  2
                  /* CLASS */
                )), [
                  [_directive_lightbox, { src: $setup.pathToUrl(path_key), download: true }]
                ]);
              }),
              128
              /* KEYED_FRAGMENT */
            )),
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.fileQueue, (file) => {
                return openBlock(), createElementBlock(
                  "div",
                  {
                    key: file.name,
                    class: normalizeClass(["multi-image-item-preview", { "bgl_fill-image": $props.fill }])
                  },
                  [
                    $setup.isImage(file.file.type) ? (openBlock(), createBlock($setup["Image"], {
                      key: 0,
                      class: "multi-preview",
                      src: $setup.fileToUrl(file.file),
                      alt: ""
                    }, null, 8, ["src"])) : (openBlock(), createBlock($setup["Icon"], {
                      key: 1,
                      icon: "description",
                      class: "multi-preview"
                    })),
                    createElementVNode(
                      "p",
                      _hoisted_9$2,
                      toDisplayString(file.name),
                      1
                      /* TEXT */
                    ),
                    createElementVNode(
                      "div",
                      {
                        class: normalizeClass(["pie", { complete: file.progress === 100 }]),
                        style: normalizeStyle([{ "--p": file.progress }, { "--b": "2px" }])
                      },
                      [
                        file.progress < 100 ? (openBlock(), createElementBlock(
                          "span",
                          _hoisted_10$2,
                          toDisplayString(file.progress.toFixed(0)),
                          1
                          /* TEXT */
                        )) : createCommentVNode("v-if", true),
                        createVNode($setup["Icon"], {
                          class: "success",
                          icon: "check_circle"
                        })
                      ],
                      6
                      /* CLASS, STYLE */
                    )
                  ],
                  2
                  /* CLASS */
                );
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])) : $setup.pathKeys.length > 0 || $setup.fileQueue.length > 0 ? (openBlock(), createElementBlock("div", _hoisted_11$2, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.pathKeys, (path_key) => {
                return openBlock(), createElementBlock(
                  "div",
                  {
                    key: path_key,
                    class: normalizeClass(["single-image-item-preview", { "bgl_fill-image": $props.fill }])
                  },
                  [
                    createElementVNode("div", _hoisted_12$1, [
                      withDirectives(createVNode($setup["Btn"], {
                        color: "gray",
                        thin: "",
                        icon: "delete",
                        onClick: ($event) => $setup.removeFile(path_key)
                      }, null, 8, ["onClick"]), [
                        [_directive_tooltip, "Delete"]
                      ]),
                      withDirectives(createVNode(
                        $setup["Btn"],
                        {
                          color: "gray",
                          thin: "",
                          icon: "autorenew",
                          onClick: $setup.browse
                        },
                        null,
                        512
                        /* NEED_PATCH */
                      ), [
                        [_directive_tooltip, "Replace"]
                      ]),
                      withDirectives(createVNode($setup["Btn"], {
                        color: "gray",
                        thin: "",
                        icon: "download",
                        href: $setup.pathToUrl(path_key),
                        download: path_key.split("/").pop()
                      }, null, 8, ["href", "download"]), [
                        [_directive_tooltip, "Download"]
                      ])
                    ]),
                    $setup.isImage(path_key) ? (openBlock(), createElementBlock("div", _hoisted_13$1, [
                      createVNode($setup["Image"], {
                        class: "single-preview",
                        pathKey: path_key,
                        alt: ""
                      }, null, 8, ["pathKey"])
                    ])) : withDirectives((openBlock(), createBlock(
                      $setup["Icon"],
                      {
                        key: 1,
                        size: 4,
                        weight: "2",
                        icon: "description",
                        class: "color-primary w-100"
                      },
                      null,
                      512
                      /* NEED_PATCH */
                    )), [
                      [_directive_lightbox, { src: $setup.pathToUrl(path_key), download: true }]
                    ])
                  ],
                  2
                  /* CLASS */
                );
              }),
              128
              /* KEYED_FRAGMENT */
            )),
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($setup.fileQueue, (file) => {
                return openBlock(), createElementBlock(
                  "div",
                  {
                    key: file.name,
                    class: normalizeClass(["single-image-item-preview", { "bgl_fill-image": $props.fill }])
                  },
                  [
                    createElementVNode(
                      "div",
                      {
                        class: normalizeClass(["pie", { complete: file.progress === 100 }]),
                        style: normalizeStyle([{ "--p": file.progress }, { "--b": "2px" }])
                      },
                      [
                        file.progress < 100 ? (openBlock(), createElementBlock(
                          "span",
                          _hoisted_14,
                          toDisplayString(file.progress.toFixed(0)),
                          1
                          /* TEXT */
                        )) : createCommentVNode("v-if", true),
                        createVNode($setup["Icon"], {
                          class: "success",
                          icon: "check_circle"
                        })
                      ],
                      6
                      /* CLASS, STYLE */
                    ),
                    $setup.isImage(file.file.type) ? (openBlock(), createBlock($setup["Image"], {
                      key: 0,
                      class: "single-preview",
                      src: $setup.fileToUrl(file.file),
                      alt: ""
                    }, null, 8, ["src"])) : createCommentVNode("v-if", true)
                  ],
                  2
                  /* CLASS */
                );
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])) : createCommentVNode("v-if", true)
        ], true),
        !$setup.pathKeys.length && !$setup.fileQueue.length || $props.multiple ? renderSlot(_ctx.$slots, "placeholder", {
          key: 0,
          files: $setup.pathKeys,
          fileQueue: $setup.fileQueue,
          browse: $setup.browse
        }, () => [
          createElementVNode("p", _hoisted_15, [
            createVNode($setup["Icon"], { icon: "upload_2" }),
            _cache[4] || (_cache[4] = createTextVNode(" Drop files here or click to upload "))
          ])
        ], true) : createCommentVNode("v-if", true)
      ],
      38
      /* CLASS, STYLE, NEED_HYDRATION */
    ))
  ]);
}
const UploadInput = /* @__PURE__ */ _export_sfc(_sfc_main$q, [["render", _sfc_render$q], ["__scopeId", "data-v-bec8d254"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/form/inputs/Upload/UploadInput.vue"]]);
const _sfc_main$p = /* @__PURE__ */ defineComponent({
  __name: "IframeVue",
  props: {
    src: { type: String, required: true },
    title: { type: String, required: false },
    height: { type: String, required: false },
    width: { type: String, required: false },
    name: { type: String, required: false },
    sandbox: { type: String, required: false },
    allow: { type: String, required: false },
    allowfullscreen: { type: Boolean, required: false },
    loading: { type: String, required: false },
    referrerpolicy: { type: String, required: false },
    marginwidth: { type: Number, required: false },
    marginheight: { type: Number, required: false },
    scrolling: { type: String, required: false },
    csp: { type: String, required: false },
    srcset: { type: String, required: false }
  },
  emits: ["message", "load"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit2 = __emit;
    const iframe = ref();
    function handleMessage(event) {
      emit2("message", event.data);
    }
    function handleMessageWrapper(event) {
      var _a2;
      if (event.source === ((_a2 = iframe.value) == null ? void 0 : _a2.contentWindow)) {
        handleMessage(event);
      }
    }
    onMounted(() => {
      window.addEventListener("message", handleMessageWrapper);
    });
    onBeforeUnmount(() => {
      window.removeEventListener("message", handleMessageWrapper);
    });
    const contentWindow = () => {
      var _a2;
      return (_a2 = iframe.value) == null ? void 0 : _a2.contentWindow;
    };
    __expose({ contentWindow });
    const __returned__ = { emit: emit2, iframe, handleMessage, handleMessageWrapper, contentWindow };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$h = ["src", "title", "width", "height", "marginwidth", "marginheight", "csp", "scrolling", "srcset"];
function _sfc_render$p(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("iframe", {
    ref: "iframe",
    src: $props.src,
    title: $props.title,
    frameborder: "none",
    width: $props.width,
    height: $props.height,
    allowpaymentrequest: "true",
    marginwidth: $props.marginwidth,
    marginheight: $props.marginheight,
    csp: $props.csp,
    scrolling: $props.scrolling,
    srcset: $props.srcset,
    onLoad: _cache[0] || (_cache[0] = ($event) => $setup.emit("load", $event))
  }, null, 40, _hoisted_1$h);
}
const IframeVue = /* @__PURE__ */ _export_sfc(_sfc_main$p, [["render", _sfc_render$p], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/IframeVue.vue"]]);
const _sfc_main$o = /* @__PURE__ */ defineComponent({
  __name: "BottomMenu",
  props: {
    navLinks: { type: Array, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = { get Btn() {
      return Btn;
    }, get Card() {
      return Card;
    }, get Icon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$g = { class: "m-0 pb-025 txt14 line-height-1 w60 menu-text" };
function _sfc_render$o(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["Card"], { class: "hide m_grid gap-05 bgl_bottombar px-1 txt14 justify-content-start align-items-center overflow-x" }, {
    default: withCtx(() => [
      renderSlot(_ctx.$slots, "brand", {}, void 0, true),
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($props.navLinks, (nav, i) => {
          return openBlock(), createBlock($setup["Btn"], {
            key: i,
            to: nav.to,
            class: "m_h-auto",
            onClick: nav.onClick
          }, {
            default: withCtx(() => [
              createVNode($setup["Icon"], {
                icon: nav.icon,
                size: 1.4,
                class: "m-0 line-height-14"
              }, null, 8, ["icon"]),
              createElementVNode(
                "p",
                _hoisted_1$g,
                toDisplayString(nav.label),
                1
                /* TEXT */
              )
            ]),
            _: 2
            /* DYNAMIC */
          }, 1032, ["to", "onClick"]);
        }),
        128
        /* KEYED_FRAGMENT */
      )),
      renderSlot(_ctx.$slots, "end", {}, void 0, true)
    ]),
    _: 3
    /* FORWARDED */
  });
}
const BottomMenu = /* @__PURE__ */ _export_sfc(_sfc_main$o, [["render", _sfc_render$o], ["__scopeId", "data-v-875bcc8f"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/layout/BottomMenu.vue"]]);
const _sfc_main$n = /* @__PURE__ */ defineComponent({
  __name: "Layout",
  props: {
    gap: { type: Number, required: false, default: 1 },
    h100: { type: Boolean, required: false, default: false },
    columns: { type: Array, required: false, default: () => [] },
    mColumns: { type: Array, required: false, default: () => [] },
    mRows: { type: Array, required: false, default: () => [] },
    rows: { type: Array, required: false, default: () => [] }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    useCssVars((_ctx) => ({
      "c9bfb757-gapSize": gapSize.value,
      "c9bfb757-gridTemplateRows": gridTemplateRows.value,
      "c9bfb757-gridTemplateColumns": gridTemplateColumns.value,
      "c9bfb757-mGridTemplateRows": mGridTemplateRows.value,
      "c9bfb757-mGridTemplateColumns": mGridTemplateColumns.value
    }));
    const props2 = __props;
    const gridTemplateRows = computed(() => props2.rows.length > 0 ? props2.rows.join(" ") : "auto");
    const gapSize = computed(() => `${props2.gap}rem`);
    const mGridTemplateRows = computed(() => {
      var _a2;
      if ((_a2 = props2.mRows) == null ? void 0 : _a2.length) return props2.mRows.join(" ");
      return gridTemplateRows.value;
    });
    const gridTemplateColumns = computed(() => props2.columns.length > 0 ? props2.columns.join(" ") : "auto");
    const mGridTemplateColumns = computed(() => {
      var _a2;
      if ((_a2 = props2.mColumns) == null ? void 0 : _a2.length) return props2.mColumns.join(" ");
      return gridTemplateColumns.value;
    });
    const __returned__ = { props: props2, gridTemplateRows, gapSize, mGridTemplateRows, gridTemplateColumns, mGridTemplateColumns };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$n(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["layout", { "layout-h-100": $props.h100 }])
    },
    [
      renderSlot(_ctx.$slots, "default", {}, void 0, true)
    ],
    2
    /* CLASS */
  );
}
const Layout = /* @__PURE__ */ _export_sfc(_sfc_main$n, [["render", _sfc_render$n], ["__scopeId", "data-v-c9bfb757"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/layout/Layout.vue"]]);
const _sfc_main$m = /* @__PURE__ */ defineComponent({
  __name: "SidebarMenu",
  props: {
    navLinks: { type: Array, required: false },
    expandable: { type: Boolean, required: false },
    open: { type: Boolean, required: true }
  },
  emits: ["update:open"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const slots = useSlots();
    let isOpen = ref(props2.open);
    const toggleMenu = useDebounceFn(() => {
      isOpen.value = !isOpen.value;
      emit2("update:open", isOpen.value);
    });
    const __returned__ = { props: props2, emit: emit2, slots, get isOpen() {
      return isOpen;
    }, set isOpen(v) {
      isOpen = v;
    }, toggleMenu, get Btn() {
      return Btn;
    }, get Card() {
      return Card;
    }, get Icon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$f = { key: 0 };
function _sfc_render$m(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_tooltip = resolveDirective("tooltip");
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["vh-100 relative p-05 bgl_sidebar", { wideNav: $setup.isOpen }])
    },
    [
      createVNode($setup["Btn"], {
        thin: "",
        color: "white",
        class: "mb-05 absolute toggleNav z-2 border",
        icon: "keyboard_arrow_right",
        onClick: $setup.toggleMenu
      }, null, 8, ["onClick"]),
      createVNode($setup["Card"], { class: "py-1 px-05 h-100 flex column gap-05 rounded relative bg-primary font-light overflow-y" }, {
        default: withCtx(() => [
          !$setup.isOpen || !$setup.slots["brand-open"] ? renderSlot(_ctx.$slots, "brand", { key: 0 }, void 0, true) : createCommentVNode("v-if", true),
          $setup.isOpen ? renderSlot(_ctx.$slots, "brand-open", { key: 1 }, void 0, true) : createCommentVNode("v-if", true),
          !$props.navLinks ? renderSlot(_ctx.$slots, "default", { key: 2 }, void 0, true) : createCommentVNode("v-if", true),
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList($props.navLinks, (nav, i) => {
              return withDirectives((openBlock(), createBlock($setup["Btn"], {
                key: i,
                to: nav.to,
                class: "nav-button px-075 me-auto w-100"
              }, {
                default: withCtx(() => [
                  createVNode($setup["Icon"], {
                    icon: nav.icon,
                    size: 1.4
                  }, null, 8, ["icon"]),
                  createVNode(
                    Transition,
                    { name: "showP" },
                    {
                      default: withCtx(() => [
                        $props.open ? (openBlock(), createElementBlock(
                          "p",
                          _hoisted_1$f,
                          toDisplayString(nav.label),
                          1
                          /* TEXT */
                        )) : createCommentVNode("v-if", true)
                      ]),
                      _: 2
                      /* DYNAMIC */
                    },
                    1024
                    /* DYNAMIC_SLOTS */
                  )
                ]),
                _: 2
                /* DYNAMIC */
              }, 1032, ["to"])), [
                [
                  _directive_tooltip,
                  {
                    content: nav.label,
                    disabled: $props.open
                  },
                  void 0,
                  { right: true }
                ]
              ]);
            }),
            128
            /* KEYED_FRAGMENT */
          )),
          _cache[0] || (_cache[0] = createElementVNode(
            "div",
            { style: { "flex-grow": "1" } },
            null,
            -1
            /* HOISTED */
          )),
          renderSlot(_ctx.$slots, "footer", {}, void 0, true)
        ]),
        _: 3
        /* FORWARDED */
      })
    ],
    2
    /* CLASS */
  );
}
const SidebarMenu = /* @__PURE__ */ _export_sfc(_sfc_main$m, [["render", _sfc_render$m], ["__scopeId", "data-v-48ec01df"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/layout/SidebarMenu.vue"]]);
const _sfc_main$l = /* @__PURE__ */ defineComponent({
  __name: "Skeleton",
  props: {
    count: { type: [Number, String], required: false, default: 1 },
    height: { type: String, required: false },
    width: { type: String, required: false },
    round: { type: Boolean, required: false, default: false },
    borderRadius: { type: String, required: false, default: "var(--skeleton-radius)" },
    class: { type: String, required: false, default: "" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const className = toRef(__props, "class");
    const slots = useSlots();
    const __returned__ = { className, slots };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$l(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(true), createElementBlock(
    Fragment,
    null,
    renderList(+$props.count, (i) => {
      return openBlock(), createElementBlock(
        Fragment,
        { key: i },
        [
          $setup.slots.default ? (openBlock(), createElementBlock(
            "div",
            {
              key: 0,
              class: normalizeClass(["skeleton-wrap", $setup.className])
            },
            [
              renderSlot(_ctx.$slots, "default", {}, void 0, true)
            ],
            2
            /* CLASS */
          )) : (openBlock(), createElementBlock(
            "div",
            {
              key: 1,
              class: normalizeClass(["skeleton", { round: $props.round, [$setup.className]: true }]),
              style: normalizeStyle({ height: $props.height, width: $props.width, borderRadius: $props.borderRadius })
            },
            null,
            6
            /* CLASS, STYLE */
          ))
        ],
        64
        /* STABLE_FRAGMENT */
      );
    }),
    128
    /* KEYED_FRAGMENT */
  );
}
const Skeleton = /* @__PURE__ */ _export_sfc(_sfc_main$l, [["render", _sfc_render$l], ["__scopeId", "data-v-baf08b74"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/layout/Skeleton.vue"]]);
const _sfc_main$k = /* @__PURE__ */ defineComponent({
  __name: "TabbedLayout",
  props: {
    title: { type: String, required: false },
    tabs: { type: Array, required: true },
    modelValue: { type: String, required: false },
    router: { type: null, required: false },
    sideTabs: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    let activeTab = ref();
    function changeTab(tab) {
      activeTab.value = tab;
      emit2("update:modelValue", activeTab.value);
      if (!props2.router) return;
      void props2.router.push({
        path: props2.router.currentRoute.value.path,
        query: { ...props2.router.currentRoute.value.query, t: tab },
        hash: props2.router.currentRoute.value.hash
      });
    }
    onMounted(() => {
      var _a2;
      const firstTab = props2.modelValue || ((_a2 = props2.router) == null ? void 0 : _a2.currentRoute.value.query.t) || props2.tabs[0];
      activeTab.value = firstTab;
    });
    const __returned__ = { props: props2, emit: emit2, get activeTab() {
      return activeTab;
    }, set activeTab(v) {
      activeTab = v;
    }, changeTab };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$e = { class: "bgl_card tabs-top" };
const _hoisted_2$8 = { class: "tabs grid auto-flow-columns fit-content" };
const _hoisted_3$6 = ["onClick"];
function _sfc_render$k(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["h-100 grid list-view gap-1", { "side-tabs": $props.sideTabs }])
    },
    [
      createElementVNode("div", _hoisted_1$e, [
        renderSlot(_ctx.$slots, "top-section", {}, void 0, true),
        createElementVNode("div", _hoisted_2$8, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList($props.tabs, (tab) => {
              var _a2;
              return openBlock(), createElementBlock("div", {
                key: tab,
                class: normalizeClass([{
                  active: tab === $setup.activeTab || tab === ((_a2 = $props.router) == null ? void 0 : _a2.currentRoute.value.path.split("/").slice(-1)[0])
                }, "tab"]),
                onClick: ($event) => $setup.changeTab(tab)
              }, toDisplayString(tab), 11, _hoisted_3$6);
            }),
            128
            /* KEYED_FRAGMENT */
          ))
        ])
      ]),
      (openBlock(true), createElementBlock(
        Fragment,
        null,
        renderList($props.tabs.filter((item) => item === $setup.activeTab), (tab) => {
          return openBlock(), createElementBlock("div", {
            key: tab,
            class: "list-content"
          }, [
            renderSlot(_ctx.$slots, tab, { key: tab }, void 0, true)
          ]);
        }),
        128
        /* KEYED_FRAGMENT */
      ))
    ],
    2
    /* CLASS */
  );
}
const TabbedLayout = /* @__PURE__ */ _export_sfc(_sfc_main$k, [["render", _sfc_render$k], ["__scopeId", "data-v-6f125238"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/layout/TabbedLayout.vue"]]);
const _sfc_main$j = /* @__PURE__ */ defineComponent({
  __name: "Tabs",
  props: {
    tabs: { type: Array, required: true },
    modelValue: { type: String, required: false },
    flat: { type: Boolean, required: false }
  },
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    const slots = useSlots();
    const group = Math.random().toString(36).slice(7);
    const { currentTab } = useTabs(group);
    const tabValue = (tab) => typeof tab === "string" ? tab : tab.id;
    const slctTab = computed({
      get: () => props2.modelValue || tabValue(props2.tabs[0]),
      set: (value) => {
        emit2("update:modelValue", value);
      }
    });
    const tabComponent = defineComponent({
      render() {
        var _a2, _b;
        const currentTabIndex = props2.tabs.findIndex(
          (tab) => tabValue(tab) === currentTab.value
        );
        if (currentTabIndex === -1) return;
        const slotChildren = (_b = (_a2 = slots.default) == null ? void 0 : _a2.call(slots)[1]) == null ? void 0 : _b.children;
        return h$1("div", slotChildren[currentTabIndex]);
      }
    });
    const __returned__ = { props: props2, emit: emit2, slots, group, currentTab, tabValue, slctTab, tabComponent, get TabsNav() {
      return TabsNav;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$d = { key: 0 };
function _sfc_render$j(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    Fragment,
    null,
    [
      createVNode($setup["TabsNav"], {
        modelValue: $setup.slctTab,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.slctTab = $event),
        flat: $props.flat,
        tabs: $props.tabs,
        group: $setup.group,
        class: "mb-05"
      }, null, 8, ["modelValue", "flat", "tabs", "group"]),
      $setup.currentTab ? (openBlock(), createElementBlock("div", _hoisted_1$d, [
        $setup.slots[$setup.currentTab] ? renderSlot(_ctx.$slots, $setup.currentTab, { key: 0 }) : $setup.currentTab ? (openBlock(), createBlock(resolveDynamicComponent($setup.tabComponent), { key: 1 })) : createCommentVNode("v-if", true)
      ])) : createCommentVNode("v-if", true)
    ],
    64
    /* STABLE_FRAGMENT */
  );
}
const Tabs = /* @__PURE__ */ _export_sfc(_sfc_main$j, [["render", _sfc_render$j], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/layout/Tabs.vue"]]);
const _sfc_main$i = /* @__PURE__ */ defineComponent({
  __name: "TabsBody",
  props: {
    group: { type: String, required: true }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const props2 = __props;
    const { currentTab } = useTabs(props2.group);
    const __returned__ = { props: props2, currentTab };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$i(_ctx, _cache, $props, $setup, $data, $options) {
  return $setup.currentTab ? renderSlot(_ctx.$slots, $setup.currentTab, { key: 0 }) : createCommentVNode("v-if", true);
}
const TabsBody = /* @__PURE__ */ _export_sfc(_sfc_main$i, [["render", _sfc_render$i], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/layout/TabsBody.vue"]]);
const _sfc_main$h = /* @__PURE__ */ defineComponent({
  __name: "ListItem",
  props: {
    src: { type: String, required: false },
    showAvatar: { type: Boolean, required: false },
    to: { type: String, required: false },
    icon: { type: null, required: false },
    title: { type: String, required: false },
    subtitle: { type: String, required: false },
    flat: { type: Boolean, required: false },
    onClick: { type: Function, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = { get Avatar() {
      return Avatar;
    }, get Icon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$c = { class: "no-margin ellipsis line-height-14 pb-025" };
const _hoisted_2$7 = { class: "txt12 no-margin txt-gray ellipsis" };
function _sfc_render$h(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($props.to ? "RouterLink" : "div"), {
    to: $props.to,
    class: normalizeClass(["flex gap-05 list-item", { "notClickable": !($props.to || $props.onClick), "no-border-list": $props.flat }]),
    onClick: $props.onClick
  }, {
    default: withCtx(() => [
      $props.src || $props.showAvatar ? (openBlock(), createBlock($setup["Avatar"], {
        key: 0,
        style: { "flex-basis": "1" },
        name: $props.title,
        src: $props.src,
        size: 40
      }, null, 8, ["name", "src"])) : createCommentVNode("v-if", true),
      $props.icon ? (openBlock(), createBlock($setup["Icon"], {
        key: 1,
        size: "1.2",
        class: "color-primary",
        icon: $props.icon
      }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
      createElementVNode("div", null, [
        createElementVNode("p", _hoisted_1$c, [
          createTextVNode(
            toDisplayString($props.title) + " ",
            1
            /* TEXT */
          ),
          renderSlot(_ctx.$slots, "default")
        ]),
        createElementVNode("p", _hoisted_2$7, [
          createTextVNode(
            toDisplayString($props.subtitle) + " ",
            1
            /* TEXT */
          ),
          renderSlot(_ctx.$slots, "subtitle")
        ])
      ])
    ]),
    _: 3
    /* FORWARDED */
  }, 8, ["to", "class", "onClick"]);
}
const ListItem = /* @__PURE__ */ _export_sfc(_sfc_main$h, [["render", _sfc_render$h], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/ListItem.vue"]]);
const _sfc_main$g = {};
const _hoisted_1$b = { class: "list-wrap bgl_card thin grid overflow-hidden h-100 pt-0 pb-05 px-0 m_pb-0" };
const _hoisted_2$6 = { class: "p-1" };
const _hoisted_3$5 = { class: "list-content auto-flow-rows align-items-start overflow-y h-100" };
function _sfc_render$g(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$b, [
    createElementVNode("div", _hoisted_2$6, [
      renderSlot(_ctx.$slots, "header")
    ]),
    createElementVNode("div", _hoisted_3$5, [
      renderSlot(_ctx.$slots, "default")
    ])
  ]);
}
const ListView = /* @__PURE__ */ _export_sfc(_sfc_main$g, [["render", _sfc_render$g], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/ListView.vue"]]);
const _sfc_main$f = /* @__PURE__ */ defineComponent({
  __name: "Loading",
  props: {
    size: { type: [Number, String], required: false, default: 64 },
    thickness: { type: [Number, String], required: false },
    duration: { type: [Number, String], required: false, default: 1.2 },
    type: { type: String, required: false, default: "ring" },
    color: { type: String, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const theme = toRef(__props, "type");
    function standardSize(value, unit2 = "px") {
      if (!value) return `${__props.size}${unit2}`;
      return typeof value === "number" ? `${value}${unit2}` : value.endsWith(unit2) ? value : `${value}${unit2}`;
    }
    const computedSize = computed(() => standardSize(__props.size));
    const animationDuration = computed(() => `${__props.duration}s`);
    const computedBorder = computed(() => {
      const borderValue = __props.thickness ?? Number.parseInt(computedSize.value) / 7;
      return standardSize(borderValue);
    });
    const __returned__ = { theme, standardSize, computedSize, animationDuration, computedBorder };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$a = { class: "flex-center" };
function _sfc_render$f(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$a, [
    createCommentVNode(" Bar Theme "),
    $setup.theme === "bar" ? (openBlock(), createElementBlock(
      "div",
      {
        key: 0,
        class: "lds-bar",
        style: normalizeStyle({ animationDuration: $setup.animationDuration, color: $props.color })
      },
      null,
      4
      /* STYLE */
    )) : createCommentVNode("v-if", true),
    createCommentVNode(" Ellipsis Theme "),
    $setup.theme === "ellipsis" ? (openBlock(), createElementBlock(
      "div",
      {
        key: 1,
        class: "lds-ellipsis",
        style: normalizeStyle({ "--size": $setup.computedSize })
      },
      [
        (openBlock(), createElementBlock(
          Fragment,
          null,
          renderList(4, (n2) => {
            return createElementVNode(
              "div",
              {
                key: n2,
                style: normalizeStyle({ color: $props.color, "--size": $setup.computedSize })
              },
              null,
              4
              /* STYLE */
            );
          }),
          64
          /* STABLE_FRAGMENT */
        ))
      ],
      4
      /* STYLE */
    )) : createCommentVNode("v-if", true),
    createCommentVNode(" Ring Theme "),
    $setup.theme === "ring" ? (openBlock(), createElementBlock(
      "div",
      {
        key: 2,
        class: "lds-ring",
        style: normalizeStyle({ "--size": $setup.computedSize, "--thickness": $setup.computedBorder })
      },
      [
        (openBlock(), createElementBlock(
          Fragment,
          null,
          renderList(4, (n2) => {
            return createElementVNode(
              "div",
              {
                key: n2,
                style: normalizeStyle({
                  color: $props.color,
                  "width": $setup.computedSize,
                  "height": $setup.computedSize,
                  "borderWidth": $setup.computedBorder,
                  "--animation-duration": $setup.animationDuration,
                  "--size": $setup.computedSize,
                  "--thickness": $setup.computedBorder
                })
              },
              null,
              4
              /* STYLE */
            );
          }),
          64
          /* STABLE_FRAGMENT */
        ))
      ],
      4
      /* STYLE */
    )) : createCommentVNode("v-if", true)
  ]);
}
const Loading = /* @__PURE__ */ _export_sfc(_sfc_main$f, [["render", _sfc_render$f], ["__scopeId", "data-v-7fb57159"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Loading.vue"]]);
const defaultMarkerSVG = '<svg width="28" height="38" viewBox="0 0 28 38" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M14.2263 37.7955C17.0897 37.7955 19.4109 37.0138 19.4109 36.0496C19.4109 35.0854 17.0897 34.3037 14.2263 34.3037C11.363 34.3037 9.04175 35.0854 9.04175 36.0496C9.04175 37.0138 11.363 37.7955 14.2263 37.7955Z" fill="black" fill-opacity="0.1"/><path d="M14.2265 0.549591C21.2842 0.549591 27.0131 6.23786 27.0787 13.28V13.4024C27.0787 19.3328 24.4759 24.4306 21.5627 28.2764C18.6511 32.12 15.4577 34.6754 14.3457 35.5097C14.2748 35.5629 14.1778 35.5629 14.1068 35.5097C12.9947 34.675 9.80135 32.1197 6.88984 28.2762C3.97665 24.4304 1.37378 19.3328 1.37378 13.4024C1.37378 6.30387 7.12806 0.549591 14.2265 0.549591Z" fill="#ED1b3E" stroke="#ED6C6F"/><path d="M14.2263 21.6185C18.7639 21.6185 22.4424 17.94 22.4424 13.4024C22.4424 8.86477 18.7639 5.18631 14.2263 5.18631C9.68872 5.18631 6.01025 8.86477 6.01025 13.4024C6.01025 17.94 9.68872 21.6185 14.2263 21.6185Z" fill="white"/></svg>';
const leafletScriptUrl = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
const _sfc_main$e = /* @__PURE__ */ defineComponent({
  __name: "MapEmbed",
  props: {
    center: { type: [Object, Array], required: false, default: () => [31.7683, 35.2137] },
    zoom: { type: Number, required: false, default: 15 },
    height: { type: Number, required: false, default: 400 },
    zoomControl: { type: Boolean, required: false, default: true },
    markers: { type: Array, required: false },
    markerIcon: { type: String, required: false, default: "" }
  },
  emits: ["select"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    let L = ref();
    let map3 = ref();
    const _markers = ref([]);
    const id = ref(Math.random().toString(36).slice(2, 10));
    async function loadGlobalL() {
      while (!window.L) await sleep(100);
      return window.L;
    }
    async function initializeMap() {
      await appendScript(leafletScriptUrl);
      L.value = await loadGlobalL();
      if (!map3.value) {
        map3.value = L.value.map(id.value, {
          center: props2.center,
          zoom: props2.zoom,
          zoomControl: props2.zoomControl
        });
        L.value.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", { maxZoom: 18 }).addTo(map3.value);
      }
    }
    async function addMarker(marker) {
      var _a2, _b;
      const iconSVG = props2.markerIcon || defaultMarkerSVG;
      const icon = (_a2 = L.value) == null ? void 0 : _a2.icon({
        iconUrl: `data:image/svg+xml;utf8,${encodeURIComponent(iconSVG)}`,
        iconSize: [32, 32]
      });
      const latlng = latLangFromMarker(marker);
      const title = Array.isArray(marker) ? marker[2] : marker.title ?? marker.tooltip;
      const tooltip = Array.isArray(marker) ? marker[2] : marker.tooltip;
      const m2 = (_b = L.value) == null ? void 0 : _b.marker(latlng, { title, icon, interactive: true }).addTo(map3.value);
      if (tooltip) m2.bindTooltip(tooltip, { direction: "top" });
      m2.on("click", () => {
        emit2("select", marker);
      });
      _markers.value.push(m2);
    }
    function fitMarkers(L2) {
      var _a2, _b;
      if (_markers.value.length > 0) {
        const latLngs = _markers.value.map((marker) => marker.getLatLng());
        const bounds = L2.latLngBounds(latLngs);
        const center2 = bounds.getCenter();
        (_a2 = map3.value) == null ? void 0 : _a2.setView(center2, props2.zoom);
        (_b = map3.value) == null ? void 0 : _b.fitBounds(bounds, {
          animate: true,
          padding: [20, 20]
          // Adjust padding as needed
        });
      }
    }
    function latLangFromMarker(marker) {
      const [lat, lng] = Array.isArray(marker) ? [marker[0], marker[1]] : [marker.lat, marker.lng];
      return { lat: +lat, lng: +lng };
    }
    async function watchMarkers(markers) {
      if (!L.value) L.value = await loadGlobalL();
      _markers.value.forEach((marker) => marker.remove());
      if (!markers) return;
      for (const marker of markers) {
        if (!map3.value) await initializeMap();
        addMarker(marker);
      }
      fitMarkers(L.value);
    }
    watch(() => props2.markers, watchMarkers, { immediate: true });
    watch(() => props2.center, (center2) => {
      var _a2;
      return (_a2 = map3.value) == null ? void 0 : _a2.setView(center2, props2.zoom);
    }, { immediate: true });
    onMounted(initializeMap);
    const __returned__ = { props: props2, emit: emit2, get L() {
      return L;
    }, set L(v) {
      L = v;
    }, get map() {
      return map3;
    }, set map(v) {
      map3 = v;
    }, _markers, id, defaultMarkerSVG, leafletScriptUrl, loadGlobalL, initializeMap, addMarker, fitMarkers, latLangFromMarker, watchMarkers };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$9 = ["id"];
function _sfc_render$e(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    id: $setup.id,
    class: "leaflet-map",
    style: normalizeStyle({ height: `${$setup.props.height || 400}px` }),
    dir: "ltr"
  }, null, 12, _hoisted_1$9);
}
const MapEmbed = /* @__PURE__ */ _export_sfc(_sfc_main$e, [["render", _sfc_render$e], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/MapEmbed.vue"]]);
const _sfc_main$d = /* @__PURE__ */ defineComponent({
  __name: "MaterialIcon",
  props: {
    icon: { type: null, required: false },
    name: { type: null, required: false },
    size: { type: [Number, String], required: false },
    color: { type: String, required: false },
    weight: { type: [Number, String], required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = {};
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$d(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "span",
    {
      class: "bgl_icon-font",
      style: normalizeStyle({ "fontSize": `${$props.size}rem`, color: $props.color, "font-variation-settings": `'wght' ${$props.weight || 400}` })
    },
    toDisplayString($props.icon || $props.name),
    5
    /* TEXT, STYLE */
  );
}
const Icon = /* @__PURE__ */ _export_sfc(_sfc_main$d, [["render", _sfc_render$d], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/MaterialIcon.vue"]]);
const _sfc_main$c = /* @__PURE__ */ defineComponent({
  __name: "Modal",
  props: {
    side: { type: Boolean, required: false },
    title: { type: String, required: false },
    width: { type: String, required: false },
    dismissable: { type: Boolean, required: false },
    actions: { type: Array, required: false },
    visible: { type: Boolean, required: false }
  },
  emits: ["update:visible"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const slots = useSlots();
    let isVisible = ref(false);
    watch(
      () => props2.visible,
      (val) => {
        if (val === isVisible.value || val === void 0) return;
        if (val) openModal();
        else closeModal();
      },
      { immediate: true }
    );
    const maxWidth = computed(() => {
      const { width } = props2;
      if (width == null ? void 0 : width.match(/px|em|rem|vw|vh|%/)) return { "max-width": width };
      if (width == null ? void 0 : width.match(/\d+/)) return { "max-width": `${width}px` };
      return { "max-width": "720px" };
    });
    function closeModal() {
      isVisible.value = false;
      setTimeout(() => {
        emit2("update:visible", false);
      }, 200);
    }
    __expose({ closeModal });
    const escapeKeyClose = (e) => props2.dismissable && useEscape(e, () => {
      closeModal();
    });
    function openModal() {
      setTimeout(() => isVisible.value = true, 1);
    }
    onMounted(() => {
      document.addEventListener("keydown", escapeKeyClose);
    });
    onUnmounted(() => {
      document.removeEventListener("keydown", escapeKeyClose);
    });
    const __returned__ = { props: props2, emit: emit2, slots, get isVisible() {
      return isVisible;
    }, set isVisible(v) {
      isVisible = v;
    }, maxWidth, closeModal, escapeKeyClose, openModal, get Btn() {
      return Btn;
    }, get Card() {
      return Card;
    }, get Title() {
      return Title;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$8 = {
  key: 0,
  class: "tool-bar"
};
const _hoisted_2$5 = {
  key: 1,
  class: "sticky bg-popup z-index-999 -mt-1 -ms-1 px-025 h-30px pt-025 modal-no-title"
};
const _hoisted_3$4 = {
  key: 2,
  class: "modal-footer mt-1"
};
function _sfc_render$c(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass(["bg-dark", { "is-side": $props.side, "is-active": $setup.isVisible, "bg-lignt": false }]),
      onClick: _cache[1] || (_cache[1] = () => $props.dismissable ? $setup.closeModal() : ""),
      onKeydown: withKeys($setup.closeModal, ["esc"])
    },
    [
      createVNode($setup["Card"], {
        class: "modal",
        style: normalizeStyle({ ...$setup.maxWidth }),
        onClick: _cache[0] || (_cache[0] = withModifiers(() => {
        }, ["stop"]))
      }, {
        default: withCtx(() => {
          var _a2;
          return [
            $setup.slots.toolbar || $props.title ? (openBlock(), createElementBlock("header", _hoisted_1$8, [
              renderSlot(_ctx.$slots, "toolbar"),
              createVNode($setup["Btn"], {
                style: normalizeStyle({ float: $props.side ? "left" : "right" }),
                flat: "",
                icon: "close",
                thin: "",
                onClick: $setup.closeModal
              }, null, 8, ["style"]),
              $props.title ? (openBlock(), createBlock($setup["Title"], {
                key: 0,
                class: "modal-title",
                tag: "h3",
                label: $props.title
              }, null, 8, ["label"])) : createCommentVNode("v-if", true)
            ])) : (openBlock(), createElementBlock("div", _hoisted_2$5, [
              createVNode($setup["Btn"], {
                class: "position-start",
                icon: "close",
                thin: "",
                color: "white",
                onClick: $setup.closeModal
              })
            ])),
            renderSlot(_ctx.$slots, "default"),
            $setup.slots.footer || ((_a2 = $props.actions) == null ? void 0 : _a2.length) ? (openBlock(), createElementBlock("footer", _hoisted_3$4, [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList($props.actions, (action, i) => {
                  return openBlock(), createBlock(
                    $setup["Btn"],
                    mergeProps({
                      key: i,
                      color: "gray",
                      ref_for: true
                    }, action, { onClick: $setup.closeModal }),
                    null,
                    16
                    /* FULL_PROPS */
                  );
                }),
                128
                /* KEYED_FRAGMENT */
              )),
              renderSlot(_ctx.$slots, "footer")
            ])) : createCommentVNode("v-if", true)
          ];
        }),
        _: 3
        /* FORWARDED */
      }, 8, ["style"])
    ],
    34
    /* CLASS, NEED_HYDRATION */
  );
}
const Modal = /* @__PURE__ */ _export_sfc(_sfc_main$c, [["render", _sfc_render$c], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Modal.vue"]]);
const _sfc_main$b = /* @__PURE__ */ defineComponent({
  __name: "ModalConfirm",
  props: {
    title: { type: String, required: false },
    message: { type: String, required: false },
    confirmText: { type: String, required: false },
    confirmBtnColor: { type: String, required: false },
    cancelBtnColor: { type: String, required: false },
    cancelText: { type: String, required: false },
    resolve: { type: Function, required: true }
  },
  emits: ["update:visible"],
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    const props2 = __props;
    const emit2 = __emit;
    function select2(val) {
      props2.resolve(val);
      emit2("update:visible");
    }
    const title = props2.title || "Confirm";
    const message2 = props2.message || "Are you sure you want to continue?";
    const confirmText = props2.confirmText || "Confirm";
    const cancelText = props2.cancelText || "Cancel";
    const confirmBtnColor = props2.confirmBtnColor || "green";
    const cancelBtnColor = props2.cancelBtnColor || "gray";
    const __returned__ = { props: props2, emit: emit2, select: select2, title, message: message2, confirmText, cancelText, confirmBtnColor, cancelBtnColor, get Btn() {
      return Btn;
    }, get Modal() {
      return Modal;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$7 = { class: "pb-05 pretty" };
function _sfc_render$b(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["Modal"], {
    title: $setup.title,
    width: "380px",
    dismissable: false,
    class: "txt-center"
  }, {
    footer: withCtx(() => [
      createVNode($setup["Btn"], {
        color: $setup.cancelBtnColor,
        value: $setup.cancelText,
        onClick: _cache[0] || (_cache[0] = ($event) => $setup.select(false))
      }, null, 8, ["color", "value"]),
      createVNode($setup["Btn"], {
        color: $setup.confirmBtnColor,
        value: $setup.confirmText,
        onClick: _cache[1] || (_cache[1] = ($event) => $setup.select(true))
      }, null, 8, ["color", "value"])
    ]),
    default: withCtx(() => [
      createElementVNode(
        "p",
        _hoisted_1$7,
        toDisplayString($setup.message),
        1
        /* TEXT */
      )
    ]),
    _: 1
    /* STABLE */
  }, 8, ["title"]);
}
const ModalConfirm = /* @__PURE__ */ _export_sfc(_sfc_main$b, [["render", _sfc_render$b], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/ModalConfirm.vue"]]);
const _sfc_main$a = /* @__PURE__ */ defineComponent({
  __name: "ModalForm",
  props: /* @__PURE__ */ mergeModels({
    side: { type: Boolean, required: false },
    title: { type: String, required: false },
    width: { type: String, required: false },
    dismissable: { type: Boolean, required: false },
    actions: { type: Array, required: false },
    schema: { type: null, required: true },
    onSubmit: { type: Function, required: false },
    onDelete: { type: Function, required: false },
    visible: { type: Boolean, required: false },
    onError: { type: Function, required: false },
    modelValue: { type: Object, required: false }
  }, {
    "modelValue": { type: Object, ...{
      default: {}
    } },
    "modelModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:visible"], ["update:modelValue"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    const props2 = __props;
    const emit2 = __emit;
    const bagel = useBagel();
    const modal = ref();
    const computedFormSchema = computed(() => {
      if (typeof props2.schema === "function") return props2.schema();
      return props2.schema;
    });
    const formData = useModel(__props, "modelValue");
    const form = ref();
    const closeModal = () => {
      var _a2;
      return (_a2 = modal.value) == null ? void 0 : _a2.closeModal();
    };
    let submitting = ref(false);
    async function runSubmit() {
      var _a2, _b, _c, _d;
      if (submitting.value) return;
      if (((_b = (_a2 = form.value) == null ? void 0 : _a2.validateForm) == null ? void 0 : _b.call(_a2)) === false) return;
      submitting.value = true;
      try {
        await ((_c = props2.onSubmit) == null ? void 0 : _c.call(props2, formData.value));
        closeModal();
      } catch (err) {
        submitting.value = false;
        if (props2.onError) props2.onError(err);
        else (_d = bagel.onError) == null ? void 0 : _d.call(bagel, err);
      }
    }
    function runDelete() {
      var _a2;
      (_a2 = props2.onDelete) == null ? void 0 : _a2.call(props2, formData.value.id);
      closeModal();
    }
    function setFormValues(values3) {
      Object.assign(formData, values3);
    }
    __expose({ setFormValues });
    const __returned__ = { props: props2, emit: emit2, bagel, modal, computedFormSchema, formData, form, closeModal, get submitting() {
      return submitting;
    }, set submitting(v) {
      submitting = v;
    }, runSubmit, runDelete, setFormValues, get BagelForm() {
      return BagelForm;
    }, get Btn() {
      return Btn;
    }, get Modal() {
      return Modal;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$a(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock($setup["Modal"], {
    ref: "modal",
    side: $props.side,
    width: $props.width,
    visible: $props.visible,
    dismissable: $props.dismissable,
    title: $props.title,
    "onUpdate:visible": _cache[1] || (_cache[1] = ($event) => $setup.emit("update:visible", $event))
  }, createSlots({
    default: withCtx(() => [
      $props.visible ? (openBlock(), createBlock($setup["BagelForm"], {
        key: 0,
        ref: "form",
        modelValue: $setup.formData,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => $setup.formData = $event),
        schema: $setup.computedFormSchema,
        onSubmit: $setup.runSubmit
      }, null, 8, ["modelValue", "schema"])) : createCommentVNode("v-if", true)
    ]),
    _: 2
    /* DYNAMIC */
  }, [
    $props.onDelete || $props.onSubmit ? {
      name: "footer",
      fn: withCtx(() => [
        createElementVNode("div", null, [
          createVNode($setup["Btn"], {
            thin: "",
            flat: "",
            value: "Cancel",
            onClick: $setup.closeModal
          }),
          $props.onDelete ? (openBlock(), createBlock($setup["Btn"], {
            key: 0,
            thin: "",
            icon: "delete",
            flat: "",
            value: "Delete",
            color: "red",
            onClick: $setup.runDelete
          })) : createCommentVNode("v-if", true)
        ]),
        createVNode($setup["Btn"], {
          value: "Submit",
          onClick: $setup.runSubmit
        })
      ]),
      key: "0"
    } : void 0
  ]), 1032, ["side", "width", "visible", "dismissable", "title"]);
}
const ModalForm = /* @__PURE__ */ _export_sfc(_sfc_main$a, [["render", _sfc_render$a], ["__scopeId", "data-v-62e8db84"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/ModalForm.vue"]]);
const _sfc_main$9 = /* @__PURE__ */ defineComponent({
  __name: "NavBar",
  props: {
    footerLinks: { type: Array, required: false, default: () => [] },
    links: { type: Array, required: false, default: () => [] },
    homeIcon: { type: null, required: false, default: "home" },
    homeLabel: { type: String, required: false, default: "Home" },
    homeTo: { type: String, required: false, default: "/" }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    let isOpen = ref(true);
    function calcIsOpen() {
      isOpen.value = window.innerWidth < 1100;
      const storedNavOpenVal = localStorage.getItem("navOpen");
      if (storedNavOpenVal === "true" || storedNavOpenVal === null) isOpen.value = true;
    }
    function toggleMenu() {
      isOpen.value = !isOpen.value;
      localStorage.setItem("navOpen", `${isOpen.value}`);
    }
    onMounted(calcIsOpen);
    const __returned__ = { get isOpen() {
      return isOpen;
    }, set isOpen(v) {
      isOpen = v;
    }, calcIsOpen, toggleMenu, get MaterialIcon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$6 = { class: "full-nav" };
const _hoisted_2$4 = { class: "nav-scroll" };
const _hoisted_3$3 = { class: "nav-links-wrapper" };
const _hoisted_4$3 = { class: "tooltip" };
const _hoisted_5$3 = { class: "bot-buttons-wrapper" };
const _hoisted_6$3 = { class: "tooltip" };
function _sfc_render$9(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      class: normalizeClass({ open: $setup.isOpen, closed: !$setup.isOpen })
    },
    [
      renderSlot(_ctx.$slots, "top", { isOpen: $setup.isOpen }, void 0, true),
      createElementVNode(
        "div",
        {
          class: "nav-expend",
          role: "button",
          "aria-label": "Toggle Navigation",
          tabindex: "0",
          onClick: $setup.toggleMenu,
          onKeypress: withKeys($setup.toggleMenu, ["enter"])
        },
        [
          createVNode($setup["MaterialIcon"], {
            icon: "chevron_right",
            class: "top-arrow"
          })
        ],
        32
        /* NEED_HYDRATION */
      ),
      createElementVNode("div", _hoisted_1$6, [
        createElementVNode("div", _hoisted_2$4, [
          createElementVNode("div", _hoisted_3$3, [
            (openBlock(true), createElementBlock(
              Fragment,
              null,
              renderList($props.links, (link) => {
                return openBlock(), createBlock(resolveDynamicComponent(link.to ? "router-link" : "div"), {
                  key: link.label,
                  class: "nav-button",
                  to: link.to,
                  onClick: ($event) => {
                    var _a2;
                    return (_a2 = link.onClick) == null ? void 0 : _a2.call(link);
                  }
                }, {
                  default: withCtx(() => [
                    createVNode($setup["MaterialIcon"], {
                      icon: link.icon
                    }, null, 8, ["icon"]),
                    createElementVNode(
                      "div",
                      _hoisted_4$3,
                      toDisplayString(link.label),
                      1
                      /* TEXT */
                    )
                  ]),
                  _: 2
                  /* DYNAMIC */
                }, 1032, ["to", "onClick"]);
              }),
              128
              /* KEYED_FRAGMENT */
            ))
          ])
        ]),
        createElementVNode("div", _hoisted_5$3, [
          (openBlock(true), createElementBlock(
            Fragment,
            null,
            renderList($props.footerLinks, (link) => {
              return openBlock(), createBlock(resolveDynamicComponent(link.to ? "router-link" : "div"), {
                key: link.label,
                class: "nav-button",
                to: link.to,
                onClick: ($event) => {
                  var _a2;
                  return (_a2 = link.onClick) == null ? void 0 : _a2.call(link);
                }
              }, {
                default: withCtx(() => [
                  createVNode($setup["MaterialIcon"], {
                    icon: link.icon
                  }, null, 8, ["icon"]),
                  createElementVNode(
                    "div",
                    _hoisted_6$3,
                    toDisplayString(link.label),
                    1
                    /* TEXT */
                  )
                ]),
                _: 2
                /* DYNAMIC */
              }, 1032, ["to", "onClick"]);
            }),
            128
            /* KEYED_FRAGMENT */
          )),
          renderSlot(_ctx.$slots, "floor", {}, void 0, true)
        ])
      ])
    ],
    2
    /* CLASS */
  );
}
const NavBar = /* @__PURE__ */ _export_sfc(_sfc_main$9, [["render", _sfc_render$9], ["__scopeId", "data-v-c3ceb15a"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/NavBar.vue"]]);
const _sfc_main$8 = /* @__PURE__ */ defineComponent({
  __name: "PageTitle",
  props: {
    value: {
      type: String,
      default: ""
    }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = {};
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$5 = { class: "page-top" };
const _hoisted_2$3 = { class: "top-title m-0" };
function _sfc_render$8(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", _hoisted_1$5, [
    createElementVNode("h1", _hoisted_2$3, [
      renderSlot(_ctx.$slots, "default"),
      createTextVNode(
        " " + toDisplayString($props.value),
        1
        /* TEXT */
      )
    ])
  ]);
}
const PageTitle = /* @__PURE__ */ _export_sfc(_sfc_main$8, [["render", _sfc_render$8], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/PageTitle.vue"]]);
const _sfc_main$7 = /* @__PURE__ */ defineComponent({
  __name: "Pill",
  props: {
    disabled: { type: Boolean, required: false },
    icon: { type: null, required: false },
    iconEnd: { type: null, required: false },
    color: { type: String, required: false },
    theme: { type: String, required: false },
    flat: { type: Boolean, required: false },
    border: { type: Boolean, required: false },
    outline: { type: Boolean, required: false },
    loading: { type: Boolean, required: false },
    value: { type: String, required: false },
    round: { type: Boolean, required: false },
    btn: { type: Object, required: false },
    btnEnd: { type: Object, required: false }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    useCssVars((_ctx) => ({
      "d3473902-computedBackgroundColor": computedBackgroundColor.value,
      "d3473902-cumputedTextColor": cumputedTextColor.value
    }));
    const props2 = __props;
    const slots = useSlots();
    const computedTheme = computed(
      () => {
        if (props2.disabled) return "gray-light";
        return props2.color || props2.theme;
      }
    );
    const computedDefaultColors = computed(
      () => ({
        backgroundColor: "var(--bgl-primary)",
        color: props2.flat ? "var(--bgl-text-color)" : "var(--bgl-light-text)"
      })
    );
    function getThemeColors(theme) {
      return {
        ...computedDefaultColors.value,
        ...theme,
        color: props2.flat ? theme.backgroundColor : theme.color
      };
    }
    const themes = {
      "red": getThemeColors({ backgroundColor: "var(--bgl-red)" }),
      "white": getThemeColors({ backgroundColor: "var(--bgl-white)", color: "var(--bgl-black)" }),
      "black": getThemeColors({ backgroundColor: "var(--bgl-black)", color: "var(--bgl-white)" }),
      "green": getThemeColors({ backgroundColor: "var(--bgl-green)", color: "var(--bgl-white)" }),
      "primary": getThemeColors({ backgroundColor: "var(--bgl-primary)", color: "var(--bgl-white)" }),
      "yellow": getThemeColors({ backgroundColor: "var(--bgl-yellow)", color: "var(--bgl-black)" }),
      "gray": getThemeColors({ backgroundColor: "var(--bgl-gray-light)", color: "var(--bgl-black)" }),
      "light": getThemeColors({ backgroundColor: "var(--bgl-primary-light)", color: "var(--bgl-primary)" }),
      "gray-light": getThemeColors({ backgroundColor: "var(--bgl-gray-light)", color: "var(--bgl-gray)" }),
      "blue": getThemeColors({})
    };
    const cumputedTextColor = computed(
      () => {
        var _a2;
        return ((_a2 = themes[computedTheme.value]) == null ? void 0 : _a2.color) ?? computedDefaultColors.value.color;
      }
    );
    const computedBackgroundColor = computed(
      () => {
        var _a2;
        return ((_a2 = themes[computedTheme.value]) == null ? void 0 : _a2.backgroundColor) ?? computedDefaultColors.value.backgroundColor;
      }
    );
    const __returned__ = { props: props2, slots, computedTheme, computedDefaultColors, getThemeColors, themes, cumputedTextColor, computedBackgroundColor, get Btn() {
      return Btn;
    }, get MaterialIcon() {
      return Icon;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$4 = ["disabled"];
const _hoisted_2$2 = { class: "bgl_pill-flex" };
const _hoisted_3$2 = {
  key: 0,
  class: "loading"
};
const _hoisted_4$2 = { key: 1 };
const _hoisted_5$2 = {
  key: 0,
  class: "flex h-100"
};
const _hoisted_6$2 = {
  key: 5,
  class: "loading"
};
const _hoisted_7$2 = { key: 6 };
const _hoisted_8$2 = {
  key: 0,
  class: "flex h-100"
};
function _sfc_render$7(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    disabled: $props.disabled,
    class: normalizeClass({
      "bgl_pill": !$props.icon || $setup.slots.default || $props.value,
      round: $props.round,
      "bgl_flatPill": $props.flat,
      "bgl_pill-border": $props.border || $props.outline
    })
  }, [
    createElementVNode("div", _hoisted_2$2, [
      $props.loading ? (openBlock(), createElementBlock("div", _hoisted_3$2)) : (openBlock(), createElementBlock("div", _hoisted_4$2, [
        $props.btn ? (openBlock(), createElementBlock("div", _hoisted_5$2, [
          createVNode(
            $setup["Btn"],
            mergeProps({
              class: "bgl_pill-btn",
              round: "",
              thin: ""
            }, $props.btn),
            null,
            16
            /* FULL_PROPS */
          )
        ])) : createCommentVNode("v-if", true)
      ])),
      $props.icon ? (openBlock(), createBlock($setup["MaterialIcon"], {
        key: 2,
        icon: $props.icon
      }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
      renderSlot(_ctx.$slots, "default", {}, void 0, true),
      !$setup.slots.default && $props.value ? (openBlock(), createElementBlock(
        Fragment,
        { key: 3 },
        [
          createTextVNode(
            toDisplayString($props.value),
            1
            /* TEXT */
          )
        ],
        64
        /* STABLE_FRAGMENT */
      )) : createCommentVNode("v-if", true),
      $props.iconEnd ? (openBlock(), createBlock($setup["MaterialIcon"], {
        key: 4,
        icon: $props.iconEnd
      }, null, 8, ["icon"])) : createCommentVNode("v-if", true),
      $props.loading ? (openBlock(), createElementBlock("div", _hoisted_6$2)) : (openBlock(), createElementBlock("div", _hoisted_7$2, [
        $props.btnEnd ? (openBlock(), createElementBlock("div", _hoisted_8$2, [
          createVNode(
            $setup["Btn"],
            mergeProps({
              class: "bgl_pill-btn",
              round: "",
              thin: ""
            }, $props.btnEnd),
            null,
            16
            /* FULL_PROPS */
          )
        ])) : createCommentVNode("v-if", true)
      ]))
    ])
  ], 10, _hoisted_1$4);
}
const Pill = /* @__PURE__ */ _export_sfc(_sfc_main$7, [["render", _sfc_render$7], ["__scopeId", "data-v-d3473902"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Pill.vue"]]);
const _sfc_main$6 = {};
function _sfc_render$6(_ctx, _cache) {
  const _component_router_view = resolveComponent("router-view");
  return openBlock(), createBlock(_component_router_view, null, {
    default: withCtx(({ Component, route }) => [
      createVNode(
        Transition,
        {
          duration: 300,
          name: "slide-fade",
          mode: "out-in",
          appear: ""
        },
        {
          default: withCtx(() => [
            (openBlock(), createBlock(resolveDynamicComponent(Component), {
              key: route == null ? void 0 : route.params.itemID
            }))
          ]),
          _: 2
          /* DYNAMIC */
        },
        1024
        /* DYNAMIC_SLOTS */
      )
    ]),
    _: 1
    /* STABLE */
  });
}
const RouterWrapper = /* @__PURE__ */ _export_sfc(_sfc_main$6, [["render", _sfc_render$6], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/RouterWrapper.vue"]]);
function tryOnScopeDispose(fn2) {
  if (getCurrentScope()) {
    onScopeDispose(fn2);
    return true;
  }
  return false;
}
function toValue(r) {
  return typeof r === "function" ? r() : unref(r);
}
const isClient = typeof window !== "undefined" && typeof document !== "undefined";
typeof WorkerGlobalScope !== "undefined" && globalThis instanceof WorkerGlobalScope;
const notNullish = (val) => val != null;
const noop = () => {
};
function createFilterWrapper(filter3, fn2) {
  function wrapper(...args) {
    return new Promise((resolve, reject3) => {
      Promise.resolve(filter3(() => fn2.apply(this, args), { fn: fn2, thisArg: this, args })).then(resolve).catch(reject3);
    });
  }
  return wrapper;
}
function debounceFilter(ms, options = {}) {
  let timer;
  let maxTimer;
  let lastRejector = noop;
  const _clearTimeout = (timer2) => {
    clearTimeout(timer2);
    lastRejector();
    lastRejector = noop;
  };
  const filter3 = (invoke) => {
    const duration = toValue(ms);
    const maxDuration = toValue(options.maxWait);
    if (timer)
      _clearTimeout(timer);
    if (duration <= 0 || maxDuration !== void 0 && maxDuration <= 0) {
      if (maxTimer) {
        _clearTimeout(maxTimer);
        maxTimer = null;
      }
      return Promise.resolve(invoke());
    }
    return new Promise((resolve, reject3) => {
      lastRejector = options.rejectOnCancel ? reject3 : resolve;
      if (maxDuration && !maxTimer) {
        maxTimer = setTimeout(() => {
          if (timer)
            _clearTimeout(timer);
          maxTimer = null;
          resolve(invoke());
        }, maxDuration);
      }
      timer = setTimeout(() => {
        if (maxTimer)
          _clearTimeout(maxTimer);
        maxTimer = null;
        resolve(invoke());
      }, duration);
    });
  };
  return filter3;
}
function promiseTimeout(ms, throwOnTimeout = false, reason = "Timeout") {
  return new Promise((resolve, reject3) => {
    if (throwOnTimeout)
      setTimeout(() => reject3(reason), ms);
    else
      setTimeout(resolve, ms);
  });
}
function getLifeCycleTarget(target) {
  return getCurrentInstance();
}
function useDebounceFn(fn2, ms = 200, options = {}) {
  return createFilterWrapper(
    debounceFilter(ms, options),
    fn2
  );
}
function tryOnMounted(fn2, sync = true, target) {
  const instance = getLifeCycleTarget();
  if (instance)
    onMounted(fn2, target);
  else if (sync)
    fn2();
  else
    nextTick(fn2);
}
function createUntil(r, isNot = false) {
  function toMatch(condition, { flush = "sync", deep = false, timeout, throwOnTimeout } = {}) {
    let stop = null;
    const watcher = new Promise((resolve) => {
      stop = watch(
        r,
        (v) => {
          if (condition(v) !== isNot) {
            if (stop)
              stop();
            else
              nextTick(() => stop == null ? void 0 : stop());
            resolve(v);
          }
        },
        {
          flush,
          deep,
          immediate: true
        }
      );
    });
    const promises = [watcher];
    if (timeout != null) {
      promises.push(
        promiseTimeout(timeout, throwOnTimeout).then(() => toValue(r)).finally(() => stop == null ? void 0 : stop())
      );
    }
    return Promise.race(promises);
  }
  function toBe(value, options) {
    if (!isRef(value))
      return toMatch((v) => v === value, options);
    const { flush = "sync", deep = false, timeout, throwOnTimeout } = options != null ? options : {};
    let stop = null;
    const watcher = new Promise((resolve) => {
      stop = watch(
        [r, value],
        ([v1, v2]) => {
          if (isNot !== (v1 === v2)) {
            if (stop)
              stop();
            else
              nextTick(() => stop == null ? void 0 : stop());
            resolve(v1);
          }
        },
        {
          flush,
          deep,
          immediate: true
        }
      );
    });
    const promises = [watcher];
    if (timeout != null) {
      promises.push(
        promiseTimeout(timeout, throwOnTimeout).then(() => toValue(r)).finally(() => {
          stop == null ? void 0 : stop();
          return toValue(r);
        })
      );
    }
    return Promise.race(promises);
  }
  function toBeTruthy(options) {
    return toMatch((v) => Boolean(v), options);
  }
  function toBeNull(options) {
    return toBe(null, options);
  }
  function toBeUndefined(options) {
    return toBe(void 0, options);
  }
  function toBeNaN(options) {
    return toMatch(Number.isNaN, options);
  }
  function toContains(value, options) {
    return toMatch((v) => {
      const array2 = Array.from(v);
      return array2.includes(value) || array2.includes(toValue(value));
    }, options);
  }
  function changed(options) {
    return changedTimes(1, options);
  }
  function changedTimes(n2 = 1, options) {
    let count2 = -1;
    return toMatch(() => {
      count2 += 1;
      return count2 >= n2;
    }, options);
  }
  if (Array.isArray(toValue(r))) {
    const instance = {
      toMatch,
      toContains,
      changed,
      changedTimes,
      get not() {
        return createUntil(r, !isNot);
      }
    };
    return instance;
  } else {
    const instance = {
      toMatch,
      toBe,
      toBeTruthy,
      toBeNull,
      toBeNaN,
      toBeUndefined,
      changed,
      changedTimes,
      get not() {
        return createUntil(r, !isNot);
      }
    };
    return instance;
  }
}
function until(r) {
  return createUntil(r);
}
const defaultWindow = isClient ? window : void 0;
function unrefElement(elRef) {
  var _a2;
  const plain = toValue(elRef);
  return (_a2 = plain == null ? void 0 : plain.$el) != null ? _a2 : plain;
}
function useMounted() {
  const isMounted = ref(false);
  const instance = getCurrentInstance();
  if (instance) {
    onMounted(() => {
      isMounted.value = true;
    }, instance);
  }
  return isMounted;
}
function useSupported(callback) {
  const isMounted = useMounted();
  return computed(() => {
    isMounted.value;
    return Boolean(callback());
  });
}
function useResizeObserver(target, callback, options = {}) {
  const { window: window2 = defaultWindow, ...observerOptions } = options;
  let observer;
  const isSupported = useSupported(() => window2 && "ResizeObserver" in window2);
  const cleanup = () => {
    if (observer) {
      observer.disconnect();
      observer = void 0;
    }
  };
  const targets = computed(() => {
    const _targets = toValue(target);
    return Array.isArray(_targets) ? _targets.map((el) => unrefElement(el)) : [unrefElement(_targets)];
  });
  const stopWatch = watch(
    targets,
    (els) => {
      cleanup();
      if (isSupported.value && window2) {
        observer = new ResizeObserver(callback);
        for (const _el of els) {
          if (_el)
            observer.observe(_el, observerOptions);
        }
      }
    },
    { immediate: true, flush: "post" }
  );
  const stop = () => {
    cleanup();
    stopWatch();
  };
  tryOnScopeDispose(stop);
  return {
    isSupported,
    stop
  };
}
function useElementSize(target, initialSize = { width: 0, height: 0 }, options = {}) {
  const { window: window2 = defaultWindow, box = "content-box" } = options;
  const isSVG = computed(() => {
    var _a2, _b;
    return (_b = (_a2 = unrefElement(target)) == null ? void 0 : _a2.namespaceURI) == null ? void 0 : _b.includes("svg");
  });
  const width = ref(initialSize.width);
  const height = ref(initialSize.height);
  const { stop: stop1 } = useResizeObserver(
    target,
    ([entry]) => {
      const boxSize = box === "border-box" ? entry.borderBoxSize : box === "content-box" ? entry.contentBoxSize : entry.devicePixelContentBoxSize;
      if (window2 && isSVG.value) {
        const $elem = unrefElement(target);
        if ($elem) {
          const rect = $elem.getBoundingClientRect();
          width.value = rect.width;
          height.value = rect.height;
        }
      } else {
        if (boxSize) {
          const formatBoxSize = Array.isArray(boxSize) ? boxSize : [boxSize];
          width.value = formatBoxSize.reduce((acc, { inlineSize }) => acc + inlineSize, 0);
          height.value = formatBoxSize.reduce((acc, { blockSize }) => acc + blockSize, 0);
        } else {
          width.value = entry.contentRect.width;
          height.value = entry.contentRect.height;
        }
      }
    },
    options
  );
  tryOnMounted(() => {
    const ele = unrefElement(target);
    if (ele) {
      width.value = "offsetWidth" in ele ? ele.offsetWidth : initialSize.width;
      height.value = "offsetHeight" in ele ? ele.offsetHeight : initialSize.height;
    }
  });
  const stop2 = watch(
    () => unrefElement(target),
    (ele) => {
      width.value = ele ? initialSize.width : 0;
      height.value = ele ? initialSize.height : 0;
    }
  );
  function stop() {
    stop1();
    stop2();
  }
  return {
    width,
    height,
    stop
  };
}
function useIntersectionObserver(target, callback, options = {}) {
  const {
    root: root2,
    rootMargin = "0px",
    threshold = 0,
    window: window2 = defaultWindow,
    immediate = true
  } = options;
  const isSupported = useSupported(() => window2 && "IntersectionObserver" in window2);
  const targets = computed(() => {
    const _target = toValue(target);
    return (Array.isArray(_target) ? _target : [_target]).map(unrefElement).filter(notNullish);
  });
  let cleanup = noop;
  const isActive = ref(immediate);
  const stopWatch = isSupported.value ? watch(
    () => [targets.value, unrefElement(root2), isActive.value],
    ([targets2, root22]) => {
      cleanup();
      if (!isActive.value)
        return;
      if (!targets2.length)
        return;
      const observer = new IntersectionObserver(
        callback,
        {
          root: unrefElement(root22),
          rootMargin,
          threshold
        }
      );
      targets2.forEach((el) => el && observer.observe(el));
      cleanup = () => {
        observer.disconnect();
        cleanup = noop;
      };
    },
    { immediate, flush: "post" }
  ) : noop;
  const stop = () => {
    cleanup();
    stopWatch();
    isActive.value = false;
  };
  tryOnScopeDispose(stop);
  return {
    isSupported,
    isActive,
    pause() {
      cleanup();
      isActive.value = false;
    },
    resume() {
      isActive.value = true;
    },
    stop
  };
}
function useVirtualList(list, options) {
  const { containerStyle, wrapperProps, scrollTo, calculateRange, currentList, containerRef } = "itemHeight" in options ? useVerticalVirtualList(options, list) : useHorizontalVirtualList(options, list);
  return {
    list: currentList,
    scrollTo,
    containerProps: {
      ref: containerRef,
      onScroll: () => {
        calculateRange();
      },
      style: containerStyle
    },
    wrapperProps
  };
}
function useVirtualListResources(list) {
  const containerRef = ref(null);
  const size2 = useElementSize(containerRef);
  const currentList = ref([]);
  const source = shallowRef(list);
  const state2 = ref({ start: 0, end: 10 });
  return { state: state2, source, currentList, size: size2, containerRef };
}
function createGetViewCapacity(state2, source, itemSize) {
  return (containerSize) => {
    if (typeof itemSize === "number")
      return Math.ceil(containerSize / itemSize);
    const { start = 0 } = state2.value;
    let sum = 0;
    let capacity = 0;
    for (let i = start; i < source.value.length; i++) {
      const size2 = itemSize(i);
      sum += size2;
      capacity = i;
      if (sum > containerSize)
        break;
    }
    return capacity - start;
  };
}
function createGetOffset(source, itemSize) {
  return (scrollDirection) => {
    if (typeof itemSize === "number")
      return Math.floor(scrollDirection / itemSize) + 1;
    let sum = 0;
    let offset2 = 0;
    for (let i = 0; i < source.value.length; i++) {
      const size2 = itemSize(i);
      sum += size2;
      if (sum >= scrollDirection) {
        offset2 = i;
        break;
      }
    }
    return offset2 + 1;
  };
}
function createCalculateRange(type3, overscan, getOffset, getViewCapacity, { containerRef, state: state2, currentList, source }) {
  return () => {
    const element = containerRef.value;
    if (element) {
      const offset2 = getOffset(type3 === "vertical" ? element.scrollTop : element.scrollLeft);
      const viewCapacity = getViewCapacity(type3 === "vertical" ? element.clientHeight : element.clientWidth);
      const from = offset2 - overscan;
      const to2 = offset2 + viewCapacity + overscan;
      state2.value = {
        start: from < 0 ? 0 : from,
        end: to2 > source.value.length ? source.value.length : to2
      };
      currentList.value = source.value.slice(state2.value.start, state2.value.end).map((ele, index2) => ({
        data: ele,
        index: index2 + state2.value.start
      }));
    }
  };
}
function createGetDistance(itemSize, source) {
  return (index2) => {
    if (typeof itemSize === "number") {
      const size22 = index2 * itemSize;
      return size22;
    }
    const size2 = source.value.slice(0, index2).reduce((sum, _2, i) => sum + itemSize(i), 0);
    return size2;
  };
}
function useWatchForSizes(size2, list, containerRef, calculateRange) {
  watch([size2.width, size2.height, list, containerRef], () => {
    calculateRange();
  });
}
function createComputedTotalSize(itemSize, source) {
  return computed(() => {
    if (typeof itemSize === "number")
      return source.value.length * itemSize;
    return source.value.reduce((sum, _2, index2) => sum + itemSize(index2), 0);
  });
}
const scrollToDictionaryForElementScrollKey = {
  horizontal: "scrollLeft",
  vertical: "scrollTop"
};
function createScrollTo(type3, calculateRange, getDistance, containerRef) {
  return (index2) => {
    if (containerRef.value) {
      containerRef.value[scrollToDictionaryForElementScrollKey[type3]] = getDistance(index2);
      calculateRange();
    }
  };
}
function useHorizontalVirtualList(options, list) {
  const resources = useVirtualListResources(list);
  const { state: state2, source, currentList, size: size2, containerRef } = resources;
  const containerStyle = { overflowX: "auto" };
  const { itemWidth, overscan = 5 } = options;
  const getViewCapacity = createGetViewCapacity(state2, source, itemWidth);
  const getOffset = createGetOffset(source, itemWidth);
  const calculateRange = createCalculateRange("horizontal", overscan, getOffset, getViewCapacity, resources);
  const getDistanceLeft = createGetDistance(itemWidth, source);
  const offsetLeft = computed(() => getDistanceLeft(state2.value.start));
  const totalWidth = createComputedTotalSize(itemWidth, source);
  useWatchForSizes(size2, list, containerRef, calculateRange);
  const scrollTo = createScrollTo("horizontal", calculateRange, getDistanceLeft, containerRef);
  const wrapperProps = computed(() => {
    return {
      style: {
        height: "100%",
        width: `${totalWidth.value - offsetLeft.value}px`,
        marginLeft: `${offsetLeft.value}px`,
        display: "flex"
      }
    };
  });
  return {
    scrollTo,
    calculateRange,
    wrapperProps,
    containerStyle,
    currentList,
    containerRef
  };
}
function useVerticalVirtualList(options, list) {
  const resources = useVirtualListResources(list);
  const { state: state2, source, currentList, size: size2, containerRef } = resources;
  const containerStyle = { overflowY: "auto" };
  const { itemHeight, overscan = 5 } = options;
  const getViewCapacity = createGetViewCapacity(state2, source, itemHeight);
  const getOffset = createGetOffset(source, itemHeight);
  const calculateRange = createCalculateRange("vertical", overscan, getOffset, getViewCapacity, resources);
  const getDistanceTop = createGetDistance(itemHeight, source);
  const offsetTop = computed(() => getDistanceTop(state2.value.start));
  const totalHeight = createComputedTotalSize(itemHeight, source);
  useWatchForSizes(size2, list, containerRef, calculateRange);
  const scrollTo = createScrollTo("vertical", calculateRange, getDistanceTop, containerRef);
  const wrapperProps = computed(() => {
    return {
      style: {
        width: "100%",
        height: `${totalHeight.value - offsetTop.value}px`,
        marginTop: `${offsetTop.value}px`
      }
    };
  });
  return {
    calculateRange,
    scrollTo,
    containerStyle,
    wrapperProps,
    currentList,
    containerRef
  };
}
const _sfc_main$5 = /* @__PURE__ */ defineComponent({
  __name: "TableSchema",
  props: /* @__PURE__ */ mergeModels({
    data: { type: Array, required: true },
    schema: { type: Function, required: false, skipCheck: true },
    showFields: { type: Array, required: false },
    useServerSort: { type: Boolean, required: false, default: false },
    selectable: { type: Boolean, required: false, default: false },
    onLastItemVisible: { type: Function, required: false }
  }, {
    "loading": { default: false },
    "loadingModifiers": {},
    "itemHeight": { default: 50 },
    "itemHeightModifiers": {},
    "selectedItems": { type: Array, ...{
      default: []
    } },
    "selectedItemsModifiers": {}
  }),
  emits: /* @__PURE__ */ mergeModels(["update:selectedItems", "orderBy", "select", "lastItemVisible"], ["update:loading", "update:itemHeight", "update:selectedItems"]),
  setup(__props, { expose: __expose, emit: __emit }) {
    __expose();
    useCssVars((_ctx) => ({
      "2ad721d3-computedItemHeight": unref(computedItemHeight)
    }));
    const emit2 = __emit;
    const NON_DIGIT_REGEX = /[^\d.-]/g;
    const slots = useSlots();
    const loading = useModel(__props, "loading");
    const itemHeight = useModel(__props, "itemHeight");
    const selectedItems = useModel(
      __props,
      "selectedItems",
      {
        set: (value) => value
      }
    );
    let sortField = ref("");
    let sortDirection = ref("ASC");
    const allSelectorEl = ref();
    const lastItemEl = ref();
    const computedSelectedItems = computed(() => selectedItems.value);
    const computedItemHeight = computed(() => `${itemHeight.value}px`);
    const isSelectable = computed(() => __props.selectable === true && Array.isArray(selectedItems.value));
    const computedSortField = computed(() => `_transformed_${sortField.value}`);
    const computedSchema = computed(() => useBglSchema({
      schema: __props.schema,
      showFields: __props.showFields,
      data: __props.data
    }));
    const computedData = computed(() => {
      if (!sortField.value || __props.useServerSort === true) return __props.data.map(transform);
      return __props.data.map(transform).sort(
        (a, z2) => {
          let aValue = a[computedSortField.value] ?? a[sortField.value] ?? "";
          let bValue = z2[computedSortField.value] ?? z2[sortField.value] ?? "";
          if (isDate(aValue) && isDate(bValue)) {
            aValue = new Date(aValue).getTime();
            bValue = new Date(bValue).getTime();
          }
          const numAValue = Number.parseInt(`${aValue}`.replaceAll(NON_DIGIT_REGEX, ""), 10);
          const numBValue = Number.parseInt(`${bValue}`.replaceAll(NON_DIGIT_REGEX, ""), 10);
          if (!Number.isNaN(numAValue) && !Number.isNaN(numBValue)) {
            if (sortDirection.value === "ASC") return numAValue - numBValue;
            return numBValue - numAValue;
          }
          if (typeof aValue === "string") {
            if (sortDirection.value === "ASC") return aValue.localeCompare(bValue);
            return bValue.localeCompare(aValue);
          }
          if (sortDirection.value === "ASC") return aValue < bValue ? -1 : 1;
          return aValue < bValue ? 1 : -1;
        }
      );
    });
    function transform(rowData) {
      var _a2;
      const obj = { ...rowData };
      const schemaFields = computedSchema.value.filter((f) => f.id);
      for (const field of schemaFields) {
        const fieldData = rowData[`${field.id}`];
        const newFieldVal = (_a2 = field.transform) == null ? void 0 : _a2.call(field, fieldData, rowData);
        Object.assign(obj, {
          [`${field.id}`]: fieldData,
          [`_transformed_${field.id}`]: newFieldVal
        });
      }
      return obj;
    }
    function sort2(fieldname) {
      if (sortField.value === fieldname) {
        if (sortDirection.value === "ASC") sortDirection.value = "DESC";
        else sortField.value = "";
      } else {
        sortField.value = fieldname;
        sortDirection.value = "ASC";
      }
      emit2("orderBy", `${fieldname} ${sortDirection.value}`.trim());
    }
    const { list, containerProps, wrapperProps, scrollTo } = useVirtualList(
      computedData,
      {
        itemHeight: itemHeight.value,
        overscan: 10
      }
    );
    function updateAllSelectorState() {
      if (!allSelectorEl.value) return;
      const allSelected = computedData.value.length === computedSelectedItems.value.length && computedData.value.every((s) => s.id && computedSelectedItems.value.includes(s.id));
      allSelectorEl.value.checked = allSelected;
      allSelectorEl.value.indeterminate = !allSelected && computedSelectedItems.value.length > 0;
    }
    function toggleSelectItem(item) {
      if (computedSelectedItems.value.length === 0) {
        const obj = { ...item };
        Object.keys(obj).forEach((key) => key.startsWith("_transformed_") && delete obj[key]);
        emit2("select", obj);
        return;
      }
      const index2 = computedSelectedItems.value.indexOf(item.id);
      index2 > -1 ? computedSelectedItems.value.splice(index2, 1) : computedSelectedItems.value.push(item.id);
    }
    function toggleSelectAll(event) {
      const value = event.target.checked;
      selectedItems.value = value ? computedData.value.map((d2) => d2.id) : [];
    }
    async function registerLastItemObserver() {
      await until(() => lastItemEl.value).toBeTruthy();
      useIntersectionObserver(lastItemEl.value, ([entry]) => {
        if (entry.isIntersecting && computedData.value.length) {
          emit2("lastItemVisible");
        }
      });
    }
    watch(
      () => computedData.value.length,
      (newLength, oldLength) => {
        if (newLength === oldLength || __props.onLastItemVisible !== void 0) return;
        scrollTo(0);
      }
    );
    watch(
      () => computedSelectedItems.value.length,
      () => {
        updateAllSelectorState();
      }
    );
    watch(
      () => loading.value,
      (newLoadingVal, oldLoadingVal) => {
        if (newLoadingVal === oldLoadingVal) return;
        if (!newLoadingVal) registerLastItemObserver();
      },
      { immediate: true }
    );
    const __returned__ = { emit: emit2, NON_DIGIT_REGEX, slots, loading, itemHeight, selectedItems, get sortField() {
      return sortField;
    }, set sortField(v) {
      sortField = v;
    }, get sortDirection() {
      return sortDirection;
    }, set sortDirection(v) {
      sortDirection = v;
    }, allSelectorEl, lastItemEl, computedSelectedItems, computedItemHeight, isSelectable, computedSortField, computedSchema, computedData, transform, sort: sort2, list, containerProps, wrapperProps, scrollTo, updateAllSelectorState, toggleSelectItem, toggleSelectAll, registerLastItemObserver, get BglField() {
      return BglField;
    }, get MaterialIcon() {
      return Icon;
    }, get keyToLabel() {
      return keyToLabel;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1$3 = {
  key: 0,
  class: "loading-table-wrapper z-99 h-100 w-100 absolute inset"
};
const _hoisted_2$1 = { class: "infinite-wrapper" };
const _hoisted_3$1 = { class: "row first-row" };
const _hoisted_4$1 = { key: 0 };
const _hoisted_5$1 = ["onClick"];
const _hoisted_6$1 = { class: "flex" };
const _hoisted_7$1 = ["onClick"];
const _hoisted_8$1 = { key: 0 };
const _hoisted_9$1 = ["value"];
const _hoisted_10$1 = { key: 1 };
const _hoisted_11$1 = {
  key: 0,
  ref: "lastItemEl",
  style: { "height": "1px" }
};
function _sfc_render$5(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    mergeProps({ class: "table-list-wrap h-100" }, $setup.containerProps, {
      class: { "loading-table": $setup.loading }
    }),
    [
      $setup.loading ? (openBlock(), createElementBlock("div", _hoisted_1$3, _cache[3] || (_cache[3] = [
        createElementVNode(
          "div",
          { class: "loading-table-animation absolute oval" },
          null,
          -1
          /* HOISTED */
        )
      ]))) : (openBlock(), createElementBlock(
        "div",
        normalizeProps(mergeProps({ key: 1 }, $setup.wrapperProps)),
        [
          createElementVNode("table", _hoisted_2$1, [
            createElementVNode("thead", _hoisted_3$1, [
              $setup.isSelectable ? (openBlock(), createElementBlock("th", _hoisted_4$1, [
                createElementVNode(
                  "input",
                  {
                    ref: "allSelectorEl",
                    type: "checkbox",
                    onClick: _cache[0] || (_cache[0] = withModifiers(() => {
                    }, ["stop"])),
                    onChange: $setup.toggleSelectAll
                  },
                  null,
                  544
                  /* NEED_HYDRATION, NEED_PATCH */
                )
              ])) : createCommentVNode("v-if", true),
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList($setup.computedSchema, (field) => {
                  return openBlock(), createElementBlock("th", {
                    key: field.id,
                    class: "col",
                    onClick: ($event) => $setup.sort((field == null ? void 0 : field.id) || "")
                  }, [
                    createElementVNode("div", _hoisted_6$1, [
                      createTextVNode(
                        toDisplayString(field.label || $setup.keyToLabel(field.id)) + " ",
                        1
                        /* TEXT */
                      ),
                      createElementVNode(
                        "div",
                        {
                          class: normalizeClass(["list-arrows", { sorted: $setup.sortField === field.id }])
                        },
                        [
                          createVNode($setup["MaterialIcon"], {
                            class: normalizeClass({ desc: $setup.sortDirection === "DESC" }),
                            icon: "keyboard_arrow_up"
                          }, null, 8, ["class"])
                        ],
                        2
                        /* CLASS */
                      )
                    ])
                  ], 8, _hoisted_5$1);
                }),
                128
                /* KEYED_FRAGMENT */
              ))
            ]),
            createElementVNode("tbody", null, [
              (openBlock(true), createElementBlock(
                Fragment,
                null,
                renderList($setup.list, ({ data: row }) => {
                  return openBlock(), createElementBlock("tr", {
                    key: row.id,
                    class: normalizeClass(["row row-item position-relative", { selected: $setup.computedSelectedItems.includes(row.id ?? "") }]),
                    onClick: ($event) => $setup.toggleSelectItem(row)
                  }, [
                    $setup.isSelectable ? (openBlock(), createElementBlock("td", _hoisted_8$1, [
                      createElementVNode("div", {
                        onClick: _cache[2] || (_cache[2] = withModifiers(() => {
                        }, ["stop"]))
                      }, [
                        withDirectives(createElementVNode("input", {
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => $setup.selectedItems = $event),
                          type: "checkbox",
                          value: row.id
                        }, null, 8, _hoisted_9$1), [
                          [vModelCheckbox, $setup.selectedItems]
                        ])
                      ])
                    ])) : createCommentVNode("v-if", true),
                    (openBlock(true), createElementBlock(
                      Fragment,
                      null,
                      renderList($setup.computedSchema, (field) => {
                        return openBlock(), createElementBlock("td", {
                          key: `${field.id}-${row.id}`,
                          class: "col"
                        }, [
                          field.id && $setup.slots[field.id] ? renderSlot(_ctx.$slots, field.id, {
                            key: 0,
                            row,
                            field
                          }, void 0, true) : (openBlock(), createElementBlock("div", _hoisted_10$1, [
                            createVNode($setup["BglField"], {
                              class: "embedded-field",
                              field,
                              modelValue: row,
                              label: ""
                            }, null, 8, ["field", "modelValue"])
                          ]))
                        ]);
                      }),
                      128
                      /* KEYED_FRAGMENT */
                    ))
                  ], 10, _hoisted_7$1);
                }),
                128
                /* KEYED_FRAGMENT */
              )),
              $props.onLastItemVisible !== void 0 ? (openBlock(), createElementBlock(
                "tr",
                _hoisted_11$1,
                null,
                512
                /* NEED_PATCH */
              )) : createCommentVNode("v-if", true)
            ])
          ])
        ],
        16
        /* FULL_PROPS */
      ))
    ],
    16
    /* FULL_PROPS */
  );
}
const TableSchema = /* @__PURE__ */ _export_sfc(_sfc_main$5, [["render", _sfc_render$5], ["__scopeId", "data-v-2ad721d3"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/TableSchema.vue"]]);
const _sfc_main$4 = /* @__PURE__ */ defineComponent({
  __name: "Title",
  props: {
    value: {
      type: String,
      default: ""
    },
    label: {
      type: String,
      default: ""
    },
    tag: {
      type: String,
      default: "h1"
    }
  },
  setup(__props, { expose: __expose }) {
    __expose();
    const __returned__ = {};
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$4(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(resolveDynamicComponent($props.tag), null, {
    default: withCtx(() => [
      createTextVNode(
        toDisplayString($props.label || $props.value) + " ",
        1
        /* TEXT */
      ),
      renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
    /* FORWARDED */
  });
}
const Title = /* @__PURE__ */ _export_sfc(_sfc_main$4, [["render", _sfc_render$4], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Title.vue"]]);
const _sfc_main$3 = {};
const _hoisted_1$2 = { class: "bg-red" };
function _sfc_render$3(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$2, " 123 ");
}
const ToolBar = /* @__PURE__ */ _export_sfc(_sfc_main$3, [["render", _sfc_render$3], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/ToolBar.vue"]]);
const _sfc_main$2 = {};
const _hoisted_1$1 = { class: "flex space-between" };
function _sfc_render$2(_ctx, _cache) {
  return openBlock(), createElementBlock("div", _hoisted_1$1, [
    renderSlot(_ctx.$slots, "default")
  ]);
}
const TopBar = /* @__PURE__ */ _export_sfc(_sfc_main$2, [["render", _sfc_render$2], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/TopBar.vue"]]);
class TapDetector {
  constructor() {
    __publicField2(this, "singleTapCallbacks", []);
    __publicField2(this, "doubleTapCallbacks", []);
    __publicField2(this, "isTouchMode", false);
    __publicField2(this, "lastTapTimestamp", 0);
    __publicField2(this, "tappedCount", 0);
    __publicField2(this, "touchMovedLength", 0);
    __publicField2(this, "lastPointerX", 0);
    __publicField2(this, "lastPointerY", 0);
    __publicField2(this, "onTouchStart", (event) => {
      this.isTouchMode = true;
      if (event.touches.length === 1) {
        this.onPointerDown(event.touches[0].clientX, event.touches[0].clientY);
      }
    });
    __publicField2(this, "onTouchMove", (event) => {
      if (event.touches.length === 1) {
        this.onPointerMove(event.touches[0].clientX, event.touches[0].clientY);
      }
    });
    __publicField2(this, "onTouchEnd", () => {
      if (this.isTouchMode) this.onPointerUp();
    });
    __publicField2(this, "onMouseDown", (event) => {
      if (!this.isTouchMode) {
        this.onPointerDown(event.clientX, event.clientY);
      }
    });
    __publicField2(this, "onMouseMove", (event) => {
      if (!this.isTouchMode && event.button === 0) {
        this.onPointerMove(event.clientX, event.clientY);
      }
    });
    __publicField2(this, "onMouseUp", () => {
      if (!this.isTouchMode) this.onPointerUp();
    });
  }
  attach(dom) {
    if (!(dom instanceof Element)) {
      console.error("TapDetector.attach: arg must be an Element");
      return;
    }
    dom.addEventListener("touchstart", this.onTouchStart);
    dom.addEventListener("touchmove", this.onTouchMove);
    dom.addEventListener("touchend", this.onTouchEnd);
    dom.addEventListener("mousedown", this.onMouseDown);
    dom.addEventListener("mouseup", this.onMouseUp);
    dom.addEventListener("mousemove", this.onMouseMove);
  }
  detach(dom) {
    dom.removeEventListener("touchstart", this.onTouchStart);
    dom.removeEventListener("touchmove", this.onTouchMove);
    dom.removeEventListener("touchend", this.onTouchEnd);
    dom.removeEventListener("mousedown", this.onMouseDown);
    dom.removeEventListener("mouseup", this.onMouseUp);
    dom.removeEventListener("mousemove", this.onMouseMove);
  }
  onSingleTap(callback) {
    if (typeof callback === "function" && !this.singleTapCallbacks.includes(callback)) {
      this.singleTapCallbacks.push(callback);
    }
  }
  onDoubleTap(callback) {
    if (typeof callback === "function" && !this.doubleTapCallbacks.includes(callback)) {
      this.doubleTapCallbacks.push(callback);
    }
  }
  triggerCallbacks(callbackType, event) {
    const callbacks = callbackType === "single" ? this.singleTapCallbacks : this.doubleTapCallbacks;
    callbacks.forEach((callback) => {
      callback(event);
    });
  }
  onPointerDown(x2, y2) {
    this.lastPointerX = x2;
    this.lastPointerY = y2;
    this.touchMovedLength = 0;
  }
  onPointerUp() {
    const currTimeStamp = Date.now();
    if (this.touchMovedLength < 10) {
      if (currTimeStamp - this.lastTapTimestamp < 300) {
        this.tappedCount++;
      } else {
        this.tappedCount = 1;
      }
      this.lastTapTimestamp = currTimeStamp;
      this.triggerCallbacks("single", { clientX: this.lastPointerX, clientY: this.lastPointerY });
      if (this.tappedCount === 2) {
        this.triggerCallbacks("double", { clientX: this.lastPointerX, clientY: this.lastPointerY });
        this.tappedCount = 0;
      }
    }
    this.touchMovedLength = 0;
  }
  onPointerMove(x2, y2) {
    const deltaX = this.lastPointerX - x2;
    const deltaY = this.lastPointerY - y2;
    this.touchMovedLength += Math.sqrt(deltaX * deltaX + deltaY * deltaY);
    this.lastPointerX = x2;
    this.lastPointerY = y2;
  }
}
const _sfc_main$1 = /* @__PURE__ */ defineComponent({
  __name: "Zoomer",
  props: {
    minScale: { type: Number, required: false, default: 1 },
    maxScale: { type: Number, required: false, default: 5 },
    zoom: { type: Number, required: false },
    resetTrigger: { type: Number, required: false },
    aspectRatio: { type: Number, required: false, default: 1 },
    backgroundColor: { type: String, required: false, default: "transparent" },
    pivot: { type: String, required: false, default: "cursor" },
    zoomingElastic: { type: Boolean, required: false, default: true },
    limitTranslation: { type: Boolean, required: false, default: true },
    doubleClickToZoom: { type: Boolean, required: false, default: true },
    mouseWheelToZoom: { type: Boolean, required: false, default: true },
    disabled: { type: Boolean, required: false, default: false }
  },
  emits: ["update:zoom"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit2 = __emit;
    const zoomElement = ref();
    let containerWidth = ref(1);
    let containerHeight = ref(1);
    let containerLeft = ref(0);
    let containerTop = ref(0);
    let translateX2 = ref(0);
    let animTranslateX = ref(0);
    let translateY2 = ref(0);
    let animTranslateY = ref(0);
    let _zoom = ref(__props.zoom || 1);
    let scale = computed({
      get: () => __props.zoom === void 0 ? _zoom.value : __props.zoom,
      set: (val) => {
        _zoom.value = val;
        emit2("update:zoom", _zoom.value);
      }
    });
    let animScale = ref(1);
    let lastFullWheelTime = ref(0);
    let lastWheelTime = ref(0);
    let lastWheelDirection = ref("y");
    let isPointerDown = ref(false);
    let pointerPosX = ref(-1);
    let pointerPosY = ref(-1);
    let twoFingerInitDist = ref(0);
    let panLocked = ref(true);
    let raf = ref();
    let tapDetector = ref();
    const wrapperStyle = computed(() => {
      const translateXValue = containerWidth.value * animTranslateX.value;
      const translateYValue = containerHeight.value * animTranslateY.value;
      return {
        transform: [
          `translate(${translateXValue}px, ${translateYValue}px)`,
          `scale(${animScale.value})`
        ].join(" ")
      };
    });
    watch(() => scale.value, (newScale) => {
      const { x: x2, y: y2 } = calcTranslateLimit();
      translateX2.value = Math.max(-x2, Math.min(x2, translateX2.value));
      translateY2.value = Math.max(-y2, Math.min(y2, translateY2.value));
      if (newScale !== 1) {
        panLocked.value = false;
      }
    });
    function reset() {
      scale.value = 1;
      panLocked.value = true;
      translateX2.value = 0;
      translateY2.value = 0;
    }
    __expose({ reset });
    function tryToScale(scaleDelta) {
      if (__props.disabled) return;
      let newScale = scale.value * scaleDelta;
      if (__props.zoomingElastic) {
        if (newScale < __props.minScale || newScale > __props.maxScale) {
          let log = Math.log2(scaleDelta);
          log *= 0.2;
          scaleDelta = 2 ** log;
          newScale = scale.value * scaleDelta;
        }
      } else {
        if (newScale < __props.minScale) newScale = __props.minScale;
        else if (newScale > __props.maxScale) newScale = __props.maxScale;
      }
      scaleDelta = newScale / scale.value;
      scale.value = newScale;
      if (__props.pivot !== "image-center") {
        const normMousePosX = (pointerPosX.value - containerLeft.value) / containerWidth.value;
        const normMousePosY = (pointerPosY.value - containerTop.value) / containerHeight.value;
        translateX2.value = (0.5 + translateX2.value - normMousePosX) * scaleDelta + normMousePosX - 0.5;
        translateY2.value = (0.5 + translateY2.value - normMousePosY) * scaleDelta + normMousePosY - 0.5;
      }
    }
    function setPointerPosCenter() {
      pointerPosX.value = containerLeft.value + containerWidth.value / 2;
      pointerPosY.value = containerTop.value + containerHeight.value / 2;
    }
    function onPointerMove(newMousePosX, newMousePosY) {
      if (isPointerDown.value) {
        const pixelDeltaX = newMousePosX - pointerPosX.value;
        const pixelDeltaY = newMousePosY - pointerPosY.value;
        if (!panLocked.value) {
          const translateLimit = calcTranslateLimit();
          const maxTranslateX = translateLimit.x;
          const maxTranslateY = translateLimit.y;
          const newTranslateX = translateX2.value + pixelDeltaX / containerWidth.value;
          const newTranslateY = translateY2.value + pixelDeltaY / containerHeight.value;
          translateX2.value = Math.max(-maxTranslateX, Math.min(maxTranslateX, newTranslateX));
          translateY2.value = Math.max(-maxTranslateY, Math.min(maxTranslateY, newTranslateY));
        }
      }
      pointerPosX.value = newMousePosX;
      pointerPosY.value = newMousePosY;
    }
    function onInteractionEnd() {
    }
    function limit() {
      if (scale.value < __props.minScale) {
        scale.value = __props.minScale;
      } else if (scale.value > __props.maxScale) {
        tryToScale(__props.maxScale / scale.value);
      }
      if (__props.limitTranslation) {
        const translateLimit = calcTranslateLimit();
        if (Math.abs(translateX2.value) > translateLimit.x) {
          translateX2.value *= translateLimit.x / Math.abs(translateX2.value);
        }
        if (Math.abs(translateY2.value) > translateLimit.y) {
          translateY2.value *= translateLimit.y / Math.abs(translateY2.value);
        }
      }
    }
    function calcTranslateLimit() {
      if (getMarginDirection() === "y") {
        const imageToContainerRatio2 = containerWidth.value / __props.aspectRatio / containerHeight.value;
        let translateLimitY = (scale.value * imageToContainerRatio2 - 1) / 2;
        if (translateLimitY < 0) translateLimitY = 0;
        return { x: (scale.value - 1) / 2, y: translateLimitY };
      }
      const imageToContainerRatio = containerHeight.value * __props.aspectRatio / containerWidth.value;
      let translateLimitX = (scale.value * imageToContainerRatio - 1) / 2;
      if (translateLimitX < 0) translateLimitX = 0;
      return { x: translateLimitX, y: (scale.value - 1) / 2 };
    }
    function getMarginDirection() {
      const containerRatio = containerWidth.value / containerHeight.value;
      return containerRatio > __props.aspectRatio ? "x" : "y";
    }
    function onMouseWheel(ev) {
      if (!__props.mouseWheelToZoom) return;
      ev.preventDefault();
      const currTime = Date.now();
      if (Math.abs(ev.deltaY) === 120) {
        if (currTime - lastFullWheelTime.value > 50) {
          onMouseWheelDo(ev.deltaY);
          lastFullWheelTime.value = currTime;
        }
      } else {
        if (currTime - lastWheelTime.value > 50) {
          lastWheelDirection.value = ev.deltaX > ev.deltaY ? "x" : "y";
          if (lastWheelDirection.value === "y") {
            onMouseWheelDo(ev.deltaY);
          }
        }
        lastWheelTime.value = currTime;
      }
    }
    function onMouseWheelDo(wheelDelta) {
      const scaleDelta = 1.25 ** (wheelDelta / 120);
      tryToScale(scaleDelta);
    }
    function onMouseDown(ev) {
      refreshContainerPos();
      isPointerDown.value = true;
      pointerPosX.value = ev.clientX;
      pointerPosY.value = ev.clientY;
      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    }
    function onMouseUp() {
      isPointerDown.value = false;
      document.removeEventListener("mouseup", onMouseUp);
      document.removeEventListener("mousemove", onMouseMove);
    }
    function onMouseMove(ev) {
      onPointerMove(ev.clientX, ev.clientY);
    }
    function onTouchStart(ev) {
      if (ev.touches.length === 1) {
        refreshContainerPos();
        pointerPosX.value = ev.touches[0].clientX;
        pointerPosY.value = ev.touches[0].clientY;
        isPointerDown.value = true;
      } else if (ev.touches.length === 2) {
        isPointerDown.value = true;
        pointerPosX.value = (ev.touches[0].clientX + ev.touches[1].clientX) / 2;
        pointerPosY.value = (ev.touches[0].clientY + ev.touches[1].clientY) / 2;
        const distX = ev.touches[0].clientX - ev.touches[1].clientX;
        const distY = ev.touches[0].clientY - ev.touches[1].clientY;
        twoFingerInitDist.value = Math.sqrt(distX * distX + distY * distY);
      }
      document.addEventListener("touchend", onTouchEnd);
    }
    function onTouchEnd(ev) {
      if (ev.touches.length === 0) {
        isPointerDown.value = false;
        if (Math.abs(scale.value - 1) < 0.1) scale.value = 1;
      } else if (ev.touches.length === 1) {
        pointerPosX.value = ev.touches[0].clientX;
        pointerPosY.value = ev.touches[0].clientY;
      }
      document.removeEventListener("touchend", onTouchEnd);
    }
    function onTouchMove(ev) {
      if (ev.touches.length === 1) {
        onPointerMove(ev.touches[0].clientX, ev.touches[0].clientY);
      } else if (ev.touches.length === 2) {
        const distX = ev.touches[0].clientX - ev.touches[1].clientX;
        const distY = ev.touches[0].clientY - ev.touches[1].clientY;
        const newTwoFingerDist = Math.sqrt(distX * distX + distY * distY);
        tryToScale(newTwoFingerDist / twoFingerInitDist.value);
        twoFingerInitDist.value = newTwoFingerDist;
      }
    }
    function refreshContainerPos() {
      if (zoomElement.value) {
        const rect = zoomElement.value.getBoundingClientRect();
        containerLeft.value = rect.left;
        containerTop.value = rect.top;
      }
    }
    function loop() {
      animScale.value = gainOn(animScale.value, scale.value);
      animTranslateX.value = gainOn(animTranslateX.value, translateX2.value);
      animTranslateY.value = gainOn(animTranslateY.value, translateY2.value);
      raf.value = window.requestAnimationFrame(loop);
    }
    function gainOn(from, to2) {
      const delta = (to2 - from) * 0.3;
      return Math.abs(delta) > 1e-5 ? from + delta : to2;
    }
    onMounted(() => {
      tapDetector.value = new TapDetector();
      if (zoomElement.value) tapDetector.value.attach(zoomElement.value);
      if (__props.doubleClickToZoom) {
        tapDetector.value.onDoubleTap(onDoubleTap);
      }
      window.addEventListener("resize", onWindowResize);
      onWindowResize();
      refreshContainerPos();
      loop();
    });
    onUnmounted(() => {
      var _a2;
      if (zoomElement.value) (_a2 = tapDetector.value) == null ? void 0 : _a2.detach(zoomElement.value);
      window.removeEventListener("resize", onWindowResize);
      if (raf.value) window.cancelAnimationFrame(raf.value);
    });
    function onDoubleTap(ev) {
      if (scale.value === 1) {
        if (ev.clientX > 0) {
          pointerPosX.value = ev.clientX;
          pointerPosY.value = ev.clientY;
        }
        tryToScale(Math.min(3, __props.maxScale));
      } else {
        reset();
      }
    }
    function onWindowResize() {
      if (zoomElement.value) {
        const styles = window.getComputedStyle(zoomElement.value);
        containerWidth.value = Number.parseFloat(styles.width);
        containerHeight.value = Number.parseFloat(styles.height);
        setPointerPosCenter();
        limit();
      }
    }
    const __returned__ = { emit: emit2, zoomElement, get containerWidth() {
      return containerWidth;
    }, set containerWidth(v) {
      containerWidth = v;
    }, get containerHeight() {
      return containerHeight;
    }, set containerHeight(v) {
      containerHeight = v;
    }, get containerLeft() {
      return containerLeft;
    }, set containerLeft(v) {
      containerLeft = v;
    }, get containerTop() {
      return containerTop;
    }, set containerTop(v) {
      containerTop = v;
    }, get translateX() {
      return translateX2;
    }, set translateX(v) {
      translateX2 = v;
    }, get animTranslateX() {
      return animTranslateX;
    }, set animTranslateX(v) {
      animTranslateX = v;
    }, get translateY() {
      return translateY2;
    }, set translateY(v) {
      translateY2 = v;
    }, get animTranslateY() {
      return animTranslateY;
    }, set animTranslateY(v) {
      animTranslateY = v;
    }, get _zoom() {
      return _zoom;
    }, set _zoom(v) {
      _zoom = v;
    }, get scale() {
      return scale;
    }, set scale(v) {
      scale = v;
    }, get animScale() {
      return animScale;
    }, set animScale(v) {
      animScale = v;
    }, get lastFullWheelTime() {
      return lastFullWheelTime;
    }, set lastFullWheelTime(v) {
      lastFullWheelTime = v;
    }, get lastWheelTime() {
      return lastWheelTime;
    }, set lastWheelTime(v) {
      lastWheelTime = v;
    }, get lastWheelDirection() {
      return lastWheelDirection;
    }, set lastWheelDirection(v) {
      lastWheelDirection = v;
    }, get isPointerDown() {
      return isPointerDown;
    }, set isPointerDown(v) {
      isPointerDown = v;
    }, get pointerPosX() {
      return pointerPosX;
    }, set pointerPosX(v) {
      pointerPosX = v;
    }, get pointerPosY() {
      return pointerPosY;
    }, set pointerPosY(v) {
      pointerPosY = v;
    }, get twoFingerInitDist() {
      return twoFingerInitDist;
    }, set twoFingerInitDist(v) {
      twoFingerInitDist = v;
    }, get panLocked() {
      return panLocked;
    }, set panLocked(v) {
      panLocked = v;
    }, get raf() {
      return raf;
    }, set raf(v) {
      raf = v;
    }, get tapDetector() {
      return tapDetector;
    }, set tapDetector(v) {
      tapDetector = v;
    }, wrapperStyle, reset, tryToScale, setPointerPosCenter, onPointerMove, onInteractionEnd, limit, calcTranslateLimit, getMarginDirection, onMouseWheel, onMouseWheelDo, onMouseDown, onMouseUp, onMouseMove, onTouchStart, onTouchEnd, onTouchMove, refreshContainerPos, loop, gainOn, onDoubleTap, onWindowResize };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
function _sfc_render$1(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock(
    "div",
    {
      ref: "zoomElement",
      class: "vue-zoomer",
      style: normalizeStyle({ backgroundColor: $props.backgroundColor }),
      onMousewheel: $setup.onMouseWheel,
      "on:DOMMouseScroll": $setup.onMouseWheel,
      onMousedown: $setup.onMouseDown,
      onMouseout: $setup.setPointerPosCenter,
      onFocusout: $setup.setPointerPosCenter,
      onTouchstart: $setup.onTouchStart,
      onTouchmove: $setup.onTouchMove
    },
    [
      createElementVNode(
        "div",
        {
          class: "zoomer",
          style: normalizeStyle($setup.wrapperStyle)
        },
        [
          renderSlot(_ctx.$slots, "default", {}, void 0, true)
        ],
        4
        /* STYLE */
      )
    ],
    36
    /* STYLE, NEED_HYDRATION */
  );
}
const Zoomer = /* @__PURE__ */ _export_sfc(_sfc_main$1, [["render", _sfc_render$1], ["__scopeId", "data-v-3b82372e"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/Zoomer.vue"]]);
function useBglSchema({ schema, showFields, data: data2 } = {}) {
  let _schema = schema;
  if (typeof _schema === "function") {
    _schema = _schema();
  }
  if (_schema) {
    return showFields && showFields.length > 0 ? _schema.filter((f) => showFields.includes(f.id)) : _schema;
  }
  return getFallbackSchema(data2, showFields);
}
function localRef(key, initialValue) {
  const storedValue = localStorage.getItem(key);
  const initial = storedValue !== null ? JSON.parse(storedValue) : initialValue;
  const value = ref(initial);
  watch(() => value.value, (val) => {
    localStorage.setItem(key, JSON.stringify(val));
  }, { immediate: true, deep: true });
  return value;
}
const useLocalStorage = localRef;
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
const axios = axios$1.create({
  withCredentials: true
});
class DataRequest {
  constructor(table, bagel) {
    __publicField(this, "data_table");
    __publicField(this, "bagel");
    __publicField(this, "itemID");
    __publicField(this, "_filter", {});
    this.data_table = table;
    this.bagel = bagel;
    this.itemID = "";
  }
  async post(item) {
    if (!this.data_table)
      throw new Error("Data table not set");
    const { data: data2 } = await axios.post(`/data/${this.data_table}`, item);
    return data2;
  }
  filter(filter3) {
    this._filter = filter3;
    return this;
  }
  async get() {
    var _a2, _b;
    if (!this.data_table)
      throw new Error("Data table not set");
    const filterStr = Object.keys(this._filter).length > 0 ? `?filter={${Object.entries(this._filter).map(([k2, v]) => `${k2}:${v}`).join(",")}}` : "";
    const url = `/data/${this.data_table}${this.itemID ? `/${this.itemID}` : ""}${filterStr}`;
    try {
      const { data: data2 } = await axios.get(url);
      return data2;
    } catch (err) {
      console.log(err);
      (_b = (_a2 = this.bagel).onError) == null ? void 0 : _b.call(_a2, err);
      return void 0;
    }
  }
  item(id) {
    this.itemID = id;
    return this;
  }
  async delete() {
    if (!this.data_table)
      throw new Error("Data table not set");
    const { data: data2 } = await axios.delete(
      `/data/${this.data_table}/${this.itemID}`
    );
    return data2;
  }
  async put(updatedItem) {
    const { data_table, itemID } = this;
    if (!data_table)
      throw new Error("Data table not set");
    if (!itemID)
      throw new Error("Item ID not set");
    const { data: data2 } = await axios.put(
      `/data/${data_table}/${itemID}`,
      updatedItem
    );
    return data2;
  }
}
function responses(key) {
  const res = {
    LOGIN_BAD_CREDENTIALS: "Invalid username or password",
    RESET_PASSWORD_BAD_TOKEN: "This reset password link is invalid or expired."
  };
  return res[key] || key;
}
class BagelAuth {
  constructor(bagel) {
    this.bagel = bagel;
    __publicField(this, "user");
    this.bagel = bagel;
  }
  async validateUser() {
    try {
      const { data: usr } = await axios.get("/users/me", {
        withCredentials: true
      });
      this.user = usr;
      return usr;
    } catch {
    }
  }
  async resetPassword(ctx) {
    return this.bagel.post("auth/reset-password", ctx).catch((err) => {
      var _a2, _b;
      throw responses((_b = (_a2 = err.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.detail);
    });
  }
  async forgotPassword(email) {
    var _a2, _b;
    try {
      await this.bagel.post("auth/forgot-password", { email });
    } catch (err) {
      throw responses((_b = (_a2 = err == null ? void 0 : err.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.detail);
    }
  }
  async login(user) {
    var _a2, _b;
    const formData = new FormData();
    formData.append("username", user.email || "");
    formData.append("password", user.password || "");
    console.log("Logging in");
    try {
      await axios.post("/auth/cookie/login", formData, {
        headers: {
          "withCredentials": true,
          "Content-Type": "multipart/form-data"
        }
      });
      axios.defaults.withCredentials = true;
      return this.validateUser();
    } catch (err) {
      throw responses(((_b = (_a2 = err.response) == null ? void 0 : _a2.data) == null ? void 0 : _b.detail) || "LOGIN_BAD_CREDENTIALS");
    }
  }
  async logout() {
    var _a2, _b;
    try {
      await axios.post("/auth/cookie/logout");
    } catch (err) {
      (_b = (_a2 = this.bagel).onError) == null ? void 0 : _b.call(_a2, err);
      console.log(err);
    }
    this.user = void 0;
  }
  async acceptInvite(token, user) {
    await axios.post(`/auth/accept-invite/${token}`, user);
    await this.login(user);
  }
  async register(user, errors) {
    try {
      await axios.post("/auth/register", user);
      return this.login(user);
    } catch (err) {
      console.error(err);
      errors.email = err.response.data.detail;
      throw err;
    }
  }
}
class Bagel {
  constructor({ host, fileBaseUrl, onError }) {
    __publicField(this, "host");
    __publicField(this, "fileBaseUrl");
    __publicField(this, "onError");
    __publicField(this, "read_table");
    __publicField(this, "auth", new BagelAuth(this));
    this.host = host == null ? void 0 : host.replace(/\/$/, "");
    this.fileBaseUrl = fileBaseUrl == null ? void 0 : fileBaseUrl.replace(/\/$/, "");
    if (!this.host) {
      return this;
    }
    axios.defaults.baseURL = this.host;
    this.onError = onError;
  }
  data(table) {
    return new DataRequest(table, this);
  }
  _endpointCleaner(endpoint) {
    const url = `${endpoint.replace(/^\//, "").replaceAll(/\/$/g, "")}`;
    return url;
  }
  async api(endpoint, query) {
    if (query) {
      const queryParams = Object.entries(query).map(([key, value]) => `${key}=${value}`).join("&");
      endpoint = `${endpoint}?${queryParams}`;
    }
    return axios.get(`/api/${endpoint}`).then(({ data: data2 }) => data2);
  }
  async get(endpoint, query) {
    this._setAuthorization();
    endpoint = this._endpointCleaner(endpoint);
    if (/undefined|null/.test(endpoint))
      throw new Error(`Invalid endpoint: ${endpoint}`);
    if (query) {
      const queryParams = Object.entries(query).filter(([_2, value]) => !!value).map(([key, value]) => `${key}=${value}`).join("&");
      if (queryParams)
        endpoint = `${endpoint}?${queryParams}`;
    }
    const url = `/${endpoint}`;
    return axios.get(url).then(({ data: data2 }) => data2).catch((err) => {
      var _a2;
      (_a2 = this.onError) == null ? void 0 : _a2.call(this, err);
      throw err;
    });
  }
  async delete(endpoint) {
    this._setAuthorization();
    endpoint = this._endpointCleaner(endpoint);
    return axios.delete(`/${endpoint}`).then(({ data: data2 }) => data2).catch((err) => {
      var _a2;
      (_a2 = this.onError) == null ? void 0 : _a2.call(this, err);
      throw err;
    });
  }
  async put(endpoint, payload) {
    endpoint = this._endpointCleaner(endpoint);
    this._setAuthorization();
    return axios.put(`/${endpoint}`, payload).then(({ data: data2 }) => data2).catch((err) => {
      var _a2;
      (_a2 = this.onError) == null ? void 0 : _a2.call(this, err);
      throw err;
    });
  }
  async patch(endpoint, payload = {}) {
    endpoint = this._endpointCleaner(endpoint);
    return axios.patch(`/${endpoint}`, payload).then(({ data: data2 }) => data2).catch((err) => {
      var _a2;
      (_a2 = this.onError) == null ? void 0 : _a2.call(this, err);
      throw err;
    });
  }
  _setAuthorization() {
    const Authorization = localStorage.getItem("access_token");
    if (Authorization) {
      axios.defaults.headers.common.Authorization = `Bearer ${Authorization}`;
    }
  }
  async post(endpoint, payload = {}) {
    this._setAuthorization();
    endpoint = this._endpointCleaner(endpoint);
    return axios.post(`/${endpoint}`, payload).then(({ data: data2 }) => data2).catch((err) => {
      var _a2;
      (_a2 = this.onError) == null ? void 0 : _a2.call(this, err);
      throw err;
    });
  }
  async uploadFile(file, options) {
    this._setAuthorization();
    const formData = new FormData();
    formData.append("file", file);
    let url = "/static_files/upload";
    if (options == null ? void 0 : options.topic)
      url = `/static_files/upload?topic=${options.topic}`;
    const { data: data2 } = await axios.post(url, formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      onUploadProgress: options == null ? void 0 : options.onUploadProgress
    });
    return data2;
  }
}
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "Lightbox",
  setup(__props, { expose: __expose }) {
    let isOpen = ref(false);
    let currentItem = ref();
    let group = ref([]);
    let currentIndex = ref(0);
    function open(item, groupItems) {
      isOpen.value = true;
      currentItem.value = item;
      if (groupItems === void 0) return;
      group.value = groupItems;
      currentIndex.value = groupItems.findIndex(({ src }) => item.src === src);
      document.addEventListener("keydown", handleKeydown);
    }
    function close() {
      isOpen.value = false;
      document.removeEventListener("keydown", handleKeydown);
    }
    function next() {
      if (group.value.length > 1) {
        currentIndex.value = (currentIndex.value + 1) % group.value.length;
        currentItem.value = group.value[currentIndex.value];
      }
    }
    function prev() {
      if (group.value.length > 1) {
        currentIndex.value = (currentIndex.value - 1 + group.value.length) % group.value.length;
        currentItem.value = group.value[currentIndex.value];
      }
    }
    function selectItem(index2) {
      currentIndex.value = index2;
      currentItem.value = group.value[index2];
    }
    watch(() => isOpen.value, (val) => {
      if (val) document.body.style.overflow = "hidden";
      else document.body.style.overflow = "";
    });
    function handleKeydown(event) {
      if (event.key === "Escape") {
        close();
      } else if (event.key === "ArrowLeft") {
        prev();
      } else if (event.key === "ArrowRight") {
        next();
      }
    }
    const zoom = ref(1);
    function clickOutside2() {
      if (zoom.value === 1) close();
    }
    const upgradeHeaders = (url) => url.replace(/http:\/\//, "//");
    __expose({ open, close });
    const __returned__ = { get isOpen() {
      return isOpen;
    }, set isOpen(v) {
      isOpen = v;
    }, get currentItem() {
      return currentItem;
    }, set currentItem(v) {
      currentItem = v;
    }, get group() {
      return group;
    }, set group(v) {
      group = v;
    }, get currentIndex() {
      return currentIndex;
    }, set currentIndex(v) {
      currentIndex = v;
    }, open, close, next, prev, selectItem, handleKeydown, zoom, clickOutside: clickOutside2, upgradeHeaders, get BglVideo() {
      return BglVideo;
    }, get Btn() {
      return Btn;
    }, get Icon() {
      return Icon;
    }, get Zoomer() {
      return Zoomer;
    }, get Image() {
      return Image$1;
    }, get normalizeURL() {
      return normalizeURL;
    } };
    Object.defineProperty(__returned__, "__isScriptSetup", { enumerable: false, value: true });
    return __returned__;
  }
});
const _hoisted_1 = {
  key: 0,
  class: "navigation flex space-between px-3 w-100 absolute m_px-1"
};
const _hoisted_2 = { class: "flex start fixed top-1 w-100 space-between px-1" };
const _hoisted_3 = {
  key: 0,
  class: "center"
};
const _hoisted_4 = { key: 3 };
const _hoisted_5 = { class: "bgl-lightbox-item" };
const _hoisted_6 = ["src", "title"];
const _hoisted_7 = {
  key: 3,
  class: "file-info txt-white flex m_block align-items-start gap-025"
};
const _hoisted_8 = { class: "txt-start" };
const _hoisted_9 = { class: "mx-0 light" };
const _hoisted_10 = { class: "semi word-break-all" };
const _hoisted_11 = { class: "mx-0" };
const _hoisted_12 = { class: "semi" };
const _hoisted_13 = {
  key: 0,
  class: "flex justify-content-center mt-2 overflow p-1 fixed bottom start end gap-1 m_justify-content-start"
};
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createBlock(Transition, { name: "fade" }, {
    default: withCtx(() => {
      var _a2, _b, _c, _d, _e2, _f, _g, _h, _i, _j, _k, _l2, _m, _n2, _o, _p, _q, _r2;
      return [
        $setup.isOpen ? (openBlock(), createElementBlock(
          "div",
          {
            key: 0,
            class: "bgl-lightbox-overlay fixed w-100 h-100 flex justify-content-center z-9999 inset mx-auto",
            onKeydown: [
              withKeys($setup.close, ["esc"]),
              withKeys($setup.prev, ["left"]),
              withKeys($setup.next, ["right"])
            ],
            onClick: $setup.clickOutside
          },
          [
            $setup.group && $setup.group.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_1, [
              createVNode($setup["Btn"], {
                class: "navigation-btn oval",
                icon: "arrow_back",
                onClick: $setup.prev
              }),
              createVNode($setup["Btn"], {
                class: "navigation-btn oval",
                icon: "arrow_forward",
                onClick: $setup.next
              })
            ])) : createCommentVNode("v-if", true),
            createElementVNode("div", {
              class: "bgl-lightbox relative txt-center",
              onClick: _cache[4] || (_cache[4] = withModifiers(() => {
              }, ["stop"]))
            }, [
              createElementVNode("div", _hoisted_2, [
                createVNode($setup["Btn"], {
                  flat: "",
                  class: "color-white",
                  icon: "close",
                  onClick: $setup.close
                }),
                ((_a2 = $setup.currentItem) == null ? void 0 : _a2.enableZoom) && ((_b = $setup.currentItem) == null ? void 0 : _b.type) === "image" ? (openBlock(), createElementBlock("div", _hoisted_3, [
                  createVNode($setup["Btn"], {
                    flat: "",
                    class: "color-white",
                    icon: "remove",
                    disabled: $setup.zoom === 1,
                    onClick: _cache[0] || (_cache[0] = ($event) => $setup.zoom--)
                  }, null, 8, ["disabled"]),
                  createVNode($setup["Btn"], {
                    flat: "",
                    class: "color-white",
                    icon: "zoom_in",
                    disabled: $setup.zoom === 1,
                    onClick: _cache[1] || (_cache[1] = ($event) => $setup.zoom = 1)
                  }, null, 8, ["disabled"]),
                  createVNode($setup["Btn"], {
                    flat: "",
                    class: "color-white",
                    icon: "add",
                    disabled: $setup.zoom === 3,
                    onClick: _cache[2] || (_cache[2] = ($event) => $setup.zoom++)
                  }, null, 8, ["disabled"])
                ])) : createCommentVNode("v-if", true),
                ((_c = $setup.currentItem) == null ? void 0 : _c.openFile) ? (openBlock(), createBlock($setup["Btn"], {
                  key: 1,
                  class: "color-white",
                  round: "",
                  thin: "",
                  flat: "",
                  iconEnd: "arrow_outward",
                  value: "Open File",
                  href: (_d = $setup.currentItem) == null ? void 0 : _d.src,
                  target: "_blank"
                }, null, 8, ["href"])) : createCommentVNode("v-if", true),
                ((_e2 = $setup.currentItem) == null ? void 0 : _e2.download) ? (openBlock(), createBlock($setup["Btn"], {
                  key: 2,
                  class: "color-white",
                  round: "",
                  thin: "",
                  flat: "",
                  icon: "download",
                  value: "Download File",
                  href: $setup.upgradeHeaders((_f = $setup.currentItem) == null ? void 0 : _f.src),
                  download: ""
                }, null, 8, ["href"])) : createCommentVNode("v-if", true),
                !((_g = $setup.currentItem) == null ? void 0 : _g.openFile) && !((_h = $setup.currentItem) == null ? void 0 : _h.download) ? (openBlock(), createElementBlock("div", _hoisted_4)) : createCommentVNode("v-if", true)
              ]),
              createElementVNode("div", _hoisted_5, [
                ((_i = $setup.currentItem) == null ? void 0 : _i.type) === "image" ? (openBlock(), createBlock($setup["Zoomer"], {
                  key: 0,
                  zoom: $setup.zoom,
                  "onUpdate:zoom": _cache[3] || (_cache[3] = ($event) => $setup.zoom = $event),
                  disabled: !((_j = $setup.currentItem) == null ? void 0 : _j.enableZoom),
                  "mouse-wheel-to-zoom": false
                }, {
                  default: withCtx(() => {
                    var _a3;
                    return [
                      createVNode($setup["Image"], {
                        draggable: false,
                        src: (_a3 = $setup.currentItem) == null ? void 0 : _a3.src,
                        alt: "Preview",
                        class: "vw90 lightbox-image"
                      }, null, 8, ["src"])
                    ];
                  }),
                  _: 1
                  /* STABLE */
                }, 8, ["zoom", "disabled"])) : ((_k = $setup.currentItem) == null ? void 0 : _k.type) === "video" ? (openBlock(), createBlock($setup["BglVideo"], {
                  key: 1,
                  src: (_l2 = $setup.currentItem) == null ? void 0 : _l2.src,
                  autoplay: "",
                  controls: "",
                  class: "vw90"
                }, null, 8, ["src"])) : ((_m = $setup.currentItem) == null ? void 0 : _m.type) === "pdf" ? (openBlock(), createElementBlock("embed", {
                  key: 2,
                  src: $setup.normalizeURL((_n2 = $setup.currentItem) == null ? void 0 : _n2.src),
                  type: "application/pdf",
                  width: "100%",
                  height: "1080",
                  title: (_o = $setup.currentItem) == null ? void 0 : _o.name,
                  class: "vw90"
                }, null, 8, _hoisted_6)) : (openBlock(), createElementBlock("div", _hoisted_7, [
                  createVNode($setup["Icon"], {
                    class: "m-0 m_none",
                    icon: "draft",
                    size: 10,
                    weight: "12"
                  }),
                  createVNode($setup["Icon"], {
                    class: "m-0 none m_block m_-mb-1",
                    icon: "draft",
                    size: 4,
                    weight: "2"
                  }),
                  createElementVNode("div", _hoisted_8, [
                    createElementVNode("p", _hoisted_9, [
                      _cache[5] || (_cache[5] = createTextVNode(" File: ")),
                      createElementVNode(
                        "span",
                        _hoisted_10,
                        toDisplayString((_p = $setup.currentItem) == null ? void 0 : _p.name),
                        1
                        /* TEXT */
                      )
                    ]),
                    createElementVNode("p", _hoisted_11, [
                      _cache[6] || (_cache[6] = createTextVNode(" Type: ")),
                      createElementVNode(
                        "span",
                        _hoisted_12,
                        toDisplayString((_q = $setup.currentItem) == null ? void 0 : _q.type),
                        1
                        /* TEXT */
                      )
                    ]),
                    createVNode($setup["Btn"], {
                      href: (_r2 = $setup.currentItem) == null ? void 0 : _r2.src,
                      target: "_blank",
                      round: "",
                      thin: "",
                      class: "mt-1",
                      value: "Open file"
                    }, null, 8, ["href"]),
                    createCommentVNode(' <a :href="currentItem?.src" target="_blank">Open file</a> ')
                  ])
                ]))
              ]),
              $setup.group && $setup.group.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_13, [
                (openBlock(true), createElementBlock(
                  Fragment,
                  null,
                  renderList($setup.group, (item, index2) => {
                    return openBlock(), createElementBlock(
                      Fragment,
                      { key: index2 },
                      [
                        item.type === "image" ? (openBlock(), createBlock($setup["Image"], {
                          key: 0,
                          class: normalizeClass(["thumbnail object-fit-cover hover opacity-5 rounded flex bg-popup justify-content-center align-items-center flex-shrink-0", { active: $setup.currentIndex === index2 }]),
                          src: item.src,
                          alt: "",
                          onClick: ($event) => $setup.selectItem(index2)
                        }, null, 8, ["src", "class", "onClick"])) : (openBlock(), createBlock($setup["Icon"], {
                          key: 1,
                          class: normalizeClass(["thumbnail object-fit-cover hover opacity-5 ed flex bg-popup justify-content-center align-items-center flex-shrink-0", { active: $setup.currentIndex === index2 }]),
                          icon: "description",
                          onClick: ($event) => $setup.selectItem(index2)
                        }, null, 8, ["class", "onClick"]))
                      ],
                      64
                      /* STABLE_FRAGMENT */
                    );
                  }),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ])) : createCommentVNode("v-if", true)
            ])
          ],
          32
          /* NEED_HYDRATION */
        )) : createCommentVNode("v-if", true)
      ];
    }),
    _: 1
    /* STABLE */
  });
}
const Lightbox$1 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-5023f163"], ["__file", "/Users/natanelyoung/Projects/bagelink/packages/vue/src/components/lightbox/Lightbox.vue"]]);
const groups = {};
let clickHandler = (_e2) => void 0;
const lightboxDirective = {
  mounted(el, binding) {
    const item = bindingToItem(binding, el);
    groupHandler(item);
    clickHandler = (e) => {
      openClickHandler(e, el, binding);
    };
    el.addEventListener("click", clickHandler);
  },
  updated(el, binding) {
    const item = bindingToItem(binding, el);
    groupHandler(item);
    el.removeEventListener("click", clickHandler);
    clickHandler = (e) => {
      openClickHandler(e, el, binding);
    };
    el.addEventListener("click", clickHandler);
  },
  unmounted(el) {
    el.removeEventListener("click", clickHandler);
  }
};
function groupHandler(item) {
  if (item.group) {
    if (!groups[item.group]) groups[item.group] = [];
    const currentIndex = groups[item.group].findIndex((i) => i.src === item.src);
    if (currentIndex === -1) groups[item.group].push(item);
  }
}
function openClickHandler(e, el, binding) {
  e.stopPropagation();
  const item = bindingToItem(binding, el);
  const lightboxInstance2 = getLightboxInstance();
  if (!lightboxInstance2 || !lightboxInstance2.open) return;
  const open = lightboxInstance2.open;
  const group = item.group ? groups[item.group] : void 0;
  open(item, group);
}
function bindingToItem(binding, el) {
  let { group, src, type: type3, name, thumbnail, enableZoom, openFile, download } = binding.value || {};
  src = src || binding.value || el.getAttribute("src") || "";
  type3 = type3 || determineFileType(src);
  name = name || urlToName(src) || el.getAttribute("alt") || "";
  return { src, type: type3, name, thumbnail, group, enableZoom, openFile, download };
}
const youtubeRegex = /youtube\.com|youtu\.be/;
const vimeoRegex = /vimeo\.com/;
function urlToName(url) {
  if (!url) return "";
  const name = url.split("/").pop() || "";
  return name.replace(/\.[^/.]+$/, "");
}
function determineFileType(url) {
  if (!url) return "unknown";
  const extension = (url.split(".").pop() || "").toLowerCase();
  if (IMAGE_FORMATS_REGEXP.test(extension)) return "image";
  if (VIDEO_FORMATS_REGEXP.test(extension) || youtubeRegex.test(url) || vimeoRegex.test(url)) return "video";
  if (["pdf"].includes(extension)) return "pdf";
  return extension ?? "unknown";
}
let lightboxInstance;
function getLightboxInstance() {
  if (!lightboxInstance) {
    const lightboxEl = document.createElement("div");
    document.body.prepend(lightboxEl);
    const app = createApp(Lightbox$1);
    lightboxInstance = app.mount(lightboxEl);
  }
  return lightboxInstance;
}
const Lightbox = {
  install(app) {
    app.directive("lightbox", lightboxDirective);
  }
};
const DEFAULT_PATTERNS = {
  pint: { pattern: /\d/ },
  int: { pattern: /[\d\-]/ },
  pnum: { pattern: /[\d.]/ },
  money: { pattern: /[\d.\s,]/ },
  number: { pattern: /[\d\-.]/ },
  num: { pattern: /[\d\-.]/ },
  hex: { pattern: /[0-9a-f]/i },
  email: { pattern: /[\w.\-@]/ },
  alpha: { pattern: /[a-z_]/i },
  alphanum: { pattern: /\w/ },
  lower: { pattern: /[a-z]/, transform: (v) => v.toLowerCase() },
  upper: { pattern: /[A-Z]/, transform: (v) => v.toUpperCase() },
  slug: { pattern: /[a-z0-9-]/i, transform: (v) => v.toLowerCase().replace(/\s/g, "-") }
};
const stateMap = /* @__PURE__ */ new WeakMap();
function getTarget(el) {
  if (el instanceof HTMLInputElement || el instanceof HTMLTextAreaElement) {
    return el;
  }
  const target = el.querySelector("input, textarea");
  return target instanceof HTMLInputElement || target instanceof HTMLTextAreaElement ? target : null;
}
function getModifiers(binding) {
  const modifiers = Object.keys(binding.modifiers || {});
  return modifiers.length ? modifiers[modifiers.length - 1] : "";
}
function getRegex(state2) {
  if (state2.pattern) return state2.pattern;
  if (state2.modifier) return DEFAULT_PATTERNS[state2.modifier].pattern || /./;
  return /./;
}
function bindEvents(el, target, state2) {
  state2.keydownEvent = (event) => {
    onKeydown(event, target, state2);
  };
  state2.pasteEvent = (event) => {
    onPaste(event, target, state2);
  };
  target.addEventListener("keydown", state2.keydownEvent);
  target.addEventListener("paste", state2.pasteEvent);
}
function unbindEvents(target, state2) {
  if (state2.keydownEvent) target.removeEventListener("keydown", state2.keydownEvent);
  if (state2.pasteEvent) target.removeEventListener("paste", state2.pasteEvent);
  state2.keydownEvent = void 0;
  state2.pasteEvent = void 0;
}
function onKeydown(event, target, state2) {
  if (event.ctrlKey || event.altKey || event.metaKey || event.key === "Tab" || event.key === "Backspace" || event.key === "Delete" || event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "ArrowUp" || event.key === "ArrowDown" || event.key === "Enter") return;
  const regex2 = getRegex(state2);
  const testKey = event.key;
  if (!regex2.test(testKey)) {
    event.preventDefault();
  } else if (state2.modifier) {
    const { transform } = DEFAULT_PATTERNS[state2.modifier];
    if (transform) {
      event.preventDefault();
      const transformedValue = transform(testKey);
      const cursorPos = target.selectionStart ?? 0;
      const newValue = target.value.slice(0, cursorPos) + transformedValue + target.value.slice(cursorPos);
      target.value = newValue;
      target.setSelectionRange(cursorPos + transformedValue.length, cursorPos + transformedValue.length);
    }
  }
}
function onPaste(event, target, state2) {
  var _a2;
  const regex2 = getRegex(state2);
  const clipboardData = ((_a2 = event.clipboardData) == null ? void 0 : _a2.getData("text")) || "";
  if (!regex2.test(clipboardData)) {
    event.preventDefault();
  } else if (state2.modifier) {
    const { transform } = DEFAULT_PATTERNS[state2.modifier];
    if (transform) {
      event.preventDefault();
      const transformedValue = transform(clipboardData);
      const cursorPos = target.selectionStart ?? 0;
      const newValue = target.value.slice(0, cursorPos) + transformedValue + target.value.slice(cursorPos);
      target.value = newValue;
      target.setSelectionRange(cursorPos + transformedValue.length, cursorPos + transformedValue.length);
    }
  }
}
const pattern = {
  beforeMount(el, binding) {
    const target = getTarget(el);
    if (!target) return;
    const state2 = {
      modifier: getModifiers(binding)
    };
    if (typeof binding.value === "object") {
      state2.pattern = binding.value.pattern || /./;
      state2.validateOnly = binding.value.validateOnly || false;
    }
    stateMap.set(el, state2);
    bindEvents(el, target, state2);
  },
  updated(el, binding) {
    const target = getTarget(el);
    if (!target) return;
    const state2 = stateMap.get(el);
    if (!state2) return;
    unbindEvents(target, state2);
    state2.modifier = getModifiers(binding);
    if (typeof binding.value === "object") {
      state2.pattern = binding.value.pattern || /./;
      state2.validateOnly = binding.value.validateOnly || false;
    }
    bindEvents(el, target, state2);
  },
  unmounted(el) {
    const target = getTarget(el);
    const state2 = stateMap.get(el);
    if (target && state2) {
      unbindEvents(target, state2);
    }
    stateMap.delete(el);
  }
};
const ripple = {
  mounted(el, binding) {
    const clickHandler2 = (e) => {
      const rect = el.getBoundingClientRect();
      const size2 = Math.max(rect.width, rect.height);
      const ripple2 = document.createElement("span");
      ripple2.className = "ripple";
      Object.assign(ripple2.style, {
        width: `${size2}px`,
        height: `${size2}px`,
        left: `${e.clientX - rect.left - size2 / 2}px`,
        top: `${e.clientY - rect.top - size2 / 2}px`,
        position: "absolute",
        borderRadius: "50%",
        transform: "scale(0)",
        background: "rgba(0, 0, 0, 0.3)",
        pointerEvents: "none",
        animation: "rippleEffect 0.6s ease-out"
      });
      el.appendChild(ripple2);
      setTimeout(() => {
        ripple2.remove();
      }, 600);
    };
    el.__rippleClickHandler = clickHandler2;
    if (binding.value !== false) {
      if (getComputedStyle(el).position === "static") {
        el.style.position = "relative";
      }
      el.style.overflow = "hidden";
      el.addEventListener("mousedown", clickHandler2);
    }
  },
  updated(el, binding) {
    const clickHandler2 = el.__rippleClickHandler;
    if (binding.value === false) {
      el.removeEventListener("mousedown", clickHandler2);
    } else {
      if (getComputedStyle(el).position === "static") {
        el.style.position = "relative";
      }
      el.style.overflow = "hidden";
      el.addEventListener("mousedown", clickHandler2);
    }
  },
  unmounted(el) {
    const clickHandler2 = el.__rippleClickHandler;
    if (clickHandler2) {
      el.removeEventListener("mousedown", clickHandler2);
      delete el.__rippleClickHandler;
    }
  }
};
function getBaseField(id, labelOrRest = {}, rest = {}) {
  if (typeof labelOrRest === "object") return { id, ...labelOrRest };
  return { id, label: labelOrRest, ...rest };
}
function richText(id, label, options) {
  return {
    $el: "richtext",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    id,
    label,
    placeholder: options == null ? void 0 : options.placeholder,
    attrs: {}
  };
}
function txtField(id, label, options) {
  return {
    $el: "text",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    id,
    label,
    disabled: options == null ? void 0 : options.disabled,
    placeholder: options == null ? void 0 : options.placeholder,
    defaultValue: options == null ? void 0 : options.defaultValue,
    attrs: {
      type: options == null ? void 0 : options.type,
      pattern: options == null ? void 0 : options.pattern,
      multiline: options == null ? void 0 : options.multiline
    }
  };
}
function slctField(id, label, options, config) {
  return {
    $el: "select",
    id,
    options,
    class: config == null ? void 0 : config.class,
    placeholder: config == null ? void 0 : config.placeholder,
    required: config == null ? void 0 : config.required,
    label,
    defaultValue: config == null ? void 0 : config.defaultValue,
    attrs: {
      disabled: config == null ? void 0 : config.disabled,
      searchable: config == null ? void 0 : config.searchable,
      multiselect: config == null ? void 0 : config.multiselect,
      onSearch: config == null ? void 0 : config.onSearch,
      clearable: config == null ? void 0 : config.clearable
    }
  };
}
function checkField(id, label, options) {
  return {
    $el: "check",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    id,
    label
  };
}
function dateField(id, label, options) {
  return {
    $el: "date",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    id,
    disabled: options == null ? void 0 : options.disabled,
    label,
    defaultValue: options == null ? void 0 : options.defaultValue,
    attrs: {
      disabled: options == null ? void 0 : options.disabled
    }
  };
}
function numField(id, label, options) {
  return {
    $el: "number",
    class: options == null ? void 0 : options.class,
    required: options == null ? void 0 : options.required,
    defaultValue: options == null ? void 0 : options.defaultValue,
    id,
    label,
    disabled: options == null ? void 0 : options.disabled,
    placeholder: options == null ? void 0 : options.placeholder,
    helptext: options == null ? void 0 : options.helptext,
    attrs: {
      step: options == null ? void 0 : options.step,
      min: options == null ? void 0 : options.min,
      max: options == null ? void 0 : options.max
    }
  };
}
function frmRow(...children2) {
  return {
    $el: "div",
    class: "flex gap-1 m_block align-items-end",
    children: children2
  };
}
function uploadField(id, label, options) {
  return {
    $el: "upload",
    id,
    label,
    attrs: options
  };
}
function bglForm(idOrField, ...schema) {
  if (typeof idOrField === "string") {
    return {
      $el: markRaw(BagelForm),
      id: idOrField,
      attrs: {
        schema: [idOrField, ...schema]
      }
    };
  }
  return {
    $el: markRaw(BagelForm),
    attrs: {
      schema: [idOrField, ...schema]
    }
  };
}
function telField(id, label, options) {
  return {
    $el: markRaw(TelInput),
    id,
    label,
    attrs: options
  };
}
function findBglFieldById(id, _schema) {
  for (const field of _schema) {
    if (field.id === id) return field;
    if (field.children && Number(field.children.length) > 0) {
      const child = findBglFieldById(id, field.children);
      if (child) return child;
    }
  }
  return void 0;
}
function arrField(id, label, schema, options) {
  return {
    label,
    id,
    $el: "array",
    attrs: { schema, delete: true, add: true, ...options }
  };
}
const state = reactive({
  defaultLang: "",
  availableLangs: [],
  lang: "en"
});
function $tdb(langEl) {
  if (!langEl) {
    console.warn("No language element provided for $tdb function");
    return "";
  }
  return langEl[state.lang] || langEl[state.defaultLang] || "";
}
function useLang() {
  const lang = computed({
    get: () => state.lang,
    set: (val) => state.lang = val
  });
  const availableLangs = computed({
    get: () => state.availableLangs,
    set: (val) => state.availableLangs = val
  });
  const defaultLang = computed({
    get: () => state.defaultLang,
    set: (val) => state.defaultLang = val
  });
  return {
    lang,
    $tdb,
    availableLangs,
    defaultLang
  };
}
function formatString(str, format2) {
  if (format2 === "titleCase") {
    return str.split("_").map((word) => word[0].toUpperCase() + word.slice(1).toLocaleLowerCase()).join(" ");
  }
  if (format2 === "pascal") {
    return str.split("_").map((word) => word[0].toUpperCase() + word.slice(1).toLocaleLowerCase()).join("");
  }
  if (format2 === "camel") {
    return str.split("_").map((word, index2) => index2 === 0 ? word : word[0].toUpperCase() + word.slice(1)).join("");
  }
  if (format2 === "snake") {
    return [...str].map((letter) => {
      if (letter === letter.toUpperCase()) {
        return `_${letter.toLowerCase()}`;
      }
      return letter;
    }).join("");
  }
  return str;
}
function debounce(callback, wait, immediate) {
  let timeout;
  return function(...args) {
    const later = () => {
      timeout = void 0;
      if (!immediate) callback.apply(this, args);
    };
    const callNow = immediate && timeout === void 0;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) callback.apply(this, args);
  };
}
function keyToLabel(key) {
  if (key === void 0) return key;
  return key.split("_").map((k2) => k2.charAt(0).toUpperCase() + k2.slice(1)).join(" ") || key;
}
async function copyText(text, cb) {
  await navigator.clipboard.writeText(text);
  if (cb) cb("Copied to clipboard");
}
function initials(...strArr) {
  strArr = strArr.flatMap((str) => str.split(/\s/));
  return strArr.map((str) => str.charAt(0)).join("");
}
function useEscape(event, closeModel) {
  if (event.key === "Escape") {
    closeModel();
  }
}
function classify(fieldVal, row, ...classes) {
  return classes.map((cls) => {
    if (typeof cls === "function") return cls(fieldVal, row);
    return cls;
  }).join(" ");
}
function bindAttrs(attrs, fieldVal, row) {
  if (!attrs) return {};
  const exclude = ["class"];
  const arr = Object.entries(attrs).filter(([key]) => !exclude.includes(key)).map(([key, value]) => [
    key,
    typeof value === "function" ? value(fieldVal, row) : value
  ]);
  const resolvedAttrs = Object.fromEntries(arr);
  return resolvedAttrs;
}
function iffer(field, itemData) {
  var _a2;
  if (field["v-if"] === void 0) return true;
  if (typeof field["v-if"] === "boolean") return field["v-if"];
  if (typeof field["v-if"] === "string") return true;
  if (typeof field["v-if"] === "function")
    return (_a2 = field["v-if"]) == null ? void 0 : _a2.call(field, itemData == null ? void 0 : itemData[field.id], itemData);
  return true;
}
function denullify(itemData, fieldID) {
  if (!fieldID) return;
  return itemData ? itemData[fieldID] : void 0;
}
const isDate = (dateToTest) => !Number.isNaN(Date.parse(dateToTest));
function getFallbackSchema(data2, showFields) {
  const keys4 = Array.from(new Set((data2 ?? []).flatMap(Object.keys)));
  const schema = keys4.map((id) => ({
    id,
    label: keyToLabel(id)
  }));
  return showFields ? schema.filter((f) => showFields.includes(f.id) || !f.id) : schema;
}
function sleep(ms = 100) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}
function appendScript(src, options) {
  return new Promise((resolve, reject3) => {
    if (options == null ? void 0 : options.id) {
      if (document.getElementById(options.id)) {
        resolve();
        return;
      }
    } else if (document.querySelector(`script[src="${src}"]`)) {
      resolve();
      return;
    }
    const script2 = document.createElement("script");
    script2.src = src;
    if (options == null ? void 0 : options.id) {
      script2.id = options.id;
    }
    script2.onload = () => {
      resolve();
    };
    script2.onerror = reject3;
    document.head.append(script2);
  });
}
function appendStyle(src) {
  return new Promise((resolve, reject3) => {
    if (document.querySelector(`link[href="${src}"]`)) {
      resolve();
      return;
    }
    const link = document.createElement("link");
    link.href = src;
    link.rel = "stylesheet";
    link.onload = () => {
      resolve();
    };
    link.onerror = reject3;
    document.head.append(link);
  });
}
function normalizeURL(url) {
  if (url.startsWith("https://")) return url;
  url = url.replace(/http:\/\//, "");
  return `https://${url}`;
}
function normalizeDimension(value, defaultMetric = "px") {
  if (typeof value === "number") return `${value}${defaultMetric}`;
  return value;
}
const clickOutside = {
  beforeMount(el, binding) {
    el.clickOutsideEvent = (event) => {
      if (!(el === event.target || el.contains(event.target))) {
        binding.value(event);
      }
    };
    document.addEventListener("click", el.clickOutsideEvent);
  },
  unmounted(el) {
    document.removeEventListener("click", el.clickOutsideEvent);
  }
};
const bagelInjectionKey = Symbol("bagel");
const i18nTInjectionKey = Symbol("bagel");
function useBagel() {
  const bagel = inject(bagelInjectionKey);
  if (!bagel) throw new Error("No bagel provided");
  return bagel;
}
function useI18nT() {
  const i18nT = inject(i18nTInjectionKey);
  if (!i18nT) throw new Error("No i18nT provided");
  return i18nT;
}
const BagelVue = {
  install: (app, options) => {
    const bagel = new Bagel({ host: options.host, fileBaseUrl: options.fileBaseUrl, onError: options.onError });
    app.directive("click-outside", clickOutside);
    app.directive("ripple", ripple);
    app.directive("pattern", pattern);
    app.use(Lightbox);
    app.use(Gt$1, {
      themes: {
        "bgl-theme": {
          triggers: ["click"],
          autoHide: true,
          placement: "bottom"
        }
      }
    });
    const { availableLangs, defaultLang, lang } = useLang();
    if (options.availableLangs) availableLangs.value = options.availableLangs;
    if (options.defaultLang) defaultLang.value = options.defaultLang;
    if (options.language) lang.value = options.language;
    app.config.globalProperties.$bagel = bagel;
    app.provide(bagelInjectionKey, bagel);
    app.config.globalProperties.$i18T = options.i18nT || ((key) => key);
    app.provide(i18nTInjectionKey, options.i18nT || ((key) => key));
  }
};
const ModalSymbol = Symbol("modal");
function useModal() {
  const modalApi = inject(ModalSymbol);
  if (!modalApi) throw new Error("Modal API not provided");
  return modalApi;
}
const ModalPlugin = {
  install: (app) => {
    const modalStack = ref([]);
    const hideModal = (index2) => {
      modalStack.value.splice(index2, 1);
    };
    const confirmModal = (options) => {
      return new Promise((resolve) => {
        const confirmOptions = typeof options === "string" ? { title: "", message: options } : options;
        modalStack.value.push({
          modalOptions: { ...confirmOptions, resolve },
          modalType: "confirmModal",
          componentSlots: {}
        });
      });
    };
    const showModal = (modalType, options, slots = {}) => {
      const modalComponent = {
        modalOptions: options,
        modalType,
        componentSlots: slots
      };
      modalStack.value.push(modalComponent);
      if (modalType === "modalForm") {
        return modalComponent;
      }
      return modalComponent;
    };
    app.provide(ModalSymbol, {
      showModal: (options, slots) => showModal("modal", options, slots),
      showModalForm: (options, slots) => showModal("modalForm", options, slots),
      confirmModal: (options) => confirmModal(options),
      hideModal: (index2 = modalStack.value.length - 1) => {
        hideModal(index2);
      }
    });
    const ModalComponent = defineComponent({
      data: () => ({ modalStack: modalStack.value }),
      render() {
        return this.modalStack.map((modal, index2) => {
          const props2 = {
            ...modal.modalOptions,
            "visible": true,
            "onUpdate:visible": () => {
              hideModal(index2);
            }
          };
          switch (modal.modalType) {
            case "modalForm":
              return h$1(ModalForm, props2, modal.componentSlots);
            case "confirmModal":
              return h$1(ModalConfirm, props2, {});
            default:
              return h$1(Modal, props2, modal.componentSlots);
          }
        });
      }
    });
    app.component("ModalContainer", ModalComponent);
  }
};
const countryArray = [
  ["Afghanistan (افغانستان)", "AF", "93"],
  ["Albania (Shqipëri)", "AL", "355"],
  ["Algeria (الجزائر)", "DZ", "213"],
  ["American Samoa", "AS", "1", 5, ["684"]],
  ["Andorra", "AD", "376"],
  ["Angola", "AO", "244"],
  ["Anguilla", "AI", "1", 6, ["264"]],
  ["Antigua and Barbuda", "AG", "1", 7, ["268"]],
  ["Argentina", "AR", "54"],
  ["Armenia (Հայաստան)", "AM", "374"],
  ["Aruba", "AW", "297"],
  ["Ascension Island", "AC", "247"],
  ["Australia", "AU", "61", 0],
  ["Austria (Österreich)", "AT", "43"],
  ["Azerbaijan (Azərbaycan)", "AZ", "994"],
  ["Bahamas", "BS", "1", 8, ["242"]],
  ["Bahrain (البحرين)", "BH", "973"],
  ["Bangladesh (বাংলাদেশ)", "BD", "880"],
  ["Barbados", "BB", "1", 9, ["246"]],
  ["Belarus (Беларусь)", "BY", "375"],
  ["Belgium (België)", "BE", "32"],
  ["Belize", "BZ", "501"],
  ["Benin (Bénin)", "BJ", "229"],
  ["Bermuda", "BM", "1", 10, ["441"]],
  ["Bhutan (འབྲུག)", "BT", "975"],
  ["Bolivia", "BO", "591"],
  ["Bosnia and Herzegovina (Босна и Херцеговина)", "BA", "387"],
  ["Botswana", "BW", "267"],
  ["Brazil (Brasil)", "BR", "55"],
  ["British Indian Ocean Territory", "IO", "246"],
  ["British Virgin Islands", "VG", "1", 11, ["284"]],
  ["Brunei", "BN", "673"],
  ["Bulgaria (България)", "BG", "359"],
  ["Burkina Faso", "BF", "226"],
  ["Burundi (Uburundi)", "BI", "257"],
  ["Cambodia (កម្ពុជា)", "KH", "855"],
  ["Cameroon (Cameroun)", "CM", "237"],
  [
    "Canada",
    "CA",
    "1",
    1,
    [
      "204",
      "226",
      "236",
      "249",
      "250",
      "263",
      "289",
      "306",
      "343",
      "354",
      "365",
      "367",
      "368",
      "382",
      "387",
      "403",
      "416",
      "418",
      "428",
      "431",
      "437",
      "438",
      "450",
      "584",
      "468",
      "474",
      "506",
      "514",
      "519",
      "548",
      "579",
      "581",
      "584",
      "587",
      "604",
      "613",
      "639",
      "647",
      "672",
      "683",
      "705",
      "709",
      "742",
      "753",
      "778",
      "780",
      "782",
      "807",
      "819",
      "825",
      "867",
      "873",
      "902",
      "905"
    ]
  ],
  ["Cape Verde (Kabu Verdi)", "CV", "238"],
  ["Caribbean Netherlands", "BQ", "599", 1, ["3", "4", "7"]],
  ["Cayman Islands", "KY", "1", 12, ["345"]],
  ["Central African Republic (République centrafricaine)", "CF", "236"],
  ["Chad (Tchad)", "TD", "235"],
  ["Chile", "CL", "56"],
  ["China (中国)", "CN", "86"],
  ["Christmas Island", "CX", "61", 2, ["89164"]],
  ["Cocos (Keeling) Islands", "CC", "61", 1, ["89162"]],
  ["Colombia", "CO", "57"],
  ["Comoros (جزر القمر)", "KM", "269"],
  ["Congo (DRC) (République démocratique du Congo)", "CD", "243"],
  ["Congo (Republic) (Congo-Brazzaville)", "CG", "242"],
  ["Cook Islands", "CK", "682"],
  ["Costa Rica", "CR", "506"],
  ["Côte d’Ivoire", "CI", "225"],
  ["Croatia (Hrvatska)", "HR", "385"],
  ["Cuba", "CU", "53"],
  ["Curaçao", "CW", "599", 0],
  ["Cyprus (Κύπρος)", "CY", "357"],
  ["Czech Republic (Česká republika)", "CZ", "420"],
  ["Denmark (Danmark)", "DK", "45"],
  ["Djibouti", "DJ", "253"],
  ["Dominica", "DM", "1", 13, ["767"]],
  [
    "Dominican Republic (República Dominicana)",
    "DO",
    "1",
    2,
    ["809", "829", "849"]
  ],
  ["Ecuador", "EC", "593"],
  ["Egypt (مصر)", "EG", "20"],
  ["El Salvador", "SV", "503"],
  ["Equatorial Guinea (Guinea Ecuatorial)", "GQ", "240"],
  ["Eritrea", "ER", "291"],
  ["Estonia (Eesti)", "EE", "372"],
  ["Eswatini", "SZ", "268"],
  ["Ethiopia", "ET", "251"],
  ["Falkland Islands (Islas Malvinas)", "FK", "500"],
  ["Faroe Islands (Føroyar)", "FO", "298"],
  ["Fiji", "FJ", "679"],
  ["Finland (Suomi)", "FI", "358", 0],
  ["France", "FR", "33"],
  ["French Guiana (Guyane française)", "GF", "594"],
  ["French Polynesia (Polynésie française)", "PF", "689"],
  ["Gabon", "GA", "241"],
  ["Gambia", "GM", "220"],
  ["Georgia (საქართველო)", "GE", "995"],
  ["Germany (Deutschland)", "DE", "49"],
  ["Ghana (Gaana)", "GH", "233"],
  ["Gibraltar", "GI", "350"],
  ["Greece (Ελλάδα)", "GR", "30"],
  ["Greenland (Kalaallit Nunaat)", "GL", "299"],
  ["Grenada", "GD", "1", 14, ["473"]],
  ["Guadeloupe", "GP", "590", 0],
  ["Guam", "GU", "1", 15, ["671"]],
  ["Guatemala", "GT", "502"],
  ["Guernsey", "GG", "44", 1, ["1481", "7781", "7839", "7911"]],
  ["Guinea (Guinée)", "GN", "224"],
  ["Guinea-Bissau (Guiné Bissau)", "GW", "245"],
  ["Guyana", "GY", "592"],
  ["Haiti", "HT", "509"],
  ["Honduras", "HN", "504"],
  ["Hong Kong (香港)", "HK", "852"],
  ["Hungary (Magyarország)", "HU", "36"],
  ["Iceland (Ísland)", "IS", "354"],
  ["India (भारत)", "IN", "91"],
  ["Indonesia", "ID", "62"],
  ["Iran (ایران)", "IR", "98"],
  ["Iraq (العراق)", "IQ", "964"],
  ["Ireland", "IE", "353"],
  ["Isle of Man", "IM", "44", 2, ["1624", "74576", "7524", "7924", "7624"]],
  ["Israel (ישראל)", "IL", "972"],
  ["Italy (Italia)", "IT", "39", 0],
  ["Jamaica", "JM", "1", 4, ["876", "658"]],
  ["Japan (日本)", "JP", "81"],
  ["Jersey", "JE", "44", 3, ["1534", "7509", "7700", "7797", "7829", "7937"]],
  ["Jordan (الأردن)", "JO", "962"],
  ["Kazakhstan (Казахстан)", "KZ", "7", 1, ["33", "7"]],
  ["Kenya", "KE", "254"],
  ["Kiribati", "KI", "686"],
  ["Kosovo", "XK", "383"],
  ["Kuwait (الكويت)", "KW", "965"],
  ["Kyrgyzstan (Кыргызстан)", "KG", "996"],
  ["Laos (ລາວ)", "LA", "856"],
  ["Latvia (Latvija)", "LV", "371"],
  ["Lebanon (لبنان)", "LB", "961"],
  ["Lesotho", "LS", "266"],
  ["Liberia", "LR", "231"],
  ["Libya (ليبيا)", "LY", "218"],
  ["Liechtenstein", "LI", "423"],
  ["Lithuania (Lietuva)", "LT", "370"],
  ["Luxembourg", "LU", "352"],
  ["Macau (澳門)", "MO", "853"],
  ["Madagascar (Madagasikara)", "MG", "261"],
  ["Malawi", "MW", "265"],
  ["Malaysia", "MY", "60"],
  ["Maldives", "MV", "960"],
  ["Mali", "ML", "223"],
  ["Malta", "MT", "356"],
  ["Marshall Islands", "MH", "692"],
  ["Martinique", "MQ", "596"],
  ["Mauritania (موريتانيا)", "MR", "222"],
  ["Mauritius (Moris)", "MU", "230"],
  ["Mayotte", "YT", "262", 1, ["269", "639"]],
  ["Mexico (México)", "MX", "52"],
  ["Micronesia", "FM", "691"],
  ["Moldova (Republica Moldova)", "MD", "373"],
  ["Monaco", "MC", "377"],
  ["Mongolia (Монгол)", "MN", "976"],
  ["Montenegro (Crna Gora)", "ME", "382"],
  ["Montserrat", "MS", "1", 16, ["664"]],
  ["Morocco (المغرب)", "MA", "212", 0],
  ["Mozambique (Moçambique)", "MZ", "258"],
  ["Myanmar (Burma) (မြန်မာ)", "MM", "95"],
  ["Namibia (Namibië)", "NA", "264"],
  ["Nauru", "NR", "674"],
  ["Nepal (नेपाल)", "NP", "977"],
  ["Netherlands (Nederland)", "NL", "31"],
  ["New Caledonia (Nouvelle-Calédonie)", "NC", "687"],
  ["New Zealand", "NZ", "64"],
  ["Nicaragua", "NI", "505"],
  ["Niger (Nijar)", "NE", "227"],
  ["Nigeria", "NG", "234"],
  ["Niue", "NU", "683"],
  ["Norfolk Island", "NF", "672"],
  ["North Korea (조선 민주주의 인민 공화국)", "KP", "850"],
  ["North Macedonia (Северна Македонија)", "MK", "389"],
  ["Northern Mariana Islands", "MP", "1", 17, ["670"]],
  ["Norway (Norge)", "NO", "47", 0],
  ["Oman (عُمان)", "OM", "968"],
  ["Pakistan (پاکستان)", "PK", "92"],
  ["Palau", "PW", "680"],
  ["Palestine (فلسطين)", "PS", "970"],
  ["Panama (Panamá)", "PA", "507"],
  ["Papua New Guinea", "PG", "675"],
  ["Paraguay", "PY", "595"],
  ["Peru (Perú)", "PE", "51"],
  ["Philippines", "PH", "63"],
  ["Poland (Polska)", "PL", "48"],
  ["Portugal", "PT", "351"],
  ["Puerto Rico", "PR", "1", 3, ["787", "939"]],
  ["Qatar (قطر)", "QA", "974"],
  ["Réunion (La Réunion)", "RE", "262", 0],
  ["Romania (România)", "RO", "40"],
  ["Russia (Россия)", "RU", "7", 0],
  ["Rwanda", "RW", "250"],
  ["Saint Barthélemy", "BL", "590", 1],
  ["Saint Helena", "SH", "290"],
  ["Saint Kitts and Nevis", "KN", "1", 18, ["869"]],
  ["Saint Lucia", "LC", "1", 19, ["758"]],
  ["Saint Martin (Saint-Martin (partie française))", "MF", "590", 2],
  ["Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)", "PM", "508"],
  ["Saint Vincent and the Grenadines", "VC", "1", 20, ["784"]],
  ["Samoa", "WS", "685"],
  ["San Marino", "SM", "378"],
  ["São Tomé and Príncipe (São Tomé e Príncipe)", "ST", "239"],
  ["Saudi Arabia (المملكة العربية السعودية)", "SA", "966"],
  ["Senegal (Sénégal)", "SN", "221"],
  ["Serbia (Србија)", "RS", "381"],
  ["Seychelles", "SC", "248"],
  ["Sierra Leone", "SL", "232"],
  ["Singapore", "SG", "65"],
  ["Sint Maarten", "SX", "1", 21, ["721"]],
  ["Slovakia (Slovensko)", "SK", "421"],
  ["Slovenia (Slovenija)", "SI", "386"],
  ["Solomon Islands", "SB", "677"],
  ["Somalia (Soomaaliya)", "SO", "252"],
  ["South Africa", "ZA", "27"],
  ["South Korea (대한민국)", "KR", "82"],
  ["South Sudan (جنوب السودان)", "SS", "211"],
  ["Spain (España)", "ES", "34"],
  ["Sri Lanka (ශ්‍රී ලංකාව)", "LK", "94"],
  ["Sudan (السودان)", "SD", "249"],
  ["Suriname", "SR", "597"],
  ["Svalbard and Jan Mayen", "SJ", "47", 1, ["79"]],
  ["Sweden (Sverige)", "SE", "46"],
  ["Switzerland (Schweiz)", "CH", "41"],
  ["Syria (سوريا)", "SY", "963"],
  ["Taiwan (台灣)", "TW", "886"],
  ["Tajikistan", "TJ", "992"],
  ["Tanzania", "TZ", "255"],
  ["Thailand (ไทย)", "TH", "66"],
  ["Timor-Leste", "TL", "670"],
  ["Togo", "TG", "228"],
  ["Tokelau", "TK", "690"],
  ["Tonga", "TO", "676"],
  ["Trinidad and Tobago", "TT", "1", 22, ["868"]],
  ["Tunisia (تونس)", "TN", "216"],
  ["Turkey (Türkiye)", "TR", "90"],
  ["Turkmenistan", "TM", "993"],
  ["Turks and Caicos Islands", "TC", "1", 23, ["649"]],
  ["Tuvalu", "TV", "688"],
  ["U.S. Virgin Islands", "VI", "1", 24, ["340"]],
  ["Uganda", "UG", "256"],
  ["Ukraine (Україна)", "UA", "380"],
  ["United Arab Emirates (الإمارات العربية المتحدة)", "AE", "971"],
  ["United Kingdom", "GB", "44", 0],
  ["United States", "US", "1", 0],
  ["Uruguay", "UY", "598"],
  ["Uzbekistan (Oʻzbekiston)", "UZ", "998"],
  ["Vanuatu", "VU", "678"],
  ["Vatican City (Città del Vaticano)", "VA", "39", 1, ["06698"]],
  ["Venezuela", "VE", "58"],
  ["Vietnam (Việt Nam)", "VN", "84"],
  ["Wallis and Futuna (Wallis-et-Futuna)", "WF", "681"],
  ["Western Sahara (الصحراء الغربية)", "EH", "212", 1, ["5288", "5289"]],
  ["Yemen (اليمن)", "YE", "967"],
  ["Zambia", "ZM", "260"],
  ["Zimbabwe", "ZW", "263"],
  ["Åland Islands", "AX", "358", 1, ["18"]]
];
const allCountries = countryArray.map(
  ([name, iso2, dialCode, priority = 0, areaCodes = []]) => ({
    name,
    iso2,
    dialCode,
    priority,
    areaCodes
  })
);
const IMAGE_FORMATS = ["jpeg", "png", "webp", "avif", "apng", "gif", "avifs", "svg", "bmp", "jpg", "heic", "heif", "ico", "cur", "tif", "tiff"];
const IMAGE_FORMATS_REGEXP = new RegExp(`(${IMAGE_FORMATS.join("|")})$`, "i");
const VIDEO_FORMATS = ["mp4", "webm", "ogg", "mov", "avi", "flv", "wmv", "mkv", "ts", "m3u8"];
const VIDEO_FORMATS_REGEXP = new RegExp(`(${VIDEO_FORMATS.join("|")})$`, "i");
const translations = {
  en: {
    year: "year",
    month: "month",
    week: "week",
    day: "day",
    hour: "hour",
    minute: "minute",
    second: "second",
    ago: "ago",
    in: "in",
    justNow: "Just now"
  },
  es: {
    year: "año",
    month: "mes",
    week: "semana",
    day: "día",
    hour: "hora",
    minute: "minuto",
    second: "segundo",
    ago: "hace",
    in: "en",
    justNow: "Justo ahora"
  },
  fr: {
    year: "an",
    month: "mois",
    week: "semaine",
    day: "jour",
    hour: "heure",
    minute: "minute",
    second: "seconde",
    ago: "il y a",
    in: "dans",
    justNow: "À l’instant"
  },
  he: {
    year: "שנה",
    month: "חודש",
    week: "שבוע",
    day: "יום",
    hour: "שעה",
    minute: "דקה",
    second: "שנייה",
    ago: "לפני",
    in: "בעוד",
    justNow: "זה עתה"
  }
};
function timeAgo(date2, lang = "en") {
  if (!date2) return "";
  if (typeof date2 === "string") date2 = new Date(date2);
  const now = /* @__PURE__ */ new Date();
  const nowNumber = now.getTime();
  const dateNumber = date2.getTime();
  const seconds = Math.floor((dateNumber - nowNumber) / 1e3);
  const intervals = [
    { label: "year", seconds: 31536e3 },
    { label: "month", seconds: 2592e3 },
    { label: "week", seconds: 604800 },
    { label: "day", seconds: 86400 },
    { label: "hour", seconds: 3600 },
    { label: "minute", seconds: 60 },
    { label: "second", seconds: 1 }
  ];
  const selectedLang = translations[lang];
  for (const interval of intervals) {
    const count2 = Math.floor(Math.abs(seconds) / interval.seconds);
    if (count2 >= 1) {
      const suffix = seconds < 0 ? ` ${selectedLang.ago}` : "";
      const prefix = "";
      if (interval.label === "day" && seconds > 0) {
        const hours = Math.floor(Math.abs(seconds) % 86400 / 3600);
        const hourLabel = hours > 1 ? `${selectedLang.hour}s` : selectedLang.hour;
        return `${prefix}${count2} ${selectedLang[interval.label]}${hours > 0 ? ` ${hours} ${hourLabel}` : ""}${suffix}`;
      }
      return `${prefix}${count2} ${selectedLang[interval.label]}${suffix}`;
    }
  }
  return selectedLang.justNow;
}
export {
  Accordion,
  AccordionItem,
  AddressSearch,
  Alert,
  Avatar,
  Badge,
  BagelForm,
  BagelVue,
  BglField,
  BagelForm as BglForm,
  BglMultiStepForm,
  BglVideo,
  BottomMenu,
  Btn,
  Card,
  Carousel,
  CheckInput,
  Checkbox,
  CodeEditor,
  ColorPicker,
  DataPreview,
  DateInput,
  DatePicker,
  Dropdown,
  FieldArray,
  FileUpload,
  Flag,
  IMAGE_FORMATS,
  IMAGE_FORMATS_REGEXP,
  Icon,
  IframeVue,
  Image$1 as Image,
  JSONInput,
  Layout,
  Lineart,
  ListItem,
  ListView,
  Loading,
  MapEmbed,
  Icon as MaterialIcon,
  Modal,
  ModalConfirm,
  ModalForm,
  ModalPlugin,
  NavBar,
  NumberInput,
  OTP,
  PageTitle,
  PasswordInput,
  Pill,
  RadioGroup,
  RadioPillsInput,
  RangeInput,
  RichText,
  RouterWrapper,
  SelectInput,
  SidebarMenu,
  SignaturePad,
  Skeleton,
  TabbedLayout,
  TableField,
  TableSchema,
  Tabs,
  TabsBody,
  TabsNav,
  TelInput,
  TextInput,
  Title,
  ToggleInput,
  ToolBar,
  TopBar,
  UploadInput,
  VIDEO_FORMATS,
  VIDEO_FORMATS_REGEXP,
  Zoomer,
  allCountries,
  appendScript,
  appendStyle,
  bagelFormUtils,
  bagelInjectionKey,
  bindAttrs,
  classify,
  copyText,
  debounce,
  denullify,
  formatString,
  getFallbackSchema,
  i18nTInjectionKey,
  iffer,
  initials,
  isDate,
  keyToLabel,
  localRef,
  normalizeDimension,
  normalizeURL,
  sleep,
  timeAgo,
  useBagel,
  useBglSchema,
  useDebounceFn,
  useEscape,
  useI18nT,
  useLang,
  useLocalStorage,
  useModal
};
